var wp = Object.create;
var ni = Object.defineProperty;
var Pp = Object.getOwnPropertyDescriptor;
var ul = (e, r) => (r = Symbol[e]) ? r : Symbol.for("Symbol." + e), Nn = (e) => {
  throw TypeError(e);
};
var dl = (e, r, t) => r in e ? ni(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
var cl = (e, r) => ni(e, "name", { value: r, configurable: !0 });
var pl = (e) => [, , , wp((e == null ? void 0 : e[ul("metadata")]) ?? null)], _l = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], wa = (e) => e !== void 0 && typeof e != "function" ? Nn("Function expected") : e, xp = (e, r, t, n, a) => ({ kind: _l[e], name: r, metadata: n, addInitializer: (o) => t._ ? Nn("Already initialized") : a.push(wa(o || null)) }), ai = (e, r) => dl(r, ul("metadata"), e[3]), gl = (e, r, t, n) => {
  for (var a = 0, o = e[r >> 1], s = o && o.length; a < s; a++) r & 1 ? o[a].call(t) : n = o[a].call(t, n);
  return n;
}, oi = (e, r, t, n, a, o) => {
  var s, l, c, u, d, p = r & 7, _ = !!(r & 8), g = !!(r & 16), h = p > 3 ? e.length + 1 : p ? _ ? 1 : 2 : 0, w = _l[p + 5], v = p > 3 && (e[h - 1] = []), f = e[h] || (e[h] = []), y = p && (!g && !_ && (a = a.prototype), p < 5 && (p > 3 || !g) && Pp(p < 4 ? a : { get [t]() {
    return N(this, o);
  }, set [t](m) {
    return ke(this, o, m);
  } }, t));
  p ? g && p < 4 && cl(o, (p > 2 ? "set " : p > 1 ? "get " : "") + t) : cl(a, t);
  for (var k = n.length - 1; k >= 0; k--)
    u = xp(p, t, c = {}, e[3], f), p && (u.static = _, u.private = g, d = u.access = { has: g ? (m) => Ep(a, m) : (m) => t in m }, p ^ 3 && (d.get = g ? (m) => (p ^ 1 ? N : sr)(m, a, p ^ 4 ? o : y.get) : (m) => m[t]), p > 2 && (d.set = g ? (m, S) => ke(m, a, S, p ^ 4 ? o : y.set) : (m, S) => m[t] = S)), l = (0, n[k])(p ? p < 4 ? g ? o : y[w] : p > 4 ? void 0 : { get: y.get, set: y.set } : a, u), c._ = 1, p ^ 4 || l === void 0 ? wa(l) && (p > 4 ? v.unshift(l) : p ? g ? o = l : y[w] = l : a = l) : typeof l != "object" || l === null ? Nn("Object expected") : (wa(s = l.get) && (y.get = s), wa(s = l.set) && (y.set = s), wa(s = l.init) && v.unshift(s));
  return p || ai(e, a), y && ni(a, t, y), g ? p ^ 4 ? o : y : a;
}, V = (e, r, t) => dl(e, typeof r != "symbol" ? r + "" : r, t), ii = (e, r, t) => r.has(e) || Nn("Cannot " + t), Ep = (e, r) => Object(r) !== r ? Nn('Cannot use the "in" operator on this value') : e.has(r), N = (e, r, t) => (ii(e, r, "read from private field"), t ? t.call(e) : r.get(e)), we = (e, r, t) => r.has(e) ? Nn("Cannot add the same private member more than once") : r instanceof WeakSet ? r.add(e) : r.set(e, t), ke = (e, r, t, n) => (ii(e, r, "write to private field"), n ? n.call(e, t) : r.set(e, t), t), sr = (e, r, t) => (ii(e, r, "access private method"), t);
const Sp = "5";
var Uc;
typeof window < "u" && ((Uc = window.__svelte ?? (window.__svelte = {})).v ?? (Uc.v = /* @__PURE__ */ new Set())).add(Sp);
const Ip = 1, Tp = 2, Hc = 4, Cp = 8, Dp = 16, Ap = 1, qp = 2, Fp = 4, zp = 8, Mp = 16, Op = 1, jp = 2, Np = 4, Wc = 1, Lp = 2, pr = Symbol(), Bp = "http://www.w3.org/1999/xhtml", Up = "http://www.w3.org/2000/svg", Rp = "@attach", Bi = !1;
var Yo = Array.isArray, Vp = Array.prototype.indexOf, Go = Array.from, Yc = Object.defineProperty, tn = Object.getOwnPropertyDescriptor, Gc = Object.getOwnPropertyDescriptors, Hp = Object.prototype, Wp = Array.prototype, vs = Object.getPrototypeOf, fl = Object.isExtensible;
function Vn(e) {
  return typeof e == "function";
}
const ze = () => {
};
function Yp(e) {
  return e();
}
function wo(e) {
  for (var r = 0; r < e.length; r++)
    e[r]();
}
function Kc() {
  var e, r, t = new Promise((n, a) => {
    e = n, r = a;
  });
  return { promise: t, resolve: e, reject: r };
}
function Ko(e, r) {
  if (Array.isArray(e))
    return e;
  if (r === void 0 || !(Symbol.iterator in e))
    return Array.from(e);
  const t = [];
  for (const n of e)
    if (t.push(n), t.length === r) break;
  return t;
}
const Pr = 2, Po = 4, Xa = 8, ks = 1 << 24, zt = 16, Gt = 32, Cn = 64, ws = 128, et = 512, vr = 1024, Cr = 2048, Mt = 4096, Hr = 8192, Rt = 16384, Xo = 32768, qt = 65536, ml = 1 << 17, Xc = 1 << 18, _a = 1 << 19, $c = 1 << 20, Lt = 1 << 25, za = 32768, Ui = 1 << 21, Ps = 1 << 22, nn = 1 << 23, Tt = Symbol("$state"), Zc = Symbol("legacy props"), Gp = Symbol(""), Wn = new class extends Error {
  constructor() {
    super(...arguments);
    V(this, "name", "StaleReactionError");
    V(this, "message", "The reaction that called `getAbortSignal()` was re-run or destroyed");
  }
}();
function xs(e) {
  throw new Error("https://svelte.dev/e/lifecycle_outside_component");
}
function Kp() {
  throw new Error("https://svelte.dev/e/async_derived_orphan");
}
function Xp(e) {
  throw new Error("https://svelte.dev/e/effect_in_teardown");
}
function $p() {
  throw new Error("https://svelte.dev/e/effect_in_unowned_derived");
}
function Zp(e) {
  throw new Error("https://svelte.dev/e/effect_orphan");
}
function Jp() {
  throw new Error("https://svelte.dev/e/effect_update_depth_exceeded");
}
function Qp(e) {
  throw new Error("https://svelte.dev/e/props_invalid_value");
}
function e_() {
  throw new Error("https://svelte.dev/e/state_descriptors_fixed");
}
function r_() {
  throw new Error("https://svelte.dev/e/state_prototype_fixed");
}
function t_() {
  throw new Error("https://svelte.dev/e/state_unsafe_mutation");
}
function n_() {
  throw new Error("https://svelte.dev/e/svelte_boundary_reset_onerror");
}
function a_() {
  console.warn("https://svelte.dev/e/select_multiple_invalid_value");
}
function o_() {
  console.warn("https://svelte.dev/e/svelte_boundary_reset_noop");
}
function Jc(e) {
  return e === this.v;
}
function Es(e, r) {
  return e != e ? r == r : e !== r || e !== null && typeof e == "object" || typeof e == "function";
}
function Qc(e) {
  return !Es(e, this.v);
}
let ga = !1, i_ = !1;
function s_() {
  ga = !0;
}
let Be = null;
function sa(e) {
  Be = e;
}
function Le(e) {
  return (
    /** @type {T} */
    eu().get(e)
  );
}
function $e(e, r) {
  return eu().set(e, r), r;
}
function ee(e, r = !1, t) {
  Be = {
    p: Be,
    i: !1,
    c: null,
    e: null,
    s: e,
    x: null,
    l: ga && !r ? { s: null, u: null, $: [] } : null
  };
}
function re(e) {
  var r = (
    /** @type {ComponentContext} */
    Be
  ), t = r.e;
  if (t !== null) {
    r.e = null;
    for (var n of t)
      vu(n);
  }
  return e !== void 0 && (r.x = e), r.i = !0, Be = r.p, e ?? /** @type {T} */
  {};
}
function $a() {
  return !ga || Be !== null && Be.l === null;
}
function eu(e) {
  return Be === null && xs(), Be.c ?? (Be.c = new Map(l_(Be) || void 0));
}
function l_(e) {
  let r = e.p;
  for (; r !== null; ) {
    const t = r.c;
    if (t !== null)
      return t;
    r = r.p;
  }
  return null;
}
let Yn = [];
function c_() {
  var e = Yn;
  Yn = [], wo(e);
}
function un(e) {
  if (Yn.length === 0) {
    var r = Yn;
    queueMicrotask(() => {
      r === Yn && c_();
    });
  }
  Yn.push(e);
}
function ru(e) {
  var r = Me;
  if (r === null)
    return Ce.f |= nn, e;
  if ((r.f & Xo) === 0) {
    if ((r.f & ws) === 0)
      throw e;
    r.b.error(e);
  } else
    la(e, r);
}
function la(e, r) {
  for (; r !== null; ) {
    if ((r.f & ws) !== 0)
      try {
        r.b.error(e);
        return;
      } catch (t) {
        e = t;
      }
    r = r.parent;
  }
  throw e;
}
const u_ = -7169;
function lr(e, r) {
  e.f = e.f & u_ | r;
}
function Ss(e) {
  (e.f & et) !== 0 || e.deps === null ? lr(e, vr) : lr(e, Mt);
}
function tu(e) {
  if (e !== null)
    for (const r of e)
      (r.f & Pr) === 0 || (r.f & za) === 0 || (r.f ^= za, tu(
        /** @type {Derived} */
        r.deps
      ));
}
function nu(e, r, t) {
  (e.f & Cr) !== 0 ? r.add(e) : (e.f & Mt) !== 0 && t.add(e), tu(e.deps), lr(e, vr);
}
const oo = /* @__PURE__ */ new Set();
let He = null, hr = null, wt = [], Is = null, Ri = !1;
var Qn, ea, hn, yn, Va, ra, ta, rt, Vi, Hi, au, ou;
const Uo = class Uo {
  constructor() {
    we(this, rt);
    V(this, "committed", !1);
    /**
     * The current values of any sources that are updated in this batch
     * They keys of this map are identical to `this.#previous`
     * @type {Map<Source, any>}
     */
    V(this, "current", /* @__PURE__ */ new Map());
    /**
     * The values of any sources that are updated in this batch _before_ those updates took place.
     * They keys of this map are identical to `this.#current`
     * @type {Map<Source, any>}
     */
    V(this, "previous", /* @__PURE__ */ new Map());
    /**
     * When the batch is committed (and the DOM is updated), we need to remove old branches
     * and append new ones by calling the functions added inside (if/each/key/etc) blocks
     * @type {Set<() => void>}
     */
    we(this, Qn, /* @__PURE__ */ new Set());
    /**
     * If a fork is discarded, we need to destroy any effects that are no longer needed
     * @type {Set<(batch: Batch) => void>}
     */
    we(this, ea, /* @__PURE__ */ new Set());
    /**
     * The number of async effects that are currently in flight
     */
    we(this, hn, 0);
    /**
     * The number of async effects that are currently in flight, _not_ inside a pending boundary
     */
    we(this, yn, 0);
    /**
     * A deferred that resolves when the batch is committed, used with `settled()`
     * TODO replace with Promise.withResolvers once supported widely enough
     * @type {{ promise: Promise<void>, resolve: (value?: any) => void, reject: (reason: unknown) => void } | null}
     */
    we(this, Va, null);
    /**
     * Deferred effects (which run after async work has completed) that are DIRTY
     * @type {Set<Effect>}
     */
    we(this, ra, /* @__PURE__ */ new Set());
    /**
     * Deferred effects that are MAYBE_DIRTY
     * @type {Set<Effect>}
     */
    we(this, ta, /* @__PURE__ */ new Set());
    /**
     * A set of branches that still exist, but will be destroyed when this batch
     * is committed — we skip over these during `process`
     * @type {Set<Effect>}
     */
    V(this, "skipped_effects", /* @__PURE__ */ new Set());
    V(this, "is_fork", !1);
  }
  is_deferred() {
    return this.is_fork || N(this, yn) > 0;
  }
  /**
   *
   * @param {Effect[]} root_effects
   */
  process(r) {
    var a;
    wt = [], this.apply();
    var t = [], n = [];
    for (const o of r)
      sr(this, rt, Vi).call(this, o, t, n);
    this.is_fork || sr(this, rt, au).call(this), this.is_deferred() ? (sr(this, rt, Hi).call(this, n), sr(this, rt, Hi).call(this, t)) : (He = null, hl(n), hl(t), (a = N(this, Va)) == null || a.resolve()), hr = null;
  }
  /**
   * Associate a change to a given source with the current
   * batch, noting its previous and current values
   * @param {Source} source
   * @param {any} value
   */
  capture(r, t) {
    t !== pr && !this.previous.has(r) && this.previous.set(r, t), (r.f & nn) === 0 && (this.current.set(r, r.v), hr == null || hr.set(r, r.v));
  }
  activate() {
    He = this, this.apply();
  }
  deactivate() {
    He === this && (He = null, hr = null);
  }
  flush() {
    if (this.activate(), wt.length > 0) {
      if (d_(), He !== null && He !== this)
        return;
    } else N(this, hn) === 0 && this.process([]);
    this.deactivate();
  }
  discard() {
    for (const r of N(this, ea)) r(this);
    N(this, ea).clear();
  }
  /**
   *
   * @param {boolean} blocking
   */
  increment(r) {
    ke(this, hn, N(this, hn) + 1), r && ke(this, yn, N(this, yn) + 1);
  }
  /**
   *
   * @param {boolean} blocking
   */
  decrement(r) {
    ke(this, hn, N(this, hn) - 1), r && ke(this, yn, N(this, yn) - 1), this.revive();
  }
  revive() {
    for (const r of N(this, ra))
      N(this, ta).delete(r), lr(r, Cr), Yt(r);
    for (const r of N(this, ta))
      lr(r, Mt), Yt(r);
    this.flush();
  }
  /** @param {() => void} fn */
  oncommit(r) {
    N(this, Qn).add(r);
  }
  /** @param {(batch: Batch) => void} fn */
  ondiscard(r) {
    N(this, ea).add(r);
  }
  settled() {
    return (N(this, Va) ?? ke(this, Va, Kc())).promise;
  }
  static ensure() {
    if (He === null) {
      const r = He = new Uo();
      oo.add(He), Uo.enqueue(() => {
        He === r && r.flush();
      });
    }
    return He;
  }
  /** @param {() => void} task */
  static enqueue(r) {
    un(r);
  }
  apply() {
  }
};
Qn = new WeakMap(), ea = new WeakMap(), hn = new WeakMap(), yn = new WeakMap(), Va = new WeakMap(), ra = new WeakMap(), ta = new WeakMap(), rt = new WeakSet(), /**
 * Traverse the effect tree, executing effects or stashing
 * them for later execution as appropriate
 * @param {Effect} root
 * @param {Effect[]} effects
 * @param {Effect[]} render_effects
 */
Vi = function(r, t, n) {
  r.f ^= vr;
  for (var a = r.first, o = null; a !== null; ) {
    var s = a.f, l = (s & (Gt | Cn)) !== 0, c = l && (s & vr) !== 0, u = c || (s & Hr) !== 0 || this.skipped_effects.has(a);
    if (!u && a.fn !== null) {
      l ? a.f ^= vr : o !== null && (s & (Po | Xa | ks)) !== 0 ? o.b.defer_effect(a) : (s & Po) !== 0 ? t.push(a) : ha(a) && ((s & zt) !== 0 && N(this, ra).add(a), ua(a));
      var d = a.first;
      if (d !== null) {
        a = d;
        continue;
      }
    }
    var p = a.parent;
    for (a = a.next; a === null && p !== null; )
      p === o && (o = null), a = p.next, p = p.parent;
  }
}, /**
 * @param {Effect[]} effects
 */
Hi = function(r) {
  for (var t = 0; t < r.length; t += 1)
    nu(r[t], N(this, ra), N(this, ta));
}, au = function() {
  if (N(this, yn) === 0) {
    for (const r of N(this, Qn)) r();
    N(this, Qn).clear();
  }
  N(this, hn) === 0 && sr(this, rt, ou).call(this);
}, ou = function() {
  var a;
  if (oo.size > 1) {
    this.previous.clear();
    var r = hr, t = !0;
    for (const o of oo) {
      if (o === this) {
        t = !1;
        continue;
      }
      const s = [];
      for (const [c, u] of this.current) {
        if (o.current.has(c))
          if (t && u !== o.current.get(c))
            o.current.set(c, u);
          else
            continue;
        s.push(c);
      }
      if (s.length === 0)
        continue;
      const l = [...o.current.keys()].filter((c) => !this.current.has(c));
      if (l.length > 0) {
        var n = wt;
        wt = [];
        const c = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Map();
        for (const d of s)
          iu(d, l, c, u);
        if (wt.length > 0) {
          He = o, o.apply();
          for (const d of wt)
            sr(a = o, rt, Vi).call(a, d, [], []);
          o.deactivate();
        }
        wt = n;
      }
    }
    He = null, hr = r;
  }
  this.committed = !0, oo.delete(this);
};
let Bt = Uo;
function d_() {
  var e = xn;
  Ri = !0;
  var r = null;
  try {
    var t = 0;
    for (Eo(!0); wt.length > 0; ) {
      var n = Bt.ensure();
      if (t++ > 1e3) {
        var a, o;
        p_();
      }
      n.process(wt), an.clear();
    }
  } finally {
    Ri = !1, Eo(e), Is = null;
  }
}
function p_() {
  try {
    Jp();
  } catch (e) {
    la(e, Is);
  }
}
let it = null;
function hl(e) {
  var r = e.length;
  if (r !== 0) {
    for (var t = 0; t < r; ) {
      var n = e[t++];
      if ((n.f & (Rt | Hr)) === 0 && ha(n) && (it = /* @__PURE__ */ new Set(), ua(n), n.deps === null && n.first === null && n.nodes === null && (n.teardown === null && n.ac === null ? Eu(n) : n.fn = null), (it == null ? void 0 : it.size) > 0)) {
        an.clear();
        for (const a of it) {
          if ((a.f & (Rt | Hr)) !== 0) continue;
          const o = [a];
          let s = a.parent;
          for (; s !== null; )
            it.has(s) && (it.delete(s), o.push(s)), s = s.parent;
          for (let l = o.length - 1; l >= 0; l--) {
            const c = o[l];
            (c.f & (Rt | Hr)) === 0 && ua(c);
          }
        }
        it.clear();
      }
    }
    it = null;
  }
}
function iu(e, r, t, n) {
  if (!t.has(e) && (t.add(e), e.reactions !== null))
    for (const a of e.reactions) {
      const o = a.f;
      (o & Pr) !== 0 ? iu(
        /** @type {Derived} */
        a,
        r,
        t,
        n
      ) : (o & (Ps | zt)) !== 0 && (o & Cr) === 0 && su(a, r, n) && (lr(a, Cr), Yt(
        /** @type {Effect} */
        a
      ));
    }
}
function su(e, r, t) {
  const n = t.get(e);
  if (n !== void 0) return n;
  if (e.deps !== null)
    for (const a of e.deps) {
      if (r.includes(a))
        return !0;
      if ((a.f & Pr) !== 0 && su(
        /** @type {Derived} */
        a,
        r,
        t
      ))
        return t.set(
          /** @type {Derived} */
          a,
          !0
        ), !0;
    }
  return t.set(e, !1), !1;
}
function Yt(e) {
  for (var r = Is = e; r.parent !== null; ) {
    r = r.parent;
    var t = r.f;
    if (Ri && r === Me && (t & zt) !== 0 && (t & Xc) === 0)
      return;
    if ((t & (Cn | Gt)) !== 0) {
      if ((t & vr) === 0) return;
      r.f ^= vr;
    }
  }
  wt.push(r);
}
function lu(e) {
  let r = 0, t = Sn(0), n;
  return () => {
    Cs() && (i(t), eo(() => (r === 0 && (n = Ue(() => e(() => Aa(t)))), r += 1, () => {
      un(() => {
        r -= 1, r === 0 && (n == null || n(), n = void 0, Aa(t));
      });
    })));
  };
}
var __ = qt | _a | ws;
function cu(e, r, t) {
  new g_(e, r, t);
}
var $r, bs, xt, bn, Et, Zr, qr, St, jt, Jt, vn, Qt, kn, na, aa, en, Ro, fr, f_, m_, Wi, yo, bo, Yi;
class g_ {
  /**
   * @param {TemplateNode} node
   * @param {BoundaryProps} props
   * @param {((anchor: Node) => void)} children
   */
  constructor(r, t, n) {
    we(this, fr);
    /** @type {Boundary | null} */
    V(this, "parent");
    V(this, "is_pending", !1);
    /** @type {TemplateNode} */
    we(this, $r);
    /** @type {TemplateNode | null} */
    we(this, bs, null);
    /** @type {BoundaryProps} */
    we(this, xt);
    /** @type {((anchor: Node) => void)} */
    we(this, bn);
    /** @type {Effect} */
    we(this, Et);
    /** @type {Effect | null} */
    we(this, Zr, null);
    /** @type {Effect | null} */
    we(this, qr, null);
    /** @type {Effect | null} */
    we(this, St, null);
    /** @type {DocumentFragment | null} */
    we(this, jt, null);
    /** @type {TemplateNode | null} */
    we(this, Jt, null);
    we(this, vn, 0);
    we(this, Qt, 0);
    we(this, kn, !1);
    /** @type {Set<Effect>} */
    we(this, na, /* @__PURE__ */ new Set());
    /** @type {Set<Effect>} */
    we(this, aa, /* @__PURE__ */ new Set());
    /**
     * A source containing the number of pending async deriveds/expressions.
     * Only created if `$effect.pending()` is used inside the boundary,
     * otherwise updating the source results in needless `Batch.ensure()`
     * calls followed by no-op flushes
     * @type {Source<number> | null}
     */
    we(this, en, null);
    we(this, Ro, lu(() => (ke(this, en, Sn(N(this, vn))), () => {
      ke(this, en, null);
    })));
    ke(this, $r, r), ke(this, xt, t), ke(this, bn, n), this.parent = /** @type {Effect} */
    Me.b, this.is_pending = !!N(this, xt).pending, ke(this, Et, ma(() => {
      Me.b = this;
      {
        var a = sr(this, fr, Wi).call(this);
        try {
          ke(this, Zr, Fr(() => n(a)));
        } catch (o) {
          this.error(o);
        }
        N(this, Qt) > 0 ? sr(this, fr, bo).call(this) : this.is_pending = !1;
      }
      return () => {
        var o;
        (o = N(this, Jt)) == null || o.remove();
      };
    }, __));
  }
  /**
   * Defer an effect inside a pending boundary until the boundary resolves
   * @param {Effect} effect
   */
  defer_effect(r) {
    nu(r, N(this, na), N(this, aa));
  }
  /**
   * Returns `false` if the effect exists inside a boundary whose pending snippet is shown
   * @returns {boolean}
   */
  is_rendered() {
    return !this.is_pending && (!this.parent || this.parent.is_rendered());
  }
  has_pending_snippet() {
    return !!N(this, xt).pending;
  }
  /**
   * Update the source that powers `$effect.pending()` inside this boundary,
   * and controls when the current `pending` snippet (if any) is removed.
   * Do not call from inside the class
   * @param {1 | -1} d
   */
  update_pending_count(r) {
    sr(this, fr, Yi).call(this, r), ke(this, vn, N(this, vn) + r), N(this, en) && ca(N(this, en), N(this, vn));
  }
  get_effect_pending() {
    return N(this, Ro).call(this), i(
      /** @type {Source<number>} */
      N(this, en)
    );
  }
  /** @param {unknown} error */
  error(r) {
    var t = N(this, xt).onerror;
    let n = N(this, xt).failed;
    if (N(this, kn) || !t && !n)
      throw r;
    N(this, Zr) && (wr(N(this, Zr)), ke(this, Zr, null)), N(this, qr) && (wr(N(this, qr)), ke(this, qr, null)), N(this, St) && (wr(N(this, St)), ke(this, St, null));
    var a = !1, o = !1;
    const s = () => {
      if (a) {
        o_();
        return;
      }
      a = !0, o && n_(), Bt.ensure(), ke(this, vn, 0), N(this, St) !== null && Pn(N(this, St), () => {
        ke(this, St, null);
      }), this.is_pending = this.has_pending_snippet(), ke(this, Zr, sr(this, fr, yo).call(this, () => (ke(this, kn, !1), Fr(() => N(this, bn).call(this, N(this, $r)))))), N(this, Qt) > 0 ? sr(this, fr, bo).call(this) : this.is_pending = !1;
    };
    var l = Ce;
    try {
      zr(null), o = !0, t == null || t(r, s), o = !1;
    } catch (c) {
      la(c, N(this, Et) && N(this, Et).parent);
    } finally {
      zr(l);
    }
    n && un(() => {
      ke(this, St, sr(this, fr, yo).call(this, () => {
        Bt.ensure(), ke(this, kn, !0);
        try {
          return Fr(() => {
            n(
              N(this, $r),
              () => r,
              () => s
            );
          });
        } catch (c) {
          return la(
            c,
            /** @type {Effect} */
            N(this, Et).parent
          ), null;
        } finally {
          ke(this, kn, !1);
        }
      }));
    });
  }
}
$r = new WeakMap(), bs = new WeakMap(), xt = new WeakMap(), bn = new WeakMap(), Et = new WeakMap(), Zr = new WeakMap(), qr = new WeakMap(), St = new WeakMap(), jt = new WeakMap(), Jt = new WeakMap(), vn = new WeakMap(), Qt = new WeakMap(), kn = new WeakMap(), na = new WeakMap(), aa = new WeakMap(), en = new WeakMap(), Ro = new WeakMap(), fr = new WeakSet(), f_ = function() {
  try {
    ke(this, Zr, Fr(() => N(this, bn).call(this, N(this, $r))));
  } catch (r) {
    this.error(r);
  }
}, m_ = function() {
  const r = N(this, xt).pending;
  r && (ke(this, qr, Fr(() => r(N(this, $r)))), Bt.enqueue(() => {
    var t = sr(this, fr, Wi).call(this);
    ke(this, Zr, sr(this, fr, yo).call(this, () => (Bt.ensure(), Fr(() => N(this, bn).call(this, t))))), N(this, Qt) > 0 ? sr(this, fr, bo).call(this) : (Pn(
      /** @type {Effect} */
      N(this, qr),
      () => {
        ke(this, qr, null);
      }
    ), this.is_pending = !1);
  }));
}, Wi = function() {
  var r = N(this, $r);
  return this.is_pending && (ke(this, Jt, Ct()), N(this, $r).before(N(this, Jt)), r = N(this, Jt)), r;
}, /**
 * @param {() => Effect | null} fn
 */
yo = function(r) {
  var t = Me, n = Ce, a = Be;
  Ft(N(this, Et)), zr(N(this, Et)), sa(N(this, Et).ctx);
  try {
    return r();
  } catch (o) {
    return ru(o), null;
  } finally {
    Ft(t), zr(n), sa(a);
  }
}, bo = function() {
  const r = (
    /** @type {(anchor: Node) => void} */
    N(this, xt).pending
  );
  N(this, Zr) !== null && (ke(this, jt, document.createDocumentFragment()), N(this, jt).append(
    /** @type {TemplateNode} */
    N(this, Jt)
  ), Tu(N(this, Zr), N(this, jt))), N(this, qr) === null && ke(this, qr, Fr(() => r(N(this, $r))));
}, /**
 * Updates the pending count associated with the currently visible pending snippet,
 * if any, such that we can replace the snippet with content once work is done
 * @param {1 | -1} d
 */
Yi = function(r) {
  var t;
  if (!this.has_pending_snippet()) {
    this.parent && sr(t = this.parent, fr, Yi).call(t, r);
    return;
  }
  if (ke(this, Qt, N(this, Qt) + r), N(this, Qt) === 0) {
    this.is_pending = !1;
    for (const n of N(this, na))
      lr(n, Cr), Yt(n);
    for (const n of N(this, aa))
      lr(n, Mt), Yt(n);
    N(this, na).clear(), N(this, aa).clear(), N(this, qr) && Pn(N(this, qr), () => {
      ke(this, qr, null);
    }), N(this, jt) && (N(this, $r).before(N(this, jt)), ke(this, jt, null));
  }
};
function uu(e, r, t, n) {
  const a = $a() ? Za : Vt;
  if (t.length === 0 && e.length === 0) {
    n(r.map(a));
    return;
  }
  var o = He, s = (
    /** @type {Effect} */
    Me
  ), l = h_();
  function c() {
    Promise.all(t.map((u) => /* @__PURE__ */ y_(u))).then((u) => {
      l();
      try {
        n([...r.map(a), ...u]);
      } catch (d) {
        (s.f & Rt) === 0 && la(d, s);
      }
      o == null || o.deactivate(), xo();
    }).catch((u) => {
      la(u, s);
    });
  }
  e.length > 0 ? Promise.all(e).then(() => {
    l();
    try {
      return c();
    } finally {
      o == null || o.deactivate(), xo();
    }
  }) : c();
}
function h_() {
  var e = Me, r = Ce, t = Be, n = He;
  return function(o = !0) {
    Ft(e), zr(r), sa(t), o && (n == null || n.activate());
  };
}
function xo() {
  Ft(null), zr(null), sa(null);
}
// @__NO_SIDE_EFFECTS__
function Za(e) {
  var r = Pr | Cr, t = Ce !== null && (Ce.f & Pr) !== 0 ? (
    /** @type {Derived} */
    Ce
  ) : null;
  return Me !== null && (Me.f |= _a), {
    ctx: Be,
    deps: null,
    effects: null,
    equals: Jc,
    f: r,
    fn: e,
    reactions: null,
    rv: 0,
    v: (
      /** @type {V} */
      pr
    ),
    wv: 0,
    parent: t ?? Me,
    ac: null
  };
}
// @__NO_SIDE_EFFECTS__
function y_(e, r, t) {
  let n = (
    /** @type {Effect | null} */
    Me
  );
  n === null && Kp();
  var a = (
    /** @type {Boundary} */
    n.b
  ), o = (
    /** @type {Promise<V>} */
    /** @type {unknown} */
    void 0
  ), s = Sn(
    /** @type {V} */
    pr
  ), l = !Ce, c = /* @__PURE__ */ new Map();
  return C_(() => {
    var g;
    var u = Kc();
    o = u.promise;
    try {
      Promise.resolve(e()).then(u.resolve, u.reject).then(() => {
        d === He && d.committed && d.deactivate(), xo();
      });
    } catch (h) {
      u.reject(h), xo();
    }
    var d = (
      /** @type {Batch} */
      He
    );
    if (l) {
      var p = a.is_rendered();
      a.update_pending_count(1), d.increment(p), (g = c.get(d)) == null || g.reject(Wn), c.delete(d), c.set(d, u);
    }
    const _ = (h, w = void 0) => {
      if (d.activate(), w)
        w !== Wn && (s.f |= nn, ca(s, w));
      else {
        (s.f & nn) !== 0 && (s.f ^= nn), ca(s, h);
        for (const [v, f] of c) {
          if (c.delete(v), v === d) break;
          f.reject(Wn);
        }
      }
      l && (a.update_pending_count(-1), d.decrement(p));
    };
    u.promise.then(_, (h) => _(null, h || "unknown"));
  }), fa(() => {
    for (const u of c.values())
      u.reject(Wn);
  }), new Promise((u) => {
    function d(p) {
      function _() {
        p === o ? u(s) : d(o);
      }
      p.then(_, _);
    }
    d(o);
  });
}
// @__NO_SIDE_EFFECTS__
function b(e) {
  const r = /* @__PURE__ */ Za(e);
  return Cu(r), r;
}
// @__NO_SIDE_EFFECTS__
function Vt(e) {
  const r = /* @__PURE__ */ Za(e);
  return r.equals = Qc, r;
}
function du(e) {
  var r = e.effects;
  if (r !== null) {
    e.effects = null;
    for (var t = 0; t < r.length; t += 1)
      wr(
        /** @type {Effect} */
        r[t]
      );
  }
}
function b_(e) {
  for (var r = e.parent; r !== null; ) {
    if ((r.f & Pr) === 0)
      return (r.f & Rt) === 0 ? (
        /** @type {Effect} */
        r
      ) : null;
    r = r.parent;
  }
  return null;
}
function Ts(e) {
  var r, t = Me;
  Ft(b_(e));
  try {
    e.f &= ~za, du(e), r = Fu(e);
  } finally {
    Ft(t);
  }
  return r;
}
function pu(e) {
  var r = Ts(e);
  if (!e.equals(r) && (e.wv = Au(), (!(He != null && He.is_fork) || e.deps === null) && (e.v = r, e.deps === null))) {
    lr(e, vr);
    return;
  }
  sn || (hr !== null ? (Cs() || He != null && He.is_fork) && hr.set(e, r) : Ss(e));
}
let Gi = /* @__PURE__ */ new Set();
const an = /* @__PURE__ */ new Map();
let _u = !1;
function Sn(e, r) {
  var t = {
    f: 0,
    // TODO ideally we could skip this altogether, but it causes type errors
    v: e,
    reactions: null,
    equals: Jc,
    rv: 0,
    wv: 0
  };
  return t;
}
// @__NO_SIDE_EFFECTS__
function X(e, r) {
  const t = Sn(e);
  return Cu(t), t;
}
// @__NO_SIDE_EFFECTS__
function Br(e, r = !1, t = !0) {
  var a;
  const n = Sn(e);
  return r || (n.equals = Qc), ga && t && Be !== null && Be.l !== null && ((a = Be.l).s ?? (a.s = [])).push(n), n;
}
function L(e, r, t = !1) {
  Ce !== null && // since we are untracking the function inside `$inspect.with` we need to add this check
  // to ensure we error if state is set inside an inspect effect
  (!lt || (Ce.f & ml) !== 0) && $a() && (Ce.f & (Pr | zt | Ps | ml)) !== 0 && !(Tr != null && Tr.includes(e)) && t_();
  let n = t ? Xe(r) : r;
  return ca(e, n);
}
function ca(e, r) {
  if (!e.equals(r)) {
    var t = e.v;
    sn ? an.set(e, r) : an.set(e, t), e.v = r;
    var n = Bt.ensure();
    if (n.capture(e, t), (e.f & Pr) !== 0) {
      const a = (
        /** @type {Derived} */
        e
      );
      (e.f & Cr) !== 0 && Ts(a), Ss(a);
    }
    e.wv = Au(), gu(e, Cr), $a() && Me !== null && (Me.f & vr) !== 0 && (Me.f & (Gt | Cn)) === 0 && (Xr === null ? A_([e]) : Xr.push(e)), !n.is_fork && Gi.size > 0 && !_u && v_();
  }
  return r;
}
function v_() {
  _u = !1;
  var e = xn;
  Eo(!0);
  const r = Array.from(Gi);
  try {
    for (const t of r)
      (t.f & vr) !== 0 && lr(t, Mt), ha(t) && ua(t);
  } finally {
    Eo(e);
  }
  Gi.clear();
}
function Aa(e) {
  L(e, e.v + 1);
}
function gu(e, r) {
  var t = e.reactions;
  if (t !== null)
    for (var n = $a(), a = t.length, o = 0; o < a; o++) {
      var s = t[o], l = s.f;
      if (!(!n && s === Me)) {
        var c = (l & Cr) === 0;
        if (c && lr(s, r), (l & Pr) !== 0) {
          var u = (
            /** @type {Derived} */
            s
          );
          hr == null || hr.delete(u), (l & za) === 0 && (l & et && (s.f |= za), gu(u, Mt));
        } else c && ((l & zt) !== 0 && it !== null && it.add(
          /** @type {Effect} */
          s
        ), Yt(
          /** @type {Effect} */
          s
        ));
      }
    }
}
function Xe(e) {
  if (typeof e != "object" || e === null || Tt in e)
    return e;
  const r = vs(e);
  if (r !== Hp && r !== Wp)
    return e;
  var t = /* @__PURE__ */ new Map(), n = Yo(e), a = /* @__PURE__ */ X(0), o = En, s = (l) => {
    if (En === o)
      return l();
    var c = Ce, u = En;
    zr(null), kl(o);
    var d = l();
    return zr(c), kl(u), d;
  };
  return n && t.set("length", /* @__PURE__ */ X(
    /** @type {any[]} */
    e.length
  )), new Proxy(
    /** @type {any} */
    e,
    {
      defineProperty(l, c, u) {
        (!("value" in u) || u.configurable === !1 || u.enumerable === !1 || u.writable === !1) && e_();
        var d = t.get(c);
        return d === void 0 ? d = s(() => {
          var p = /* @__PURE__ */ X(u.value);
          return t.set(c, p), p;
        }) : L(d, u.value, !0), !0;
      },
      deleteProperty(l, c) {
        var u = t.get(c);
        if (u === void 0) {
          if (c in l) {
            const d = s(() => /* @__PURE__ */ X(pr));
            t.set(c, d), Aa(a);
          }
        } else
          L(u, pr), Aa(a);
        return !0;
      },
      get(l, c, u) {
        var g;
        if (c === Tt)
          return e;
        var d = t.get(c), p = c in l;
        if (d === void 0 && (!p || (g = tn(l, c)) != null && g.writable) && (d = s(() => {
          var h = Xe(p ? l[c] : pr), w = /* @__PURE__ */ X(h);
          return w;
        }), t.set(c, d)), d !== void 0) {
          var _ = i(d);
          return _ === pr ? void 0 : _;
        }
        return Reflect.get(l, c, u);
      },
      getOwnPropertyDescriptor(l, c) {
        var u = Reflect.getOwnPropertyDescriptor(l, c);
        if (u && "value" in u) {
          var d = t.get(c);
          d && (u.value = i(d));
        } else if (u === void 0) {
          var p = t.get(c), _ = p == null ? void 0 : p.v;
          if (p !== void 0 && _ !== pr)
            return {
              enumerable: !0,
              configurable: !0,
              value: _,
              writable: !0
            };
        }
        return u;
      },
      has(l, c) {
        var _;
        if (c === Tt)
          return !0;
        var u = t.get(c), d = u !== void 0 && u.v !== pr || Reflect.has(l, c);
        if (u !== void 0 || Me !== null && (!d || (_ = tn(l, c)) != null && _.writable)) {
          u === void 0 && (u = s(() => {
            var g = d ? Xe(l[c]) : pr, h = /* @__PURE__ */ X(g);
            return h;
          }), t.set(c, u));
          var p = i(u);
          if (p === pr)
            return !1;
        }
        return d;
      },
      set(l, c, u, d) {
        var k;
        var p = t.get(c), _ = c in l;
        if (n && c === "length")
          for (var g = u; g < /** @type {Source<number>} */
          p.v; g += 1) {
            var h = t.get(g + "");
            h !== void 0 ? L(h, pr) : g in l && (h = s(() => /* @__PURE__ */ X(pr)), t.set(g + "", h));
          }
        if (p === void 0)
          (!_ || (k = tn(l, c)) != null && k.writable) && (p = s(() => /* @__PURE__ */ X(void 0)), L(p, Xe(u)), t.set(c, p));
        else {
          _ = p.v !== pr;
          var w = s(() => Xe(u));
          L(p, w);
        }
        var v = Reflect.getOwnPropertyDescriptor(l, c);
        if (v != null && v.set && v.set.call(d, u), !_) {
          if (n && typeof c == "string") {
            var f = (
              /** @type {Source<number>} */
              t.get("length")
            ), y = Number(c);
            Number.isInteger(y) && y >= f.v && L(f, y + 1);
          }
          Aa(a);
        }
        return !0;
      },
      ownKeys(l) {
        i(a);
        var c = Reflect.ownKeys(l).filter((p) => {
          var _ = t.get(p);
          return _ === void 0 || _.v !== pr;
        });
        for (var [u, d] of t)
          d.v !== pr && !(u in l) && c.push(u);
        return c;
      },
      setPrototypeOf() {
        r_();
      }
    }
  );
}
function yl(e) {
  try {
    if (e !== null && typeof e == "object" && Tt in e)
      return e[Tt];
  } catch {
  }
  return e;
}
function k_(e, r) {
  return Object.is(yl(e), yl(r));
}
var bl, fu, mu, hu;
function w_() {
  if (bl === void 0) {
    bl = window, fu = /Firefox/.test(navigator.userAgent);
    var e = Element.prototype, r = Node.prototype, t = Text.prototype;
    mu = tn(r, "firstChild").get, hu = tn(r, "nextSibling").get, fl(e) && (e.__click = void 0, e.__className = void 0, e.__attributes = null, e.__style = void 0, e.__e = void 0), fl(t) && (t.__t = void 0);
  }
}
function Ct(e = "") {
  return document.createTextNode(e);
}
// @__NO_SIDE_EFFECTS__
function Rr(e) {
  return (
    /** @type {TemplateNode | null} */
    mu.call(e)
  );
}
// @__NO_SIDE_EFFECTS__
function Ja(e) {
  return (
    /** @type {TemplateNode | null} */
    hu.call(e)
  );
}
function z(e, r) {
  return /* @__PURE__ */ Rr(e);
}
function J(e, r = !1) {
  {
    var t = /* @__PURE__ */ Rr(e);
    return t instanceof Comment && t.data === "" ? /* @__PURE__ */ Ja(t) : t;
  }
}
function R(e, r = 1, t = !1) {
  let n = e;
  for (; r--; )
    n = /** @type {TemplateNode} */
    /* @__PURE__ */ Ja(n);
  return n;
}
function P_(e) {
  e.textContent = "";
}
function yu() {
  return !1;
}
function x_(e, r) {
  if (r) {
    const t = document.body;
    e.autofocus = !0, un(() => {
      document.activeElement === t && e.focus();
    });
  }
}
function Qa(e) {
  var r = Ce, t = Me;
  zr(null), Ft(null);
  try {
    return e();
  } finally {
    zr(r), Ft(t);
  }
}
function bu(e) {
  Me === null && (Ce === null && Zp(), $p()), sn && Xp();
}
function E_(e, r) {
  var t = r.last;
  t === null ? r.last = r.first = e : (t.next = e, e.prev = t, r.last = e);
}
function dt(e, r, t) {
  var n = Me;
  n !== null && (n.f & Hr) !== 0 && (e |= Hr);
  var a = {
    ctx: Be,
    deps: null,
    nodes: null,
    f: e | Cr | et,
    first: null,
    fn: r,
    last: null,
    next: null,
    parent: n,
    b: n && n.b,
    prev: null,
    teardown: null,
    wv: 0,
    ac: null
  };
  if (t)
    try {
      ua(a), a.f |= Xo;
    } catch (l) {
      throw wr(a), l;
    }
  else r !== null && Yt(a);
  var o = a;
  if (t && o.deps === null && o.teardown === null && o.nodes === null && o.first === o.last && // either `null`, or a singular child
  (o.f & _a) === 0 && (o = o.first, (e & zt) !== 0 && (e & qt) !== 0 && o !== null && (o.f |= qt)), o !== null && (o.parent = n, n !== null && E_(o, n), Ce !== null && (Ce.f & Pr) !== 0 && (e & Cn) === 0)) {
    var s = (
      /** @type {Derived} */
      Ce
    );
    (s.effects ?? (s.effects = [])).push(o);
  }
  return a;
}
function Cs() {
  return Ce !== null && !lt;
}
function fa(e) {
  const r = dt(Xa, null, !1);
  return lr(r, vr), r.teardown = e, r;
}
function kr(e) {
  bu();
  var r = (
    /** @type {Effect} */
    Me.f
  ), t = !Ce && (r & Gt) !== 0 && (r & Xo) === 0;
  if (t) {
    var n = (
      /** @type {ComponentContext} */
      Be
    );
    (n.e ?? (n.e = [])).push(e);
  } else
    return vu(e);
}
function vu(e) {
  return dt(Po | $c, e, !1);
}
function S_(e) {
  return bu(), dt(Xa | $c, e, !0);
}
function I_(e) {
  Bt.ensure();
  const r = dt(Cn | _a, e, !0);
  return (t = {}) => new Promise((n) => {
    t.outro ? Pn(r, () => {
      wr(r), n(void 0);
    }) : (wr(r), n(void 0));
  });
}
function Dn(e) {
  return dt(Po, e, !1);
}
function pt(e, r) {
  var t = (
    /** @type {ComponentContextLegacy} */
    Be
  ), n = { effect: null, ran: !1, deps: e };
  t.l.$.push(n), n.effect = eo(() => {
    e(), !n.ran && (n.ran = !0, Ue(r));
  });
}
function T_() {
  var e = (
    /** @type {ComponentContextLegacy} */
    Be
  );
  eo(() => {
    for (var r of e.l.$) {
      r.deps();
      var t = r.effect;
      (t.f & vr) !== 0 && t.deps !== null && lr(t, Mt), ha(t) && ua(t), r.ran = !1;
    }
  });
}
function C_(e) {
  return dt(Ps | _a, e, !0);
}
function eo(e, r = 0) {
  return dt(Xa | r, e, !0);
}
function U(e, r = [], t = [], n = []) {
  uu(n, r, t, (a) => {
    dt(Xa, () => e(...a.map(i)), !0);
  });
}
function ma(e, r = 0) {
  var t = dt(zt | r, e, !0);
  return t;
}
function ku(e, r = 0) {
  var t = dt(ks | r, e, !0);
  return t;
}
function Fr(e) {
  return dt(Gt | _a, e, !0);
}
function wu(e) {
  var r = e.teardown;
  if (r !== null) {
    const t = sn, n = Ce;
    vl(!0), zr(null);
    try {
      r.call(null);
    } finally {
      vl(t), zr(n);
    }
  }
}
function Pu(e, r = !1) {
  var t = e.first;
  for (e.first = e.last = null; t !== null; ) {
    const a = t.ac;
    a !== null && Qa(() => {
      a.abort(Wn);
    });
    var n = t.next;
    (t.f & Cn) !== 0 ? t.parent = null : wr(t, r), t = n;
  }
}
function D_(e) {
  for (var r = e.first; r !== null; ) {
    var t = r.next;
    (r.f & Gt) === 0 && wr(r), r = t;
  }
}
function wr(e, r = !0) {
  var t = !1;
  (r || (e.f & Xc) !== 0) && e.nodes !== null && e.nodes.end !== null && (xu(
    e.nodes.start,
    /** @type {TemplateNode} */
    e.nodes.end
  ), t = !0), Pu(e, r && !t), So(e, 0), lr(e, Rt);
  var n = e.nodes && e.nodes.t;
  if (n !== null)
    for (const o of n)
      o.stop();
  wu(e);
  var a = e.parent;
  a !== null && a.first !== null && Eu(e), e.next = e.prev = e.teardown = e.ctx = e.deps = e.fn = e.nodes = e.ac = null;
}
function xu(e, r) {
  for (; e !== null; ) {
    var t = e === r ? null : /* @__PURE__ */ Ja(e);
    e.remove(), e = t;
  }
}
function Eu(e) {
  var r = e.parent, t = e.prev, n = e.next;
  t !== null && (t.next = n), n !== null && (n.prev = t), r !== null && (r.first === e && (r.first = n), r.last === e && (r.last = t));
}
function Pn(e, r, t = !0) {
  var n = [];
  Su(e, n, !0);
  var a = () => {
    t && wr(e), r && r();
  }, o = n.length;
  if (o > 0) {
    var s = () => --o || a();
    for (var l of n)
      l.out(s);
  } else
    a();
}
function Su(e, r, t) {
  if ((e.f & Hr) === 0) {
    e.f ^= Hr;
    var n = e.nodes && e.nodes.t;
    if (n !== null)
      for (const l of n)
        (l.is_global || t) && r.push(l);
    for (var a = e.first; a !== null; ) {
      var o = a.next, s = (a.f & qt) !== 0 || // If this is a branch effect without a block effect parent,
      // it means the parent block effect was pruned. In that case,
      // transparency information was transferred to the branch effect.
      (a.f & Gt) !== 0 && (e.f & zt) !== 0;
      Su(a, r, s ? t : !1), a = o;
    }
  }
}
function Ds(e) {
  Iu(e, !0);
}
function Iu(e, r) {
  if ((e.f & Hr) !== 0) {
    e.f ^= Hr, (e.f & vr) === 0 && (lr(e, Cr), Yt(e));
    for (var t = e.first; t !== null; ) {
      var n = t.next, a = (t.f & qt) !== 0 || (t.f & Gt) !== 0;
      Iu(t, a ? r : !1), t = n;
    }
    var o = e.nodes && e.nodes.t;
    if (o !== null)
      for (const s of o)
        (s.is_global || r) && s.in();
  }
}
function Tu(e, r) {
  if (e.nodes)
    for (var t = e.nodes.start, n = e.nodes.end; t !== null; ) {
      var a = t === n ? null : /* @__PURE__ */ Ja(t);
      r.append(t), t = a;
    }
}
let xn = !1;
function Eo(e) {
  xn = e;
}
let sn = !1;
function vl(e) {
  sn = e;
}
let Ce = null, lt = !1;
function zr(e) {
  Ce = e;
}
let Me = null;
function Ft(e) {
  Me = e;
}
let Tr = null;
function Cu(e) {
  Ce !== null && (Tr === null ? Tr = [e] : Tr.push(e));
}
let Ir = null, Nr = 0, Xr = null;
function A_(e) {
  Xr = e;
}
let Du = 1, Ma = 0, En = Ma;
function kl(e) {
  En = e;
}
function Au() {
  return ++Du;
}
function ha(e) {
  var r = e.f;
  if ((r & Cr) !== 0)
    return !0;
  if (r & Pr && (e.f &= -32769), (r & Mt) !== 0) {
    for (var t = (
      /** @type {Value[]} */
      e.deps
    ), n = t.length, a = 0; a < n; a++) {
      var o = t[a];
      if (ha(
        /** @type {Derived} */
        o
      ) && pu(
        /** @type {Derived} */
        o
      ), o.wv > e.wv)
        return !0;
    }
    (r & et) !== 0 && // During time traveling we don't want to reset the status so that
    // traversal of the graph in the other batches still happens
    hr === null && lr(e, vr);
  }
  return !1;
}
function qu(e, r, t = !0) {
  var n = e.reactions;
  if (n !== null && !(Tr != null && Tr.includes(e)))
    for (var a = 0; a < n.length; a++) {
      var o = n[a];
      (o.f & Pr) !== 0 ? qu(
        /** @type {Derived} */
        o,
        r,
        !1
      ) : r === o && (t ? lr(o, Cr) : (o.f & vr) !== 0 && lr(o, Mt), Yt(
        /** @type {Effect} */
        o
      ));
    }
}
function Fu(e) {
  var h;
  var r = Ir, t = Nr, n = Xr, a = Ce, o = Tr, s = Be, l = lt, c = En, u = e.f;
  Ir = /** @type {null | Value[]} */
  null, Nr = 0, Xr = null, Ce = (u & (Gt | Cn)) === 0 ? e : null, Tr = null, sa(e.ctx), lt = !1, En = ++Ma, e.ac !== null && (Qa(() => {
    e.ac.abort(Wn);
  }), e.ac = null);
  try {
    e.f |= Ui;
    var d = (
      /** @type {Function} */
      e.fn
    ), p = d(), _ = e.deps;
    if (Ir !== null) {
      var g;
      if (So(e, Nr), _ !== null && Nr > 0)
        for (_.length = Nr + Ir.length, g = 0; g < Ir.length; g++)
          _[Nr + g] = Ir[g];
      else
        e.deps = _ = Ir;
      if (Cs() && (e.f & et) !== 0)
        for (g = Nr; g < _.length; g++)
          ((h = _[g]).reactions ?? (h.reactions = [])).push(e);
    } else _ !== null && Nr < _.length && (So(e, Nr), _.length = Nr);
    if ($a() && Xr !== null && !lt && _ !== null && (e.f & (Pr | Mt | Cr)) === 0)
      for (g = 0; g < /** @type {Source[]} */
      Xr.length; g++)
        qu(
          Xr[g],
          /** @type {Effect} */
          e
        );
    return a !== null && a !== e && (Ma++, Xr !== null && (n === null ? n = Xr : n.push(.../** @type {Source[]} */
    Xr))), (e.f & nn) !== 0 && (e.f ^= nn), p;
  } catch (w) {
    return ru(w);
  } finally {
    e.f ^= Ui, Ir = r, Nr = t, Xr = n, Ce = a, Tr = o, sa(s), lt = l, En = c;
  }
}
function q_(e, r) {
  let t = r.reactions;
  if (t !== null) {
    var n = Vp.call(t, e);
    if (n !== -1) {
      var a = t.length - 1;
      a === 0 ? t = r.reactions = null : (t[n] = t[a], t.pop());
    }
  }
  if (t === null && (r.f & Pr) !== 0 && // Destroying a child effect while updating a parent effect can cause a dependency to appear
  // to be unused, when in fact it is used by the currently-updating parent. Checking `new_deps`
  // allows us to skip the expensive work of disconnecting and immediately reconnecting it
  (Ir === null || !Ir.includes(r))) {
    var o = (
      /** @type {Derived} */
      r
    );
    (o.f & et) !== 0 && (o.f ^= et, o.f &= -32769), Ss(o), du(o), So(o, 0);
  }
}
function So(e, r) {
  var t = e.deps;
  if (t !== null)
    for (var n = r; n < t.length; n++)
      q_(e, t[n]);
}
function ua(e) {
  var r = e.f;
  if ((r & Rt) === 0) {
    lr(e, vr);
    var t = Me, n = xn;
    Me = e, xn = !0;
    try {
      (r & (zt | ks)) !== 0 ? D_(e) : Pu(e), wu(e);
      var a = Fu(e);
      e.teardown = typeof a == "function" ? a : null, e.wv = Du;
      var o;
      Bi && i_ && (e.f & Cr) !== 0 && e.deps;
    } finally {
      xn = n, Me = t;
    }
  }
}
function i(e) {
  var r = e.f, t = (r & Pr) !== 0;
  if (Ce !== null && !lt) {
    var n = Me !== null && (Me.f & Rt) !== 0;
    if (!n && !(Tr != null && Tr.includes(e))) {
      var a = Ce.deps;
      if ((Ce.f & Ui) !== 0)
        e.rv < Ma && (e.rv = Ma, Ir === null && a !== null && a[Nr] === e ? Nr++ : Ir === null ? Ir = [e] : Ir.includes(e) || Ir.push(e));
      else {
        (Ce.deps ?? (Ce.deps = [])).push(e);
        var o = e.reactions;
        o === null ? e.reactions = [Ce] : o.includes(Ce) || o.push(Ce);
      }
    }
  }
  if (sn && an.has(e))
    return an.get(e);
  if (t) {
    var s = (
      /** @type {Derived} */
      e
    );
    if (sn) {
      var l = s.v;
      return ((s.f & vr) === 0 && s.reactions !== null || Mu(s)) && (l = Ts(s)), an.set(s, l), l;
    }
    var c = (s.f & et) === 0 && !lt && Ce !== null && (xn || (Ce.f & et) !== 0), u = s.deps === null;
    ha(s) && (c && (s.f |= et), pu(s)), c && !u && zu(s);
  }
  if (hr != null && hr.has(e))
    return hr.get(e);
  if ((e.f & nn) !== 0)
    throw e.v;
  return e.v;
}
function zu(e) {
  if (e.deps !== null) {
    e.f |= et;
    for (const r of e.deps)
      (r.reactions ?? (r.reactions = [])).push(e), (r.f & Pr) !== 0 && (r.f & et) === 0 && zu(
        /** @type {Derived} */
        r
      );
  }
}
function Mu(e) {
  if (e.v === pr) return !0;
  if (e.deps === null) return !1;
  for (const r of e.deps)
    if (an.has(r) || (r.f & Pr) !== 0 && Mu(
      /** @type {Derived} */
      r
    ))
      return !0;
  return !1;
}
function Ue(e) {
  var r = lt;
  try {
    return lt = !0, e();
  } finally {
    lt = r;
  }
}
function F_(e, r) {
  var t = {};
  for (var n in e)
    r.includes(n) || (t[n] = e[n]);
  for (var a of Object.getOwnPropertySymbols(e))
    Object.propertyIsEnumerable.call(e, a) && !r.includes(a) && (t[a] = e[a]);
  return t;
}
function Ge(e) {
  if (!(typeof e != "object" || !e || e instanceof EventTarget)) {
    if (Tt in e)
      Ki(e);
    else if (!Array.isArray(e))
      for (let r in e) {
        const t = e[r];
        typeof t == "object" && t && Tt in t && Ki(t);
      }
  }
}
function Ki(e, r = /* @__PURE__ */ new Set()) {
  if (typeof e == "object" && e !== null && // We don't want to traverse DOM elements
  !(e instanceof EventTarget) && !r.has(e)) {
    r.add(e), e instanceof Date && e.getTime();
    for (let n in e)
      try {
        Ki(e[n], r);
      } catch {
      }
    const t = vs(e);
    if (t !== Object.prototype && t !== Array.prototype && t !== Map.prototype && t !== Set.prototype && t !== Date.prototype) {
      const n = Gc(t);
      for (let a in n) {
        const o = n[a].get;
        if (o)
          try {
            o.call(e);
          } catch {
          }
      }
    }
  }
}
const Ou = /* @__PURE__ */ new Set(), Xi = /* @__PURE__ */ new Set();
function As(e, r, t, n = {}) {
  function a(o) {
    if (n.capture || Sa.call(r, o), !o.cancelBubble)
      return Qa(() => t == null ? void 0 : t.call(this, o));
  }
  return e.startsWith("pointer") || e.startsWith("touch") || e === "wheel" ? un(() => {
    r.addEventListener(e, a, n);
  }) : r.addEventListener(e, a, n), a;
}
function z_(e, r, t, n = {}) {
  var a = As(r, e, t, n);
  return () => {
    e.removeEventListener(r, a, n);
  };
}
function Vr(e, r, t, n, a) {
  var o = { capture: n, passive: a }, s = As(e, r, t, o);
  (r === document.body || // @ts-ignore
  r === window || // @ts-ignore
  r === document || // Firefox has quirky behavior, it can happen that we still get "canplay" events when the element is already removed
  r instanceof HTMLMediaElement) && fa(() => {
    r.removeEventListener(e, s, o);
  });
}
function ro(e) {
  for (var r = 0; r < e.length; r++)
    Ou.add(e[r]);
  for (var t of Xi)
    t(e);
}
let wl = null;
function Sa(e) {
  var v;
  var r = this, t = (
    /** @type {Node} */
    r.ownerDocument
  ), n = e.type, a = ((v = e.composedPath) == null ? void 0 : v.call(e)) || [], o = (
    /** @type {null | Element} */
    a[0] || e.target
  );
  wl = e;
  var s = 0, l = wl === e && e.__root;
  if (l) {
    var c = a.indexOf(l);
    if (c !== -1 && (r === document || r === /** @type {any} */
    window)) {
      e.__root = r;
      return;
    }
    var u = a.indexOf(r);
    if (u === -1)
      return;
    c <= u && (s = c);
  }
  if (o = /** @type {Element} */
  a[s] || e.target, o !== r) {
    Yc(e, "currentTarget", {
      configurable: !0,
      get() {
        return o || t;
      }
    });
    var d = Ce, p = Me;
    zr(null), Ft(null);
    try {
      for (var _, g = []; o !== null; ) {
        var h = o.assignedSlot || o.parentNode || /** @type {any} */
        o.host || null;
        try {
          var w = o["__" + n];
          w != null && (!/** @type {any} */
          o.disabled || // DOM could've been updated already by the time this is reached, so we check this as well
          // -> the target could not have been disabled because it emits the event in the first place
          e.target === o) && w.call(o, e);
        } catch (f) {
          _ ? g.push(f) : _ = f;
        }
        if (e.cancelBubble || h === r || h === null)
          break;
        o = h;
      }
      if (_) {
        for (let f of g)
          queueMicrotask(() => {
            throw f;
          });
        throw _;
      }
    } finally {
      e.__root = r, delete e.currentTarget, zr(d), Ft(p);
    }
  }
}
function qs(e) {
  var r = document.createElement("template");
  return r.innerHTML = e.replaceAll("<!>", "<!---->"), r.content;
}
function ln(e, r) {
  var t = (
    /** @type {Effect} */
    Me
  );
  t.nodes === null && (t.nodes = { start: e, end: r, a: null, t: null });
}
// @__NO_SIDE_EFFECTS__
function B(e, r) {
  var t = (r & Wc) !== 0, n = (r & Lp) !== 0, a, o = !e.startsWith("<!>");
  return () => {
    a === void 0 && (a = qs(o ? e : "<!>" + e), t || (a = /** @type {TemplateNode} */
    /* @__PURE__ */ Rr(a)));
    var s = (
      /** @type {TemplateNode} */
      n || fu ? document.importNode(a, !0) : a.cloneNode(!0)
    );
    if (t) {
      var l = (
        /** @type {TemplateNode} */
        /* @__PURE__ */ Rr(s)
      ), c = (
        /** @type {TemplateNode} */
        s.lastChild
      );
      ln(l, c);
    } else
      ln(s, s);
    return s;
  };
}
// @__NO_SIDE_EFFECTS__
function M_(e, r, t = "svg") {
  var n = !e.startsWith("<!>"), a = (r & Wc) !== 0, o = `<${t}>${n ? e : "<!>" + e}</${t}>`, s;
  return () => {
    if (!s) {
      var l = (
        /** @type {DocumentFragment} */
        qs(o)
      ), c = (
        /** @type {Element} */
        /* @__PURE__ */ Rr(l)
      );
      if (a)
        for (s = document.createDocumentFragment(); /* @__PURE__ */ Rr(c); )
          s.appendChild(
            /** @type {TemplateNode} */
            /* @__PURE__ */ Rr(c)
          );
      else
        s = /** @type {Element} */
        /* @__PURE__ */ Rr(c);
    }
    var u = (
      /** @type {TemplateNode} */
      s.cloneNode(!0)
    );
    if (a) {
      var d = (
        /** @type {TemplateNode} */
        /* @__PURE__ */ Rr(u)
      ), p = (
        /** @type {TemplateNode} */
        u.lastChild
      );
      ln(d, p);
    } else
      ln(u, u);
    return u;
  };
}
// @__NO_SIDE_EFFECTS__
function or(e, r) {
  return /* @__PURE__ */ M_(e, r, "svg");
}
function Ee(e = "") {
  {
    var r = Ct(e + "");
    return ln(r, r), r;
  }
}
function _e() {
  var e = document.createDocumentFragment(), r = document.createComment(""), t = Ct();
  return e.append(r, t), ln(r, t), e;
}
function T(e, r) {
  e !== null && e.before(
    /** @type {Node} */
    r
  );
}
function O_(e) {
  return e.endsWith("capture") && e !== "gotpointercapture" && e !== "lostpointercapture";
}
const j_ = [
  "beforeinput",
  "click",
  "change",
  "dblclick",
  "contextmenu",
  "focusin",
  "focusout",
  "input",
  "keydown",
  "keyup",
  "mousedown",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "pointerdown",
  "pointermove",
  "pointerout",
  "pointerover",
  "pointerup",
  "touchend",
  "touchmove",
  "touchstart"
];
function N_(e) {
  return j_.includes(e);
}
const L_ = {
  // no `class: 'className'` because we handle that separately
  formnovalidate: "formNoValidate",
  ismap: "isMap",
  nomodule: "noModule",
  playsinline: "playsInline",
  readonly: "readOnly",
  defaultvalue: "defaultValue",
  defaultchecked: "defaultChecked",
  srcobject: "srcObject",
  novalidate: "noValidate",
  allowfullscreen: "allowFullscreen",
  disablepictureinpicture: "disablePictureInPicture",
  disableremoteplayback: "disableRemotePlayback"
};
function B_(e) {
  return e = e.toLowerCase(), L_[e] ?? e;
}
const U_ = ["touchstart", "touchmove"];
function R_(e) {
  return U_.includes(e);
}
let Io = !0;
function io(e) {
  Io = e;
}
function pe(e, r) {
  var t = r == null ? "" : typeof r == "object" ? r + "" : r;
  t !== (e.__t ?? (e.__t = e.nodeValue)) && (e.__t = t, e.nodeValue = t + "");
}
function Gn(e, r) {
  return V_(e, r);
}
const Ln = /* @__PURE__ */ new Map();
function V_(e, { target: r, anchor: t, props: n = {}, events: a, context: o, intro: s = !0 }) {
  w_();
  var l = /* @__PURE__ */ new Set(), c = (p) => {
    for (var _ = 0; _ < p.length; _++) {
      var g = p[_];
      if (!l.has(g)) {
        l.add(g);
        var h = R_(g);
        r.addEventListener(g, Sa, { passive: h });
        var w = Ln.get(g);
        w === void 0 ? (document.addEventListener(g, Sa, { passive: h }), Ln.set(g, 1)) : Ln.set(g, w + 1);
      }
    }
  };
  c(Go(Ou)), Xi.add(c);
  var u = void 0, d = I_(() => {
    var p = t ?? r.appendChild(Ct());
    return cu(
      /** @type {TemplateNode} */
      p,
      {
        pending: () => {
        }
      },
      (_) => {
        if (o) {
          ee({});
          var g = (
            /** @type {ComponentContext} */
            Be
          );
          g.c = o;
        }
        a && (n.$$events = a), Io = s, u = e(_, n) || {}, Io = !0, o && re();
      }
    ), () => {
      var h;
      for (var _ of l) {
        r.removeEventListener(_, Sa);
        var g = (
          /** @type {number} */
          Ln.get(_)
        );
        --g === 0 ? (document.removeEventListener(_, Sa), Ln.delete(_)) : Ln.set(_, g);
      }
      Xi.delete(c), p !== t && ((h = p.parentNode) == null || h.removeChild(p));
    };
  });
  return $i.set(u, d), u;
}
let $i = /* @__PURE__ */ new WeakMap();
function Ia(e, r) {
  const t = $i.get(e);
  return t ? ($i.delete(e), t(r)) : Promise.resolve();
}
var st, It, Ur, wn, Ha, Wa, Vo;
class $o {
  /**
   * @param {TemplateNode} anchor
   * @param {boolean} transition
   */
  constructor(r, t = !0) {
    /** @type {TemplateNode} */
    V(this, "anchor");
    /** @type {Map<Batch, Key>} */
    we(this, st, /* @__PURE__ */ new Map());
    /**
     * Map of keys to effects that are currently rendered in the DOM.
     * These effects are visible and actively part of the document tree.
     * Example:
     * ```
     * {#if condition}
     * 	foo
     * {:else}
     * 	bar
     * {/if}
     * ```
     * Can result in the entries `true->Effect` and `false->Effect`
     * @type {Map<Key, Effect>}
     */
    we(this, It, /* @__PURE__ */ new Map());
    /**
     * Similar to #onscreen with respect to the keys, but contains branches that are not yet
     * in the DOM, because their insertion is deferred.
     * @type {Map<Key, Branch>}
     */
    we(this, Ur, /* @__PURE__ */ new Map());
    /**
     * Keys of effects that are currently outroing
     * @type {Set<Key>}
     */
    we(this, wn, /* @__PURE__ */ new Set());
    /**
     * Whether to pause (i.e. outro) on change, or destroy immediately.
     * This is necessary for `<svelte:element>`
     */
    we(this, Ha, !0);
    we(this, Wa, () => {
      var r = (
        /** @type {Batch} */
        He
      );
      if (N(this, st).has(r)) {
        var t = (
          /** @type {Key} */
          N(this, st).get(r)
        ), n = N(this, It).get(t);
        if (n)
          Ds(n), N(this, wn).delete(t);
        else {
          var a = N(this, Ur).get(t);
          a && (N(this, It).set(t, a.effect), N(this, Ur).delete(t), a.fragment.lastChild.remove(), this.anchor.before(a.fragment), n = a.effect);
        }
        for (const [o, s] of N(this, st)) {
          if (N(this, st).delete(o), o === r)
            break;
          const l = N(this, Ur).get(s);
          l && (wr(l.effect), N(this, Ur).delete(s));
        }
        for (const [o, s] of N(this, It)) {
          if (o === t || N(this, wn).has(o)) continue;
          const l = () => {
            if (Array.from(N(this, st).values()).includes(o)) {
              var u = document.createDocumentFragment();
              Tu(s, u), u.append(Ct()), N(this, Ur).set(o, { effect: s, fragment: u });
            } else
              wr(s);
            N(this, wn).delete(o), N(this, It).delete(o);
          };
          N(this, Ha) || !n ? (N(this, wn).add(o), Pn(s, l, !1)) : l();
        }
      }
    });
    /**
     * @param {Batch} batch
     */
    we(this, Vo, (r) => {
      N(this, st).delete(r);
      const t = Array.from(N(this, st).values());
      for (const [n, a] of N(this, Ur))
        t.includes(n) || (wr(a.effect), N(this, Ur).delete(n));
    });
    this.anchor = r, ke(this, Ha, t);
  }
  /**
   *
   * @param {any} key
   * @param {null | ((target: TemplateNode) => void)} fn
   */
  ensure(r, t) {
    var n = (
      /** @type {Batch} */
      He
    ), a = yu();
    if (t && !N(this, It).has(r) && !N(this, Ur).has(r))
      if (a) {
        var o = document.createDocumentFragment(), s = Ct();
        o.append(s), N(this, Ur).set(r, {
          effect: Fr(() => t(s)),
          fragment: o
        });
      } else
        N(this, It).set(
          r,
          Fr(() => t(this.anchor))
        );
    if (N(this, st).set(n, r), a) {
      for (const [l, c] of N(this, It))
        l === r ? n.skipped_effects.delete(c) : n.skipped_effects.add(c);
      for (const [l, c] of N(this, Ur))
        l === r ? n.skipped_effects.delete(c.effect) : n.skipped_effects.add(c.effect);
      n.oncommit(N(this, Wa)), n.ondiscard(N(this, Vo));
    } else
      N(this, Wa).call(this);
  }
}
st = new WeakMap(), It = new WeakMap(), Ur = new WeakMap(), wn = new WeakMap(), Ha = new WeakMap(), Wa = new WeakMap(), Vo = new WeakMap();
function Ze(e, r, ...t) {
  var n = new $o(e);
  ma(() => {
    const a = r() ?? null;
    n.ensure(a, a && ((o) => a(o, ...t)));
  }, qt);
}
function nr(e) {
  Be === null && xs(), ga && Be.l !== null ? H_(Be).m.push(e) : kr(() => {
    const r = Ue(e);
    if (typeof r == "function") return (
      /** @type {() => void} */
      r
    );
  });
}
function Ot(e) {
  Be === null && xs(), nr(() => () => Ue(e));
}
function H_(e) {
  var r = (
    /** @type {ComponentContextLegacy} */
    e.l
  );
  return r.u ?? (r.u = { a: [], b: [], m: [] });
}
function W(e, r, t = !1) {
  var n = new $o(e), a = t ? qt : 0;
  function o(s, l) {
    n.ensure(s, l);
  }
  ma(() => {
    var s = !1;
    r((l, c = !0) => {
      s = !0, o(c, l);
    }), s || o(!1, null);
  }, a);
}
function Ht(e, r) {
  return r;
}
function W_(e, r, t) {
  for (var n = [], a = r.length, o, s = r.length, l = 0; l < a; l++) {
    let p = r[l];
    Pn(
      p,
      () => {
        if (o) {
          if (o.pending.delete(p), o.done.add(p), o.pending.size === 0) {
            var _ = (
              /** @type {Set<EachOutroGroup>} */
              e.outrogroups
            );
            Zi(Go(o.done)), _.delete(o), _.size === 0 && (e.outrogroups = null);
          }
        } else
          s -= 1;
      },
      !1
    );
  }
  if (s === 0) {
    var c = n.length === 0 && t !== null;
    if (c) {
      var u = (
        /** @type {Element} */
        t
      ), d = (
        /** @type {Element} */
        u.parentNode
      );
      P_(d), d.append(u), e.items.clear();
    }
    Zi(r, !c);
  } else
    o = {
      pending: new Set(r),
      done: /* @__PURE__ */ new Set()
    }, (e.outrogroups ?? (e.outrogroups = /* @__PURE__ */ new Set())).add(o);
}
function Zi(e, r = !0) {
  for (var t = 0; t < e.length; t++)
    wr(e[t], r);
}
var Pl;
function Dt(e, r, t, n, a, o = null) {
  var s = e, l = /* @__PURE__ */ new Map(), c = (r & Hc) !== 0;
  if (c) {
    var u = (
      /** @type {Element} */
      e
    );
    s = u.appendChild(Ct());
  }
  var d = null, p = /* @__PURE__ */ Vt(() => {
    var f = t();
    return Yo(f) ? f : f == null ? [] : Go(f);
  }), _, g = !0;
  function h() {
    v.fallback = d, Y_(v, _, s, r, n), d !== null && (_.length === 0 ? (d.f & Lt) === 0 ? Ds(d) : (d.f ^= Lt, Ta(d, null, s)) : Pn(d, () => {
      d = null;
    }));
  }
  var w = ma(() => {
    _ = /** @type {V[]} */
    i(p);
    for (var f = _.length, y = /* @__PURE__ */ new Set(), k = (
      /** @type {Batch} */
      He
    ), m = yu(), S = 0; S < f; S += 1) {
      var x = _[S], P = n(x, S), I = g ? null : l.get(P);
      I ? (I.v && ca(I.v, x), I.i && ca(I.i, S), m && k.skipped_effects.delete(I.e)) : (I = G_(
        l,
        g ? s : Pl ?? (Pl = Ct()),
        x,
        P,
        S,
        a,
        r,
        t
      ), g || (I.e.f |= Lt), l.set(P, I)), y.add(P);
    }
    if (f === 0 && o && !d && (g ? d = Fr(() => o(s)) : (d = Fr(() => o(Pl ?? (Pl = Ct()))), d.f |= Lt)), !g)
      if (m) {
        for (const [E, D] of l)
          y.has(E) || k.skipped_effects.add(D.e);
        k.oncommit(h), k.ondiscard(() => {
        });
      } else
        h();
    i(p);
  }), v = { effect: w, items: l, outrogroups: null, fallback: d };
  g = !1;
}
function Y_(e, r, t, n, a) {
  var D, F, M, C, j, H, A, q, O;
  var o = (n & Cp) !== 0, s = r.length, l = e.items, c = e.effect.first, u, d = null, p, _ = [], g = [], h, w, v, f;
  if (o)
    for (f = 0; f < s; f += 1)
      h = r[f], w = a(h, f), v = /** @type {EachItem} */
      l.get(w).e, (v.f & Lt) === 0 && ((F = (D = v.nodes) == null ? void 0 : D.a) == null || F.measure(), (p ?? (p = /* @__PURE__ */ new Set())).add(v));
  for (f = 0; f < s; f += 1) {
    if (h = r[f], w = a(h, f), v = /** @type {EachItem} */
    l.get(w).e, e.outrogroups !== null)
      for (const G of e.outrogroups)
        G.pending.delete(v), G.done.delete(v);
    if ((v.f & Lt) !== 0)
      if (v.f ^= Lt, v === c)
        Ta(v, null, t);
      else {
        var y = d ? d.next : c;
        v === e.effect.last && (e.effect.last = v.prev), v.prev && (v.prev.next = v.next), v.next && (v.next.prev = v.prev), $t(e, d, v), $t(e, v, y), Ta(v, y, t), d = v, _ = [], g = [], c = d.next;
        continue;
      }
    if ((v.f & Hr) !== 0 && (Ds(v), o && ((C = (M = v.nodes) == null ? void 0 : M.a) == null || C.unfix(), (p ?? (p = /* @__PURE__ */ new Set())).delete(v))), v !== c) {
      if (u !== void 0 && u.has(v)) {
        if (_.length < g.length) {
          var k = g[0], m;
          d = k.prev;
          var S = _[0], x = _[_.length - 1];
          for (m = 0; m < _.length; m += 1)
            Ta(_[m], k, t);
          for (m = 0; m < g.length; m += 1)
            u.delete(g[m]);
          $t(e, S.prev, x.next), $t(e, d, S), $t(e, x, k), c = k, d = x, f -= 1, _ = [], g = [];
        } else
          u.delete(v), Ta(v, c, t), $t(e, v.prev, v.next), $t(e, v, d === null ? e.effect.first : d.next), $t(e, d, v), d = v;
        continue;
      }
      for (_ = [], g = []; c !== null && c !== v; )
        (u ?? (u = /* @__PURE__ */ new Set())).add(c), g.push(c), c = c.next;
      if (c === null)
        continue;
    }
    (v.f & Lt) === 0 && _.push(v), d = v, c = v.next;
  }
  if (e.outrogroups !== null) {
    for (const G of e.outrogroups)
      G.pending.size === 0 && (Zi(Go(G.done)), (j = e.outrogroups) == null || j.delete(G));
    e.outrogroups.size === 0 && (e.outrogroups = null);
  }
  if (c !== null || u !== void 0) {
    var P = [];
    if (u !== void 0)
      for (v of u)
        (v.f & Hr) === 0 && P.push(v);
    for (; c !== null; )
      (c.f & Hr) === 0 && c !== e.fallback && P.push(c), c = c.next;
    var I = P.length;
    if (I > 0) {
      var E = (n & Hc) !== 0 && s === 0 ? t : null;
      if (o) {
        for (f = 0; f < I; f += 1)
          (A = (H = P[f].nodes) == null ? void 0 : H.a) == null || A.measure();
        for (f = 0; f < I; f += 1)
          (O = (q = P[f].nodes) == null ? void 0 : q.a) == null || O.fix();
      }
      W_(e, P, E);
    }
  }
  o && un(() => {
    var G, Y;
    if (p !== void 0)
      for (v of p)
        (Y = (G = v.nodes) == null ? void 0 : G.a) == null || Y.apply();
  });
}
function G_(e, r, t, n, a, o, s, l) {
  var c = (s & Ip) !== 0 ? (s & Dp) === 0 ? /* @__PURE__ */ Br(t, !1, !1) : Sn(t) : null, u = (s & Tp) !== 0 ? Sn(a) : null;
  return {
    v: c,
    i: u,
    e: Fr(() => (o(r, c ?? t, u ?? a, l), () => {
      e.delete(n);
    }))
  };
}
function Ta(e, r, t) {
  if (e.nodes)
    for (var n = e.nodes.start, a = e.nodes.end, o = r && (r.f & Lt) === 0 ? (
      /** @type {EffectNodes} */
      r.nodes.start
    ) : t; n !== null; ) {
      var s = (
        /** @type {TemplateNode} */
        /* @__PURE__ */ Ja(n)
      );
      if (o.before(n), n === a)
        return;
      n = s;
    }
}
function $t(e, r, t) {
  r === null ? e.effect.first = t : r.next = t, t === null ? e.effect.last = r : t.prev = r;
}
function dn(e, r, t = !1, n = !1, a = !1) {
  var o = e, s = "";
  U(() => {
    var l = (
      /** @type {Effect} */
      Me
    );
    if (s !== (s = r() ?? "") && (l.nodes !== null && (xu(
      l.nodes.start,
      /** @type {TemplateNode} */
      l.nodes.end
    ), l.nodes = null), s !== "")) {
      var c = s + "";
      t ? c = `<svg>${c}</svg>` : n && (c = `<math>${c}</math>`);
      var u = qs(c);
      if ((t || n) && (u = /** @type {Element} */
      /* @__PURE__ */ Rr(u)), ln(
        /** @type {TemplateNode} */
        /* @__PURE__ */ Rr(u),
        /** @type {TemplateNode} */
        u.lastChild
      ), t || n)
        for (; /* @__PURE__ */ Rr(u); )
          o.before(
            /** @type {TemplateNode} */
            /* @__PURE__ */ Rr(u)
          );
      else
        o.before(u);
    }
  });
}
function K_(e, r, t) {
  var n = new $o(e);
  ma(() => {
    var a = r() ?? null;
    n.ensure(a, a && ((o) => t(o, a)));
  }, qt);
}
const X_ = () => performance.now(), Nt = {
  // don't access requestAnimationFrame eagerly outside method
  // this allows basic testing of user code without JSDOM
  // bunder will eval and remove ternary when the user's app is built
  tick: (
    /** @param {any} _ */
    (e) => requestAnimationFrame(e)
  ),
  now: () => X_(),
  tasks: /* @__PURE__ */ new Set()
};
function ju() {
  const e = Nt.now();
  Nt.tasks.forEach((r) => {
    r.c(e) || (Nt.tasks.delete(r), r.f());
  }), Nt.tasks.size !== 0 && Nt.tick(ju);
}
function $_(e) {
  let r;
  return Nt.tasks.size === 0 && Nt.tick(ju), {
    promise: new Promise((t) => {
      Nt.tasks.add(r = { c: e, f: t });
    }),
    abort() {
      Nt.tasks.delete(r);
    }
  };
}
function so(e, r) {
  Qa(() => {
    e.dispatchEvent(new CustomEvent(r));
  });
}
function Z_(e) {
  if (e === "float") return "cssFloat";
  if (e === "offset") return "cssOffset";
  if (e.startsWith("--")) return e;
  const r = e.split("-");
  return r.length === 1 ? r[0] : r[0] + r.slice(1).map(
    /** @param {any} word */
    (t) => t[0].toUpperCase() + t.slice(1)
  ).join("");
}
function xl(e) {
  const r = {}, t = e.split(";");
  for (const n of t) {
    const [a, o] = n.split(":");
    if (!a || o === void 0) break;
    const s = Z_(a.trim());
    r[s] = o.trim();
  }
  return r;
}
const J_ = (e) => e;
function Nu(e, r, t, n) {
  var k;
  var a = (e & Op) !== 0, o = (e & jp) !== 0, s = a && o, l = (e & Np) !== 0, c = s ? "both" : a ? "in" : "out", u, d = r.inert, p = r.style.overflow, _, g;
  function h() {
    return Qa(() => u ?? (u = t()(r, (n == null ? void 0 : n()) ?? /** @type {P} */
    {}, {
      direction: c
    })));
  }
  var w = {
    is_global: l,
    in() {
      var m;
      if (r.inert = d, !a) {
        g == null || g.abort(), (m = g == null ? void 0 : g.reset) == null || m.call(g);
        return;
      }
      o || _ == null || _.abort(), so(r, "introstart"), _ = Ji(r, h(), g, 1, () => {
        so(r, "introend"), _ == null || _.abort(), _ = u = void 0, r.style.overflow = p;
      });
    },
    out(m) {
      if (!o) {
        m == null || m(), u = void 0;
        return;
      }
      r.inert = !0, so(r, "outrostart"), g = Ji(r, h(), _, 0, () => {
        so(r, "outroend"), m == null || m();
      });
    },
    stop: () => {
      _ == null || _.abort(), g == null || g.abort();
    }
  }, v = (
    /** @type {Effect & { nodes: EffectNodes }} */
    Me
  );
  if (((k = v.nodes).t ?? (k.t = [])).push(w), a && Io) {
    var f = l;
    if (!f) {
      for (var y = (
        /** @type {Effect | null} */
        v.parent
      ); y && (y.f & qt) !== 0; )
        for (; (y = y.parent) && (y.f & zt) === 0; )
          ;
      f = !y || (y.f & Xo) !== 0;
    }
    f && Dn(() => {
      Ue(() => w.in());
    });
  }
}
function Ji(e, r, t, n, a) {
  var o = n === 1;
  if (Vn(r)) {
    var s, l = !1;
    return un(() => {
      if (!l) {
        var v = r({ direction: o ? "in" : "out" });
        s = Ji(e, v, t, n, a);
      }
    }), {
      abort: () => {
        l = !0, s == null || s.abort();
      },
      deactivate: () => s.deactivate(),
      reset: () => s.reset(),
      t: () => s.t()
    };
  }
  if (t == null || t.deactivate(), !(r != null && r.duration))
    return a(), {
      abort: ze,
      deactivate: ze,
      reset: ze,
      t: () => n
    };
  const { delay: c = 0, css: u, tick: d, easing: p = J_ } = r;
  var _ = [];
  if (o && t === void 0 && (d && d(0, 1), u)) {
    var g = xl(u(0, 1));
    _.push(g, g);
  }
  var h = () => 1 - n, w = e.animate(_, { duration: c, fill: "forwards" });
  return w.onfinish = () => {
    w.cancel();
    var v = (t == null ? void 0 : t.t()) ?? 1 - n;
    t == null || t.abort();
    var f = n - v, y = (
      /** @type {number} */
      r.duration * Math.abs(f)
    ), k = [];
    if (y > 0) {
      var m = !1;
      if (u)
        for (var S = Math.ceil(y / 16.666666666666668), x = 0; x <= S; x += 1) {
          var P = v + f * p(x / S), I = xl(u(P, 1 - P));
          k.push(I), m || (m = I.overflow === "hidden");
        }
      m && (e.style.overflow = "hidden"), h = () => {
        var E = (
          /** @type {number} */
          /** @type {globalThis.Animation} */
          w.currentTime
        );
        return v + f * p(E / y);
      }, d && $_(() => {
        if (w.playState !== "running") return !1;
        var E = h();
        return d(E, 1 - E), !0;
      });
    }
    w = e.animate(k, { duration: y, fill: "forwards" }), w.onfinish = () => {
      h = () => n, d == null || d(n, 1 - n), a();
    };
  }, {
    abort: () => {
      w && (w.cancel(), w.effect = null, w.onfinish = ze);
    },
    deactivate: () => {
      a = ze;
    },
    reset: () => {
      n === 0 && (d == null || d(1, 0));
    },
    t: () => h()
  };
}
function Fs(e, r, t, n, a, o) {
  var s = null, l = (
    /** @type {TemplateNode} */
    e
  ), c = new $o(l, !1);
  ma(() => {
    const u = r() || null;
    var d = u === "svg" ? Up : null;
    if (u === null) {
      c.ensure(null, null), io(!0);
      return;
    }
    return c.ensure(u, (p) => {
      if (u) {
        if (s = d ? document.createElementNS(d, u) : document.createElement(u), ln(s, s), n) {
          var _ = s.appendChild(Ct());
          n(s, _);
        }
        Me.nodes.end = s, p.before(s);
      }
    }), io(!0), () => {
      u && io(!1);
    };
  }, qt), fa(() => {
    io(!0);
  });
}
function oe(e, r) {
  Dn(() => {
    var t = e.getRootNode(), n = (
      /** @type {ShadowRoot} */
      t.host ? (
        /** @type {ShadowRoot} */
        t
      ) : (
        /** @type {Document} */
        t.head ?? /** @type {Document} */
        t.ownerDocument.head
      )
    );
    if (!n.querySelector("#" + r.hash)) {
      const a = document.createElement("style");
      a.id = r.hash, a.textContent = r.code, n.appendChild(a);
    }
  });
}
function Q_(e, r, t) {
  Dn(() => {
    var n = Ue(() => r(e, t == null ? void 0 : t()) || {});
    if (t && (n != null && n.update)) {
      var a = !1, o = (
        /** @type {any} */
        {}
      );
      eo(() => {
        var s = t();
        Ge(s), a && Es(o, s) && (o = s, n.update(s));
      }), a = !0;
    }
    if (n != null && n.destroy)
      return () => (
        /** @type {Function} */
        n.destroy()
      );
  });
}
function eg(e, r) {
  var t = void 0, n;
  ku(() => {
    t !== (t = r()) && (n && (wr(n), n = null), t && (n = Fr(() => {
      Dn(() => (
        /** @type {(node: Element) => void} */
        t(e)
      ));
    })));
  });
}
function Lu(e) {
  var r, t, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (r = 0; r < a; r++) e[r] && (t = Lu(e[r])) && (n && (n += " "), n += t);
  } else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function rg() {
  for (var e, r, t = 0, n = "", a = arguments.length; t < a; t++) (e = arguments[t]) && (r = Lu(e)) && (n && (n += " "), n += r);
  return n;
}
function zs(e) {
  return typeof e == "object" ? rg(e) : e ?? "";
}
const El = [...` 	
\r\f \v\uFEFF`];
function tg(e, r, t) {
  var n = e == null ? "" : "" + e;
  if (r && (n = n ? n + " " + r : r), t) {
    for (var a in t)
      if (t[a])
        n = n ? n + " " + a : a;
      else if (n.length)
        for (var o = a.length, s = 0; (s = n.indexOf(a, s)) >= 0; ) {
          var l = s + o;
          (s === 0 || El.includes(n[s - 1])) && (l === n.length || El.includes(n[l])) ? n = (s === 0 ? "" : n.substring(0, s)) + n.substring(l + 1) : s = l;
        }
  }
  return n === "" ? null : n;
}
function Sl(e, r = !1) {
  var t = r ? " !important;" : ";", n = "";
  for (var a in e) {
    var o = e[a];
    o != null && o !== "" && (n += " " + a + ": " + o + t);
  }
  return n;
}
function si(e) {
  return e[0] !== "-" || e[1] !== "-" ? e.toLowerCase() : e;
}
function ng(e, r) {
  if (r) {
    var t = "", n, a;
    if (Array.isArray(r) ? (n = r[0], a = r[1]) : n = r, e) {
      e = String(e).replaceAll(/\s*\/\*.*?\*\/\s*/g, "").trim();
      var o = !1, s = 0, l = !1, c = [];
      n && c.push(...Object.keys(n).map(si)), a && c.push(...Object.keys(a).map(si));
      var u = 0, d = -1;
      const w = e.length;
      for (var p = 0; p < w; p++) {
        var _ = e[p];
        if (l ? _ === "/" && e[p - 1] === "*" && (l = !1) : o ? o === _ && (o = !1) : _ === "/" && e[p + 1] === "*" ? l = !0 : _ === '"' || _ === "'" ? o = _ : _ === "(" ? s++ : _ === ")" && s--, !l && o === !1 && s === 0) {
          if (_ === ":" && d === -1)
            d = p;
          else if (_ === ";" || p === w - 1) {
            if (d !== -1) {
              var g = si(e.substring(u, d).trim());
              if (!c.includes(g)) {
                _ !== ";" && p++;
                var h = e.substring(u, p).trim();
                t += " " + h + ";";
              }
            }
            u = p + 1, d = -1;
          }
        }
      }
    }
    return n && (t += Sl(n)), a && (t += Sl(a, !0)), t = t.trim(), t === "" ? null : t;
  }
  return e == null ? null : String(e);
}
function tr(e, r, t, n, a, o) {
  var s = e.__className;
  if (s !== t || s === void 0) {
    var l = tg(t, n, o);
    l == null ? e.removeAttribute("class") : r ? e.className = l : e.setAttribute("class", l), e.__className = t;
  } else if (o && a !== o)
    for (var c in o) {
      var u = !!o[c];
      (a == null || u !== !!a[c]) && e.classList.toggle(c, u);
    }
  return o;
}
function li(e, r = {}, t, n) {
  for (var a in t) {
    var o = t[a];
    r[a] !== o && (t[a] == null ? e.style.removeProperty(a) : e.style.setProperty(a, o, n));
  }
}
function Pe(e, r, t, n) {
  var a = e.__style;
  if (a !== r) {
    var o = ng(r, n);
    o == null ? e.removeAttribute("style") : e.style.cssText = o, e.__style = r;
  } else n && (Array.isArray(n) ? (li(e, t == null ? void 0 : t[0], n[0]), li(e, t == null ? void 0 : t[1], n[1], "important")) : li(e, t, n));
  return n;
}
function Qi(e, r, t = !1) {
  if (e.multiple) {
    if (r == null)
      return;
    if (!Yo(r))
      return a_();
    for (var n of e.options)
      n.selected = r.includes(Il(n));
    return;
  }
  for (n of e.options) {
    var a = Il(n);
    if (k_(a, r)) {
      n.selected = !0;
      return;
    }
  }
  (!t || r !== void 0) && (e.selectedIndex = -1);
}
function ag(e) {
  var r = new MutationObserver(() => {
    Qi(e, e.__value);
  });
  r.observe(e, {
    // Listen to option element changes
    childList: !0,
    subtree: !0,
    // because of <optgroup>
    // Listen to option element value attribute changes
    // (doesn't get notified of select value changes,
    // because that property is not reflected as an attribute)
    attributes: !0,
    attributeFilter: ["value"]
  }), fa(() => {
    r.disconnect();
  });
}
function Il(e) {
  return "__value" in e ? e.__value : e.value;
}
const Pa = Symbol("class"), xa = Symbol("style"), Bu = Symbol("is custom element"), Uu = Symbol("is html");
function og(e, r) {
  r ? e.hasAttribute("selected") || e.setAttribute("selected", "") : e.removeAttribute("selected");
}
function se(e, r, t, n) {
  var a = Ru(e);
  a[r] !== (a[r] = t) && (r === "loading" && (e[Gp] = t), t == null ? e.removeAttribute(r) : typeof t != "string" && Vu(e).includes(r) ? e[r] = t : e.setAttribute(r, t));
}
function ig(e, r, t, n, a = !1, o = !1) {
  var s = Ru(e), l = s[Bu], c = !s[Uu], u = r || {}, d = e.tagName === "OPTION";
  for (var p in r)
    p in t || (t[p] = null);
  t.class ? t.class = zs(t.class) : (n || t[Pa]) && (t.class = null), t[xa] && (t.style ?? (t.style = null));
  var _ = Vu(e);
  for (const k in t) {
    let m = t[k];
    if (d && k === "value" && m == null) {
      e.value = e.__value = "", u[k] = m;
      continue;
    }
    if (k === "class") {
      var g = e.namespaceURI === "http://www.w3.org/1999/xhtml";
      tr(e, g, m, n, r == null ? void 0 : r[Pa], t[Pa]), u[k] = m, u[Pa] = t[Pa];
      continue;
    }
    if (k === "style") {
      Pe(e, m, r == null ? void 0 : r[xa], t[xa]), u[k] = m, u[xa] = t[xa];
      continue;
    }
    var h = u[k];
    if (!(m === h && !(m === void 0 && e.hasAttribute(k)))) {
      u[k] = m;
      var w = k[0] + k[1];
      if (w !== "$$")
        if (w === "on") {
          const S = {}, x = "$$" + k;
          let P = k.slice(2);
          var v = N_(P);
          if (O_(P) && (P = P.slice(0, -7), S.capture = !0), !v && h) {
            if (m != null) continue;
            e.removeEventListener(P, u[x], S), u[x] = null;
          }
          if (m != null)
            if (v)
              e[`__${P}`] = m, ro([P]);
            else {
              let I = function(E) {
                u[k].call(this, E);
              };
              u[x] = As(P, e, I, S);
            }
          else v && (e[`__${P}`] = void 0);
        } else if (k === "style")
          se(e, k, m);
        else if (k === "autofocus")
          x_(
            /** @type {HTMLElement} */
            e,
            !!m
          );
        else if (!l && (k === "__value" || k === "value" && m != null))
          e.value = e.__value = m;
        else if (k === "selected" && d)
          og(
            /** @type {HTMLOptionElement} */
            e,
            m
          );
        else {
          var f = k;
          c || (f = B_(f));
          var y = f === "defaultValue" || f === "defaultChecked";
          if (m == null && !l && !y)
            if (s[k] = null, f === "value" || f === "checked") {
              let S = (
                /** @type {HTMLInputElement} */
                e
              );
              const x = r === void 0;
              if (f === "value") {
                let P = S.defaultValue;
                S.removeAttribute(f), S.defaultValue = P, S.value = S.__value = x ? P : null;
              } else {
                let P = S.defaultChecked;
                S.removeAttribute(f), S.defaultChecked = P, S.checked = x ? P : !1;
              }
            } else
              e.removeAttribute(k);
          else y || _.includes(f) && (l || typeof m != "string") ? (e[f] = m, f in s && (s[f] = pr)) : typeof m != "function" && se(e, f, m);
        }
    }
  }
  return u;
}
function Ms(e, r, t = [], n = [], a = [], o, s = !1, l = !1) {
  uu(a, t, n, (c) => {
    var u = void 0, d = {}, p = e.nodeName === "SELECT", _ = !1;
    if (ku(() => {
      var h = r(...c.map(i)), w = ig(
        e,
        u,
        h,
        o,
        s,
        l
      );
      _ && p && "value" in h && Qi(
        /** @type {HTMLSelectElement} */
        e,
        h.value
      );
      for (let f of Object.getOwnPropertySymbols(d))
        h[f] || wr(d[f]);
      for (let f of Object.getOwnPropertySymbols(h)) {
        var v = h[f];
        f.description === Rp && (!u || v !== u[f]) && (d[f] && wr(d[f]), d[f] = Fr(() => eg(e, () => v))), w[f] = v;
      }
      u = w;
    }), p) {
      var g = (
        /** @type {HTMLSelectElement} */
        e
      );
      Dn(() => {
        Qi(
          g,
          /** @type {Record<string | symbol, any>} */
          u.value,
          !0
        ), ag(g);
      });
    }
    _ = !0;
  });
}
function Ru(e) {
  return (
    /** @type {Record<string | symbol, unknown>} **/
    // @ts-expect-error
    e.__attributes ?? (e.__attributes = {
      [Bu]: e.nodeName.includes("-"),
      [Uu]: e.namespaceURI === Bp
    })
  );
}
var Tl = /* @__PURE__ */ new Map();
function Vu(e) {
  var r = e.getAttribute("is") || e.nodeName, t = Tl.get(r);
  if (t) return t;
  Tl.set(r, t = []);
  for (var n, a = e, o = Element.prototype; o !== a; ) {
    n = Gc(a);
    for (var s in n)
      n[s].set && t.push(s);
    a = vs(a);
  }
  return t;
}
var rn, oa, Ya, Ho, Hu;
const Wo = class Wo {
  /** @param {ResizeObserverOptions} options */
  constructor(r) {
    we(this, Ho);
    /** */
    we(this, rn, /* @__PURE__ */ new WeakMap());
    /** @type {ResizeObserver | undefined} */
    we(this, oa);
    /** @type {ResizeObserverOptions} */
    we(this, Ya);
    ke(this, Ya, r);
  }
  /**
   * @param {Element} element
   * @param {(entry: ResizeObserverEntry) => any} listener
   */
  observe(r, t) {
    var n = N(this, rn).get(r) || /* @__PURE__ */ new Set();
    return n.add(t), N(this, rn).set(r, n), sr(this, Ho, Hu).call(this).observe(r, N(this, Ya)), () => {
      var a = N(this, rn).get(r);
      a.delete(t), a.size === 0 && (N(this, rn).delete(r), N(this, oa).unobserve(r));
    };
  }
};
rn = new WeakMap(), oa = new WeakMap(), Ya = new WeakMap(), Ho = new WeakSet(), Hu = function() {
  return N(this, oa) ?? ke(this, oa, new ResizeObserver(
    /** @param {any} entries */
    (r) => {
      for (var t of r) {
        Wo.entries.set(t.target, t);
        for (var n of N(this, rn).get(t.target) || [])
          n(t);
      }
    }
  ));
}, /** @static */
V(Wo, "entries", /* @__PURE__ */ new WeakMap());
let To = Wo;
var sg = /* @__PURE__ */ new To({
  box: "content-box"
}), lg = /* @__PURE__ */ new To({
  box: "border-box"
});
function Wu(e, r, t) {
  var n = sg, a = n.observe(
    e,
    /** @param {any} entry */
    (o) => t(o[r])
  );
  fa(a);
}
function Os(e, r, t) {
  var n = lg.observe(e, () => t(e[r]));
  Dn(() => (Ue(() => t(e[r])), n));
}
function Cl(e, r) {
  return e === r || (e == null ? void 0 : e[Tt]) === r;
}
function to(e = {}, r, t, n) {
  return Dn(() => {
    var a, o;
    return eo(() => {
      a = o, o = [], Ue(() => {
        e !== t(...o) && (r(e, ...o), a && Cl(t(...a), e) && r(null, ...a));
      });
    }), () => {
      un(() => {
        o && Cl(t(...o), e) && r(null, ...o);
      });
    };
  }), e;
}
function An(e = !1) {
  const r = (
    /** @type {ComponentContextLegacy} */
    Be
  ), t = r.l.u;
  if (!t) return;
  let n = () => Ge(r.s);
  if (e) {
    let a = 0, o = (
      /** @type {Record<string, any>} */
      {}
    );
    const s = /* @__PURE__ */ Za(() => {
      let l = !1;
      const c = r.s;
      for (const u in c)
        c[u] !== o[u] && (o[u] = c[u], l = !0);
      return l && a++, a;
    });
    n = () => i(s);
  }
  t.b.length && S_(() => {
    Dl(r, n), wo(t.b);
  }), kr(() => {
    const a = Ue(() => t.m.map(Yp));
    return () => {
      for (const o of a)
        typeof o == "function" && o();
    };
  }), t.a.length && kr(() => {
    Dl(r, n), wo(t.a);
  });
}
function Dl(e, r) {
  if (e.l.s)
    for (const t of e.l.s) i(t);
  r();
}
function Yu(e, r) {
  var o;
  var t = (
    /** @type {Record<string, Function[] | Function>} */
    (o = e.$$events) == null ? void 0 : o[r.type]
  ), n = Yo(t) ? t.slice() : t == null ? [] : [t];
  for (var a of n)
    a.call(this, r);
}
function js(e, r, t) {
  if (e == null)
    return r(void 0), t && t(void 0), ze;
  const n = Ue(
    () => e.subscribe(
      r,
      // @ts-expect-error
      t
    )
  );
  return n.unsubscribe ? () => n.unsubscribe() : n;
}
const Bn = [];
function At(e, r) {
  return {
    subscribe: gr(e, r).subscribe
  };
}
function gr(e, r = ze) {
  let t = null;
  const n = /* @__PURE__ */ new Set();
  function a(l) {
    if (Es(e, l) && (e = l, t)) {
      const c = !Bn.length;
      for (const u of n)
        u[1](), Bn.push(u, e);
      if (c) {
        for (let u = 0; u < Bn.length; u += 2)
          Bn[u][0](Bn[u + 1]);
        Bn.length = 0;
      }
    }
  }
  function o(l) {
    a(l(
      /** @type {T} */
      e
    ));
  }
  function s(l, c = ze) {
    const u = [l, c];
    return n.add(u), n.size === 1 && (t = r(a, o) || ze), l(
      /** @type {T} */
      e
    ), () => {
      n.delete(u), n.size === 0 && t && (t(), t = null);
    };
  }
  return { set: a, update: o, subscribe: s };
}
function ct(e, r, t) {
  const n = !Array.isArray(e), a = n ? [e] : e;
  if (!a.every(Boolean))
    throw new Error("derived() expects stores as input, got a falsy value");
  const o = r.length < 2;
  return At(t, (s, l) => {
    let c = !1;
    const u = [];
    let d = 0, p = ze;
    const _ = () => {
      if (d)
        return;
      p();
      const h = r(n ? u[0] : u, s, l);
      o ? s(h) : p = typeof h == "function" ? h : ze;
    }, g = a.map(
      (h, w) => js(
        h,
        (v) => {
          u[w] = v, d &= ~(1 << w), c && _();
        },
        () => {
          d |= 1 << w;
        }
      )
    );
    return c = !0, _(), function() {
      wo(g), p(), c = !1;
    };
  });
}
function cg(e) {
  let r;
  return js(e, (t) => r = t)(), r;
}
let lo = !1, es = Symbol();
function fe(e, r, t) {
  const n = t[r] ?? (t[r] = {
    store: null,
    source: /* @__PURE__ */ Br(void 0),
    unsubscribe: ze
  });
  if (n.store !== e && !(es in t))
    if (n.unsubscribe(), n.store = e ?? null, e == null)
      n.source.v = void 0, n.unsubscribe = ze;
    else {
      var a = !0;
      n.unsubscribe = js(e, (o) => {
        a ? n.source.v = o : L(n.source, o);
      }), a = !1;
    }
  return e && es in t ? cg(e) : i(n.source);
}
function Al(e, r) {
  return e.set(r), r;
}
function Ae() {
  const e = {};
  function r() {
    fa(() => {
      for (var t in e)
        e[t].unsubscribe();
      Yc(e, es, {
        enumerable: !1,
        value: !0
      });
    });
  }
  return [e, r];
}
function ug(e) {
  var r = lo;
  try {
    return lo = !1, [e(), lo];
  } finally {
    lo = r;
  }
}
const dg = {
  get(e, r) {
    if (!e.exclude.includes(r))
      return e.props[r];
  },
  set(e, r) {
    return !1;
  },
  getOwnPropertyDescriptor(e, r) {
    if (!e.exclude.includes(r) && r in e.props)
      return {
        enumerable: !0,
        configurable: !0,
        value: e.props[r]
      };
  },
  has(e, r) {
    return e.exclude.includes(r) ? !1 : r in e.props;
  },
  ownKeys(e) {
    return Reflect.ownKeys(e.props).filter((r) => !e.exclude.includes(r));
  }
};
// @__NO_SIDE_EFFECTS__
function ur(e, r, t) {
  return new Proxy(
    { props: e, exclude: r },
    dg
  );
}
const pg = {
  get(e, r) {
    let t = e.props.length;
    for (; t--; ) {
      let n = e.props[t];
      if (Vn(n) && (n = n()), typeof n == "object" && n !== null && r in n) return n[r];
    }
  },
  set(e, r, t) {
    let n = e.props.length;
    for (; n--; ) {
      let a = e.props[n];
      Vn(a) && (a = a());
      const o = tn(a, r);
      if (o && o.set)
        return o.set(t), !0;
    }
    return !1;
  },
  getOwnPropertyDescriptor(e, r) {
    let t = e.props.length;
    for (; t--; ) {
      let n = e.props[t];
      if (Vn(n) && (n = n()), typeof n == "object" && n !== null && r in n) {
        const a = tn(n, r);
        return a && !a.configurable && (a.configurable = !0), a;
      }
    }
  },
  has(e, r) {
    if (r === Tt || r === Zc) return !1;
    for (let t of e.props)
      if (Vn(t) && (t = t()), t != null && r in t) return !0;
    return !1;
  },
  ownKeys(e) {
    const r = [];
    for (let t of e.props)
      if (Vn(t) && (t = t()), !!t) {
        for (const n in t)
          r.includes(n) || r.push(n);
        for (const n of Object.getOwnPropertySymbols(t))
          r.includes(n) || r.push(n);
      }
    return r;
  }
};
function Ye(...e) {
  return new Proxy({ props: e }, pg);
}
function K(e, r, t, n) {
  var k;
  var a = !ga || (t & qp) !== 0, o = (t & zp) !== 0, s = (t & Mp) !== 0, l = (
    /** @type {V} */
    n
  ), c = !0, u = () => (c && (c = !1, l = s ? Ue(
    /** @type {() => V} */
    n
  ) : (
    /** @type {V} */
    n
  )), l), d;
  if (o) {
    var p = Tt in e || Zc in e;
    d = ((k = tn(e, r)) == null ? void 0 : k.set) ?? (p && r in e ? (m) => e[r] = m : void 0);
  }
  var _, g = !1;
  o ? [_, g] = ug(() => (
    /** @type {V} */
    e[r]
  )) : _ = /** @type {V} */
  e[r], _ === void 0 && n !== void 0 && (_ = u(), d && (a && Qp(), d(_)));
  var h;
  if (a ? h = () => {
    var m = (
      /** @type {V} */
      e[r]
    );
    return m === void 0 ? u() : (c = !0, m);
  } : h = () => {
    var m = (
      /** @type {V} */
      e[r]
    );
    return m !== void 0 && (l = /** @type {V} */
    void 0), m === void 0 ? l : m;
  }, a && (t & Fp) === 0)
    return h;
  if (d) {
    var w = e.$$legacy;
    return (
      /** @type {() => V} */
      function(m, S) {
        return arguments.length > 0 ? ((!a || !S || w || g) && d(S ? h() : m), m) : h();
      }
    );
  }
  var v = !1, f = ((t & Ap) !== 0 ? Za : Vt)(() => (v = !1, h()));
  o && i(f);
  var y = (
    /** @type {Effect} */
    Me
  );
  return (
    /** @type {() => V} */
    function(m, S) {
      if (arguments.length > 0) {
        const x = S ? i(f) : a && o ? Xe(m) : m;
        return L(f, x), v = !0, l !== void 0 && (l = x), m;
      }
      return sn && v || (y.f & Rt) !== 0 ? f.v : i(f);
    }
  );
}
var We = /* @__PURE__ */ ((e) => (e[e.UnknownError = 0] = "UnknownError", e[e.UserCancelledError = 1] = "UserCancelledError", e[e.StoreProblemError = 2] = "StoreProblemError", e[e.PurchaseNotAllowedError = 3] = "PurchaseNotAllowedError", e[e.PurchaseInvalidError = 4] = "PurchaseInvalidError", e[e.ProductNotAvailableForPurchaseError = 5] = "ProductNotAvailableForPurchaseError", e[e.ProductAlreadyPurchasedError = 6] = "ProductAlreadyPurchasedError", e[e.ReceiptAlreadyInUseError = 7] = "ReceiptAlreadyInUseError", e[e.InvalidReceiptError = 8] = "InvalidReceiptError", e[e.MissingReceiptFileError = 9] = "MissingReceiptFileError", e[e.NetworkError = 10] = "NetworkError", e[e.InvalidCredentialsError = 11] = "InvalidCredentialsError", e[e.UnexpectedBackendResponseError = 12] = "UnexpectedBackendResponseError", e[e.InvalidAppUserIdError = 14] = "InvalidAppUserIdError", e[e.OperationAlreadyInProgressError = 15] = "OperationAlreadyInProgressError", e[e.UnknownBackendError = 16] = "UnknownBackendError", e[e.InvalidAppleSubscriptionKeyError = 17] = "InvalidAppleSubscriptionKeyError", e[e.IneligibleError = 18] = "IneligibleError", e[e.InsufficientPermissionsError = 19] = "InsufficientPermissionsError", e[e.PaymentPendingError = 20] = "PaymentPendingError", e[e.InvalidSubscriberAttributesError = 21] = "InvalidSubscriberAttributesError", e[e.LogOutWithAnonymousUserError = 22] = "LogOutWithAnonymousUserError", e[e.ConfigurationError = 23] = "ConfigurationError", e[e.UnsupportedError = 24] = "UnsupportedError", e[e.EmptySubscriberAttributesError = 25] = "EmptySubscriberAttributesError", e[e.CustomerInfoError = 28] = "CustomerInfoError", e[e.SignatureVerificationError = 36] = "SignatureVerificationError", e[e.InvalidEmailError = 38] = "InvalidEmailError", e[e.TestStoreSimulatedPurchaseError = 42] = "TestStoreSimulatedPurchaseError", e))(We || {});
class Jn {
  // This is the message shown to developers. It is not intended to be displayed to end customers.
  static getPublicMessage(r) {
    switch (r) {
      case 0:
        return "Unknown error.";
      case 1:
        return "Purchase was cancelled.";
      case 2:
        return "There was a problem with the store.";
      case 3:
        return "The device or user is not allowed to make the purchase.";
      case 4:
        return "One or more of the arguments provided are invalid.";
      case 5:
        return "The product is not available for purchase.";
      case 6:
        return "This product is already active for the user.";
      case 7:
        return "There is already another active subscriber using the same receipt.";
      case 8:
        return "The receipt is not valid.";
      case 9:
        return "The receipt is missing.";
      case 10:
        return "Error performing request. Please check your network connection and try again.";
      case 11:
        return "There was a credentials issue. Check the underlying error for more details.";
      case 12:
        return "Received unexpected response from the backend.";
      case 14:
        return "The app user id is not valid.";
      case 15:
        return "The operation is already in progress.";
      case 16:
        return "There was an unknown backend error.";
      case 17:
        return "Apple Subscription Key is invalid or not present. In order to provide subscription offers, you must first generate a subscription key. Please see https://docs.revenuecat.com/docs/ios-subscription-offers for more info.";
      case 18:
        return "The User is ineligible for that action.";
      case 19:
        return "App does not have sufficient permissions to make purchases.";
      case 20:
        return "The payment is pending.";
      case 21:
        return "One or more of the attributes sent could not be saved.";
      case 22:
        return "Called logOut but the current user is anonymous.";
      case 23:
        return "There is an issue with your configuration. Check the underlying error for more details.";
      case 24:
        return "There was a problem with the operation. Looks like we doesn't support that yet. Check the underlying error for more details.";
      case 25:
        return "A request for subscriber attributes returned none.";
      case 28:
        return "There was a problem related to the customer info.";
      case 36:
        return "Request failed signature verification. Please see https://rev.cat/trusted-entitlements for more info.";
      case 38:
        return "Email is not valid. Please provide a valid email address.";
      case 42:
        return "Purchase failure simulated successfully in Test Store.";
    }
  }
  static getErrorCodeForBackendErrorCode(r) {
    switch (r) {
      case 7101:
      case 7773:
      case 7898:
      case 7899:
      case 7900:
      case 7901:
        return 2;
      case 7102:
        return 7;
      case 7103:
        return 8;
      case 7107:
      case 7224:
      case 7225:
      case 7967:
        return 11;
      case 7105:
      case 7106:
      case 7814:
      case 7877:
      case 7878:
        return 4;
      case 7772:
        return 6;
      case 7220:
        return 14;
      case 7259:
        return 28;
      case 7229:
        return 2;
      case 7230:
      case 7e3:
        return 23;
      case 7231:
        return 2;
      case 7232:
        return 18;
      case 7263:
      case 7264:
        return 21;
      case 7104:
      case 7234:
      case 7226:
      case 7110:
        return 12;
      case 7662:
        return 24;
      case 7012:
      case 7834:
      case 7879:
        return 38;
    }
  }
  static convertCodeToBackendErrorCode(r) {
    return r in Kn ? r : null;
  }
  static convertPurchaseFlowErrorCodeToErrorCode(r) {
    switch (r) {
      case Q.ErrorSettingUpPurchase:
        return 2;
      case Q.ErrorChargingPayment:
        return 20;
      case Q.NetworkError:
        return 10;
      case Q.MissingEmailError:
        return 4;
      case Q.AlreadyPurchasedError:
        return 6;
      case Q.InvalidPaddleAPIKeyError:
        return 11;
      default:
        return 0;
    }
  }
}
var Kn = /* @__PURE__ */ ((e) => (e[e.BackendInvalidPlatform = 7e3] = "BackendInvalidPlatform", e[e.BackendInvalidEmail = 7012] = "BackendInvalidEmail", e[e.BackendStoreProblem = 7101] = "BackendStoreProblem", e[e.BackendCannotTransferPurchase = 7102] = "BackendCannotTransferPurchase", e[e.BackendInvalidReceiptToken = 7103] = "BackendInvalidReceiptToken", e[e.BackendInvalidAppStoreSharedSecret = 7104] = "BackendInvalidAppStoreSharedSecret", e[e.BackendInvalidPaymentModeOrIntroPriceNotProvided = 7105] = "BackendInvalidPaymentModeOrIntroPriceNotProvided", e[e.BackendProductIdForGoogleReceiptNotProvided = 7106] = "BackendProductIdForGoogleReceiptNotProvided", e[e.BackendInvalidPlayStoreCredentials = 7107] = "BackendInvalidPlayStoreCredentials", e[e.BackendInternalServerError = 7110] = "BackendInternalServerError", e[e.BackendEmptyAppUserId = 7220] = "BackendEmptyAppUserId", e[e.BackendInvalidAuthToken = 7224] = "BackendInvalidAuthToken", e[e.BackendInvalidAPIKey = 7225] = "BackendInvalidAPIKey", e[e.BackendBadRequest = 7226] = "BackendBadRequest", e[e.BackendPlayStoreQuotaExceeded = 7229] = "BackendPlayStoreQuotaExceeded", e[e.BackendPlayStoreInvalidPackageName = 7230] = "BackendPlayStoreInvalidPackageName", e[e.BackendPlayStoreGenericError = 7231] = "BackendPlayStoreGenericError", e[e.BackendUserIneligibleForPromoOffer = 7232] = "BackendUserIneligibleForPromoOffer", e[e.BackendInvalidAppleSubscriptionKey = 7234] = "BackendInvalidAppleSubscriptionKey", e[e.BackendSubscriberNotFound = 7259] = "BackendSubscriberNotFound", e[e.BackendInvalidSubscriberAttributes = 7263] = "BackendInvalidSubscriberAttributes", e[e.BackendInvalidSubscriberAttributesBody = 7264] = "BackendInvalidSubscriberAttributesBody", e[e.BackendProductIDsMalformed = 7662] = "BackendProductIDsMalformed", e[e.BackendAlreadySubscribedError = 7772] = "BackendAlreadySubscribedError", e[e.BackendPaymentGatewayGenericError = 7773] = "BackendPaymentGatewayGenericError", e[e.BackendOfferNotFound = 7814] = "BackendOfferNotFound", e[e.BackendNoMXRecordsFound = 7834] = "BackendNoMXRecordsFound", e[e.BackendInvalidOperationSession = 7877] = "BackendInvalidOperationSession", e[e.BackendPurchaseCannotBeCompleted = 7878] = "BackendPurchaseCannotBeCompleted", e[e.BackendEmailIsRequired = 7879] = "BackendEmailIsRequired", e[e.BackendGatewaySetupErrorStripeTaxNotActive = 7898] = "BackendGatewaySetupErrorStripeTaxNotActive", e[e.BackendGatewaySetupErrorInvalidTaxOriginAddress = 7899] = "BackendGatewaySetupErrorInvalidTaxOriginAddress", e[e.BackendGatewaySetupErrorMissingRequiredPermission = 7900] = "BackendGatewaySetupErrorMissingRequiredPermission", e[e.BackendGatewaySetupErrorSandboxModeOnly = 7901] = "BackendGatewaySetupErrorSandboxModeOnly", e[e.BackendInvalidPaddleAPIKey = 7967] = "BackendInvalidPaddleAPIKey", e))(Kn || {});
class je extends Error {
  constructor(t, n, a, o) {
    super(n);
    V(this, "toString", () => `PurchasesError(code: ${We[this.errorCode]}, message: ${this.message})`);
    this.errorCode = t, this.underlyingErrorMessage = a, this.extra = o;
  }
  /** @internal */
  static getForBackendError(t, n) {
    const a = Jn.getErrorCodeForBackendErrorCode(t);
    return new je(
      a,
      Jn.getPublicMessage(a),
      n,
      { backendErrorCode: t }
    );
  }
  /** @internal */
  static getForPurchasesFlowError(t) {
    return new je(
      Jn.convertPurchaseFlowErrorCodeToErrorCode(
        t.errorCode
      ),
      t.message,
      t.underlyingErrorMessage
    );
  }
}
class _g extends Error {
  constructor() {
    super("Purchases must be configured before calling getInstance");
  }
}
var Ut = /* @__PURE__ */ ((e) => (e.Started = "started", e.InProgress = "in_progress", e.Succeeded = "succeeded", e.Failed = "failed", e))(Ut || {}), Hn = /* @__PURE__ */ ((e) => (e[e.SetupIntentCreationFailed = 1] = "SetupIntentCreationFailed", e[e.PaymentMethodCreationFailed = 2] = "PaymentMethodCreationFailed", e[e.PaymentChargeFailed = 3] = "PaymentChargeFailed", e[e.SetupIntentCompletionFailed = 4] = "SetupIntentCompletionFailed", e[e.AlreadyPurchased = 5] = "AlreadyPurchased", e))(Hn || {}), jr = /* @__PURE__ */ ((e) => (e[e.Silent = 0] = "Silent", e[e.Error = 1] = "Error", e[e.Warn = 2] = "Warn", e[e.Info = 3] = "Info", e[e.Debug = 4] = "Debug", e[e.Verbose = 5] = "Verbose", e))(jr || {});
class ne {
  static setLogLevel(r) {
    this.logLevel = r;
  }
  static setLogHandler(r) {
    this.logHandler = r;
  }
  static log(r, t = this.logLevel) {
    const n = `[Purchases] ${r}`;
    if (!(this.logLevel < t || t === jr.Silent)) {
      if (this.logHandler !== null) {
        this.logHandler(t, n);
        return;
      }
      switch (t) {
        case jr.Error:
          console.error(n);
          break;
        case jr.Warn:
          console.warn(n);
          break;
        case jr.Info:
          console.info(n);
          break;
        case jr.Debug:
          console.debug(n);
          break;
        case jr.Verbose:
          console.debug(n);
          break;
      }
    }
  }
  static errorLog(r) {
    this.log(r, jr.Error);
  }
  static warnLog(r) {
    this.log(r, jr.Warn);
  }
  static infoLog(r) {
    this.log(r, jr.Info);
  }
  static debugLog(r) {
    this.log(r, jr.Debug);
  }
  static verboseLog(r) {
    this.log(r, jr.Verbose);
  }
}
V(ne, "logLevel", jr.Silent), V(ne, "logHandler", null);
function Gu(e) {
  var r;
  return e.operation.redemption_info ? {
    redeemUrl: ((r = e.operation.redemption_info) == null ? void 0 : r.redeem_url) ?? null
  } : null;
}
function Ku(e, r) {
  if (e == null) {
    r(
      new ae(
        Q.UnknownError,
        "Got an error status but error field is empty."
      )
    );
    return;
  }
  switch (e.code) {
    case Hn.SetupIntentCreationFailed:
      r(
        new ae(
          Q.ErrorSettingUpPurchase,
          "Setup intent creation failed"
        )
      );
      return;
    case Hn.PaymentMethodCreationFailed:
      r(
        new ae(
          Q.ErrorSettingUpPurchase,
          "Payment method creation failed"
        )
      );
      return;
    case Hn.PaymentChargeFailed:
      r(
        new ae(
          Q.ErrorChargingPayment,
          "Payment charge failed"
        )
      );
      return;
    case Hn.SetupIntentCompletionFailed:
      r(
        new ae(
          Q.ErrorSettingUpPurchase,
          "Setup intent completion failed"
        )
      );
      return;
    case Hn.AlreadyPurchased:
      r(
        new ae(
          Q.AlreadyPurchasedError,
          "Purchased was already completed"
        )
      );
      return;
    default:
      r(
        new ae(
          Q.UnknownError,
          "Unknown error code received"
        )
      );
      return;
  }
}
var Q = /* @__PURE__ */ ((e) => (e[e.ErrorSettingUpPurchase = 0] = "ErrorSettingUpPurchase", e[e.ErrorChargingPayment = 1] = "ErrorChargingPayment", e[e.UnknownError = 2] = "UnknownError", e[e.NetworkError = 3] = "NetworkError", e[e.MissingEmailError = 4] = "MissingEmailError", e[e.AlreadyPurchasedError = 5] = "AlreadyPurchasedError", e[e.StripeTaxNotActive = 6] = "StripeTaxNotActive", e[e.StripeInvalidTaxOriginAddress = 7] = "StripeInvalidTaxOriginAddress", e[e.StripeMissingRequiredPermission = 8] = "StripeMissingRequiredPermission", e[e.InvalidPaddleAPIKeyError = 9] = "InvalidPaddleAPIKeyError", e))(Q || {});
class ae extends Error {
  constructor(r, t, n, a, o, s) {
    super(t), this.errorCode = r, this.underlyingErrorMessage = n, this.purchasesErrorCode = a, this.extra = o, this.displayPurchaseFlowErrorCode = s;
  }
  getErrorCode() {
    var t;
    const r = ((t = this.extra) == null ? void 0 : t.backendErrorCode) ?? this.purchasesErrorCode;
    return this.displayPurchaseFlowErrorCode ? this.errorCode ?? r : r ?? this.errorCode;
  }
  static fromPurchasesError(r, t, n = !1) {
    var o;
    let a;
    return r.errorCode === We.ProductAlreadyPurchasedError ? a = 5 : r.errorCode === We.InvalidEmailError ? a = 4 : r.errorCode === We.NetworkError ? a = 3 : a = ae.fromBackendErrorCode((o = r.extra) == null ? void 0 : o.backendErrorCode) ?? t, new ae(
      a,
      r.message,
      r.underlyingErrorMessage,
      r.errorCode,
      r.extra,
      n
    );
  }
  static fromBackendErrorCode(r) {
    switch (r) {
      case Kn.BackendGatewaySetupErrorStripeTaxNotActive:
        return 6;
      case Kn.BackendGatewaySetupErrorInvalidTaxOriginAddress:
        return 7;
      case Kn.BackendGatewaySetupErrorMissingRequiredPermission:
        return 8;
      case Kn.BackendInvalidPaddleAPIKey:
        return 9;
      default:
        return null;
    }
  }
}
class gg {
  constructor(r, t, n = 10) {
    V(this, "operationSessionId", null);
    V(this, "backend");
    V(this, "eventsTracker");
    V(this, "maxNumberAttempts");
    V(this, "waitMSBetweenAttempts", 1e3);
    this.backend = r, this.eventsTracker = t, this.maxNumberAttempts = n;
  }
  async prepareCheckout(r, t) {
    try {
      return await this.backend.postCheckoutPrepare(
        r,
        t
      );
    } catch (n) {
      if (n instanceof je)
        throw ae.fromPurchasesError(
          n,
          0
          /* ErrorSettingUpPurchase */
        );
      {
        const a = "Unknown error preparing purchase: " + String(n);
        throw ne.errorLog(a), new ae(
          2,
          a
        );
      }
    }
  }
  async checkoutStart(r, t, n, a, o, s, l, c) {
    try {
      const u = this.eventsTracker.getTraceId(), d = l == null ? void 0 : l.stepId, p = await this.backend.postCheckoutStart(
        r,
        t,
        a,
        n,
        u,
        o,
        s,
        d,
        c
      );
      return this.operationSessionId = p.operation_session_id, p;
    } catch (u) {
      if (u instanceof je)
        throw ae.fromPurchasesError(
          u,
          0
          /* ErrorSettingUpPurchase */
        );
      {
        const d = "Unknown error starting purchase: " + String(u);
        throw ne.errorLog(d), new ae(
          2,
          d
        );
      }
    }
  }
  async checkoutCalculateTax(r, t, n) {
    const a = this.operationSessionId;
    if (!a)
      throw new ae(
        0,
        "No purchase started"
      );
    try {
      return await this.backend.postCheckoutCalculateTax(
        a,
        r,
        t,
        n
      );
    } catch (o) {
      if (o instanceof je)
        throw ae.fromPurchasesError(
          o,
          0
          /* ErrorSettingUpPurchase */
        );
      {
        const s = "Unknown error calculating tax: " + String(o);
        throw ne.errorLog(s), new ae(
          2,
          s
        );
      }
    }
  }
  async checkoutComplete(r) {
    const t = this.operationSessionId;
    if (!t)
      throw new ae(
        0,
        "No purchase started"
      );
    try {
      return await this.backend.postCheckoutComplete(t, r);
    } catch (n) {
      if (n instanceof je)
        throw ae.fromPurchasesError(
          n,
          0
          /* ErrorSettingUpPurchase */
        );
      {
        const a = "Unknown error starting purchase: " + String(n);
        throw ne.errorLog(a), new ae(
          2,
          a
        );
      }
    }
  }
  async pollCurrentPurchaseForCompletion() {
    const r = this.operationSessionId;
    if (!r)
      throw new ae(
        0,
        "No purchase in progress"
      );
    return new Promise((t, n) => {
      const a = (o = 1) => {
        if (o > this.maxNumberAttempts) {
          this.clearPurchaseInProgress(), n(
            new ae(
              2,
              "Max attempts reached trying to get successful purchase status"
            )
          );
          return;
        }
        this.backend.getCheckoutStatus(r).then((s) => {
          const l = s.operation.store_transaction_identifier, c = s.operation.product_identifier, u = s.operation.purchase_date ? isNaN(Date.parse(s.operation.purchase_date)) ? null : new Date(s.operation.purchase_date) : null;
          switch (s.operation.status) {
            case Ut.Started:
            case Ut.InProgress:
              setTimeout(
                () => a(o + 1),
                this.waitMSBetweenAttempts
              );
              break;
            case Ut.Succeeded:
              if (this.clearPurchaseInProgress(), !l || !c || !u) {
                n(
                  new ae(
                    2,
                    "Missing required fields in operation response."
                  )
                );
                return;
              }
              t({
                redemptionInfo: Gu(s),
                operationSessionId: r,
                storeTransactionIdentifier: l,
                productIdentifier: c,
                purchaseDate: u
              });
              return;
            case Ut.Failed:
              this.clearPurchaseInProgress(), Ku(
                s.operation.error,
                n
              );
          }
        }).catch((s) => {
          const l = ae.fromPurchasesError(
            s,
            3
            /* NetworkError */
          );
          n(l);
        });
      };
      a();
    });
  }
  clearPurchaseInProgress() {
    this.operationSessionId = null;
  }
}
const dr = "rcb-ui-translator", Er = "en", fg = {
  "periods.week": "{{amount}} week",
  "periods.month": "{{amount}} month",
  "periods.year": "{{amount}} year",
  "periods.day": "{{amount}} day",
  "periods.weekShort": "{{amount}}wk",
  "periods.monthShort": "{{amount}}mo",
  "periods.yearShort": "{{amount}}yr",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "lifetime",
  "periods.weekPlural": "{{amount}} weeks",
  "periods.monthPlural": "{{amount}} months",
  "periods.yearPlural": "{{amount}} years",
  "periods.dayPlural": "{{amount}} days",
  "periods.weekFrequency": "weekly",
  "periods.monthFrequency": "monthly",
  "periods.yearFrequency": "yearly",
  "periods.dayFrequency": "daily",
  "periods.perWeekFrequency": "per week",
  "periods.perMonthFrequency": "per month",
  "periods.perYearFrequency": "per year",
  "periods.perDayFrequency": "per day",
  "periods.unknownFrequency": "unknown",
  "periods.weekFrequencyPlural": "every {{amount}} weeks",
  "periods.monthFrequencyPlural": "every {{amount}} months",
  "periods.yearFrequencyPlural": "every {{amount}} years",
  "periods.dayFrequencyPlural": "every {{amount}} days",
  "product_info.subscribe_to": "Subscribe to",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "Try free for {{trialDuration}}",
  "product_info.price_after_free_trial": "After trial ends, on {{renewalDate}}",
  "product_info.intro_price_phase_after_trial": "Then {{introPriceDuration}} for {{introPrice}}",
  "product_info.intro_price_phase": "First {{introPriceDuration}} for {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "paid once",
  "product_info.price_after_intro_price": "After {{introPriceDuration}}, on {{renewalDate}}",
  "product_info.after_trial": "after trial",
  "product_info.after": "after",
  "product_info.total_due_today": "Total due today",
  "product_info.renewal_frequency": "Renews {{frequency}}",
  "product_info.continues_until_cancelled": "Continues until cancelled",
  "product_info.cancel_anytime": "Cancel anytime",
  "payment_entry_page.payment_step_title": "Secure checkout by RevenueCat",
  "payment_entry_page.trial_subscription_terms_info": "After your trial ends, you will be charged {{price}} {{perFrequency}} starting {{renewalDate}}. You can cancel any time before this date.",
  "payment_entry_page.subscription_terms_info": "By subscribing, you agree to allow {{appName}} to charge you according to their terms until you cancel.",
  "payment_entry_page.otp_terms_info": "By purchasing, you agree to allow {{appName}} to charge you according to their terms.",
  "payment_entry_page.terms_link_label": "Terms",
  "payment_entry_page.subscription_info": "Subscription renews automatically. Cancel anytime.",
  "payment_entry_page.button_pay": "Pay now",
  "payment_entry_page.button_start_trial": "Start trial",
  "payment_entry_page.button_with_price": "Pay {{formattedPrice}}",
  "payment_entry_page.button_payment_method": "Pay {{formattedPrice}} with {{paymentMethod}}",
  "payment_entry_page.express_checkout_divider": "OR PAY BY CARD",
  "loading_page.processing_payment": "Processing payment",
  "loading_page.keep_page_open": "The process is almost done. Keep this page open.",
  "success_page.purchase_successful": "Payment complete",
  "success_page.button_close": "Continue",
  "error_page.close_button_title": "Go to {{appName}}",
  "error_page.if_error_persists": "If it persists, please contact ",
  "error_page.trouble_accessing": "If you're having trouble accessing your purchase, reach out to support on ",
  "error_page.error_title_already_subscribed": "You already subscribed to {{productTitle}}",
  "error_page.error_title_already_purchased": "You already purchased {{productTitle}}",
  "error_page.error_title_other_errors": "Something went wrong",
  "error_page.error_message_already_subscribed": "You can't subscribe to this product again.",
  "error_page.error_message_already_purchased": "You can't purchase this product again.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax not active",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Invalid tax origin address",
  "error_page.error_title_stripe_missing_required_permission": "Missing Stripe permission",
  "error_page.error_message_missing_email_error": "Email is required to complete the purchase.",
  "error_page.error_message_invalid_email_error": "The email address {{email}} couldn't be verified. Please provide a valid email address.",
  "error_page.error_message_network_error": "Network error. Please check your internet connection.",
  "error_page.error_message_error_charging_payment": "Payment failed.",
  "error_page.error_message_error_setting_up_purchase": "Purchase not started due to an error (error code: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "We couldn't verify your billing address. Please double-check that the postal code and country are correct.",
  "error_page.error_message_unknown_error": "An unknown error occurred (error code: {{errorCode}}).",
  "error_page.error_message_stripe_tax_not_active": "The purchase failed because Stripe Tax isn’t enabled. In production, purchases will work without taxes applied.",
  "error_page.error_message_stripe_invalid_tax_origin_address": "The purchase failed because the tax origin address is invalid. In production, purchases will work without taxes applied.",
  "error_page.error_message_stripe_missing_required_permission": "The purchase failed because the Stripe app lacks a required permission. In production, purchases will work without taxes applied.",
  "error_page.error_only_in_sandbox": "This message appears only in sandbox.",
  "error_page.button_try_again": "Try again",
  "error_page.button_close": "Close",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "pricing_dropdown.show_details": "Show details",
  "pricing_dropdown.hide_details": "Hide details",
  "pricing_table.trial_ends": "After trial ends, on {{formattedTrialEndDate}}",
  "pricing_table.total_excluding_tax": "Total excluding tax",
  "pricing_table.total_due_today": "Total due today",
  "pricing_table.subtotal": "Subtotal",
  "pricing_table.discount": "Discount",
  "pricing_table.tax": "Tax",
  "pricing_table.enter_billing_address_to_calculate": "Enter billing address to calculate",
  "pricing_table.enter_postal_code_to_calculate": "Enter zip code to calculate",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Enter state or postal code to calculate",
  "navbar_header.details": "Details",
  "navbar_header.back_button": "Back",
  "price_update.title": "Price update",
  "price_update.base_message": "The total price was updated with tax based on your billing address. Please review and try again. Your card will only be charged once.",
  "price_update.trial_message": "The subscription price was updated to include tax based on your billing address. Free trial still applies. Review and try again.",
  "apple_pay.free_trial": "Free Trial"
}, mg = {
  "periods.week": "{{amount}} semana",
  "periods.month": "{{amount}} mes",
  "periods.year": "{{amount}} año",
  "periods.day": "{{amount}} día",
  "periods.weekShort": "{{amount}} sem",
  "periods.monthShort": "{{amount}}mes",
  "periods.yearShort": "{{amount}}año",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "de por vida",
  "periods.weekPlural": "{{amount}} semanas",
  "periods.monthPlural": "{{amount}} meses",
  "periods.yearPlural": "{{amount}} años",
  "periods.dayPlural": "{{amount}} días",
  "periods.weekFrequency": "semanal",
  "periods.monthFrequency": "mensual",
  "periods.yearFrequency": "anual",
  "periods.dayFrequency": "diaria",
  "periods.perWeekFrequency": "por semana",
  "periods.perMonthFrequency": "por mes",
  "periods.perYearFrequency": "por año",
  "periods.perDayFrequency": "por día",
  "periods.unknownFrequency": "desconocida",
  "periods.weekFrequencyPlural": "cada {{amount}} semanas",
  "periods.monthFrequencyPlural": "cada {{amount}} meses",
  "periods.yearFrequencyPlural": "cada {{amount}} años",
  "periods.dayFrequencyPlural": "cada {{amount}} días",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} prueba gratuita",
  "product_info.price_after_free_trial": "Después de que termine el periodo de prueba, el {{renewalDate}}",
  "product_info.renewal_frequency": "Se renueva {{frequency}}",
  "product_info.continues_until_cancelled": "Continua hasta que se cancele",
  "product_info.cancel_anytime": "Cancelar en cualquier momento",
  "payment_entry_page.payment_step_title": "Pago seguro mediante RevenueCat",
  "payment_entry_page.button_pay": "Pagar ahora",
  "payment_entry_page.button_start_trial": "Comenzar prueba",
  "success_page.purchase_successful": "Pago completado",
  "success_page.button_close": "Continuar",
  "error_page.if_error_persists": "Si el error persiste, contacta con ",
  "error_page.error_title_already_subscribed": "Ya te has suscrito a {{productTitle}}",
  "error_page.error_title_already_purchased": "Ya has comprado {{productTitle}}",
  "error_page.error_title_other_errors": "Algo salió mal",
  "error_page.error_message_already_subscribed": "No puedes suscribirte a este producto de nuevo.",
  "error_page.error_message_already_purchased": "No puedes comprar este producto de nuevo.",
  "error_page.error_message_missing_email_error": "Se requiere un correo electrónico para completar la compra.",
  "error_page.error_message_network_error": "Error de red. Por favor, comprueba tu conexión a internet.",
  "error_page.error_message_error_charging_payment": "Pago fallido.",
  "error_page.error_message_error_setting_up_purchase": "No se pudo iniciar la compra debido a un error (código de error: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "No pudimos verificar tu dirección de facturación. Por favor, verifica que el código postal y el país sean correctos.",
  "error_page.error_message_unknown_error": "Ocurrió un error desconocido (código de error: {{errorCode}}).",
  "error_page.button_try_again": "Intentar de nuevo",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Total a pagar hoy",
  "product_info.subscribe_to": "Suscribirse a",
  "navbar_header.details": "Detalles",
  "navbar_header.back_button": "Atrás",
  "pricing_dropdown.show_details": "Mostrar detalles",
  "pricing_dropdown.hide_details": "Ocultar detalles",
  "pricing_table.tax": "Impuestos",
  "pricing_table.trial_ends": "Después de que finalice la prueba, el {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total a pagar hoy",
  "pricing_table.total_excluding_tax": "Total sin impuestos",
  "pricing_table.enter_billing_address_to_calculate": "Introduce la dirección de facturación para calcular",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Introduce el estado o el código postal para calcular",
  "pricing_table.enter_postal_code_to_calculate": "Introduce el código postal para calcular",
  "error_page.error_message_invalid_email_error": "La dirección de correo electrónico {{email}} no se pudo verificar. Por favor, proporciona una dirección de correo electrónico válida.",
  "payment_entry_page.button_payment_method": "Pagar {{formattedPrice}} con {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Pagar {{formattedPrice}}",
  "price_update.title": "Actualización de precio",
  "price_update.base_message": "El precio total se actualizó con impuestos según su dirección de facturación. Revise e intente nuevamente. Solo se efectuará un cobro en su tarjeta.",
  "price_update.trial_message": "El precio de la suscripción se actualizó para incluir impuestos según su dirección de facturación. La prueba gratuita sigue aplicándose. Revise e intente nuevamente.",
  "payment_entry_page.express_checkout_divider": "O PAGA CON TARJETA",
  "error_page.trouble_accessing": "Si tiene problemas para acceder a su compra, póngase en contacto con el servicio de asistencia en ",
  "error_page.close_button_title": "Ir a {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Falta permiso de Stripe",
  "error_page.button_close": "Cerrar",
  "error_page.error_message_stripe_invalid_tax_origin_address": "La compra falló porque la dirección de origen fiscal no es válida. En producción, las compras funcionarán sin impuestos aplicados.",
  "error_page.error_message_stripe_tax_not_active": "La compra falló porque Stripe Tax no está habilitado. En producción, las compras funcionarán sin impuestos aplicados.",
  "error_page.error_only_in_sandbox": "Este mensaje aparece solo en el entorno de pruebas.",
  "error_page.error_message_stripe_missing_required_permission": "La compra falló porque la aplicación Stripe carece de un permiso necesario. En producción, las compras funcionarán sin impuestos aplicados.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax no está activo",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Dirección de origen fiscal no válida",
  "apple_pay.free_trial": "Prueba gratuita",
  "product_info.price_after_intro_price": "Después de {{introPriceDuration}}, el {{renewalDate}}",
  "product_info.after_trial": "después del período de prueba",
  "product_info.after": "después de",
  "product_info.intro_price_phase_after_trial": "Luego, {{introPriceDuration}} por {{introPrice}}",
  "product_info.intro_price_phase": "Primero, {{introPriceDuration}} por {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "pago único",
  "payment_entry_page.trial_subscription_terms_info": "Una vez finalizado el período de prueba, se te cobrarán {{price}} {{perFrequency}} a partir del {{renewalDate}}. Puedes cancelar en cualquier momento antes de esta fecha.",
  "payment_entry_page.subscription_info": "La suscripción se renueva automáticamente. Cancela en cualquier momento.",
  "payment_entry_page.otp_terms_info": "Al comprar, aceptas que {{appName}} te cobre de acuerdo con sus términos.",
  "payment_entry_page.terms_link_label": "Términos",
  "payment_entry_page.subscription_terms_info": "Al suscribirte, aceptas que {{appName}} te cobre de acuerdo con sus términos hasta que canceles.",
  "loading_page.keep_page_open": "El proceso está casi terminado. Mantén esta página abierta.",
  "loading_page.processing_payment": "Procesando el pago",
  "pricing_table.discount": "Descuento",
  "pricing_table.subtotal": "Subtotal"
}, hg = {
  "periods.week": "{{amount}} settimana",
  "periods.month": "{{amount}} mese",
  "periods.year": "{{amount}} anno",
  "periods.day": "{{amount}} giorno",
  "periods.weekShort": "{{amount}}sett",
  "periods.monthShort": "{{amount}}mese",
  "periods.yearShort": "{{amount}}anno",
  "periods.dayShort": "{{amount}}g",
  "periods.lifetime": "a vita",
  "periods.weekPlural": "{{amount}} settimane",
  "periods.monthPlural": "{{amount}} mesi",
  "periods.yearPlural": "{{amount}} anni",
  "periods.dayPlural": "{{amount}} giorni",
  "periods.weekFrequency": "settimanale",
  "periods.monthFrequency": "mensile",
  "periods.yearFrequency": "annuale",
  "periods.dayFrequency": "giornaliero",
  "periods.perWeekFrequency": "a settimana",
  "periods.perMonthFrequency": "al mese",
  "periods.perYearFrequency": "all'anno",
  "periods.perDayFrequency": "al giorno",
  "periods.unknownFrequency": "sconosciuto",
  "periods.weekFrequencyPlural": "ogni {{amount}} settimane",
  "periods.monthFrequencyPlural": "ogni {{amount}} mesi",
  "periods.yearFrequencyPlural": "ogni {{amount}} anni",
  "periods.dayFrequencyPlural": "ogni {{amount}} giorni",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} prova gratuita",
  "product_info.price_after_free_trial": "Dopo la fine della prova, il {{renewalDate}}",
  "product_info.renewal_frequency": "Si rinnova {{frequency}}",
  "product_info.continues_until_cancelled": "Continua fino a disdetta",
  "product_info.cancel_anytime": "Disdici in qualsiasi momento",
  "payment_entry_page.payment_step_title": "Pagamento sicuro tramite RevenueCat",
  "payment_entry_page.button_pay": "Paga ora",
  "payment_entry_page.button_start_trial": "Inizia la prova",
  "success_page.purchase_successful": "Pagamento completato",
  "success_page.button_close": "Continua",
  "error_page.if_error_persists": "Se l'errore persiste, contatta ",
  "error_page.error_title_already_subscribed": "Hai già un abbonamento a {{productTitle}}",
  "error_page.error_title_already_purchased": "Hai già acquistato {{productTitle}}",
  "error_page.error_title_other_errors": "Qualcosa è andato storto",
  "error_page.error_message_already_subscribed": "Non puoi abbonarti di nuovo a questo prodotto.",
  "error_page.error_message_already_purchased": "Non puoi acquistare di nuovo questo prodotto.",
  "error_page.error_message_missing_email_error": "L'email è necessaria per completare l'acquisto.",
  "error_page.error_message_network_error": "Errore di rete. Verifica la connessione internet.",
  "error_page.error_message_error_charging_payment": "Pagamento fallito.",
  "error_page.error_message_error_setting_up_purchase": "Acquisto non avviato a causa di un errore (codice errore: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Non siamo riusciti a verificare il tuo indirizzo di fatturazione. Per favore, controlla che il codice postale e il paese siano corretti.",
  "error_page.error_message_unknown_error": "Si è verificato un errore sconosciuto (codice errore: {{errorCode}}).",
  "error_page.button_try_again": "Riprova",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Totale dovuto oggi",
  "product_info.subscribe_to": "Abbonati a",
  "navbar_header.details": "Dettagli",
  "navbar_header.back_button": "Indietro",
  "pricing_dropdown.show_details": "Mostra dettagli",
  "pricing_dropdown.hide_details": "Nascondi dettagli",
  "pricing_table.tax": "Tasse",
  "pricing_table.trial_ends": "Al termine del periodo di prova, il {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Totale dovuto oggi",
  "pricing_table.total_excluding_tax": "Totale tasse escluse",
  "pricing_table.enter_billing_address_to_calculate": "Inserisci l'indirizzo di fatturazione per calcolare",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Inserisci la regione o il codice postale per calcolare",
  "pricing_table.enter_postal_code_to_calculate": "Inserisci il codice postale per calcolare",
  "error_page.error_message_invalid_email_error": "L'indirizzo email {{email}} non può essere verificato. Si prega di fornire un indirizzo email valido.",
  "payment_entry_page.button_payment_method": "Paga {{formattedPrice}} con {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Paga {{formattedPrice}}",
  "price_update.title": "Aggiornamento prezzo",
  "price_update.base_message": "Il prezzo totale è stato aggiornato con le tasse in base al tuo indirizzo di fatturazione. Rivedi e riprova. L'addebito sulla tua carta avverrà solo una volta.",
  "price_update.trial_message": "Il prezzo dell'abbonamento è stato aggiornato per includere le tasse in base al tuo indirizzo di fatturazione. La prova gratuita è ancora valida. Controlla e riprova.",
  "payment_entry_page.express_checkout_divider": "OPPURE PAGA CON CARTA",
  "error_page.trouble_accessing": "Se hai problemi ad accedere al tuo acquisto, contatta l'assistenza all'indirizzo ",
  "error_page.close_button_title": "Vai a {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Autorizzazione Stripe mancante",
  "error_page.button_close": "Chiudi",
  "error_page.error_message_stripe_invalid_tax_origin_address": "L'acquisto non è andato a buon fine perché l'indirizzo di origine fiscale non è valido. In produzione, gli acquisti verranno effettuati senza l'applicazione delle imposte e questo errore non sarà visibile.",
  "error_page.error_message_stripe_tax_not_active": "L'acquisto non è andato a buon fine perché Stripe Tax non è abilitato. In produzione, gli acquisti verranno effettuati senza l'applicazione delle imposte e questo errore non sarà visibile.",
  "error_page.error_only_in_sandbox": "Questo messaggio viene visualizzato solo in sandbox.",
  "error_page.error_message_stripe_missing_required_permission": "L'acquisto non è andato a buon fine perché l'app Stripe non dispone dell'autorizzazione necessaria. In produzione, gli acquisti verranno effettuati senza l'applicazione delle imposte e questo errore non sarà visibile.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax non attivo",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Indirizzo di origine fiscale non valido",
  "apple_pay.free_trial": "Prova gratuita",
  "product_info.price_after_intro_price": "Dopo {{introPriceDuration}}, il {{renewalDate}}",
  "product_info.after_trial": "dopo il periodo di prova",
  "product_info.after": "dopo",
  "product_info.intro_price_phase_after_trial": "Poi {{introPriceDuration}} a {{introPrice}}",
  "product_info.intro_price_phase": "Prima {{introPriceDuration}} a {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "pagato una volta",
  "payment_entry_page.trial_subscription_terms_info": "Al termine del periodo di prova, ti verranno addebitati {{price}} {{perFrequency}} a partire dal {{renewalDate}}. Puoi annullare in qualsiasi momento prima di questa data.",
  "payment_entry_page.subscription_info": "L'abbonamento si rinnova automaticamente. Annulla in qualsiasi momento.",
  "payment_entry_page.otp_terms_info": "Acquistando, accetti che {{appName}} ti addebiti l'importo in base ai suoi termini.",
  "payment_entry_page.terms_link_label": "Termini",
  "payment_entry_page.subscription_terms_info": "Abbonandoti, accetti che {{appName}} ti addebiti l'importo secondo i suoi termini fino all'annullamento.",
  "loading_page.keep_page_open": "Il processo è quasi terminato. Mantieni questa pagina aperta.",
  "loading_page.processing_payment": "Elaborazione del pagamento",
  "pricing_table.discount": "Sconto",
  "pricing_table.subtotal": "Subtotale"
}, yg = {
  "periods.week": "{{amount}} أسبوع",
  "periods.month": "{{amount}} شهر",
  "periods.year": "{{amount}} سنة",
  "periods.day": "{{amount}} يوم",
  "periods.weekShort": "{{amount}}أسبوع",
  "periods.monthShort": "{{amount}}شهر",
  "periods.yearShort": "{{amount}}سنة",
  "periods.dayShort": "{{amount}}يوم",
  "periods.lifetime": "مدى الحياة",
  "periods.weekPlural": "{{amount}} أسابيع",
  "periods.monthPlural": "{{amount}} أشهر",
  "periods.yearPlural": "{{amount}} سنوات",
  "periods.dayPlural": "{{amount}} أيام",
  "periods.weekFrequency": "أسبوعيًا",
  "periods.monthFrequency": "شهريًا",
  "periods.yearFrequency": "سنويًا",
  "periods.dayFrequency": "يوميًا",
  "periods.perWeekFrequency": "في الأسبوع",
  "periods.perMonthFrequency": "في الشهر",
  "periods.perYearFrequency": "في السنة",
  "periods.perDayFrequency": "في اليوم",
  "periods.unknownFrequency": "غير معروف",
  "periods.weekFrequencyPlural": "كل {{amount}} أسابيع",
  "periods.monthFrequencyPlural": "كل {{amount}} أشهر",
  "periods.yearFrequencyPlural": "كل {{amount}} سنوات",
  "periods.dayFrequencyPlural": "كل {{amount}} أيام",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} تجربة مجانية",
  "product_info.price_after_free_trial": "بعد انتهاء التجربة، في {{renewalDate}}",
  "product_info.renewal_frequency": "يتم التجديد {{frequency}}",
  "product_info.continues_until_cancelled": "يستمر حتى يتم إلغاؤه",
  "product_info.cancel_anytime": "يمكن الإلغاء في أي وقت",
  "payment_entry_page.payment_step_title": "الدفع الآمن عبر RevenueCat",
  "payment_entry_page.button_pay": "ادفع الآن",
  "payment_entry_page.button_start_trial": "ابدأ التجربة",
  "success_page.purchase_successful": "تم الدفع بنجاح",
  "success_page.button_close": "متابعة",
  "error_page.if_error_persists": "إذا استمرت المشكلة، يرجى الاتصال بـ ",
  "error_page.error_title_already_subscribed": "أنت مشترك بالفعل في {{productTitle}}",
  "error_page.error_title_already_purchased": "لقد اشتريت {{productTitle}} بالفعل",
  "error_page.error_title_other_errors": "حدث خطأ ما",
  "error_page.error_message_already_subscribed": "لا يمكنك الاشتراك في هذا المنتج مرة أخرى.",
  "error_page.error_message_already_purchased": "لا يمكنك شراء هذا المنتج مرة أخرى.",
  "error_page.error_message_missing_email_error": "يُطلب البريد الإلكتروني لإتمام عملية الشراء.",
  "error_page.error_message_network_error": "خطأ في الشبكة. يرجى التحقق من اتصال الإنترنت.",
  "error_page.error_message_error_charging_payment": "فشل الدفع.",
  "error_page.error_message_error_setting_up_purchase": "لم تبدأ عملية الشراء بسبب خطأ (رمز الخطأ: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "لم نتمكن من التحقق من عنوان الفوترة الخاص بك. يرجى التحقق مرة أخرى من الرمز البريدي والبلد للتأكد من صحتهما.",
  "error_page.error_message_unknown_error": "حدث خطأ غير معروف (رمز الخطأ: {{errorCode}}).",
  "error_page.button_try_again": "حاول مرة أخرى",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "إجمالي المبلغ المستحق اليوم",
  "product_info.subscribe_to": "اشترك في",
  "navbar_header.details": "تفاصيل",
  "navbar_header.back_button": "عودة",
  "pricing_dropdown.show_details": "إظهار التفاصيل",
  "pricing_dropdown.hide_details": "إخفاء التفاصيل",
  "pricing_table.tax": "الضريبة",
  "pricing_table.trial_ends": "بعد انتهاء الفترة التجريبية، في {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "الإجمالي المستحق اليوم",
  "pricing_table.total_excluding_tax": "الإجمالي باستثناء الضريبة",
  "pricing_table.enter_billing_address_to_calculate": "أدخل عنوان إرسال الفواتير لحسابها",
  "pricing_table.enter_state_or_postal_code_to_calculate": "أدخل الولاية أو الرمز البريدي للحساب",
  "pricing_table.enter_postal_code_to_calculate": "أدخل الرمز البريدي للحساب",
  "error_page.error_message_invalid_email_error": "تعذر التحقق من عنوان البريد الإلكتروني {{email}}. يرجى تقديم عنوان بريد إلكتروني صالح.",
  "payment_entry_page.button_payment_method": "ادفع {{formattedPrice}} باستخدام {{paymentMethod}}",
  "payment_entry_page.button_with_price": "ادفع {{formattedPrice}}",
  "price_update.title": "تحديث السعر",
  "price_update.base_message": "تم تحديث السعر الإجمالي مع الضريبة بناءً على عنوان إرسال الفواتير الخاص بك. يرجى المراجعة والمحاولة مرة أخرى. لن يتم تحصيل رسوم من بطاقتك إلا مرة واحدة.",
  "price_update.trial_message": "تم تحديث سعر الاشتراك ليشمل الضرائب بناءً على عنوان الفوترة الخاص بك. فترة التجربة المجانية لا تزال سارية. يرجى التحقق والمحاولة مرة أخرى.",
  "payment_entry_page.express_checkout_divider": "أو ادفع بواسطة البطاقة",
  "error_page.trouble_accessing": "إذا كنت تواجه مشكلة في الوصول إلى عملية الشراء، فتواصل مع الدعم على ",
  "error_page.close_button_title": "اذهب إلى {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "إذن Stripe مفقود",
  "error_page.button_close": "إغلاق",
  "error_page.error_message_stripe_invalid_tax_origin_address": "فشلت عملية الشراء لأن عنوان المنشأ الضريبي غير صالح. في مرحلة الإنتاج، ستعمل عمليات الشراء بدون تطبيق الضرائب.",
  "error_page.error_message_stripe_tax_not_active": "فشلت عملية الشراء لأن ضريبة Stripe غير مفعلة. في مرحلة الإنتاج، ستعمل عمليات الشراء بدون تطبيق الضرائب.",
  "error_page.error_only_in_sandbox": "تظهر هذه الرسالة فقط في البيئة التجريبية.",
  "error_page.error_message_stripe_missing_required_permission": "فشلت عملية الشراء لأن تطبيق Stripe يفتقر إلى إذن مطلوب. في مرحلة الإنتاج، ستعمل عمليات الشراء بدون تطبيق الضرائب.",
  "error_page.error_title_stripe_tax_not_active": "ضريبة Stripe غير نشطة",
  "error_page.error_title_stripe_invalid_tax_origin_address": "عنوان منشأ ضريبي غير صالح",
  "apple_pay.free_trial": "تجربة مجانية",
  "product_info.price_after_intro_price": "بعد {{introPriceDuration}}، في {{renewalDate}}",
  "product_info.after_trial": "بعد الفترة التجريبية",
  "product_info.after": "بعد",
  "product_info.intro_price_phase_after_trial": "ثم {{introPriceDuration}} مقابل {{introPrice}}",
  "product_info.intro_price_phase": "أولاً {{introPriceDuration}} مقابل {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "تدفع مرة واحدة",
  "payment_entry_page.trial_subscription_terms_info": "بعد انتهاء الفترة التجريبية، سيتم محاسبتك بمبلغ {{price}} {{perFrequency}} بدءًا من {{renewalDate}}. يمكنك الإلغاء في أي وقت قبل هذا التاريخ.",
  "payment_entry_page.subscription_info": "يتم تجديد الاشتراك تلقائيًا. يمكنك الإلغاء في أي وقت.",
  "payment_entry_page.otp_terms_info": "بالشراء، أنت توافق على السماح لتطبيق {{appName}} بتحصيل الرسوم منك وفقًا لشروطه.",
  "payment_entry_page.terms_link_label": "الشروط",
  "payment_entry_page.subscription_terms_info": "بالاشتراك، فإنك توافق على السماح لـ {{appName}} بتحصيل رسوم منك وفقًا لشروطها حتى تقوم بالإلغاء.",
  "loading_page.keep_page_open": "العملية شارفت على الانتهاء. أبقِ هذه الصفحة مفتوحة.",
  "loading_page.processing_payment": "جاري معالجة الدفع",
  "pricing_table.discount": "خصم",
  "pricing_table.subtotal": "المجموع الفرعي"
}, bg = {
  "periods.week": "{{amount}} setmana",
  "periods.month": "{{amount}} mes",
  "periods.year": "{{amount}} any",
  "periods.day": "{{amount}} dia",
  "periods.weekShort": "{{amount}}set",
  "periods.monthShort": "{{amount}}mes",
  "periods.yearShort": "{{amount}}any",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "de per vida",
  "periods.weekPlural": "{{amount}} setmanes",
  "periods.monthPlural": "{{amount}} mesos",
  "periods.yearPlural": "{{amount}} anys",
  "periods.dayPlural": "{{amount}} dies",
  "periods.weekFrequency": "setmanal",
  "periods.monthFrequency": "mensual",
  "periods.yearFrequency": "anual",
  "periods.dayFrequency": "diari",
  "periods.perWeekFrequency": "per setmana",
  "periods.perMonthFrequency": "per mes",
  "periods.perYearFrequency": "per any",
  "periods.perDayFrequency": "per dia",
  "periods.unknownFrequency": "desconeguda",
  "periods.weekFrequencyPlural": "cada {{amount}} setmanes",
  "periods.monthFrequencyPlural": "cada {{amount}} mesos",
  "periods.yearFrequencyPlural": "cada {{amount}} anys",
  "periods.dayFrequencyPlural": "cada {{amount}} dies",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} de prova gratuïta",
  "product_info.price_after_free_trial": "Després del període de prova, el {{renewalDate}}",
  "product_info.renewal_frequency": "Es renova {{frequency}}",
  "product_info.continues_until_cancelled": "Continua fins que es cancel·li",
  "product_info.cancel_anytime": "Cancel·la en qualsevol moment",
  "payment_entry_page.payment_step_title": "Pagament segur amb RevenueCat",
  "payment_entry_page.button_pay": "Paga ara",
  "payment_entry_page.button_start_trial": "Comença la prova",
  "success_page.purchase_successful": "Pagament complet",
  "success_page.button_close": "Continua",
  "error_page.if_error_persists": "Si l'error persisteix, contacta amb ",
  "error_page.error_title_already_subscribed": "Ja us heu subscrit a {{productTitle}}",
  "error_page.error_title_already_purchased": "Ja heu comprat {{productTitle}}",
  "error_page.error_title_other_errors": "Alguna cosa ha anat malament",
  "error_page.error_message_already_subscribed": "No us podeu subscriure a aquest producte de nou.",
  "error_page.error_message_already_purchased": "No podeu comprar aquest producte de nou.",
  "error_page.error_message_missing_email_error": "Es necessita un correu electrònic per completar la compra.",
  "error_page.error_message_network_error": "Error de xarxa. Comprova la teva connexió a internet.",
  "error_page.error_message_error_charging_payment": "El pagament ha fallat.",
  "error_page.error_message_error_setting_up_purchase": "No s'ha iniciat la compra a causa d'un error (codi d'error: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "No hem pogut verificar la vostra adreça de facturació. Si us plau, verifiqueu de nou el codi postal i el país per assegurar-vos que són correctes.",
  "error_page.error_message_unknown_error": "S'ha produït un error desconegut (codi d'error: {{errorCode}}).",
  "error_page.button_try_again": "Torna a intentar-ho",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Total a pagar avui",
  "product_info.subscribe_to": "Subscriu-te a",
  "navbar_header.details": "Detalls",
  "navbar_header.back_button": "Enrere",
  "pricing_dropdown.show_details": "Mostra detalls",
  "pricing_dropdown.hide_details": "Amaga detalls",
  "pricing_table.tax": "Impostos",
  "pricing_table.trial_ends": "Després que finalitzi la prova, el {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total a pagar avui",
  "pricing_table.total_excluding_tax": "Total sense impostos",
  "pricing_table.enter_billing_address_to_calculate": "Introduïu l'adreça de facturació per calcular",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Introduïu la província o el codi postal per calcular",
  "pricing_table.enter_postal_code_to_calculate": "Introduïu el codi postal per calcular",
  "error_page.error_message_invalid_email_error": "No s'ha pogut verificar l'adreça de correu electrònic {{email}}. Si us plau, proporcioneu una adreça de correu electrònic vàlida.",
  "payment_entry_page.button_payment_method": "Paga {{formattedPrice}} amb {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Paga {{formattedPrice}}",
  "price_update.title": "Actualització de preu",
  "price_update.base_message": "El preu total s'ha actualitzat amb els impostos segons la vostra adreça de facturació. Reviseu-ho i torneu-ho a provar. Només es carregarà la vostra targeta una vegada.",
  "price_update.trial_message": "El preu de la subscripció s'ha actualitzat per incloure els impostos segons la seva adreça de facturació. El període de prova gratuït segueix vigent. Si us plau, comprovi-ho i torni-ho a provar.",
  "payment_entry_page.express_checkout_divider": "O PAGUEU AMB TARGETA",
  "error_page.trouble_accessing": "Si teniu problemes per accedir a la vostra compra, poseu-vos en contacte amb el servei d'assistència a ",
  "error_page.close_button_title": "Vés a {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Falta el permís de Stripe",
  "error_page.button_close": "Tanca",
  "error_page.error_message_stripe_invalid_tax_origin_address": "La compra ha fallat perquè l'adreça d'origen fiscal no és vàlida. En producció, les compres funcionaran sense impostos aplicats.",
  "error_page.error_message_stripe_tax_not_active": "La compra ha fallat perquè Stripe Tax no està activat. En producció, les compres funcionaran sense impostos aplicats.",
  "error_page.error_only_in_sandbox": "Aquest missatge apareix només a l'entorn de proves.",
  "error_page.error_message_stripe_missing_required_permission": "La compra ha fallat perquè l'aplicació Stripe no té un permís necessari. En producció, les compres funcionaran sense impostos aplicats.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax no està actiu",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Adreça d'origen fiscal no vàlida",
  "apple_pay.free_trial": "Prova gratuïta",
  "product_info.price_after_intro_price": "Després de {{introPriceDuration}}, el {{renewalDate}}",
  "product_info.after_trial": "després del període de prova",
  "product_info.after": "després de",
  "product_info.intro_price_phase_after_trial": "Després {{introPriceDuration}} per {{introPrice}}",
  "product_info.intro_price_phase": "Primer {{introPriceDuration}} per {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "pagat un cop",
  "payment_entry_page.trial_subscription_terms_info": "Un cop finalitzat el període de prova, se us cobrarà {{price}} {{perFrequency}} a partir del {{renewalDate}}. Podeu cancel·lar-ho en qualsevol moment abans d'aquesta data.",
  "payment_entry_page.subscription_info": "La subscripció es renova automàticament. Cancel·leu-la quan vulgueu.",
  "payment_entry_page.otp_terms_info": "En comprar, accepteu que {{appName}} us cobri d'acord amb les seves condicions.",
  "payment_entry_page.terms_link_label": "Condicions",
  "payment_entry_page.subscription_terms_info": "En subscriure-us, accepteu que {{appName}} us cobri d'acord amb les seves condicions fins que ho cancel·leu.",
  "loading_page.keep_page_open": "El procés està gairebé acabat. Mantingueu aquesta pàgina oberta.",
  "loading_page.processing_payment": "S'està processant el pagament",
  "pricing_table.discount": "Descompte",
  "pricing_table.subtotal": "Subtotal"
}, vg = {
  "periods.week": "{{amount}} 周",
  "periods.month": "{{amount}} 月",
  "periods.year": "{{amount}} 年",
  "periods.day": "{{amount}} 天",
  "periods.weekShort": "{{amount}}周",
  "periods.monthShort": "{{amount}}月",
  "periods.yearShort": "{{amount}}年",
  "periods.dayShort": "{{amount}}天",
  "periods.lifetime": "终身",
  "periods.weekPlural": "{{amount}} 周",
  "periods.monthPlural": "{{amount}} 个月",
  "periods.yearPlural": "{{amount}} 年",
  "periods.dayPlural": "{{amount}} 天",
  "periods.weekFrequency": "每周",
  "periods.monthFrequency": "每月",
  "periods.yearFrequency": "每年",
  "periods.dayFrequency": "每天",
  "periods.perWeekFrequency": "每周",
  "periods.perMonthFrequency": "每月",
  "periods.perYearFrequency": "每年",
  "periods.perDayFrequency": "每天",
  "periods.unknownFrequency": "未知",
  "periods.weekFrequencyPlural": "每 {{amount}} 周",
  "periods.monthFrequencyPlural": "每 {{amount}} 个月",
  "periods.yearFrequencyPlural": "每 {{amount}} 年",
  "periods.dayFrequencyPlural": "每 {{amount}} 天",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} 天免费试用",
  "product_info.price_after_free_trial": "试用期结束后，于 {{renewalDate}}",
  "product_info.renewal_frequency": "续订 {{frequency}}",
  "product_info.continues_until_cancelled": "持续到取消",
  "product_info.cancel_anytime": "随时取消",
  "payment_entry_page.payment_step_title": "RevenueCat 安全结账",
  "payment_entry_page.button_pay": "立即支付",
  "payment_entry_page.button_start_trial": "开始试用",
  "success_page.purchase_successful": "支付完成",
  "success_page.button_close": "继续",
  "error_page.if_error_persists": "如果错误仍然存在，请联系 ",
  "error_page.error_title_already_subscribed": "您已订阅 {{productTitle}}",
  "error_page.error_title_already_purchased": "您已购买 {{productTitle}}",
  "error_page.error_title_other_errors": "出现错误",
  "error_page.error_message_already_subscribed": "您不能再次订阅此产品。",
  "error_page.error_message_already_purchased": "您不能再次购买此产品。",
  "error_page.error_message_missing_email_error": "完成购买需要邮箱地址。",
  "error_page.error_message_network_error": "网络错误。请检查您的互联网连接。",
  "error_page.error_message_error_charging_payment": "支付失败。",
  "error_page.error_message_error_setting_up_purchase": "由于错误，购买未启动（错误代码：{{errorCode}}）。",
  "error_page.error_message_invalid_tax_location": "我们无法验证您的账单地址。请仔细检查邮政编码和国家是否正确。",
  "error_page.error_message_unknown_error": "发生未知错误（错误代码：{{errorCode}}）。",
  "error_page.button_try_again": "重试",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "今天应付总额",
  "product_info.subscribe_to": "订阅",
  "navbar_header.details": "详情",
  "navbar_header.back_button": "返回",
  "pricing_dropdown.show_details": "显示详情",
  "pricing_dropdown.hide_details": "隐藏详情",
  "pricing_table.tax": "税",
  "pricing_table.trial_ends": "试用期结束后，于{{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "今日应付总额",
  "pricing_table.total_excluding_tax": "总计（不含税）",
  "pricing_table.enter_billing_address_to_calculate": "输入账单地址以计算",
  "pricing_table.enter_state_or_postal_code_to_calculate": "输入州或邮政编码以计算",
  "pricing_table.enter_postal_code_to_calculate": "输入邮政编码以计算",
  "error_page.error_message_invalid_email_error": "无法验证电子邮件地址{{email}}。请提供有效的电子邮件地址。",
  "payment_entry_page.button_payment_method": "使用{{paymentMethod}}支付{{formattedPrice}}",
  "payment_entry_page.button_with_price": "支付{{formattedPrice}}",
  "price_update.title": "价格更新",
  "price_update.base_message": "总价已根据您的账单地址更新了税费。请查看并重试。您的银行卡只会扣款一次。",
  "price_update.trial_message": "根据您的账单地址，订阅价格已更新为含税价格。免费试用仍然有效。请查看并重试。",
  "payment_entry_page.express_checkout_divider": "或使用银行卡支付",
  "error_page.trouble_accessing": "如果您在访问购买项目时遇到问题，请通过以下方式联系支持：",
  "error_page.close_button_title": "前往{{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "缺少Stripe权限",
  "error_page.button_close": "关闭",
  "error_page.error_message_stripe_invalid_tax_origin_address": "购买失败，因为税务起始地址无效。在生产环境中，购买将在不应用税款的情况下进行。",
  "error_page.error_message_stripe_tax_not_active": "购买失败，因为Stripe Tax未启用。在生产环境中，购买将在不应用税款的情况下进行。",
  "error_page.error_only_in_sandbox": "此消息仅在沙盒中显示。",
  "error_page.error_message_stripe_missing_required_permission": "购买失败，因为Stripe应用程序缺少必需的权限。在生产环境中，购买将在不应用税款的情况下进行。",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax未激活",
  "error_page.error_title_stripe_invalid_tax_origin_address": "税务起始地址无效",
  "apple_pay.free_trial": "免费试用",
  "product_info.price_after_intro_price": "在{{introPriceDuration}}之后，于{{renewalDate}}开始",
  "product_info.after_trial": "试用后",
  "product_info.after": "之后",
  "product_info.intro_price_phase_after_trial": "然后{{introPriceDuration}}，价格为{{introPrice}}",
  "product_info.intro_price_phase": "首先{{introPriceDuration}}，价格为{{introPrice}}",
  "product_info.intro_price_phase_paid_once": "一次性支付",
  "payment_entry_page.trial_subscription_terms_info": "试用期结束后，您将被收取 {{price}} {{perFrequency}}，从 {{renewalDate}} 开始。您可以在此日期之前的任何时间取消。",
  "payment_entry_page.subscription_info": "订阅自动续订。随时取消。",
  "payment_entry_page.otp_terms_info": "购买即表示您同意允许{{appName}}根据其条款向您收费。",
  "payment_entry_page.terms_link_label": "条款",
  "payment_entry_page.subscription_terms_info": "订阅即表示您同意允许 {{appName}} 按照其条款向您收费，直到您取消订阅。",
  "loading_page.keep_page_open": "流程即将完成。请保持此页面打开。",
  "loading_page.processing_payment": "正在处理付款",
  "pricing_table.discount": "折扣",
  "pricing_table.subtotal": "小计"
}, kg = {
  "periods.week": "{{amount}} 週",
  "periods.month": "{{amount}} 個月",
  "periods.year": "{{amount}} 年",
  "periods.day": "{{amount}} 天",
  "periods.weekShort": "{{amount}}週",
  "periods.monthShort": "{{amount}}月",
  "periods.yearShort": "{{amount}}年",
  "periods.dayShort": "{{amount}}天",
  "periods.lifetime": "終身",
  "periods.weekPlural": "{{amount}} 週",
  "periods.monthPlural": "{{amount}} 個月",
  "periods.yearPlural": "{{amount}} 年",
  "periods.dayPlural": "{{amount}} 天",
  "periods.weekFrequency": "每週",
  "periods.monthFrequency": "每月",
  "periods.yearFrequency": "每年",
  "periods.dayFrequency": "每天",
  "periods.perWeekFrequency": "每週",
  "periods.perMonthFrequency": "每月",
  "periods.perYearFrequency": "每年",
  "periods.perDayFrequency": "每天",
  "periods.unknownFrequency": "未知",
  "periods.weekFrequencyPlural": "每 {{amount}} 週",
  "periods.monthFrequencyPlural": "每 {{amount}} 個月",
  "periods.yearFrequencyPlural": "每 {{amount}} 年",
  "periods.dayFrequencyPlural": "每 {{amount}} 天",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} 天免費試用",
  "product_info.price_after_free_trial": "試用期結束後，於 {{renewalDate}}",
  "product_info.renewal_frequency": "每 {{frequency}} 續約",
  "product_info.continues_until_cancelled": "持續到取消",
  "product_info.cancel_anytime": "隨時取消",
  "payment_entry_page.payment_step_title": "RevenueCat 安全結帳",
  "payment_entry_page.button_pay": "立即付款",
  "payment_entry_page.button_start_trial": "開始試用",
  "success_page.purchase_successful": "付款完成",
  "success_page.button_close": "繼續",
  "error_page.if_error_persists": "如果錯誤持續存在，請聯絡 ",
  "error_page.error_title_already_subscribed": "您已經訂閱 {{productTitle}}",
  "error_page.error_title_already_purchased": "您已經購買 {{productTitle}}",
  "error_page.error_title_other_errors": "發生錯誤",
  "error_page.error_message_already_subscribed": "您無法再次訂閱此產品。",
  "error_page.error_message_already_purchased": "您無法再次購買此產品。",
  "error_page.error_message_missing_email_error": "完成購買需要電子郵件地址。",
  "error_page.error_message_network_error": "網路錯誤。請檢查您的網路連線。",
  "error_page.error_message_error_charging_payment": "付款失敗。",
  "error_page.error_message_error_setting_up_purchase": "由於發生錯誤，購買未啟動（錯誤代碼：{{errorCode}}）。",
  "error_page.error_message_invalid_tax_location": "我們無法驗證您的帳單地址。請仔細檢查郵遞區號和國家是否正確。",
  "error_page.error_message_unknown_error": "發生不明錯誤（錯誤代碼：{{errorCode}}）。",
  "error_page.button_try_again": "再試一次",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "今日應付總額",
  "product_info.subscribe_to": "訂閱",
  "navbar_header.details": "詳細資訊",
  "navbar_header.back_button": "返回",
  "pricing_dropdown.show_details": "顯示詳細資訊",
  "pricing_dropdown.hide_details": "隱藏詳細資訊",
  "pricing_table.tax": "稅金",
  "pricing_table.trial_ends": "試用期結束後，於 {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "今日應付總額",
  "pricing_table.total_excluding_tax": "總計（不含稅）",
  "pricing_table.enter_billing_address_to_calculate": "輸入帳單地址以計算",
  "pricing_table.enter_state_or_postal_code_to_calculate": "輸入州或郵政編碼以計算",
  "pricing_table.enter_postal_code_to_calculate": "輸入郵政編碼以計算",
  "error_page.error_message_invalid_email_error": "無法驗證電子郵件地址 {{email}}。請提供有效的電子郵件地址。",
  "payment_entry_page.button_payment_method": "使用 {{paymentMethod}} 支付 {{formattedPrice}}",
  "payment_entry_page.button_with_price": "支付 {{formattedPrice}}",
  "price_update.title": "價格更新",
  "price_update.base_message": "總價已根據您的帳單地址更新稅金。請檢查後重試。您的信用卡只會被收取一次費用。",
  "price_update.trial_message": "根據您的帳單地址，訂閱價格已更新為含稅價格。免費試用仍然有效。請查看並重試。",
  "payment_entry_page.express_checkout_divider": "或以信用卡付款",
  "error_page.trouble_accessing": "如果您在存取購買項目時遇到問題，請透過以下方式聯絡支援人員：",
  "error_page.close_button_title": "前往{{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "缺少 Stripe 權限",
  "error_page.button_close": "關閉",
  "error_page.error_message_stripe_invalid_tax_origin_address": "購買失敗，因為稅務起始地址無效。在正式環境中，購買將在不套用稅金的情況下運作。",
  "error_page.error_message_stripe_tax_not_active": "購買失敗，因為 Stripe Tax 未啟用。在正式環境中，購買將在不套用稅金的情況下運作。",
  "error_page.error_only_in_sandbox": "此訊息僅在沙盒中顯示。",
  "error_page.error_message_stripe_missing_required_permission": "購買失敗，因為 Stripe 應用程式缺少必要的權限。在正式環境中，購買將在不套用稅金的情況下運作。",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax 未啟用",
  "error_page.error_title_stripe_invalid_tax_origin_address": "無效的稅務起始地址",
  "apple_pay.free_trial": "免費試用",
  "product_info.price_after_intro_price": "在 {{introPriceDuration}} 之後，於 {{renewalDate}}",
  "product_info.after_trial": "試用期後",
  "product_info.after": "之後",
  "product_info.intro_price_phase_after_trial": "然後 {{introPriceDuration}}，價格為 {{introPrice}}",
  "product_info.intro_price_phase": "首先 {{introPriceDuration}}，價格為 {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "一次性支付",
  "payment_entry_page.trial_subscription_terms_info": "在您的試用期結束後，您將被收取 {{price}} {{perFrequency}}，從 {{renewalDate}} 開始。您可以隨時在此日期之前取消。",
  "payment_entry_page.subscription_info": "訂閱會自動續訂。隨時取消。",
  "payment_entry_page.otp_terms_info": "購買即表示您同意授權 {{appName}} 根據其條款向您收費。",
  "payment_entry_page.terms_link_label": "條款",
  "payment_entry_page.subscription_terms_info": "訂閱即表示您同意允許 {{appName}} 根據其條款向您收費，直到您取消為止。",
  "loading_page.keep_page_open": "程序即將完成。請保持此頁面開啟。",
  "loading_page.processing_payment": "正在處理付款",
  "pricing_table.discount": "折扣",
  "pricing_table.subtotal": "小計"
}, wg = {
  "periods.week": "{{amount}} tjedan",
  "periods.month": "{{amount}} mjesec",
  "periods.year": "{{amount}} godina",
  "periods.day": "{{amount}} dan",
  "periods.weekShort": "{{amount}}tj",
  "periods.monthShort": "{{amount}}mj",
  "periods.yearShort": "{{amount}}g",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "doživotno",
  "periods.weekPlural": "{{amount}} tjedana",
  "periods.monthPlural": "{{amount}} mjeseci",
  "periods.yearPlural": "{{amount}} godina",
  "periods.dayPlural": "{{amount}} dana",
  "periods.weekFrequency": "tjedno",
  "periods.monthFrequency": "mjesečno",
  "periods.yearFrequency": "godišnje",
  "periods.dayFrequency": "dnevno",
  "periods.perWeekFrequency": "tjedno",
  "periods.perMonthFrequency": "mjesečno",
  "periods.perYearFrequency": "godišnje",
  "periods.perDayFrequency": "dnevno",
  "periods.unknownFrequency": "nepoznato",
  "periods.weekFrequencyPlural": "svakih {{amount}} tjedana",
  "periods.monthFrequencyPlural": "svakih {{amount}} mjeseci",
  "periods.yearFrequencyPlural": "svakih {{amount}} godina",
  "periods.dayFrequencyPlural": "svakih {{amount}} dana",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} besplatno probno razdoblje",
  "product_info.price_after_free_trial": "Nakon isteka probnog razdoblja, {{renewalDate}}",
  "product_info.renewal_frequency": "Obnavlja se {{frequency}}",
  "product_info.continues_until_cancelled": "Nastavlja se dok se ne otkaže",
  "product_info.cancel_anytime": "Otkažite u bilo kojem trenutku",
  "payment_entry_page.payment_step_title": "Sigurna naplata putem RevenueCat",
  "payment_entry_page.button_pay": "Plati sada",
  "payment_entry_page.button_start_trial": "Počni probno razdoblje",
  "success_page.purchase_successful": "Uplata je uspješna",
  "success_page.button_close": "Nastavi",
  "error_page.if_error_persists": "Ako se pogreška nastavi, obratite se ",
  "error_page.error_title_already_subscribed": "Već ste pretplaćeni na {{productTitle}}",
  "error_page.error_title_already_purchased": "Već ste kupili {{productTitle}}",
  "error_page.error_title_other_errors": "Nešto je pošlo po zlu",
  "error_page.error_message_already_subscribed": "Ne možete se ponovno pretplatiti na ovaj proizvod.",
  "error_page.error_message_already_purchased": "Ne možete ponovno kupiti ovaj proizvod.",
  "error_page.error_message_missing_email_error": "E-pošta je potrebna za dovršetak kupnje.",
  "error_page.error_message_network_error": "Mrežna pogreška. Provjerite internetsku vezu.",
  "error_page.error_message_error_charging_payment": "Plaćanje nije uspjelo.",
  "error_page.error_message_error_setting_up_purchase": "Kupnja nije započela zbog pogreške (kod pogreške: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nismo mogli potvrditi vašu adresu za naplatu. Molimo provjerite poštanski broj i državu kako biste bili sigurni da su točni.",
  "error_page.error_message_unknown_error": "Došlo je do nepoznate pogreške (kod pogreške: {{errorCode}}).",
  "error_page.button_try_again": "Pokušaj ponovno",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Ukupno dospijeće danas",
  "product_info.subscribe_to": "Pretplatite se",
  "navbar_header.details": "Detalji",
  "navbar_header.back_button": "Natrag",
  "pricing_dropdown.show_details": "Prikaži detalje",
  "pricing_dropdown.hide_details": "Sakrij detalje",
  "pricing_table.tax": "Porez",
  "pricing_table.trial_ends": "Nakon isteka probnog razdoblja, {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Ukupan iznos dospijeća danas",
  "pricing_table.total_excluding_tax": "Ukupno bez poreza",
  "pricing_table.enter_billing_address_to_calculate": "Unesite adresu za naplatu za izračun",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Unesite državu ili poštanski broj za izračun",
  "pricing_table.enter_postal_code_to_calculate": "Unesite poštanski broj za izračun",
  "error_page.error_message_invalid_email_error": "Adresa e-pošte {{email}} nije se mogla potvrditi. Molimo unesite valjanu adresu e-pošte.",
  "payment_entry_page.button_payment_method": "Plati {{formattedPrice}} putem {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Plati {{formattedPrice}}",
  "price_update.title": "Ažuriranje cijene",
  "price_update.base_message": "Ukupna cijena je ažurirana s porezom na temelju vaše adrese za naplatu. Pregledajte i pokušajte ponovo. Vaša kartica bit će naplaćena samo jednom.",
  "price_update.trial_message": "Cijena pretplate je ažurirana da uključi poreze na temelju vaše adrese za naplatu. Besplatno probno razdoblje i dalje vrijedi. Molimo provjerite i pokušajte ponovno.",
  "payment_entry_page.express_checkout_divider": "ILI PLATITE KARTICOM",
  "error_page.trouble_accessing": "Ako imate problema s pristupom kupnji, obratite se podršci na ",
  "error_page.close_button_title": "Idi na {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Nedostaje Stripe dopuštenje",
  "error_page.button_close": "Zatvori",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Kupnja nije uspjela jer je adresa poreznog podrijetla nevažeća. U produkciji će kupnje funkcionirati bez primijenjenih poreza.",
  "error_page.error_message_stripe_tax_not_active": "Kupnja nije uspjela jer Stripe Tax nije omogućen. U produkciji će kupnje funkcionirati bez primijenjenih poreza.",
  "error_page.error_only_in_sandbox": "Ova se poruka pojavljuje samo u sandboxu.",
  "error_page.error_message_stripe_missing_required_permission": "Kupnja nije uspjela jer Stripe aplikaciji nedostaje potrebno dopuštenje. U produkciji će kupnje funkcionirati bez primijenjenih poreza.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax nije aktivan",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Nevažeća adresa poreznog podrijetla",
  "apple_pay.free_trial": "Besplatna proba",
  "product_info.price_after_intro_price": "Nakon {{introPriceDuration}}, na {{renewalDate}}",
  "product_info.after_trial": "nakon probnog perioda",
  "product_info.after": "nakon",
  "product_info.intro_price_phase_after_trial": "Zatim {{introPriceDuration}} za {{introPrice}}",
  "product_info.intro_price_phase": "Prvo {{introPriceDuration}} za {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "plaća se jednokratno",
  "payment_entry_page.trial_subscription_terms_info": "Nakon isteka probnog razdoblja, bit će vam naplaćeno {{price}} {{perFrequency}} počevši od {{renewalDate}}. Možete otkazati bilo kada prije tog datuma.",
  "payment_entry_page.subscription_info": "Pretplata se automatski obnavlja. Otkažite bilo kada.",
  "payment_entry_page.otp_terms_info": "Kupnjom pristajete dopustiti aplikaciji {{appName}} da vam naplati u skladu s njihovim uvjetima.",
  "payment_entry_page.terms_link_label": "Uvjeti",
  "payment_entry_page.subscription_terms_info": "Pretplatom se slažete da ćete dopustiti {{appName}} da vam naplaćuje u skladu s njihovim uvjetima dok ne otkažete.",
  "loading_page.keep_page_open": "Proces je skoro gotov. Ostavite ovu stranicu otvorenom.",
  "loading_page.processing_payment": "Obrada uplate",
  "pricing_table.discount": "Popust",
  "pricing_table.subtotal": "Međuzbroj"
}, Pg = {
  "periods.week": "{{amount}} týden",
  "periods.month": "{{amount}} měsíc",
  "periods.year": "{{amount}} rok",
  "periods.day": "{{amount}} den",
  "periods.weekShort": "{{amount}}týd",
  "periods.monthShort": "{{amount}}měs",
  "periods.yearShort": "{{amount}}rok",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "doživotně",
  "periods.weekPlural": "{{amount}} týdnů",
  "periods.monthPlural": "{{amount}} měsíců",
  "periods.yearPlural": "{{amount}} let",
  "periods.dayPlural": "{{amount}} dnů",
  "periods.weekFrequency": "týdně",
  "periods.monthFrequency": "měsíčně",
  "periods.yearFrequency": "ročně",
  "periods.dayFrequency": "denně",
  "periods.perWeekFrequency": "týdně",
  "periods.perMonthFrequency": "měsíčně",
  "periods.perYearFrequency": "ročně",
  "periods.perDayFrequency": "denně",
  "periods.unknownFrequency": "neznámé",
  "periods.weekFrequencyPlural": "každých {{amount}} týdnů",
  "periods.monthFrequencyPlural": "každých {{amount}} měsíců",
  "periods.yearFrequencyPlural": "každých {{amount}} let",
  "periods.dayFrequencyPlural": "každých {{amount}} dnů",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} zkušební verze zdarma",
  "product_info.price_after_free_trial": "Po skončení zkušební verze, {{renewalDate}}",
  "product_info.renewal_frequency": "Obnovuje se {{frequency}}",
  "product_info.continues_until_cancelled": "Pokračuje, dokud není zrušeno",
  "product_info.cancel_anytime": "Zrušit kdykoli",
  "payment_entry_page.payment_step_title": "Bezpečné placení přes RevenueCat",
  "payment_entry_page.button_pay": "Platit nyní",
  "payment_entry_page.button_start_trial": "Spustit zkušební verzi",
  "success_page.purchase_successful": "Platba dokončena",
  "success_page.button_close": "Pokračovat",
  "error_page.if_error_persists": "Pokud chyba přetrvává, kontaktujte ",
  "error_page.error_title_already_subscribed": "Již máte předplatné pro {{productTitle}}",
  "error_page.error_title_already_purchased": "Již jste zakoupili {{productTitle}}",
  "error_page.error_title_other_errors": "Něco se pokazilo",
  "error_page.error_message_already_subscribed": "Nemůžete si znovu předplatit tento produkt.",
  "error_page.error_message_already_purchased": "Tento produkt si nemůžete znovu zakoupit.",
  "error_page.error_message_missing_email_error": "Pro dokončení nákupu je vyžadován e-mail.",
  "error_page.error_message_network_error": "Síťová chyba. Zkontrolujte prosím své internetové připojení.",
  "error_page.error_message_error_charging_payment": "Platba selhala.",
  "error_page.error_message_error_setting_up_purchase": "Nákup nebyl zahájen z důvodu chyby (kód chyby: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nemohli jsme ověřit vaši fakturační adresu. Zkontrolujte prosím, zda je poštovní směrovací číslo a země správné.",
  "error_page.error_message_unknown_error": "Došlo k neznámé chybě (kód chyby: {{errorCode}}).",
  "error_page.button_try_again": "Zkusit znovu",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Celkem dnes k zaplacení",
  "product_info.subscribe_to": "Předplatit",
  "navbar_header.details": "Podrobnosti",
  "navbar_header.back_button": "Zpět",
  "pricing_dropdown.show_details": "Zobrazit podrobnosti",
  "pricing_dropdown.hide_details": "Skrýt podrobnosti",
  "pricing_table.tax": "Daň",
  "pricing_table.trial_ends": "Po skončení zkušební doby, dne {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Celkem splatné dnes",
  "pricing_table.total_excluding_tax": "Celkem bez daně",
  "pricing_table.enter_billing_address_to_calculate": "Zadejte fakturační adresu pro výpočet",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Zadejte stát nebo PSČ pro výpočet",
  "pricing_table.enter_postal_code_to_calculate": "Zadejte PSČ pro výpočet",
  "error_page.error_message_invalid_email_error": "E-mailová adresa {{email}} nemohla být ověřena. Zadejte prosím platnou e-mailovou adresu.",
  "payment_entry_page.button_payment_method": "Zaplatit {{formattedPrice}} pomocí {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Zaplatit {{formattedPrice}}",
  "price_update.title": "Aktualizace ceny",
  "price_update.base_message": "Celková cena byla aktualizována o daň na základě vaší fakturační adresy. Zkontrolujte ji a zkuste to znovu. Vaše karta bude stržena pouze jednou.",
  "price_update.trial_message": "Cena předplatného byla aktualizována včetně daní na základě vaší fakturační adresy. Bezplatná zkušební doba stále platí. Prosím, zkontrolujte a zkuste to znovu.",
  "payment_entry_page.express_checkout_divider": "NEBO ZAPLATIT KARTOU",
  "error_page.trouble_accessing": "Pokud máte potíže s přístupem k zakoupenému obsahu, kontaktujte podporu na ",
  "error_page.close_button_title": "Přejít na {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Chybí oprávnění Stripe",
  "error_page.button_close": "Zavřít",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Nákup se nezdařil, protože adresa původu daně je neplatná. V produkčním prostředí budou nákupy fungovat bez uplatnění daní.",
  "error_page.error_message_stripe_tax_not_active": "Nákup se nezdařil, protože Stripe Tax není aktivní. V produkčním prostředí budou nákupy fungovat bez uplatnění daní.",
  "error_page.error_only_in_sandbox": "Tato zpráva se zobrazuje pouze v sandboxu.",
  "error_page.error_message_stripe_missing_required_permission": "Nákup se nezdařil, protože aplikaci Stripe chybí požadované oprávnění. V produkčním prostředí budou nákupy fungovat bez uplatnění daní.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax není aktivní",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Neplatná adresa původu daně",
  "apple_pay.free_trial": "Zkušební verze zdarma",
  "product_info.price_after_intro_price": "Po {{introPriceDuration}}, dne {{renewalDate}}",
  "product_info.after_trial": "po zkušební době",
  "product_info.after": "po",
  "product_info.intro_price_phase_after_trial": "Poté {{introPriceDuration}} za {{introPrice}}",
  "product_info.intro_price_phase": "Nejprve {{introPriceDuration}} za {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "placeno jednorázově",
  "payment_entry_page.trial_subscription_terms_info": "Po skončení zkušebního období vám bude účtováno {{price}} {{perFrequency}} počínaje {{renewalDate}}. Před tímto datem můžete kdykoli zrušit.",
  "payment_entry_page.subscription_info": "Předplatné se automaticky obnovuje. Zrušit můžete kdykoli.",
  "payment_entry_page.otp_terms_info": "Zakoupením souhlasíte s tím, že umožníte aplikaci {{appName}} účtovat vám poplatky v souladu s jejími podmínkami.",
  "payment_entry_page.terms_link_label": "Podmínky",
  "payment_entry_page.subscription_terms_info": "Přihlášením k odběru souhlasíte s tím, že společnost {{appName}} vám bude účtovat poplatky v souladu s jejími podmínkami, dokud odběr nezrušíte.",
  "loading_page.keep_page_open": "Probíhá dokončování procesu. Nechte tuto stránku otevřenou.",
  "loading_page.processing_payment": "Probíhá zpracování platby",
  "pricing_table.discount": "Sleva",
  "pricing_table.subtotal": "Mezisoučet"
}, xg = {
  "periods.week": "{{amount}} uge",
  "periods.month": "{{amount}} måned",
  "periods.year": "{{amount}} år",
  "periods.day": "{{amount}} dag",
  "periods.weekShort": "{{amount}}ug",
  "periods.monthShort": "{{amount}}md",
  "periods.yearShort": "{{amount}}år",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "livstid",
  "periods.weekPlural": "{{amount}} uger",
  "periods.monthPlural": "{{amount}} måneder",
  "periods.yearPlural": "{{amount}} år",
  "periods.dayPlural": "{{amount}} dage",
  "periods.weekFrequency": "ugentligt",
  "periods.monthFrequency": "månedligt",
  "periods.yearFrequency": "årligt",
  "periods.dayFrequency": "dagligt",
  "periods.perWeekFrequency": "pr. uge",
  "periods.perMonthFrequency": "pr. måned",
  "periods.perYearFrequency": "pr. år",
  "periods.perDayFrequency": "pr. dag",
  "periods.unknownFrequency": "ukendt",
  "periods.weekFrequencyPlural": "hver {{amount}} uger",
  "periods.monthFrequencyPlural": "hver {{amount}} måneder",
  "periods.yearFrequencyPlural": "hver {{amount}} år",
  "periods.dayFrequencyPlural": "hver {{amount}} dage",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} gratis prøveperiode",
  "product_info.price_after_free_trial": "Efter prøveperioden slutter, den {{renewalDate}}",
  "product_info.renewal_frequency": "Fornyes {{frequency}}",
  "product_info.continues_until_cancelled": "Fortsætter indtil annulleret",
  "product_info.cancel_anytime": "Annuller når som helst",
  "payment_entry_page.payment_step_title": "Sikker betaling via RevenueCat",
  "payment_entry_page.button_pay": "Betal nu",
  "payment_entry_page.button_start_trial": "Start prøveperiode",
  "success_page.purchase_successful": "Betaling gennemført",
  "success_page.button_close": "Fortsæt",
  "error_page.if_error_persists": "Hvis fejlen fortsætter, kontakt venligst ",
  "error_page.error_title_already_subscribed": "Du abonnerer allerede på {{productTitle}}",
  "error_page.error_title_already_purchased": "Du har allerede købt {{productTitle}}",
  "error_page.error_title_other_errors": "Noget gik galt",
  "error_page.error_message_already_subscribed": "Du kan ikke abonnere på dette produkt igen.",
  "error_page.error_message_already_purchased": "Du kan ikke købe dette produkt igen.",
  "error_page.error_message_missing_email_error": "Email er påkrævet for at gennemføre købet.",
  "error_page.error_message_network_error": "Netværksfejl. Kontroller din internetforbindelse.",
  "error_page.error_message_error_charging_payment": "Betalingen mislykkedes.",
  "error_page.error_message_error_setting_up_purchase": "Køb ikke startet på grund af en fejl (fejlkode: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Vi kunne ikke bekræfte din faktureringsadresse. Kontroller venligst, at postnummeret og landet er korrekte.",
  "error_page.error_message_unknown_error": "Der opstod en ukendt fejl (fejlkode: {{errorCode}}).",
  "error_page.button_try_again": "Prøv igen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Samlet beløb for i dag",
  "product_info.subscribe_to": "Abonner på",
  "navbar_header.details": "Detaljer",
  "navbar_header.back_button": "Tilbage",
  "pricing_dropdown.show_details": "Vis detaljer",
  "pricing_dropdown.hide_details": "Skjul detaljer",
  "pricing_table.tax": "Moms",
  "pricing_table.trial_ends": "Efter prøveperioden slutter, den {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Samlet beløb forfalden i dag",
  "pricing_table.total_excluding_tax": "Samlet beløb eksklusive moms",
  "pricing_table.enter_billing_address_to_calculate": "Indtast faktureringsadresse for at beregne",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Indtast stat eller postnummer for at beregne",
  "pricing_table.enter_postal_code_to_calculate": "Indtast postnummer for at beregne",
  "error_page.error_message_invalid_email_error": "E-mailadressen {{email}} kunne ikke bekræftes. Angiv en gyldig e-mailadresse.",
  "payment_entry_page.button_payment_method": "Betal {{formattedPrice}} med {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Betal {{formattedPrice}}",
  "price_update.title": "Prisopdatering",
  "price_update.base_message": "Den samlede pris er blevet opdateret med moms baseret på din faktureringsadresse. Gennemgå og prøv igen. Dit kort vil kun blive debiteret én gang.",
  "price_update.trial_message": "Abonnementsprisen er opdateret for at inkludere skatter baseret på din faktureringsadresse. Den gratis prøveperiode gælder stadig. Kontroller venligst og prøv igen.",
  "payment_entry_page.express_checkout_divider": "ELLER BETAL MED KORT",
  "error_page.trouble_accessing": "Hvis du har problemer med at få adgang til dit køb, kan du kontakte support på ",
  "error_page.close_button_title": "Gå til {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Manglende Stripe-tilladelse",
  "error_page.button_close": "Luk",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Købet mislykkedes, fordi skatteoprindelsesadressen er ugyldig. I produktion vil køb fungere uden påførte skatter.",
  "error_page.error_message_stripe_tax_not_active": "Købet mislykkedes, fordi Stripe Tax ikke er aktiveret. I produktion vil køb fungere uden påførte skatter.",
  "error_page.error_only_in_sandbox": "Denne meddelelse vises kun i sandkassen.",
  "error_page.error_message_stripe_missing_required_permission": "Købet mislykkedes, fordi Stripe-appen mangler en påkrævet tilladelse. I produktion vil køb fungere uden påførte skatter.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax er ikke aktiv",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Ugyldig skatteoprindelsesadresse",
  "apple_pay.free_trial": "Gratis prøveperiode",
  "product_info.price_after_intro_price": "Efter {{introPriceDuration}}, den {{renewalDate}}",
  "product_info.after_trial": "efter prøveperiode",
  "product_info.after": "efter",
  "product_info.intro_price_phase_after_trial": "Derefter {{introPriceDuration}} for {{introPrice}}",
  "product_info.intro_price_phase": "Først {{introPriceDuration}} for {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "betales én gang",
  "payment_entry_page.trial_subscription_terms_info": "Efter din prøveperiode slutter, vil du blive opkrævet {{price}} {{perFrequency}} fra og med {{renewalDate}}. Du kan opsige når som helst før denne dato.",
  "payment_entry_page.subscription_info": "Abonnementet fornys automatisk. Opsig når som helst.",
  "payment_entry_page.otp_terms_info": "Ved at købe accepterer du, at {{appName}} kan debitere dig i overensstemmelse med deres vilkår.",
  "payment_entry_page.terms_link_label": "Vilkår",
  "payment_entry_page.subscription_terms_info": "Ved at abonnere accepterer du, at {{appName}} kan opkræve dig i henhold til deres vilkår, indtil du opsiger.",
  "loading_page.keep_page_open": "Processen er næsten færdig. Hold denne side åben.",
  "loading_page.processing_payment": "Behandler betaling",
  "pricing_table.discount": "Rabat",
  "pricing_table.subtotal": "Subtotal"
}, Eg = {
  "periods.week": "{{amount}} week",
  "periods.month": "{{amount}} maand",
  "periods.year": "{{amount}} jaar",
  "periods.day": "{{amount}} dag",
  "periods.weekShort": "{{amount}}wk",
  "periods.monthShort": "{{amount}}maand",
  "periods.yearShort": "{{amount}}jr",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "levenslang",
  "periods.weekPlural": "{{amount}} weken",
  "periods.monthPlural": "{{amount}} maanden",
  "periods.yearPlural": "{{amount}} jaren",
  "periods.dayPlural": "{{amount}} dagen",
  "periods.weekFrequency": "wekelijks",
  "periods.monthFrequency": "maandelijks",
  "periods.yearFrequency": "jaarlijks",
  "periods.dayFrequency": "dagelijks",
  "periods.perWeekFrequency": "per week",
  "periods.perMonthFrequency": "per maand",
  "periods.perYearFrequency": "per jaar",
  "periods.perDayFrequency": "per dag",
  "periods.unknownFrequency": "onbekend",
  "periods.weekFrequencyPlural": "elke {{amount}} weken",
  "periods.monthFrequencyPlural": "elke {{amount}} maanden",
  "periods.yearFrequencyPlural": "elke {{amount}} jaren",
  "periods.dayFrequencyPlural": "elke {{amount}} dagen",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} gratis proefperiode",
  "product_info.price_after_free_trial": "Na afloop van de proefperiode, op {{renewalDate}}",
  "product_info.renewal_frequency": "Wordt verlengd {{frequency}}",
  "product_info.continues_until_cancelled": "Wordt voortgezet tot annulering",
  "product_info.cancel_anytime": "Annuleer op elk gewenst moment",
  "payment_entry_page.payment_step_title": "Veilige afrekening via RevenueCat",
  "payment_entry_page.button_pay": "Nu betalen",
  "payment_entry_page.button_start_trial": "Start proefperiode",
  "success_page.purchase_successful": "Betaling voltooid",
  "success_page.button_close": "Doorgaan",
  "error_page.if_error_persists": "Neem contact op met  als de fout aanhoudt",
  "error_page.error_title_already_subscribed": "Je bent al geabonneerd op {{productTitle}}",
  "error_page.error_title_already_purchased": "Je hebt {{productTitle}} al gekocht",
  "error_page.error_title_other_errors": "Er is iets misgegaan",
  "error_page.error_message_already_subscribed": "Je kunt je niet opnieuw abonneren op dit product.",
  "error_page.error_message_already_purchased": "Je kunt dit product niet opnieuw kopen.",
  "error_page.error_message_missing_email_error": "Een e-mailadres is vereist om de aankoop te voltooien.",
  "error_page.error_message_network_error": "Netwerkfout. Controleer uw internetverbinding.",
  "error_page.error_message_error_charging_payment": "Betaling mislukt.",
  "error_page.error_message_error_setting_up_purchase": "Aankoop niet gestart vanwege een fout (foutcode: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "We konden uw factuuradres niet verifiëren. Controleer of de postcode en het land correct zijn.",
  "error_page.error_message_unknown_error": "Er is een onbekende fout opgetreden (foutcode: {{errorCode}}).",
  "error_page.button_try_again": "Opnieuw proberen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Totaal te betalen vandaag",
  "product_info.subscribe_to": "Abonneren op",
  "navbar_header.details": "Details",
  "navbar_header.back_button": "Terug",
  "pricing_dropdown.show_details": "Toon details",
  "pricing_dropdown.hide_details": "Verberg details",
  "pricing_table.tax": "Btw",
  "pricing_table.trial_ends": "Na afloop van de proefperiode, op {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Totaal vandaag te betalen",
  "pricing_table.total_excluding_tax": "Totaal exclusief btw",
  "pricing_table.enter_billing_address_to_calculate": "Voer het factuuradres in om te berekenen",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Voer provincie of postcode in om te berekenen",
  "pricing_table.enter_postal_code_to_calculate": "Voer postcode in om te berekenen",
  "error_page.error_message_invalid_email_error": "Het e-mailadres {{email}} kon niet worden geverifieerd. Geef een geldig e-mailadres op.",
  "payment_entry_page.button_payment_method": "Betaal {{formattedPrice}} met {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Betaal {{formattedPrice}}",
  "price_update.title": "Prijsupdate",
  "price_update.base_message": "De totale prijs is bijgewerkt met belasting op basis van uw factuuradres. Controleer en probeer het opnieuw. Uw kaart wordt slechts één keer belast.",
  "price_update.trial_message": "De abonnementsprijs is bijgewerkt om belastingen op te nemen op basis van uw factuuradres. De gratis proefperiode blijft van toepassing. Controleer en probeer het opnieuw.",
  "payment_entry_page.express_checkout_divider": "OF BETAAL MET EEN KAART",
  "error_page.trouble_accessing": "Als je problemen hebt met het verkrijgen van toegang tot je aankoop, neem dan contact op met de ondersteuning via ",
  "error_page.close_button_title": "Ga naar {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Ontbrekende Stripe-toestemming",
  "error_page.button_close": "Sluiten",
  "error_page.error_message_stripe_invalid_tax_origin_address": "De aankoop is mislukt omdat het belastingoorsprongadres ongeldig is. In productie werken aankopen zonder toegepaste belastingen.",
  "error_page.error_message_stripe_tax_not_active": "De aankoop is mislukt omdat Stripe Tax niet is ingeschakeld. In productie werken aankopen zonder toegepaste belastingen.",
  "error_page.error_only_in_sandbox": "Dit bericht verschijnt alleen in de sandbox.",
  "error_page.error_message_stripe_missing_required_permission": "De aankoop is mislukt omdat de Stripe-app een vereiste toestemming mist. In productie werken aankopen zonder toegepaste belastingen.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax niet actief",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Ongeldig belastingoorsprongadres",
  "apple_pay.free_trial": "Gratis proefperiode",
  "product_info.price_after_intro_price": "Na {{introPriceDuration}}, op {{renewalDate}}",
  "product_info.after_trial": "na proefperiode",
  "product_info.after": "na",
  "product_info.intro_price_phase_after_trial": "Daarna {{introPriceDuration}} voor {{introPrice}}",
  "product_info.intro_price_phase": "Eerst {{introPriceDuration}} voor {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "eenmalig betaald",
  "payment_entry_page.trial_subscription_terms_info": "Na afloop van uw proefperiode wordt {{price}} {{perFrequency}} in rekening gebracht, beginnend op {{renewalDate}}. U kunt op elk moment vóór deze datum annuleren.",
  "payment_entry_page.subscription_info": "Abonnement wordt automatisch verlengd. Annuleer op elk moment.",
  "payment_entry_page.otp_terms_info": "Door de aankoop ga je ermee akkoord dat {{appName}} kosten in rekening brengt volgens hun voorwaarden.",
  "payment_entry_page.terms_link_label": "Voorwaarden",
  "payment_entry_page.subscription_terms_info": "Door u te abonneren, stemt u ermee in dat {{appName}} u kosten in rekening brengt volgens hun voorwaarden totdat u annuleert.",
  "loading_page.keep_page_open": "Het proces is bijna voltooid. Houd deze pagina open.",
  "loading_page.processing_payment": "Betaling verwerken",
  "pricing_table.discount": "Korting",
  "pricing_table.subtotal": "Subtotaal"
}, Sg = {
  "periods.week": "{{amount}} viikko",
  "periods.month": "{{amount}} kuukausi",
  "periods.year": "{{amount}} vuosi",
  "periods.day": "{{amount}} päivä",
  "periods.weekShort": "{{amount}}vk",
  "periods.monthShort": "{{amount}}kk",
  "periods.yearShort": "{{amount}}v",
  "periods.dayShort": "{{amount}}p",
  "periods.lifetime": "elämäaika",
  "periods.weekPlural": "{{amount}} viikkoa",
  "periods.monthPlural": "{{amount}} kuukautta",
  "periods.yearPlural": "{{amount}} vuotta",
  "periods.dayPlural": "{{amount}} päivää",
  "periods.weekFrequency": "viikoittain",
  "periods.monthFrequency": "kuukausittain",
  "periods.yearFrequency": "vuosittain",
  "periods.dayFrequency": "päivittäin",
  "periods.perWeekFrequency": "viikossa",
  "periods.perMonthFrequency": "kuukaudessa",
  "periods.perYearFrequency": "vuodessa",
  "periods.perDayFrequency": "päivässä",
  "periods.unknownFrequency": "tuntematon",
  "periods.weekFrequencyPlural": "joka {{amount}} viikko",
  "periods.monthFrequencyPlural": "joka {{amount}} kuukausi",
  "periods.yearFrequencyPlural": "joka {{amount}} vuosi",
  "periods.dayFrequencyPlural": "joka {{amount}} päivä",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} ilmainen kokeilujakso",
  "product_info.price_after_free_trial": "Kokeilujakson päätyttyä, {{renewalDate}}",
  "product_info.renewal_frequency": "Uusiutuu {{frequency}}",
  "product_info.continues_until_cancelled": "Jatkuu, kunnes peruutetaan",
  "product_info.cancel_anytime": "Peruuta milloin tahansa",
  "payment_entry_page.payment_step_title": "Suojautunut kassatoiminto RevenueCatin kautta",
  "payment_entry_page.button_pay": "Maksa nyt",
  "payment_entry_page.button_start_trial": "Aloita kokeilujakso",
  "success_page.purchase_successful": "Maksaminen onnistui",
  "success_page.button_close": "Jatka",
  "error_page.if_error_persists": "Jos virhe jatkuu, ota yhteyttä ",
  "error_page.error_title_already_subscribed": "Olet jo tilannut tuotteen {{productTitle}}",
  "error_page.error_title_already_purchased": "Olet jo ostanut tuotteen {{productTitle}}",
  "error_page.error_title_other_errors": "Jokin meni pieleen",
  "error_page.error_message_already_subscribed": "Et voi tilata tätä tuotetta uudelleen.",
  "error_page.error_message_already_purchased": "Et voi ostaa tätä tuotetta uudelleen.",
  "error_page.error_message_missing_email_error": "Sähköpostiosoite tarvitaan ostoksen loppuun saattamiseksi.",
  "error_page.error_message_network_error": "Verkkovirhe. Tarkista internet-yhteytesi.",
  "error_page.error_message_error_charging_payment": "Maksaminen epäonnistui.",
  "error_page.error_message_error_setting_up_purchase": "Ostoa ei aloitettu virheen vuoksi (virhekoodi: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Emme voineet vahvistaa laskutusosoitettasi. Tarkista, että postinumero ja maa ovat oikein.",
  "error_page.error_message_unknown_error": "Tapahtui tuntematon virhe (virhekoodi: {{errorCode}}).",
  "error_page.button_try_again": "Yritä uudelleen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Maksettava summa tänään",
  "product_info.subscribe_to": "Tilaa",
  "navbar_header.details": "Yksityiskohdat",
  "navbar_header.back_button": "Takaisin",
  "pricing_dropdown.show_details": "Näytä tiedot",
  "pricing_dropdown.hide_details": "Piilota tiedot",
  "pricing_table.tax": "Vero",
  "pricing_table.trial_ends": "Kokeilujakson päätyttyä, {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Maksettava summa tänään",
  "pricing_table.total_excluding_tax": "Veroton kokonaissumma",
  "pricing_table.enter_billing_address_to_calculate": "Syötä laskutusosoite laskeaksesi",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Syötä osavaltio tai postinumero laskeaksesi",
  "pricing_table.enter_postal_code_to_calculate": "Syötä postinumero laskeaksesi",
  "error_page.error_message_invalid_email_error": "Sähköpostiosoitetta {{email}} ei voitu vahvistaa. Anna kelvollinen sähköpostiosoite.",
  "payment_entry_page.button_payment_method": "Maksa {{formattedPrice}} käyttämällä {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Maksa {{formattedPrice}}",
  "price_update.title": "Hinnan päivitys",
  "price_update.base_message": "Kokonaishinta on päivitetty verolla laskutusosoitteesi perusteella. Tarkista ja yritä uudelleen. Korttiasi veloitetaan vain kerran.",
  "price_update.trial_message": "Tilauksen hinta on päivitetty sisältämään verot laskutusosoitteesi perusteella. Ilmainen kokeilujakso on edelleen voimassa. Tarkista ja yritä uudelleen.",
  "payment_entry_page.express_checkout_divider": "TAI MAKSA KORTILLA",
  "error_page.trouble_accessing": "Jos sinulla on ongelmia ostoksesi käyttämisessä, ota yhteyttä tukeen osoitteessa ",
  "error_page.close_button_title": "Siirry sovellukseen {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Puuttuva Stripe-käyttöoikeus",
  "error_page.button_close": "Sulje",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Osto epäonnistui, koska veron alkuperäosoite on virheellinen. Tuotantoympäristössä ostot toimivat ilman veroja.",
  "error_page.error_message_stripe_tax_not_active": "Osto epäonnistui, koska Stripe Tax ei ole käytössä. Tuotantoympäristössä ostot toimivat ilman veroja.",
  "error_page.error_only_in_sandbox": "Tämä viesti näkyy vain hiekkalaatikossa.",
  "error_page.error_message_stripe_missing_required_permission": "Osto epäonnistui, koska Stripe-sovellukselta puuttuu vaadittu käyttöoikeus. Tuotantoympäristössä ostot toimivat ilman veroja.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax ei ole aktiivinen",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Virheellinen veron alkuperäosoite",
  "apple_pay.free_trial": "Ilmainen kokeilu",
  "product_info.price_after_intro_price": "{{introPriceDuration}} jälkeen, {{renewalDate}}",
  "product_info.after_trial": "kokeilujakson jälkeen",
  "product_info.after": "jälkeen",
  "product_info.intro_price_phase_after_trial": "Sitten {{introPriceDuration}} hintaan {{introPrice}}",
  "product_info.intro_price_phase": "Ensimmäiset {{introPriceDuration}} hintaan {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "maksetaan kerran",
  "payment_entry_page.trial_subscription_terms_info": "Kokeilujakson päätyttyä sinulta veloitetaan {{price}} {{perFrequency}} alkaen {{renewalDate}}. Voit peruuttaa milloin tahansa ennen tätä päivämäärää.",
  "payment_entry_page.subscription_info": "Tilaus uusiutuu automaattisesti. Peruuta milloin tahansa.",
  "payment_entry_page.otp_terms_info": "Ostamalla hyväksyt, että {{appName}} veloittaa sinua heidän ehtojensa mukaisesti.",
  "payment_entry_page.terms_link_label": "Ehdot",
  "payment_entry_page.subscription_terms_info": "Tilaamalla hyväksyt, että {{appName}} veloittaa sinulta ehtojensa mukaisesti, kunnes peruutat tilauksen.",
  "loading_page.keep_page_open": "Prosessi on melkein valmis. Pidä tämä sivu auki.",
  "loading_page.processing_payment": "Maksua käsitellään",
  "pricing_table.discount": "Alennus",
  "pricing_table.subtotal": "Välisumma"
}, Ig = {
  "periods.week": "{{amount}} semaine",
  "periods.month": "{{amount}} mois",
  "periods.year": "{{amount}} an",
  "periods.day": "{{amount}} jour",
  "periods.weekShort": "{{amount}}sem",
  "periods.monthShort": "{{amount}}mois",
  "periods.yearShort": "{{amount}}an",
  "periods.dayShort": "{{amount}}j",
  "periods.lifetime": "à vie",
  "periods.weekPlural": "{{amount}} semaines",
  "periods.monthPlural": "{{amount}} mois",
  "periods.yearPlural": "{{amount}} ans",
  "periods.dayPlural": "{{amount}} jours",
  "periods.weekFrequency": "hebdomadaire",
  "periods.monthFrequency": "mensuel",
  "periods.yearFrequency": "annuel",
  "periods.dayFrequency": "quotidien",
  "periods.perWeekFrequency": "par semaine",
  "periods.perMonthFrequency": "par mois",
  "periods.perYearFrequency": "par an",
  "periods.perDayFrequency": "par jour",
  "periods.unknownFrequency": "inconnu",
  "periods.weekFrequencyPlural": "toutes les {{amount}} semaines",
  "periods.monthFrequencyPlural": "tous les {{amount}} mois",
  "periods.yearFrequencyPlural": "tous les {{amount}} ans",
  "periods.dayFrequencyPlural": "tous les {{amount}} jours",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} essai gratuit",
  "product_info.price_after_free_trial": "Après la fin de l'essai, le {{renewalDate}}",
  "product_info.renewal_frequency": "Renouvellement {{frequency}}",
  "product_info.continues_until_cancelled": "Continue jusqu'à annulation",
  "product_info.cancel_anytime": "Annulez à tout moment",
  "payment_entry_page.payment_step_title": "Paiement sécurisé par RevenueCat",
  "payment_entry_page.button_pay": "Payer maintenant",
  "payment_entry_page.button_start_trial": "Commencer l'essai",
  "success_page.purchase_successful": "Paiement effectué",
  "success_page.button_close": "Continuer",
  "error_page.if_error_persists": "Si l'erreur persiste, veuillez contacter ",
  "error_page.error_title_already_subscribed": "Vous êtes déjà abonné à {{productTitle}}",
  "error_page.error_title_already_purchased": "Vous avez déjà acheté {{productTitle}}",
  "error_page.error_title_other_errors": "Une erreur s'est produite",
  "error_page.error_message_already_subscribed": "Vous ne pouvez pas vous abonner à nouveau à ce produit.",
  "error_page.error_message_already_purchased": "Vous ne pouvez pas acheter ce produit à nouveau.",
  "error_page.error_message_missing_email_error": "L'adresse e-mail est requise pour effectuer l'achat.",
  "error_page.error_message_network_error": "Erreur réseau. Veuillez vérifier votre connexion Internet.",
  "error_page.error_message_error_charging_payment": "Échec du paiement.",
  "error_page.error_message_error_setting_up_purchase": "L'achat n'a pas pu démarrer en raison d'une erreur (code d'erreur : {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nous n'avons pas pu vérifier votre adresse de facturation. Veuillez vérifier que le code postal et le pays sont corrects.",
  "error_page.error_message_unknown_error": "Une erreur inconnue s'est produite (code d'erreur : {{errorCode}}).",
  "error_page.button_try_again": "Réessayer",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Total dû aujourd'hui",
  "product_info.subscribe_to": "S'abonner à",
  "navbar_header.details": "Détails",
  "navbar_header.back_button": "Retour",
  "pricing_dropdown.show_details": "Afficher les détails",
  "pricing_dropdown.hide_details": "Masquer les détails",
  "pricing_table.tax": "Taxe",
  "pricing_table.trial_ends": "Après la fin de l'essai, le {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total dû aujourd'hui",
  "pricing_table.total_excluding_tax": "Total hors taxes",
  "pricing_table.enter_billing_address_to_calculate": "Saisir l'adresse de facturation pour calculer",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Entrez l'état ou le code postal pour calculer",
  "pricing_table.enter_postal_code_to_calculate": "Entrez le code postal pour calculer",
  "error_page.error_message_invalid_email_error": "L'adresse e-mail {{email}} n'a pas pu être vérifiée. Veuillez fournir une adresse e-mail valide.",
  "payment_entry_page.button_payment_method": "Payer {{formattedPrice}} avec {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Payer {{formattedPrice}}",
  "price_update.title": "Mise à jour du prix",
  "price_update.base_message": "Le prix total a été mis à jour avec la taxe en fonction de votre adresse de facturation. Veuillez vérifier et réessayer. Votre carte ne sera débitée qu'une seule fois.",
  "price_update.trial_message": "Le prix de l'abonnement a été mis à jour pour inclure les taxes en fonction de votre adresse de facturation. La période d'essai gratuit reste applicable. Veuillez vérifier et réessayer.",
  "payment_entry_page.express_checkout_divider": "OU PAYER PAR CARTE",
  "error_page.trouble_accessing": "Si vous avez des difficultés à accéder à votre achat, contactez le support à l'adresse suivante : ",
  "error_page.close_button_title": "Aller sur {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Autorisation Stripe manquante",
  "error_page.button_close": "Fermer",
  "error_page.error_message_stripe_invalid_tax_origin_address": "L'achat a échoué car l'adresse d'origine de la taxe n'est pas valide. En production, les achats fonctionneront sans taxes appliquées.",
  "error_page.error_message_stripe_tax_not_active": "L'achat a échoué car Stripe Tax n'est pas activé. En production, les achats fonctionneront sans taxes appliquées.",
  "error_page.error_only_in_sandbox": "Ce message apparaît uniquement dans l'environnement de test.",
  "error_page.error_message_stripe_missing_required_permission": "L'achat a échoué car l'application Stripe ne dispose pas d'une autorisation requise. En production, les achats fonctionneront sans taxes appliquées.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax non actif",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Adresse d'origine de la taxe non valide",
  "apple_pay.free_trial": "Essai gratuit",
  "product_info.price_after_intro_price": "Après {{introPriceDuration}}, le {{renewalDate}}",
  "product_info.after_trial": "après l'essai",
  "product_info.after": "après",
  "product_info.intro_price_phase_after_trial": "Puis {{introPriceDuration}} pour {{introPrice}}",
  "product_info.intro_price_phase": "{{introPriceDuration}} pour {{introPrice}} au départ",
  "product_info.intro_price_phase_paid_once": "payé une fois",
  "payment_entry_page.trial_subscription_terms_info": "Après la fin de votre essai, vous serez facturé {{price}} {{perFrequency}} à partir du {{renewalDate}}. Vous pouvez annuler à tout moment avant cette date.",
  "payment_entry_page.subscription_info": "L'abonnement est renouvelé automatiquement. Annulez à tout moment.",
  "payment_entry_page.otp_terms_info": "En achetant, vous acceptez d'autoriser {{appName}} à vous facturer conformément à ses conditions.",
  "payment_entry_page.terms_link_label": "Conditions",
  "payment_entry_page.subscription_terms_info": "En vous abonnant, vous acceptez d'autoriser {{appName}} à vous facturer conformément à ses conditions jusqu'à ce que vous annuliez.",
  "loading_page.keep_page_open": "Le processus est presque terminé. Veuillez garder cette page ouverte.",
  "loading_page.processing_payment": "Paiement en cours",
  "pricing_table.discount": "Remise",
  "pricing_table.subtotal": "Sous-total"
}, Tg = {
  "periods.week": "{{amount}} Woche",
  "periods.month": "{{amount}} Monat",
  "periods.year": "{{amount}} Jahr",
  "periods.day": "{{amount}} Tag",
  "periods.weekShort": "{{amount}}Wo",
  "periods.monthShort": "{{amount}}Mo",
  "periods.yearShort": "{{amount}}J",
  "periods.dayShort": "{{amount}}T",
  "periods.lifetime": "lebenslang",
  "periods.weekPlural": "{{amount}} Wochen",
  "periods.monthPlural": "{{amount}} Monate",
  "periods.yearPlural": "{{amount}} Jahre",
  "periods.dayPlural": "{{amount}} Tage",
  "periods.weekFrequency": "wöchentlich",
  "periods.monthFrequency": "monatlich",
  "periods.yearFrequency": "jährlich",
  "periods.dayFrequency": "täglich",
  "periods.perWeekFrequency": "pro Woche",
  "periods.perMonthFrequency": "pro Monat",
  "periods.perYearFrequency": "pro Jahr",
  "periods.perDayFrequency": "pro Tag",
  "periods.unknownFrequency": "unbekannt",
  "periods.weekFrequencyPlural": "alle {{amount}} Wochen",
  "periods.monthFrequencyPlural": "alle {{amount}} Monate",
  "periods.yearFrequencyPlural": "alle {{amount}} Jahre",
  "periods.dayFrequencyPlural": "alle {{amount}} Tage",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} kostenlose Testversion",
  "product_info.price_after_free_trial": "Nach Ablauf der Testversion, am {{renewalDate}}",
  "product_info.renewal_frequency": "Verlängert sich {{frequency}}",
  "product_info.continues_until_cancelled": "Läuft bis zur Kündigung",
  "product_info.cancel_anytime": "Jederzeit kündbar",
  "payment_entry_page.payment_step_title": "Sicherer Checkout über RevenueCat",
  "payment_entry_page.button_pay": "Jetzt bezahlen",
  "payment_entry_page.button_start_trial": "Testversion starten",
  "success_page.purchase_successful": "Zahlung abgeschlossen",
  "success_page.button_close": "Weiter",
  "error_page.if_error_persists": "Wenn der Fehler weiterhin besteht, wenden Sie sich bitte an ",
  "error_page.error_title_already_subscribed": "Du hast {{productTitle}} bereits abonniert",
  "error_page.error_title_already_purchased": "Du hast {{productTitle}} bereits gekauft",
  "error_page.error_title_other_errors": "Etwas ist schief gelaufen",
  "error_page.error_message_already_subscribed": "Du kannst dieses Produkt nicht erneut abonnieren.",
  "error_page.error_message_already_purchased": "Du kannst dieses Produkt nicht erneut kaufen.",
  "error_page.error_message_missing_email_error": "Für den Kauf ist eine E-Mail-Adresse erforderlich.",
  "error_page.error_message_network_error": "Netzwerkfehler. Bitte überprüfen Sie Ihre Internetverbindung.",
  "error_page.error_message_error_charging_payment": "Zahlung fehlgeschlagen.",
  "error_page.error_message_error_setting_up_purchase": "Der Kauf wurde aufgrund eines Fehlers nicht gestartet (Fehlercode: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Wir konnten Ihre Rechnungsadresse nicht überprüfen. Bitte überprüfen Sie, ob die Postleitzahl und das Land korrekt sind.",
  "error_page.error_message_unknown_error": "Ein unbekannter Fehler ist aufgetreten (Fehlercode: {{errorCode}}).",
  "error_page.button_try_again": "Erneut versuchen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Heute fälliger Gesamtbetrag",
  "product_info.subscribe_to": "Abonnieren",
  "navbar_header.details": "Details",
  "navbar_header.back_button": "Zurück",
  "pricing_dropdown.show_details": "Details anzeigen",
  "pricing_dropdown.hide_details": "Details ausblenden",
  "pricing_table.tax": "Steuer",
  "pricing_table.trial_ends": "Nach Ablauf der Testphase, am {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Heute fälliger Gesamtbetrag",
  "pricing_table.total_excluding_tax": "Gesamtbetrag ohne Steuer",
  "pricing_table.enter_billing_address_to_calculate": "Rechnungsadresse eingeben, um zu berechnen",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Bundesland oder Postleitzahl zur Berechnung eingeben",
  "pricing_table.enter_postal_code_to_calculate": "Postleitzahl zur Berechnung eingeben",
  "error_page.error_message_invalid_email_error": "Die E-Mail-Adresse {{email}} konnte nicht verifiziert werden. Bitte gib eine gültige E-Mail-Adresse an.",
  "payment_entry_page.button_payment_method": "Mit {{paymentMethod}} für {{formattedPrice}} bezahlen",
  "payment_entry_page.button_with_price": "{{formattedPrice}} bezahlen",
  "price_update.title": "Preisaktualisierung",
  "price_update.base_message": "Der Gesamtpreis wurde basierend auf Ihrer Rechnungsadresse mit Steuern aktualisiert. Bitte überprüfen Sie ihn und versuchen Sie es erneut. Ihre Karte wird erst belastet, wenn alles korrekt ist.",
  "price_update.trial_message": "Der Abonnementpreis wurde aktualisiert, um Steuern basierend auf Ihrer Rechnungsadresse einzuschließen. Die kostenlose Testphase gilt weiterhin. Bitte überprüfen Sie und versuchen Sie es erneut.",
  "payment_entry_page.express_checkout_divider": "ODER MIT KARTE ZAHLEN",
  "error_page.trouble_accessing": "Wenn Sie Probleme beim Zugriff auf Ihren Kauf haben, wenden Sie sich an den Support unter ",
  "error_page.close_button_title": "Zu {{appName}} gehen",
  "error_page.error_title_stripe_missing_required_permission": "Fehlende Stripe-Berechtigung",
  "error_page.button_close": "Schließen",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Der Kauf ist fehlgeschlagen, da die Steuerursprungsadresse ungültig ist. In der Produktion funktionieren Käufe ohne angewendete Steuern.",
  "error_page.error_message_stripe_tax_not_active": "Der Kauf ist fehlgeschlagen, da Stripe Tax nicht aktiviert ist. In der Produktion funktionieren Käufe ohne angewendete Steuern.",
  "error_page.error_only_in_sandbox": "Diese Meldung wird nur in der Sandbox angezeigt.",
  "error_page.error_message_stripe_missing_required_permission": "Der Kauf ist fehlgeschlagen, da der Stripe-App eine erforderliche Berechtigung fehlt. In der Produktion funktionieren Käufe ohne angewendete Steuern.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax ist nicht aktiv",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Ungültige Steuerursprungsadresse",
  "apple_pay.free_trial": "Kostenlose Testversion",
  "product_info.price_after_intro_price": "Nach {{introPriceDuration}}, am {{renewalDate}}",
  "product_info.after_trial": "nach Testphase",
  "product_info.after": "nach",
  "product_info.intro_price_phase_after_trial": "Danach {{introPriceDuration}} für {{introPrice}}",
  "product_info.intro_price_phase": "Zuerst {{introPriceDuration}} für {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "einmalig bezahlt",
  "payment_entry_page.trial_subscription_terms_info": "Nach Ablauf Ihres Testzeitraums werden Ihnen {{price}} {{perFrequency}} ab dem {{renewalDate}} berechnet. Sie können jederzeit vor diesem Datum kündigen.",
  "payment_entry_page.subscription_info": "Das Abonnement verlängert sich automatisch. Jederzeit kündbar.",
  "payment_entry_page.otp_terms_info": "Mit dem Kauf erklären Sie sich einverstanden, dass {{appName}} Ihnen Gebühren gemäß ihren Bedingungen berechnet.",
  "payment_entry_page.terms_link_label": "Bedingungen",
  "payment_entry_page.subscription_terms_info": "Mit dem Abonnieren erklären Sie sich damit einverstanden, dass {{appName}} Ihnen gemäß ihren Bedingungen Gebühren berechnet, bis Sie kündigen.",
  "loading_page.keep_page_open": "Der Vorgang ist fast abgeschlossen. Bitte lassen Sie diese Seite geöffnet.",
  "loading_page.processing_payment": "Zahlung wird verarbeitet",
  "pricing_table.discount": "Rabatt",
  "pricing_table.subtotal": "Zwischensumme"
}, Cg = {
  "periods.week": "{{amount}} εβδομάδα",
  "periods.month": "{{amount}} μήνας",
  "periods.year": "{{amount}} χρόνος",
  "periods.day": "{{amount}} ημέρα",
  "periods.weekShort": "{{amount}} εβδ.",
  "periods.monthShort": "{{amount}} μήν.",
  "periods.yearShort": "{{amount}} έτ.",
  "periods.dayShort": "{{amount}} ημ.",
  "periods.lifetime": "διάρκεια ζωής",
  "periods.weekPlural": "{{amount}} εβδομάδες",
  "periods.monthPlural": "{{amount}} μήνες",
  "periods.yearPlural": "{{amount}} χρόνια",
  "periods.dayPlural": "{{amount}} ημέρες",
  "periods.weekFrequency": "εβδομαδιαία",
  "periods.monthFrequency": "μηνιαία",
  "periods.yearFrequency": "ετήσια",
  "periods.dayFrequency": "καθημερινά",
  "periods.perWeekFrequency": "ανά εβδομάδα",
  "periods.perMonthFrequency": "ανά μήνα",
  "periods.perYearFrequency": "ανά έτος",
  "periods.perDayFrequency": "ανά ημέρα",
  "periods.unknownFrequency": "άγνωστο",
  "periods.weekFrequencyPlural": "κάθε {{amount}} εβδομάδες",
  "periods.monthFrequencyPlural": "κάθε {{amount}} μήνες",
  "periods.yearFrequencyPlural": "κάθε {{amount}} χρόνια",
  "periods.dayFrequencyPlural": "κάθε {{amount}} ημέρες",
  "product_info.subscribe_to": "Εγγραφείτε στο",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "Δωρεάν για {{trialDuration}}",
  "product_info.price_after_free_trial": "Μετά τη λήξη της δοκιμής, στις {{renewalDate}}",
  "product_info.total_due_today": "Σύνολο πληρωτέο σήμερα",
  "product_info.renewal_frequency": "Ανανεώνεται {{frequency}}",
  "product_info.continues_until_cancelled": "Συνεχίζεται μέχρι την ακύρωση",
  "product_info.cancel_anytime": "Ακύρωση ανά πάσα στιγμή",
  "payment_entry_page.payment_step_title": "Ασφαλής ολοκλήρωση αγοράς από την RevenueCat",
  "payment_entry_page.button_pay": "Πληρωμή τώρα",
  "payment_entry_page.button_start_trial": "Έναρξη δοκιμής",
  "success_page.purchase_successful": "Η πληρωμή ολοκληρώθηκε",
  "success_page.button_close": "Συνέχεια",
  "error_page.if_error_persists": "Εάν το σφάλμα παραμένει, επικοινωνήστε με ",
  "error_page.error_title_already_subscribed": "Έχετε ήδη εγγραφεί στο {{productTitle}}",
  "error_page.error_title_already_purchased": "Έχετε ήδη αγοράσει το {{productTitle}}",
  "error_page.error_title_other_errors": "Κάτι πήγε στραβά",
  "error_page.error_message_already_subscribed": "Δεν μπορείτε να εγγραφείτε ξανά σε αυτό το προϊόν.",
  "error_page.error_message_already_purchased": "Δεν μπορείτε να αγοράσετε ξανά αυτό το προϊόν.",
  "error_page.error_message_missing_email_error": "Απαιτείται email για την ολοκλήρωση της αγοράς.",
  "error_page.error_message_network_error": "Σφάλμα δικτύου. Ελέγξτε τη σύνδεσή σας στο διαδίκτυο.",
  "error_page.error_message_error_charging_payment": "Η πληρωμή απέτυχε.",
  "error_page.error_message_error_setting_up_purchase": "Η αγορά δεν ξεκίνησε λόγω σφάλματος (κωδικός σφάλματος: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Δεν μπορέσαμε να επαληθεύσουμε τη διεύθυνση χρέωσής σας. Παρακαλούμε ελέγξτε ξανά τον ταχυδρομικό κώδικα και τη χώρα για να βεβαιωθείτε ότι είναι σωστά.",
  "error_page.error_message_unknown_error": "Παρουσιάστηκε ένα άγνωστο σφάλμα (κωδικός σφάλματος: {{errorCode}}).",
  "error_page.button_try_again": "Προσπαθήστε ξανά",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "navbar_header.details": "Λεπτομέρειες",
  "navbar_header.back_button": "Πίσω",
  "pricing_dropdown.show_details": "Εμφάνιση λεπτομερειών",
  "pricing_dropdown.hide_details": "Απόκρυψη λεπτομερειών",
  "pricing_table.tax": "Φόρος",
  "pricing_table.trial_ends": "Μετά τη λήξη της δοκιμαστικής περιόδου, στις {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Σύνολο πληρωτέο σήμερα",
  "pricing_table.total_excluding_tax": "Σύνολο χωρίς φόρο",
  "pricing_table.enter_billing_address_to_calculate": "Εισαγάγετε τη διεύθυνση χρέωσης για να υπολογιστεί",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Εισαγάγετε την πολιτεία ή τον ταχυδρομικό κώδικα για να υπολογιστεί",
  "pricing_table.enter_postal_code_to_calculate": "Εισαγάγετε τον ταχυδρομικό κώδικα για να υπολογιστεί",
  "error_page.error_message_invalid_email_error": "Η διεύθυνση email {{email}} δεν μπόρεσε να επαληθευτεί. Παρακαλώ δώστε μια έγκυρη διεύθυνση email.",
  "payment_entry_page.button_payment_method": "Πληρωμή {{formattedPrice}} με {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Πληρωμή {{formattedPrice}}",
  "price_update.title": "Ενημέρωση τιμής",
  "price_update.base_message": "Η συνολική τιμή ενημερώθηκε με τον φόρο βάσει της διεύθυνσης χρέωσής σας. Ελέγξτε και δοκιμάστε ξανά. Η κάρτα σας θα χρεωθεί μόνο μία φορά.",
  "price_update.trial_message": "Η τιμή της συνδρομής ενημερώθηκε για να συμπεριλάβει τους φόρους βάσει της διεύθυνσης χρέωσής σας. Η δωρεάν δοκιμαστική περίοδος εξακολουθεί να ισχύει. Παρακαλώ ελέγξτε και δοκιμάστε ξανά.",
  "payment_entry_page.express_checkout_divider": "Ή ΠΛΗΡΩΣΤΕ ΜΕ ΚΑΡΤΑ",
  "error_page.trouble_accessing": "Εάν αντιμετωπίζετε προβλήματα πρόσβασης στην αγορά σας, επικοινωνήστε με την υποστήριξη στο ",
  "error_page.close_button_title": "Μετάβαση στο {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Λείπει άδεια Stripe",
  "error_page.button_close": "Κλείσιμο",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Η αγορά απέτυχε επειδή η διεύθυνση προέλευσης φόρου δεν είναι έγκυρη. Στην παραγωγή, οι αγορές θα λειτουργούν χωρίς να εφαρμόζονται φόροι.",
  "error_page.error_message_stripe_tax_not_active": "Η αγορά απέτυχε επειδή το Stripe Tax δεν είναι ενεργοποιημένο. Στην παραγωγή, οι αγορές θα λειτουργούν χωρίς να εφαρμόζονται φόροι.",
  "error_page.error_only_in_sandbox": "Αυτό το μήνυμα εμφανίζεται μόνο στο sandbox.",
  "error_page.error_message_stripe_missing_required_permission": "Η αγορά απέτυχε επειδή η εφαρμογή Stripe δεν διαθέτει την απαιτούμενη άδεια. Στην παραγωγή, οι αγορές θα λειτουργούν χωρίς να εφαρμόζονται φόροι.",
  "error_page.error_title_stripe_tax_not_active": "Το Stripe Tax δεν είναι ενεργό",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Μη έγκυρη διεύθυνση προέλευσης φόρου",
  "apple_pay.free_trial": "Δωρεάν δοκιμή",
  "product_info.price_after_intro_price": "Μετά από {{introPriceDuration}}, στις {{renewalDate}}",
  "product_info.after_trial": "μετά τη δοκιμή",
  "product_info.after": "μετά",
  "product_info.intro_price_phase_after_trial": "Έπειτα {{introPriceDuration}} για {{introPrice}}",
  "product_info.intro_price_phase": "Αρχικά {{introPriceDuration}} για {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "πληρωμένο εφάπαξ",
  "payment_entry_page.trial_subscription_terms_info": "Μετά τη λήξη της δοκιμαστικής περιόδου, θα χρεωθείτε {{price}} {{perFrequency}} ξεκινώντας από {{renewalDate}}. Μπορείτε να ακυρώσετε ανά πάσα στιγμή πριν από αυτήν την ημερομηνία.",
  "payment_entry_page.subscription_info": "Η συνδρομή ανανεώνεται αυτόματα. Ακυρώστε ανά πάσα στιγμή.",
  "payment_entry_page.otp_terms_info": "Με την αγορά, συμφωνείτε να επιτρέψετε στην {{appName}} να σας χρεώσει σύμφωνα με τους όρους της.",
  "payment_entry_page.terms_link_label": "Όροι",
  "payment_entry_page.subscription_terms_info": "Με την εγγραφή σας, συμφωνείτε να επιτρέψετε στην εφαρμογή {{appName}} να σας χρεώνει σύμφωνα με τους όρους της έως ότου ακυρώσετε.",
  "loading_page.keep_page_open": "Η διαδικασία σχεδόν ολοκληρώθηκε. Κρατήστε αυτή τη σελίδα ανοιχτή.",
  "loading_page.processing_payment": "Επεξεργασία πληρωμής",
  "pricing_table.discount": "Έκπτωση",
  "pricing_table.subtotal": "Υποσύνολο"
}, Dg = {
  "periods.week": "{{amount}} שבוע",
  "periods.month": "{{amount}} חודש",
  "periods.year": "{{amount}} שנה",
  "periods.day": "{{amount}} יום",
  "periods.weekShort": "{{amount}}wk",
  "periods.monthShort": "{{amount}}mo",
  "periods.yearShort": "{{amount}}yr",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "למשך כל החיים",
  "periods.weekPlural": "{{amount}} שבועות",
  "periods.monthPlural": "{{amount}} חודשים",
  "periods.yearPlural": "{{amount}} שנים",
  "periods.dayPlural": "{{amount}} ימים",
  "periods.weekFrequency": "שבועי",
  "periods.monthFrequency": "חודשי",
  "periods.yearFrequency": "שנתי",
  "periods.dayFrequency": "יומי",
  "periods.perWeekFrequency": "לשבוע",
  "periods.perMonthFrequency": "לחודש",
  "periods.perYearFrequency": "לשנה",
  "periods.perDayFrequency": "ליום",
  "periods.unknownFrequency": "לא ידוע",
  "periods.weekFrequencyPlural": "כל {{amount}} שבועות",
  "periods.monthFrequencyPlural": "כל {{amount}} חודשים",
  "periods.yearFrequencyPlural": "כל {{amount}} שנים",
  "periods.dayFrequencyPlural": "כל {{amount}} ימים",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} ניסיון חינם",
  "product_info.price_after_free_trial": "לאחר סיום הניסיון, ב-{{renewalDate}}",
  "product_info.renewal_frequency": "מתחדש {{frequency}}",
  "product_info.continues_until_cancelled": "נמשך עד ביטול",
  "product_info.cancel_anytime": "ניתן לבטל בכל עת",
  "payment_entry_page.payment_step_title": "קופה מאובטחת באמצעות RevenueCat",
  "payment_entry_page.button_pay": "שלם עכשיו",
  "payment_entry_page.button_start_trial": "התחל ניסיון",
  "success_page.purchase_successful": "התשלום הושלם",
  "success_page.button_close": "המשך",
  "error_page.if_error_persists": "אם השגיאה נמשכת, אנא פנה אל ",
  "error_page.error_title_already_subscribed": "כבר נרשמת כמנוי ל-{{productTitle}}",
  "error_page.error_title_already_purchased": "כבר רכשת את {{productTitle}}",
  "error_page.error_title_other_errors": "משהו השתבש",
  "error_page.error_message_already_subscribed": "אינך יכול להירשם כמנוי למוצר זה שוב.",
  "error_page.error_message_already_purchased": "אינך יכול לרכוש מוצר זה שוב.",
  "error_page.error_message_missing_email_error": 'דוא"ל נדרש כדי להשלים את הרכישה.',
  "error_page.error_message_network_error": "שגיאת רשת. אנא בדוק את חיבור האינטרנט שלך.",
  "error_page.error_message_error_charging_payment": "התשלום נכשל.",
  "error_page.error_message_error_setting_up_purchase": "הרכישה לא הופעלה עקב שגיאה (קוד שגיאה: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "לא הצלחנו לאמת את כתובת החיוב שלך. אנא בדוק שוב את המיקוד והמדינה כדי לוודא שהם נכונים.",
  "error_page.error_message_unknown_error": "אירעה שגיאה לא ידועה (קוד שגיאה: {{errorCode}}).",
  "error_page.button_try_again": "נסה שוב",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": 'סה"כ לתשלום היום',
  "product_info.subscribe_to": "הירשם כמנוי ל-",
  "navbar_header.details": "פרטים",
  "navbar_header.back_button": "חזרה",
  "pricing_dropdown.show_details": "הצג פרטים",
  "pricing_dropdown.hide_details": "הסתר פרטים",
  "pricing_table.tax": "מס",
  "pricing_table.trial_ends": "לאחר סיום תקופת הניסיון, בתאריך {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "סך הכל לתשלום היום",
  "pricing_table.total_excluding_tax": "סך הכל לא כולל מס",
  "pricing_table.enter_billing_address_to_calculate": "הזן כתובת לחיוב כדי לחשב",
  "pricing_table.enter_state_or_postal_code_to_calculate": "הזן מדינה או מיקוד לחישוב",
  "pricing_table.enter_postal_code_to_calculate": "הזן מיקוד לחישוב",
  "error_page.error_message_invalid_email_error": "לא ניתן לאמת את כתובת האימייל {{email}}. אנא ספק כתובת אימייל חוקית.",
  "payment_entry_page.button_payment_method": "שלם {{formattedPrice}} באמצעות {{paymentMethod}}",
  "payment_entry_page.button_with_price": "שלם {{formattedPrice}}",
  "price_update.title": "עדכון מחיר",
  "price_update.base_message": "המחיר הכולל עודכן עם מס בהתבסס על כתובת החיוב שלך. אנא בדוק שוב ונסה שוב. החיוב יתבצע רק פעם אחת.",
  "price_update.trial_message": "מחיר המנוי עודכן כדי לכלול מיסים בהתבסס על כתובת החיוב שלך. תקופת הניסיון החינמית עדיין תקפה. אנא בדוק ונסה שוב.",
  "payment_entry_page.express_checkout_divider": "או שלם באמצעות כרטיס",
  "error_page.trouble_accessing": "אם אתה מתקשה לגשת לרכישה שלך, פנה לתמיכה בכתובת ",
  "error_page.close_button_title": "עבור אל {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "חסרה הרשאה של Stripe",
  "error_page.button_close": "סגור",
  "error_page.error_message_stripe_invalid_tax_origin_address": "הרכישה נכשלה מכיוון שכתובת מקור המס אינה חוקית. בייצור, רכישות יעבדו ללא מסים.",
  "error_page.error_message_stripe_tax_not_active": "הרכישה נכשלה מכיוון שמס Stripe אינו מופעל. בייצור, רכישות יעבדו ללא מסים.",
  "error_page.error_only_in_sandbox": "הודעה זו מופיעה רק בארגז חול.",
  "error_page.error_message_stripe_missing_required_permission": "הרכישה נכשלה מכיוון שלאפליקציית Stripe חסרה הרשאה נדרשת. בייצור, רכישות יעבדו ללא מסים.",
  "error_page.error_title_stripe_tax_not_active": "מס Stripe לא פעיל",
  "error_page.error_title_stripe_invalid_tax_origin_address": "כתובת מקור מס לא חוקית",
  "apple_pay.free_trial": "תקופת ניסיון בחינם",
  "product_info.price_after_intro_price": "לאחר {{introPriceDuration}}, בתאריך {{renewalDate}}",
  "product_info.after_trial": "אחרי תקופת ניסיון",
  "product_info.after": "אחרי",
  "product_info.intro_price_phase_after_trial": "אחר כך {{introPriceDuration}} עבור {{introPrice}}",
  "product_info.intro_price_phase": "תחילה {{introPriceDuration}} עבור {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "משולם פעם אחת",
  "payment_entry_page.trial_subscription_terms_info": "לאחר סיום תקופת הניסיון שלך, תחויב בסך {{price}} {{perFrequency}} החל מ-{{renewalDate}}. באפשרותך לבטל בכל עת לפני תאריך זה.",
  "payment_entry_page.subscription_info": "המנוי מתחדש אוטומטית. ניתן לבטל בכל עת.",
  "payment_entry_page.otp_terms_info": "ברכישה, אתה מסכים לאפשר ל-{{appName}} לחייב אותך בהתאם לתנאים שלהם.",
  "payment_entry_page.terms_link_label": "תנאים",
  "payment_entry_page.subscription_terms_info": "על ידי הרשמה כמנוי, אתה מסכים לאפשר ל-{{appName}} לחייב אותך בהתאם לתנאים שלהם עד שתבטל.",
  "loading_page.keep_page_open": "התהליך כמעט הסתיים. השאר דף זה פתוח.",
  "loading_page.processing_payment": "מעבד תשלום תבעה",
  "pricing_table.discount": "הנחה",
  "pricing_table.subtotal": "סכום ביניים"
}, Ag = {
  "periods.week": "{{amount}} सप्ताह",
  "periods.month": "{{amount}} महीना",
  "periods.year": "{{amount}} वर्ष",
  "periods.day": "{{amount}} दिन",
  "periods.weekShort": "{{amount}}सप्ताह",
  "periods.monthShort": "{{amount}}महीना",
  "periods.yearShort": "{{amount}}वर्ष",
  "periods.dayShort": "{{amount}}दिन",
  "periods.lifetime": "लाइफ़टाइम",
  "periods.weekPlural": "{{amount}} सप्ताह",
  "periods.monthPlural": "{{amount}} महीने",
  "periods.yearPlural": "{{amount}} वर्ष",
  "periods.dayPlural": "{{amount}} दिन",
  "periods.weekFrequency": "साप्ताहिक",
  "periods.monthFrequency": "मासिक",
  "periods.yearFrequency": "वार्षिक",
  "periods.dayFrequency": "दैनिक",
  "periods.perWeekFrequency": "प्रति सप्ताह",
  "periods.perMonthFrequency": "प्रति माह",
  "periods.perYearFrequency": "प्रति वर्ष",
  "periods.perDayFrequency": "प्रति दिन",
  "periods.unknownFrequency": "अज्ञात",
  "periods.weekFrequencyPlural": "प्रत्येक {{amount}} सप्ताह",
  "periods.monthFrequencyPlural": "प्रत्येक {{amount}} महीने",
  "periods.yearFrequencyPlural": "प्रत्येक {{amount}} वर्ष",
  "periods.dayFrequencyPlural": "प्रत्येक {{amount}} दिन",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} निःशुल्क परीक्षण",
  "product_info.price_after_free_trial": "परीक्षण समाप्त होने के बाद, {{renewalDate}} को",
  "product_info.renewal_frequency": "{{frequency}} पर नवीनीकृत होता है",
  "product_info.continues_until_cancelled": "रद्द होने तक जारी रहता है",
  "product_info.cancel_anytime": "किसी भी समय रद्द करें",
  "payment_entry_page.payment_step_title": "RevenueCat द्वारा सुरक्षित चेकआउट",
  "payment_entry_page.button_pay": "अभी भुगतान करें",
  "payment_entry_page.button_start_trial": "परीक्षण प्रारंभ करें",
  "success_page.purchase_successful": "भुगतान पूर्ण",
  "success_page.button_close": "जारी रखें",
  "error_page.if_error_persists": "यदि त्रुटि बनी रहती है, तो कृपया संपर्क करें ",
  "error_page.error_title_already_subscribed": "आपने पहले ही {{productTitle}} की सदस्यता ले ली है",
  "error_page.error_title_already_purchased": "आपने पहले ही {{productTitle}} खरीद लिया है",
  "error_page.error_title_other_errors": "कुछ गलत हो गया",
  "error_page.error_message_already_subscribed": "आप इस उत्पाद की सदस्यता फिर से नहीं ले सकते.",
  "error_page.error_message_already_purchased": "आप इस उत्पाद को फिर से नहीं खरीद सकते.",
  "error_page.error_message_missing_email_error": "खरीद को पूरा करने के लिए ईमेल आवश्यक है।",
  "error_page.error_message_network_error": "नेटवर्क त्रुटि। कृपया अपना इंटरनेट कनेक्शन जांचें।",
  "error_page.error_message_error_charging_payment": "भुगतान विफल।",
  "error_page.error_message_error_setting_up_purchase": "किसी त्रुटि के कारण खरीदारी शुरू नहीं हुई (त्रुटि कोड: {{errorCode}})।",
  "error_page.error_message_invalid_tax_location": "हम आपके बिलिंग पते को सत्यापित नहीं कर सके। कृपया सुनिश्चित करें कि पिन कोड और देश सही हैं।",
  "error_page.error_message_unknown_error": "एक अज्ञात त्रुटि हुई (त्रुटि कोड: {{errorCode}})।",
  "error_page.button_try_again": "फिर से कोशिश करें",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "आज देय कुल राशि",
  "product_info.subscribe_to": "सदस्यता लें",
  "navbar_header.details": "विवरण",
  "navbar_header.back_button": "वापस",
  "pricing_dropdown.show_details": "विवरण दिखाएँ",
  "pricing_dropdown.hide_details": "विवरण छिपाएँ",
  "pricing_table.tax": "कर",
  "pricing_table.trial_ends": "{{formattedTrialEndDate}} पर परीक्षण समाप्त होने के बाद",
  "pricing_table.total_due_today": "आज देय कुल",
  "pricing_table.total_excluding_tax": "कर को छोड़कर कुल",
  "pricing_table.enter_billing_address_to_calculate": "गणना करने के लिए बिलिंग पता दर्ज करें",
  "pricing_table.enter_state_or_postal_code_to_calculate": "गणना करने के लिए राज्य या ज़िप कोड दर्ज करें",
  "pricing_table.enter_postal_code_to_calculate": "गणना करने के लिए ज़िप कोड दर्ज करें",
  "error_page.error_message_invalid_email_error": "ईमेल पता {{email}} सत्यापित नहीं किया जा सका. कृपया एक मान्य ईमेल पता प्रदान करें.",
  "payment_entry_page.button_payment_method": "{{paymentMethod}} के साथ {{formattedPrice}} का भुगतान करें",
  "payment_entry_page.button_with_price": "{{formattedPrice}} का भुगतान करें",
  "price_update.title": "मूल्य अपडेट",
  "price_update.base_message": "आप के बिलिंग पते के आधार पर कुल कीमत कर के साथ अपडेट की गई थी। कृपया समीक्षा करें और फिर से प्रयास करें। आपके कार्ड से केवल एक बार शुल्क लिया जाएगा।",
  "price_update.trial_message": "सदस्यता मूल्य आपके बिलिंग पते के आधार पर करों को शामिल करने के लिए अपडेट किया गया है। निःशुल्क परीक्षण अवधि अभी भी लागू है। कृपया जांचें और पुनः प्रयास करें।",
  "payment_entry_page.express_checkout_divider": "या कार्ड से भुगतान करें",
  "error_page.trouble_accessing": "यदि आपको अपनी खरीदारी तक पहुंचने में परेशानी हो रही है, तो पर समर्थन के लिए संपर्क करें",
  "error_page.close_button_title": "{{appName}} पर जाएं",
  "error_page.error_title_stripe_missing_required_permission": "स्ट्राइप अनुमति गुम है",
  "error_page.button_close": "बंद करें",
  "error_page.error_message_stripe_invalid_tax_origin_address": "खरीदारी विफल रही क्योंकि कर उत्पत्ति पता अमान्य है. उत्पादन में, खरीदारी बिना करों के लागू किए काम करेगी.",
  "error_page.error_message_stripe_tax_not_active": "खरीदारी विफल रही क्योंकि स्ट्राइप टैक्स सक्षम नहीं है. उत्पादन में, खरीदारी बिना करों के लागू किए काम करेगी.",
  "error_page.error_only_in_sandbox": "यह संदेश केवल सैंडबॉक्स में दिखाई देता है.",
  "error_page.error_message_stripe_missing_required_permission": "खरीदारी विफल रही क्योंकि स्ट्राइप ऐप में आवश्यक अनुमति नहीं है. उत्पादन में, खरीदारी बिना करों के लागू किए काम करेगी.",
  "error_page.error_title_stripe_tax_not_active": "स्ट्राइप टैक्स सक्रिय नहीं है",
  "error_page.error_title_stripe_invalid_tax_origin_address": "अमान्य कर उत्पत्ति पता",
  "apple_pay.free_trial": "मुफ़्त ट्रायल",
  "product_info.price_after_intro_price": "{{introPriceDuration}} के बाद, {{renewalDate}} पर",
  "product_info.after_trial": "ट्रायल के बाद",
  "product_info.after": "के बाद",
  "product_info.intro_price_phase_after_trial": "फिर {{introPriceDuration}} के लिए {{introPrice}}",
  "product_info.intro_price_phase": "पहले {{introPriceDuration}} के लिए {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "एक बार भुगतान किया गया",
  "payment_entry_page.trial_subscription_terms_info": "आपकी परीक्षण अवधि समाप्त होने के बाद, आपसे {{renewalDate}} से शुरू होकर {{price}} {{perFrequency}} शुल्क लिया जाएगा. आप इस तिथि से पहले कभी भी रद्द कर सकते हैं.",
  "payment_entry_page.subscription_info": "सदस्यता स्वतः नवीनीकृत हो जाती है. कभी भी रद्द करें.",
  "payment_entry_page.otp_terms_info": "खरीदकर, आप {{appName}} को उनकी शर्तों के अनुसार आपसे शुल्क लेने की अनुमति देने के लिए सहमत हैं.",
  "payment_entry_page.terms_link_label": "नियम",
  "payment_entry_page.subscription_terms_info": "सदस्यता लेकर, आप {{appName}} को रद्द करने तक उनकी शर्तों के अनुसार आपसे शुल्क लेने की अनुमति देने के लिए सहमत हैं.",
  "loading_page.keep_page_open": "प्रक्रिया लगभग पूरी हो चुकी है. इस पृष्ठ को खुला रखें.",
  "loading_page.processing_payment": "भुगतान संसाधित किया जा रहा है",
  "pricing_table.discount": "छूट",
  "pricing_table.subtotal": "उपकुल योग"
}, qg = {
  "periods.week": "{{amount}} hét",
  "periods.month": "{{amount}} hónap",
  "periods.year": "{{amount}} év",
  "periods.day": "{{amount}} nap",
  "periods.weekShort": "{{amount}}hét",
  "periods.monthShort": "{{amount}}hó",
  "periods.yearShort": "{{amount}}év",
  "periods.dayShort": "{{amount}}n",
  "periods.lifetime": "életre szóló",
  "periods.weekPlural": "{{amount}} hét",
  "periods.monthPlural": "{{amount}} hónap",
  "periods.yearPlural": "{{amount}} év",
  "periods.dayPlural": "{{amount}} nap",
  "periods.weekFrequency": "heti",
  "periods.monthFrequency": "havi",
  "periods.yearFrequency": "éves",
  "periods.dayFrequency": "napi",
  "periods.perWeekFrequency": "hetente",
  "periods.perMonthFrequency": "havonta",
  "periods.perYearFrequency": "évente",
  "periods.perDayFrequency": "naponta",
  "periods.unknownFrequency": "ismeretlen",
  "periods.weekFrequencyPlural": "minden {{amount}} hétben",
  "periods.monthFrequencyPlural": "minden {{amount}} hónapban",
  "periods.yearFrequencyPlural": "minden {{amount}} évben",
  "periods.dayFrequencyPlural": "minden {{amount}} napban",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} próbaidőszak",
  "product_info.price_after_free_trial": "A próbaidőszak vége után, {{renewalDate}}-kor",
  "product_info.renewal_frequency": "{{frequency}} gyakorisággal megújul",
  "product_info.continues_until_cancelled": "Folytatódik, amíg le nem mondják",
  "product_info.cancel_anytime": "Bármikor lemondható",
  "payment_entry_page.payment_step_title": "Biztonságos fizetés a RevenueCat-en keresztül",
  "payment_entry_page.button_pay": "Fizetés most",
  "payment_entry_page.button_start_trial": "Próbaidőszak indítása",
  "success_page.purchase_successful": "Fizetés sikeres",
  "success_page.button_close": "Tovább",
  "error_page.if_error_persists": "Ha a hiba továbbra is fennáll, kérjük, vedd fel a kapcsolatot ",
  "error_page.error_title_already_subscribed": "Már előfizettél a(z) {{productTitle}} termékre",
  "error_page.error_title_already_purchased": "Már megvásároltad a(z) {{productTitle}} terméket",
  "error_page.error_title_other_errors": "Valami hiba történt",
  "error_page.error_message_already_subscribed": "Nem fizethetsz elő újra erre a termékre.",
  "error_page.error_message_already_purchased": "Nem vásárolhatod meg újra ezt a terméket.",
  "error_page.error_message_missing_email_error": "Az email cím szükséges a vásárlás befejezéséhez.",
  "error_page.error_message_network_error": "Hálózati hiba. Kérjük, ellenőrizd az internetkapcsolatodat.",
  "error_page.error_message_error_charging_payment": "A fizetés sikertelen volt.",
  "error_page.error_message_error_setting_up_purchase": "Hiba miatt nem indult el a vásárlás (hibakód: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nem tudtuk ellenőrizni a számlázási címét. Kérjük, ellenőrizze, hogy az irányítószám és az ország helyes-e.",
  "error_page.error_message_unknown_error": "Ismeretlen hiba történt (hibakód: {{errorCode}}).",
  "error_page.button_try_again": "Újrapróbálkozás",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Ma fizetendő összesen",
  "product_info.subscribe_to": "Feliratkozás erre:",
  "navbar_header.details": "Részletek",
  "navbar_header.back_button": "Vissza",
  "pricing_dropdown.show_details": "Részletek mutatása",
  "pricing_dropdown.hide_details": "Részletek elrejtése",
  "pricing_table.tax": "Adó",
  "pricing_table.trial_ends": "A próbaidőszak vége: {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Ma fizetendő összeg",
  "pricing_table.total_excluding_tax": "Összesen adó nélkül",
  "pricing_table.enter_billing_address_to_calculate": "Adja meg a számlázási címet a számításhoz",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Adja meg az államot vagy az irányítószámot a számításhoz",
  "pricing_table.enter_postal_code_to_calculate": "Adja meg az irányítószámot a számításhoz",
  "error_page.error_message_invalid_email_error": "A(z) {{email}} e-mail címet nem sikerült ellenőrizni. Kérjük, adj meg egy érvényes e-mail címet.",
  "payment_entry_page.button_payment_method": "Fizetés {{formattedPrice}} összeggel a következővel: {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Fizetés {{formattedPrice}}",
  "price_update.title": "Ár frissítése",
  "price_update.base_message": "A teljes ár frissítve lett az adóval a számlázási címed alapján. Kérjük, tekintsd át és próbáld újra. A kártyádat csak egyszer terheljük meg.",
  "price_update.trial_message": "Az előfizetés ára adókkal együtt frissítésre került a számlázási címének megfelelően. Az ingyenes próbaidőszak továbbra is érvényes. Kérjük, ellenőrizze és próbálja újra.",
  "payment_entry_page.express_checkout_divider": "VAGY FIZESSEN KÁRTYÁVAL",
  "error_page.trouble_accessing": "Ha problémái vannak a vásárláshoz való hozzáféréssel, forduljon az ügyfélszolgálathoz a következő címen: ",
  "error_page.close_button_title": "Ugrás a(z) {{appName}} alkalmazáshoz",
  "error_page.error_title_stripe_missing_required_permission": "Hiányzó Stripe engedély",
  "error_page.button_close": "Bezárás",
  "error_page.error_message_stripe_invalid_tax_origin_address": "A vásárlás sikertelen volt, mert az adókiindulási cím érvénytelen. Éles környezetben a vásárlások adók alkalmazása nélkül fognak működni.",
  "error_page.error_message_stripe_tax_not_active": "A vásárlás sikertelen volt, mert a Stripe adó nincs engedélyezve. Éles környezetben a vásárlások adók alkalmazása nélkül fognak működni.",
  "error_page.error_only_in_sandbox": "Ez az üzenet csak a tesztkörnyezetben jelenik meg.",
  "error_page.error_message_stripe_missing_required_permission": "A vásárlás sikertelen volt, mert a Stripe alkalmazásból hiányzik egy szükséges engedély. Éles környezetben a vásárlások adók alkalmazása nélkül fognak működni.",
  "error_page.error_title_stripe_tax_not_active": "A Stripe adó nincs aktiválva",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Érvénytelen adókiindulási cím",
  "apple_pay.free_trial": "Ingyenes próbaidőszak",
  "product_info.price_after_intro_price": "{{introPriceDuration}} után, {{renewalDate}} napján",
  "product_info.after_trial": "próbaidőszak után",
  "product_info.after": "utána",
  "product_info.intro_price_phase_after_trial": "Ezután {{introPriceDuration}} ideig {{introPrice}} áron",
  "product_info.intro_price_phase": "Először {{introPriceDuration}} ideig {{introPrice}} áron",
  "product_info.intro_price_phase_paid_once": "egyszeri fizetéssel",
  "payment_entry_page.trial_subscription_terms_info": "A próbaidőszak vége után {{price}} összeget számítunk fel {{perFrequency}} gyakorisággal, kezdve {{renewalDate}} dátummal. Ezt a dátumot megelőzően bármikor lemondhatod.",
  "payment_entry_page.subscription_info": "Az előfizetés automatikusan megújul. Bármikor lemondhatod.",
  "payment_entry_page.otp_terms_info": "A vásárlással elfogadod, hogy a {{appName}} az általa meghatározott feltételek szerint terheljen.",
  "payment_entry_page.terms_link_label": "Feltételek",
  "payment_entry_page.subscription_terms_info": "A feliratkozással elfogadod, hogy a {{appName}} az általa meghatározott feltételek szerint terheljen, amíg le nem mondod.",
  "loading_page.keep_page_open": "A folyamat majdnem befejeződött. Tartsa nyitva ezt az oldalt.",
  "loading_page.processing_payment": "Fizetés feldolgozása",
  "pricing_table.discount": "Kedvezmény",
  "pricing_table.subtotal": "Részösszeg"
}, Fg = {
  "periods.week": "{{amount}} minggu",
  "periods.month": "{{amount}} bulan",
  "periods.year": "{{amount}} tahun",
  "periods.day": "{{amount}} hari",
  "periods.weekShort": "{{amount}}mg",
  "periods.monthShort": "{{amount}}bl",
  "periods.yearShort": "{{amount}}th",
  "periods.dayShort": "{{amount}}h",
  "periods.lifetime": "seumur hidup",
  "periods.weekPlural": "{{amount}} minggu",
  "periods.monthPlural": "{{amount}} bulan",
  "periods.yearPlural": "{{amount}} tahun",
  "periods.dayPlural": "{{amount}} hari",
  "periods.weekFrequency": "mingguan",
  "periods.monthFrequency": "bulanan",
  "periods.yearFrequency": "tahunan",
  "periods.dayFrequency": "harian",
  "periods.perWeekFrequency": "per minggu",
  "periods.perMonthFrequency": "per bulan",
  "periods.perYearFrequency": "per tahun",
  "periods.perDayFrequency": "per hari",
  "periods.unknownFrequency": "tidak diketahui",
  "periods.weekFrequencyPlural": "setiap {{amount}} minggu",
  "periods.monthFrequencyPlural": "setiap {{amount}} bulan",
  "periods.yearFrequencyPlural": "setiap {{amount}} tahun",
  "periods.dayFrequencyPlural": "setiap {{amount}} hari",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} uji coba gratis",
  "product_info.price_after_free_trial": "Setelah uji coba berakhir, pada {{renewalDate}}",
  "product_info.renewal_frequency": "Diperbarui {{frequency}}",
  "product_info.continues_until_cancelled": "Berlanjut hingga dibatalkan",
  "product_info.cancel_anytime": "Batalkan kapan saja",
  "payment_entry_page.payment_step_title": "Pembayaran aman oleh RevenueCat",
  "payment_entry_page.button_pay": "Bayar sekarang",
  "payment_entry_page.button_start_trial": "Mulai Uji Coba",
  "success_page.purchase_successful": "Pembayaran selesai",
  "success_page.button_close": "Lanjutkan",
  "error_page.if_error_persists": "Jika kesalahan berlanjut, silakan hubungi ",
  "error_page.error_title_already_subscribed": "Anda sudah berlangganan ke {{productTitle}}",
  "error_page.error_title_already_purchased": "Anda sudah membeli {{productTitle}}",
  "error_page.error_title_other_errors": "Terjadi kesalahan",
  "error_page.error_message_already_subscribed": "Anda tidak dapat berlangganan produk ini lagi.",
  "error_page.error_message_already_purchased": "Anda tidak dapat membeli produk ini lagi.",
  "error_page.error_message_missing_email_error": "Email diperlukan untuk menyelesaikan pembelian.",
  "error_page.error_message_network_error": "Kesalahan jaringan. Periksa koneksi internet Anda.",
  "error_page.error_message_error_charging_payment": "Pembayaran gagal.",
  "error_page.error_message_error_setting_up_purchase": "Pembelian tidak dimulai karena kesalahan (kode kesalahan: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Kami tidak dapat memverifikasi alamat penagihan Anda. Harap periksa kembali kode pos dan negara untuk memastikan keduanya benar.",
  "error_page.error_message_unknown_error": "Terjadi kesalahan yang tidak diketahui (kode kesalahan: {{errorCode}}).",
  "error_page.button_try_again": "Coba lagi",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Total yang harus dibayar hari ini",
  "product_info.subscribe_to": "Berlangganan ke",
  "navbar_header.details": "Detail",
  "navbar_header.back_button": "Kembali",
  "pricing_dropdown.show_details": "Tampilkan detail",
  "pricing_dropdown.hide_details": "Sembunyikan detail",
  "pricing_table.tax": "Pajak",
  "pricing_table.trial_ends": "Setelah masa percobaan berakhir, pada {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total yang harus dibayar hari ini",
  "pricing_table.total_excluding_tax": "Total belum termasuk pajak",
  "pricing_table.enter_billing_address_to_calculate": "Masukkan alamat penagihan untuk menghitung",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Masukkan negara bagian atau kode pos untuk menghitung",
  "pricing_table.enter_postal_code_to_calculate": "Masukkan kode pos untuk menghitung",
  "error_page.error_message_invalid_email_error": "Alamat email {{email}} tidak dapat diverifikasi. Harap berikan alamat email yang valid.",
  "payment_entry_page.button_payment_method": "Bayar {{formattedPrice}} dengan {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Bayar {{formattedPrice}}",
  "price_update.title": "Pembaruan harga",
  "price_update.base_message": "Total harga telah diperbarui dengan pajak berdasarkan alamat penagihan Anda. Harap tinjau dan coba lagi. Kartu Anda hanya akan dikenakan biaya sekali.",
  "price_update.trial_message": "Harga langganan telah diperbarui untuk menyertakan pajak berdasarkan alamat penagihan Anda. Masa percobaan gratis masih berlaku. Silakan periksa dan coba lagi.",
  "payment_entry_page.express_checkout_divider": "ATAU BAYAR DENGAN KARTU",
  "error_page.trouble_accessing": "Jika Anda mengalami masalah dalam mengakses pembelian, hubungi dukungan di ",
  "error_page.close_button_title": "Pergi ke {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Izin Stripe tidak ada",
  "error_page.button_close": "Tutup",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Pembelian gagal karena alamat asal pajak tidak valid. Dalam produksi, pembelian akan berfungsi tanpa pajak yang diterapkan.",
  "error_page.error_message_stripe_tax_not_active": "Pembelian gagal karena Stripe Tax tidak diaktifkan. Dalam produksi, pembelian akan berfungsi tanpa pajak yang diterapkan.",
  "error_page.error_only_in_sandbox": "Pesan ini hanya muncul di sandbox.",
  "error_page.error_message_stripe_missing_required_permission": "Pembelian gagal karena aplikasi Stripe tidak memiliki izin yang diperlukan. Dalam produksi, pembelian akan berfungsi tanpa pajak yang diterapkan.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax tidak aktif",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Alamat asal pajak tidak valid",
  "apple_pay.free_trial": "Uji Coba Gratis",
  "product_info.price_after_intro_price": "Setelah {{introPriceDuration}}, pada {{renewalDate}}",
  "product_info.after_trial": "setelah uji coba",
  "product_info.after": "setelah",
  "product_info.intro_price_phase_after_trial": "Kemudian {{introPriceDuration}} dengan harga {{introPrice}}",
  "product_info.intro_price_phase": "Pertama {{introPriceDuration}} dengan harga {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "dibayar sekali",
  "payment_entry_page.trial_subscription_terms_info": "Setelah masa percobaan Anda berakhir, Anda akan dikenakan biaya sebesar {{price}} {{perFrequency}} mulai {{renewalDate}}. Anda dapat membatalkan kapan saja sebelum tanggal ini.",
  "payment_entry_page.subscription_info": "Langganan diperpanjang secara otomatis. Batalkan kapan saja.",
  "payment_entry_page.otp_terms_info": "Dengan membeli, Anda setuju untuk mengizinkan {{appName}} menagih Anda sesuai dengan ketentuan mereka.",
  "payment_entry_page.terms_link_label": "Ketentuan",
  "payment_entry_page.subscription_terms_info": "Dengan berlangganan, Anda setuju untuk mengizinkan {{appName}} mengenakan biaya sesuai dengan ketentuan mereka hingga Anda membatalkan.",
  "loading_page.keep_page_open": "Prosesnya hampir selesai. Jangan tutup halaman ini.",
  "loading_page.processing_payment": "Pembayaran sedang diproses",
  "pricing_table.discount": "Diskon",
  "pricing_table.subtotal": "Subtotal"
}, zg = {
  "periods.week": "{{amount}}週間",
  "periods.month": "{{amount}}ヶ月",
  "periods.year": "{{amount}}年",
  "periods.day": "{{amount}}日",
  "periods.weekShort": "{{amount}}週",
  "periods.monthShort": "{{amount}}ヶ月",
  "periods.yearShort": "{{amount}}年",
  "periods.dayShort": "{{amount}}日",
  "periods.lifetime": "生涯",
  "periods.weekPlural": "{{amount}}週間",
  "periods.monthPlural": "{{amount}}ヶ月",
  "periods.yearPlural": "{{amount}}年",
  "periods.dayPlural": "{{amount}}日",
  "periods.weekFrequency": "毎週",
  "periods.monthFrequency": "毎月",
  "periods.yearFrequency": "毎年",
  "periods.dayFrequency": "毎日",
  "periods.perWeekFrequency": "週ごと",
  "periods.perMonthFrequency": "月ごと",
  "periods.perYearFrequency": "年ごと",
  "periods.perDayFrequency": "日ごと",
  "periods.unknownFrequency": "不明",
  "periods.weekFrequencyPlural": "{{amount}}週間ごと",
  "periods.monthFrequencyPlural": "{{amount}}ヶ月ごと",
  "periods.yearFrequencyPlural": "{{amount}}年ごと",
  "periods.dayFrequencyPlural": "{{amount}}日ごと",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}}日間無料トライアル",
  "product_info.price_after_free_trial": "トライアル終了後、{{renewalDate}}に",
  "product_info.renewal_frequency": "{{frequency}}で更新",
  "product_info.continues_until_cancelled": "キャンセルされるまで継続されます",
  "product_info.cancel_anytime": "いつでもキャンセルできます",
  "payment_entry_page.payment_step_title": "RevenueCatによる安全なチェックアウト",
  "payment_entry_page.button_pay": "今すぐ支払う",
  "payment_entry_page.button_start_trial": "トライアルを開始",
  "success_page.purchase_successful": "支払いが完了しました",
  "success_page.button_close": "続行",
  "error_page.if_error_persists": "エラーが続く場合は、ご連絡ください。",
  "error_page.error_title_already_subscribed": "すでに{{productTitle}}を購読しています",
  "error_page.error_title_already_purchased": "すでに{{productTitle}}を購入しています",
  "error_page.error_title_other_errors": "エラーが発生しました",
  "error_page.error_message_already_subscribed": "この商品を再度購読することはできません。",
  "error_page.error_message_already_purchased": "この商品を再度購入することはできません。",
  "error_page.error_message_missing_email_error": "購入を完了するにはメールアドレスが必要です。",
  "error_page.error_message_network_error": "ネットワークエラーです。インターネット接続を確認してください。",
  "error_page.error_message_error_charging_payment": "支払いに失敗しました。",
  "error_page.error_message_error_setting_up_purchase": "エラーが発生したため、購入を開始できませんでした（エラーコード：{{errorCode}}）。",
  "error_page.error_message_invalid_tax_location": "請求先住所を確認できませんでした。郵便番号と国が正しいかご確認ください。",
  "error_page.error_message_unknown_error": "不明なエラーが発生しました（エラーコード：{{errorCode}}）。",
  "error_page.button_try_again": "再試行",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "本日のお支払い合計",
  "product_info.subscribe_to": "購読する",
  "navbar_header.details": "詳細",
  "navbar_header.back_button": "戻る",
  "pricing_dropdown.show_details": "詳細を表示",
  "pricing_dropdown.hide_details": "詳細を隠す",
  "pricing_table.tax": "税金",
  "pricing_table.trial_ends": "トライアル終了後、{{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "本日お支払いいただく合計金額",
  "pricing_table.total_excluding_tax": "税抜き合計",
  "pricing_table.enter_billing_address_to_calculate": "請求先住所を入力して計算",
  "pricing_table.enter_state_or_postal_code_to_calculate": "計算するには州または郵便番号を入力してください",
  "pricing_table.enter_postal_code_to_calculate": "計算するには郵便番号を入力してください",
  "error_page.error_message_invalid_email_error": "メールアドレス{{email}}を確認できませんでした。有効なメールアドレスを入力してください。",
  "payment_entry_page.button_payment_method": "{{paymentMethod}}で{{formattedPrice}}を支払う",
  "payment_entry_page.button_with_price": "{{formattedPrice}}を支払う",
  "price_update.title": "価格の更新",
  "price_update.base_message": "合計金額が、お客様の請求先住所に基づいて税金とともに更新されました。再度ご確認ください。カードへの請求は1回のみです。",
  "price_update.trial_message": "請求先住所に基づいて税金を含むサブスクリプション料金が更新されました。無料トライアルは引き続き適用されます。確認して再度お試しください。",
  "payment_entry_page.express_checkout_divider": "カードで支払う",
  "error_page.trouble_accessing": "購入へのアクセスに問題がある場合は、サポートにお問い合わせください: ",
  "error_page.close_button_title": "{{appName}} に移動",
  "error_page.error_title_stripe_missing_required_permission": "必要なStripeの権限がありません",
  "error_page.button_close": "閉じる",
  "error_page.error_message_stripe_invalid_tax_origin_address": "税の原産地住所が無効なため、購入に失敗しました。 本番環境では、税金が適用されなくても購入は可能です。",
  "error_page.error_message_stripe_tax_not_active": "Stripe Taxが有効になっていないため、購入に失敗しました。 本番環境では、税金が適用されなくても購入は可能です。",
  "error_page.error_only_in_sandbox": "このメッセージはサンドボックスでのみ表示されます。",
  "error_page.error_message_stripe_missing_required_permission": "Stripeアプリに必要な権限がないため、購入に失敗しました。 本番環境では、税金が適用されなくても購入は可能です。",
  "error_page.error_title_stripe_tax_not_active": "Stripe Taxが有効ではありません",
  "error_page.error_title_stripe_invalid_tax_origin_address": "税の原産地住所が無効です",
  "apple_pay.free_trial": "無料トライアル",
  "product_info.price_after_intro_price": "{{introPriceDuration}}の後、{{renewalDate}}に",
  "product_info.after_trial": "トライアル後",
  "product_info.after": "後",
  "product_info.intro_price_phase_after_trial": "その後、{{introPriceDuration}}間は{{introPrice}}",
  "product_info.intro_price_phase": "最初の{{introPriceDuration}}間は{{introPrice}}",
  "product_info.intro_price_phase_paid_once": "一回払い",
  "payment_entry_page.trial_subscription_terms_info": "トライアル期間が終了すると、{{renewalDate}}から{{price}} {{perFrequency}}が課金されます。この日より前にいつでもキャンセルできます。",
  "payment_entry_page.subscription_info": "サブスクリプションは自動的に更新されます。いつでもキャンセルできます。",
  "payment_entry_page.otp_terms_info": "購入することにより、{{appName}}が利用規約に基づいて料金を請求することに同意したことになります。",
  "payment_entry_page.terms_link_label": "利用規約",
  "payment_entry_page.subscription_terms_info": "サブスクリプションに登録すると、キャンセルするまで{{appName}}が利用規約に従って課金することを許可することに同意したことになります。",
  "loading_page.keep_page_open": "プロセスはほぼ完了です。このページを開いたままにしてください。",
  "loading_page.processing_payment": "お支払い手続き中",
  "pricing_table.discount": "割引",
  "pricing_table.subtotal": "小計"
}, Mg = {
  "periods.week": "{{amount}}주",
  "periods.month": "{{amount}}개월",
  "periods.year": "{{amount}}년",
  "periods.day": "{{amount}}일",
  "periods.weekShort": "{{amount}}주",
  "periods.monthShort": "{{amount}}개월",
  "periods.yearShort": "{{amount}}년",
  "periods.dayShort": "{{amount}}일",
  "periods.lifetime": "평생",
  "periods.weekPlural": "{{amount}}주",
  "periods.monthPlural": "{{amount}}개월",
  "periods.yearPlural": "{{amount}}년",
  "periods.dayPlural": "{{amount}}일",
  "periods.weekFrequency": "매주",
  "periods.monthFrequency": "매달",
  "periods.yearFrequency": "매년",
  "periods.dayFrequency": "매일",
  "periods.perWeekFrequency": "주당",
  "periods.perMonthFrequency": "월별",
  "periods.perYearFrequency": "연간",
  "periods.perDayFrequency": "매일",
  "periods.unknownFrequency": "알 수 없음",
  "periods.weekFrequencyPlural": "{{amount}}주마다",
  "periods.monthFrequencyPlural": "{{amount}}개월마다",
  "periods.yearFrequencyPlural": "{{amount}}년마다",
  "periods.dayFrequencyPlural": "{{amount}}일마다",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}}일 무료 체험",
  "product_info.price_after_free_trial": "체험 종료 후, {{renewalDate}}에",
  "product_info.renewal_frequency": "{{frequency}}마다 갱신",
  "product_info.continues_until_cancelled": "취소될 때까지 계속됩니다.",
  "product_info.cancel_anytime": "언제든지 취소 가능",
  "payment_entry_page.payment_step_title": "RevenueCat을 통한 안전한 결제",
  "payment_entry_page.button_pay": "지금 결제",
  "payment_entry_page.button_start_trial": "체험 시작",
  "success_page.purchase_successful": "결제가 완료되었습니다.",
  "success_page.button_close": "계속",
  "error_page.if_error_persists": "오류가 지속되면 다음으로 문의하십시오.",
  "error_page.error_title_already_subscribed": "이미 {{productTitle}}을 구독하셨습니다",
  "error_page.error_title_already_purchased": "이미 {{productTitle}}을 구매하셨습니다",
  "error_page.error_title_other_errors": "문제가 발생했습니다.",
  "error_page.error_message_already_subscribed": "이 제품을 다시 구독할 수 없습니다.",
  "error_page.error_message_already_purchased": "이 제품을 다시 구매할 수 없습니다.",
  "error_page.error_message_missing_email_error": "구매를 완료하려면 이메일이 필요합니다.",
  "error_page.error_message_network_error": "네트워크 오류입니다. 인터넷 연결을 확인하십시오.",
  "error_page.error_message_error_charging_payment": "결제에 실패했습니다.",
  "error_page.error_message_error_setting_up_purchase": "오류로 인해 구매가 시작되지 않았습니다(오류 코드: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "청구 주소를 확인할 수 없습니다. 우편번호와 국가가 정확한지 다시 한번 확인해 주세요.",
  "error_page.error_message_unknown_error": "알 수 없는 오류가 발생했습니다(오류 코드: {{errorCode}}).",
  "error_page.button_try_again": "다시 시도",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "오늘 총 결제 금액",
  "product_info.subscribe_to": "구독하기",
  "navbar_header.details": "세부 정보",
  "navbar_header.back_button": "뒤로",
  "pricing_dropdown.show_details": "세부 정보 표시",
  "pricing_dropdown.hide_details": "세부 정보 숨기기",
  "pricing_table.tax": "세금",
  "pricing_table.trial_ends": "체험판 종료 후, {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "오늘 지불해야 할 총액",
  "pricing_table.total_excluding_tax": "세금 제외 총액",
  "pricing_table.enter_billing_address_to_calculate": "계산을 위해 청구지 주소를 입력하세요",
  "pricing_table.enter_state_or_postal_code_to_calculate": "주 또는 우편 번호를 입력하여 계산",
  "pricing_table.enter_postal_code_to_calculate": "우편 번호를 입력하여 계산",
  "error_page.error_message_invalid_email_error": "이메일 주소 {{email}}을(를) 확인할 수 없습니다. 유효한 이메일 주소를 제공해 주세요.",
  "payment_entry_page.button_payment_method": "{{paymentMethod}}으로 {{formattedPrice}} 결제",
  "payment_entry_page.button_with_price": "{{formattedPrice}} 결제",
  "price_update.title": "가격 업데이트",
  "price_update.base_message": "청구지 주소를 기준으로 세금이 포함된 총 가격이 업데이트되었습니다. 다시 확인하고 시도해 주세요. 카드는 한 번만 청구됩니다.",
  "price_update.trial_message": "청구 주소에 따라 세금이 포함된 구독 가격이 업데이트되었습니다. 무료 체험은 계속 적용됩니다. 확인하고 다시 시도해 주세요.",
  "payment_entry_page.express_checkout_divider": "또는 카드 결제",
  "error_page.trouble_accessing": "구매에 문제가 있는 경우 다음 주소로 지원팀에 문의하세요. ",
  "error_page.close_button_title": "{{appName}}으로 이동",
  "error_page.error_title_stripe_missing_required_permission": "필수 Stripe 권한 누락",
  "error_page.button_close": "닫기",
  "error_page.error_message_stripe_invalid_tax_origin_address": "세금 원산지 주소가 잘못되어 구매에 실패했습니다. 프로덕션 환경에서는 세금이 적용되지 않은 상태로 구매가 진행됩니다.",
  "error_page.error_message_stripe_tax_not_active": "Stripe Tax가 활성화되지 않아 구매에 실패했습니다. 프로덕션 환경에서는 세금이 적용되지 않은 상태로 구매가 진행됩니다.",
  "error_page.error_only_in_sandbox": "이 메시지는 샌드박스에서만 표시됩니다.",
  "error_page.error_message_stripe_missing_required_permission": "Stripe 앱에 필요한 권한이 없어 구매에 실패했습니다. 프로덕션 환경에서는 세금이 적용되지 않은 상태로 구매가 진행됩니다.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax가 활성화되지 않음",
  "error_page.error_title_stripe_invalid_tax_origin_address": "잘못된 세금 원산지 주소",
  "apple_pay.free_trial": "무료 체험",
  "product_info.price_after_intro_price": "{{introPriceDuration}} 후 {{renewalDate}}에",
  "product_info.after_trial": "체험 후",
  "product_info.after": "후",
  "product_info.intro_price_phase_after_trial": "다음 {{introPriceDuration}} 동안 {{introPrice}}",
  "product_info.intro_price_phase": "처음 {{introPriceDuration}} 동안 {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "1회 결제",
  "payment_entry_page.trial_subscription_terms_info": "체험 기간이 종료되면 {{renewalDate}}부터 {{price}} {{perFrequency}}가 청구됩니다. 이 날짜 전에는 언제든지 취소할 수 있습니다.",
  "payment_entry_page.subscription_info": "구독은 자동으로 갱신됩니다. 언제든지 취소할 수 있습니다.",
  "payment_entry_page.otp_terms_info": "구매하시면 {{appName}}의 약관에 따라 요금이 청구되는 것에 동의하는 것입니다.",
  "payment_entry_page.terms_link_label": "약관",
  "payment_entry_page.subscription_terms_info": "구독하면 취소할 때까지 {{appName}}이 약관에 따라 요금을 청구하는 데 동의하는 것입니다.",
  "loading_page.keep_page_open": "거의 완료되었습니다. 이 페이지를 계속 열어 두세요.",
  "loading_page.processing_payment": "결제 처리 중",
  "pricing_table.discount": "할인",
  "pricing_table.subtotal": "소계"
}, Og = {
  "periods.week": "{{amount}} minggu",
  "periods.month": "{{amount}} bulan",
  "periods.year": "{{amount}} tahun",
  "periods.day": "{{amount}} hari",
  "periods.weekShort": "{{amount}}mg",
  "periods.monthShort": "{{amount}}bl",
  "periods.yearShort": "{{amount}}th",
  "periods.dayShort": "{{amount}}h",
  "periods.lifetime": "seumur hidup",
  "periods.weekPlural": "{{amount}} minggu",
  "periods.monthPlural": "{{amount}} bulan",
  "periods.yearPlural": "{{amount}} tahun",
  "periods.dayPlural": "{{amount}} hari",
  "periods.weekFrequency": "mingguan",
  "periods.monthFrequency": "bulanan",
  "periods.yearFrequency": "tahunan",
  "periods.dayFrequency": "harian",
  "periods.perWeekFrequency": "setiap minggu",
  "periods.perMonthFrequency": "setiap bulan",
  "periods.perYearFrequency": "setiap tahun",
  "periods.perDayFrequency": "setiap hari",
  "periods.unknownFrequency": "tidak diketahui",
  "periods.weekFrequencyPlural": "setiap {{amount}} minggu",
  "periods.monthFrequencyPlural": "setiap {{amount}} bulan",
  "periods.yearFrequencyPlural": "setiap {{amount}} tahun",
  "periods.dayFrequencyPlural": "setiap {{amount}} hari",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} percubaan percuma",
  "product_info.price_after_free_trial": "Selepas tamat percubaan, pada {{renewalDate}}",
  "product_info.renewal_frequency": "Diperbaharui {{frequency}}",
  "product_info.continues_until_cancelled": "Berterusan sehingga dibatalkan",
  "product_info.cancel_anytime": "Batal bila-bila masa",
  "payment_entry_page.payment_step_title": "Pembayaran selamat oleh RevenueCat",
  "payment_entry_page.button_pay": "Bayar sekarang",
  "payment_entry_page.button_start_trial": "Mula Percubaan",
  "success_page.purchase_successful": "Pembayaran selesai",
  "success_page.button_close": "Teruskan",
  "error_page.if_error_persists": "Jika ralat berterusan, sila hubungi ",
  "error_page.error_title_already_subscribed": "Anda sudah melanggan {{productTitle}}",
  "error_page.error_title_already_purchased": "Anda sudah membeli {{productTitle}}",
  "error_page.error_title_other_errors": "Ada sesuatu yang tidak kena",
  "error_page.error_message_already_subscribed": "Anda tidak boleh melanggan produk ini lagi.",
  "error_page.error_message_already_purchased": "Anda tidak boleh membeli produk ini lagi.",
  "error_page.error_message_missing_email_error": "Emel diperlukan untuk menyelesaikan pembelian.",
  "error_page.error_message_network_error": "Ralat rangkaian. Sila semak sambungan internet anda.",
  "error_page.error_message_error_charging_payment": "Pembayaran gagal.",
  "error_page.error_message_error_setting_up_purchase": "Pembelian tidak dimulakan disebabkan ralat (kod ralat: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Kami tidak dapat mengesahkan alamat bil anda. Sila semak sama ada poskod dan negara adalah betul.",
  "error_page.error_message_unknown_error": "Ralat yang tidak diketahui telah berlaku (kod ralat: {{errorCode}}).",
  "error_page.button_try_again": "Cuba lagi",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Jumlah yang perlu dibayar hari ini",
  "product_info.subscribe_to": "Langgan",
  "navbar_header.details": "Butiran",
  "navbar_header.back_button": "Kembali",
  "pricing_dropdown.show_details": "Tunjukkan butiran",
  "pricing_dropdown.hide_details": "Sembunyikan butiran",
  "pricing_table.tax": "Cukai",
  "pricing_table.trial_ends": "Selepas tempoh percubaan tamat, pada {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Jumlah yang perlu dibayar hari ini",
  "pricing_table.total_excluding_tax": "Jumlah tidak termasuk cukai",
  "pricing_table.enter_billing_address_to_calculate": "Masukkan alamat pengebilan untuk mengira",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Masukkan negeri atau poskod untuk mengira",
  "pricing_table.enter_postal_code_to_calculate": "Masukkan poskod untuk mengira",
  "error_page.error_message_invalid_email_error": "Alamat e-mel {{email}} tidak dapat disahkan. Sila berikan alamat e-mel yang sah.",
  "payment_entry_page.button_payment_method": "Bayar {{formattedPrice}} dengan {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Bayar {{formattedPrice}}",
  "price_update.title": "Kemaskini harga",
  "price_update.base_message": "Jumlah harga telah dikemas kini dengan cukai berdasarkan alamat pengebilan anda. Sila semak dan cuba lagi. Kad anda hanya akan dicaj sekali.",
  "price_update.trial_message": "Harga langganan telah dikemas kini untuk memasukkan cukai berdasarkan alamat bil anda. Tempoh percubaan percuma masih terpakai. Sila semak dan cuba lagi.",
  "payment_entry_page.express_checkout_divider": "ATAU BAYAR DENGAN KAD",
  "error_page.trouble_accessing": "Jika anda menghadapi masalah untuk mengakses pembelian anda, hubungi sokongan di ",
  "error_page.close_button_title": "Pergi ke {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Kebenaran Stripe hilang",
  "error_page.button_close": "Tutup",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Pembelian gagal kerana alamat asal cukai tidak sah. Dalam pengeluaran, pembelian akan berfungsi tanpa cukai dikenakan.",
  "error_page.error_message_stripe_tax_not_active": "Pembelian gagal kerana Cukai Stripe tidak didayakan. Dalam pengeluaran, pembelian akan berfungsi tanpa cukai dikenakan.",
  "error_page.error_only_in_sandbox": "Mesej ini hanya muncul dalam kotak pasir.",
  "error_page.error_message_stripe_missing_required_permission": "Pembelian gagal kerana aplikasi Stripe kekurangan kebenaran yang diperlukan. Dalam pengeluaran, pembelian akan berfungsi tanpa cukai dikenakan.",
  "error_page.error_title_stripe_tax_not_active": "Cukai Stripe tidak aktif",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Alamat asal cukai Stripe tidak sah",
  "apple_pay.free_trial": "Percubaan Percuma",
  "product_info.price_after_intro_price": "Selepas {{introPriceDuration}}, pada {{renewalDate}}",
  "product_info.after_trial": "selepas percubaan",
  "product_info.after": "selepas",
  "product_info.intro_price_phase_after_trial": "Kemudian {{introPriceDuration}} untuk {{introPrice}}",
  "product_info.intro_price_phase": "Pertama {{introPriceDuration}} untuk {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "dibayar sekali",
  "payment_entry_page.trial_subscription_terms_info": "Selepas tempoh percubaan anda tamat, anda akan dikenakan bayaran sebanyak {{price}} {{perFrequency}} bermula {{renewalDate}}. Anda boleh membatalkan pada bila-bila masa sebelum tarikh ini.",
  "payment_entry_page.subscription_info": "Langganan diperbaharui secara automatik. Batalkan bila-bila masa.",
  "payment_entry_page.otp_terms_info": "Dengan membuat pembelian, anda bersetuju untuk membenarkan {{appName}} mengenakan bayaran kepada anda mengikut terma mereka.",
  "payment_entry_page.terms_link_label": "Terma",
  "payment_entry_page.subscription_terms_info": "Dengan melanggan, anda bersetuju untuk membenarkan {{appName}} mengenakan bayaran kepada anda mengikut terma mereka sehingga anda membatalkan.",
  "loading_page.keep_page_open": "Proses hampir selesai. Pastikan halaman ini dibuka.",
  "loading_page.processing_payment": "Memproses pembayaran",
  "pricing_table.discount": "Diskaun",
  "pricing_table.subtotal": "Subtotal"
}, jg = {
  "periods.week": "{{amount}} uke",
  "periods.month": "{{amount}} måned",
  "periods.year": "{{amount}} år",
  "periods.day": "{{amount}} dag",
  "periods.weekShort": "{{amount}}uk",
  "periods.monthShort": "{{amount}}md",
  "periods.yearShort": "{{amount}}år",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "livstid",
  "periods.weekPlural": "{{amount}} uker",
  "periods.monthPlural": "{{amount}} måneder",
  "periods.yearPlural": "{{amount}} år",
  "periods.dayPlural": "{{amount}} dager",
  "periods.weekFrequency": "ukentlig",
  "periods.monthFrequency": "månedlig",
  "periods.yearFrequency": "årlig",
  "periods.dayFrequency": "daglig",
  "periods.perWeekFrequency": "per uke",
  "periods.perMonthFrequency": "per måned",
  "periods.perYearFrequency": "per år",
  "periods.perDayFrequency": "per dag",
  "periods.unknownFrequency": "ukjent",
  "periods.weekFrequencyPlural": "hver {{amount}} uker",
  "periods.monthFrequencyPlural": "hver {{amount}} måneder",
  "periods.yearFrequencyPlural": "hver {{amount}} år",
  "periods.dayFrequencyPlural": "hver {{amount}} dager",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} gratis prøveperiode",
  "product_info.price_after_free_trial": "Etter prøveperioden slutter, den {{renewalDate}}",
  "product_info.renewal_frequency": "Fornyes {{frequency}}",
  "product_info.continues_until_cancelled": "Varer til den avbestilles",
  "product_info.cancel_anytime": "Avbestille når som helst",
  "payment_entry_page.payment_step_title": "Sikker betaling via RevenueCat",
  "payment_entry_page.button_pay": "Betal nå",
  "payment_entry_page.button_start_trial": "Start prøveperiode",
  "success_page.purchase_successful": "Betalingen er fullført",
  "success_page.button_close": "Fortsett",
  "error_page.if_error_persists": "Hvis feilen vedvarer, vennligst kontakt ",
  "error_page.error_title_already_subscribed": "Du abonnerer allerede på {{productTitle}}",
  "error_page.error_title_already_purchased": "Du har allerede kjøpt {{productTitle}}",
  "error_page.error_title_other_errors": "Noe gikk galt",
  "error_page.error_message_already_subscribed": "Du kan ikke abonnere på dette produktet igjen.",
  "error_page.error_message_already_purchased": "Du kan ikke kjøpe dette produktet igjen.",
  "error_page.error_message_missing_email_error": "E-post er nødvendig for å fullføre kjøpet.",
  "error_page.error_message_network_error": "Nettverksfeil. Vennligst sjekk internettforbindelsen din.",
  "error_page.error_message_error_charging_payment": "Betalingen mislyktes.",
  "error_page.error_message_error_setting_up_purchase": "Kjøpet ble ikke startet på grunn av en feil (feilkode: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Vi kunne ikke bekrefte faktureringsadressen din. Vennligst sjekk at postnummeret og landet er korrekte.",
  "error_page.error_message_unknown_error": "En ukjent feil oppstod (feilkode: {{errorCode}}).",
  "error_page.button_try_again": "Prøv igjen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Totalt forfaller i dag",
  "product_info.subscribe_to": "Abonner på",
  "navbar_header.details": "Detaljer",
  "navbar_header.back_button": "Tilbake",
  "pricing_dropdown.show_details": "Vis detaljer",
  "pricing_dropdown.hide_details": "Skjul detaljer",
  "pricing_table.tax": "Skatt",
  "pricing_table.trial_ends": "Etter prøveperioden slutter, den {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Totalt forfaller i dag",
  "pricing_table.total_excluding_tax": "Total eksklusive skatt",
  "pricing_table.enter_billing_address_to_calculate": "Oppgi faktureringsadresse for å beregne",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Skriv inn stat eller postnummer for å beregne",
  "pricing_table.enter_postal_code_to_calculate": "Skriv inn postnummer for å beregne",
  "error_page.error_message_invalid_email_error": "E-postadressen {{email}} kunne ikke bekreftes. Vennligst oppgi en gyldig e-postadresse.",
  "payment_entry_page.button_payment_method": "Betal {{formattedPrice}} med {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Betal {{formattedPrice}}",
  "price_update.title": "Prisoppdatering",
  "price_update.base_message": "Totalprisen er oppdatert med skatt basert på fakturaadressen din. Vennligst se gjennom og prøv igjen. Kortet ditt vil kun bli belastet én gang.",
  "price_update.trial_message": "Abonnementsprisen er oppdatert for å inkludere skatter basert på din fakturaadresse. Den gratis prøveperioden gjelder fortsatt. Vennligst sjekk og prøv igjen.",
  "payment_entry_page.express_checkout_divider": "ELLER BETAL MED KORT",
  "error_page.trouble_accessing": "Hvis du har problemer med å få tilgang til kjøpet ditt, kan du kontakte support på ",
  "error_page.close_button_title": "Gå til {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Mangler Stripe-tillatelse",
  "error_page.button_close": "Lukk",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Kjøpet mislyktes fordi skatteopprinnelsesadressen er ugyldig. I produksjon vil kjøp fungere uten at skatter brukes.",
  "error_page.error_message_stripe_tax_not_active": "Kjøpet mislyktes fordi Stripe Tax ikke er aktivert. I produksjon vil kjøp fungere uten at skatter brukes.",
  "error_page.error_only_in_sandbox": "Denne meldingen vises bare i sandkassen.",
  "error_page.error_message_stripe_missing_required_permission": "Kjøpet mislyktes fordi Stripe-appen mangler en nødvendig tillatelse. I produksjon vil kjøp fungere uten at skatter brukes.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax er ikke aktivt",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Ugyldig skatteopprinnelsesadresse",
  "apple_pay.free_trial": "Gratis prøveperiode",
  "product_info.price_after_intro_price": "Etter {{introPriceDuration}}, den {{renewalDate}}",
  "product_info.after_trial": "etter prøveperiode",
  "product_info.after": "etter",
  "product_info.intro_price_phase_after_trial": "Deretter {{introPriceDuration}} for {{introPrice}}",
  "product_info.intro_price_phase": "Først {{introPriceDuration}} for {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "betales én gang",
  "payment_entry_page.trial_subscription_terms_info": "Etter at prøveperioden din er over, blir du belastet {{price}} {{perFrequency}} fra og med {{renewalDate}}. Du kan kansellere når som helst før denne datoen.",
  "payment_entry_page.subscription_info": "Abonnementet fornyes automatisk. Avbryt når som helst.",
  "payment_entry_page.otp_terms_info": "Ved å kjøpe godtar du at {{appName}} belaster deg i henhold til deres vilkår.",
  "payment_entry_page.terms_link_label": "Vilkår",
  "payment_entry_page.subscription_terms_info": "Ved å abonnere godtar du at {{appName}} belaster deg i henhold til deres vilkår til du kansellerer.",
  "loading_page.keep_page_open": "Prosessen er nesten ferdig. Hold denne siden åpen.",
  "loading_page.processing_payment": "Behandler betaling",
  "pricing_table.discount": "Rabatt",
  "pricing_table.subtotal": "Subtotal"
}, Ng = {
  "periods.week": "{{amount}} tydzień",
  "periods.month": "{{amount}} miesiąc",
  "periods.year": "{{amount}} rok",
  "periods.day": "{{amount}} dzień",
  "periods.weekShort": "{{amount}}tydz",
  "periods.monthShort": "{{amount}}mies",
  "periods.yearShort": "{{amount}}rok",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "dożywotnio",
  "periods.weekPlural": "{{amount}} tygodni",
  "periods.monthPlural": "{{amount}} miesięcy",
  "periods.yearPlural": "{{amount}} lat",
  "periods.dayPlural": "{{amount}} dni",
  "periods.weekFrequency": "tygodniowo",
  "periods.monthFrequency": "miesięcznie",
  "periods.yearFrequency": "rocznie",
  "periods.dayFrequency": "dziennie",
  "periods.perWeekFrequency": "na tydzień",
  "periods.perMonthFrequency": "na miesiąc",
  "periods.perYearFrequency": "na rok",
  "periods.perDayFrequency": "na dzień",
  "periods.unknownFrequency": "nieznany",
  "periods.weekFrequencyPlural": "co {{amount}} tygodni",
  "periods.monthFrequencyPlural": "co {{amount}} miesięcy",
  "periods.yearFrequencyPlural": "co {{amount}} lat",
  "periods.dayFrequencyPlural": "co {{amount}} dni",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} dni próbnych",
  "product_info.price_after_free_trial": "Po zakończeniu okresu próbnego, dnia {{renewalDate}}",
  "product_info.renewal_frequency": "Odnawialny co {{frequency}}",
  "product_info.continues_until_cancelled": "Kontynuowane do momentu anulowania",
  "product_info.cancel_anytime": "Możesz anulować w dowolnym momencie",
  "payment_entry_page.payment_step_title": "Bezpieczna płatność przez RevenueCat",
  "payment_entry_page.button_pay": "Zapłać teraz",
  "payment_entry_page.button_start_trial": "Rozpocznij okres próbny",
  "success_page.purchase_successful": "Płatność zakończona",
  "success_page.button_close": "Kontynuuj",
  "error_page.if_error_persists": "Jeśli błąd będzie się powtarzał, skontaktuj się z ",
  "error_page.error_title_already_subscribed": "Już subskrybujesz {{productTitle}}",
  "error_page.error_title_already_purchased": "Już zakupiłeś/aś {{productTitle}}",
  "error_page.error_title_other_errors": "Coś poszło nie tak",
  "error_page.error_message_already_subscribed": "Nie możesz ponownie subskrybować tego produktu.",
  "error_page.error_message_already_purchased": "Nie możesz ponownie zakupić tego produktu.",
  "error_page.error_message_missing_email_error": "Adres e-mail jest wymagany do dokonania zakupu.",
  "error_page.error_message_network_error": "Błąd sieci. Sprawdź połączenie internetowe.",
  "error_page.error_message_error_charging_payment": "Płatność nieudana.",
  "error_page.error_message_error_setting_up_purchase": "Zakup nie został rozpoczęty z powodu błędu (kod błędu: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nie mogliśmy zweryfikować Twojego adresu rozliczeniowego. Sprawdź, czy kod pocztowy i kraj są poprawne.",
  "error_page.error_message_unknown_error": "Wystąpił nieznany błąd (kod błędu: {{errorCode}}).",
  "error_page.button_try_again": "Spróbuj ponownie",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Do zapłaty dzisiaj",
  "product_info.subscribe_to": "Subskrybuj",
  "navbar_header.details": "Szczegóły",
  "navbar_header.back_button": "Wstecz",
  "pricing_dropdown.show_details": "Pokaż szczegóły",
  "pricing_dropdown.hide_details": "Ukryj szczegóły",
  "pricing_table.tax": "Podatek",
  "pricing_table.trial_ends": "Po zakończeniu okresu próbnego, {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Suma należna dzisiaj",
  "pricing_table.total_excluding_tax": "Suma bez podatku",
  "pricing_table.enter_billing_address_to_calculate": "Wprowadź adres rozliczeniowy, aby obliczyć",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Wprowadź stan lub kod pocztowy, aby obliczyć",
  "pricing_table.enter_postal_code_to_calculate": "Wprowadź kod pocztowy, aby obliczyć",
  "error_page.error_message_invalid_email_error": "Nie można zweryfikować adresu e-mail {{email}}. Proszę podać prawidłowy adres e-mail.",
  "payment_entry_page.button_payment_method": "Zapłać {{formattedPrice}} przez {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Zapłać {{formattedPrice}}",
  "price_update.title": "Aktualizacja ceny",
  "price_update.base_message": "Cena całkowita została zaktualizowana o podatek na podstawie Twojego adresu rozliczeniowego. Sprawdź i spróbuj ponownie. Twoja karta zostanie obciążona tylko raz.",
  "price_update.trial_message": "Cena subskrypcji została zaktualizowana o podatki na podstawie Twojego adresu rozliczeniowego. Okres próbny nadal obowiązuje. Sprawdź i spróbuj ponownie.",
  "payment_entry_page.express_checkout_divider": "LUB ZAPŁAĆ KARTĄ",
  "error_page.trouble_accessing": "Jeśli masz problemy z dostępem do zakupu, skontaktuj się z działem pomocy pod adresem ",
  "error_page.close_button_title": "Przejdź do {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Brakujące uprawnienie Stripe",
  "error_page.button_close": "Zamknij",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Zakup nie powiódł się, ponieważ adres pochodzenia podatku jest nieprawidłowy. W środowisku produkcyjnym zakupy będą działać bez naliczania podatków.",
  "error_page.error_message_stripe_tax_not_active": "Zakup nie powiódł się, ponieważ Stripe Tax nie jest włączony. W środowisku produkcyjnym zakupy będą działać bez naliczania podatków.",
  "error_page.error_only_in_sandbox": "Ta wiadomość pojawia się tylko w środowisku testowym.",
  "error_page.error_message_stripe_missing_required_permission": "Zakup nie powiódł się, ponieważ aplikacja Stripe nie ma wymaganego uprawnienia. W środowisku produkcyjnym zakupy będą działać bez naliczania podatków.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax nieaktywny",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Nieprawidłowy adres pochodzenia podatku",
  "apple_pay.free_trial": "Okres próbny",
  "product_info.price_after_intro_price": "Po {{introPriceDuration}}, od {{renewalDate}}",
  "product_info.after_trial": "po okresie próbnym",
  "product_info.after": "po",
  "product_info.intro_price_phase_after_trial": "Następnie {{introPriceDuration}} za {{introPrice}}",
  "product_info.intro_price_phase": "Najpierw {{introPriceDuration}} za {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "płatne jednorazowo",
  "payment_entry_page.trial_subscription_terms_info": "Po zakończeniu okresu próbnego zostanie pobrana opłata w wysokości {{price}} {{perFrequency}} począwszy od {{renewalDate}}. Możesz anulować subskrypcję w dowolnym momencie przed tą datą.",
  "payment_entry_page.subscription_info": "Subskrypcja odnawia się automatycznie. Anuluj w dowolnym momencie.",
  "payment_entry_page.otp_terms_info": "Dokonując zakupu, zgadzasz się na obciążenie przez {{appName}} zgodnie z ich warunkami.",
  "payment_entry_page.terms_link_label": "Warunki",
  "payment_entry_page.subscription_terms_info": "Subskrybując, zgadzasz się na obciążanie przez {{appName}} zgodnie z ich warunkami do momentu anulowania.",
  "loading_page.keep_page_open": "Proces jest prawie zakończony. Pozostaw tę stronę otwartą.",
  "loading_page.processing_payment": "Przetwarzanie płatności",
  "pricing_table.discount": "Rabat",
  "pricing_table.subtotal": "Suma częściowa"
}, Lg = {
  "periods.week": "{{amount}} semana",
  "periods.month": "{{amount}} mês",
  "periods.year": "{{amount}} ano",
  "periods.day": "{{amount}} dia",
  "periods.weekShort": "{{amount}}sem",
  "periods.monthShort": "{{amount}}mês",
  "periods.yearShort": "{{amount}}ano",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "vitalício",
  "periods.weekPlural": "{{amount}} semanas",
  "periods.monthPlural": "{{amount}} meses",
  "periods.yearPlural": "{{amount}} anos",
  "periods.dayPlural": "{{amount}} dias",
  "periods.weekFrequency": "semanal",
  "periods.monthFrequency": "mensal",
  "periods.yearFrequency": "anual",
  "periods.dayFrequency": "diário",
  "periods.perWeekFrequency": "por semana",
  "periods.perMonthFrequency": "por mês",
  "periods.perYearFrequency": "por ano",
  "periods.perDayFrequency": "por dia",
  "periods.unknownFrequency": "desconhecido",
  "periods.weekFrequencyPlural": "a cada {{amount}} semanas",
  "periods.monthFrequencyPlural": "a cada {{amount}} meses",
  "periods.yearFrequencyPlural": "a cada {{amount}} anos",
  "periods.dayFrequencyPlural": "a cada {{amount}} dias",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} teste grátis",
  "product_info.price_after_free_trial": "Após o término do teste, em {{renewalDate}}",
  "product_info.renewal_frequency": "Renova {{frequency}}",
  "product_info.continues_until_cancelled": "Continua até ser cancelado",
  "product_info.cancel_anytime": "Cancelar a qualquer momento",
  "payment_entry_page.payment_step_title": "Pagamento seguro pela RevenueCat",
  "payment_entry_page.button_pay": "Pagar agora",
  "payment_entry_page.button_start_trial": "Iniciar Teste",
  "success_page.purchase_successful": "Pagamento concluído",
  "success_page.button_close": "Continuar",
  "error_page.if_error_persists": "Se o erro persistir, entre em contato com ",
  "error_page.error_title_already_subscribed": "Você já se inscreveu em {{productTitle}}",
  "error_page.error_title_already_purchased": "Você já comprou {{productTitle}}",
  "error_page.error_title_other_errors": "Algo deu errado",
  "error_page.error_message_already_subscribed": "Você não pode se inscrever neste produto novamente.",
  "error_page.error_message_already_purchased": "Você não pode comprar este produto novamente.",
  "error_page.error_message_missing_email_error": "Email é necessário para concluir a compra.",
  "error_page.error_message_network_error": "Erro de rede. Verifique sua conexão com a internet.",
  "error_page.error_message_error_charging_payment": "Pagamento falhou.",
  "error_page.error_message_error_setting_up_purchase": "Compra não iniciada devido a um erro (código de erro: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Não conseguimos verificar seu endereço de cobrança. Por favor, verifique se o código postal e o país estão corretos.",
  "error_page.error_message_unknown_error": "Ocorreu um erro desconhecido (código de erro: {{errorCode}}).",
  "error_page.button_try_again": "Tentar novamente",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Total a pagar hoje",
  "product_info.subscribe_to": "Subscrever",
  "navbar_header.details": "Detalhes",
  "navbar_header.back_button": "Voltar",
  "pricing_dropdown.show_details": "Mostrar detalhes",
  "pricing_dropdown.hide_details": "Ocultar detalhes",
  "pricing_table.tax": "Imposto",
  "pricing_table.trial_ends": "Após o término do período de avaliação, em {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total a pagar hoje",
  "pricing_table.total_excluding_tax": "Total sem impostos",
  "pricing_table.enter_billing_address_to_calculate": "Insira o endereço de cobrança para calcular",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Insira o estado ou o CEP para calcular",
  "pricing_table.enter_postal_code_to_calculate": "Insira o CEP para calcular",
  "error_page.error_message_invalid_email_error": "O endereço de e-mail {{email}} não pôde ser verificado. Por favor, forneça um endereço de e-mail válido.",
  "payment_entry_page.button_payment_method": "Pagar {{formattedPrice}} com {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Pagar {{formattedPrice}}",
  "price_update.title": "Atualização de preço",
  "price_update.base_message": "O preço total foi atualizado com impostos com base no seu endereço de cobrança. Por favor, revise e tente novamente. Seu cartão só será cobrado uma vez.",
  "price_update.trial_message": "O preço da assinatura foi atualizado para incluir impostos com base no seu endereço de faturação. O período de teste gratuito continua válido. Por favor, verifique e tente novamente.",
  "payment_entry_page.express_checkout_divider": "OU PAGUE COM CARTÃO",
  "error_page.trouble_accessing": "Se estiver com problemas para acessar sua compra, entre em contato com o suporte em ",
  "error_page.close_button_title": "Ir para {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Permissão do Stripe em falta",
  "error_page.button_close": "Fechar",
  "error_page.error_message_stripe_invalid_tax_origin_address": "A compra falhou porque o endereço de origem fiscal é inválido. Em produção, as compras funcionarão sem impostos aplicados.",
  "error_page.error_message_stripe_tax_not_active": "A compra falhou porque o Stripe Tax não está ativado. Em produção, as compras funcionarão sem impostos aplicados.",
  "error_page.error_only_in_sandbox": "Esta mensagem aparece apenas na sandbox.",
  "error_page.error_message_stripe_missing_required_permission": "A compra falhou porque o aplicativo Stripe não tem uma permissão necessária. Em produção, as compras funcionarão sem impostos aplicados.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax não está ativo",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Endereço de origem fiscal inválido",
  "apple_pay.free_trial": "Teste Gratuito",
  "product_info.price_after_intro_price": "Após {{introPriceDuration}}, em {{renewalDate}}",
  "product_info.after_trial": "após o período de teste",
  "product_info.after": "após",
  "product_info.intro_price_phase_after_trial": "Depois, {{introPriceDuration}} por {{introPrice}}",
  "product_info.intro_price_phase": "Primeiro, {{introPriceDuration}} por {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "pago uma vez",
  "payment_entry_page.trial_subscription_terms_info": "Após o término do período de avaliação, será cobrado o valor de {{price}} {{perFrequency}} a partir de {{renewalDate}}. Pode cancelar a qualquer momento antes desta data.",
  "payment_entry_page.subscription_info": "A subscrição é renovada automaticamente. Cancele a qualquer momento.",
  "payment_entry_page.otp_terms_info": "Ao comprar, você concorda em permitir que o {{appName}} cobre de acordo com os termos deles.",
  "payment_entry_page.terms_link_label": "Termos",
  "payment_entry_page.subscription_terms_info": "Ao subscrever, concorda em permitir que a {{appName}} lhe cobre de acordo com os seus termos até cancelar.",
  "loading_page.keep_page_open": "O processo está quase concluído. Mantenha esta página aberta.",
  "loading_page.processing_payment": "Processando o pagamento",
  "pricing_table.discount": "Desconto",
  "pricing_table.subtotal": "Subtotal"
}, Bg = {
  "periods.week": "{{amount}} săptămână",
  "periods.month": "{{amount}} lună",
  "periods.year": "{{amount}} an",
  "periods.day": "{{amount}} zi",
  "periods.weekShort": "{{amount}}săpt",
  "periods.monthShort": "{{amount}}lun",
  "periods.yearShort": "{{amount}}an",
  "periods.dayShort": "{{amount}}z",
  "periods.lifetime": "pe viață",
  "periods.weekPlural": "{{amount}} săptămâni",
  "periods.monthPlural": "{{amount}} luni",
  "periods.yearPlural": "{{amount}} ani",
  "periods.dayPlural": "{{amount}} zile",
  "periods.weekFrequency": "săptămânal",
  "periods.monthFrequency": "lunar",
  "periods.yearFrequency": "anual",
  "periods.dayFrequency": "zilnic",
  "periods.perWeekFrequency": "pe săptămână",
  "periods.perMonthFrequency": "pe lună",
  "periods.perYearFrequency": "pe an",
  "periods.perDayFrequency": "pe zi",
  "periods.unknownFrequency": "necunoscut",
  "periods.weekFrequencyPlural": "la fiecare {{amount}} săptămâni",
  "periods.monthFrequencyPlural": "la fiecare {{amount}} luni",
  "periods.yearFrequencyPlural": "la fiecare {{amount}} ani",
  "periods.dayFrequencyPlural": "la fiecare {{amount}} zile",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} perioadă de probă gratuită",
  "product_info.price_after_free_trial": "După terminarea perioadei de probă, pe {{renewalDate}}",
  "product_info.renewal_frequency": "Se reînnoiește {{frequency}}",
  "product_info.continues_until_cancelled": "Continuă până la anulare",
  "product_info.cancel_anytime": "Anulare oricând",
  "payment_entry_page.payment_step_title": "Plata securizată prin RevenueCat",
  "payment_entry_page.button_pay": "Plătește acum",
  "payment_entry_page.button_start_trial": "Începe perioada de probă",
  "success_page.purchase_successful": "Plata efectuată",
  "success_page.button_close": "Continuă",
  "error_page.if_error_persists": "Dacă eroarea persistă, vă rugăm să contactați ",
  "error_page.error_title_already_subscribed": "Sunteți deja abonat la {{productTitle}}",
  "error_page.error_title_already_purchased": "Ați achiziționat deja {{productTitle}}",
  "error_page.error_title_other_errors": "A apărut o eroare",
  "error_page.error_message_already_subscribed": "Nu vă puteți abona din nou la acest produs.",
  "error_page.error_message_already_purchased": "Nu puteți achiziționa din nou acest produs.",
  "error_page.error_message_missing_email_error": "Adresa de e-mail este necesară pentru a finaliza achiziția.",
  "error_page.error_message_network_error": "Eroare de rețea. Verificați conexiunea la internet.",
  "error_page.error_message_error_charging_payment": "Plata a eșuat.",
  "error_page.error_message_error_setting_up_purchase": "Achiziția nu a putut fi inițiată din cauza unei erori (cod de eroare: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nu am putut verifica adresa de facturare. Vă rugăm să verificați dacă codul poștal și țara sunt corecte.",
  "error_page.error_message_unknown_error": "A apărut o eroare necunoscută (cod de eroare: {{errorCode}}).",
  "error_page.button_try_again": "Încearcă din nou",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Total de plată astăzi",
  "product_info.subscribe_to": "Abonare la",
  "navbar_header.details": "Detalii",
  "navbar_header.back_button": "Înapoi",
  "pricing_dropdown.show_details": "Arată detalii",
  "pricing_dropdown.hide_details": "Ascunde detalii",
  "pricing_table.tax": "Taxă",
  "pricing_table.trial_ends": "După ce perioada de probă se termină, pe {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total de plătit astăzi",
  "pricing_table.total_excluding_tax": "Total fără taxe",
  "pricing_table.enter_billing_address_to_calculate": "Introduceți adresa de facturare pentru a calcula",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Introduceți statul sau codul poștal pentru a calcula",
  "pricing_table.enter_postal_code_to_calculate": "Introduceți codul poștal pentru a calcula",
  "error_page.error_message_invalid_email_error": "Adresa de e-mail {{email}} nu a putut fi verificată. Vă rugăm să furnizați o adresă de e-mail validă.",
  "payment_entry_page.button_payment_method": "Plătește {{formattedPrice}} cu {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Plătește {{formattedPrice}}",
  "price_update.title": "Actualizare preț",
  "price_update.base_message": "Prețul total a fost actualizat cu taxe, în funcție de adresa dumneavoastră de facturare. Vă rugăm să revizuiți și să încercați din nou. Cardul dumneavoastră va fi debitat o singură dată.",
  "price_update.trial_message": "Prețul abonamentului a fost actualizat pentru a include taxele bazate pe adresa dvs. de facturare. Perioada de probă gratuită rămâne valabilă. Vă rugăm să verificați și să încercați din nou.",
  "payment_entry_page.express_checkout_divider": "SAU PLĂTEȘTE CU CARDUL",
  "error_page.trouble_accessing": "Dacă întâmpini probleme în accesarea achiziției tale, contactează serviciul de asistență la ",
  "error_page.close_button_title": "Mergi la {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Permisiune Stripe lipsă",
  "error_page.button_close": "Închide",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Achiziția a eșuat deoarece adresa de origine fiscală este nevalidă. În producție, achizițiile vor funcționa fără taxe aplicate.",
  "error_page.error_message_stripe_tax_not_active": "Achiziția a eșuat deoarece Stripe Tax nu este activat. În producție, achizițiile vor funcționa fără taxe aplicate.",
  "error_page.error_only_in_sandbox": "Acest mesaj apare doar în sandbox.",
  "error_page.error_message_stripe_missing_required_permission": "Achiziția a eșuat deoarece aplicației Stripe îi lipsește o permisiune necesară. În producție, achizițiile vor funcționa fără taxe aplicate.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax nu este activ",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Adresă de origine fiscală Stripe nevalidă",
  "apple_pay.free_trial": "Perioadă de probă gratuită",
  "product_info.price_after_intro_price": "După {{introPriceDuration}}, pe {{renewalDate}}",
  "product_info.after_trial": "după perioada de probă",
  "product_info.after": "după",
  "product_info.intro_price_phase_after_trial": "Apoi {{introPriceDuration}} pentru {{introPrice}}",
  "product_info.intro_price_phase": "Mai întâi {{introPriceDuration}} pentru {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "plătit o singură dată",
  "payment_entry_page.trial_subscription_terms_info": "După ce perioada de probă se termină, veți fi taxat cu {{price}} {{perFrequency}} începând cu {{renewalDate}}. Puteți anula oricând înainte de această dată.",
  "payment_entry_page.subscription_info": "Abonamentul se reînnoiește automat. Anulați oricând.",
  "payment_entry_page.otp_terms_info": "Prin achiziționarea, sunteți de acord să permiteți {{appName}} să vă taxeze conform termenilor săi.",
  "payment_entry_page.terms_link_label": "Termeni",
  "payment_entry_page.subscription_terms_info": "Prin abonare, sunteți de acord să permiteți {{appName}} să vă taxeze conform termenilor săi până la anulare.",
  "loading_page.keep_page_open": "Procesul este aproape finalizat. Păstrați această pagină deschisă.",
  "loading_page.processing_payment": "Se procesează plata",
  "pricing_table.discount": "Reducere",
  "pricing_table.subtotal": "Subtotal"
}, Ug = {
  "periods.week": "{{amount}} неделя",
  "periods.month": "{{amount}} месяц",
  "periods.year": "{{amount}} год",
  "periods.day": "{{amount}} день",
  "periods.weekShort": "{{amount}}нед",
  "periods.monthShort": "{{amount}}мес",
  "periods.yearShort": "{{amount}}г",
  "periods.dayShort": "{{amount}}д",
  "periods.lifetime": "пожизненно",
  "periods.weekPlural": "{{amount}} недель",
  "periods.monthPlural": "{{amount}} месяцев",
  "periods.yearPlural": "{{amount}} лет",
  "periods.dayPlural": "{{amount}} дней",
  "periods.weekFrequency": "еженедельно",
  "periods.monthFrequency": "ежемесячно",
  "periods.yearFrequency": "ежегодно",
  "periods.dayFrequency": "ежедневно",
  "periods.perWeekFrequency": "в неделю",
  "periods.perMonthFrequency": "в месяц",
  "periods.perYearFrequency": "в год",
  "periods.perDayFrequency": "в день",
  "periods.unknownFrequency": "неизвестно",
  "periods.weekFrequencyPlural": "каждые {{amount}} недель",
  "periods.monthFrequencyPlural": "каждые {{amount}} месяцев",
  "periods.yearFrequencyPlural": "каждые {{amount}} лет",
  "periods.dayFrequencyPlural": "каждые {{amount}} дней",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} бесплатная пробная версия",
  "product_info.price_after_free_trial": "После окончания пробного периода, {{renewalDate}}",
  "product_info.renewal_frequency": "Продлевается {{frequency}}",
  "product_info.continues_until_cancelled": "Продолжается до отмены",
  "product_info.cancel_anytime": "Отменить в любое время",
  "payment_entry_page.payment_step_title": "Безопасная оплата через RevenueCat",
  "payment_entry_page.button_pay": "Оплатить сейчас",
  "payment_entry_page.button_start_trial": "Начать пробный период",
  "success_page.purchase_successful": "Оплата завершена",
  "success_page.button_close": "Продолжить",
  "error_page.if_error_persists": "Если ошибка сохраняется, пожалуйста, свяжитесь с ",
  "error_page.error_title_already_subscribed": "Вы уже подписаны на {{productTitle}}",
  "error_page.error_title_already_purchased": "Вы уже приобрели {{productTitle}}",
  "error_page.error_title_other_errors": "Что-то пошло не так",
  "error_page.error_message_already_subscribed": "Вы не можете подписаться на этот продукт повторно.",
  "error_page.error_message_already_purchased": "Вы не можете приобрести этот продукт повторно.",
  "error_page.error_message_missing_email_error": "Для завершения покупки необходим адрес электронной почты.",
  "error_page.error_message_network_error": "Ошибка сети. Проверьте ваше интернет-соединение.",
  "error_page.error_message_error_charging_payment": "Оплата не прошла.",
  "error_page.error_message_error_setting_up_purchase": "Покупка не была начата из-за ошибки (код ошибки: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Мы не смогли проверить ваш платежный адрес. Пожалуйста, проверьте, что почтовый индекс и страна указаны правильно.",
  "error_page.error_message_unknown_error": "Произошла неизвестная ошибка (код ошибки: {{errorCode}}).",
  "error_page.button_try_again": "Повторить попытку",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Всего к оплате сегодня",
  "product_info.subscribe_to": "Подписаться",
  "navbar_header.details": "Детали",
  "navbar_header.back_button": "Назад",
  "pricing_dropdown.show_details": "Показать детали",
  "pricing_dropdown.hide_details": "Скрыть детали",
  "pricing_table.tax": "Налог",
  "pricing_table.trial_ends": "После окончания пробного периода, {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Итого к оплате сегодня",
  "pricing_table.total_excluding_tax": "Итого без учета налога",
  "pricing_table.enter_billing_address_to_calculate": "Введите платежный адрес для расчета",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Введите штат или почтовый индекс для расчета",
  "pricing_table.enter_postal_code_to_calculate": "Введите почтовый индекс для расчета",
  "error_page.error_message_invalid_email_error": "Не удалось проверить адрес электронной почты {{email}}. Пожалуйста, укажите действительный адрес электронной почты.",
  "payment_entry_page.button_payment_method": "Оплатить {{formattedPrice}} через {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Оплатить {{formattedPrice}}",
  "price_update.title": "Обновление цены",
  "price_update.base_message": "Общая цена была обновлена с учетом налога на основе вашего платежного адреса. Пожалуйста, проверьте и повторите попытку. С вашей карты будет списано только один раз.",
  "price_update.trial_message": "Цена подписки была обновлена с учетом налогов на основе вашего платежного адреса. Пробный период остается бесплатным. Пожалуйста, проверьте и попробуйте снова.",
  "payment_entry_page.express_checkout_divider": "ИЛИ ОПЛАТИТЕ КАРТОЙ",
  "error_page.trouble_accessing": "Если у вас возникли проблемы с доступом к вашей покупке, обратитесь в службу поддержки по адресу ",
  "error_page.close_button_title": "Перейти в {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Отсутствует разрешение Stripe",
  "error_page.button_close": "Закрыть",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Покупка не удалась, так как адрес отправления налога недействителен. В рабочей среде покупки будут работать без применения налогов.",
  "error_page.error_message_stripe_tax_not_active": "Покупка не удалась, так как Stripe Tax не включен. В рабочей среде покупки будут работать без применения налогов.",
  "error_page.error_only_in_sandbox": "Это сообщение появляется только в песочнице.",
  "error_page.error_message_stripe_missing_required_permission": "Покупка не удалась, так как у приложения Stripe отсутствует необходимое разрешение. В рабочей среде покупки будут работать без применения налогов.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax не активен",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Недействительный адрес отправления налога",
  "apple_pay.free_trial": "Бесплатная пробная версия",
  "product_info.price_after_intro_price": "После {{introPriceDuration}}, {{renewalDate}}",
  "product_info.after_trial": "после пробного периода",
  "product_info.after": "после",
  "product_info.intro_price_phase_after_trial": "Затем {{introPriceDuration}} за {{introPrice}}",
  "product_info.intro_price_phase": "Сначала {{introPriceDuration}} за {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "единоразовый платеж",
  "payment_entry_page.trial_subscription_terms_info": "По окончании пробного периода с вас будет взиматься плата в размере {{price}} {{perFrequency}}, начиная с {{renewalDate}}. Вы можете отменить подписку в любое время до этой даты.",
  "payment_entry_page.subscription_info": "Подписка продлевается автоматически. Отменить можно в любое время.",
  "payment_entry_page.otp_terms_info": "Совершая покупку, вы соглашаетесь с тем, что {{appName}} будет взимать с вас плату в соответствии со своими условиями.",
  "payment_entry_page.terms_link_label": "Условия",
  "payment_entry_page.subscription_terms_info": "Подписываясь, вы соглашаетесь с тем, что {{appName}} будет взимать с вас плату в соответствии с их условиями до тех пор, пока вы не отмените подписку.",
  "loading_page.keep_page_open": "Процесс почти завершен. Не закрывайте эту страницу.",
  "loading_page.processing_payment": "Обработка платежа",
  "pricing_table.discount": "Скидка",
  "pricing_table.subtotal": "Итого"
}, Rg = {
  "periods.week": "{{amount}} týždeň",
  "periods.month": "{{amount}} mesiac",
  "periods.year": "{{amount}} rok",
  "periods.day": "{{amount}} deň",
  "periods.weekShort": "{{amount}}týž",
  "periods.monthShort": "{{amount}}mes",
  "periods.yearShort": "{{amount}}rok",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "doživotne",
  "periods.weekPlural": "{{amount}} týždňov",
  "periods.monthPlural": "{{amount}} mesiacov",
  "periods.yearPlural": "{{amount}} rokov",
  "periods.dayPlural": "{{amount}} dní",
  "periods.weekFrequency": "týždenne",
  "periods.monthFrequency": "mesačne",
  "periods.yearFrequency": "ročne",
  "periods.dayFrequency": "denne",
  "periods.perWeekFrequency": "týždenne",
  "periods.perMonthFrequency": "mesačne",
  "periods.perYearFrequency": "ročne",
  "periods.perDayFrequency": "denne",
  "periods.unknownFrequency": "neznáme",
  "periods.weekFrequencyPlural": "každých {{amount}} týždňov",
  "periods.monthFrequencyPlural": "každých {{amount}} mesiacov",
  "periods.yearFrequencyPlural": "každých {{amount}} rokov",
  "periods.dayFrequencyPlural": "každých {{amount}} dní",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} bezplatné skúšobné obdobie",
  "product_info.price_after_free_trial": "Po skončení skúšobného obdobia, dňa {{renewalDate}}",
  "product_info.renewal_frequency": "Obnovuje sa {{frequency}}",
  "product_info.continues_until_cancelled": "Pokračuje, kým sa nezruší",
  "product_info.cancel_anytime": "Kedykoľvek zrušiť",
  "payment_entry_page.payment_step_title": "Bezpečný nákup prostredníctvom RevenueCat",
  "payment_entry_page.button_pay": "Zaplatiť teraz",
  "payment_entry_page.button_start_trial": "Spustiť skúšobné obdobie",
  "success_page.purchase_successful": "Platba dokončená",
  "success_page.button_close": "Pokračovať",
  "error_page.if_error_persists": "Ak chyba pretrváva, kontaktujte ",
  "error_page.error_title_already_subscribed": "Už ste si predplatili {{productTitle}}",
  "error_page.error_title_already_purchased": "Už ste si zakúpili {{productTitle}}",
  "error_page.error_title_other_errors": "Niečo sa pokazilo",
  "error_page.error_message_already_subscribed": "Na tento produkt sa nemôžete znova prihlásiť na odber.",
  "error_page.error_message_already_purchased": "Tento produkt si nemôžete znova zakúpiť.",
  "error_page.error_message_missing_email_error": "Na dokončenie nákupu je potrebný e-mail.",
  "error_page.error_message_network_error": "Chyba siete. Skontrolujte svoje internetové pripojenie.",
  "error_page.error_message_error_charging_payment": "Platba zlyhala.",
  "error_page.error_message_error_setting_up_purchase": "Nákup sa nespustil kvôli chybe (kód chyby: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nepodarilo sa nám overiť vašu fakturačnú adresu. Skontrolujte, prosím, či je PSČ a krajina správne.",
  "error_page.error_message_unknown_error": "Vyskytla sa neznáma chyba (kód chyby: {{errorCode}}).",
  "error_page.button_try_again": "Skúsiť znova",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Celková suma splatná dnes",
  "product_info.subscribe_to": "Prihlásiť sa na odber",
  "navbar_header.details": "Podrobnosti",
  "navbar_header.back_button": "Späť",
  "pricing_dropdown.show_details": "Zobraziť podrobnosti",
  "pricing_dropdown.hide_details": "Skryť podrobnosti",
  "pricing_table.tax": "Daň",
  "pricing_table.trial_ends": "Po skončení skúšobnej verzie, dňa {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Celková suma splatná dnes",
  "pricing_table.total_excluding_tax": "Celkom bez dane",
  "pricing_table.enter_billing_address_to_calculate": "Zadajte fakturačnú adresu pre výpočet",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Zadajte štát alebo PSČ pre výpočet",
  "pricing_table.enter_postal_code_to_calculate": "Zadajte PSČ pre výpočet",
  "error_page.error_message_invalid_email_error": "E-mailová adresa {{email}} sa nedala overiť. Zadajte platnú e-mailovú adresu.",
  "payment_entry_page.button_payment_method": "Zaplatiť sumu {{formattedPrice}} pomocou {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Zaplatiť {{formattedPrice}}",
  "price_update.title": "Aktualizácia ceny",
  "price_update.base_message": "Celková cena bola aktualizovaná o daň na základe vašej fakturačnej adresy. Skontrolujte to a skúste znova. Vaša karta bude zaťažená iba raz.",
  "price_update.trial_message": "Cena predplatného bola aktualizovaná o daňe na základe vašej fakturačnej adresy. Bezplatná skúšobná doba stále platí. Prosím, skontrolujte a skúste znova.",
  "payment_entry_page.express_checkout_divider": "ALEBO ZAPLATIŤ KARTOU",
  "error_page.trouble_accessing": "Ak máte problémy s prístupom k svojmu nákupu, kontaktujte podporu na ",
  "error_page.close_button_title": "Prejsť na {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Chýbajúce povolenie Stripe",
  "error_page.button_close": "Zavrieť",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Nákup sa nepodaril, pretože adresa pôvodu dane je neplatná. V produkčnom prostredí budú nákupy fungovať bez uplatnenia daní.",
  "error_page.error_message_stripe_tax_not_active": "Nákup sa nepodaril, pretože Stripe Tax nie je povolený. V produkčnom prostredí budú nákupy fungovať bez uplatnenia daní.",
  "error_page.error_only_in_sandbox": "Táto správa sa zobrazuje iba v testovacom prostredí (sandbox).",
  "error_page.error_message_stripe_missing_required_permission": "Nákup sa nepodaril, pretože aplikácii Stripe chýba požadované povolenie. V produkčnom prostredí budú nákupy fungovať bez uplatnenia daní.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax nie je aktívny",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Neplatná adresa pôvodu dane",
  "apple_pay.free_trial": "Skúšobná verzia zdarma",
  "product_info.price_after_intro_price": "Po {{introPriceDuration}}, dňa {{renewalDate}}",
  "product_info.after_trial": "po skúšobnej dobe",
  "product_info.after": "po",
  "product_info.intro_price_phase_after_trial": "Potom {{introPriceDuration}} za {{introPrice}}",
  "product_info.intro_price_phase": "Najprv {{introPriceDuration}} za {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "zaplatené jednorazovo",
  "payment_entry_page.trial_subscription_terms_info": "Po skončení skúšobného obdobia vám bude účtovaná suma {{price}} {{perFrequency}} počnúc dňom {{renewalDate}}. Pred týmto dátumom môžete kedykoľvek zrušiť.",
  "payment_entry_page.subscription_info": "Predplatné sa automaticky obnovuje. Zrušiť môžete kedykoľvek.",
  "payment_entry_page.otp_terms_info": "Zakúpením súhlasíte s tým, že spoločnosti {{appName}} umožníte účtovať vám poplatky v súlade s jej podmienkami.",
  "payment_entry_page.terms_link_label": "Podmienky",
  "payment_entry_page.subscription_terms_info": "Prihlásením na odber súhlasíte s tým, že spoločnosť {{appName}} vám bude účtovať poplatky podľa svojich podmienok, až kým odber nezrušíte.",
  "loading_page.keep_page_open": "Proces sa takmer dokončil. Nechajte túto stránku otvorenú.",
  "loading_page.processing_payment": "Spracováva sa platba",
  "pricing_table.discount": "Zľava",
  "pricing_table.subtotal": "Medzisúčet"
}, Vg = {
  "periods.week": "{{amount}} vecka",
  "periods.month": "{{amount}} månad",
  "periods.year": "{{amount}} år",
  "periods.day": "{{amount}} dag",
  "periods.weekShort": "{{amount}}v",
  "periods.monthShort": "{{amount}}mån",
  "periods.yearShort": "{{amount}}år",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "livstid",
  "periods.weekPlural": "{{amount}} veckor",
  "periods.monthPlural": "{{amount}} månader",
  "periods.yearPlural": "{{amount}} år",
  "periods.dayPlural": "{{amount}} dagar",
  "periods.weekFrequency": "veckovis",
  "periods.monthFrequency": "månadsvis",
  "periods.yearFrequency": "årligen",
  "periods.dayFrequency": "dagligen",
  "periods.perWeekFrequency": "per vecka",
  "periods.perMonthFrequency": "per månad",
  "periods.perYearFrequency": "per år",
  "periods.perDayFrequency": "per dag",
  "periods.unknownFrequency": "okänd",
  "periods.weekFrequencyPlural": "varje {{amount}} veckor",
  "periods.monthFrequencyPlural": "varje {{amount}} månader",
  "periods.yearFrequencyPlural": "varje {{amount}} år",
  "periods.dayFrequencyPlural": "varje {{amount}} dagar",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} gratis provperiod",
  "product_info.price_after_free_trial": "Efter provperioden slutar, den {{renewalDate}}",
  "product_info.renewal_frequency": "Förnyas {{frequency}}",
  "product_info.continues_until_cancelled": "Gäller tills avbokad",
  "product_info.cancel_anytime": "Avboka när som helst",
  "payment_entry_page.payment_step_title": "Säker betalning via RevenueCat",
  "payment_entry_page.button_pay": "Betala nu",
  "payment_entry_page.button_start_trial": "Starta provperiod",
  "success_page.purchase_successful": "Betalningen är klar",
  "success_page.button_close": "Fortsätt",
  "error_page.if_error_persists": "Om felet kvarstår, vänligen kontakta ",
  "error_page.error_title_already_subscribed": "Du prenumererar redan på {{productTitle}}",
  "error_page.error_title_already_purchased": "Du har redan köpt {{productTitle}}",
  "error_page.error_title_other_errors": "Något gick fel",
  "error_page.error_message_already_subscribed": "Du kan inte prenumerera på den här produkten igen.",
  "error_page.error_message_already_purchased": "Du kan inte köpa den här produkten igen.",
  "error_page.error_message_missing_email_error": "E-post krävs för att slutföra köpet.",
  "error_page.error_message_network_error": "Nätverksfel. Kontrollera din internetanslutning.",
  "error_page.error_message_error_charging_payment": "Betalningen misslyckades.",
  "error_page.error_message_error_setting_up_purchase": "Köp kunde inte startas på grund av ett fel (felkod: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Vi kunde inte verifiera din faktureringsadress. Kontrollera att postnummer och land är korrekta.",
  "error_page.error_message_unknown_error": "Ett okänt fel inträffade (felkod: {{errorCode}}).",
  "error_page.button_try_again": "Försök igen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Totalt att betala idag",
  "product_info.subscribe_to": "Prenumerera på",
  "navbar_header.details": "Detaljer",
  "navbar_header.back_button": "Tillbaka",
  "pricing_dropdown.show_details": "Visa detaljer",
  "pricing_dropdown.hide_details": "Dölj detaljer",
  "pricing_table.tax": "Moms",
  "pricing_table.trial_ends": "Efter provperiodens slut, den {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total summa att betala idag",
  "pricing_table.total_excluding_tax": "Totalt exklusive moms",
  "pricing_table.enter_billing_address_to_calculate": "Ange faktureringsadress för att beräkna",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Ange delstat eller postnummer för att beräkna",
  "pricing_table.enter_postal_code_to_calculate": "Ange postnummer för att beräkna",
  "error_page.error_message_invalid_email_error": "E-postadressen {{email}} kunde inte verifieras. Ange en giltig e-postadress.",
  "payment_entry_page.button_payment_method": "Betala {{formattedPrice}} med {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Betala {{formattedPrice}}",
  "price_update.title": "Prisuppdatering",
  "price_update.base_message": "Det totala priset har uppdaterats med moms baserat på din faktureringsadress. Granska och försök igen. Ditt kort kommer endast att debiteras en gång.",
  "price_update.trial_message": "Prenumerationspriset har uppdaterats för att inkludera skatter baserat på din fakturaadress. Den kostnadsfria provperioden gäller fortfarande. Kontrollera och försök igen.",
  "payment_entry_page.express_checkout_divider": "ELLER BETALA MED KORT",
  "error_page.trouble_accessing": "Om du har problem med att komma åt ditt köp, kontakta support på ",
  "error_page.close_button_title": "Gå till {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Saknar Stripe-behörighet",
  "error_page.button_close": "Stäng",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Köpet misslyckades eftersom skatteursprungsadressen är ogiltig. I produktion kommer köp att fungera utan att skatter tillämpas.",
  "error_page.error_message_stripe_tax_not_active": "Köpet misslyckades eftersom Stripe Tax inte är aktiverat. I produktion kommer köp att fungera utan att skatter tillämpas.",
  "error_page.error_only_in_sandbox": "Det här meddelandet visas bara i sandlådan.",
  "error_page.error_message_stripe_missing_required_permission": "Köpet misslyckades eftersom Stripe-appen saknar en nödvändig behörighet. I produktion kommer köp att fungera utan att skatter tillämpas.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax är inte aktivt",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Ogiltig skatteursprungsadress",
  "apple_pay.free_trial": "Gratis provperiod",
  "product_info.price_after_intro_price": "Efter {{introPriceDuration}}, den {{renewalDate}}",
  "product_info.after_trial": "efter provperioden",
  "product_info.after": "efter",
  "product_info.intro_price_phase_after_trial": "Sedan {{introPriceDuration}} för {{introPrice}}",
  "product_info.intro_price_phase": "Först {{introPriceDuration}} för {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "betalas en gång",
  "payment_entry_page.trial_subscription_terms_info": "Efter att din provperiod slutar debiteras du {{price}} {{perFrequency}} från och med {{renewalDate}}. Du kan avbryta när som helst före detta datum.",
  "payment_entry_page.subscription_info": "Prenumerationen förnyas automatiskt. Avbryt när som helst.",
  "payment_entry_page.otp_terms_info": "Genom att köpa godkänner du att {{appName}} debiterar dig i enlighet med deras villkor.",
  "payment_entry_page.terms_link_label": "Villkor",
  "payment_entry_page.subscription_terms_info": "Genom att prenumerera godkänner du att {{appName}} debiterar dig i enlighet med deras villkor tills du avbryter.",
  "loading_page.keep_page_open": "Processen är nästan klar. Håll den här sidan öppen.",
  "loading_page.processing_payment": "Behandlar betalning",
  "pricing_table.discount": "Rabatt",
  "pricing_table.subtotal": "Delsumma"
}, Hg = {
  "periods.week": "{{amount}} สัปดาห์",
  "periods.month": "{{amount}} เดือน",
  "periods.year": "{{amount}} ปี",
  "periods.day": "{{amount}} วัน",
  "periods.weekShort": "{{amount}} สัปดาห์",
  "periods.monthShort": "{{amount}} เดือน",
  "periods.yearShort": "{{amount}} ปี",
  "periods.dayShort": "{{amount}} วัน",
  "periods.lifetime": "ตลอดชีพ",
  "periods.weekPlural": "{{amount}} สัปดาห์",
  "periods.monthPlural": "{{amount}} เดือน",
  "periods.yearPlural": "{{amount}} ปี",
  "periods.dayPlural": "{{amount}} วัน",
  "periods.weekFrequency": "รายสัปดาห์",
  "periods.monthFrequency": "รายเดือน",
  "periods.yearFrequency": "รายปี",
  "periods.dayFrequency": "รายวัน",
  "periods.perWeekFrequency": "ต่อสัปดาห์",
  "periods.perMonthFrequency": "ต่อเดือน",
  "periods.perYearFrequency": "ต่อปี",
  "periods.perDayFrequency": "ต่อวัน",
  "periods.unknownFrequency": "ไม่รู้จัก",
  "periods.weekFrequencyPlural": "ทุกๆ {{amount}} สัปดาห์",
  "periods.monthFrequencyPlural": "ทุกๆ {{amount}} เดือน",
  "periods.yearFrequencyPlural": "ทุกๆ {{amount}} ปี",
  "periods.dayFrequencyPlural": "ทุกๆ {{amount}} วัน",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} ทดลองใช้ฟรี",
  "product_info.price_after_free_trial": "หลังจากสิ้นสุดการทดลองใช้ ในวันที่ {{renewalDate}}",
  "product_info.renewal_frequency": "ต่ออายุ {{frequency}}",
  "product_info.continues_until_cancelled": "ต่อเนื่องจนกว่าจะยกเลิก",
  "product_info.cancel_anytime": "ยกเลิกได้ตลอดเวลา",
  "payment_entry_page.payment_step_title": "การชำระเงินอย่างปลอดภัยโดย RevenueCat",
  "payment_entry_page.button_pay": "ชำระเงินตอนนี้",
  "payment_entry_page.button_start_trial": "เริ่มทดลองใช้",
  "success_page.purchase_successful": "การชำระเงินเสร็จสมบูรณ์",
  "success_page.button_close": "ดำเนินการต่อ",
  "error_page.if_error_persists": "หากข้อผิดพลาดยังคงอยู่ โปรดติดต่อ ",
  "error_page.error_title_already_subscribed": "คุณได้สมัครสมาชิก {{productTitle}} แล้ว",
  "error_page.error_title_already_purchased": "คุณได้ซื้อ {{productTitle}} แล้ว",
  "error_page.error_title_other_errors": "มีบางอย่างผิดพลาด",
  "error_page.error_message_already_subscribed": "คุณไม่สามารถสมัครสมาชิกผลิตภัณฑ์นี้ได้อีก",
  "error_page.error_message_already_purchased": "คุณไม่สามารถซื้อผลิตภัณฑ์นี้ได้อีก",
  "error_page.error_message_missing_email_error": "ต้องใช้อีเมลเพื่อทำการซื้อให้เสร็จสมบูรณ์",
  "error_page.error_message_network_error": "ข้อผิดพลาดของเครือข่าย โปรดตรวจสอบการเชื่อมต่ออินเทอร์เน็ตของคุณ",
  "error_page.error_message_error_charging_payment": "การชำระเงินล้มเหลว",
  "error_page.error_message_error_setting_up_purchase": "ไม่สามารถเริ่มการซื้อได้เนื่องจากข้อผิดพลาด (รหัสข้อผิดพลาด: {{errorCode}})",
  "error_page.error_message_invalid_tax_location": "เราไม่สามารถยืนยันที่อยู่สำหรับออกใบแจ้งหนี้ของคุณได้ กรุณาตรวจสอบรหัสไปรษณีย์และประเทศให้ถูกต้อง",
  "error_page.error_message_unknown_error": "เกิดข้อผิดพลาดที่ไม่รู้จัก (รหัสข้อผิดพลาด: {{errorCode}})",
  "error_page.button_try_again": "ลองอีกครั้ง",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "ยอดรวมที่ต้องชำระวันนี้",
  "product_info.subscribe_to": "สมัครสมาชิก",
  "navbar_header.details": "รายละเอียด",
  "navbar_header.back_button": "ย้อนกลับ",
  "pricing_dropdown.show_details": "แสดงรายละเอียด",
  "pricing_dropdown.hide_details": "ซ่อนรายละเอียด",
  "pricing_table.tax": "ภาษี",
  "pricing_table.trial_ends": "หลังจากช่วงทดลองใช้สิ้นสุด ในวันที่ {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "ยอดรวมที่ต้องชำระวันนี้",
  "pricing_table.total_excluding_tax": "ราคารวมก่อนภาษี",
  "pricing_table.enter_billing_address_to_calculate": "กรุณากรอกที่อยู่สำหรับเรียกเก็บเงินเพื่อคำนวณ",
  "pricing_table.enter_state_or_postal_code_to_calculate": "ใส่รัฐหรือรหัสไปรษณีย์เพื่อคำนวณ",
  "pricing_table.enter_postal_code_to_calculate": "ใส่รหัสไปรษณีย์เพื่อคำนวณ",
  "error_page.error_message_invalid_email_error": "ไม่สามารถยืนยันที่อยู่อีเมล {{email}} ได้ โปรดระบุที่อยู่อีเมลที่ถูกต้อง",
  "payment_entry_page.button_payment_method": "ชำระเงิน {{formattedPrice}} ด้วย {{paymentMethod}}",
  "payment_entry_page.button_with_price": "ชำระเงิน {{formattedPrice}}",
  "price_update.title": "อัปเดตราคา",
  "price_update.base_message": "ราคารวมได้รับการอัปเดตพร้อมภาษีตามที่อยู่สำหรับการเรียกเก็บเงินของคุณ โปรดตรวจสอบและลองอีกครั้ง บัตรของคุณจะถูกเรียกเก็บเงินเพียงครั้งเดียวเท่านั้น",
  "price_update.trial_message": "ราคาการสมัครสมาชิกได้รับการอัปเดตเพื่อรวมภาษีตามที่อยู่สำหรับการเรียกเก็บเงินของคุณ ระยะเวลาทดลองใช้ฟรียังคงมีผล โปรดตรวจสอบและลองอีกครั้ง",
  "payment_entry_page.express_checkout_divider": "หรือชำระด้วยบัตร",
  "error_page.trouble_accessing": "หากคุณมีปัญหาในการเข้าถึงการซื้อ โปรดติดต่อฝ่ายสนับสนุนที่ ",
  "error_page.close_button_title": "ไปที่ {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "ขาดสิทธิ์ Stripe ที่จำเป็น",
  "error_page.button_close": "ปิด",
  "error_page.error_message_stripe_invalid_tax_origin_address": "การซื้อล้มเหลวเนื่องจากที่อยู่ต้นทางภาษีไม่ถูกต้อง ในสภาพแวดล้อมจริง การซื้อจะทำงานได้โดยไม่มีการเรียกเก็บภาษี",
  "error_page.error_message_stripe_tax_not_active": "การซื้อล้มเหลวเนื่องจากไม่ได้เปิดใช้งาน Stripe Tax ในสภาพแวดล้อมจริง การซื้อจะทำงานได้โดยไม่มีการเรียกเก็บภาษี",
  "error_page.error_only_in_sandbox": "ข้อความนี้จะปรากฏเฉพาะใน sandbox เท่านั้น",
  "error_page.error_message_stripe_missing_required_permission": "การซื้อล้มเหลวเนื่องจากแอป Stripe ขาดสิทธิ์ที่จำเป็น ในสภาพแวดล้อมจริง การซื้อจะทำงานได้โดยไม่มีการเรียกเก็บภาษี",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax ไม่เปิดใช้งาน",
  "error_page.error_title_stripe_invalid_tax_origin_address": "ที่อยู่ต้นทางภาษีไม่ถูกต้อง",
  "apple_pay.free_trial": "ทดลองใช้ฟรี",
  "product_info.price_after_intro_price": "หลังจาก {{introPriceDuration}} ในวันที่ {{renewalDate}}",
  "product_info.after_trial": "หลังช่วงทดลองใช้",
  "product_info.after": "หลังจาก",
  "product_info.intro_price_phase_after_trial": "จากนั้น {{introPriceDuration}} ในราคา {{introPrice}}",
  "product_info.intro_price_phase": "ช่วงแรก {{introPriceDuration}} ในราคา {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "ชำระครั้งเดียว",
  "payment_entry_page.trial_subscription_terms_info": "หลังจากช่วงทดลองใช้ของคุณสิ้นสุดลง คุณจะถูกเรียกเก็บเงิน {{price}} {{perFrequency}} เริ่มตั้งแต่วันที่ {{renewalDate}} คุณสามารถยกเลิกได้ตลอดเวลาก่อนวันดังกล่าว",
  "payment_entry_page.subscription_info": "การสมัครรับข้อมูลจะต่ออายุโดยอัตโนมัติ ยกเลิกได้ตลอดเวลา",
  "payment_entry_page.otp_terms_info": "เมื่อทำการซื้อ คุณตกลงที่จะอนุญาตให้ {{appName}} เรียกเก็บเงินจากคุณตามข้อกำหนดของพวกเขา",
  "payment_entry_page.terms_link_label": "ข้อกำหนด",
  "payment_entry_page.subscription_terms_info": "เมื่อสมัครรับข้อมูล แสดงว่าคุณยินยอมให้ {{appName}} เรียกเก็บเงินจากคุณตามข้อกำหนดจนกว่าคุณจะยกเลิก",
  "loading_page.keep_page_open": "กระบวนการเกือบเสร็จสมบูรณ์แล้ว โปรดเปิดหน้านี้ไว้",
  "loading_page.processing_payment": "กำลังดำเนินการชำระเงิน",
  "pricing_table.discount": "ส่วนลด",
  "pricing_table.subtotal": "ราคารวมย่อย"
}, Wg = {
  "periods.week": "{{amount}} hafta",
  "periods.month": "{{amount}} ay",
  "periods.year": "{{amount}} yıl",
  "periods.day": "{{amount}} gün",
  "periods.weekShort": "{{amount}}hf",
  "periods.monthShort": "{{amount}}ay",
  "periods.yearShort": "{{amount}}yl",
  "periods.dayShort": "{{amount}}g",
  "periods.lifetime": "ömür boyu",
  "periods.weekPlural": "{{amount}} hafta",
  "periods.monthPlural": "{{amount}} ay",
  "periods.yearPlural": "{{amount}} yıl",
  "periods.dayPlural": "{{amount}} gün",
  "periods.weekFrequency": "haftalık",
  "periods.monthFrequency": "aylık",
  "periods.yearFrequency": "yıllık",
  "periods.dayFrequency": "günlük",
  "periods.perWeekFrequency": "haftada",
  "periods.perMonthFrequency": "ayda",
  "periods.perYearFrequency": "yılda",
  "periods.perDayFrequency": "günde",
  "periods.unknownFrequency": "bilinmiyor",
  "periods.weekFrequencyPlural": "her {{amount}} haftada",
  "periods.monthFrequencyPlural": "her {{amount}} ayda",
  "periods.yearFrequencyPlural": "her {{amount}} yılda",
  "periods.dayFrequencyPlural": "her {{amount}} günde",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} ücretsiz deneme",
  "product_info.price_after_free_trial": "Deneme süresi sona erdiğinde, {{renewalDate}} tarihinde",
  "product_info.renewal_frequency": "{{frequency}} sıklığında yenilenir",
  "product_info.continues_until_cancelled": "İptal edilene kadar devam eder",
  "product_info.cancel_anytime": "İstediğiniz zaman iptal edebilirsiniz",
  "payment_entry_page.payment_step_title": "RevenueCat ile güvenli ödeme",
  "payment_entry_page.button_pay": "Şimdi öde",
  "payment_entry_page.button_start_trial": "Denemeyi başlat",
  "success_page.purchase_successful": "Ödeme tamamlandı",
  "success_page.button_close": "Devam et",
  "error_page.if_error_persists": "Hata devam ederse lütfen iletişime geçin ",
  "error_page.error_title_already_subscribed": "{{productTitle}} ürününe zaten abone oldunuz",
  "error_page.error_title_already_purchased": "{{productTitle}} ürününü zaten satın aldınız",
  "error_page.error_title_other_errors": "Bir şeyler ters gitti",
  "error_page.error_message_already_subscribed": "Bu ürüne tekrar abone olamazsınız.",
  "error_page.error_message_already_purchased": "Bu ürünü tekrar satın alamazsınız.",
  "error_page.error_message_missing_email_error": "Satın almayı tamamlamak için e-posta gereklidir.",
  "error_page.error_message_network_error": "Ağ hatası. Lütfen internet bağlantınızı kontrol edin.",
  "error_page.error_message_error_charging_payment": "Ödeme başarısız oldu.",
  "error_page.error_message_error_setting_up_purchase": "Bir hata nedeniyle satın alma başlatılamadı (hata kodu: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Fatura adresinizi doğrulayamadık. Lütfen posta kodu ve ülkenin doğru olduğunu kontrol edin.",
  "error_page.error_message_unknown_error": "Bilinmeyen bir hata oluştu (hata kodu: {{errorCode}}).",
  "error_page.button_try_again": "Tekrar dene",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Bugün ödenecek toplam tutar",
  "product_info.subscribe_to": "Abone Ol",
  "navbar_header.details": "Detaylar",
  "navbar_header.back_button": "Geri",
  "pricing_dropdown.show_details": "Detayları göster",
  "pricing_dropdown.hide_details": "Detayları gizle",
  "pricing_table.tax": "Vergi",
  "pricing_table.trial_ends": "Deneme süresi sona erdikten sonra, {{formattedTrialEndDate}} tarihinde",
  "pricing_table.total_due_today": "Bugün ödenecek toplam",
  "pricing_table.total_excluding_tax": "Vergi hariç toplam",
  "pricing_table.enter_billing_address_to_calculate": "Hesaplamak için fatura adresini girin",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Hesaplamak için eyalet veya posta kodunu girin",
  "pricing_table.enter_postal_code_to_calculate": "Hesaplamak için posta kodunu girin",
  "error_page.error_message_invalid_email_error": "{{email}} e-posta adresi doğrulanamadı. Lütfen geçerli bir e-posta adresi girin.",
  "payment_entry_page.button_payment_method": "{{paymentMethod}} ile {{formattedPrice}} öde",
  "payment_entry_page.button_with_price": "{{formattedPrice}} öde",
  "price_update.title": "Fiyat güncellemesi",
  "price_update.base_message": "Toplam fiyat, fatura adresinize göre vergi dahil olacak şekilde güncellendi. Lütfen inceleyip tekrar deneyin. Kartınızdan yalnızca bir kez ücret alınacaktır.",
  "price_update.trial_message": "Abonelik fiyatı, fatura adresinize göre vergileri içerecek şekilde güncellendi. Ücretsiz deneme süresi hala geçerli. Lütfen kontrol edin ve tekrar deneyin.",
  "payment_entry_page.express_checkout_divider": "VEYA KARTLA ÖDEYİN",
  "error_page.trouble_accessing": "Satın alımınıza erişmekte sorun yaşıyorsanız, şu adresten destek ekibine ulaşın: ",
  "error_page.close_button_title": "{{appName}}'e Git",
  "error_page.error_title_stripe_missing_required_permission": "Eksik Stripe izni",
  "error_page.button_close": "Kapat",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Vergi başlangıç adresi geçersiz olduğu için satın alma başarısız oldu. Üretimde, satın alımlar vergi uygulanmadan çalışacaktır.",
  "error_page.error_message_stripe_tax_not_active": "Stripe Vergi etkinleştirilmediği için satın alma başarısız oldu. Üretimde, satın alımlar vergi uygulanmadan çalışacaktır.",
  "error_page.error_only_in_sandbox": "Bu mesaj yalnızca sanal ortamda görünür.",
  "error_page.error_message_stripe_missing_required_permission": "Stripe uygulamasında gerekli bir izin eksik olduğu için satın alma başarısız oldu. Üretimde, satın alımlar vergi uygulanmadan çalışacaktır.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Vergi aktif değil",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Geçersiz vergi başlangıç adresi",
  "apple_pay.free_trial": "Ücretsiz Deneme",
  "product_info.price_after_intro_price": "{{introPriceDuration}} sonra, {{renewalDate}} tarihinde",
  "product_info.after_trial": "deneme süresinden sonra",
  "product_info.after": "sonra",
  "product_info.intro_price_phase_after_trial": "Sonra {{introPriceDuration}} boyunca {{introPrice}}",
  "product_info.intro_price_phase": "İlk {{introPriceDuration}} boyunca {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "bir defaya mahsus ödenir",
  "payment_entry_page.trial_subscription_terms_info": "Deneme süreniz sona erdikten sonra, {{renewalDate}} tarihinden itibaren {{price}} {{perFrequency}} ücretlendirileceksiniz. Bu tarihten önce istediğiniz zaman iptal edebilirsiniz.",
  "payment_entry_page.subscription_info": "Abonelik otomatik olarak yenilenir. İstediğiniz zaman iptal edin.",
  "payment_entry_page.otp_terms_info": "Satın alarak, {{appName}}'in sizi şartlarına göre ücretlendirmesine izin vermeyi kabul edersiniz.",
  "payment_entry_page.terms_link_label": "Koşullar",
  "payment_entry_page.subscription_terms_info": "Abone olarak, iptal edene kadar {{appName}}'in sizi şartlarına göre ücretlendirmesine izin vermeyi kabul edersiniz.",
  "loading_page.keep_page_open": "İşlem neredeyse tamamlandı. Bu sayfayı açık tutun.",
  "loading_page.processing_payment": "Ödeme işleniyor",
  "pricing_table.discount": "İndirim",
  "pricing_table.subtotal": "Ara Toplam"
}, Yg = {
  "periods.week": "{{amount}} тиждень",
  "periods.month": "{{amount}} місяць",
  "periods.year": "{{amount}} рік",
  "periods.day": "{{amount}} день",
  "periods.weekShort": "{{amount}}тиж",
  "periods.monthShort": "{{amount}}міс",
  "periods.yearShort": "{{amount}}рік",
  "periods.dayShort": "{{amount}}дн",
  "periods.lifetime": "пожиттєво",
  "periods.weekPlural": "{{amount}} тижнів",
  "periods.monthPlural": "{{amount}} місяців",
  "periods.yearPlural": "{{amount}} років",
  "periods.dayPlural": "{{amount}} днів",
  "periods.weekFrequency": "щотижня",
  "periods.monthFrequency": "щомісяця",
  "periods.yearFrequency": "щороку",
  "periods.dayFrequency": "щодня",
  "periods.perWeekFrequency": "на тиждень",
  "periods.perMonthFrequency": "на місяць",
  "periods.perYearFrequency": "на рік",
  "periods.perDayFrequency": "на день",
  "periods.unknownFrequency": "невідомо",
  "periods.weekFrequencyPlural": "кожні {{amount}} тижнів",
  "periods.monthFrequencyPlural": "кожні {{amount}} місяців",
  "periods.yearFrequencyPlural": "кожні {{amount}} років",
  "periods.dayFrequencyPlural": "кожні {{amount}} днів",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} безкоштовний пробний період",
  "product_info.price_after_free_trial": "Після закінчення пробного періоду, {{renewalDate}}",
  "product_info.renewal_frequency": "Продовжується {{frequency}}",
  "product_info.continues_until_cancelled": "Триває до скасування",
  "product_info.cancel_anytime": "Можна скасувати в будь-який час",
  "payment_entry_page.payment_step_title": "Безпечна оплата через RevenueCat",
  "payment_entry_page.button_pay": "Оплатити зараз",
  "payment_entry_page.button_start_trial": "Розпочати пробний період",
  "success_page.purchase_successful": "Оплата завершена",
  "success_page.button_close": "Продовжити",
  "error_page.if_error_persists": "Якщо помилка повторюється, зверніться до ",
  "error_page.error_title_already_subscribed": "Ви вже підписалися на {{productTitle}}",
  "error_page.error_title_already_purchased": "Ви вже придбали {{productTitle}}",
  "error_page.error_title_other_errors": "Щось пішло не так",
  "error_page.error_message_already_subscribed": "Ви не можете підписатися на цей продукт знову.",
  "error_page.error_message_already_purchased": "Ви не можете придбати цей продукт знову.",
  "error_page.error_message_missing_email_error": "Для завершення покупки потрібна електронна пошта.",
  "error_page.error_message_network_error": "Помилка мережі. Перевірте підключення до інтернету.",
  "error_page.error_message_error_charging_payment": "Оплата не пройшла.",
  "error_page.error_message_error_setting_up_purchase": "Помилка при ініціалізації покупки (код помилки: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Ми не змогли перевірити вашу платіжну адресу. Будь ласка, перевірте, чи правильні поштовий індекс та країна.",
  "error_page.error_message_unknown_error": "Сталася невідома помилка (код помилки: {{errorCode}}).",
  "error_page.button_try_again": "Спробувати ще раз",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Всього до сплати сьогодні",
  "product_info.subscribe_to": "Підписатися на",
  "navbar_header.details": "Деталі",
  "navbar_header.back_button": "Назад",
  "pricing_dropdown.show_details": "Показати деталі",
  "pricing_dropdown.hide_details": "Приховати деталі",
  "pricing_table.tax": "Податок",
  "pricing_table.trial_ends": "Після закінчення пробного періоду, {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Загальна сума до сплати сьогодні",
  "pricing_table.total_excluding_tax": "Загальна сума без урахування податку",
  "pricing_table.enter_billing_address_to_calculate": "Введіть адресу виставлення рахунку для розрахунку",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Введіть штат або поштовий індекс для розрахунку",
  "pricing_table.enter_postal_code_to_calculate": "Введіть поштовий індекс для розрахунку",
  "error_page.error_message_invalid_email_error": "Електронну адресу {{email}} не вдалося підтвердити. Будь ласка, вкажіть дійсну електронну адресу.",
  "payment_entry_page.button_payment_method": "Сплатити {{formattedPrice}} за допомогою {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Сплатити {{formattedPrice}}",
  "price_update.title": "Оновлення ціни",
  "price_update.base_message": "Загальну ціну було оновлено з урахуванням податку на основі вашої платіжної адреси. Перегляньте та спробуйте ще раз. З вашої картки буде списано кошти лише один раз.",
  "price_update.trial_message": "Ціна підписки була оновлена для включення податків на основі вашої платіжної адреси. Безкоштовний пробний період все ще діє. Будь ласка, перевірте та спробуйте ще раз.",
  "payment_entry_page.express_checkout_divider": "АБО СПЛАТІТЬ КАРТКОЮ",
  "error_page.trouble_accessing": "Якщо у вас виникли проблеми з доступом до вашої покупки, зверніться до служби підтримки за адресою ",
  "error_page.close_button_title": "Перейти до {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Відсутній дозвіл Stripe",
  "error_page.button_close": "Закрити",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Покупка не вдалася, оскільки адреса походження податку недійсна. У виробництві покупки працюватимуть без застосування податків.",
  "error_page.error_message_stripe_tax_not_active": "Покупка не вдалася, оскільки Stripe Tax не ввімкнено. У виробництві покупки працюватимуть без застосування податків.",
  "error_page.error_only_in_sandbox": "Це повідомлення з’являється лише в пісочниці.",
  "error_page.error_message_stripe_missing_required_permission": "Покупка не вдалася, оскільки програмі Stripe не вистачає необхідного дозволу. У виробництві покупки працюватимуть без застосування податків.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax не активовано",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Недійсна адреса походження податку",
  "apple_pay.free_trial": "Безкоштовна пробна версія",
  "product_info.price_after_intro_price": "Після {{introPriceDuration}}, {{renewalDate}}",
  "product_info.after_trial": "після пробного періоду",
  "product_info.after": "після",
  "product_info.intro_price_phase_after_trial": "Потім {{introPriceDuration}} за {{introPrice}}",
  "product_info.intro_price_phase": "Спочатку {{introPriceDuration}} за {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "сплачено один раз",
  "payment_entry_page.trial_subscription_terms_info": "Після закінчення пробного періоду з вас буде стягуватися плата в розмірі {{price}} {{perFrequency}} починаючи з {{renewalDate}}. Ви можете скасувати підписку в будь-який час до цієї дати.",
  "payment_entry_page.subscription_info": "Підписка поновлюється автоматично. Скасувати можна в будь-який час.",
  "payment_entry_page.otp_terms_info": "Купуючи, ви погоджуєтеся дозволити {{appName}} стягувати з вас плату відповідно до їхніх умов.",
  "payment_entry_page.terms_link_label": "Умови",
  "payment_entry_page.subscription_terms_info": "Підписуючись, ви погоджуєтеся дозволити {{appName}} стягувати з вас плату відповідно до їхніх умов, поки ви не скасуєте підписку.",
  "loading_page.keep_page_open": "Процес майже завершено. Залиште цю сторінку відкритою.",
  "loading_page.processing_payment": "Обробка платежу",
  "pricing_table.discount": "Знижка",
  "pricing_table.subtotal": "Сума до сплати"
}, Gg = {
  "periods.week": "{{amount}} tuần",
  "periods.month": "{{amount}} tháng",
  "periods.year": "{{amount}} năm",
  "periods.day": "{{amount}} ngày",
  "periods.weekShort": "{{amount}}tuần",
  "periods.monthShort": "{{amount}}tháng",
  "periods.yearShort": "{{amount}}năm",
  "periods.dayShort": "{{amount}}ngày",
  "periods.lifetime": "trọn đời",
  "periods.weekPlural": "{{amount}} tuần",
  "periods.monthPlural": "{{amount}} tháng",
  "periods.yearPlural": "{{amount}} năm",
  "periods.dayPlural": "{{amount}} ngày",
  "periods.weekFrequency": "hàng tuần",
  "periods.monthFrequency": "hàng tháng",
  "periods.yearFrequency": "hàng năm",
  "periods.dayFrequency": "hàng ngày",
  "periods.perWeekFrequency": "mỗi tuần",
  "periods.perMonthFrequency": "mỗi tháng",
  "periods.perYearFrequency": "mỗi năm",
  "periods.perDayFrequency": "mỗi ngày",
  "periods.unknownFrequency": "không xác định",
  "periods.weekFrequencyPlural": "cứ {{amount}} tuần",
  "periods.monthFrequencyPlural": "cứ {{amount}} tháng",
  "periods.yearFrequencyPlural": "cứ {{amount}} năm",
  "periods.dayFrequencyPlural": "cứ {{amount}} ngày",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} dùng thử miễn phí",
  "product_info.price_after_free_trial": "Sau khi dùng thử kết thúc, vào {{renewalDate}}",
  "product_info.renewal_frequency": "Gia hạn {{frequency}}",
  "product_info.continues_until_cancelled": "Tiếp tục cho đến khi hủy",
  "product_info.cancel_anytime": "Hủy bất cứ lúc nào",
  "payment_entry_page.payment_step_title": "Thanh toán an toàn bởi RevenueCat",
  "payment_entry_page.button_pay": "Thanh toán ngay",
  "payment_entry_page.button_start_trial": "Bắt đầu dùng thử",
  "success_page.purchase_successful": "Thanh toán hoàn tất",
  "success_page.button_close": "Tiếp tục",
  "error_page.if_error_persists": "Nếu lỗi vẫn tiếp diễn, vui lòng liên hệ ",
  "error_page.error_title_already_subscribed": "Bạn đã đăng ký {{productTitle}} rồi",
  "error_page.error_title_already_purchased": "Bạn đã mua {{productTitle}} rồi",
  "error_page.error_title_other_errors": "Có lỗi xảy ra",
  "error_page.error_message_already_subscribed": "Bạn không thể đăng ký sản phẩm này lần nữa.",
  "error_page.error_message_already_purchased": "Bạn không thể mua sản phẩm này lần nữa.",
  "error_page.error_message_missing_email_error": "Email bắt buộc để hoàn tất việc mua hàng.",
  "error_page.error_message_network_error": "Lỗi mạng. Vui lòng kiểm tra kết nối internet của bạn.",
  "error_page.error_message_error_charging_payment": "Thanh toán thất bại.",
  "error_page.error_message_error_setting_up_purchase": "Không thể bắt đầu mua do lỗi (mã lỗi: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Chúng tôi không thể xác minh địa chỉ thanh toán của bạn. Vui lòng kiểm tra lại mã bưu điện và quốc gia.",
  "error_page.error_message_unknown_error": "Đã xảy ra lỗi không xác định (mã lỗi: {{errorCode}}).",
  "error_page.button_try_again": "Thử lại",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Tổng số tiền phải trả hôm nay",
  "product_info.subscribe_to": "Đăng ký",
  "navbar_header.details": "Chi tiết",
  "navbar_header.back_button": "Quay lại",
  "pricing_dropdown.show_details": "Xem chi tiết",
  "pricing_dropdown.hide_details": "Ẩn chi tiết",
  "pricing_table.tax": "Thuế",
  "pricing_table.trial_ends": "Sau khi thời gian dùng thử kết thúc, vào {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Tổng số tiền phải trả hôm nay",
  "pricing_table.total_excluding_tax": "Tổng cộng chưa bao gồm thuế",
  "pricing_table.enter_billing_address_to_calculate": "Nhập địa chỉ thanh toán để tính toán",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Nhập tiểu bang hoặc mã bưu điện để tính toán",
  "pricing_table.enter_postal_code_to_calculate": "Nhập mã bưu điện để tính toán",
  "error_page.error_message_invalid_email_error": "Không thể xác minh địa chỉ email {{email}}. Vui lòng cung cấp một địa chỉ email hợp lệ.",
  "payment_entry_page.button_payment_method": "Thanh toán {{formattedPrice}} bằng {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Thanh toán {{formattedPrice}}",
  "price_update.title": "Cập nhật giá",
  "price_update.base_message": "Tổng giá đã được cập nhật với thuế dựa trên địa chỉ thanh toán của bạn. Vui lòng xem lại và thử lại. Thẻ của bạn sẽ chỉ bị tính phí một lần.",
  "price_update.trial_message": "Giá đăng ký đã được cập nhật để bao gồm thuế dựa trên địa chỉ thanh toán của bạn. Thời gian dùng thử miễn phí vẫn được áp dụng. Vui lòng kiểm tra và thử lại.",
  "payment_entry_page.express_checkout_divider": "HOẶC THANH TOÁN BẰNG THẺ",
  "error_page.trouble_accessing": "Nếu bạn gặp sự cố khi truy cập giao dịch mua của mình, hãy liên hệ với bộ phận hỗ trợ theo địa chỉ ",
  "error_page.close_button_title": "Đi đến {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Thiếu quyền Stripe",
  "error_page.button_close": "Đóng",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Giao dịch mua không thành công vì địa chỉ gốc thuế không hợp lệ. Trong môi trường thực tế, giao dịch mua sẽ hoạt động mà không áp dụng thuế.",
  "error_page.error_message_stripe_tax_not_active": "Giao dịch mua không thành công vì Thuế Stripe chưa được bật. Trong môi trường thực tế, giao dịch mua sẽ hoạt động mà không áp dụng thuế.",
  "error_page.error_only_in_sandbox": "Thông báo này chỉ xuất hiện trong môi trường thử nghiệm.",
  "error_page.error_message_stripe_missing_required_permission": "Giao dịch mua không thành công vì ứng dụng Stripe thiếu một quyền cần thiết. Trong môi trường thực tế, giao dịch mua sẽ hoạt động mà không áp dụng thuế.",
  "error_page.error_title_stripe_tax_not_active": "Thuế Stripe chưa hoạt động",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Địa chỉ gốc thuế không hợp lệ",
  "apple_pay.free_trial": "Dùng thử miễn phí",
  "product_info.price_after_intro_price": "Sau {{introPriceDuration}}, vào {{renewalDate}}",
  "product_info.after_trial": "sau khi dùng thử",
  "product_info.after": "sau",
  "product_info.intro_price_phase_after_trial": "Sau đó {{introPriceDuration}} với giá {{introPrice}}",
  "product_info.intro_price_phase": "{{introPriceDuration}} đầu tiên với giá {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "trả một lần",
  "payment_entry_page.trial_subscription_terms_info": "Sau khi thời gian dùng thử của bạn kết thúc, bạn sẽ bị tính phí {{price}} {{perFrequency}} bắt đầu từ {{renewalDate}}. Bạn có thể hủy bất cứ lúc nào trước ngày này.",
  "payment_entry_page.subscription_info": "Gói đăng ký tự động gia hạn. Hủy bất cứ lúc nào.",
  "payment_entry_page.otp_terms_info": "Bằng cách mua, bạn đồng ý cho phép {{appName}} tính phí bạn theo các điều khoản của họ.",
  "payment_entry_page.terms_link_label": "Điều khoản",
  "payment_entry_page.subscription_terms_info": "Bằng cách đăng ký, bạn đồng ý cho phép {{appName}} tính phí bạn theo các điều khoản của họ cho đến khi bạn hủy.",
  "loading_page.keep_page_open": "Quá trình gần hoàn tất. Vui lòng giữ trang này mở.",
  "loading_page.processing_payment": "Đang xử lý thanh toán",
  "pricing_table.discount": "Giảm giá",
  "pricing_table.subtotal": "Tổng cộng"
};
var $ = /* @__PURE__ */ ((e) => (e.PeriodsWeek = "periods.week", e.PeriodsMonth = "periods.month", e.PeriodsYear = "periods.year", e.PeriodsDay = "periods.day", e.PeriodsWeekShort = "periods.weekShort", e.PeriodsMonthShort = "periods.monthShort", e.PeriodsYearShort = "periods.yearShort", e.PeriodsDayShort = "periods.dayShort", e.PeriodsLifetime = "periods.lifetime", e.PeriodsWeekPlural = "periods.weekPlural", e.PeriodsMonthPlural = "periods.monthPlural", e.PeriodsYearPlural = "periods.yearPlural", e.PeriodsDayPlural = "periods.dayPlural", e.PeriodsWeekFrequency = "periods.weekFrequency", e.PeriodsMonthFrequency = "periods.monthFrequency", e.PeriodsYearFrequency = "periods.yearFrequency", e.PeriodsDayFrequency = "periods.dayFrequency", e.PeriodsPerWeekFrequency = "periods.perWeekFrequency", e.PeriodsPerMonthFrequency = "periods.perMonthFrequency", e.PeriodsPerYearFrequency = "periods.perYearFrequency", e.PeriodsPerDayFrequency = "periods.perDayFrequency", e.PeriodsUnknownFrequency = "periods.unknownFrequency", e.PeriodsWeekFrequencyPlural = "periods.weekFrequencyPlural", e.PeriodsMonthFrequencyPlural = "periods.monthFrequencyPlural", e.PeriodsYearFrequencyPlural = "periods.yearFrequencyPlural", e.PeriodsDayFrequencyPlural = "periods.dayFrequencyPlural", e.ProductInfoProductTitle = "product_info.product_title", e.ProductInfoProductDescription = "product_info.product_description", e.ProductInfoProductPrice = "product_info.product_price", e.ProductInfoFreeTrialDuration = "product_info.free_trial_duration", e.ProductInfoPriceAfterFreeTrial = "product_info.price_after_free_trial", e.ProductInfoIntroPricePhaseAfterTrial = "product_info.intro_price_phase_after_trial", e.ProductInfoIntroPricePhasePaidOnce = "product_info.intro_price_phase_paid_once", e.ProductInfoIntroPricePhase = "product_info.intro_price_phase", e.ProductInfoPriceAfterIntroPrice = "product_info.price_after_intro_price", e.ProductInfoAfterTrial = "product_info.after_trial", e.ProductInfoAfter = "product_info.after", e.ProductInfoPriceTotalDueToday = "product_info.total_due_today", e.ProductInfoSubscribeTo = "product_info.subscribe_to", e.ProductInfoRenewalFrequency = "product_info.renewal_frequency", e.ProductInfoContinuesUntilCancelled = "product_info.continues_until_cancelled", e.ProductInfoCancelAnytime = "product_info.cancel_anytime", e.PaymentEntryPagePaymentStepTitle = "payment_entry_page.payment_step_title", e.PaymentEntryPageTrialSubscriptionTermsInfo = "payment_entry_page.trial_subscription_terms_info", e.PaymentEntryPageSubscriptionTermsInfo = "payment_entry_page.subscription_terms_info", e.PaymentEntryPageOtpTermsInfo = "payment_entry_page.otp_terms_info", e.PaymentEntryPageTermsLinkLabel = "payment_entry_page.terms_link_label", e.PaymentEntryPageSubscriptionInfo = "payment_entry_page.subscription_info", e.PaymentEntryPageButtonPay = "payment_entry_page.button_pay", e.PaymentEntryPageButtonStartTrial = "payment_entry_page.button_start_trial", e.PaymentEntryPageButtonWithPrice = "payment_entry_page.button_with_price", e.PaymentEntryPageButtonPaymentMethod = "payment_entry_page.button_payment_method", e.PaymentEntryPageExpressCheckoutDivider = "payment_entry_page.express_checkout_divider", e.SuccessPagePurchaseSuccessful = "success_page.purchase_successful", e.SuccessPageButtonClose = "success_page.button_close", e.LoadingPageProcessingPayment = "loading_page.processing_payment", e.LoadingPageKeepPageOpen = "loading_page.keep_page_open", e.ErrorPageCloseButtonTitle = "error_page.close_button_title", e.ErrorPageIfErrorPersists = "error_page.if_error_persists", e.ErrorPageTroubleAccessing = "error_page.trouble_accessing", e.ErrorPageErrorTitleAlreadySubscribed = "error_page.error_title_already_subscribed", e.ErrorPageErrorTitleAlreadyPurchased = "error_page.error_title_already_purchased", e.ErrorPageErrorTitleOtherErrors = "error_page.error_title_other_errors", e.ErrorPageErrorTitleStripeTaxNotActive = "error_page.error_title_stripe_tax_not_active", e.ErrorPageErrorTitleStripeInvalidTaxOriginAddress = "error_page.error_title_stripe_invalid_tax_origin_address", e.ErrorPageErrorTitleStripeMissingRequiredPermission = "error_page.error_title_stripe_missing_required_permission", e.ErrorPageErrorMessageAlreadySubscribed = "error_page.error_message_already_subscribed", e.ErrorPageErrorMessageAlreadyPurchased = "error_page.error_message_already_purchased", e.ErrorPageErrorMessageMissingEmailError = "error_page.error_message_missing_email_error", e.ErrorPageErrorMessageInvalidEmailError = "error_page.error_message_invalid_email_error", e.ErrorPageErrorMessageNetworkError = "error_page.error_message_network_error", e.ErrorPageErrorMessageErrorChargingPayment = "error_page.error_message_error_charging_payment", e.ErrorPageErrorMessageErrorSettingUpPurchase = "error_page.error_message_error_setting_up_purchase", e.ErrorPageErrorMessageUnknownError = "error_page.error_message_unknown_error", e.ErrorPageErrorMessageInvalidTaxLocation = "error_page.error_message_invalid_tax_location", e.ErrorPageErrorMessageStripeTaxNotActive = "error_page.error_message_stripe_tax_not_active", e.ErrorPageErrorMessageStripeInvalidTaxOriginAddress = "error_page.error_message_stripe_invalid_tax_origin_address", e.ErrorPageErrorMessageStripeMissingRequiredPermission = "error_page.error_message_stripe_missing_required_permission", e.ErrorPageErrorMessageOnlyInSandbox = "error_page.error_only_in_sandbox", e.ErrorButtonTryAgain = "error_page.button_try_again", e.ErrorButtonClose = "error_page.button_close", e.PaywallVariablesPricePerPeriod = "paywall_variables.price_per_period", e.PaywallVariablesSubRelativeDiscount = "paywall_variables.sub_relative_discount", e.PaywallVariablesTotalPriceAndPerMonth = "paywall_variables.total_price_and_per_month", e.PricingDropdownShowDetails = "pricing_dropdown.show_details", e.PricingDropdownHideDetails = "pricing_dropdown.hide_details", e.PricingTotalExcludingTax = "pricing_table.total_excluding_tax", e.PricingTableTrialEnds = "pricing_table.trial_ends", e.PricingTableTotalDueToday = "pricing_table.total_due_today", e.PricingTableSubtotal = "pricing_table.subtotal", e.PricingTableDiscount = "pricing_table.discount", e.PricingTableTax = "pricing_table.tax", e.PricingTableEnterBillingAddressToCalculate = "pricing_table.enter_billing_address_to_calculate", e.PricingTableEnterStateOrPostalCodeToCalculate = "pricing_table.enter_state_or_postal_code_to_calculate", e.PricingTableEnterPostalCodeToCalculate = "pricing_table.enter_postal_code_to_calculate", e.NavbarHeaderDetails = "navbar_header.details", e.NavbarBackButton = "navbar_header.back_button", e.PriceUpdateTitle = "price_update.title", e.PriceUpdateBaseMessage = "price_update.base_message", e.PriceUpdateTrialMessage = "price_update.trial_message", e.ApplePayFreeTrial = "apple_pay.free_trial", e))($ || {});
const Kg = {
  en: fg,
  es: mg,
  it: hg,
  ar: yg,
  ca: bg,
  zh_Hans: vg,
  zh_Hant: kg,
  hr: wg,
  cs: Pg,
  da: xg,
  nl: Eg,
  fi: Sg,
  fr: Ig,
  de: Tg,
  el: Cg,
  he: Dg,
  hi: Ag,
  hu: qg,
  id: Fg,
  ja: zg,
  ko: Mg,
  ms: Og,
  no: jg,
  pl: Ng,
  pt: Lg,
  ro: Bg,
  ru: Ug,
  sk: Rg,
  sv: Vg,
  th: Hg,
  tr: Wg,
  uk: Yg,
  vi: Gg
};
var ce = /* @__PURE__ */ ((e) => (e.Year = "year", e.Month = "month", e.Week = "week", e.Day = "day", e))(ce || {});
function Ns(e) {
  const r = e.match(/^PT?([0-9]+)([MDYW])$/);
  if (!r || r.length < 3)
    return ne.errorLog(`Invalid ISO 8601 duration format: ${e}`), null;
  const t = parseInt(r[1]);
  switch (r[2]) {
    case "Y":
      return {
        number: t,
        unit: "year"
        /* Year */
      };
    case "M":
      return {
        number: t,
        unit: "month"
        /* Month */
      };
    case "W":
      return {
        number: t,
        unit: "week"
        /* Week */
      };
    case "D":
      return {
        number: t,
        unit: "day"
        /* Day */
      };
    default:
      return ne.errorLog(`Invalid ISO 8601 unit duration format: ${e}`), null;
  }
}
function rs(e, r, t) {
  if (!t)
    return null;
  let n = new Date(e);
  switch (r.unit) {
    case "year":
      n.getDate() === 29 && n.getMonth() === 1 && r.number !== 4 ? n.setFullYear(
        n.getFullYear() + r.number,
        n.getMonth(),
        28
      ) : n.setFullYear(
        n.getFullYear() + r.number,
        n.getMonth(),
        n.getDate()
      );
      break;
    case "month":
      n.setMonth(n.getMonth() + r.number, n.getDate()), n.getDate() !== e.getDate() && (n = new Date(e), n.setMonth(n.getMonth() + r.number + 1, 0));
      break;
    case "week":
      n.setDate(n.getDate() + r.number * 7);
      break;
    case "day":
      n.setDate(n.getDate() + r.number);
      break;
  }
  return n;
}
const Xn = (e) => {
  if (!e)
    return e;
  const r = e.replace(/_/g, "-");
  try {
    const [n] = Intl.getCanonicalLocales(r);
    if (n)
      return n;
  } catch {
  }
  const t = r.split("-")[0];
  try {
    const [n] = Intl.getCanonicalLocales(t);
    if (n)
      return n;
  } catch {
  }
  return t;
}, Xg = (e) => e / 1e6, ql = /* @__PURE__ */ new Map();
function $g(e) {
  const r = ql.get(e);
  if (r !== void 0) return r;
  let t;
  try {
    t = new Intl.NumberFormat("en", {
      style: "currency",
      currency: e
    }).resolvedOptions().maximumFractionDigits ?? 2;
  } catch {
    t = 2;
  }
  return ql.set(e, t), t;
}
function vo(e, r) {
  const n = 10 ** (6 - $g(r)), a = Math.round(e / n * 1e9) / 1e9;
  return Math.floor(a) * n;
}
const on = (e, r, t, n = {}) => {
  const a = Xg(e), o = {
    style: "currency",
    currency: r,
    currencyDisplay: "symbol",
    ...n,
    // Some browsers require minimumFractionDigits to be set if maximumFractionDigits is set.
    minimumFractionDigits: n.maximumFractionDigits
  };
  return new Intl.NumberFormat(
    Xn(t),
    o
  ).format(a).replace("US$", "$");
}, Zg = (e, r) => {
  const t = Ns(e);
  return t ? r.translatePeriod(t.number, t.unit) || `${t.number} ${t.unit}s` : e;
}, Jg = (e) => {
  try {
    return e.charAt(0).toUpperCase() + e.slice(1);
  } catch {
    return e;
  }
}, $n = {
  noWhitespace: !1,
  short: !1
}, Xu = {
  useMultipleWords: !1
};
class cn {
  constructor(r = {}, t = Er, n = Er) {
    V(this, "locales", {});
    this.selectedLocale = t, this.defaultLocale = n;
    const a = {};
    Object.entries(Kg).forEach(([o, s]) => {
      a[o] = new Fl(s, o);
    }), this.locales = a, r && this.override(r);
  }
  static fallback() {
    return new cn();
  }
  override(r) {
    Object.entries(r).forEach(([t, n]) => {
      this.locales[t] = new Fl(
        {
          ...this.locales[t].labels || {},
          ...n
        },
        this.getLanguageCodeString(t)
      );
    });
  }
  formatPrice(r, t) {
    const n = { currencyDisplay: "narrowSymbol" };
    r === 0 && (n.maximumFractionDigits = 0);
    try {
      return on(
        r,
        t,
        this.bcp47Locale,
        n
      );
    } catch {
      ne.errorLog(
        `Failed to create a price formatter for locale: ${this.bcp47Locale}`
      );
    }
    try {
      return on(
        r,
        t,
        this.fallbackBcp47Locale,
        n
      );
    } catch {
      ne.errorLog(
        `Failed to create a price formatter for locale: ${this.fallbackBcp47Locale}`
      );
    }
    return on(
      r,
      t,
      Er,
      n
    );
  }
  /**
   * Returns the locale in a format that is compatible with other JS libraries.
   * This is particularly important for zh_Hans and zh_Hant that are instead
   * represented as zh-Hans and zh-Hant in Intl.DateTimeFormat.
   */
  get bcp47Locale() {
    var r;
    return Xn((r = this.getLocaleInstance(this.selectedLocale)) == null ? void 0 : r.localeKey) || Xn(this.getLanguageCodeString(this.selectedLocale)) || Er;
  }
  /**
   * Returns the fallback locale in a format that is compatible with other JS
   * libraries.
   * This is particularly important for zh_Hans and zh_Hant that are instead
   * represented as zh-Hans and zh-Hant in Intl.DateTimeFormat.
   */
  get fallbackBcp47Locale() {
    var r;
    return Xn((r = this.getLocaleInstance(this.defaultLocale)) == null ? void 0 : r.localeKey) || Xn(this.getLanguageCodeString(this.defaultLocale)) || Er;
  }
  getLanguageCodeString(r) {
    return r.split("_")[0].split("-")[0];
  }
  getLocaleInstance(r) {
    const t = this.getLanguageCodeString(r);
    return this.locales[r] || this.locales[t];
  }
  translate(r, t) {
    const n = this.getLocaleInstance(this.selectedLocale), a = this.getLocaleInstance(this.defaultLocale);
    return (n == null ? void 0 : n.translate(r, t)) || (a == null ? void 0 : a.translate(r, t)) || "";
  }
  formatCountry(r) {
    return new Intl.DisplayNames([this.bcp47Locale], { type: "region" }).of(
      r
    ) || r;
  }
  translatePeriod(r, t, n = $n) {
    const a = this.getLocaleInstance(this.selectedLocale), o = this.getLocaleInstance(this.defaultLocale);
    return (a == null ? void 0 : a.translatePeriod(r, t, n)) || (o == null ? void 0 : o.translatePeriod(r, t, n));
  }
  translatePeriodUnit(r, t = $n) {
    const n = this.getLocaleInstance(this.selectedLocale), a = this.getLocaleInstance(this.defaultLocale);
    return (n == null ? void 0 : n.translatePeriodUnit(r, t)) || (a == null ? void 0 : a.translatePeriodUnit(r, t));
  }
  translatePeriodFrequency(r, t, n = Xu) {
    const a = this.getLocaleInstance(this.selectedLocale), o = this.getLocaleInstance(this.defaultLocale);
    return (a == null ? void 0 : a.translatePeriodFrequency(r, t, n)) || (o == null ? void 0 : o.translatePeriodFrequency(r, t, n));
  }
  translateDate(r, t = {}) {
    const n = this.getLocaleInstance(this.selectedLocale), a = this.getLocaleInstance(this.defaultLocale);
    return (n == null ? void 0 : n.translateDate(r, t)) || (a == null ? void 0 : a.translateDate(r, t));
  }
}
class Fl {
  constructor(r = {}, t) {
    this.labels = r, this.localeKey = t;
  }
  replaceVariables(r, t) {
    return Object.entries(t).reduce(
      (n, [a, o]) => n.replace(
        `{{${a}}}`,
        `${o ?? ""}`
      ),
      r
    );
  }
  translate(r, t) {
    const n = this.labels[r];
    if (n)
      return this.replaceVariables(n, t || {});
  }
  translatePeriod(r, t, n = $n) {
    var l;
    const { noWhitespace: a, short: o } = {
      ...$n,
      ...n
    }, s = o ? `periods.${t}Short` : Math.abs(r) === 1 ? `periods.${t}` : `periods.${t}Plural`;
    return (l = this.translate(s, {
      amount: r.toString()
    })) == null ? void 0 : l.replace(" ", a ? "" : " ");
  }
  translatePeriodUnit(r, t = $n) {
    var s;
    const { noWhitespace: n, short: a } = {
      ...$n,
      ...t
    }, o = `periods.${r}${a ? "Short" : ""}`;
    return (s = this.translate(o, { amount: "" })) == null ? void 0 : s.replace(
      " ",
      n ? "" : " "
    );
  }
  translatePeriodFrequency(r, t, n = Xu) {
    const a = n == null ? void 0 : n.useMultipleWords, o = Math.abs(r) === 1 ? `periods.${a === !0 ? "per" : ""}${a ? Jg(t.toString()) : t}Frequency` : `periods.${t}FrequencyPlural`;
    return this.translate(o, {
      amount: r.toString()
    });
  }
  translateDate(r, t = {}) {
    return r.toLocaleDateString(Xn(this.localeKey), t);
  }
}
s_();
const Qg = `<svg viewBox="0 0 124 124" fill="var(--rc-color-grey-text-dark)" xmlns="http://www.w3.org/2000/svg">
    <circle cx="62" cy="62" r="62" fill="var(--rc-color-grey-text-dark)" opacity="0.2"/>
    <path d="M87.6668 41.504L82.4968 36.334L62.0002 56.8307L41.5035 36.334L36.3335 41.504L56.8302 62.0006L36.3335 82.4973L41.5035 87.6673L62.0002 67.1706L82.4968 87.6673L87.6668 82.4973L67.1702 62.0006L87.6668 41.504Z"
          />
</svg>
`;
var ef = /* @__PURE__ */ B('<div style="color:var(--rc-color-primary);"><!></div>');
function $u(e) {
  var r = ef(), t = z(r);
  dn(t, () => Qg), T(e, r);
}
const Zu = Symbol("inputValidation"), Ju = Symbol("initialInputSelections");
function rf() {
  const e = gr(!0);
  return {
    isSatisfied: e,
    updateSatisfaction: (t) => {
      e.set(t);
    }
  };
}
function tf(e) {
  $e(Zu, e);
}
function Ls() {
  return Le(Zu);
}
function nf(e) {
  $e(Ju, e);
}
function Qu() {
  return Le(Ju) ?? {};
}
const ed = Symbol("paywall");
function rd(e) {
  $e(ed, e);
}
function pn() {
  const e = Le(ed);
  if (e === void 0)
    throw new Error("Paywall context not found");
  return e;
}
const td = Symbol("selected");
function Zo(e) {
  $e(td, e);
}
function tt() {
  return Le(td) ?? At(!1);
}
const Ca = {
  SelectedPackageCondition: "selected_package_condition",
  IntroOfferCondition: "intro_offer_condition",
  PromoOfferCondition: "promo_offer_condition",
  VariableCondition: "variable_condition"
};
function af({ stack: e, sticky_footer: r }) {
  const t = (a) => {
    if (a.type === "package" && a.is_selected_by_default)
      return a;
    if ("components" in a && Array.isArray(a.components))
      for (const o of a.components) {
        const s = t(o);
        if (s !== void 0)
          return s;
      }
    if ("stack" in a) {
      const o = t(a.stack);
      if (o !== void 0)
        return o;
    }
  }, n = t(e);
  if (n !== void 0)
    return n == null ? void 0 : n.package_id;
  if (r != null) {
    const a = t(r);
    if (a !== void 0)
      return a == null ? void 0 : a.package_id;
  }
}
const nt = (e, r) => {
  if (!e)
    return {};
  const t = r == null ? void 0 : r.find((n) => n.conditions.find((a) => a.type === "selected"));
  return (t == null ? void 0 : t.properties) ?? {};
}, of = (e, r) => {
  if (!e)
    return {};
  const t = r == null ? void 0 : r.find((n) => n.conditions.find((a) => a.type === "hover"));
  return (t == null ? void 0 : t.properties) ?? {};
}, sf = (e, r) => {
  if (!e)
    return {};
  const t = r == null ? void 0 : r.find((n) => n.conditions.find((a) => a.type === "intro_offer"));
  return (t == null ? void 0 : t.properties) ?? {};
}, zl = [
  Ca.IntroOfferCondition,
  Ca.PromoOfferCondition,
  Ca.SelectedPackageCondition,
  Ca.VariableCondition
], lf = (e, r, t) => {
  const n = new Set(Object.values(Ca)), a = r == null ? void 0 : r.find((s) => s.conditions.every((l) => n.has(l.type)));
  return a ? [...a.conditions].sort((s, l) => zl.indexOf(s.type) - zl.indexOf(l.type)).every((s) => {
    var l, c, u;
    if (s.type === "intro_offer_condition") {
      const d = !!((l = e.packageInfo) != null && l.hasIntroOffer) || !!((c = e.packageInfo) != null && c.hasTrial);
      if (s.operator === "=")
        return d === s.value;
      if (s.operator === "!=")
        return d !== s.value;
    }
    if (s.type === "promo_offer_condition") {
      const d = !!((u = e.packageInfo) != null && u.hasPromoOffer);
      if (s.operator === "=")
        return d === s.value;
      if (s.operator === "!=")
        return d !== s.value;
    }
    if (s.type === "selected_package_condition") {
      const d = e.selectedPackageId ?? "";
      if (s.operator === "in")
        return s.packages.includes(d);
      if (s.operator === "not in")
        return !s.packages.includes(d);
    }
    if (s.type === "variable_condition") {
      const d = e.variables[s.variable], p = String(s.value.value);
      if (s.operator === "=")
        return d === p;
      if (s.operator === "!=")
        return d !== p;
    }
    return !1;
  }) : t ?? !0;
};
function cf(e, r) {
  ee(r, !0);
  const t = () => fe(l, "$selectedState", a), n = () => fe(g, "$inputSatisfied", a), [a, o] = Ae(), s = /* @__PURE__ */ ur(r, ["$$slots", "$$events", "$$legacy"]), l = tt(), c = /* @__PURE__ */ b(() => ({
    ...s,
    ...nt(t(), r.overrides)
  })), u = /* @__PURE__ */ b(() => i(c).action), { onButtonAction: d, hideBackButtons: p } = pn(), _ = Ls(), g = (_ == null ? void 0 : _.isSatisfied) ?? At(!0), h = /* @__PURE__ */ b(() => i(u).type === "workflow" && !n()), w = () => {
    var x;
    if (i(h)) return;
    const S = (x = r.triggers) == null ? void 0 : x.on_press;
    d(r.action, S);
  }, v = /* @__PURE__ */ b(() => {
    switch (i(u).type) {
      case "workflow":
        return !0;
      case "restore_purchases":
        return !1;
      case "navigate_back":
        return !p;
      case "navigate_to":
        return i(u).destination !== "web_paywall_link";
      default:
        return !0;
    }
  }), f = /* @__PURE__ */ b(() => i(h) ? {
    opacity: "0.4",
    "pointer-events": "none",
    cursor: "not-allowed"
  } : {});
  var y = _e(), k = J(y);
  {
    var m = (S) => {
      {
        let x = /* @__PURE__ */ b(() => `button-${i(u).type}`);
        _r(S, Ye(() => r.stack, {
          onclick: w,
          get style() {
            return i(f);
          },
          get testId() {
            return i(x);
          }
        }));
      }
    };
    W(k, (S) => {
      i(v) && S(m);
    });
  }
  T(e, y), re(), o();
}
const nd = Symbol("inputChoice");
function ad(e, r, t = !1, n = null, a = []) {
  const o = gr(new Set(a)), s = ct(o, (d) => (n == null ? void 0 : n.max) == null ? !1 : d.size >= n.max), l = ct(o, (d) => {
    const p = d.size;
    return !t && n == null ? !0 : t && n == null ? p >= 1 : t && n != null ? n.min === n.max ? p === n.min : p >= n.min && p <= n.max : !0;
  });
  let c = !1;
  return s.subscribe((d) => c = d), {
    fieldId: e,
    mode: r,
    required: t,
    selectionRange: n,
    selectedOptionIds: o,
    selectOption: (d) => {
      o.update((p) => {
        if (r === "single")
          return /* @__PURE__ */ new Set([d]);
        const _ = new Set(p);
        return _.has(d) ? _.delete(d) : c || _.add(d), _;
      });
    },
    isAtMax: s,
    isSatisfied: l
  };
}
function od(e) {
  $e(nd, e);
}
function uf() {
  return Le(nd);
}
function df(e, r) {
  ee(r, !0);
  const t = /* @__PURE__ */ ur(r, ["$$slots", "$$events", "$$legacy"]), { stack: n, field_id: a, required: o = !1, selection_range: s = null } = t, c = Qu()[a] ?? [], u = ad(a, "multiple", o, s, c);
  od(u);
  const d = Ls();
  if (d) {
    const p = u.isSatisfied.subscribe((_) => {
      d.updateSatisfaction(_);
    });
    Ot(p);
  }
  qa(e, {
    get nodeData() {
      return n;
    }
  }), re();
}
const id = Symbol("hover");
function pf(e) {
  $e(id, e);
}
function _f() {
  return Le(id) ?? At(!1);
}
var gf = /* @__PURE__ */ B('<div class="option-wrapper svelte-1rmlxgu"><!></div>');
const ff = {
  hash: "svelte-1rmlxgu",
  code: ".option-wrapper.svelte-1rmlxgu {display:contents;}"
};
function mf(e, r) {
  ee(r, !0), oe(e, ff);
  const t = () => fe(p, "$isDisabled", n), [n, a] = Ae(), o = /* @__PURE__ */ ur(r, ["$$slots", "$$events", "$$legacy"]), { stack: s, option_id: l } = o, { onButtonAction: c } = pn(), u = uf(), d = u ? ct(u.selectedOptionIds, (k) => k.has(l)) : At(!1);
  Zo(d);
  const p = u ? ct([d, u.isAtMax], ([k, m]) => !k && m) : At(!1), _ = gr(!1);
  pf(_);
  const g = () => _.set(!0), h = () => _.set(!1), w = () => {
    var m;
    if (t()) return;
    const k = (m = r.triggers) == null ? void 0 : m.on_press;
    u == null || u.selectOption(l), c({ type: "workflow" }, k);
  }, v = /* @__PURE__ */ b(() => t() ? { "pointer-events": "none", opacity: "0.4" } : void 0);
  var f = gf(), y = z(f);
  _r(y, Ye(() => s, {
    onclick: w,
    get style() {
      return i(v);
    }
  })), Vr("mouseenter", f, g), Vr("mouseleave", f, h), T(e, f), re(), a();
}
function hf(e, r) {
  ee(r, !0);
  const t = /* @__PURE__ */ ur(r, ["$$slots", "$$events", "$$legacy"]), { stack: n, field_id: a, required: o = !1, selection_range: s = null } = t, c = Qu()[a] ?? [], u = ad(a, "single", o, s, c);
  od(u);
  const d = Ls();
  if (d) {
    const p = u.isSatisfied.subscribe((_) => {
      d.updateSatisfaction(_);
    });
    Ot(p);
  }
  qa(e, {
    get nodeData() {
      return n;
    }
  }), re();
}
const sd = Symbol("variables");
function Bs(e) {
  $e(sd, e);
}
function Jo() {
  const e = Le(sd);
  if (e === void 0)
    throw new Error("Variables context not found");
  return e;
}
function yf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Un = {}, ci, Ml;
function bf() {
  return Ml || (Ml = 1, ci = function() {
    return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
  }), ci;
}
var ui = {}, Zt = {}, Ol;
function qn() {
  if (Ol) return Zt;
  Ol = 1;
  let e;
  const r = [
    0,
    // Not used
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
  ];
  return Zt.getSymbolSize = function(n) {
    if (!n) throw new Error('"version" cannot be null or undefined');
    if (n < 1 || n > 40) throw new Error('"version" should be in range from 1 to 40');
    return n * 4 + 17;
  }, Zt.getSymbolTotalCodewords = function(n) {
    return r[n];
  }, Zt.getBCHDigit = function(t) {
    let n = 0;
    for (; t !== 0; )
      n++, t >>>= 1;
    return n;
  }, Zt.setToSJISFunction = function(n) {
    if (typeof n != "function")
      throw new Error('"toSJISFunc" is not a valid function.');
    e = n;
  }, Zt.isKanjiModeEnabled = function() {
    return typeof e < "u";
  }, Zt.toSJIS = function(n) {
    return e(n);
  }, Zt;
}
var di = {}, jl;
function Us() {
  return jl || (jl = 1, function(e) {
    e.L = { bit: 1 }, e.M = { bit: 0 }, e.Q = { bit: 3 }, e.H = { bit: 2 };
    function r(t) {
      if (typeof t != "string")
        throw new Error("Param is not a string");
      switch (t.toLowerCase()) {
        case "l":
        case "low":
          return e.L;
        case "m":
        case "medium":
          return e.M;
        case "q":
        case "quartile":
          return e.Q;
        case "h":
        case "high":
          return e.H;
        default:
          throw new Error("Unknown EC Level: " + t);
      }
    }
    e.isValid = function(n) {
      return n && typeof n.bit < "u" && n.bit >= 0 && n.bit < 4;
    }, e.from = function(n, a) {
      if (e.isValid(n))
        return n;
      try {
        return r(n);
      } catch {
        return a;
      }
    };
  }(di)), di;
}
var pi, Nl;
function vf() {
  if (Nl) return pi;
  Nl = 1;
  function e() {
    this.buffer = [], this.length = 0;
  }
  return e.prototype = {
    get: function(r) {
      const t = Math.floor(r / 8);
      return (this.buffer[t] >>> 7 - r % 8 & 1) === 1;
    },
    put: function(r, t) {
      for (let n = 0; n < t; n++)
        this.putBit((r >>> t - n - 1 & 1) === 1);
    },
    getLengthInBits: function() {
      return this.length;
    },
    putBit: function(r) {
      const t = Math.floor(this.length / 8);
      this.buffer.length <= t && this.buffer.push(0), r && (this.buffer[t] |= 128 >>> this.length % 8), this.length++;
    }
  }, pi = e, pi;
}
var _i, Ll;
function kf() {
  if (Ll) return _i;
  Ll = 1;
  function e(r) {
    if (!r || r < 1)
      throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = r, this.data = new Uint8Array(r * r), this.reservedBit = new Uint8Array(r * r);
  }
  return e.prototype.set = function(r, t, n, a) {
    const o = r * this.size + t;
    this.data[o] = n, a && (this.reservedBit[o] = !0);
  }, e.prototype.get = function(r, t) {
    return this.data[r * this.size + t];
  }, e.prototype.xor = function(r, t, n) {
    this.data[r * this.size + t] ^= n;
  }, e.prototype.isReserved = function(r, t) {
    return this.reservedBit[r * this.size + t];
  }, _i = e, _i;
}
var gi = {}, Bl;
function wf() {
  return Bl || (Bl = 1, function(e) {
    const r = qn().getSymbolSize;
    e.getRowColCoords = function(n) {
      if (n === 1) return [];
      const a = Math.floor(n / 7) + 2, o = r(n), s = o === 145 ? 26 : Math.ceil((o - 13) / (2 * a - 2)) * 2, l = [o - 7];
      for (let c = 1; c < a - 1; c++)
        l[c] = l[c - 1] - s;
      return l.push(6), l.reverse();
    }, e.getPositions = function(n) {
      const a = [], o = e.getRowColCoords(n), s = o.length;
      for (let l = 0; l < s; l++)
        for (let c = 0; c < s; c++)
          l === 0 && c === 0 || // top-left
          l === 0 && c === s - 1 || // bottom-left
          l === s - 1 && c === 0 || a.push([o[l], o[c]]);
      return a;
    };
  }(gi)), gi;
}
var fi = {}, Ul;
function Pf() {
  if (Ul) return fi;
  Ul = 1;
  const e = qn().getSymbolSize, r = 7;
  return fi.getPositions = function(n) {
    const a = e(n);
    return [
      // top-left
      [0, 0],
      // top-right
      [a - r, 0],
      // bottom-left
      [0, a - r]
    ];
  }, fi;
}
var mi = {}, Rl;
function xf() {
  return Rl || (Rl = 1, function(e) {
    e.Patterns = {
      PATTERN000: 0,
      PATTERN001: 1,
      PATTERN010: 2,
      PATTERN011: 3,
      PATTERN100: 4,
      PATTERN101: 5,
      PATTERN110: 6,
      PATTERN111: 7
    };
    const r = {
      N1: 3,
      N2: 3,
      N3: 40,
      N4: 10
    };
    e.isValid = function(a) {
      return a != null && a !== "" && !isNaN(a) && a >= 0 && a <= 7;
    }, e.from = function(a) {
      return e.isValid(a) ? parseInt(a, 10) : void 0;
    }, e.getPenaltyN1 = function(a) {
      const o = a.size;
      let s = 0, l = 0, c = 0, u = null, d = null;
      for (let p = 0; p < o; p++) {
        l = c = 0, u = d = null;
        for (let _ = 0; _ < o; _++) {
          let g = a.get(p, _);
          g === u ? l++ : (l >= 5 && (s += r.N1 + (l - 5)), u = g, l = 1), g = a.get(_, p), g === d ? c++ : (c >= 5 && (s += r.N1 + (c - 5)), d = g, c = 1);
        }
        l >= 5 && (s += r.N1 + (l - 5)), c >= 5 && (s += r.N1 + (c - 5));
      }
      return s;
    }, e.getPenaltyN2 = function(a) {
      const o = a.size;
      let s = 0;
      for (let l = 0; l < o - 1; l++)
        for (let c = 0; c < o - 1; c++) {
          const u = a.get(l, c) + a.get(l, c + 1) + a.get(l + 1, c) + a.get(l + 1, c + 1);
          (u === 4 || u === 0) && s++;
        }
      return s * r.N2;
    }, e.getPenaltyN3 = function(a) {
      const o = a.size;
      let s = 0, l = 0, c = 0;
      for (let u = 0; u < o; u++) {
        l = c = 0;
        for (let d = 0; d < o; d++)
          l = l << 1 & 2047 | a.get(u, d), d >= 10 && (l === 1488 || l === 93) && s++, c = c << 1 & 2047 | a.get(d, u), d >= 10 && (c === 1488 || c === 93) && s++;
      }
      return s * r.N3;
    }, e.getPenaltyN4 = function(a) {
      let o = 0;
      const s = a.data.length;
      for (let c = 0; c < s; c++) o += a.data[c];
      return Math.abs(Math.ceil(o * 100 / s / 5) - 10) * r.N4;
    };
    function t(n, a, o) {
      switch (n) {
        case e.Patterns.PATTERN000:
          return (a + o) % 2 === 0;
        case e.Patterns.PATTERN001:
          return a % 2 === 0;
        case e.Patterns.PATTERN010:
          return o % 3 === 0;
        case e.Patterns.PATTERN011:
          return (a + o) % 3 === 0;
        case e.Patterns.PATTERN100:
          return (Math.floor(a / 2) + Math.floor(o / 3)) % 2 === 0;
        case e.Patterns.PATTERN101:
          return a * o % 2 + a * o % 3 === 0;
        case e.Patterns.PATTERN110:
          return (a * o % 2 + a * o % 3) % 2 === 0;
        case e.Patterns.PATTERN111:
          return (a * o % 3 + (a + o) % 2) % 2 === 0;
        default:
          throw new Error("bad maskPattern:" + n);
      }
    }
    e.applyMask = function(a, o) {
      const s = o.size;
      for (let l = 0; l < s; l++)
        for (let c = 0; c < s; c++)
          o.isReserved(c, l) || o.xor(c, l, t(a, c, l));
    }, e.getBestMask = function(a, o) {
      const s = Object.keys(e.Patterns).length;
      let l = 0, c = 1 / 0;
      for (let u = 0; u < s; u++) {
        o(u), e.applyMask(u, a);
        const d = e.getPenaltyN1(a) + e.getPenaltyN2(a) + e.getPenaltyN3(a) + e.getPenaltyN4(a);
        e.applyMask(u, a), d < c && (c = d, l = u);
      }
      return l;
    };
  }(mi)), mi;
}
var co = {}, Vl;
function ld() {
  if (Vl) return co;
  Vl = 1;
  const e = Us(), r = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
  ], t = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
  ];
  return co.getBlocksCount = function(a, o) {
    switch (o) {
      case e.L:
        return r[(a - 1) * 4 + 0];
      case e.M:
        return r[(a - 1) * 4 + 1];
      case e.Q:
        return r[(a - 1) * 4 + 2];
      case e.H:
        return r[(a - 1) * 4 + 3];
      default:
        return;
    }
  }, co.getTotalCodewordsCount = function(a, o) {
    switch (o) {
      case e.L:
        return t[(a - 1) * 4 + 0];
      case e.M:
        return t[(a - 1) * 4 + 1];
      case e.Q:
        return t[(a - 1) * 4 + 2];
      case e.H:
        return t[(a - 1) * 4 + 3];
      default:
        return;
    }
  }, co;
}
var hi = {}, Ea = {}, Hl;
function Ef() {
  if (Hl) return Ea;
  Hl = 1;
  const e = new Uint8Array(512), r = new Uint8Array(256);
  return function() {
    let n = 1;
    for (let a = 0; a < 255; a++)
      e[a] = n, r[n] = a, n <<= 1, n & 256 && (n ^= 285);
    for (let a = 255; a < 512; a++)
      e[a] = e[a - 255];
  }(), Ea.log = function(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return r[n];
  }, Ea.exp = function(n) {
    return e[n];
  }, Ea.mul = function(n, a) {
    return n === 0 || a === 0 ? 0 : e[r[n] + r[a]];
  }, Ea;
}
var Wl;
function Sf() {
  return Wl || (Wl = 1, function(e) {
    const r = Ef();
    e.mul = function(n, a) {
      const o = new Uint8Array(n.length + a.length - 1);
      for (let s = 0; s < n.length; s++)
        for (let l = 0; l < a.length; l++)
          o[s + l] ^= r.mul(n[s], a[l]);
      return o;
    }, e.mod = function(n, a) {
      let o = new Uint8Array(n);
      for (; o.length - a.length >= 0; ) {
        const s = o[0];
        for (let c = 0; c < a.length; c++)
          o[c] ^= r.mul(a[c], s);
        let l = 0;
        for (; l < o.length && o[l] === 0; ) l++;
        o = o.slice(l);
      }
      return o;
    }, e.generateECPolynomial = function(n) {
      let a = new Uint8Array([1]);
      for (let o = 0; o < n; o++)
        a = e.mul(a, new Uint8Array([1, r.exp(o)]));
      return a;
    };
  }(hi)), hi;
}
var yi, Yl;
function If() {
  if (Yl) return yi;
  Yl = 1;
  const e = Sf();
  function r(t) {
    this.genPoly = void 0, this.degree = t, this.degree && this.initialize(this.degree);
  }
  return r.prototype.initialize = function(n) {
    this.degree = n, this.genPoly = e.generateECPolynomial(this.degree);
  }, r.prototype.encode = function(n) {
    if (!this.genPoly)
      throw new Error("Encoder not initialized");
    const a = new Uint8Array(n.length + this.degree);
    a.set(n);
    const o = e.mod(a, this.genPoly), s = this.degree - o.length;
    if (s > 0) {
      const l = new Uint8Array(this.degree);
      return l.set(o, s), l;
    }
    return o;
  }, yi = r, yi;
}
var bi = {}, vi = {}, ki = {}, Gl;
function cd() {
  return Gl || (Gl = 1, ki.isValid = function(r) {
    return !isNaN(r) && r >= 1 && r <= 40;
  }), ki;
}
var _t = {}, Kl;
function ud() {
  if (Kl) return _t;
  Kl = 1;
  const e = "[0-9]+", r = "[A-Z $%*+\\-./:]+";
  let t = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
  t = t.replace(/u/g, "\\u");
  const n = "(?:(?![A-Z0-9 $%*+\\-./:]|" + t + `)(?:.|[\r
]))+`;
  _t.KANJI = new RegExp(t, "g"), _t.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g"), _t.BYTE = new RegExp(n, "g"), _t.NUMERIC = new RegExp(e, "g"), _t.ALPHANUMERIC = new RegExp(r, "g");
  const a = new RegExp("^" + t + "$"), o = new RegExp("^" + e + "$"), s = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
  return _t.testKanji = function(c) {
    return a.test(c);
  }, _t.testNumeric = function(c) {
    return o.test(c);
  }, _t.testAlphanumeric = function(c) {
    return s.test(c);
  }, _t;
}
var Xl;
function Fn() {
  return Xl || (Xl = 1, function(e) {
    const r = cd(), t = ud();
    e.NUMERIC = {
      id: "Numeric",
      bit: 1,
      ccBits: [10, 12, 14]
    }, e.ALPHANUMERIC = {
      id: "Alphanumeric",
      bit: 2,
      ccBits: [9, 11, 13]
    }, e.BYTE = {
      id: "Byte",
      bit: 4,
      ccBits: [8, 16, 16]
    }, e.KANJI = {
      id: "Kanji",
      bit: 8,
      ccBits: [8, 10, 12]
    }, e.MIXED = {
      bit: -1
    }, e.getCharCountIndicator = function(o, s) {
      if (!o.ccBits) throw new Error("Invalid mode: " + o);
      if (!r.isValid(s))
        throw new Error("Invalid version: " + s);
      return s >= 1 && s < 10 ? o.ccBits[0] : s < 27 ? o.ccBits[1] : o.ccBits[2];
    }, e.getBestModeForData = function(o) {
      return t.testNumeric(o) ? e.NUMERIC : t.testAlphanumeric(o) ? e.ALPHANUMERIC : t.testKanji(o) ? e.KANJI : e.BYTE;
    }, e.toString = function(o) {
      if (o && o.id) return o.id;
      throw new Error("Invalid mode");
    }, e.isValid = function(o) {
      return o && o.bit && o.ccBits;
    };
    function n(a) {
      if (typeof a != "string")
        throw new Error("Param is not a string");
      switch (a.toLowerCase()) {
        case "numeric":
          return e.NUMERIC;
        case "alphanumeric":
          return e.ALPHANUMERIC;
        case "kanji":
          return e.KANJI;
        case "byte":
          return e.BYTE;
        default:
          throw new Error("Unknown mode: " + a);
      }
    }
    e.from = function(o, s) {
      if (e.isValid(o))
        return o;
      try {
        return n(o);
      } catch {
        return s;
      }
    };
  }(vi)), vi;
}
var $l;
function Tf() {
  return $l || ($l = 1, function(e) {
    const r = qn(), t = ld(), n = Us(), a = Fn(), o = cd(), s = 7973, l = r.getBCHDigit(s);
    function c(_, g, h) {
      for (let w = 1; w <= 40; w++)
        if (g <= e.getCapacity(w, h, _))
          return w;
    }
    function u(_, g) {
      return a.getCharCountIndicator(_, g) + 4;
    }
    function d(_, g) {
      let h = 0;
      return _.forEach(function(w) {
        const v = u(w.mode, g);
        h += v + w.getBitsLength();
      }), h;
    }
    function p(_, g) {
      for (let h = 1; h <= 40; h++)
        if (d(_, h) <= e.getCapacity(h, g, a.MIXED))
          return h;
    }
    e.from = function(g, h) {
      return o.isValid(g) ? parseInt(g, 10) : h;
    }, e.getCapacity = function(g, h, w) {
      if (!o.isValid(g))
        throw new Error("Invalid QR Code version");
      typeof w > "u" && (w = a.BYTE);
      const v = r.getSymbolTotalCodewords(g), f = t.getTotalCodewordsCount(g, h), y = (v - f) * 8;
      if (w === a.MIXED) return y;
      const k = y - u(w, g);
      switch (w) {
        case a.NUMERIC:
          return Math.floor(k / 10 * 3);
        case a.ALPHANUMERIC:
          return Math.floor(k / 11 * 2);
        case a.KANJI:
          return Math.floor(k / 13);
        case a.BYTE:
        default:
          return Math.floor(k / 8);
      }
    }, e.getBestVersionForData = function(g, h) {
      let w;
      const v = n.from(h, n.M);
      if (Array.isArray(g)) {
        if (g.length > 1)
          return p(g, v);
        if (g.length === 0)
          return 1;
        w = g[0];
      } else
        w = g;
      return c(w.mode, w.getLength(), v);
    }, e.getEncodedBits = function(g) {
      if (!o.isValid(g) || g < 7)
        throw new Error("Invalid QR Code version");
      let h = g << 12;
      for (; r.getBCHDigit(h) - l >= 0; )
        h ^= s << r.getBCHDigit(h) - l;
      return g << 12 | h;
    };
  }(bi)), bi;
}
var wi = {}, Zl;
function Cf() {
  if (Zl) return wi;
  Zl = 1;
  const e = qn(), r = 1335, t = 21522, n = e.getBCHDigit(r);
  return wi.getEncodedBits = function(o, s) {
    const l = o.bit << 3 | s;
    let c = l << 10;
    for (; e.getBCHDigit(c) - n >= 0; )
      c ^= r << e.getBCHDigit(c) - n;
    return (l << 10 | c) ^ t;
  }, wi;
}
var Pi = {}, xi, Jl;
function Df() {
  if (Jl) return xi;
  Jl = 1;
  const e = Fn();
  function r(t) {
    this.mode = e.NUMERIC, this.data = t.toString();
  }
  return r.getBitsLength = function(n) {
    return 10 * Math.floor(n / 3) + (n % 3 ? n % 3 * 3 + 1 : 0);
  }, r.prototype.getLength = function() {
    return this.data.length;
  }, r.prototype.getBitsLength = function() {
    return r.getBitsLength(this.data.length);
  }, r.prototype.write = function(n) {
    let a, o, s;
    for (a = 0; a + 3 <= this.data.length; a += 3)
      o = this.data.substr(a, 3), s = parseInt(o, 10), n.put(s, 10);
    const l = this.data.length - a;
    l > 0 && (o = this.data.substr(a), s = parseInt(o, 10), n.put(s, l * 3 + 1));
  }, xi = r, xi;
}
var Ei, Ql;
function Af() {
  if (Ql) return Ei;
  Ql = 1;
  const e = Fn(), r = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
  ];
  function t(n) {
    this.mode = e.ALPHANUMERIC, this.data = n;
  }
  return t.getBitsLength = function(a) {
    return 11 * Math.floor(a / 2) + 6 * (a % 2);
  }, t.prototype.getLength = function() {
    return this.data.length;
  }, t.prototype.getBitsLength = function() {
    return t.getBitsLength(this.data.length);
  }, t.prototype.write = function(a) {
    let o;
    for (o = 0; o + 2 <= this.data.length; o += 2) {
      let s = r.indexOf(this.data[o]) * 45;
      s += r.indexOf(this.data[o + 1]), a.put(s, 11);
    }
    this.data.length % 2 && a.put(r.indexOf(this.data[o]), 6);
  }, Ei = t, Ei;
}
var Si, ec;
function qf() {
  if (ec) return Si;
  ec = 1;
  const e = Fn();
  function r(t) {
    this.mode = e.BYTE, typeof t == "string" ? this.data = new TextEncoder().encode(t) : this.data = new Uint8Array(t);
  }
  return r.getBitsLength = function(n) {
    return n * 8;
  }, r.prototype.getLength = function() {
    return this.data.length;
  }, r.prototype.getBitsLength = function() {
    return r.getBitsLength(this.data.length);
  }, r.prototype.write = function(t) {
    for (let n = 0, a = this.data.length; n < a; n++)
      t.put(this.data[n], 8);
  }, Si = r, Si;
}
var Ii, rc;
function Ff() {
  if (rc) return Ii;
  rc = 1;
  const e = Fn(), r = qn();
  function t(n) {
    this.mode = e.KANJI, this.data = n;
  }
  return t.getBitsLength = function(a) {
    return a * 13;
  }, t.prototype.getLength = function() {
    return this.data.length;
  }, t.prototype.getBitsLength = function() {
    return t.getBitsLength(this.data.length);
  }, t.prototype.write = function(n) {
    let a;
    for (a = 0; a < this.data.length; a++) {
      let o = r.toSJIS(this.data[a]);
      if (o >= 33088 && o <= 40956)
        o -= 33088;
      else if (o >= 57408 && o <= 60351)
        o -= 49472;
      else
        throw new Error(
          "Invalid SJIS character: " + this.data[a] + `
Make sure your charset is UTF-8`
        );
      o = (o >>> 8 & 255) * 192 + (o & 255), n.put(o, 13);
    }
  }, Ii = t, Ii;
}
var Ti = { exports: {} }, tc;
function zf() {
  return tc || (tc = 1, function(e) {
    var r = {
      single_source_shortest_paths: function(t, n, a) {
        var o = {}, s = {};
        s[n] = 0;
        var l = r.PriorityQueue.make();
        l.push(n, 0);
        for (var c, u, d, p, _, g, h, w, v; !l.empty(); ) {
          c = l.pop(), u = c.value, p = c.cost, _ = t[u] || {};
          for (d in _)
            _.hasOwnProperty(d) && (g = _[d], h = p + g, w = s[d], v = typeof s[d] > "u", (v || w > h) && (s[d] = h, l.push(d, h), o[d] = u));
        }
        if (typeof a < "u" && typeof s[a] > "u") {
          var f = ["Could not find a path from ", n, " to ", a, "."].join("");
          throw new Error(f);
        }
        return o;
      },
      extract_shortest_path_from_predecessor_list: function(t, n) {
        for (var a = [], o = n; o; )
          a.push(o), t[o], o = t[o];
        return a.reverse(), a;
      },
      find_path: function(t, n, a) {
        var o = r.single_source_shortest_paths(t, n, a);
        return r.extract_shortest_path_from_predecessor_list(
          o,
          a
        );
      },
      /**
       * A very naive priority queue implementation.
       */
      PriorityQueue: {
        make: function(t) {
          var n = r.PriorityQueue, a = {}, o;
          t = t || {};
          for (o in n)
            n.hasOwnProperty(o) && (a[o] = n[o]);
          return a.queue = [], a.sorter = t.sorter || n.default_sorter, a;
        },
        default_sorter: function(t, n) {
          return t.cost - n.cost;
        },
        /**
         * Add a new item to the queue and ensure the highest priority element
         * is at the front of the queue.
         */
        push: function(t, n) {
          var a = { value: t, cost: n };
          this.queue.push(a), this.queue.sort(this.sorter);
        },
        /**
         * Return the highest priority element in the queue.
         */
        pop: function() {
          return this.queue.shift();
        },
        empty: function() {
          return this.queue.length === 0;
        }
      }
    };
    e.exports = r;
  }(Ti)), Ti.exports;
}
var nc;
function Mf() {
  return nc || (nc = 1, function(e) {
    const r = Fn(), t = Df(), n = Af(), a = qf(), o = Ff(), s = ud(), l = qn(), c = zf();
    function u(f) {
      return unescape(encodeURIComponent(f)).length;
    }
    function d(f, y, k) {
      const m = [];
      let S;
      for (; (S = f.exec(k)) !== null; )
        m.push({
          data: S[0],
          index: S.index,
          mode: y,
          length: S[0].length
        });
      return m;
    }
    function p(f) {
      const y = d(s.NUMERIC, r.NUMERIC, f), k = d(s.ALPHANUMERIC, r.ALPHANUMERIC, f);
      let m, S;
      return l.isKanjiModeEnabled() ? (m = d(s.BYTE, r.BYTE, f), S = d(s.KANJI, r.KANJI, f)) : (m = d(s.BYTE_KANJI, r.BYTE, f), S = []), y.concat(k, m, S).sort(function(P, I) {
        return P.index - I.index;
      }).map(function(P) {
        return {
          data: P.data,
          mode: P.mode,
          length: P.length
        };
      });
    }
    function _(f, y) {
      switch (y) {
        case r.NUMERIC:
          return t.getBitsLength(f);
        case r.ALPHANUMERIC:
          return n.getBitsLength(f);
        case r.KANJI:
          return o.getBitsLength(f);
        case r.BYTE:
          return a.getBitsLength(f);
      }
    }
    function g(f) {
      return f.reduce(function(y, k) {
        const m = y.length - 1 >= 0 ? y[y.length - 1] : null;
        return m && m.mode === k.mode ? (y[y.length - 1].data += k.data, y) : (y.push(k), y);
      }, []);
    }
    function h(f) {
      const y = [];
      for (let k = 0; k < f.length; k++) {
        const m = f[k];
        switch (m.mode) {
          case r.NUMERIC:
            y.push([
              m,
              { data: m.data, mode: r.ALPHANUMERIC, length: m.length },
              { data: m.data, mode: r.BYTE, length: m.length }
            ]);
            break;
          case r.ALPHANUMERIC:
            y.push([
              m,
              { data: m.data, mode: r.BYTE, length: m.length }
            ]);
            break;
          case r.KANJI:
            y.push([
              m,
              { data: m.data, mode: r.BYTE, length: u(m.data) }
            ]);
            break;
          case r.BYTE:
            y.push([
              { data: m.data, mode: r.BYTE, length: u(m.data) }
            ]);
        }
      }
      return y;
    }
    function w(f, y) {
      const k = {}, m = { start: {} };
      let S = ["start"];
      for (let x = 0; x < f.length; x++) {
        const P = f[x], I = [];
        for (let E = 0; E < P.length; E++) {
          const D = P[E], F = "" + x + E;
          I.push(F), k[F] = { node: D, lastCount: 0 }, m[F] = {};
          for (let M = 0; M < S.length; M++) {
            const C = S[M];
            k[C] && k[C].node.mode === D.mode ? (m[C][F] = _(k[C].lastCount + D.length, D.mode) - _(k[C].lastCount, D.mode), k[C].lastCount += D.length) : (k[C] && (k[C].lastCount = D.length), m[C][F] = _(D.length, D.mode) + 4 + r.getCharCountIndicator(D.mode, y));
          }
        }
        S = I;
      }
      for (let x = 0; x < S.length; x++)
        m[S[x]].end = 0;
      return { map: m, table: k };
    }
    function v(f, y) {
      let k;
      const m = r.getBestModeForData(f);
      if (k = r.from(y, m), k !== r.BYTE && k.bit < m.bit)
        throw new Error('"' + f + '" cannot be encoded with mode ' + r.toString(k) + `.
 Suggested mode is: ` + r.toString(m));
      switch (k === r.KANJI && !l.isKanjiModeEnabled() && (k = r.BYTE), k) {
        case r.NUMERIC:
          return new t(f);
        case r.ALPHANUMERIC:
          return new n(f);
        case r.KANJI:
          return new o(f);
        case r.BYTE:
          return new a(f);
      }
    }
    e.fromArray = function(y) {
      return y.reduce(function(k, m) {
        return typeof m == "string" ? k.push(v(m, null)) : m.data && k.push(v(m.data, m.mode)), k;
      }, []);
    }, e.fromString = function(y, k) {
      const m = p(y, l.isKanjiModeEnabled()), S = h(m), x = w(S, k), P = c.find_path(x.map, "start", "end"), I = [];
      for (let E = 1; E < P.length - 1; E++)
        I.push(x.table[P[E]].node);
      return e.fromArray(g(I));
    }, e.rawSplit = function(y) {
      return e.fromArray(
        p(y, l.isKanjiModeEnabled())
      );
    };
  }(Pi)), Pi;
}
var ac;
function Of() {
  if (ac) return ui;
  ac = 1;
  const e = qn(), r = Us(), t = vf(), n = kf(), a = wf(), o = Pf(), s = xf(), l = ld(), c = If(), u = Tf(), d = Cf(), p = Fn(), _ = Mf();
  function g(x, P) {
    const I = x.size, E = o.getPositions(P);
    for (let D = 0; D < E.length; D++) {
      const F = E[D][0], M = E[D][1];
      for (let C = -1; C <= 7; C++)
        if (!(F + C <= -1 || I <= F + C))
          for (let j = -1; j <= 7; j++)
            M + j <= -1 || I <= M + j || (C >= 0 && C <= 6 && (j === 0 || j === 6) || j >= 0 && j <= 6 && (C === 0 || C === 6) || C >= 2 && C <= 4 && j >= 2 && j <= 4 ? x.set(F + C, M + j, !0, !0) : x.set(F + C, M + j, !1, !0));
    }
  }
  function h(x) {
    const P = x.size;
    for (let I = 8; I < P - 8; I++) {
      const E = I % 2 === 0;
      x.set(I, 6, E, !0), x.set(6, I, E, !0);
    }
  }
  function w(x, P) {
    const I = a.getPositions(P);
    for (let E = 0; E < I.length; E++) {
      const D = I[E][0], F = I[E][1];
      for (let M = -2; M <= 2; M++)
        for (let C = -2; C <= 2; C++)
          M === -2 || M === 2 || C === -2 || C === 2 || M === 0 && C === 0 ? x.set(D + M, F + C, !0, !0) : x.set(D + M, F + C, !1, !0);
    }
  }
  function v(x, P) {
    const I = x.size, E = u.getEncodedBits(P);
    let D, F, M;
    for (let C = 0; C < 18; C++)
      D = Math.floor(C / 3), F = C % 3 + I - 8 - 3, M = (E >> C & 1) === 1, x.set(D, F, M, !0), x.set(F, D, M, !0);
  }
  function f(x, P, I) {
    const E = x.size, D = d.getEncodedBits(P, I);
    let F, M;
    for (F = 0; F < 15; F++)
      M = (D >> F & 1) === 1, F < 6 ? x.set(F, 8, M, !0) : F < 8 ? x.set(F + 1, 8, M, !0) : x.set(E - 15 + F, 8, M, !0), F < 8 ? x.set(8, E - F - 1, M, !0) : F < 9 ? x.set(8, 15 - F - 1 + 1, M, !0) : x.set(8, 15 - F - 1, M, !0);
    x.set(E - 8, 8, 1, !0);
  }
  function y(x, P) {
    const I = x.size;
    let E = -1, D = I - 1, F = 7, M = 0;
    for (let C = I - 1; C > 0; C -= 2)
      for (C === 6 && C--; ; ) {
        for (let j = 0; j < 2; j++)
          if (!x.isReserved(D, C - j)) {
            let H = !1;
            M < P.length && (H = (P[M] >>> F & 1) === 1), x.set(D, C - j, H), F--, F === -1 && (M++, F = 7);
          }
        if (D += E, D < 0 || I <= D) {
          D -= E, E = -E;
          break;
        }
      }
  }
  function k(x, P, I) {
    const E = new t();
    I.forEach(function(j) {
      E.put(j.mode.bit, 4), E.put(j.getLength(), p.getCharCountIndicator(j.mode, x)), j.write(E);
    });
    const D = e.getSymbolTotalCodewords(x), F = l.getTotalCodewordsCount(x, P), M = (D - F) * 8;
    for (E.getLengthInBits() + 4 <= M && E.put(0, 4); E.getLengthInBits() % 8 !== 0; )
      E.putBit(0);
    const C = (M - E.getLengthInBits()) / 8;
    for (let j = 0; j < C; j++)
      E.put(j % 2 ? 17 : 236, 8);
    return m(E, x, P);
  }
  function m(x, P, I) {
    const E = e.getSymbolTotalCodewords(P), D = l.getTotalCodewordsCount(P, I), F = E - D, M = l.getBlocksCount(P, I), C = E % M, j = M - C, H = Math.floor(E / M), A = Math.floor(F / M), q = A + 1, O = H - A, G = new c(O);
    let Y = 0;
    const te = new Array(M), le = new Array(M);
    let be = 0;
    const ge = new Uint8Array(x.buffer);
    for (let De = 0; De < M; De++) {
      const ve = De < j ? A : q;
      te[De] = ge.slice(Y, Y + ve), le[De] = G.encode(te[De]), Y += ve, be = Math.max(be, ve);
    }
    const xe = new Uint8Array(E);
    let de = 0, ue, Ie;
    for (ue = 0; ue < be; ue++)
      for (Ie = 0; Ie < M; Ie++)
        ue < te[Ie].length && (xe[de++] = te[Ie][ue]);
    for (ue = 0; ue < O; ue++)
      for (Ie = 0; Ie < M; Ie++)
        xe[de++] = le[Ie][ue];
    return xe;
  }
  function S(x, P, I, E) {
    let D;
    if (Array.isArray(x))
      D = _.fromArray(x);
    else if (typeof x == "string") {
      let H = P;
      if (!H) {
        const A = _.rawSplit(x);
        H = u.getBestVersionForData(A, I);
      }
      D = _.fromString(x, H || 40);
    } else
      throw new Error("Invalid data");
    const F = u.getBestVersionForData(D, I);
    if (!F)
      throw new Error("The amount of data is too big to be stored in a QR Code");
    if (!P)
      P = F;
    else if (P < F)
      throw new Error(
        `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + F + `.
`
      );
    const M = k(P, I, D), C = e.getSymbolSize(P), j = new n(C);
    return g(j, P), h(j), w(j, P), f(j, I, 0), P >= 7 && v(j, P), y(j, M), isNaN(E) && (E = s.getBestMask(
      j,
      f.bind(null, j, I)
    )), s.applyMask(E, j), f(j, I, E), {
      modules: j,
      version: P,
      errorCorrectionLevel: I,
      maskPattern: E,
      segments: D
    };
  }
  return ui.create = function(P, I) {
    if (typeof P > "u" || P === "")
      throw new Error("No input text");
    let E = r.M, D, F;
    return typeof I < "u" && (E = r.from(I.errorCorrectionLevel, r.M), D = u.from(I.version), F = s.from(I.maskPattern), I.toSJISFunc && e.setToSJISFunction(I.toSJISFunc)), S(P, D, E, F);
  }, ui;
}
var Ci = {}, Di = {}, oc;
function dd() {
  return oc || (oc = 1, function(e) {
    function r(t) {
      if (typeof t == "number" && (t = t.toString()), typeof t != "string")
        throw new Error("Color should be defined as hex string");
      let n = t.slice().replace("#", "").split("");
      if (n.length < 3 || n.length === 5 || n.length > 8)
        throw new Error("Invalid hex color: " + t);
      (n.length === 3 || n.length === 4) && (n = Array.prototype.concat.apply([], n.map(function(o) {
        return [o, o];
      }))), n.length === 6 && n.push("F", "F");
      const a = parseInt(n.join(""), 16);
      return {
        r: a >> 24 & 255,
        g: a >> 16 & 255,
        b: a >> 8 & 255,
        a: a & 255,
        hex: "#" + n.slice(0, 6).join("")
      };
    }
    e.getOptions = function(n) {
      n || (n = {}), n.color || (n.color = {});
      const a = typeof n.margin > "u" || n.margin === null || n.margin < 0 ? 4 : n.margin, o = n.width && n.width >= 21 ? n.width : void 0, s = n.scale || 4;
      return {
        width: o,
        scale: o ? 4 : s,
        margin: a,
        color: {
          dark: r(n.color.dark || "#000000ff"),
          light: r(n.color.light || "#ffffffff")
        },
        type: n.type,
        rendererOpts: n.rendererOpts || {}
      };
    }, e.getScale = function(n, a) {
      return a.width && a.width >= n + a.margin * 2 ? a.width / (n + a.margin * 2) : a.scale;
    }, e.getImageWidth = function(n, a) {
      const o = e.getScale(n, a);
      return Math.floor((n + a.margin * 2) * o);
    }, e.qrToImageData = function(n, a, o) {
      const s = a.modules.size, l = a.modules.data, c = e.getScale(s, o), u = Math.floor((s + o.margin * 2) * c), d = o.margin * c, p = [o.color.light, o.color.dark];
      for (let _ = 0; _ < u; _++)
        for (let g = 0; g < u; g++) {
          let h = (_ * u + g) * 4, w = o.color.light;
          if (_ >= d && g >= d && _ < u - d && g < u - d) {
            const v = Math.floor((_ - d) / c), f = Math.floor((g - d) / c);
            w = p[l[v * s + f] ? 1 : 0];
          }
          n[h++] = w.r, n[h++] = w.g, n[h++] = w.b, n[h] = w.a;
        }
    };
  }(Di)), Di;
}
var ic;
function jf() {
  return ic || (ic = 1, function(e) {
    const r = dd();
    function t(a, o, s) {
      a.clearRect(0, 0, o.width, o.height), o.style || (o.style = {}), o.height = s, o.width = s, o.style.height = s + "px", o.style.width = s + "px";
    }
    function n() {
      try {
        return document.createElement("canvas");
      } catch {
        throw new Error("You need to specify a canvas element");
      }
    }
    e.render = function(o, s, l) {
      let c = l, u = s;
      typeof c > "u" && (!s || !s.getContext) && (c = s, s = void 0), s || (u = n()), c = r.getOptions(c);
      const d = r.getImageWidth(o.modules.size, c), p = u.getContext("2d"), _ = p.createImageData(d, d);
      return r.qrToImageData(_.data, o, c), t(p, u, d), p.putImageData(_, 0, 0), u;
    }, e.renderToDataURL = function(o, s, l) {
      let c = l;
      typeof c > "u" && (!s || !s.getContext) && (c = s, s = void 0), c || (c = {});
      const u = e.render(o, s, c), d = c.type || "image/png", p = c.rendererOpts || {};
      return u.toDataURL(d, p.quality);
    };
  }(Ci)), Ci;
}
var Ai = {}, sc;
function Nf() {
  if (sc) return Ai;
  sc = 1;
  const e = dd();
  function r(a, o) {
    const s = a.a / 255, l = o + '="' + a.hex + '"';
    return s < 1 ? l + " " + o + '-opacity="' + s.toFixed(2).slice(1) + '"' : l;
  }
  function t(a, o, s) {
    let l = a + o;
    return typeof s < "u" && (l += " " + s), l;
  }
  function n(a, o, s) {
    let l = "", c = 0, u = !1, d = 0;
    for (let p = 0; p < a.length; p++) {
      const _ = Math.floor(p % o), g = Math.floor(p / o);
      !_ && !u && (u = !0), a[p] ? (d++, p > 0 && _ > 0 && a[p - 1] || (l += u ? t("M", _ + s, 0.5 + g + s) : t("m", c, 0), c = 0, u = !1), _ + 1 < o && a[p + 1] || (l += t("h", d), d = 0)) : c++;
    }
    return l;
  }
  return Ai.render = function(o, s, l) {
    const c = e.getOptions(s), u = o.modules.size, d = o.modules.data, p = u + c.margin * 2, _ = c.color.light.a ? "<path " + r(c.color.light, "fill") + ' d="M0 0h' + p + "v" + p + 'H0z"/>' : "", g = "<path " + r(c.color.dark, "stroke") + ' d="' + n(d, u, c.margin) + '"/>', h = 'viewBox="0 0 ' + p + " " + p + '"', v = '<svg xmlns="http://www.w3.org/2000/svg" ' + (c.width ? 'width="' + c.width + '" height="' + c.width + '" ' : "") + h + ' shape-rendering="crispEdges">' + _ + g + `</svg>
`;
    return typeof l == "function" && l(null, v), v;
  }, Ai;
}
var lc;
function Lf() {
  if (lc) return Un;
  lc = 1;
  const e = bf(), r = Of(), t = jf(), n = Nf();
  function a(o, s, l, c, u) {
    const d = [].slice.call(arguments, 1), p = d.length, _ = typeof d[p - 1] == "function";
    if (!_ && !e())
      throw new Error("Callback required as last argument");
    if (_) {
      if (p < 2)
        throw new Error("Too few arguments provided");
      p === 2 ? (u = l, l = s, s = c = void 0) : p === 3 && (s.getContext && typeof u > "u" ? (u = c, c = void 0) : (u = c, c = l, l = s, s = void 0));
    } else {
      if (p < 1)
        throw new Error("Too few arguments provided");
      return p === 1 ? (l = s, s = c = void 0) : p === 2 && !s.getContext && (c = l, l = s, s = void 0), new Promise(function(g, h) {
        try {
          const w = r.create(l, c);
          g(o(w, s, c));
        } catch (w) {
          h(w);
        }
      });
    }
    try {
      const g = r.create(l, c);
      u(null, o(g, s, c));
    } catch (g) {
      u(g);
    }
  }
  return Un.create = r.create, Un.toCanvas = a.bind(null, t.render), Un.toDataURL = a.bind(null, t.renderToDataURL), Un.toString = a.bind(null, function(o, s, l) {
    return n.render(o, l);
  }), Un;
}
var Bf = Lf();
const Uf = /* @__PURE__ */ yf(Bf);
var Rf = /* @__PURE__ */ B('<div class="qr-wrapper svelte-107mxxy"><img alt="Redemption QR Code" class="qr-code svelte-107mxxy"/></div>');
const Vf = {
  hash: "svelte-107mxxy",
  code: ".qr-wrapper.svelte-107mxxy {display:flex;justify-content:center;align-items:center;align-self:center;width:fit-content;margin:0 auto;background-color:#ffffff;border-radius:8px;padding:16px;}.qr-code.svelte-107mxxy {display:block;width:128px;height:128px;image-rendering:-webkit-optimize-contrast;image-rendering:crisp-edges;}"
};
function Hf(e, r) {
  ee(r, !0), oe(e, Vf);
  const t = () => fe(o, "$variables", n), [n, a] = Ae(), o = Jo(), s = /* @__PURE__ */ b(() => {
    var h;
    return (h = t()) == null ? void 0 : h["success.redemption_url"];
  });
  let l = /* @__PURE__ */ X(!0), c = /* @__PURE__ */ X(""), u = /* @__PURE__ */ X(!1);
  nr(() => {
    const h = window.matchMedia("(max-width: 767px)");
    L(l, h.matches, !0);
    const w = (v) => {
      L(l, v.matches, !0);
    };
    return h.addEventListener("change", w), () => {
      h.removeEventListener("change", w);
    };
  }), kr(() => {
    !i(l) && i(s) && (L(u, !1), Uf.toDataURL(i(s), {
      width: 512,
      margin: 2,
      errorCorrectionLevel: "M",
      color: { dark: "#000000", light: "#ffffff" }
    }).then((h) => {
      L(c, h, !0);
    }).catch((h) => {
      console.warn("Failed to generate QR code:", h), L(u, !0);
    }));
  });
  var d = _e(), p = J(d);
  {
    var _ = (h) => {
      _r(h, Ye(() => r.stack, {
        onclick: () => {
          window.location.href = i(s);
        }
      }));
    }, g = (h) => {
      var w = _e(), v = J(w);
      {
        var f = (y) => {
          var k = Rf(), m = z(k);
          U(() => se(m, "src", i(c))), T(y, k);
        };
        W(
          v,
          (y) => {
            i(c) && y(f);
          },
          !0
        );
      }
      T(h, w);
    };
    W(p, (h) => {
      (i(l) || i(u)) && i(s) ? h(_) : h(g, !1);
    });
  }
  T(e, d), re(), a();
}
var cc;
(function(e) {
  e.body_s = "p", e.body_m = "p", e.body_l = "p", e.body_xl = "p", e.heading_xs = "h6", e.heading_s = "h5", e.heading_m = "h4", e.heading_l = "h3", e.heading_xl = "h2", e.heading_xxl = "h1";
})(cc || (cc = {}));
var Co;
(function(e) {
  e[e.extra_light = 100] = "extra_light", e[e.thin = 200] = "thin", e[e.light = 300] = "light", e[e.regular = 400] = "regular", e[e.medium = 500] = "medium", e[e.semibold = 600] = "semibold", e[e.bold = 700] = "bold", e[e.extra_bold = 800] = "extra_bold", e[e.black = 900] = "black";
})(Co || (Co = {}));
var Do;
(function(e) {
  e.body_s = "13px", e.body_m = "14px", e.body_l = "15px", e.body_xl = "16px", e.heading_xs = "14px", e.heading_s = "16px", e.heading_m = "18px", e.heading_l = "20px", e.heading_xl = "26px", e.heading_xxl = "32px";
})(Do || (Do = {}));
var Ao;
(function(e) {
  e.leading = "start", e.center = "center", e.trailing = "end";
})(Ao || (Ao = {}));
var uc;
(function(e) {
  e.vertical = "column", e.horizontal = "row", e.zlayer = "zstack";
})(uc || (uc = {}));
var dc;
(function(e) {
  e.top = "flex-start", e.leading = "flex-start", e.center = "center", e.bottom = "flex-end", e.trailing = "flex-end";
})(dc || (dc = {}));
var pc;
(function(e) {
  e.space_between = "space-between", e.space_around = "space-around", e.space_evenly = "space-evenly", e.start = "flex-start", e.center = "center", e.end = "flex-end";
})(pc || (pc = {}));
const ts = "light", Wf = "#000000", Oa = {
  top: 0,
  bottom: 0,
  leading: 0,
  trailing: 0
};
function Re(e) {
  return Object.entries(e).map(([r, t]) => `${r}:${t}`).join(";");
}
function mr(e) {
  return `${e}px`;
}
function pd(...e) {
  return e.map(mr).join(" ");
}
function Wt(e, r) {
  return r[e] ?? r.light;
}
function cr(e) {
  switch (e.type) {
    case "fill":
      return navigator.userAgent.includes("Firefox") ? "-moz-available" : "-webkit-fill-available";
    case "fit":
      return "fit-content";
    case "fixed":
      return mr(e.value);
    case "relative":
      return `${e.value * 100}%`;
  }
}
function ar(e) {
  const { top: r, bottom: t, leading: n, trailing: a } = e ?? Oa;
  return pd(r, a, t, n);
}
function _d(e) {
  if (e.type === "alias" || e.type === "hex")
    return e.value;
  const r = e.points.map((t) => `${t.color} ${t.percent}%`).join(", ");
  switch (e.type) {
    case "linear":
      return `linear-gradient(${e.degrees}deg, ${r})`;
    case "radial":
      return `radial-gradient(circle, ${r})`;
  }
}
function br(e, r) {
  if (r == null)
    return "transparent";
  const t = Wt(e, r);
  return _d(t);
}
function Yf(e, r) {
  return r == null ? "transparent" : br(e, r);
}
function In(e, r) {
  if (r == null)
    return "none";
  const t = br(e, r.color);
  return `${r.width}px solid ${t}`;
}
function Gf(e) {
  if (e == null)
    return "0";
  const { top_leading: r, top_trailing: t, bottom_trailing: n, bottom_leading: a } = e;
  return pd(r, t, n, a);
}
function ya(e) {
  switch (e == null ? void 0 : e.type) {
    case void 0:
    case "concave":
    case "convex":
      return "0";
    case "rectangle":
      return `${Gf(e.corners)}`;
    case "circle":
    case "pill":
      return "9999px";
  }
}
function ba(e, r) {
  if (r == null)
    return "none";
  const { x: t, y: n, radius: a } = r, o = br(e, r.color);
  return `${t}px ${n}px ${a}px ${o}`;
}
function qo(e) {
  switch (e) {
    case "fill":
      return "cover";
    case "fit":
      return "contain";
  }
}
function Kf(e, r) {
  return `url(${Wt(e, r).webp})`;
}
function Xf(e, r) {
  return console.error("Not supported yet"), `url(${Wt(e, r)})`;
}
function $f(e, r, t) {
  return t == null ? r == null ? "none" : br(e, r) : t.type === "color" ? br(e, r ?? t.value) : t.type === "image" ? Kf(e, t.value) : Xf(e, t.value);
}
function zn(e, r, t) {
  const n = $f(e, r, t);
  if ((t == null ? void 0 : t.type) !== "image")
    return { background: n };
  const { fit_mode: a, color_overlay: o } = t;
  return {
    background: n,
    "background-size": qo(a),
    "background-position": a === "fill" ? "center" : "top center",
    "background-repeat": "no-repeat",
    "--overlay": Yf(e, o)
  };
}
function Zf(e) {
  return e.startsWith("RCFM:");
}
function ns(e) {
  return `RevCatPaywall-${e}`;
}
async function Jf(e) {
  var t;
  if (!e.app.fonts || typeof document > "u")
    return;
  const r = [];
  for (const [n, a] of Object.entries(e.app.fonts)) {
    const o = a.web;
    if (!o || !o.url || !o.family) {
      console.warn(`[Font Registration] Skipping font ${n}: missing web config or required fields`);
      continue;
    }
    try {
      const s = `${ns(o.family)}-${o.style}-${o.weight}`, l = new FontFace(s, `url(${o.url})`, {
        weight: ((t = o.weight) == null ? void 0 : t.toString()) || "400",
        style: o.style || "normal"
      });
      l.family = ns(o.family);
      const c = l.load().then(() => {
        document.fonts.add(l), console.debug(`[Font Registration] Successfully registered font: ${s} (${o.family}, ${o.weight}, ${o.style})`);
      }).catch((u) => {
        console.warn(`[Font Registration] Failed to load font ${o.family}:`, u);
      });
      r.push(c);
    } catch (s) {
      console.warn(`[Font Registration] Failed to create FontFace for ${n}:`, s);
    }
  }
  try {
    await Promise.allSettled(r), console.debug(`[Font Registration] Font registration complete. Processed ${r.length} fonts.`);
  } catch (n) {
    console.warn("[Font Registration] Unexpected error during font registration:", n);
  }
}
const Qf = {
  light: { type: "hex", value: Wf }
};
function em(e, r) {
  const t = Wt(e, r), n = _d(t);
  switch (t.type) {
    case "alias":
    case "hex":
      return { color: n };
    case "linear":
    case "radial":
      return {
        color: "transparent",
        background: n,
        "-webkit-background-clip": "text",
        "background-clip": "text"
      };
  }
}
const rm = (e, r, t) => {
  var h;
  const { font_name: n, font_size: a, font_weight: o, font_weight_int: s, horizontal_alignment: l, color: c = Qf, padding: u, margin: d, size: p } = r, _ = t[n ?? ""], g = (h = _ == null ? void 0 : _.web) == null ? void 0 : h.family;
  return Re({
    display: "block",
    width: cr(p.width),
    height: cr(p.height),
    margin: ar(d),
    padding: ar(u),
    ...em(e, c),
    "text-align": Ao[l] || Ao.leading,
    "font-weight": s ?? Co[o] ?? Co.regular,
    "font-size": Number.isInteger(Number(a)) ? `${a}px` : Do[a] || Do.body_m,
    "font-family": Zf(n ?? "") ? ns(g ?? "") : "sans-serif"
  });
};
function tm(e, r, t, n) {
  return Re({
    display: "block",
    position: "relative",
    width: cr(t.width),
    height: cr(t.height),
    ...zn(e, n, null)
  });
}
function nm(e) {
  return e ? Object.values({
    newLine: { regexp: /\\\n/g, output: "<br/>" },
    bold: { regexp: /\*\*(.*?)\*\*/g, output: "<b>$1</b>" },
    italic: { regexp: /\*(.*?)\*/g, output: "<i>$1</i>" },
    strikethrough: { regexp: /~(.*?)~/g, output: "<s>$1</s>" },
    code: {
      regexp: /`(.*?)`/g,
      output: "<span style='font-family: monospace'>$1</span>"
    },
    link: {
      regexp: /\[(.*?)\]\((.*?)\)/g,
      output: "<a href=$2 target='_blank' rel='noopener noreferrer'>$1</a>"
    }
  }).reduce((t, { regexp: n, output: a }) => t.replaceAll(n, a), e) : "";
}
function am(e, r) {
  const t = K(r, "style", 3, ""), n = K(r, "component", 3, "p");
  var a = _e(), o = J(a);
  Fs(o, n, !1, (s, l) => {
    Ms(s, () => ({ style: t() }));
    var c = _e(), u = J(c);
    Ze(u, () => r.children ?? ze), T(l, c);
  }), T(e, a);
}
var Ga, Ka;
class om {
  /**
   *
   * @param {() => T} fn
   * @param {(update: () => void) => void} onsubscribe
   */
  constructor(r, t) {
    we(this, Ga);
    we(this, Ka);
    ke(this, Ga, r), ke(this, Ka, lu(t));
  }
  get current() {
    return N(this, Ka).call(this), N(this, Ga).call(this);
  }
}
Ga = new WeakMap(), Ka = new WeakMap();
const im = /\(.+\)/, sm = /* @__PURE__ */ new Set(["all", "print", "screen", "and", "or", "not", "only"]);
class lm extends om {
  /**
   * @param {string} query A media query string
   * @param {boolean} [fallback] Fallback value for the server
   */
  constructor(r, t) {
    let n = im.test(r) || // we need to use `some` here because technically this `window.matchMedia('random,screen')` still returns true
    r.split(/[\s,]+/).some((o) => sm.has(o.trim())) ? r : `(${r})`;
    const a = window.matchMedia(n);
    super(
      () => a.matches,
      (o) => z_(a, "change", o)
    );
  }
}
const gd = Symbol("color-mode");
function cm(e) {
  const r = new lm("prefers-color-scheme: dark", ((e == null ? void 0 : e()) ?? ts) === "dark"), t = () => (e == null ? void 0 : e()) ?? (r.current ? "dark" : ts);
  return $e(gd, t), t;
}
function at() {
  return Le(gd) ?? (() => ts);
}
const fd = Symbol("localization");
function um(e) {
  const t = {
    getLocalizedString: (n) => {
      var d, p;
      if (!n)
        return "";
      const { selectedLocale: a, defaultLocale: o, localizations: s } = e(), c = (d = s[a ?? o]) == null ? void 0 : d[n], u = (p = s[o]) == null ? void 0 : p[n];
      return c ?? u;
    }
  };
  return $e(fd, t), t;
}
function dm() {
  const e = Le(fd);
  if (e === void 0)
    throw new Error("Localization context not found");
  return e;
}
function pm(e) {
  return e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
}
const _m = {
  uppercase: (e) => String(e ?? "").toUpperCase(),
  lowercase: (e) => String(e ?? "").toLowerCase(),
  capitalize: (e) => String(e ?? "").replaceAll(new RegExp("(\\p{Letter}+)", "giu"), pm)
}, gm = /^\$?custom\./;
function fm(e, r) {
  const t = /\{\{\s*([$a-z0-9._-]+)(?:\s*\|\s*([^}]*))?\s*\}\}/gi;
  return e.replace(t, (n, a, o) => {
    var d;
    const s = (d = a == null ? void 0 : a.trim()) == null ? void 0 : d.replace(gm, ""), l = s && r[s];
    if (l === void 0)
      return "";
    const c = o == null ? void 0 : o.trim();
    if (c === void 0)
      return l;
    const u = _m[c];
    return u ? u(l) : l;
  });
}
function mm(e = "", r) {
  return fm(e, r ?? {});
}
const md = Symbol("packageInfo");
function hd(e) {
  $e(md, e);
}
function yd() {
  const e = Le(md);
  if (e === void 0)
    throw new Error("PackageInfo context not found");
  return e;
}
var hm = /* @__PURE__ */ B("<span><!></span>");
function as(e, r) {
  ee(r, !0);
  const t = () => fe(u, "$selectedState", s), n = () => fe(d, "$packageInfo", s), a = () => fe(_, "$selectedPackageId", s), o = () => fe(k, "$variables", s), [s, l] = Ae(), c = /* @__PURE__ */ ur(r, ["$$slots", "$$events", "$$legacy"]), u = tt(), d = yd(), { uiConfig: p, selectedPackageId: _ } = pn(), g = /* @__PURE__ */ b(() => {
    var D, F;
    return {
      ...c,
      ...nt(t(), r.overrides),
      ...sf(!!((D = n()) != null && D.hasIntroOffer) || !!((F = n()) != null && F.hasTrial), r.overrides)
    };
  }), h = /* @__PURE__ */ b(() => lf(
    {
      selectedPackageId: a(),
      packageInfo: n(),
      variables: o()
    },
    r.overrides,
    r.visible
  )), w = at(), v = /* @__PURE__ */ b(w);
  let f = /* @__PURE__ */ b(() => rm(i(v), i(g), p.app.fonts));
  const y = /* @__PURE__ */ b(() => tm(i(v), i(g), i(g).size, i(g).background_color)), k = Jo(), { getLocalizedString: m } = dm(), S = /* @__PURE__ */ b(() => mm(m(i(g).text_lid), o())), x = /* @__PURE__ */ b(() => nm(i(S)));
  var P = _e(), I = J(P);
  {
    var E = (D) => {
      var F = hm(), M = z(F);
      am(M, {
        get style() {
          return i(f);
        },
        component: "span",
        children: (C, j) => {
          var H = _e(), A = J(H);
          dn(A, () => i(x)), T(C, H);
        },
        $$slots: { default: !0 }
      }), U(() => Pe(F, i(y))), T(D, F);
    };
    W(I, (D) => {
      i(h) && D(E);
    });
  }
  T(e, P), re(), l();
}
function ym(e) {
  switch (e) {
    case "top":
      return "flex-start";
    case "center":
      return "center";
    case "bottom":
      return "flex-end";
  }
}
function bm(e, r, t) {
  return Math.max(r, Math.min(e, t));
}
function uo(e) {
  if (e === null)
    return 0;
  const r = window.getComputedStyle(e);
  return new WebKitCSSMatrix(r.transform).m41;
}
var vm = /* @__PURE__ */ B('<div class="page svelte-1lg7l28" role="group" aria-roledescription="slide"><!></div>');
const km = {
  hash: "svelte-1lg7l28",
  code: "div.svelte-1lg7l28 {flex:0 0 100%;scroll-snap-align:center;scroll-snap-stop:always;}"
};
function qi(e, r) {
  oe(e, km);
  const t = K(r, "hidden", 3, !1);
  var n = vm(), a = z(n);
  _r(a, Ye(() => r.page)), U(() => {
    se(n, "aria-label", `Slide ${r.index + 1} of ${r.pages}`), se(n, "aria-current", r.selected), se(n, "aria-hidden", t());
  }), T(e, n);
}
var wm = /* @__PURE__ */ B("<div></div>"), Pm = /* @__PURE__ */ B('<div class="control svelte-wr84on"></div>');
const xm = {
  hash: "svelte-wr84on",
  code: ".control.svelte-wr84on {align-self:center;display:flex;flex-direction:row;align-items:center;justify-content:center;}"
};
function Em(e, r) {
  ee(r, !0), oe(e, xm);
  const t = K(r, "background_color", 3, null), n = K(r, "border", 3, null), a = K(r, "shape", 3, null), o = K(r, "shadow", 3, null), s = at(), l = /* @__PURE__ */ b(s);
  function c(h) {
    return h.stroke_width == null || h.stroke_color == null ? "none" : In(i(l), { width: h.stroke_width, color: h.stroke_color });
  }
  function u(h) {
    return Re({
      width: mr(h.width),
      height: mr(h.height),
      background: br(i(l), h.color),
      border: c(h),
      "border-radius": "9999px"
    });
  }
  const d = /* @__PURE__ */ b(() => u(r.default)), p = /* @__PURE__ */ b(() => u(r.active)), _ = /* @__PURE__ */ b(() => Re({
    order: r.position === "top" ? -1 : 1,
    gap: mr(r.spacing),
    margin: ar(r.margin),
    padding: ar(r.padding),
    ...zn(i(l), t(), null),
    border: In(i(l), n()),
    "border-radius": ya(a()),
    "box-shadow": ba(i(l), o())
  }));
  var g = Pm();
  Dt(g, 21, () => ({ length: r.length }), Ht, (h, w, v) => {
    var f = wm();
    U(() => Pe(f, v === r.selected ? i(p) : i(d))), T(h, f);
  }), U(() => Pe(g, i(_))), T(e, g), re();
}
var Sm = /* @__PURE__ */ B('<div class="carousel svelte-1mwlqyp"><div class="slider svelte-1mwlqyp" role="region" aria-label="Feature carousel" aria-roledescription="carousel" aria-live="polite"><!> <!> <!></div> <!></div>');
const Im = {
  hash: "svelte-1mwlqyp",
  code: ".carousel.svelte-1mwlqyp {max-width:100%;display:flex;flex-direction:column;overflow:hidden;flex-shrink:0;}.slider.svelte-1mwlqyp {display:flex;flex-direction:row;flex-wrap:nowrap;transition-property:transform;transition-duration:500ms;transition-timing-function:ease-in-out;transition-delay:2500ms;transform:translateX(0);cursor:grab;&:active {cursor:grabbing;user-select:none;}}"
};
function Tm(e, r) {
  ee(r, !0), oe(e, Im);
  const t = () => fe(s, "$selectedState", n), [n, a] = Ae(), o = /* @__PURE__ */ ur(r, ["$$slots", "$$events", "$$legacy"]), s = tt(), l = /* @__PURE__ */ b(() => ({
    ...o,
    ...nt(t(), r.overrides)
  })), c = /* @__PURE__ */ b(() => i(l).pages), u = /* @__PURE__ */ b(() => i(l).padding), d = /* @__PURE__ */ b(() => i(l).margin), p = /* @__PURE__ */ b(() => i(l).background), _ = /* @__PURE__ */ b(() => i(l).shape), g = /* @__PURE__ */ b(() => i(l).border), h = /* @__PURE__ */ b(() => i(l).shadow), w = /* @__PURE__ */ b(() => i(l).page_alignment), v = /* @__PURE__ */ b(() => i(l).page_spacing), f = /* @__PURE__ */ b(() => i(l).page_peek), y = /* @__PURE__ */ b(() => i(l).page_control), k = /* @__PURE__ */ b(() => i(l).initial_page_index), m = /* @__PURE__ */ b(() => i(l).loop), S = /* @__PURE__ */ b(() => i(l).auto_advance), x = at(), P = /* @__PURE__ */ b(x), I = /* @__PURE__ */ b(() => {
    var ie;
    return Re({
      margin: ar(i(d)),
      padding: ar(i(u)),
      ...zn(i(P), null, i(p)),
      border: In(i(P), i(g)),
      "border-radius": ya(i(_)),
      "box-shadow": ba(i(P), i(h)),
      "transition-duration": `${((ie = i(S)) == null ? void 0 : ie.ms_transition_time) ?? 0}ms`
    });
  }), E = /* @__PURE__ */ b(() => Re({
    gap: mr(i(v)),
    padding: `0 ${i(f) + i(v)}px`,
    "align-items": ym(i(w))
  })), D = /* @__PURE__ */ b(() => {
    if (!i(m))
      return [];
    const ie = i(c).length - 1;
    switch (i(c).length) {
      case 0:
        return [];
      case 1:
        return [0, 0];
      case 2:
        return [0, ie];
      default:
        return [ie - 1, ie];
    }
  }), F = /* @__PURE__ */ b(() => {
    if (!i(m))
      return [];
    switch (i(c).length) {
      case 0:
        return [];
      case 1:
        return [0, 0];
      default:
        return [0, 1];
    }
  });
  let M = null, C = /* @__PURE__ */ X(0), j = /* @__PURE__ */ X(0), H = /* @__PURE__ */ b(() => 2 * i(f) + i(v)), A = /* @__PURE__ */ b(() => i(j) - i(H));
  function q(ie = !0, Ne) {
    var Sr, Yr;
    if (M === null)
      return;
    const Ke = ie ? ((Sr = i(S)) == null ? void 0 : Sr.ms_time_per_page) ?? 0 : 0;
    Ne ?? (Ne = ((Yr = i(S)) == null ? void 0 : Yr.ms_transition_time) ?? 0), M.style.transition = `transform ${Ne}ms ease-in-out ${Ke}ms`;
  }
  function O() {
    M !== null && (M.style.transition = "none");
  }
  const G = /* @__PURE__ */ b(() => i(m) ? 2 : 0);
  function Y(ie) {
    M !== null && (M.style.transform = `translateX(${ie}px)`);
  }
  function te(ie) {
    if (M === null)
      return;
    ie += i(G);
    const Ne = ie * -i(A);
    Y(Ne);
  }
  function le(ie) {
    ie %= i(c).length + i(G), q(!0), te(ie);
  }
  function be() {
    i(S) != null && requestAnimationFrame(() => {
      le(i(C) + 1);
    });
  }
  nr(() => {
    const ie = i(c).at(i(k)) !== void 0 ? i(k) : 0;
    L(C, ie, !0), O(), te(i(C)), be();
  });
  function ge(ie) {
    return Math.round(ie / -i(A)) - i(G);
  }
  function xe() {
    const ie = uo(M), Ne = ge(ie);
    L(C, (Ne + i(c).length) % i(c).length), O(), te(i(C)), requestAnimationFrame(() => {
      be();
    });
  }
  let de = /* @__PURE__ */ X(0);
  function ue(ie) {
    ie.currentTarget.setPointerCapture(ie.pointerId), L(de, uo(M), !0);
  }
  function Ie(ie) {
    ie.currentTarget.releasePointerCapture(ie.pointerId);
    const Ke = uo(M), Sr = ge(Ke);
    q(!1, 500), te(Sr);
  }
  function De(ie) {
    if (!ie.currentTarget.hasPointerCapture(ie.pointerId))
      return;
    const [Ke, Sr] = i(m) ? [
      i(de) - i(j),
      i(de) + i(j)
    ] : [-(i(c).length - 1) * i(A), 0], Yr = uo(M), Kt = bm(Yr + ie.movementX, Ke, Sr), ot = ge(Kt);
    L(C, (ot + i(c).length) % i(c).length), Y(Kt), O();
  }
  var ve = Sm(), Te = z(ve);
  Te.__pointerdown = ue, Te.__pointerup = Ie, Te.__pointermove = De;
  var ir = z(Te);
  Dt(ir, 17, () => i(D), Ht, (ie, Ne) => {
    {
      let Ke = /* @__PURE__ */ b(() => i(C) === i(Ne));
      qi(ie, {
        get page() {
          return i(c)[i(Ne)];
        },
        get index() {
          return i(Ne);
        },
        get pages() {
          return i(c).length;
        },
        get selected() {
          return i(Ke);
        },
        hidden: !0
      });
    }
  });
  var Je = R(ir, 2);
  Dt(Je, 17, () => i(c), Ht, (ie, Ne, Ke) => {
    {
      let Sr = /* @__PURE__ */ b(() => i(C) === Ke);
      qi(ie, {
        get page() {
          return i(Ne);
        },
        index: Ke,
        get pages() {
          return i(c).length;
        },
        get selected() {
          return i(Sr);
        }
      });
    }
  });
  var me = R(Je, 2);
  Dt(me, 17, () => i(F), Ht, (ie, Ne) => {
    {
      let Ke = /* @__PURE__ */ b(() => i(C) === i(Ne));
      qi(ie, {
        get page() {
          return i(c)[i(Ne)];
        },
        get index() {
          return i(Ne);
        },
        get pages() {
          return i(c).length;
        },
        get selected() {
          return i(Ke);
        },
        hidden: !0
      });
    }
  }), to(Te, (ie) => M = ie, () => M);
  var Oe = R(Te, 2);
  {
    var Ar = (ie) => {
      Em(ie, Ye(() => i(y), {
        get length() {
          return i(c).length;
        },
        get selected() {
          return i(C);
        }
      }));
    };
    W(Oe, (ie) => {
      i(y) != null && ie(Ar);
    });
  }
  U(() => {
    Pe(ve, i(I)), Pe(Te, i(E));
  }), Vr("transitionend", Te, xe), Os(Te, "clientWidth", (ie) => L(j, ie)), T(e, ve), re(), a();
}
ro(["pointerdown", "pointerup", "pointermove"]);
var Cm = /* @__PURE__ */ B("<div><div></div></div>");
function bd(e, r) {
  ee(r, !0);
  const t = () => fe(s, "$selectedState", n), [n, a] = Ae(), o = /* @__PURE__ */ ur(r, ["$$slots", "$$events", "$$legacy"]), s = tt(), l = /* @__PURE__ */ b(() => ({
    ...o,
    ...nt(t(), r.overrides)
  })), c = /* @__PURE__ */ b(() => i(l).base_url), u = /* @__PURE__ */ b(() => i(l).formats), d = /* @__PURE__ */ b(() => i(l).size), p = /* @__PURE__ */ b(() => i(l).margin), _ = /* @__PURE__ */ b(() => i(l).padding), g = /* @__PURE__ */ b(() => i(l).color), h = /* @__PURE__ */ b(() => i(l).icon_background), w = at(), v = /* @__PURE__ */ b(w), f = /* @__PURE__ */ b(() => {
    var x, P, I, E;
    return Re({
      width: cr(i(d).width),
      height: cr(i(d).height),
      margin: ar(i(p)),
      padding: ar(i(_)),
      "background-color": br(i(v), (x = i(h)) == null ? void 0 : x.color),
      border: In(i(v), (P = i(h)) == null ? void 0 : P.border),
      "border-radius": ya((I = i(h)) == null ? void 0 : I.shape),
      "box-shadow": ba(i(v), (E = i(h)) == null ? void 0 : E.shadow),
      flex: "0 0 auto"
    });
  }), y = /* @__PURE__ */ b(() => `${i(c)}/${i(u).webp}`), k = /* @__PURE__ */ b(() => Re({
    width: "100%",
    height: "100%",
    position: "relative",
    "z-index": 1,
    overflow: "hidden",
    "background-color": br(i(v), i(g)),
    "mask-image": `url(${i(y)})`,
    "-webkit-mask-image": `url(${i(y)})`,
    "mask-size": "contain",
    "-webkit-mask-size": "contain",
    "mask-position": "center",
    "-webkit-mask-position": "center",
    "mask-repeat": "no-repeat",
    "-webkit-mask-repeat": "no-repeat"
  }));
  var m = Cm(), S = z(m);
  U(() => {
    Pe(m, i(f)), Pe(S, i(k));
  }), T(e, m), re(), a();
}
const vd = Symbol("selected");
function Dm(e) {
  $e(vd, e);
}
function Rs() {
  const e = Le(vd);
  if (e === void 0)
    throw new Error("Tabs context not found");
  return e;
}
function Am(e, r) {
  ee(r, !0);
  const t = () => fe(o, "$control", n), [n, a] = Ae(), { control: o } = Rs();
  _r(e, Ye(() => t().stack)), re(), a();
}
function qm(e, r) {
  ee(r, !0);
  const { selectedTabId: t, selectTab: n } = Rs();
  Zo(ct(t, (o) => o === r.tab_id)), _r(e, Ye(() => r.stack, { onclick: () => {
    n(r.tab_id, r.tab_index);
  } })), re();
}
var Fm = /* @__PURE__ */ B('<div role="button" tabindex="0" aria-label="Toggle" class="toggle svelte-2yf755"><div class="thumb svelte-2yf755"></div></div>');
const zm = {
  hash: "svelte-2yf755",
  code: `.toggle.svelte-2yf755 {appearance:none;--height: 31px;position:relative;width:51px;height:var(--height);border-radius:calc(var(--height) / 2);cursor:pointer;user-select:none;transition:background-color 300ms ease;}.thumb.svelte-2yf755 {--size: 27px;position:absolute;top:2px;width:var(--size);height:var(--size);border-radius:50%;box-shadow:0 1px 3px rgba(0, 0, 0, 0.2),
      0 1px 2px rgba(0, 0, 0, 0.12);transition:left 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94),
      background-color 300ms ease;}`
};
function Mm(e, r) {
  ee(r, !0), oe(e, zm);
  const t = () => fe(l, "$selectedState", a), n = () => fe(g, "$isActive", a), [a, o] = Ae(), s = /* @__PURE__ */ ur(r, ["$$slots", "$$events", "$$legacy"]), l = tt(), c = /* @__PURE__ */ b(() => ({
    ...s,
    ...nt(t(), r.overrides)
  })), u = /* @__PURE__ */ b(() => i(c).thumb_color_on), d = /* @__PURE__ */ b(() => i(c).thumb_color_off), p = /* @__PURE__ */ b(() => i(c).track_color_on), _ = /* @__PURE__ */ b(() => i(c).track_color_off), { isActive: g, selectTab: h } = Rs();
  Zo(g);
  const w = at(), v = /* @__PURE__ */ b(w), f = /* @__PURE__ */ b(() => Re({
    background: n() ? br(i(v), i(p)) : br(i(v), i(_))
  })), y = /* @__PURE__ */ b(() => Re({
    left: n() ? "22px" : "2px",
    background: n() ? br(i(v), i(u)) : br(i(v), i(d))
  })), k = () => {
    h("", n() ? 0 : 1);
  }, m = (P) => {
    (P.code === "Enter" || P.code === "Space") && k();
  };
  var S = Fm();
  S.__click = k, S.__keydown = m;
  var x = z(S);
  U(() => {
    Pe(S, i(f)), Pe(x, i(y));
  }), T(e, S), re(), o();
}
ro(["click", "keydown"]);
var Om = /* @__PURE__ */ B("<div><!></div>");
function jm(e, r) {
  ee(r, !0);
  const t = () => fe(d, "$selectedState", a), n = () => fe(P, "$tab", a), [a, o] = Ae(), s = /* @__PURE__ */ ur(r, ["$$slots", "$$events", "$$legacy"]), { control: l, tabs: c, default_tab_id: u } = s, d = tt(), p = /* @__PURE__ */ b(() => ({
    ...s,
    ...nt(t(), r.overrides)
  })), _ = /* @__PURE__ */ b(() => i(p).size), g = /* @__PURE__ */ b(() => i(p).padding), h = /* @__PURE__ */ b(() => i(p).margin), w = /* @__PURE__ */ b(() => i(p).background), v = /* @__PURE__ */ b(() => i(p).shape), f = /* @__PURE__ */ b(() => i(p).border), y = /* @__PURE__ */ b(() => i(p).shadow), k = at(), m = /* @__PURE__ */ b(k), S = /* @__PURE__ */ b(() => Re({
    width: cr(i(_).width),
    height: cr(i(_).height),
    margin: ar(i(h)),
    padding: ar(i(g)),
    ...zn(i(m), null, i(w)),
    border: In(i(m), i(f)),
    "border-radius": ya(i(v)),
    "box-shadow": ba(i(m), i(y))
  })), x = gr(Math.max(0, c.findIndex((M) => M.id === u))), P = ct(x, (M) => c[M]), I = (M, C) => {
    const j = c.findIndex((A) => A.id === M), H = j !== -1 ? j : C;
    H >= 0 && H < c.length && x.set(C);
  };
  Dm({
    control: At(l),
    selectedTabId: ct(P, (M) => M.id),
    selectTab: I,
    isActive: ct(x, (M) => M === 1)
  });
  var E = Om(), D = z(E);
  {
    var F = (M) => {
      _r(M, Ye(() => n().stack));
    };
    W(D, (M) => {
      n() !== void 0 && M(F);
    });
  }
  U(() => Pe(E, i(S))), T(e, E), re(), o();
}
const Nm = Object.freeze({
  leading: "flex-start",
  top: "flex-start",
  center: "center",
  trailing: "flex-end",
  bottom: "flex-end"
}), Lm = Object.freeze({
  space_between: "space-between",
  space_around: "space-around",
  space_evenly: "space-evenly",
  start: "flex-start",
  center: "center",
  end: "flex-end"
});
function Vs(e) {
  if (e.type === "zlayer")
    return {};
  const r = e.type === "vertical" ? "column" : "row", t = Lm[e.distribution] || "center", n = Nm[e.alignment] || "center";
  return {
    "flex-direction": r,
    "justify-content": t,
    "align-items": n
  };
}
const Bm = Object.freeze({
  top_leading: { justifyContent: "flex-start", alignItems: "flex-start" },
  top: { justifyContent: "center", alignItems: "flex-start" },
  top_trailing: { justifyContent: "flex-end", alignItems: "flex-start" },
  leading: { justifyContent: "flex-start", alignItems: "center" },
  center: { justifyContent: "center", alignItems: "center" },
  trailing: { justifyContent: "flex-end", alignItems: "center" },
  bottom_leading: { justifyContent: "flex-start", alignItems: "flex-end" },
  bottom: { justifyContent: "center", alignItems: "flex-end" },
  bottom_trailing: { justifyContent: "flex-end", alignItems: "flex-end" }
});
function Um(e) {
  return Bm[e];
}
function Rm(e, r) {
  if (e == null)
    return {};
  const { style: t, alignment: n } = e, a = n.startsWith("top"), o = n.endsWith("leading"), s = n.endsWith("trailing"), l = !o && !s, c = r ?? 0;
  if (t === "overlay") {
    const u = l ? "translateX(-50%)" : "", d = a ? "translateY(-50%)" : "translateY(50%)";
    return {
      "z-index": 10,
      position: "absolute",
      width: "max-content",
      top: a ? mr(-c / 2) : "initial",
      bottom: a ? "initial" : mr(-c / 2),
      left: o ? mr(-c) : l ? "50%" : "initial",
      right: s ? mr(-c) : "initial",
      transform: `${u} ${d}`
    };
  }
  return t === "nested" ? {
    "z-index": 10,
    position: "absolute",
    inset: 0,
    display: "flex",
    top: a ? mr(c) : "initial",
    bottom: a ? "initial" : mr(c),
    left: o ? mr(c) : l ? "50%" : "initial",
    right: s ? mr(c) : "initial",
    transform: l ? "translateX(-50%)" : "initial"
  } : {};
}
var Vm = /* @__PURE__ */ B('<div><div style="flex-grow: 1; width:100%;"></div></div>');
function Hm(e, r) {
  ee(r, !0);
  const t = () => fe(l, "$selectedPackageId", n), [n, a] = Ae(), { walletButtonRender: o, onWalletButtonReady: s, selectedPackageId: l } = pn(), c = { width: { type: "fill" }, height: { type: "fit" } }, u = {
    type: "vertical",
    alignment: "center",
    distribution: "center"
  }, d = /* @__PURE__ */ b(() => ({
    size: r.size ?? c,
    dimension: r.dimension ?? u,
    spacing: r.spacing ?? 0,
    margin: r.margin ?? Oa,
    border: r.border ?? null,
    shape: r.shape ?? null,
    shadow: r.shadow ?? null,
    style: r.style
  })), p = /* @__PURE__ */ b(() => i(d).size), _ = /* @__PURE__ */ b(() => i(d).dimension), g = /* @__PURE__ */ b(() => i(d).spacing), h = /* @__PURE__ */ b(() => i(d).margin), w = /* @__PURE__ */ b(() => i(d).style), v = /* @__PURE__ */ b(() => ({
    ...i(w),
    display: "flex",
    position: "relative",
    width: cr(i(p).width),
    height: cr(i(p).height),
    ...Vs(i(_)),
    gap: mr(i(g)),
    margin: ar({
      ...i(h) ? { ...i(h) } : { ...Oa }
    })
  })), f = /* @__PURE__ */ b(() => Re(i(v)));
  var y = _e(), k = J(y);
  {
    var m = (S) => {
      var x = Vm(), P = z(x);
      Q_(P, (I, E) => o == null ? void 0 : o(I, E), () => ({
        selectedPackageId: t(),
        onReady: r.onWalletButtonReady ?? s
      })), U(() => Pe(x, i(f))), T(S, x);
    };
    W(k, (S) => {
      o && t() && S(m);
    });
  }
  T(e, y), re(), a();
}
var Wm = /* @__PURE__ */ B('<div class="wallet-skeleton svelte-yh0jjo">&nbsp;</div>');
const Ym = {
  hash: "svelte-yh0jjo",
  code: `.wallet-skeleton.svelte-yh0jjo {position:relative;overflow:hidden;border-radius:9999px;background-color:rgba(128, 128, 128, 0.16);backdrop-filter:blur(18px);min-height:48px;content:" ";flex-grow:1;width:100%;}.wallet-skeleton.svelte-yh0jjo::before {content:"";position:absolute;inset:0;background:linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.01)
    );opacity:0.9;mix-blend-mode:screen;}.wallet-skeleton.svelte-yh0jjo::after {content:"";position:absolute;inset:0;transform:translateX(-100%);background:linear-gradient(
      120deg,
      transparent 0%,
      rgba(255, 255, 255, 0.6) 20%,
      transparent 40%
    );opacity:0.8;
    animation: svelte-yh0jjo-wallet-skeleton-shimmer 1.4s ease-in-out infinite;}

  @keyframes svelte-yh0jjo-wallet-skeleton-shimmer {
    100% {
      transform: translateX(100%);
    }
  }`
};
function Gm(e, r) {
  ee(r, !0), oe(e, Ym);
  const t = { width: { type: "fill" }, height: { type: "fit" } }, n = {
    type: "vertical",
    alignment: "center",
    distribution: "center"
  }, a = /* @__PURE__ */ b(() => ({
    size: r.size ?? t,
    dimension: r.dimension ?? n,
    spacing: r.spacing ?? 0,
    margin: r.margin ?? Oa,
    border: r.border ?? null,
    shape: r.shape ?? null,
    shadow: r.shadow ?? null,
    style: r.style
  })), o = /* @__PURE__ */ b(() => i(a).size), s = /* @__PURE__ */ b(() => i(a).dimension), l = /* @__PURE__ */ b(() => i(a).spacing), c = /* @__PURE__ */ b(() => i(a).margin), u = /* @__PURE__ */ b(() => i(a).border), d = /* @__PURE__ */ b(() => i(a).shape), p = /* @__PURE__ */ b(() => i(a).shadow), _ = /* @__PURE__ */ b(() => i(a).style), g = 10, h = at(), w = /* @__PURE__ */ b(h), v = /* @__PURE__ */ b(() => ({
    ...i(_),
    display: "flex",
    position: "relative",
    width: cr(i(o).width),
    height: cr(i(o).height),
    ...Vs(i(s)),
    gap: mr(i(l)),
    margin: ar({
      ...i(c) ? {
        ...i(c),
        bottom: Math.max(i(c).bottom, g)
      } : {
        ...Oa,
        bottom: g
      }
    })
  })), f = /* @__PURE__ */ b(() => Re({
    ...i(v),
    border: In(i(w), i(u)),
    "border-radius": ya(i(d)),
    "box-shadow": ba(i(w), i(p))
  }));
  var y = Wm();
  se(y, "aria-hidden", !0), U(() => Pe(y, i(f))), T(e, y), re();
}
var Km = /* @__PURE__ */ B("<!> <!>", 1);
function Xm(e, r) {
  ee(r, !0);
  const t = /* @__PURE__ */ ur(r, ["$$slots", "$$events", "$$legacy"]), {
    wallet_unknown_stack: n,
    wallet_available_stack: a,
    wallet_unavailable_stack: o,
    type: s,
    ...l
  } = t, { walletButtonRender: c, ...u } = pn();
  let d = /* @__PURE__ */ X(void 0), p = /* @__PURE__ */ X(!!c);
  rd({ walletButtonRender: c, ...u, onWalletButtonReady: (v) => {
    L(d, v, !0), L(p, !1);
  } });
  const g = /* @__PURE__ */ b(() => !i(d) || !a), h = /* @__PURE__ */ b(() => !!(a && i(d) && !i(p))), w = {
    components: [],
    type: "stack",
    visible: null,
    dimension: { type: "vertical", distribution: "start", alignment: "center" },
    background_color: null,
    spacing: 0,
    ...l
  };
  _r(e, Ye(() => w, {
    children: (v, f) => {
      var y = Km(), k = J(y);
      {
        let P = /* @__PURE__ */ b(() => ({
          ...a,
          visible: i(h)
        }));
        _r(k, Ye(() => i(P)));
      }
      var m = R(k, 2);
      {
        var S = (P) => {
          _r(P, Ye(() => n));
        }, x = (P) => {
          var I = _e(), E = J(I);
          {
            var D = (F) => {
              _r(F, Ye(() => o));
            };
            W(
              E,
              (F) => {
                i(g) && F(D);
              },
              !0
            );
          }
          T(P, I);
        };
        W(m, (P) => {
          i(p) ? P(S) : P(x, !1);
        });
      }
      T(v, y);
    },
    $$slots: { default: !0 }
  })), re();
}
function qa(e, r) {
  ee(r, !0);
  const t = {
    button: cf,
    carousel: Tm,
    countdown: rh,
    express_purchase_button: Xm,
    footer: kd,
    icon: bd,
    image: vh,
    input_multiple_choice: df,
    input_option: mf,
    input_single_choice: hf,
    package: kh,
    purchase_button: Ch,
    redemption_button: Hf,
    skeleton_loader: Gm,
    stack: _r,
    tab_control_button: qm,
    tab_control_toggle: Mm,
    tab_control: Am,
    tabs: jm,
    text: as,
    timeline: Oh,
    video: Hh,
    wallet_button: Hm
  }, n = (g) => {
    if (t[g.type])
      return [t[g.type], g];
    const { fallback: h } = g;
    if (h && t[h == null ? void 0 : h.type])
      return [t[h.type], h];
  }, a = /* @__PURE__ */ ur(r, ["$$slots", "$$events", "$$legacy", "nodeData"]), o = /* @__PURE__ */ b(() => n(r.nodeData) ?? []), s = /* @__PURE__ */ b(() => Ko(i(o), 2)), l = /* @__PURE__ */ b(() => i(s)[0]), c = /* @__PURE__ */ b(() => i(s)[1]);
  var u = { getComponentClass: n }, d = _e(), p = J(d);
  {
    var _ = (g) => {
      var h = _e(), w = J(h);
      K_(w, () => i(l), (v, f) => {
        f(v, Ye(() => i(c) || {}, () => a));
      }), T(g, h);
    };
    W(p, (g) => {
      i(l) && g(_);
    });
  }
  return T(e, d), re(u);
}
var $m = /* @__PURE__ */ B("<div><!></div>"), Zm = /* @__PURE__ */ B("<div><!></div>"), Jm = /* @__PURE__ */ B('<div style="position: relative; width: 100%; height: 100%;"></div>'), Qm = /* @__PURE__ */ B("<!> <!> <!>", 1);
const eh = {
  hash: "svelte-1yfn3n3",
  code: '.stack.svelte-1yfn3n3 {appearance:none;position:relative;&[role="button"] {cursor:pointer;}&::before {content:"";position:absolute;top:0;left:0;width:100%;height:100%;background:var(--overlay);}}'
};
function _r(e, r) {
  ee(r, !0), oe(e, eh);
  const t = () => fe(_, "$hoverState", a), n = () => fe(p, "$selectedState", a), [a, o] = Ae(), s = /* @__PURE__ */ ur(r, ["$$slots", "$$events", "$$legacy"]), { onclick: l, children: c, class: u, testId: d } = s, p = tt(), _ = _f(), g = /* @__PURE__ */ b(() => ({
    ...s,
    ...of(t(), r.overrides),
    ...nt(n(), r.overrides)
  })), h = /* @__PURE__ */ b(() => i(g).components), w = /* @__PURE__ */ b(() => i(g).size), v = /* @__PURE__ */ b(() => i(g).dimension), f = /* @__PURE__ */ b(() => i(g).spacing), y = /* @__PURE__ */ b(() => i(g).margin), k = /* @__PURE__ */ b(() => i(g).padding), m = /* @__PURE__ */ b(() => i(g).background_color), S = /* @__PURE__ */ b(() => i(g).background), x = /* @__PURE__ */ b(() => i(g).border), P = /* @__PURE__ */ b(() => i(g).shape), I = /* @__PURE__ */ b(() => i(g).shadow), E = /* @__PURE__ */ b(() => i(g).badge), D = at(), F = /* @__PURE__ */ b(D), M = /* @__PURE__ */ b(() => Re({
    display: r.visible === !1 ? "none" : "flex",
    position: "relative",
    width: cr(i(w).width),
    height: cr(i(w).height),
    ...Vs(i(v)),
    gap: mr(i(f)),
    margin: ar(i(y)),
    padding: ar(i(k)),
    ...zn(i(F), i(m), i(S)),
    border: In(i(F), i(x)),
    "border-radius": ya(i(P)),
    "box-shadow": ba(i(F), i(I)),
    // Read from props proxy so $derived re-evaluates when parent updates style
    ...r.style
  })), C = (q) => {
    if (q === 0 || i(v).type !== "zlayer")
      return "";
    const { justifyContent: O, alignItems: G } = Um(i(v).alignment);
    return Re({
      position: "absolute",
      inset: 0,
      display: "flex",
      "justify-content": O,
      "align-items": G,
      "z-index": q + 1
    });
  }, j = /* @__PURE__ */ b(() => {
    var q;
    return Re(Rm(i(E), (q = i(x)) == null ? void 0 : q.width));
  });
  var H = _e(), A = J(H);
  Fs(A, () => l !== void 0 ? "button" : "div", !1, (q, O) => {
    Ms(
      q,
      (de) => ({
        role: l !== void 0 ? "button" : void 0,
        onclick: l,
        style: i(M),
        class: de,
        "data-testid": d
      }),
      [() => ["stack", u].filter(Boolean).join(" ")],
      void 0,
      void 0,
      "svelte-1yfn3n3"
    );
    var G = Qm(), Y = J(G);
    {
      var te = (de) => {
        var ue = $m(), Ie = z(ue);
        qa(Ie, {
          get nodeData() {
            return i(E).stack;
          }
        }), U(() => Pe(ue, i(j))), T(de, ue);
      };
      W(Y, (de) => {
        i(E) && de(te);
      });
    }
    var le = R(Y, 2);
    {
      var be = (de) => {
        var ue = Jm();
        Dt(ue, 21, () => i(h), Ht, (Ie, De, ve) => {
          var Te = Zm(), ir = z(Te);
          qa(ir, {
            get nodeData() {
              return i(De);
            }
          }), U((Je) => Pe(Te, Je), [() => C(ve)]), T(Ie, Te);
        }), T(de, ue);
      }, ge = (de) => {
        var ue = _e(), Ie = J(ue);
        Dt(Ie, 17, () => i(h), Ht, (De, ve) => {
          qa(De, {
            get nodeData() {
              return i(ve);
            }
          });
        }), T(de, ue);
      };
      W(le, (de) => {
        i(v).type === "zlayer" ? de(be) : de(ge, !1);
      });
    }
    var xe = R(le, 2);
    c == null || c(xe), T(O, G);
  }), T(e, H), re(), o();
}
function po(e) {
  return e < 10 ? `0${e}` : `${e}`;
}
function _o(e) {
  return `${e}`;
}
function _c(e) {
  const r = /* @__PURE__ */ new Date(), n = new Date(e).getTime() - r.getTime();
  if (n <= 0)
    return {
      count_days_with_zero: "00",
      count_days_without_zero: "0",
      count_hours_with_zero: "00",
      count_hours_without_zero: "0",
      count_minutes_with_zero: "00",
      count_minutes_without_zero: "0",
      count_seconds_with_zero: "00",
      count_seconds_without_zero: "0"
    };
  const a = Math.floor(n / 1e3), o = Math.floor(a / 60), s = Math.floor(o / 60), c = Math.floor(s / 24), u = s % 24, d = o % 60, p = a % 60;
  return {
    count_days_with_zero: po(c),
    count_days_without_zero: _o(c),
    count_hours_with_zero: po(u),
    count_hours_without_zero: _o(u),
    count_minutes_with_zero: po(d),
    count_minutes_without_zero: _o(d),
    count_seconds_with_zero: po(p),
    count_seconds_without_zero: _o(p)
  };
}
function gc(e) {
  const r = /* @__PURE__ */ new Date();
  return new Date(e).getTime() <= r.getTime();
}
function rh(e, r) {
  ee(r, !0);
  const t = /* @__PURE__ */ ur(r, ["$$slots", "$$events", "$$legacy"]), { countdown_stack: n, end_stack: a } = t;
  let o = /* @__PURE__ */ X(Xe(_c(r.style.date))), s = /* @__PURE__ */ X(Xe(gc(r.style.date)));
  const l = Jo(), c = gr(i(o)), u = ct([l, c], ([p, _]) => ({ ...p, ..._ }));
  Bs(u), kr(() => {
    const p = setInterval(
      () => {
        L(o, _c(r.style.date), !0), L(s, gc(r.style.date), !0), c.set(i(o));
      },
      1e3
    );
    return () => clearInterval(p);
  });
  const d = /* @__PURE__ */ b(() => i(s) && a ? a : n);
  _r(e, Ye(() => i(d))), re();
}
var th = /* @__PURE__ */ B('<div class="svelte-36rikz"><!></div>');
const nh = {
  hash: "svelte-36rikz",
  code: "div.svelte-36rikz {position:sticky;bottom:0;width:100%;z-index:1000;display:flex;flex-direction:row;justify-content:center;}"
};
function kd(e, r) {
  oe(e, nh);
  var t = th(), n = z(t);
  _r(n, Ye(() => r.stack)), T(e, t);
}
var ah = /* @__PURE__ */ or("<circle></circle>"), oh = /* @__PURE__ */ or("<path></path>"), ih = /* @__PURE__ */ or("<path></path>"), sh = /* @__PURE__ */ or("<path></path>"), lh = /* @__PURE__ */ or("<!><!><!><!>", 1);
function Fo(e, r) {
  ee(r, !0);
  const t = /* @__PURE__ */ b(() => {
    var y;
    if (((y = r.shape) == null ? void 0 : y.type) !== "rectangle")
      return [0, 0, 0, 0];
    const { corners: f } = r.shape;
    return [
      (f == null ? void 0 : f.top_leading) ?? 0,
      (f == null ? void 0 : f.top_trailing) ?? 0,
      (f == null ? void 0 : f.bottom_trailing) ?? 0,
      (f == null ? void 0 : f.bottom_leading) ?? 0
    ];
  }), n = /* @__PURE__ */ b(() => Ko(i(t), 4)), a = /* @__PURE__ */ b(() => i(n)[0]), o = /* @__PURE__ */ b(() => i(n)[1]), s = /* @__PURE__ */ b(() => i(n)[2]), l = /* @__PURE__ */ b(() => i(n)[3]);
  var c = lh(), u = J(c);
  {
    var d = (f) => {
      var y = ah();
      U(
        (k) => {
          se(y, "cx", r.width / 2), se(y, "cy", r.height / 2), se(y, "r", k);
        },
        [() => Math.min(r.width, r.height) / 2]
      ), T(f, y);
    };
    W(u, (f) => {
      var y;
      ((y = r.shape) == null ? void 0 : y.type) === "circle" && f(d);
    });
  }
  var p = R(u);
  {
    var _ = (f) => {
      var y = oh();
      U(() => se(y, "d", `M 0 0 L ${r.width} 0 L ${r.width}  ${r.height} Q ${r.width / 2} ${r.height - 54} 0 ${r.height} Z`)), T(f, y);
    };
    W(p, (f) => {
      var y;
      ((y = r.shape) == null ? void 0 : y.type) === "concave" && f(_);
    });
  }
  var g = R(p);
  {
    var h = (f) => {
      var y = ih();
      U(() => se(y, "d", `M 0 0 L ${r.width} 0 L ${r.width} ${r.height - 27} Q ${r.width / 2} ${r.height + 27} 0 ${r.height - 27} Z`)), T(f, y);
    };
    W(g, (f) => {
      var y;
      ((y = r.shape) == null ? void 0 : y.type) === "convex" && f(h);
    });
  }
  var w = R(g);
  {
    var v = (f) => {
      var y = sh();
      U(() => se(y, "d", `M ${i(a)} 0 H ${r.width - i(o)} A ${i(o)} ${i(o)} 0 0 1 ${r.width} ${i(o)}
        V ${r.height - i(s)} A ${i(s)} ${i(s)} 0 0 1 ${r.width - i(s)} ${r.height}
        H ${i(l)} A ${i(l)} ${i(l)} 0 0 1 0 ${r.height - i(l)}
        V ${i(a)} A ${i(a)} ${i(a)} 0 0 1 ${i(a)} 0 Z`)), T(f, y);
    };
    W(w, (f) => {
      var y, k;
      (((y = r.shape) == null ? void 0 : y.type) === "rectangle" || ((k = r.shape) == null ? void 0 : k.type) === void 0) && f(v);
    });
  }
  T(e, c), re();
}
var ch = /* @__PURE__ */ or('<linearGradient x1="0" y1="0" x2="100%" y2="100%"><stop offset="0%"></stop><stop offset="100%"></stop></linearGradient>'), uh = /* @__PURE__ */ or("<stop></stop>"), dh = /* @__PURE__ */ or("<linearGradient></linearGradient>"), ph = /* @__PURE__ */ or("<stop></stop>"), _h = /* @__PURE__ */ or("<radialGradient></radialGradient>"), gh = /* @__PURE__ */ or("<!><!><!>", 1);
function wd(e, r) {
  ee(r, !0);
  var t = gh(), n = J(t);
  {
    var a = (u) => {
      var d = ch(), p = z(d), _ = R(p);
      U(() => {
        se(d, "id", r.id), se(p, "stop-color", r.overlay.value), se(_, "stop-color", r.overlay.value);
      }), T(u, d);
    };
    W(n, (u) => {
      var d;
      ((d = r.overlay) == null ? void 0 : d.type) === "hex" && u(a);
    });
  }
  var o = R(n);
  {
    var s = (u) => {
      var d = dh();
      Dt(d, 21, () => r.overlay.points, Ht, (p, _) => {
        var g = uh();
        U(() => {
          se(g, "offset", `${i(_).percent}%`), se(g, "stop-color", i(_).color);
        }), T(p, g);
      }), U(() => {
        se(d, "id", r.id), se(d, "gradientTransform", `rotate(${r.overlay.degrees - 90}, 0.5, 0.5)`);
      }), T(u, d);
    };
    W(o, (u) => {
      var d;
      ((d = r.overlay) == null ? void 0 : d.type) === "linear" && u(s);
    });
  }
  var l = R(o);
  {
    var c = (u) => {
      var d = _h();
      Dt(d, 21, () => r.overlay.points, Ht, (p, _) => {
        var g = ph();
        U(() => {
          se(g, "offset", `${i(_).percent}%`), se(g, "stop-color", i(_).color);
        }), T(p, g);
      }), U(() => se(d, "id", r.id)), T(u, d);
    };
    W(l, (u) => {
      var d;
      ((d = r.overlay) == null ? void 0 : d.type) === "radial" && u(c);
    });
  }
  T(e, t), re();
}
var fh = /* @__PURE__ */ or('<use fill="transparent"></use>'), mh = /* @__PURE__ */ or('<rect x="0" y="0" height="100%" width="100%"></rect>'), hh = /* @__PURE__ */ or('<use fill="none"></use>'), yh = /* @__PURE__ */ B('<div><svg width="100%" height="100%"><defs><clipPath><!></clipPath><g><!></g><!></defs><!><g><foreignObject x="0" y="0" width="100%" height="100%"><img alt="" class="svelte-1oyp9gj"/></foreignObject><!><!></g></svg></div>');
const bh = {
  hash: "svelte-1oyp9gj",
  code: "img.svelte-1oyp9gj {width:100%;height:100%;object-fit:contain;object-position:center;}"
};
function vh(e, r) {
  ee(r, !0), oe(e, bh);
  const t = () => fe(s, "$selectedState", n), [n, a] = Ae(), o = /* @__PURE__ */ ur(r, ["$$slots", "$$events", "$$legacy"]), s = tt(), l = /* @__PURE__ */ b(() => ({
    ...o,
    ...nt(t(), r.overrides)
  })), c = /* @__PURE__ */ b(() => i(l).id), u = /* @__PURE__ */ b(() => i(l).source), d = /* @__PURE__ */ b(() => i(l).size), p = /* @__PURE__ */ b(() => i(l).mask_shape), _ = /* @__PURE__ */ b(() => i(l).fit_mode), g = /* @__PURE__ */ b(() => i(l).padding), h = /* @__PURE__ */ b(() => i(l).margin), w = /* @__PURE__ */ b(() => i(l).color_overlay), v = /* @__PURE__ */ b(() => i(l).border), f = /* @__PURE__ */ b(() => i(l).shadow), y = at(), k = /* @__PURE__ */ b(y), m = /* @__PURE__ */ b(() => Wt(i(k), i(u)));
  let S = /* @__PURE__ */ X(0), x = /* @__PURE__ */ X(Xe({ height: 0, width: 0 }));
  kr(() => {
    if (i(m).width || i(m).height) {
      L(x, { height: i(m).height, width: i(m).width }, !0);
      return;
    }
    const me = new window.Image();
    me.src = i(m).original;
    const Oe = () => {
      L(x, { height: me.height, width: me.width }, !0);
    };
    return me.addEventListener("load", Oe), () => {
      me.removeEventListener("load", Oe);
    };
  });
  const P = /* @__PURE__ */ b(() => i(d).height.type === "fixed" ? i(d).height.value : Math.round(i(S) * (i(x).height / i(x).width))), I = /* @__PURE__ */ b(() => Re({
    width: cr(i(d).width),
    height: `${i(P)}px`,
    margin: ar(i(h)),
    padding: ar(i(g)),
    "line-height": 0,
    "flex-shrink": i(d).width.type === "fixed" ? 0 : 1
  }));
  let E = /* @__PURE__ */ X(null);
  const D = /* @__PURE__ */ b(() => {
    var me, Oe;
    return [((me = i(E)) == null ? void 0 : me.width) ?? 0, ((Oe = i(E)) == null ? void 0 : Oe.height) ?? 0];
  }), F = /* @__PURE__ */ b(() => Ko(i(D), 2)), M = /* @__PURE__ */ b(() => i(F)[0]), C = /* @__PURE__ */ b(() => i(F)[1]), j = /* @__PURE__ */ b(() => `0 0 ${i(M)} ${i(C)}`), H = /* @__PURE__ */ b(() => {
    var Ke;
    if (!((Ke = i(f)) != null && Ke.color))
      return "";
    const { x: me, y: Oe, radius: Ar, color: ie } = i(f), Ne = br(i(k), ie);
    return `filter: drop-shadow(${me}px ${Oe}px ${Ar}px ${Ne})`;
  }), A = /* @__PURE__ */ b(() => i(w) && Wt(i(k), i(w)));
  var q = yh(), O = z(q), G = z(O), Y = z(G), te = z(Y);
  Fo(te, {
    get shape() {
      return i(p);
    },
    get width() {
      return i(M);
    },
    get height() {
      return i(C);
    }
  });
  var le = R(Y), be = z(le);
  Fo(be, {
    get shape() {
      return i(p);
    },
    get width() {
      return i(M);
    },
    get height() {
      return i(C);
    }
  });
  var ge = R(le);
  {
    let me = /* @__PURE__ */ b(() => `${i(c)}-overlay`);
    wd(ge, {
      get id() {
        return i(me);
      },
      get overlay() {
        return i(A);
      }
    });
  }
  var xe = R(G);
  {
    var de = (me) => {
      var Oe = fh();
      U(() => se(Oe, "href", `#${i(c)}-border`)), T(me, Oe);
    };
    W(xe, (me) => {
      i(v) && i(v).width > 0 && me(de);
    });
  }
  var ue = R(xe), Ie = z(ue), De = z(Ie), ve = R(Ie);
  {
    var Te = (me) => {
      var Oe = mh();
      U(() => se(Oe, "fill", `url(#${i(c)}-overlay)`)), T(me, Oe);
    };
    W(ve, (me) => {
      i(A) && me(Te);
    });
  }
  var ir = R(ve);
  {
    var Je = (me) => {
      var Oe = hh();
      U(
        (Ar) => {
          se(Oe, "href", `#${i(c)}-border`), se(Oe, "stroke", Ar), se(Oe, "stroke-width", i(v).width);
        },
        [() => br(i(k), i(v).color)]
      ), T(me, Oe);
    };
    W(ir, (me) => {
      i(v) && i(v).width > 0 && me(Je);
    });
  }
  U(
    (me) => {
      Pe(q, i(I)), se(O, "viewBox", i(j)), Pe(O, i(H)), se(Y, "id", `${i(c)}-path`), se(le, "id", `${i(c)}-border`), se(ue, "clip-path", `url(#${i(c)}-path)`), se(De, "src", i(m).original), Pe(De, `object-fit:${me ?? ""}`);
    },
    [() => qo(i(_))]
  ), Wu(O, "contentRect", (me) => L(E, me)), Os(q, "clientWidth", (me) => L(S, me)), T(e, q), re(), a();
}
function kh(e, r) {
  ee(r, !0);
  const t = () => fe(d, "$selectedPackageId", c), n = () => fe(p, "$variablesPerPackage", c), a = () => fe(f, "$fallbackVariables", c), o = () => fe(_, "$baseVariables", c), s = () => fe(g, "$infoPerPackage", c), l = () => fe(m, "$fallbackPackageInfo", c), [c, u] = Ae(), {
    selectedPackageId: d,
    variablesPerPackage: p,
    baseVariables: _,
    infoPerPackage: g
  } = pn();
  nr(() => {
    r.is_selected_by_default && Al(d, r.package_id);
  });
  const h = /* @__PURE__ */ b(() => t() === r.package_id), w = gr(i(h));
  kr(() => {
    w.set(i(h));
  }), Zo(w);
  const v = () => {
    Al(d, r.package_id);
  }, f = Jo(), y = /* @__PURE__ */ b(() => {
    var I;
    const P = (I = n()) == null ? void 0 : I[r.package_id];
    return P === void 0 ? a() : { ...o(), ...P };
  }), k = gr(i(y));
  kr(() => {
    k.set(i(y));
  }), Bs(k);
  const m = yd(), S = /* @__PURE__ */ b(() => {
    var P;
    return ((P = s()) == null ? void 0 : P[r.package_id]) ?? l();
  }), x = gr(i(S));
  kr(() => {
    x.set(i(S));
  }), hd(x), _r(e, Ye(() => r.stack, { onclick: v })), re(), u();
}
var fc;
(function(e) {
  e.weekly = "$rc_weekly", e.monthly = "$rc_monthly", e.two_month = "$rc_two_month", e.three_month = "$rc_three_month", e.six_month = "$rc_six_month", e.annual = "$rc_annual", e.lifetime = "$rc_lifetime";
})(fc || (fc = {}));
const I1 = {
  /**
   * Creates a string custom variable value.
   * @param value The string value for the custom variable.
   * @returns A CustomVariableValue containing the string.
   */
  string: (e) => ({ type: "string", value: e }),
  /**
   * Creates a number custom variable value.
   * @param value The number value for the custom variable.
   * @returns A CustomVariableValue containing the number.
   */
  number: (e) => ({ type: "number", value: e }),
  /**
   * Creates a boolean custom variable value.
   * @param value The boolean value for the custom variable.
   * @returns A CustomVariableValue containing the boolean.
   */
  boolean: (e) => ({
    type: "boolean",
    value: e
  })
};
function wh(e, r) {
  const t = Object.fromEntries(Object.entries(e).map(([a, { value: o }]) => [
    a,
    String(o)
  ]));
  return r ? {
    ...Object.fromEntries(Object.entries(r.custom_variables ?? {}).map(([a, { default_value: o }]) => [
      a,
      String(o)
    ])),
    ...t
  } : t;
}
var Ph = /* @__PURE__ */ B('<div class="backdrop svelte-5ehfx4" role="presentation" tabindex="-1" aria-hidden="true"><div role="dialog" aria-modal="true"><!></div></div>');
const xh = {
  hash: "svelte-5ehfx4",
  code: ".backdrop.svelte-5ehfx4 {position:absolute;inset:0 0 0 0;width:100%;height:100%;background-color:#0000003f;display:flex;flex-direction:column;}.sheet.svelte-5ehfx4 {position:absolute;inset:auto 0 0 0;transition-property:transform;transition-duration:225ms;transition-timing-function:cubic-bezier(0, 0, 0.2, 1);transform:translateY(100%);&.visible {transform:translateY(0);}}"
};
function Eh(e, r) {
  ee(r, !0), oe(e, xh);
  const t = () => fe(l, "$selectedState", n), [n, a] = Ae(), o = /* @__PURE__ */ ur(r, ["$$slots", "$$events", "$$legacy"]), { stack: s } = o, l = tt(), c = /* @__PURE__ */ b(() => ({
    ...o,
    ...nt(t(), r.overrides)
  })), u = /* @__PURE__ */ b(() => i(c).size), d = /* @__PURE__ */ b(() => i(c).background), p = /* @__PURE__ */ b(() => i(c).background_blur), _ = at(), g = /* @__PURE__ */ b(_), h = /* @__PURE__ */ b(() => Re({ background: i(p) ? "#0000003f" : "" })), w = /* @__PURE__ */ b(() => Re({
    height: cr(i(u).height),
    ...zn(i(g), null, i(d))
  })), { onButtonAction: v } = pn();
  let f, y = /* @__PURE__ */ X(!1);
  nr(() => {
    requestAnimationFrame(() => {
      L(y, !0);
    });
  });
  const k = () => {
    L(y, !1);
  }, m = () => {
    i(y) || v({ type: "navigate_to", destination: "sheet", sheet: null });
  }, S = (F) => {
    F.target === F.currentTarget && k();
  }, x = (F) => {
    F.key === "Escape" && k();
  };
  let P = /* @__PURE__ */ b(() => `sheet ${i(y) ? "visible" : ""}`);
  var I = Ph();
  I.__click = S, I.__keydown = x;
  var E = z(I), D = z(E);
  _r(D, Ye(() => s)), to(E, (F) => f = F, () => f), U(() => {
    Pe(I, i(h)), tr(E, 1, zs(i(P)), "svelte-5ehfx4"), Pe(E, i(w));
  }), Vr("transitionend", E, m), T(e, I), re(), a();
}
ro(["click", "keydown"]);
var Sh = /* @__PURE__ */ B('<div><div class="paywall-content svelte-1636b7j"><!> <!></div></div> <!>', 1);
const Ih = {
  hash: "svelte-1636b7j",
  code: `.paywall.svelte-1636b7j {position:relative;display:flex;flex-direction:column;align-items:stretch;height:100%;transition-property:filter, transform;transition-duration:0.1s;transition-timing-function:ease-in-out;transform-origin:center;&.blur {filter:blur(10px) brightness(0.8);transform:scale(1.045);}}.paywall-content.svelte-1636b7j {width:100%;flex:1;display:flex;flex-direction:column;min-height:0;& > .paywall-content-scroll {flex-grow:1;min-height:0;overflow-y:auto;}}
    /* Scoped reset - same as original but only affects .paywall descendants */.paywall *,
    .paywall *::before,
    .paywall *::after {box-sizing:border-box;margin:0;padding:0;font-family:sans-serif;}.paywall {line-height:1.5;-webkit-font-smoothing:antialiased;}.paywall img,
    .paywall picture,
    .paywall video,
    .paywall canvas,
    .paywall svg {display:block;max-width:100%;}.paywall input,
    .paywall button,
    .paywall textarea,
    .paywall select {font:inherit;}.paywall p,
    .paywall h1,
    .paywall h2,
    .paywall h3,
    .paywall h4,
    .paywall h5,
    .paywall h6 {overflow-wrap:break-word;}.paywall p {text-wrap:pretty;}.paywall h1,
    .paywall h2,
    .paywall h3,
    .paywall h4,
    .paywall h5,
    .paywall h6 {text-wrap:balance;}`
};
function Th(e, r) {
  ee(r, !0), oe(e, Ih);
  const t = () => fe(y, "$selectedPackageId", n), [n, a] = Ae(), o = K(r, "variablesPerPackage", 19, () => ({})), s = K(r, "globalVariables", 19, () => ({})), l = K(r, "infoPerPackage", 19, () => ({})), c = K(r, "hideBackButtons", 3, !1), u = K(r, "initialInputSelections", 19, () => ({})), d = K(r, "customVariables", 19, () => ({})), p = cm(() => r.preferredColorMode), _ = /* @__PURE__ */ b(p), { default_locale: g, components_config: h, components_localizations: w } = r.paywallData, { base: v } = h, { getLocalizedString: f } = um(() => ({
    defaultLocale: g,
    selectedLocale: r.selectedLocale,
    localizations: w
  })), y = gr(af(v)), k = (A) => {
    var O;
    const q = t();
    q !== void 0 && ((O = r.onPurchaseClicked) == null || O.call(r, q, A ?? ""));
  };
  let m = /* @__PURE__ */ X(void 0);
  const S = (A, q) => {
    var O, G, Y, te, le, be;
    switch (A.type) {
      case "workflow":
        q && ((O = r.onActionTriggered) == null || O.call(r, q));
        return;
      case "navigate_back":
        (G = r.onBackClicked) == null || G.call(r);
        return;
      case "restore_purchases":
        (Y = r.onRestorePurchasesClicked) == null || Y.call(r);
        return;
    }
    switch (A.destination) {
      case "customer_center":
        (te = r.onVisitCustomerCenterClicked) == null || te.call(r);
        return;
      case "screen_redirect":
        (le = r.onActionTriggered) == null || le.call(r, "screen_redirect");
        return;
      case "privacy_policy":
      case "terms":
      case "url":
        const ge = f(A.url.url_lid);
        ge && ((be = r.onNavigateToUrlClicked) == null || be.call(r, ge));
        return;
      case "sheet":
        L(m, A.sheet ?? void 0, !0);
        return;
      case "offer_code":
      case "web_paywall_link":
        return;
    }
  }, x = wh(d(), r.uiConfig);
  rd({
    selectedPackageId: y,
    variablesPerPackage: At(o()),
    baseVariables: At({ ...s(), ...x }),
    infoPerPackage: At(l()),
    onPurchase: k,
    onButtonAction: S,
    walletButtonRender: r.walletButtonRender,
    uiConfig: r.uiConfig,
    hideBackButtons: c()
  });
  const P = rf();
  tf(P), nf(u());
  const I = ct(y, (A) => {
    const q = o()[A || ""];
    return { ...s(), ...x, ...q };
  });
  Bs(I);
  const E = ct(y, (A) => l()[A || ""]);
  hd(E);
  const D = /* @__PURE__ */ b(() => Re(zn(i(_), null, v.background)));
  nr(() => {
    Jf(r.uiConfig);
  });
  const F = /* @__PURE__ */ b(() => i(m) ? "paywall blur" : "paywall"), { stack: M, sticky_footer: C } = v;
  var j = _e(), H = J(j);
  cu(
    H,
    {
      get onerror() {
        return r.onError;
      }
    },
    (A) => {
      var q = Sh(), O = J(q), G = z(O), Y = z(G);
      _r(Y, Ye(() => M, { class: "paywall-content-scroll" }));
      var te = R(Y, 2);
      {
        var le = (xe) => {
          kd(xe, Ye(() => C));
        };
        W(te, (xe) => {
          C && xe(le);
        });
      }
      var be = R(O, 2);
      {
        var ge = (xe) => {
          Eh(xe, Ye(() => i(m)));
        };
        W(be, (xe) => {
          i(m) && xe(ge);
        });
      }
      U(() => {
        tr(O, 1, zs(i(F)), "svelte-1636b7j"), Pe(O, i(D)), Pe(G, r.maxContentWidth ? `max-width: ${r.maxContentWidth}; margin-inline: auto;` : "");
      }), T(A, q);
    }
  ), T(e, j), re(), a();
}
function Ch(e, r) {
  ee(r, !0);
  const t = /* @__PURE__ */ ur(r, ["$$slots", "$$events", "$$legacy"]), { stack: n } = t, { onPurchase: a } = pn();
  _r(e, Ye(() => n, { onclick: () => {
    var l;
    const s = (l = r.triggers) == null ? void 0 : l.on_purchase_press;
    a(s);
  } })), re();
}
function Dh(e) {
  return {
    display: "grid",
    "grid-template-columns": "auto 1fr",
    "column-gap": `${e.column_gutter}px`,
    "align-items": "stretch",
    position: "relative",
    flex: "0 1 auto",
    width: cr(e.size.width),
    height: cr(e.size.height),
    padding: ar(e.padding),
    margin: ar(e.margin)
  };
}
function Ah(e, r) {
  return {
    display: "flex",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-items": "flex-start",
    gap: `${r.text_spacing}px`,
    height: "fit-content",
    "margin-bottom": `${r.item_spacing}px`
  };
}
var qh = /* @__PURE__ */ B("<div><div></div></div>"), Fh = /* @__PURE__ */ B("<div><!> <div><!></div></div> <div><!> <!></div>", 1);
function zh(e, r) {
  ee(r, !0);
  const t = () => fe(s, "$selectedState", n), [n, a] = Ae(), o = /* @__PURE__ */ ur(r, ["$$slots", "$$events", "$$legacy"]), s = tt(), l = /* @__PURE__ */ b(() => ({
    ...o,
    ...nt(t(), r.overrides)
  })), c = /* @__PURE__ */ b(() => i(l).icon), u = /* @__PURE__ */ b(() => i(l).title), d = /* @__PURE__ */ b(() => i(l).description), p = /* @__PURE__ */ b(() => i(l).connector), _ = /* @__PURE__ */ b(() => i(l).text_spacing), g = /* @__PURE__ */ b(() => i(l).item_spacing), h = at(), w = /* @__PURE__ */ b(h), v = Re({ position: "relative" }), f = Re({ position: "relative", "z-index": "2" }), y = /* @__PURE__ */ b(() => Re(Ah(i(w), {
    text_spacing: i(_),
    item_spacing: i(g)
  }))), k = /* @__PURE__ */ b(() => {
    var H;
    return i(p) ? Re({
      position: "absolute",
      left: "50%",
      top: `${(((H = i(c)) == null ? void 0 : H.size.width.value) ?? 24) / 2}px`,
      transform: "translateX(-50%)",
      "z-index": "1",
      width: `${i(p).width}px`,
      height: "100%",
      // Extend beyond icon
      "padding-top": `${i(p).margin.top}px`,
      "padding-bottom": `${i(p).margin.bottom}px`
    }) : "";
  }), m = /* @__PURE__ */ b(() => {
    if (!i(p)) return "";
    const H = br(i(w), i(p).color);
    return Re({ width: "100%", height: "100%", background: H });
  });
  var S = Fh(), x = J(S), P = z(x);
  {
    var I = (H) => {
      var A = qh(), q = z(A);
      U(() => {
        Pe(A, i(k)), Pe(q, i(m));
      }), T(H, A);
    };
    W(P, (H) => {
      i(p) && H(I);
    });
  }
  var E = R(P, 2), D = z(E);
  bd(D, Ye(() => i(c)));
  var F = R(x, 2), M = z(F);
  as(M, Ye(() => i(u)));
  var C = R(M, 2);
  {
    var j = (H) => {
      as(H, Ye(() => i(d)));
    };
    W(C, (H) => {
      i(d) && H(j);
    });
  }
  U(() => {
    Pe(x, v), Pe(E, f), Pe(F, i(y));
  }), T(e, S), re(), a();
}
var Mh = /* @__PURE__ */ B("<div></div>");
function Oh(e, r) {
  ee(r, !0);
  const t = () => fe(s, "$selectedState", n), [n, a] = Ae(), o = /* @__PURE__ */ ur(r, ["$$slots", "$$events", "$$legacy"]), s = tt(), l = /* @__PURE__ */ b(() => ({
    ...o,
    ...nt(t(), r.overrides)
  })), c = /* @__PURE__ */ b(() => i(l).items), u = /* @__PURE__ */ b(() => i(l).text_spacing), d = /* @__PURE__ */ b(() => i(l).item_spacing), p = /* @__PURE__ */ b(() => i(l).column_gutter), _ = /* @__PURE__ */ b(() => i(l).icon_alignment), g = /* @__PURE__ */ b(() => i(l).size), h = /* @__PURE__ */ b(() => i(l).padding), w = /* @__PURE__ */ b(() => i(l).margin), v = /* @__PURE__ */ b(() => F_(i(l), [
    "items",
    "text_spacing",
    "item_spacing",
    "column_gutter",
    "icon_alignment",
    "size",
    "padding",
    "margin"
  ])), f = /* @__PURE__ */ b(() => Re(Dh({
    items: i(c),
    text_spacing: i(u),
    item_spacing: i(d),
    column_gutter: i(p),
    icon_alignment: i(_),
    size: i(g),
    padding: i(h),
    margin: i(w),
    ...i(v)
  })));
  var y = _e(), k = J(y);
  {
    var m = (S) => {
      var x = Mh();
      Dt(x, 21, () => i(c), (P) => P.id, (P, I) => {
        zh(P, Ye(() => i(I), {
          get text_spacing() {
            return i(u);
          },
          get item_spacing() {
            return i(d);
          }
        }));
      }), U(() => Pe(x, i(f))), T(S, x);
    };
    W(k, (S) => {
      i(c).length && S(m);
    });
  }
  T(e, y), re(), a();
}
var jh = /* @__PURE__ */ or('<use fill="transparent"></use>'), Nh = /* @__PURE__ */ B('<img alt="" class="svelte-1c2utvr"/>'), Lh = /* @__PURE__ */ B('<video playsinline="" class="svelte-1c2utvr"><track kind="captions"/></video>', 2), Bh = /* @__PURE__ */ or('<rect x="0" y="0" height="100%" width="100%"></rect>'), Uh = /* @__PURE__ */ or('<use fill="none"></use>'), Rh = /* @__PURE__ */ B('<div><svg width="100%" height="100%"><defs><clipPath><!></clipPath><g><!></g><!></defs><!><g><foreignObject x="0" y="0" width="100%" height="100%"><!></foreignObject><!><!></g></svg></div>');
const Vh = {
  hash: "svelte-1c2utvr",
  code: `video.svelte-1c2utvr,
  img.svelte-1c2utvr {width:100%;height:100%;object-fit:contain;object-position:center;}`
};
function Hh(e, r) {
  ee(r, !0), oe(e, Vh);
  const t = () => fe(s, "$selectedState", n), [n, a] = Ae(), o = /* @__PURE__ */ ur(r, ["$$slots", "$$events", "$$legacy"]), s = tt(), l = /* @__PURE__ */ b(() => ({
    ...o,
    ...nt(t(), r.overrides)
  })), c = /* @__PURE__ */ b(() => i(l).id), u = /* @__PURE__ */ b(() => i(l).source), d = /* @__PURE__ */ b(() => i(l).fallback_source), p = /* @__PURE__ */ b(() => i(l).size), _ = /* @__PURE__ */ b(() => i(l).mask_shape), g = /* @__PURE__ */ b(() => i(l).fit_mode), h = /* @__PURE__ */ b(() => i(l).padding), w = /* @__PURE__ */ b(() => i(l).margin), v = /* @__PURE__ */ b(() => i(l).color_overlay), f = /* @__PURE__ */ b(() => i(l).border), y = /* @__PURE__ */ b(() => i(l).shadow), k = /* @__PURE__ */ b(() => i(l).auto_play), m = /* @__PURE__ */ b(() => i(l).loop), S = /* @__PURE__ */ b(() => i(l).mute_audio), x = /* @__PURE__ */ b(() => i(l).show_controls), P = at(), I = /* @__PURE__ */ b(P), E = /* @__PURE__ */ b(() => i(u) ? Wt(i(I), i(u)) : null), D = /* @__PURE__ */ b(() => i(d) ? Wt(i(I), i(d)) : null);
  let F = /* @__PURE__ */ X(0), M = /* @__PURE__ */ X(Xe({ height: 0, width: 0 })), C = /* @__PURE__ */ X(null), j = /* @__PURE__ */ X(!1);
  kr(() => {
    if (i(E)) {
      if (i(E).width && i(E).height) {
        L(M, { height: i(E).height, width: i(E).width }, !0);
        return;
      }
      if (i(C)) {
        const he = () => {
          var xr, Gr;
          L(
            M,
            {
              height: ((xr = i(C)) == null ? void 0 : xr.videoHeight) ?? 0,
              width: ((Gr = i(C)) == null ? void 0 : Gr.videoWidth) ?? 0
            },
            !0
          );
        }, qe = () => {
          L(j, !0);
        };
        return i(C).addEventListener("loadedmetadata", he), i(C).addEventListener("error", qe), () => {
          var xr, Gr;
          (xr = i(C)) == null || xr.removeEventListener("loadedmetadata", he), (Gr = i(C)) == null || Gr.removeEventListener("error", qe);
        };
      }
    } else if (i(D)) {
      if (i(D).width && i(D).height) {
        L(
          M,
          {
            height: i(D).height,
            width: i(D).width
          },
          !0
        );
        return;
      }
      const he = new window.Image();
      he.src = i(D).original;
      const qe = () => {
        L(M, { height: he.height, width: he.width }, !0);
      };
      return he.addEventListener("load", qe), () => {
        he.removeEventListener("load", qe);
      };
    }
  });
  const H = /* @__PURE__ */ b(() => i(p).height.type === "fixed" ? i(p).height.value : Math.round(i(F) * (i(M).height / i(M).width))), A = /* @__PURE__ */ b(() => Re({
    width: cr(i(p).width),
    height: `${i(H)}px`,
    margin: ar(i(w)),
    padding: ar(i(h)),
    "line-height": 0,
    "flex-shrink": i(p).width.type === "fixed" ? 0 : 1
  }));
  let q = /* @__PURE__ */ X(null);
  const O = /* @__PURE__ */ b(() => {
    var he, qe;
    return [((he = i(q)) == null ? void 0 : he.width) ?? 0, ((qe = i(q)) == null ? void 0 : qe.height) ?? 0];
  }), G = /* @__PURE__ */ b(() => Ko(i(O), 2)), Y = /* @__PURE__ */ b(() => i(G)[0]), te = /* @__PURE__ */ b(() => i(G)[1]), le = /* @__PURE__ */ b(() => `0 0 ${i(Y)} ${i(te)}`), be = /* @__PURE__ */ b(() => {
    var Or;
    if (!((Or = i(y)) != null && Or.color))
      return "";
    const { x: he, y: qe, radius: xr, color: Gr } = i(y), _n = br(i(I), Gr);
    return `filter: drop-shadow(${he}px ${qe}px ${xr}px ${_n})`;
  }), ge = /* @__PURE__ */ b(() => i(v) && Wt(i(I), i(v))), xe = /* @__PURE__ */ b(() => i(j) || !i(E));
  var de = Rh(), ue = z(de), Ie = z(ue), De = z(Ie), ve = z(De);
  Fo(ve, {
    get shape() {
      return i(_);
    },
    get width() {
      return i(Y);
    },
    get height() {
      return i(te);
    }
  });
  var Te = R(De), ir = z(Te);
  Fo(ir, {
    get shape() {
      return i(_);
    },
    get width() {
      return i(Y);
    },
    get height() {
      return i(te);
    }
  });
  var Je = R(Te);
  {
    let he = /* @__PURE__ */ b(() => `${i(c)}-overlay`);
    wd(Je, {
      get id() {
        return i(he);
      },
      get overlay() {
        return i(ge);
      }
    });
  }
  var me = R(Ie);
  {
    var Oe = (he) => {
      var qe = jh();
      U(() => se(qe, "href", `#${i(c)}-border`)), T(he, qe);
    };
    W(me, (he) => {
      i(f) && i(f).width > 0 && he(Oe);
    });
  }
  var Ar = R(me), ie = z(Ar), Ne = z(ie);
  {
    var Ke = (he) => {
      var qe = Nh();
      U(
        (xr) => {
          se(qe, "src", i(D).original), Pe(qe, `object-fit:${xr ?? ""}`);
        },
        [() => qo(i(g))]
      ), T(he, qe);
    }, Sr = (he) => {
      var qe = _e(), xr = J(qe);
      {
        var Gr = (_n) => {
          var Or = Lh();
          to(Or, (jn) => L(C, jn), () => i(C)), U(
            (jn) => {
              se(Or, "src", i(E).url), Pe(Or, `object-fit:${jn ?? ""}`), Or.autoplay = i(k), Or.loop = i(m), Or.muted = i(S), Or.controls = i(x);
            },
            [() => qo(i(g))]
          ), T(_n, Or);
        };
        W(
          xr,
          (_n) => {
            i(E) && _n(Gr);
          },
          !0
        );
      }
      T(he, qe);
    };
    W(Ne, (he) => {
      i(xe) && i(D) ? he(Ke) : he(Sr, !1);
    });
  }
  var Yr = R(ie);
  {
    var Kt = (he) => {
      var qe = Bh();
      U(() => se(qe, "fill", `url(#${i(c)}-overlay)`)), T(he, qe);
    };
    W(Yr, (he) => {
      i(ge) && he(Kt);
    });
  }
  var ot = R(Yr);
  {
    var On = (he) => {
      var qe = Uh();
      U(
        (xr) => {
          se(qe, "href", `#${i(c)}-border`), se(qe, "stroke", xr), se(qe, "stroke-width", i(f).width);
        },
        [() => br(i(I), i(f).color)]
      ), T(he, qe);
    };
    W(ot, (he) => {
      i(f) && i(f).width > 0 && he(On);
    });
  }
  U(() => {
    Pe(de, i(A)), se(ue, "viewBox", i(le)), Pe(ue, i(be)), se(De, "id", `${i(c)}-path`), se(Te, "id", `${i(c)}-border`), se(Ar, "clip-path", `url(#${i(c)}-path)`);
  }), Wu(ue, "contentRect", (he) => L(q, he)), Os(de, "clientWidth", (he) => L(F, he)), T(e, de), re(), a();
}
var Wh = /* @__PURE__ */ B("<span><!></span>");
const Yh = {
  hash: "svelte-su89ui",
  code: `
  /* svelte-ignore css-unused-selector */.rcb-typography-heading-2xl.svelte-su89ui {font:var(--rc-text-heading2xl-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-xl.svelte-su89ui {font:var(--rc-text-headingXl-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-lg.svelte-su89ui {font:var(--rc-text-headingLg-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-md.svelte-su89ui {font:var(--rc-text-headingMd-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-body-base.svelte-su89ui {font:var(--rc-text-bodyBase-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-body-small.svelte-su89ui {font:var(--rc-text-bodySmall-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-label-button.svelte-su89ui {font:var(--rc-text-labelButton-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-label-default.svelte-su89ui {font:var(--rc-text-labelDefault-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-caption-default.svelte-su89ui {font:var(--rc-text-captionDefault-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-caption-link.svelte-su89ui {font:var(--rc-text-captionLink-mobile);}

  @container layout-query-container (width >= 768px) {
    /* svelte-ignore css-unused-selector */.rcb-typography-heading-2xl.svelte-su89ui {font:var(--rc-text-heading2xl-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-xl.svelte-su89ui {font:var(--rc-text-headingXl-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-lg.svelte-su89ui {font:var(--rc-text-headingLg-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-md.svelte-su89ui {font:var(--rc-text-headingMd-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-body-base.svelte-su89ui {font:var(--rc-text-bodyBase-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-body-small.svelte-su89ui {font:var(--rc-text-bodySmall-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-label-button.svelte-su89ui {font:var(--rc-text-labelButton-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-label-default.svelte-su89ui {font:var(--rc-text-labelDefault-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-caption-default.svelte-su89ui {font:var(--rc-text-captionDefault-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-caption-link.svelte-su89ui {font:var(--rc-text-captionLink-desktop);}
  }`
};
function Gh(e, r) {
  oe(e, Yh);
  const t = K(r, "size", 3, "body-base");
  var n = Wh(), a = z(n);
  Ze(a, () => r.children ?? ze), U(() => tr(n, 1, `rcb-typography rcb-typography-${t() ?? ""}`, "svelte-su89ui")), T(e, n);
}
const Kh = {
  outerPadding: {
    mobile: "clamp(1.3125rem, 5.6vw, 1.5rem)",
    desktop: "clamp(1.5rem, 9.44vw, 5rem)"
  },
  outerPaddingSmall: {
    mobile: "clamp(0.75rem, 4.2vw, 1rem)",
    desktop: "clamp(1.5rem, 9.44vw, 5rem)"
  },
  gapSmall: {
    mobile: "0.25rem",
    desktop: "0.375rem"
  },
  gapMedium: {
    mobile: "0.5rem",
    desktop: "0.75rem"
  },
  gapLarge: {
    mobile: "0.75rem",
    desktop: "0.75rem"
  },
  gapXLarge: {
    mobile: "1rem",
    desktop: "1.5rem"
  },
  gapXXLarge: {
    mobile: "1.25rem",
    desktop: "2.25rem"
  },
  gapXXXLarge: {
    mobile: "2.25rem",
    desktop: "4.5rem"
  },
  inputHeight: {
    mobile: "3rem",
    desktop: "3rem"
  },
  gapStripeElement: {
    mobile: "0.70rem",
    desktop: "1rem"
  }
}, mc = "-apple-system, BlinkMacSystemFont, avenir next, avenir, segoe ui, helvetica neue, helvetica, Cantarell, Ubuntu, roboto, noto, arial, sans-serif", gt = {
  regular: "400",
  medium: "500",
  semibold: "600"
}, Jr = {
  12: "12px",
  14: "14px",
  16: "16px",
  18: "18px",
  24: "24px",
  28: "28px",
  32: "32px",
  36: "36px"
}, ft = {
  120: "120%",
  130: "130%",
  140: "140%"
}, mt = {
  tight: "0.20%",
  regular: "0"
}, er = {
  heading2xl: {
    fontSize: Jr[28],
    lineHeight: ft[120],
    fontWeight: gt.semibold,
    letterSpacing: mt.tight
  },
  headingXl: {
    fontSize: Jr[24],
    lineHeight: ft[130],
    fontWeight: gt.semibold,
    letterSpacing: mt.regular
  },
  headingLg: {
    fontSize: "20px",
    lineHeight: ft[130],
    fontWeight: gt.semibold,
    letterSpacing: mt.regular
  },
  headingMd: {
    fontSize: "16px",
    lineHeight: ft[140],
    fontWeight: gt.medium,
    letterSpacing: mt.regular
  },
  bodyBase: {
    fontSize: Jr[16],
    lineHeight: ft[140],
    fontWeight: gt.regular,
    letterSpacing: mt.regular
  },
  bodySmall: {
    fontSize: Jr[14],
    lineHeight: ft[140],
    fontWeight: gt.regular,
    letterSpacing: mt.regular
  },
  labelButton: {
    fontSize: Jr[16],
    lineHeight: ft[140],
    fontWeight: gt.regular,
    letterSpacing: mt.tight
  },
  labelDefault: {
    fontSize: Jr[14],
    lineHeight: ft[140],
    fontWeight: gt.regular,
    letterSpacing: mt.tight
  },
  captionDefault: {
    fontSize: Jr[12],
    lineHeight: ft[140],
    fontWeight: gt.regular,
    letterSpacing: mt.regular
  },
  captionLink: {
    fontSize: Jr[12],
    lineHeight: ft[140],
    fontWeight: gt.regular,
    letterSpacing: mt.regular
  }
}, ht = {
  heading2xl: {
    ...er.heading2xl,
    fontSize: Jr[36]
  },
  headingXl: {
    ...er.headingXl,
    fontSize: Jr[32]
  },
  headingLg: {
    ...er.headingLg,
    fontSize: Jr[24]
  },
  headingMd: {
    ...er.headingMd,
    fontSize: Jr[18]
  },
  bodyBase: {
    ...er.bodyBase
  },
  bodySmall: {
    ...er.bodySmall
  },
  labelButton: {
    ...er.labelButton
  },
  labelDefault: {
    ...er.labelDefault
  },
  captionDefault: {
    ...er.captionDefault
  },
  captionLink: {
    ...er.captionLink
  }
}, Xh = {
  heading2xl: {
    mobile: er.heading2xl,
    desktop: ht.heading2xl
  },
  headingXl: {
    desktop: ht.headingXl,
    mobile: er.headingXl
  },
  headingLg: {
    desktop: ht.headingLg,
    mobile: er.headingLg
  },
  headingMd: {
    desktop: ht.headingMd,
    mobile: er.headingMd
  },
  bodyBase: {
    desktop: ht.bodyBase,
    mobile: er.bodyBase
  },
  bodySmall: {
    desktop: ht.bodySmall,
    mobile: er.bodySmall
  },
  labelButton: {
    desktop: ht.labelButton,
    mobile: er.labelButton
  },
  labelDefault: {
    desktop: ht.labelDefault,
    mobile: er.labelDefault
  },
  captionDefault: {
    desktop: ht.captionDefault,
    mobile: er.captionDefault
  },
  captionLink: {
    desktop: ht.captionLink,
    mobile: er.captionLink
  }
}, $h = {
  error: "#B0171F",
  warning: "#f4e971",
  focus: "#1148B8",
  accent: "#767676",
  primary: "#576CDB",
  "primary-hover": "rgba(87, 108, 219, .8)",
  "primary-pressed": "rgba(87, 108, 219, .9)",
  "primary-text": "#ffffff",
  white: "#ffffff",
  "grey-text-dark": "rgba(0,0,0,1)",
  "grey-text-light": "rgba(0,0,0,0.7)",
  "grey-ui-dark": "rgba(0,0,0,0.3)",
  "grey-ui-light": "rgba(0,0,0,0.1)",
  "input-background": "white",
  background: "white"
}, Zh = {
  error: "#B0171F",
  warning: "#f4e971",
  focus: "#1148B8",
  accent: "#767676",
  primary: "#576CDB",
  "primary-hover": "rgba(87, 108, 219, .8)",
  "primary-pressed": "rgba(87, 108, 219, .9)",
  "primary-text": "#ffffff",
  white: "#ffffff",
  "grey-text-dark": "rgba(0,0,0,1)",
  "grey-text-light": "rgba(0,0,0,0.7)",
  "grey-ui-dark": "rgba(0,0,0,0.3)",
  "grey-ui-light": "rgba(0,0,0,0.1)",
  "input-background": "white",
  background: "#EFF3FA"
}, Pd = {
  error: "color_error",
  focus: "color_accent",
  accent: "color_accent",
  primary: "color_buttons_primary"
}, Jh = {
  ...Pd,
  "input-background": "color_form_bg",
  background: "color_form_bg"
}, Qh = {
  ...Pd,
  "input-background": "color_product_info_bg",
  background: "color_product_info_bg"
}, xd = {
  "input-border-radius": "4px",
  "input-button-border-radius": "8px"
}, ey = {
  "input-border-radius": "0px",
  "input-button-border-radius": "0px"
}, ry = {
  "input-border-radius": "12px",
  "input-button-border-radius": "9999px"
}, hc = xd, ja = (e) => e.length == 7 ? {
  r: parseInt(e.slice(1, 3), 16),
  g: parseInt(e.slice(3, 5), 16),
  b: parseInt(e.slice(5, 7), 16)
} : e.length == 4 ? {
  r: parseInt(e[1], 16),
  g: parseInt(e[2], 16),
  b: parseInt(e[3], 16)
} : null, Hs = ({ r: e, g: r, b: t, luminanceThreshold: n }) => {
  const a = (s) => (s = s / 255, s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4));
  return 0.2126 * a(e) + 0.7152 * a(r) + 0.0722 * a(t) > n;
}, Ws = 0.37, ty = (e, r = Ws) => {
  const t = Hs({ ...e, luminanceThreshold: r }) ? "0,0,0" : "255,255,255";
  return {
    "grey-text-dark": `rgb(${t})`,
    "grey-text-light": `rgba(${t},0.70)`,
    "grey-ui-dark": `rgba(${t},0.3)`,
    "grey-ui-light": `rgba(${t},0.1)`
  };
};
function ny(e, r, t) {
  const n = ja(e) || { r: 0, g: 0, b: 0 }, a = ja(r) || { r: 255, g: 255, b: 255 }, o = Math.round(a.r * t + n.r * (1 - t)), s = Math.round(a.g * t + n.g * (1 - t)), l = Math.round(a.b * t + n.b * (1 - t));
  return `#${Fi(o)}${Fi(s)}${Fi(l)}`;
}
function yc(e, r) {
  const t = { r: 255, g: 255, b: 255 }, n = Math.max(0, Math.min(1, r));
  let a = e, o = ja(e) || t;
  (isNaN(o.r) || isNaN(o.g) || isNaN(o.b)) && (o = t, a = "#FFFFFF");
  const l = Hs({
    ...o,
    luminanceThreshold: Ws
  }) ? "#000000" : "#FFFFFF";
  return ny(a, l, n);
}
function Fi(e) {
  return e.toString(16).padStart(2, "0").toUpperCase();
}
const ay = (e, r, t, n = Ws) => {
  const a = {
    "grey-text-dark": t["grey-text-dark"],
    "grey-text-light": t["grey-text-light"],
    "grey-ui-dark": t["grey-ui-dark"],
    "grey-ui-light": t["grey-ui-light"],
    "primary-text": t["primary-text"]
  };
  if (e != null && e.startsWith("#")) {
    const o = ja(e);
    o !== null && Object.assign(a, ty(o));
  }
  if (r != null && r.startsWith("#")) {
    const o = ja(r);
    o !== null && (a["primary-text"] = Hs({ ...o, luminanceThreshold: n }) ? "black" : "white");
  }
  return a;
}, oy = (e) => ({
  "primary-hover": yc(e, 0.1),
  "primary-pressed": yc(e, 0.15)
}), iy = (e, r) => e || r, sy = (e, r, t) => {
  const n = Object.entries(e).map(([a, o]) => [
    a,
    iy(t ? t[o] : null, r[a])
  ]);
  return Object.fromEntries(n);
}, Ed = (e, r, t) => {
  const n = sy(e, r, t);
  return t ? {
    ...r,
    ...n,
    ...ay(n.background, n.primary, r),
    ...oy(n.primary)
  } : { ...r };
}, ly = (e) => Ed(Qh, Zh, e), Sd = (e) => Ed(Jh, $h, e), Ys = (e) => {
  if (!e)
    return hc;
  switch (e.shapes) {
    case "rounded":
      return xd;
    case "rectangle":
      return ey;
    case "pill":
      return ry;
    default:
      return hc;
  }
}, zo = (e = "", r) => r.map(([t, n]) => `--rc-${e}-${t}: ${n}`).join("; "), cy = (e) => {
  const r = zo("color", Object.entries(ly(e))), t = zo("shape", Object.entries(Ys(e)));
  return [r, t].join("; ");
}, uy = (e) => {
  const r = zo("color", Object.entries(Sd(e))), t = zo("shape", Object.entries(Ys(e)));
  return [r, t].join("; ");
}, dy = (e = "", r) => Object.entries(r).flatMap(([t, { desktop: n, mobile: a }]) => [
  `--rc-${e}-${t}-desktop: normal normal ${n.fontWeight} ${n.fontSize}/${n.lineHeight} ${mc}`,
  `--rc-${e}-${t}-mobile: normal normal ${a.fontWeight} ${a.fontSize}/${a.lineHeight} ${mc}`,
  `--rc-${e}-${t}-desktop-font-size: ${n.fontSize}`,
  `--rc-${e}-${t}-mobile-font-size: ${a.fontSize}`
]).join("; "), py = (e = "", r) => Object.entries(r).map(([t, { mobile: n, desktop: a }]) => `--rc-${e}-${t}-mobile: ${n};  --rc-${e}-${t}-desktop: ${a};`).join(" ");
let _y = class {
  constructor(r) {
    V(this, "brandingAppearance");
    r ? this.brandingAppearance = r : this.brandingAppearance = void 0;
  }
  get shape() {
    return Ys(this.brandingAppearance);
  }
  get formColors() {
    return Sd(this.brandingAppearance);
  }
  get formStyleVars() {
    return uy(this.brandingAppearance);
  }
  get productInfoStyleVars() {
    return cy(this.brandingAppearance);
  }
  get spacing() {
    return Kh;
  }
  get textStyles() {
    return Xh;
  }
  get textStyleVars() {
    return dy("text", this.textStyles);
  }
  get spacingStyleVars() {
    return py("spacing", this.spacing);
  }
};
var gy = /* @__PURE__ */ B('<div class="rcb-processing svelte-1h6b6kq"></div>');
const fy = {
  hash: "svelte-1h6b6kq",
  code: `.rcb-processing.svelte-1h6b6kq {width:var(--width, 12px);aspect-ratio:1;border-radius:50%;
    animation: svelte-1h6b6kq-l5 1.5s infinite linear;}

  @keyframes svelte-1h6b6kq-l5 {
    0% {
      box-shadow:
        var(--shadow-offset) 0 #fff2,
        calc(-1 * var(--shadow-offset)) 0 #fff2;
      background: #fff2;
    }
    25% {
      box-shadow:
        var(--shadow-offset) 0 #fff2,
        calc(-1 * var(--shadow-offset)) 0 #ffff;
      background: #fff2;
    }
    50% {
      box-shadow:
        var(--shadow-offset) 0 #fff2,
        calc(-1 * var(--shadow-offset)) 0 #fff2;
      background: #ffff;
    }
    75% {
      box-shadow:
        var(--shadow-offset) 0 #ffff,
        calc(-1 * var(--shadow-offset)) 0 #fff2;
      background: #fff2;
    }
    100% {
      box-shadow:
        var(--shadow-offset) 0 #fff2,
        calc(-1 * var(--shadow-offset)) 0 #fff2;
      background: #fff2;
    }
  }`
};
function my(e, r) {
  oe(e, fy);
  let t = K(r, "size", 8, "medium");
  const n = {
    small: { width: "8px", offset: "10px" },
    medium: { width: "12px", offset: "20px" },
    large: { width: "16px", offset: "30px" }
  };
  var a = gy();
  U(() => Pe(a, `--shadow-offset: ${Ge(t()), Ue(() => n[t()].offset) ?? ""}; --width: ${Ge(t()), Ue(() => n[t()].width) ?? ""};`)), T(e, a);
}
var hy = /* @__PURE__ */ B("<button><!></button>");
const yy = {
  hash: "svelte-1ich4sa",
  code: `button.svelte-1ich4sa {border:none;border-radius:var(--rc-shape-input-button-border-radius);cursor:pointer;height:var(--rc-spacing-inputHeight-mobile);color:var(--rc-color-grey-text-dark);background-color:var(--rc-color-grey-ui-dark);display:flex;align-items:center;justify-content:center;-webkit-tap-highlight-color:rgba(0, 0, 0, 0);-webkit-tap-highlight-color:transparent;transition:background-color 0.15s ease-in-out;user-select:none;}

  @container layout-query-container (width >= 768px) {button.svelte-1ich4sa {height:var(--rc-spacing-inputHeight-desktop);}
  }

  /* focus-visible is triggered only when focused with keyboard/reader */button.svelte-1ich4sa:focus-visible {outline:2px solid var(--rc-color-focus);}button.intent-primary.svelte-1ich4sa {background-color:var(--rc-color-primary);color:var(--rc-color-primary-text);}button.svelte-1ich4sa:disabled {color:var(--rc-color-grey-text-light);background-color:var(--rc-color-grey-ui-dark);outline:none;}button.intent-primary.svelte-1ich4sa:not(:disabled):hover {background-color:var(--rc-color-primary-hover);}button.intent-primary.svelte-1ich4sa:not(:disabled):active,
  button.svelte-1ich4sa:active {background-color:var(--rc-color-primary-pressed);outline:none;}button.intent-primary.svelte-1ich4sa:disabled {color:var(--rc-color-grey-text-light);background-color:var(--rc-color-grey-ui-dark);}`
};
function Id(e, r) {
  ee(r, !0), oe(e, yy);
  const t = K(r, "intent", 3, "primary"), n = K(r, "disabled", 3, !1), a = K(r, "loading", 3, !1), o = /* @__PURE__ */ b(() => new _y(r.brandingAppearance)), s = /* @__PURE__ */ b(() => i(o).textStyleVars), l = /* @__PURE__ */ b(() => i(o).spacingStyleVars), c = /* @__PURE__ */ b(() => i(o).productInfoStyleVars), u = /* @__PURE__ */ b(() => i(o).formStyleVars), d = /* @__PURE__ */ b(() => [
    r.styleOverrides,
    i(s),
    i(l),
    i(c),
    i(u)
  ].join("; "));
  var p = hy();
  p.__click = function(...w) {
    var v;
    (v = r.onclick) == null || v.apply(this, w);
  };
  var _ = z(p);
  {
    var g = (w) => {
      my(w, { size: "small" });
    }, h = (w) => {
      Gh(w, {
        size: "body-base",
        children: (v, f) => {
          var y = _e(), k = J(y);
          Ze(k, () => r.children ?? ze), T(v, y);
        },
        $$slots: { default: !0 }
      });
    };
    W(_, (w) => {
      a() ? w(g) : w(h, !1);
    });
  }
  U(() => {
    tr(p, 1, `intent-${t()}`, "svelte-1ich4sa"), p.disabled = n(), se(p, "data-testid", r.testId), se(p, "type", r.type), Pe(p, i(d));
  }), T(e, p), re();
}
ro(["click"]);
var by = /* @__PURE__ */ B('<footer class="rcb-modal-footer svelte-gz2zuy"><!></footer>');
const vy = {
  hash: "svelte-gz2zuy",
  code: "footer.svelte-gz2zuy {display:flex;flex-direction:column;}"
};
function ky(e, r) {
  oe(e, vy);
  let t = K(r, "children", 8);
  var n = by(), a = z(n);
  Ze(a, () => t() ?? ze), T(e, n);
}
const wy = {
  hash: "svelte-1lkpm18",
  code: ".rcb-modal-section.svelte-1lkpm18 {padding:8px 0px;display:flex;}section.rcb-modal-section.svelte-1lkpm18 {flex-grow:1;}.rcb-modal-section.svelte-1lkpm18:last-of-type {padding:0;}"
};
function Py(e, r) {
  oe(e, wy);
  let t = K(r, "as", 8, "section"), n = K(r, "children", 8);
  var a = _e(), o = J(a);
  Fs(o, t, !1, (s, l) => {
    Ms(s, () => ({ class: "rcb-modal-section" }), void 0, void 0, void 0, "svelte-1lkpm18");
    var c = _e(), u = J(c);
    Ze(u, () => n() ?? ze), T(l, c);
  }), T(e, a);
}
var xy = /* @__PURE__ */ B("<div><!></div>");
const Ey = {
  hash: "svelte-7lmlfa",
  code: `.rcb-column.svelte-7lmlfa {display:flex;flex-direction:column;justify-content:flex-start;flex-grow:1;min-width:100%;}.rcb-column.justify-center.svelte-7lmlfa {justify-content:center;}.rcb-column.justify-end.svelte-7lmlfa {justify-content:flex-end;}.rcb-column.align-center.svelte-7lmlfa {align-items:center;}.rcb-column.align-end.svelte-7lmlfa {align-items:flex-end;}.rcb-column.gap-small.svelte-7lmlfa {gap:var(--rc-spacing-gapSmall-mobile);}.rcb-column.gap-medium.svelte-7lmlfa {gap:var(--rc-spacing-gapXLarge-mobile);}.rcb-column.gap-large.svelte-7lmlfa {gap:var(--rc-spacing-gapXXLarge-mobile);}

  @container layout-query-container (width >= 768px) {.rcb-column.gap-small.svelte-7lmlfa {gap:var(--rc-spacing-gapSmall-desktop);}.rcb-column.gap-medium.svelte-7lmlfa {gap:var(--rc-spacing-gapLarge-desktop);}.rcb-column.gap-large.svelte-7lmlfa {gap:var(--rc-spacing-gapXXLarge-desktop);}
  }`
};
function Na(e, r) {
  oe(e, Ey);
  let t = K(r, "gap", 8, "small"), n = K(r, "justify", 8, "start"), a = K(r, "align", 8, "start"), o = K(r, "children", 8);
  var s = xy(), l = z(s);
  Ze(l, () => o() ?? ze), U(() => tr(s, 1, `rcb-column gap-${t() ?? ""} justify-${n() ?? ""} align-${a() ?? ""}`, "svelte-7lmlfa")), T(e, s);
}
var Sy = /* @__PURE__ */ B('<div class="rcb-row svelte-130pyos"><!></div>');
const Iy = {
  hash: "svelte-130pyos",
  code: ".rcb-row.svelte-130pyos {display:flex;flex-direction:row;justify-content:flex-start;}"
};
function Ty(e, r) {
  oe(e, Iy);
  let t = K(r, "children", 8);
  var n = Sy(), a = z(n);
  Ze(a, () => t() ?? ze), T(e, n);
}
var Cy = /* @__PURE__ */ B("<span><!></span>");
const Dy = {
  hash: "svelte-y2q9vo",
  code: `.rcb-typography.svelte-y2q9vo {display:inline-block;line-height:normal;}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-2xl.svelte-y2q9vo {font:var(--rc-text-heading2xl-mobile);}.rcb-typography-heading-2xl.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-heading2xl-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-xl.svelte-y2q9vo {font:var(--rc-text-headingXl-mobile);}.rcb-typography-heading-xl.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-headingXl-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-lg.svelte-y2q9vo {font:var(--rc-text-headingLg-mobile);}.rcb-typography-heading-lg.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-headingLg-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-md.svelte-y2q9vo {font:var(--rc-text-headingMd-mobile);}.rcb-typography-heading-md.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-headingMd-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-body-base.svelte-y2q9vo {font:var(--rc-text-bodyBase-mobile);}.rcb-typography-body-base.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-bodyBase-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-body-small.svelte-y2q9vo {font:var(--rc-text-bodySmall-mobile);}.rcb-typography-body-small.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-bodySmall-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-label-button.svelte-y2q9vo {font:var(--rc-text-labelButton-mobile);}.rcb-typography-label-button.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-labelButton-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-label-default.svelte-y2q9vo {font:var(--rc-text-labelDefault-mobile);}.rcb-typography-label-default.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-labelDefault-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-caption-default.svelte-y2q9vo {font:var(--rc-text-captionDefault-mobile);}.rcb-typography-caption-default.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-captionDefault-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-caption-link.svelte-y2q9vo {font:var(--rc-text-captionLink-mobile);}.rcb-typography-caption-link.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-captionLink-branded-mobile);}

  @container layout-query-container (width >= 768px) {span.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-brandedText-font-style-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-2xl.svelte-y2q9vo {font:var(--rc-text-heading2xl-desktop);}.rcb-typography-heading-2xl.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-heading2xl-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-xl.svelte-y2q9vo {font:var(--rc-text-headingXl-desktop);}.rcb-typography-heading-xl.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-headingXl-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-lg.svelte-y2q9vo {font:var(--rc-text-headingLg-desktop);}.rcb-typography-heading-lg.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-headingLg-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-md.svelte-y2q9vo {font:var(--rc-text-headingMd-desktop);}.rcb-typography-heading-md.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-headingMd-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-body-base.svelte-y2q9vo {font:var(--rc-text-bodyBase-desktop);}.rcb-typography-body-base.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-bodyBase-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-body-small.svelte-y2q9vo {font:var(--rc-text-bodySmall-desktop);}.rcb-typography-body-small.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-bodySmall-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-label-button.svelte-y2q9vo {font:var(--rc-text-labelButton-desktop);}.rcb-typography-label-button.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-labelButton-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-label-default.svelte-y2q9vo {font:var(--rc-text-labelDefault-desktop);}.rcb-typography-label-default.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-labelDefault-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-caption-default.svelte-y2q9vo {font:var(--rc-text-captionDefault-desktop);}.rcb-typography-caption-default.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-captionDefault-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-caption-link.svelte-y2q9vo {font:var(--rc-text-captionLink-desktop);}.rcb-typography-caption-link.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-captionLink-branded-desktop);}
  }`
};
function ye(e, r) {
  oe(e, Dy);
  const t = K(r, "size", 3, "body-base"), n = K(r, "branded", 3, !1);
  var a = Cy(), o = z(a);
  Ze(o, () => r.children ?? ze), U(() => tr(a, 1, `rcb-typography rcb-typography-${t() ?? ""} ${n() ? "rcb-typography-branded" : ""}`, "svelte-y2q9vo")), T(e, a);
}
var Ay = /* @__PURE__ */ B("<div><!></div>"), qy = /* @__PURE__ */ B('<span style="display: block;"><!></span>'), Fy = /* @__PURE__ */ B("<!> <!>", 1), zy = /* @__PURE__ */ B("<!> <!>", 1), My = /* @__PURE__ */ B('<div class="rcb-modal-message svelte-1ldqsgm" data-type="error"><!></div>');
const Oy = {
  hash: "svelte-1ldqsgm",
  code: `.rcb-modal-message-icon.svelte-1ldqsgm {flex-shrink:0;align-self:center;margin-right:16px;}.rcb-modal-message.svelte-1ldqsgm {width:100%;min-height:160px;display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:left;margin-top:4px;}.rcb-modal-message[data-has-title="false"].svelte-1ldqsgm {margin-top:var(--rc-spacing-gapXXLarge-mobile);}.rcb-modal-message-icon.small.svelte-1ldqsgm {height:var(--rc-text-headingLg-mobile-font-size);width:var(--rc-text-headingLg-mobile-font-size);}.rcb-modal-message-icon.large.svelte-1ldqsgm {height:calc(2 * var(--rc-text-headingMd-mobile-font-size));width:calc(2 * var(--rc-text-headingMd-mobile-font-size));}

  @container layout-query-container (width >= 768px) {.rcb-modal-message-icon.small.svelte-1ldqsgm {height:var(--rc-text-headingLg-desktop-font-size);width:var(--rc-text-headingLg-desktop-font-size);}.rcb-modal-message-icon.large.svelte-1ldqsgm {height:calc(2 * var(--rc-text-headingMd-desktop-font-size));width:calc(2 * var(--rc-text-headingMd-desktop-font-size));}.rcb-modal-message[data-has-title="false"].svelte-1ldqsgm {margin-top:var(--rc-spacing-gapXXLarge-desktop);}
  }`
};
function jy(e, r) {
  ee(r, !0), oe(e, Oy);
  const t = K(r, "title", 3, null), n = K(r, "icon", 3, null), a = 32;
  let o = /* @__PURE__ */ X(null), s = /* @__PURE__ */ X(!1), l;
  nr(() => (i(o) && (l = new ResizeObserver(() => {
    var d;
    L(s, (((d = i(o)) == null ? void 0 : d.offsetHeight) ?? 0) > a);
  }), l.observe(i(o))), () => {
    l == null || l.disconnect();
  }));
  var c = My(), u = z(c);
  Na(u, {
    gap: "medium",
    justify: "start",
    children: (d, p) => {
      var _ = zy(), g = J(_);
      Ty(g, {
        children: (v, f) => {
          var y = Fy(), k = J(y);
          {
            var m = (P) => {
              var I = Ay(), E = z(I);
              Ze(E, n), U(() => tr(I, 1, `rcb-modal-message-icon ${i(s) ? "large" : "small"}`, "svelte-1ldqsgm")), T(P, I);
            };
            W(k, (P) => {
              n() && P(m);
            });
          }
          var S = R(k, 2);
          {
            var x = (P) => {
              var I = qy(), E = z(I);
              ye(E, {
                size: "heading-md",
                children: (D, F) => {
                  var M = Ee();
                  U(() => pe(M, t())), T(D, M);
                },
                $$slots: { default: !0 }
              }), to(I, (D) => L(o, D), () => i(o)), T(P, I);
            };
            W(S, (P) => {
              t() && P(x);
            });
          }
          T(v, y);
        },
        $$slots: { default: !0 }
      });
      var h = R(g, 2);
      {
        var w = (v) => {
          ye(v, {
            size: "body-small",
            children: (f, y) => {
              var k = _e(), m = J(k);
              Ze(m, () => r.message ?? ze), T(f, k);
            },
            $$slots: { default: !0 }
          });
        };
        W(h, (v) => {
          r.message && v(w);
        });
      }
      T(d, _);
    },
    $$slots: { default: !0 }
  }), U(() => se(c, "data-has-title", !!t())), T(e, c), re();
}
var Ny = /* @__PURE__ */ B('<div class="rcb-modal-message-icon svelte-1h8pwwr"><!></div>'), Ly = /* @__PURE__ */ B("<!> <!>", 1), By = /* @__PURE__ */ B('<div class="rcb-modal-message svelte-1h8pwwr" data-type="success"><!></div>');
const Uy = {
  hash: "svelte-1h8pwwr",
  code: `.rcb-modal-message-icon.svelte-1h8pwwr {height:54px;width:54px;margin:0 auto;}.rcb-modal-message[data-has-title="false"].svelte-1h8pwwr {margin-top:var(--rc-spacing-gapXXLarge-mobile);}.rcb-modal-message.svelte-1h8pwwr {width:100%;min-height:160px;display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:center;}

  @container layout-query-container (width >= 768px) {.rcb-modal-message[data-has-title="false"].svelte-1h8pwwr {margin-top:var(--rc-spacing-gapXXLarge-desktop);}
  }`
};
function Ry(e, r) {
  oe(e, Uy);
  const t = K(r, "title", 3, null), n = K(r, "icon", 3, null);
  var a = By(), o = z(a);
  Na(o, {
    gap: "large",
    justify: "center",
    children: (s, l) => {
      var c = Ly(), u = J(c);
      {
        var d = (g) => {
          var h = Ny(), w = z(h);
          Ze(w, n), T(g, h);
        };
        W(u, (g) => {
          n() && g(d);
        });
      }
      var p = R(u, 2);
      {
        var _ = (g) => {
          ye(g, {
            size: "heading-md",
            children: (h, w) => {
              var v = Ee();
              U(() => pe(v, t())), T(h, v);
            },
            $$slots: { default: !0 }
          });
        };
        W(p, (g) => {
          t() && g(_);
        });
      }
      T(s, c);
    },
    $$slots: { default: !0 }
  }), U(() => se(a, "data-has-title", !!t())), T(e, a);
}
const no = "rcb-ui-events-tracker", va = "branding";
var Vy = /* @__PURE__ */ B('<div><div class="message-layout-content svelte-clabfx"><!></div> <div class="message-layout-footer"><!></div></div>');
const Hy = {
  hash: "svelte-clabfx",
  code: `.message-layout.svelte-clabfx {display:flex;flex-direction:column;}.message-layout-content.svelte-clabfx {flex-grow:1;display:flex;flex-direction:column;justify-content:center;}

  @container layout-query-container (width < 768px) {.message-layout.svelte-clabfx {flex-grow:1;gap:var(--rc-spacing-gapXXLarge-mobile);}
  }

  @container layout-query-container (width >= 768px) {.message-layout.svelte-clabfx {min-height:354px;gap:var(--rc-spacing-gapXXLarge-desktop);}.message-layout-content.svelte-clabfx {justify-content:flex-start;flex-grow:1;}
  }.message-layout-full-width.svelte-clabfx {width:100%;}

  @media (min-width: 768px) {.message-layout-full-width.svelte-clabfx {width:544px;}
  }`
};
function Gs(e, r) {
  ee(r, !0), oe(e, Hy);
  const t = () => fe(d, "$brandingAppearanceStore", n), [n, a] = Ae();
  let o = K(r, "title", 3, null), s = K(r, "closeButtonTitle", 3, "Go back to app"), l = K(r, "icon", 3, null), c = K(r, "message", 3, null), u = K(r, "fullWidth", 3, !1);
  const d = Le(va), p = /* @__PURE__ */ b(() => t() ?? void 0);
  function _() {
    r.onDismiss();
  }
  var g = Vy();
  let h;
  var w = z(g), v = z(w);
  Py(v, {
    children: (k, m) => {
      var S = _e(), x = J(S);
      {
        var P = (E) => {
          Ry(E, {
            get title() {
              return o();
            },
            get icon() {
              return l();
            }
          });
        }, I = (E) => {
          jy(E, {
            get title() {
              return o();
            },
            get icon() {
              return l();
            },
            get message() {
              return c();
            }
          });
        };
        W(x, (E) => {
          r.type === "success" ? E(P) : E(I, !1);
        });
      }
      T(k, S);
    },
    $$slots: { default: !0 }
  });
  var f = R(w, 2), y = z(f);
  ky(y, {
    children: (k, m) => {
      Id(k, {
        onclick: _,
        type: "submit",
        get brandingAppearance() {
          return i(p);
        },
        children: (S, x) => {
          var P = Ee();
          U(() => pe(P, s())), T(S, P);
        },
        $$slots: { default: !0 }
      });
    },
    $$slots: { default: !0 }
  }), U(() => h = tr(g, 1, "message-layout svelte-clabfx", null, h, { "message-layout-full-width": u() })), T(e, g), re(), a();
}
function Wr(e, r) {
  ee(r, !0);
  const t = () => fe(s, "$translator", n), [n, a] = Ae(), o = K(r, "key", 3, ""), s = Le(dr), l = /* @__PURE__ */ b(() => o() ? t().translate(o() || "", r.variables) : void 0);
  var c = _e(), u = J(c);
  {
    var d = (_) => {
      var g = Ee();
      U(() => pe(g, i(l))), T(_, g);
    }, p = (_) => {
      var g = _e(), h = J(g);
      Ze(h, () => r.children ?? ze), T(_, g);
    };
    W(u, (_) => {
      i(l) ? _(d) : _(p, !1);
    });
  }
  T(e, c), re(), a();
}
var Wy = /* @__PURE__ */ B('<p class="footer-caption svelte-1fu2zos"><!></p>'), Yy = /* @__PURE__ */ B('<p class="footer-caption svelte-1fu2zos"><!></p>'), Gy = /* @__PURE__ */ B('<a class="terms-link svelte-1fu2zos" rel="noopener noreferrer" target="_blank"><!></a> <span class="terms-divider svelte-1fu2zos"></span>', 1), Ky = /* @__PURE__ */ B("<!> <!>", 1), Xy = /* @__PURE__ */ B('<div class="footer-caption-container svelte-1fu2zos"><!> <!> <p class="footer-caption svelte-1fu2zos"><!></p></div>');
const $y = {
  hash: "svelte-1fu2zos",
  code: `.footer-caption-container.svelte-1fu2zos {display:flex;flex-direction:column;gap:var(--rc-spacing-gapLarge-mobile);}.footer-caption.svelte-1fu2zos {color:var(--rc-color-grey-text-light);text-align:center;margin:0;}.terms-link.svelte-1fu2zos {color:inherit;}.terms-divider.svelte-1fu2zos {margin:0 4px;}

  @container layout-query-container (width >= 768px) {.footer-caption-container.svelte-1fu2zos {gap:var(--rc-spacing-gapLarge-desktop);}
  }`
};
function Zy(e, r) {
  ee(r, !1), oe(e, $y);
  const t = () => fe(y, "$translator", n), [n, a] = Ae(), o = /* @__PURE__ */ Br(), s = /* @__PURE__ */ Br(), l = /* @__PURE__ */ Br(), c = /* @__PURE__ */ Br(), u = /* @__PURE__ */ Br(), d = /* @__PURE__ */ Br(), p = /* @__PURE__ */ Br(), _ = /* @__PURE__ */ Br(), g = /* @__PURE__ */ Br(), h = /* @__PURE__ */ Br();
  let w = K(r, "brandingInfo", 8, null), v = K(r, "purchaseOption", 8, null), f = K(r, "termsAndConditionsUrl", 8, null);
  const y = Le(dr);
  function k(C) {
    return C != null && "base" in C;
  }
  function m(C) {
    return C != null && "basePrice" in C;
  }
  function S(C) {
    return C ? C.trial ? $.PaymentEntryPageTrialSubscriptionTermsInfo : $.PaymentEntryPageSubscriptionTermsInfo : $.PaymentEntryPageOtpTermsInfo;
  }
  pt(() => Ge(v()), () => {
    L(o, k(v()) ? v() : null);
  }), pt(() => Ge(v()), () => {
    L(s, m(v()) ? v() : null);
  }), pt(() => i(o), () => {
    L(l, S(i(o)));
  }), pt(() => i(o), () => {
    var C, j, H;
    L(c, ((C = i(o)) == null ? void 0 : C.discount) ?? ((j = i(o)) == null ? void 0 : j.introPrice) ?? ((H = i(o)) == null ? void 0 : H.base) ?? null);
  }), pt(
    () => (i(s), i(c)),
    () => {
      var C, j, H, A;
      L(u, ((j = (C = i(s)) == null ? void 0 : C.discount) == null ? void 0 : j.price) || ((H = i(s)) == null ? void 0 : H.basePrice) || ((A = i(c)) == null ? void 0 : A.price));
    }
  ), pt(() => (i(u), t()), () => {
    L(d, i(u) ? on(i(u).amountMicros, i(u).currency, t().bcp47Locale || t().fallbackBcp47Locale) : null);
  }), pt(() => (i(c), t()), () => {
    var C, j, H, A, q;
    L(p, (C = i(c)) != null && C.period ? t().translatePeriodFrequency(((H = (j = i(c)) == null ? void 0 : j.period) == null ? void 0 : H.number) || 1, (q = (A = i(c)) == null ? void 0 : A.period) == null ? void 0 : q.unit, { useMultipleWords: !0 }) : null);
  }), pt(() => (i(o), t(), rs), () => {
    var C, j;
    L(_, (j = (C = i(o)) == null ? void 0 : C.trial) != null && j.period ? t().translateDate(rs(/* @__PURE__ */ new Date(), i(o).trial.period, !0), { year: "numeric", month: "long", day: "numeric" }) : null);
  }), pt(
    () => (Ge(w()), i(u), t(), i(l), i(d), i(p), i(_)),
    () => {
      var C;
      L(g, w() && i(u) ? t().translate(i(l), {
        appName: (C = w()) == null ? void 0 : C.app_name,
        price: i(d),
        perFrequency: i(p),
        renewalDate: i(_)
      }) : null);
    }
  ), pt(() => (i(o), t(), $), () => {
    L(h, i(o) ? t().translate($.PaymentEntryPageSubscriptionInfo) : null);
  }), T_(), An();
  var x = Xy(), P = z(x);
  {
    var I = (C) => {
      var j = Wy(), H = z(j);
      ye(H, {
        size: "caption-default",
        children: (A, q) => {
          var O = Ee();
          U(() => pe(O, i(g))), T(A, O);
        },
        $$slots: { default: !0 }
      }), T(C, j);
    };
    W(P, (C) => {
      i(g) && C(I);
    });
  }
  var E = R(P, 2);
  {
    var D = (C) => {
      var j = Yy(), H = z(j);
      ye(H, {
        size: "caption-default",
        children: (A, q) => {
          var O = Ee();
          U(() => pe(O, i(h))), T(A, O);
        },
        $$slots: { default: !0 }
      }), T(C, j);
    };
    W(E, (C) => {
      i(h) && C(D);
    });
  }
  var F = R(E, 2), M = z(F);
  ye(M, {
    size: "caption-default",
    children: (C, j) => {
      var H = Ky(), A = J(H);
      {
        var q = (G) => {
          var Y = Gy(), te = J(Y), le = z(te);
          Wr(le, {
            get key() {
              return Ge($), Ue(() => $.PaymentEntryPageTermsLinkLabel);
            }
          });
          var be = R(te, 2);
          be.textContent = "|", U(() => se(te, "href", f())), T(G, Y);
        };
        W(A, (G) => {
          f() && G(q);
        });
      }
      var O = R(A, 2);
      Wr(O, {
        get key() {
          return Ge($), Ue(() => $.PaymentEntryPagePaymentStepTitle);
        }
      }), T(C, H);
    },
    $$slots: { default: !0 }
  }), T(e, x), re(), a();
}
var Mr = /* @__PURE__ */ ((e) => (e.SDKInitialized = "sdk_initialized", e.CheckoutSessionStart = "checkout_session_start", e.CheckoutSessionEnd = "checkout_session_end", e.CheckoutFlowError = "checkout_flow_error", e.CheckoutPaymentTaxCalculation = "checkout_payment_tax_calculation", e.CheckoutPaymentFormImpression = "checkout_payment_form_impression", e.CheckoutPaymentFormError = "checkout_payment_form_error", e.CheckoutPaymentFormDismiss = "checkout_payment_form_dismiss", e.CheckoutPaymentFormSubmit = "checkout_payment_form_submit", e.CheckoutPaymentFormGatewayError = "checkout_payment_form_gateway_error", e.CheckoutPurchaseSuccessfulImpression = "checkout_purchase_successful_impression", e.CheckoutPurchaseSuccessfulDismiss = "checkout_purchase_successful_dismiss", e))(Mr || {}), Ks = /* @__PURE__ */ ((e) => (e.tax_collection_disabled = "tax_collection_disabled", e.invalid_tax_location = "invalid_tax_location", e.rate_limit_exceeded = "rate_limit_exceeded", e.missing_required_permission = "missing_required_permission", e.invalid_origin_address = "invalid_origin_address", e.taxes_not_active = "taxes_not_active", e.unexpected_gateway_error = "unexpected_gateway_error", e))(Ks || {});
function Td(e) {
  const r = {};
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t)) {
      const n = t.replace(/([A-Z])/g, "_$1").toLowerCase(), a = e[t];
      a && typeof a == "object" && !Array.isArray(a) ? r[n] = Td(
        a
      ) : r[n] = a;
    }
  return r;
}
function bc(e) {
  for (let r = 0; r < e.length; r++)
    e[r] = Math.floor(Math.random() * 256);
}
function Tn() {
  const e = typeof crypto < "u" ? crypto : globalThis.crypto;
  if (e && e.randomUUID)
    return e.randomUUID();
  const r = new Uint8Array(16);
  try {
    e && e.getRandomValues ? e.getRandomValues(r) : bc(r);
  } catch (n) {
    console.log(
      `Error using crypto.getRandomValues(), falling back to Math.random. + ${n}`
    ), bc(r);
  }
  r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128;
  const t = Array.from(r).map((n) => n.toString(16).padStart(2, "0"));
  return [
    t.slice(0, 4).join(""),
    t.slice(4, 6).join(""),
    t.slice(6, 8).join(""),
    t.slice(8, 10).join(""),
    t.slice(10, 16).join("")
  ].join("-");
}
const Dr = "sdk_checkout";
class Jy {
  constructor(r) {
    V(this, "EVENT_TYPE", "web_billing");
    V(this, "id");
    V(this, "timestampMs");
    V(this, "data");
    this.id = Tn(), this.timestampMs = Date.now(), this.data = r;
  }
  toJSON() {
    return Td({
      id: this.id,
      timestampMs: this.timestampMs,
      type: this.EVENT_TYPE,
      eventName: this.data.eventName,
      appUserId: this.data.appUserId,
      context: {
        ...this.data.context
      },
      properties: {
        ...this.data.properties,
        traceId: this.data.traceId,
        ...this.data.workflowIdentifier !== void 0 ? { workflowIdentifier: this.data.workflowIdentifier } : {}
      }
    });
  }
}
function Cd({
  errorCode: e,
  errorMessage: r,
  mode: t = Dr
}) {
  return {
    eventName: Mr.CheckoutFlowError,
    properties: {
      mode: t,
      errorCode: e,
      errorMessage: r
    }
  };
}
function Qy({
  errorCode: e,
  errorMessage: r,
  mode: t = Dr
}) {
  return {
    eventName: Mr.CheckoutPaymentFormError,
    properties: {
      mode: t,
      errorCode: e,
      errorMessage: r
    }
  };
}
function ko({
  appearance: e,
  rcPackage: r,
  purchaseOptionToUse: t,
  customerEmail: n,
  mode: a = Dr
}) {
  return {
    eventName: Mr.CheckoutSessionStart,
    properties: {
      mode: a,
      customizationColorButtonsPrimary: (e == null ? void 0 : e.color_buttons_primary) ?? null,
      customizationColorAccent: (e == null ? void 0 : e.color_accent) ?? null,
      customizationColorError: (e == null ? void 0 : e.color_error) ?? null,
      customizationColorProductInfoBg: (e == null ? void 0 : e.color_product_info_bg) ?? null,
      customizationColorFormBg: (e == null ? void 0 : e.color_form_bg) ?? null,
      customizationColorPageBg: (e == null ? void 0 : e.color_page_bg) ?? null,
      customizationFont: (e == null ? void 0 : e.font) ?? null,
      customizationShapes: (e == null ? void 0 : e.shapes) ?? null,
      customizationShowProductDescription: (e == null ? void 0 : e.show_product_description) ?? null,
      productInterval: r.webBillingProduct.normalPeriodDuration,
      productPrice: r.webBillingProduct.price.amountMicros,
      productCurrency: r.webBillingProduct.price.currency,
      selectedProductId: r.webBillingProduct.identifier,
      selectedPackageId: r.identifier,
      selectedPurchaseOption: t.id,
      customerEmailProvidedByDeveloper: !!n
    }
  };
}
function vc({
  redemptionInfo: e,
  mode: r = Dr
}) {
  return {
    eventName: Mr.CheckoutSessionEnd,
    properties: {
      mode: r,
      outcome: "finished",
      withRedemptionInfo: !!e
    }
  };
}
function Dd(e) {
  return {
    eventName: Mr.CheckoutSessionEnd,
    properties: {
      mode: (e == null ? void 0 : e.mode) ?? Dr,
      outcome: "closed"
    }
  };
}
function kc({
  errorCode: e,
  errorMessage: r,
  mode: t = Dr
}) {
  return {
    eventName: Mr.CheckoutSessionEnd,
    properties: {
      mode: t,
      outcome: "errored",
      errorCode: e,
      errorMessage: r
    }
  };
}
function Ad({
  taxCalculation: e,
  taxCustomerDetails: r,
  mode: t = Dr
}) {
  const n = e.failed_reason === Ks.tax_collection_disabled ? "disabled" : e.failed_reason ? "failed" : e.tax_amount_in_micros === 0 ? "not-taxed" : "taxed", a = r === null ? "auto" : "form";
  return {
    eventName: Mr.CheckoutPaymentTaxCalculation,
    properties: {
      mode: t,
      outcome: n,
      ui_element: a,
      tax_inclusive: e.tax_inclusive,
      error_code: e.failed_reason ?? null
    }
  };
}
function qd({
  selectedPaymentMethod: e,
  mode: r = Dr
}) {
  return {
    eventName: Mr.CheckoutPaymentFormSubmit,
    properties: {
      mode: r,
      selectedPaymentMethod: e ?? null
    }
  };
}
function os({
  errorCode: e,
  errorMessage: r,
  mode: t = Dr
}) {
  return {
    eventName: Mr.CheckoutPaymentFormGatewayError,
    properties: {
      mode: t,
      errorCode: e,
      errorMessage: r
    }
  };
}
function eb(e, r = Dr) {
  return {
    eventName: Mr.CheckoutPurchaseSuccessfulDismiss,
    properties: {
      mode: r,
      ui_element: e
    }
  };
}
function rb(e = Dr) {
  return {
    eventName: Mr.CheckoutPurchaseSuccessfulImpression,
    properties: {
      mode: e
    }
  };
}
const tb = `<svg width="80" height="80" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <g transform="scale(0.5)" transform-origin="center">
  <path d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 11.5858 20.8358 11.25 21.25 11.25C21.6642 11.25 22 11.5858 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.4142 2 12.75 2.33579 12.75 2.75C12.75 3.16421 12.4142 3.5 12 3.5Z" fill="currentColor"/>
  </g>
</svg>`;
var nb = /* @__PURE__ */ B('<div class="rcb-ui-asset-icon svelte-6k29hu"><!></div>');
const ab = {
  hash: "svelte-6k29hu",
  code: `
  @-webkit-keyframes svelte-6k29hu-rotating /* Safari and Chrome */ {
    from {
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes svelte-6k29hu-rotating {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }div.svelte-6k29hu {width:80px;height:80px;
    -webkit-animation: svelte-6k29hu-rotating 2s ease-in-out infinite;
    -moz-animation: svelte-6k29hu-rotating 2s ease-in-out infinite;
    -ms-animation: svelte-6k29hu-rotating 2s ease-in-out infinite;
    -o-animation: svelte-6k29hu-rotating 2s ease-in-out infinite;
    animation: svelte-6k29hu-rotating 2s ease-in-out infinite;}`
};
function Mo(e, r) {
  oe(e, ab);
  const t = K(r, "color", 3, "var(--rc-color-accent)");
  var n = nb(), a = z(n);
  dn(a, () => tb), U(() => Pe(n, `color:${t() ?? ""};`)), T(e, n);
}
var ob = /* @__PURE__ */ B('<div class="rcb-modal-loader svelte-rhstd0"><!></div>');
const ib = {
  hash: "svelte-rhstd0",
  code: `.rcb-modal-loader.svelte-rhstd0 {width:100%;flex-grow:1;display:flex;justify-content:center;align-items:center;}

  @container layout-query-container (width >= 768px) {.rcb-modal-loader.svelte-rhstd0 {align-items:flex-start;margin-top:calc(var(--rc-spacing-gapXXLarge-desktop) * 6);}
  }`
};
function Fd(e) {
  oe(e, ib);
  var r = ob(), t = z(r);
  Mo(t, {}), T(e, r);
}
function sb(e, r) {
  var _, g;
  ee(r, !0);
  const t = () => fe(l, "$brandingAppearanceStore", a), n = () => fe(s, "$translator", a), [a, o] = Ae(), s = Le(dr), l = Le(va), c = /* @__PURE__ */ b(() => t() ?? void 0), u = /* @__PURE__ */ b(() => r.priceBreakdown ? n().formatPrice(r.priceBreakdown.totalAmountInMicros, r.priceBreakdown.currency) : null), d = (g = (_ = r.subscriptionOption) == null ? void 0 : _.trial) == null ? void 0 : g.period, p = /* @__PURE__ */ b(() => d ? n().translatePeriod(d.number, d.unit) : null);
  Id(e, {
    get disabled() {
      return r.disabled;
    },
    testId: "PayButton",
    get brandingAppearance() {
      return i(c);
    },
    children: (h, w) => {
      var v = _e(), f = J(v);
      {
        var y = (m) => {
          {
            let S = /* @__PURE__ */ b(() => ({ trialPeriodLabel: i(p) }));
            Wr(m, {
              get key() {
                return $.PaymentEntryPageButtonStartTrial;
              },
              get variables() {
                return i(S);
              }
            });
          }
        }, k = (m) => {
          var S = _e(), x = J(S);
          {
            var P = (E) => {
              {
                let D = /* @__PURE__ */ b(() => ({ formattedPrice: i(u) }));
                Wr(E, {
                  get key() {
                    return $.PaymentEntryPageButtonWithPrice;
                  },
                  get variables() {
                    return i(D);
                  }
                });
              }
            }, I = (E) => {
              Wr(E, {
                get key() {
                  return $.PaymentEntryPageButtonPay;
                }
              });
            };
            W(
              x,
              (E) => {
                i(u) ? E(P) : E(I, !1);
              },
              !0
            );
          }
          T(m, S);
        };
        W(f, (m) => {
          var S;
          (S = r.subscriptionOption) != null && S.trial ? m(y) : m(k, !1);
        });
      }
      T(h, v);
    },
    $$slots: { default: !0 }
  }), re(), o();
}
const lb = {
  error: "#B0171F",
  warning: "#f4e971",
  focus: "#1148B8",
  accent: "#767676",
  primary: "#576CDB",
  "primary-hover": "rgba(87, 108, 219, .8)",
  "primary-pressed": "rgba(87, 108, 219, .9)",
  "primary-text": "#ffffff",
  white: "#ffffff",
  "grey-text-dark": "rgba(0,0,0,1)",
  "grey-text-light": "rgba(0,0,0,0.7)",
  "grey-ui-dark": "rgba(0,0,0,0.3)",
  "grey-ui-light": "rgba(0,0,0,0.1)",
  "input-background": "white",
  background: "white"
}, cb = {
  error: "#B0171F",
  warning: "#f4e971",
  focus: "#1148B8",
  accent: "#767676",
  primary: "#576CDB",
  "primary-hover": "rgba(87, 108, 219, .8)",
  "primary-pressed": "rgba(87, 108, 219, .9)",
  "primary-text": "#ffffff",
  white: "#ffffff",
  "grey-text-dark": "rgba(0,0,0,1)",
  "grey-text-light": "rgba(0,0,0,0.7)",
  "grey-ui-dark": "rgba(0,0,0,0.3)",
  "grey-ui-light": "rgba(0,0,0,0.1)",
  "input-background": "white",
  background: "#EFF3FA"
}, ub = {
  error: "#B0171F",
  warning: "#f4e971",
  focus: "#1148B8",
  accent: "#767676",
  primary: "#576CDB",
  "primary-hover": "rgba(87, 108, 219, .8)",
  "primary-pressed": "rgba(87, 108, 219, .9)",
  "primary-text": "#ffffff",
  white: "#ffffff",
  "grey-text-dark": "rgba(0,0,0,1)",
  "grey-text-light": "rgba(0,0,0,0.7)",
  "grey-ui-dark": "rgba(0,0,0,0.3)",
  "grey-ui-light": "rgba(0,0,0,0.1)",
  "input-background": "white",
  background: "#ffffff"
}, Xs = {
  error: "color_error",
  focus: "color_accent",
  accent: "color_accent",
  primary: "color_buttons_primary"
}, db = {
  ...Xs,
  "input-background": "color_form_bg",
  background: "color_form_bg"
}, pb = {
  ...Xs,
  "input-background": "color_product_info_bg",
  background: "color_product_info_bg"
}, _b = {
  ...Xs,
  "input-background": "color_page_bg",
  background: "color_page_bg"
}, zd = {
  "input-border-radius": "4px",
  "input-button-border-radius": "8px"
}, gb = {
  "input-border-radius": "0px",
  "input-button-border-radius": "0px"
}, fb = {
  "input-border-radius": "12px",
  "input-button-border-radius": "9999px"
}, wc = zd, La = "-apple-system, BlinkMacSystemFont, avenir next, avenir, segoe ui, helvetica neue, helvetica, Cantarell, Ubuntu, roboto, noto, arial, sans-serif", Md = "BrandCustomFont", Pc = `${Md}, ${La}`, yt = {
  regular: "400",
  medium: "500",
  semibold: "600"
}, Qr = {
  12: "12px",
  14: "14px",
  16: "16px",
  18: "18px",
  24: "24px",
  28: "28px",
  32: "32px",
  36: "36px"
}, bt = {
  130: "130%",
  140: "140%"
}, vt = {
  tight: "0.20%",
  regular: "0",
  loose: "0.20%"
}, rr = {
  heading2xl: {
    fontSize: Qr[28],
    lineHeight: bt[130],
    fontWeight: yt.semibold,
    letterSpacing: vt.loose
  },
  headingXl: {
    fontSize: Qr[24],
    lineHeight: bt[130],
    fontWeight: yt.semibold,
    letterSpacing: vt.loose
  },
  headingLg: {
    fontSize: "20px",
    lineHeight: bt[130],
    fontWeight: yt.semibold,
    letterSpacing: vt.loose
  },
  headingMd: {
    fontSize: "16px",
    lineHeight: bt[140],
    fontWeight: yt.medium,
    letterSpacing: vt.regular
  },
  bodyBase: {
    fontSize: Qr[16],
    lineHeight: bt[140],
    fontWeight: yt.regular,
    letterSpacing: vt.regular
  },
  bodySmall: {
    fontSize: Qr[14],
    lineHeight: bt[140],
    fontWeight: yt.regular,
    letterSpacing: vt.regular
  },
  labelButton: {
    fontSize: Qr[16],
    lineHeight: bt[140],
    fontWeight: yt.semibold,
    letterSpacing: vt.tight
  },
  labelDefault: {
    fontSize: Qr[14],
    lineHeight: bt[140],
    fontWeight: yt.regular,
    letterSpacing: vt.tight
  },
  captionDefault: {
    fontSize: Qr[12],
    lineHeight: bt[140],
    fontWeight: yt.regular,
    letterSpacing: vt.regular
  },
  captionLink: {
    fontSize: Qr[12],
    lineHeight: bt[140],
    fontWeight: yt.regular,
    letterSpacing: vt.regular
  }
}, kt = {
  heading2xl: {
    ...rr.heading2xl,
    fontSize: Qr[36]
  },
  headingXl: {
    ...rr.headingXl,
    fontSize: Qr[32]
  },
  headingLg: {
    ...rr.headingLg,
    fontSize: Qr[24]
  },
  headingMd: {
    ...rr.headingMd,
    fontSize: Qr[18]
  },
  bodyBase: {
    ...rr.bodyBase
  },
  bodySmall: {
    ...rr.bodySmall
  },
  labelButton: {
    ...rr.labelButton
  },
  labelDefault: {
    ...rr.labelDefault
  },
  captionDefault: {
    ...rr.captionDefault
  },
  captionLink: {
    ...rr.captionLink
  }
}, is = {
  heading2xl: {
    mobile: rr.heading2xl,
    desktop: kt.heading2xl
  },
  headingXl: {
    desktop: kt.headingXl,
    mobile: rr.headingXl
  },
  headingLg: {
    desktop: kt.headingLg,
    mobile: rr.headingLg
  },
  headingMd: {
    desktop: kt.headingMd,
    mobile: rr.headingMd
  },
  bodyBase: {
    desktop: kt.bodyBase,
    mobile: rr.bodyBase
  },
  bodySmall: {
    desktop: kt.bodySmall,
    mobile: rr.bodySmall
  },
  labelButton: {
    desktop: kt.labelButton,
    mobile: rr.labelButton
  },
  labelDefault: {
    desktop: kt.labelDefault,
    mobile: rr.labelDefault
  },
  captionDefault: {
    desktop: kt.captionDefault,
    mobile: rr.captionDefault
  },
  captionLink: {
    desktop: kt.captionLink,
    mobile: rr.captionLink
  }
}, Ba = (e) => e.length == 7 ? {
  r: parseInt(e.slice(1, 3), 16),
  g: parseInt(e.slice(3, 5), 16),
  b: parseInt(e.slice(5, 7), 16)
} : e.length == 4 ? {
  r: parseInt(e[1], 16),
  g: parseInt(e[2], 16),
  b: parseInt(e[3], 16)
} : null, $s = ({
  r: e,
  g: r,
  b: t,
  luminanceThreshold: n
}) => {
  const a = (s) => (s = s / 255, s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4));
  return 0.2126 * a(e) + 0.7152 * a(r) + 0.0722 * a(t) > n;
}, Zs = 0.37, mb = (e, r = Zs) => {
  const t = $s({ ...e, luminanceThreshold: r }) ? "0,0,0" : "255,255,255";
  return {
    "grey-text-dark": `rgb(${t})`,
    "grey-text-light": `rgba(${t},0.70)`,
    "grey-ui-dark": `rgba(${t},0.3)`,
    "grey-ui-light": `rgba(${t},0.1)`
  };
};
function hb(e, r, t) {
  const n = Ba(e) || { r: 0, g: 0, b: 0 }, a = Ba(r) || { r: 255, g: 255, b: 255 }, o = Math.round(a.r * t + n.r * (1 - t)), s = Math.round(a.g * t + n.g * (1 - t)), l = Math.round(a.b * t + n.b * (1 - t));
  return `#${zi(o)}${zi(s)}${zi(l)}`;
}
function xc(e, r) {
  const t = { r: 255, g: 255, b: 255 }, n = Math.max(0, Math.min(1, r));
  let a = e, o = Ba(e) || t;
  (isNaN(o.r) || isNaN(o.g) || isNaN(o.b)) && (o = t, a = "#FFFFFF");
  const l = $s({
    ...o,
    luminanceThreshold: Zs
  }) ? "#000000" : "#FFFFFF";
  return hb(a, l, n);
}
function zi(e) {
  return e.toString(16).padStart(2, "0").toUpperCase();
}
const yb = (e, r, t, n = Zs) => {
  const a = {
    "grey-text-dark": t["grey-text-dark"],
    "grey-text-light": t["grey-text-light"],
    "grey-ui-dark": t["grey-ui-dark"],
    "grey-ui-light": t["grey-ui-light"],
    "primary-text": t["primary-text"]
  };
  if (e != null && e.startsWith("#")) {
    const o = Ba(e);
    o !== null && Object.assign(a, mb(o));
  }
  if (r != null && r.startsWith("#")) {
    const o = Ba(r);
    o !== null && (a["primary-text"] = $s({ ...o, luminanceThreshold: n }) ? "black" : "white");
  }
  return a;
}, bb = (e) => ({
  "primary-hover": xc(e, 0.1),
  "primary-pressed": xc(e, 0.15)
}), vb = (e, r) => e || r, kb = (e, r, t) => {
  const n = Object.entries(e).map(([a, o]) => [
    a,
    vb(
      t ? t[o] : null,
      r[a]
    )
  ]);
  return Object.fromEntries(n);
}, Js = (e, r, t) => {
  const n = kb(
    e,
    r,
    t
  );
  return t ? {
    ...r,
    ...n,
    ...yb(
      n.background,
      n.primary,
      r
    ),
    ...bb(n.primary)
  } : { ...r };
}, wb = (e) => Js(
  pb,
  cb,
  e
), Od = (e) => Js(
  db,
  lb,
  e
), Pb = (e) => Js(
  _b,
  ub,
  e
), Qo = (e) => {
  if (!e)
    return wc;
  switch (e.shapes) {
    case "rounded":
      return zd;
    case "rectangle":
      return gb;
    case "pill":
      return fb;
    default:
      return wc;
  }
}, da = (e = "", r) => r.map(([t, n]) => `--rc-${e}-${t}: ${n}`).join("; "), jd = (e) => {
  const r = da(
    "color",
    Object.entries(wb(e))
  ), t = da(
    "shape",
    Object.entries(Qo(e))
  );
  return [r, t].join("; ");
}, xb = (e) => {
  const r = da(
    "color",
    Object.entries(Od(e))
  ), t = da(
    "shape",
    Object.entries(Qo(e))
  );
  return [r, t].join("; ");
}, Eb = (e) => {
  const r = da(
    "color",
    Object.entries(Pb(e))
  ), t = da(
    "shape",
    Object.entries(Qo(e))
  );
  return [r, t].join("; ");
}, Sb = (e = "", r, t) => Object.entries(r).flatMap(([n, { desktop: a, mobile: o }]) => {
  const s = `normal normal ${a.fontWeight} ${a.fontSize}/${a.lineHeight} ${La}`, l = `normal normal ${o.fontWeight} ${o.fontSize}/${o.lineHeight} ${La}`, c = `normal normal ${t == null ? void 0 : t.desktop.font_weight} ${t == null ? void 0 : t.desktop.font_size} ${Pc}`, u = `normal normal ${t == null ? void 0 : t.mobile.font_weight} ${t == null ? void 0 : t.mobile.font_size} ${Pc}`;
  return [
    `--rc-${e}-${n}-desktop: ${s}`,
    `--rc-${e}-${n}-mobile: ${l}`,
    `--rc-${e}-${n}-branded-desktop: ${t ? c : s}`,
    `--rc-${e}-${n}-branded-mobile: ${t ? u : l}`,
    `--rc-${e}-${n}-desktop-font-size: ${a.fontSize}`,
    `--rc-${e}-${n}-mobile-font-size: ${o.fontSize}`
  ];
}).join("; "), Ib = (e = "", r) => Object.entries(r).map(
  ([t, { mobile: n, desktop: a }]) => `--rc-${e}-${t}-mobile: ${n};  --rc-${e}-${t}-desktop: ${a};`
).join(" "), Tb = {
  outerPaddingTop: {
    mobile: "0.25rem",
    // 4px
    desktop: "clamp(1rem, 8.44vw, 7.5rem)"
    // 16px to 128px
  },
  outerPadding: {
    mobile: "clamp(1.3125rem, 5.6vw, 1.5rem)",
    // 21px to 24px
    desktop: "clamp(3rem, 6.44vw, 4.5rem)"
    // 48px to 72px
  },
  gapSmall: {
    mobile: "0.25rem",
    // 4px
    desktop: "0.5rem"
    // 8px
  },
  gapMedium: {
    mobile: "0.5rem",
    // 8px
    desktop: "0.75rem"
    // 12px
  },
  gapLarge: {
    mobile: "0.75rem",
    // 12px
    desktop: "1rem"
    // 16px
  },
  gapXLarge: {
    mobile: "1rem",
    // 16px
    desktop: "2rem"
    // 32px
  },
  gapXXLarge: {
    mobile: "1.25rem",
    // 20px
    desktop: "2.25rem"
    // 36px
  },
  gapXXXLarge: {
    mobile: "2.25rem",
    // 36px
    desktop: "5rem"
    // 80px
  },
  inputHeight: {
    // Only used with button
    // Inconsistent with design system
    // Should rely on padding spacings
    mobile: "3rem",
    // 48px
    desktop: "3rem"
    // 48px
  }
};
class pa {
  constructor(r) {
    V(this, "brandingAppearance");
    r ? this.brandingAppearance = r : this.brandingAppearance = void 0;
  }
  get shape() {
    return Qo(this.brandingAppearance);
  }
  get formColors() {
    return Od(this.brandingAppearance);
  }
  get formStyleVars() {
    return xb(this.brandingAppearance);
  }
  get productInfoStyleVars() {
    return jd(this.brandingAppearance);
  }
  get pageStyleVars() {
    return Eb(this.brandingAppearance);
  }
  get spacing() {
    return Tb;
  }
  get textStyles() {
    return is;
  }
  getTextStyleVars(r) {
    return Sb("text", this.textStyles, r);
  }
  get spacingStyleVars() {
    return Ib("spacing", this.spacing);
  }
}
var ss = /* @__PURE__ */ ((e) => (e[e.ErrorLoadingStripe = 0] = "ErrorLoadingStripe", e[e.HandledFormError = 1] = "HandledFormError", e[e.UnhandledFormError = 2] = "UnhandledFormError", e))(ss || {});
class Zn {
  constructor(r, t, n) {
    this.code = r, this.gatewayErrorCode = t, this.message = n;
  }
}
const Lr = class Lr {
  /* eslint-enable @typescript-eslint/consistent-type-imports */
  static preloadStripeModule() {
    Lr.stripeModulePromise || (Lr.stripeModulePromise = import("./index-DuKHkfLn.js"));
  }
  static async getLoadStripe() {
    Lr.stripeModulePromise || (Lr.stripeModulePromise = import("./index-DuKHkfLn.js"));
    const { loadStripe: r } = await Lr.stripeModulePromise.catch(() => {
      throw new Zn(
        0,
        void 0,
        "Failed to load Stripe library"
      );
    });
    return r;
  }
  /**
   * This function converts some particular locales to the ones that stripe supports.
   * Finally falls back to 'auto' if the initialLocale is not supported by stripe.
   * @param locale
   */
  static getStripeLocale(r) {
    if (["ca", "hi", "uk"].includes(r))
      return "auto";
    const n = {
      zh_Hans: "zh",
      "zh-Hans": "zh",
      zh_Hant: "zh-TW",
      "zh-Hant": "zh-TW"
    };
    return Object.keys(n).includes(r) ? n[r] : r;
  }
  static async getStripeClient(r, t) {
    const a = await (await Lr.getLoadStripe())(t, {
      stripeAccount: r
    }).catch((o) => {
      throw this.mapInitializationError(o);
    });
    if (!a)
      throw {
        code: 0,
        gatewayErrorCode: void 0,
        message: "Stripe client not found"
      };
    return { stripe: a };
  }
  static async initializeStripe(r, t, n, a, o, s, l) {
    if (!t || !r || !n)
      throw {
        code: 0,
        gatewayErrorCode: void 0,
        message: "Stripe configuration is missing"
      };
    const { stripe: c } = await this.getStripeClient(
      r,
      t
    ), u = new pa(a == null ? void 0 : a.appearance), d = u.shape, p = u.formColors, _ = u.textStyles, g = is.bodyBase[l].fontSize || is.bodyBase.mobile.fontSize;
    let h;
    try {
      h = c.elements({
        mode: n.mode,
        paymentMethodTypes: n.payment_method_types,
        setupFutureUsage: n.setup_future_usage,
        amount: n.amount,
        currency: n.currency,
        loader: "always",
        locale: o,
        appearance: {
          theme: "stripe",
          labels: "floating",
          variables: {
            borderRadius: d["input-border-radius"],
            focusBoxShadow: "none",
            colorDanger: p.error,
            colorTextPlaceholder: p["grey-text-light"],
            colorText: p["grey-text-dark"],
            colorTextSecondary: p["grey-text-light"],
            fontSizeBase: g,
            ...s
          },
          rules: {
            ".Input": {
              boxShadow: "none",
              paddingTop: "6px",
              paddingBottom: "6px",
              fontSize: g,
              border: `1px solid ${p["grey-ui-dark"]}`,
              backgroundColor: p["input-background"],
              color: p["grey-text-dark"]
            },
            ".Input:focus": {
              border: `1px solid ${p.focus}`,
              outline: "none"
            },
            ".Label": {
              fontWeight: _.labelDefault[l].fontWeight,
              lineHeight: "22px",
              color: p["grey-text-dark"]
            },
            ".Label--floating": {
              opacity: "1"
            },
            ".Input--invalid": {
              boxShadow: "none"
            }
          }
        }
      });
    } catch (w) {
      throw this.mapInitializationError(w);
    }
    return { stripe: c, elements: h };
  }
  static async initializeStripeCheckout(r, t, n, a) {
    if (!r || !t || !n)
      throw {
        code: 0,
        gatewayErrorCode: void 0,
        message: "Stripe configuration is missing"
      };
    const { stripe: o } = await this.getStripeClient(
      r,
      t
    );
    let s;
    try {
      s = await o.initEmbeddedCheckout({
        fetchClientSecret: () => Promise.resolve(n.client_secret),
        onComplete: a
      });
    } catch (l) {
      throw this.mapInitializationError(l);
    }
    return { stripe: o, embeddedCheckout: s };
  }
  static updateElementsConfiguration(r, t) {
    r.update({
      mode: t.mode,
      paymentMethodTypes: t.payment_method_types,
      setupFutureUsage: t.setup_future_usage,
      amount: t.amount,
      currency: t.currency
    });
  }
  static isStripeHandledFormError(r) {
    const t = r.type === "validation_error", n = r.type === "card_error" && r.code && this.FORM_VALIDATED_CARD_ERROR_CODES.includes(r.code);
    return t || n;
  }
  static createPaymentElement(r, t) {
    return r.create("payment", {
      business: t ? { name: t } : void 0,
      layout: {
        type: "tabs"
      },
      terms: {
        applePay: "never",
        auBecsDebit: "never",
        bancontact: "never",
        card: "never",
        cashapp: "never",
        googlePay: "never",
        ideal: "never",
        paypal: "never",
        sepaDebit: "never",
        sofort: "never",
        usBankAccount: "never"
      }
    });
  }
  static createExpressCheckoutElement(r, t, n, a) {
    const o = {
      billingAddressRequired: t,
      emailRequired: !0,
      ...n ? {
        paymentMethods: {
          applePay: "always",
          googlePay: "always"
        }
      } : {},
      ...a || {}
    };
    return r.create("expressCheckout", o);
  }
  static createLinkAuthenticationElement(r, t) {
    return r.create("linkAuthentication", {
      defaultValues: {
        email: t ?? ""
      }
    });
  }
  static async submitElements(r) {
    const { error: t } = await r.submit();
    if (t)
      throw this.mapError(t);
  }
  static mapInitializationError(r) {
    return new Zn(
      0,
      r.code,
      r.message
    );
  }
  static mapError(r) {
    return this.isStripeHandledFormError(r) ? new Zn(
      1,
      r.code,
      r.message
    ) : new Zn(
      2,
      r.code,
      r.message
    );
  }
  static async confirmElements(r, t, n, a) {
    const o = {
      clientSecret: n,
      redirect: "if_required"
    }, s = a ? {
      ...o,
      confirmParams: { confirmation_token: a }
    } : {
      ...o,
      elements: t
    }, l = n.startsWith("seti_");
    let c;
    if (l ? c = await r.confirmSetup(s) : c = await r.confirmPayment(s), c != null && c.error)
      throw this.mapError(c.error);
  }
  static async extractTaxCustomerDetails(r, t) {
    var s, l;
    const { error: n, confirmationToken: a } = await t.createConfirmationToken({
      elements: r
    });
    if (n)
      throw this.mapError(n);
    const o = (l = (s = a.payment_method_preview) == null ? void 0 : s.billing_details) == null ? void 0 : l.address;
    return {
      customerDetails: {
        countryCode: (o == null ? void 0 : o.country) ?? void 0,
        postalCode: (o == null ? void 0 : o.postal_code) ?? void 0
      },
      confirmationTokenId: a.id
    };
  }
  static nextDateForPeriod(r, t) {
    return r.unit === ce.Year ? (t.setFullYear(t.getFullYear() + r.number), t) : r.unit === ce.Month ? (t.setMonth(t.getMonth() + r.number), t) : r.unit === ce.Week ? (t.setDate(t.getDate() + r.number * 7), t) : (r.unit === ce.Day && t.setDate(t.getDate() + r.number), t);
  }
  static applePayPeriod(r) {
    return r.unit === ce.Week ? {
      recurringPaymentIntervalUnit: "day",
      recurringPaymentIntervalCount: r.number * 7
    } : {
      recurringPaymentIntervalUnit: r.unit,
      recurringPaymentIntervalCount: r.number
    };
  }
  // https://docs.stripe.com/js/elements_object/create_without_intent#stripe_elements_no_intent-options-amount
  static microsToMinimumAmountPrice(r, t) {
    return [
      "BIF",
      "CLP",
      "DJF",
      "GNF",
      "JPY",
      "KMF",
      "KRW",
      "MGA",
      "PYG",
      "RWF",
      "UGX",
      "VND",
      "VUV",
      "XAF",
      "XOF",
      "XPF"
    ].includes(t) ? Math.floor(r / 1e6) : Math.floor(r / 1e4);
  }
  static buildStripeExpressCheckoutOptionsForSubscription(r, t, n, a, o, s, l, c) {
    var w;
    const u = Lr.microsToMinimumAmountPrice(
      t.totalAmountInMicros,
      t.currency
    ), d = n.trial, p = (w = n.trial) == null ? void 0 : w.period, _ = n.base.period, g = d && p ? Lr.nextDateForPeriod(p, /* @__PURE__ */ new Date()) : void 0, h = _ ? Lr.applePayPeriod(_) : {};
    return {
      layout: {
        maxRows: s,
        maxColumns: l,
        overflow: c
      },
      applePay: {
        recurringPaymentRequest: {
          paymentDescription: r.title,
          managementURL: o,
          trialBilling: d ? {
            label: a.translate($.ApplePayFreeTrial),
            amount: 0
          } : void 0,
          regularBilling: {
            label: r.title,
            amount: u,
            recurringPaymentStartDate: g,
            ...h
          }
        }
      }
    };
  }
};
/* eslint-disable @typescript-eslint/consistent-type-imports */
V(Lr, "stripeModulePromise", null), V(Lr, "FORM_VALIDATED_CARD_ERROR_CODES", [
  "card_declined",
  "expired_card",
  "incorrect_cvc",
  "incorrect_number"
]);
let Ve = Lr;
var Cb = /* @__PURE__ */ B("<div></div>");
function Db(e, r) {
  ee(r, !0);
  let t = null;
  const n = "payment-element", a = async (s) => {
    await r.onError(Ve.mapInitializationError(s.error));
  };
  nr(() => {
    var s;
    try {
      t = Ve.createPaymentElement(r.elements, (s = r.brandingInfo) == null ? void 0 : s.app_name), t.mount(`#${n}`), t.on("ready", r.onReady), t.on("change", r.onChange), t.on("loaderror", a);
    } catch (l) {
      r.onError(Ve.mapInitializationError(l));
    }
  }), Ot(() => {
    t == null || t.destroy(), t = null;
  });
  var o = Cb();
  se(o, "id", n), T(e, o), re();
}
var Ab = /* @__PURE__ */ B("<div></div>");
function qb(e, r) {
  ee(r, !0);
  let t = null;
  const n = "link-authentication-element", a = async (s) => {
    await r.onError(Ve.mapInitializationError(s.error));
  };
  nr(() => {
    try {
      t = Ve.createLinkAuthenticationElement(r.elements, r.email), t.mount(`#${n}`), t.on("ready", r.onReady), t.on("change", r.onChange), t.on("loaderror", a);
    } catch (s) {
      r.onError(Ve.mapInitializationError(s));
    }
  }), Ot(() => {
    t == null || t.destroy(), t = null;
  });
  var o = Ab();
  se(o, "id", n), T(e, o), re();
}
var Fb = /* @__PURE__ */ B('<div class="text-separator svelte-3efq78"><hr class="line svelte-3efq78"/> <span class="text svelte-3efq78"><!></span> <hr class="line svelte-3efq78"/></div>');
const zb = {
  hash: "svelte-3efq78",
  code: `.text-separator.svelte-3efq78 {display:flex;align-items:center;justify-content:center;gap:var(--rc-spacing-gapSmall-mobile);}

  @container layout-query-container (width >= 768px) {.text-separator.svelte-3efq78 {gap:var(--rc-spacing-gapSmall-desktop);}
  }.line.svelte-3efq78 {flex:1;height:1px;background-color:var(--rc-color-grey-ui-dark);border:none;}.text.svelte-3efq78 {color:var(--rc-color-grey-text-light);text-transform:uppercase;white-space:nowrap;}`
};
function Mb(e, r) {
  oe(e, zb);
  let t = K(r, "text", 8);
  var n = Fb(), a = R(z(n), 2), o = z(a);
  ye(o, {
    size: "caption-default",
    children: (s, l) => {
      var c = Ee();
      U(() => pe(c, t())), T(s, c);
    },
    $$slots: { default: !0 }
  }), T(e, n);
}
var Ob = /* @__PURE__ */ B("<div></div> <!>", 1);
function Nd(e, r) {
  ee(r, !0);
  const t = () => fe(s, "$translator", n), [n, a] = Ae(), o = K(r, "hideCheckoutSeparator", 3, !1), s = Le(dr);
  let l = null, c = /* @__PURE__ */ X(!1);
  const u = `express-checkout-element-${(/* @__PURE__ */ new Date()).getTime()}`, d = async () => {
    r.onCancel && r.onCancel();
  }, p = async (y) => {
    const k = {
      ...r.expressCheckoutOptions ? r.expressCheckoutOptions : {}
    };
    r.onClick && r.onClick(y), y.resolve(k);
  }, _ = async (y) => {
    await r.onError(Ve.mapInitializationError(y.error));
  }, g = async (y) => {
    var k;
    return r.onSubmit(y.expressPaymentType, ((k = y.billingDetails) == null ? void 0 : k.email) ?? "", y);
  }, h = async (y) => {
    L(c, !y.availablePaymentMethods), r.onReady && r.onReady(y);
  };
  nr(() => {
    try {
      l = Ve.createExpressCheckoutElement(r.elements, r.billingAddressRequired, r.forceEnableWalletMethods, r.expressCheckoutOptions), l.mount(`#${u}`), l.on("ready", h), l.on("confirm", g), l.on("loaderror", _), l.on("click", p), l.on("cancel", d);
    } catch (y) {
      r.onError(Ve.mapInitializationError(y));
    }
  }), Ot(() => {
    l == null || l.destroy(), l = null;
  });
  var w = _e(), v = J(w);
  {
    var f = (y) => {
      var k = Ob(), m = J(k), S = R(m, 2);
      {
        var x = (P) => {
          {
            let I = /* @__PURE__ */ b(() => t().translate($.PaymentEntryPageExpressCheckoutDivider));
            Mb(P, {
              get text() {
                return i(I);
              }
            });
          }
        };
        W(S, (P) => {
          o() || P(x);
        });
      }
      U(() => se(m, "id", u)), T(y, k);
    };
    W(v, (y) => {
      i(c) || y(f);
    });
  }
  T(e, w), re(), a();
}
var jb = /* @__PURE__ */ B('<div class="rc-elements svelte-kvz7kd"><!> <!> <!></div>');
const Nb = {
  hash: "svelte-kvz7kd",
  code: `.rc-elements.svelte-kvz7kd {display:flex;flex-direction:column;gap:var(--rc-spacing-gapXLarge-mobile);}

  @container layout-query-container (width >= 768px) {.rc-elements.svelte-kvz7kd {gap:var(--rc-spacing-gapLarge-desktop);}
  }`
};
function Lb(e, r) {
  ee(r, !0), oe(e, Nb);
  const t = () => fe(l, "$translator", n), [n, a] = Ae();
  let o = K(r, "stripe", 15, null), s = K(r, "elements", 15, null);
  const l = Le(dr), c = Ve.getStripeLocale(t().bcp47Locale || t().fallbackBcp47Locale);
  let u = /* @__PURE__ */ X(!1), d = /* @__PURE__ */ X(Xe(r.skipEmail)), p = /* @__PURE__ */ X(!1), _ = /* @__PURE__ */ X(void 0), g = /* @__PURE__ */ X("mobile"), h = /* @__PURE__ */ X(void 0);
  function w() {
    window.matchMedia && window.matchMedia("(max-width: 767px)").matches ? L(g, "mobile") : L(g, "desktop"), L(
      _,
      {
        // Floating labels size cannot be overriden in Stripe since `!important` is being used.
        // There we set fontSizeBase to the desired label size
        // and update the input font size to 16px.
        fontSizeBase: "14px",
        fontFamily: La,
        // Spacing is hardcoded to 16px to match the desired gaps in mobile/desktop
        // which do not match the design system spacing. Also we cannot use "rem" units
        // since the fontSizeBase is set to 14px per the comment above.
        spacingGridRow: "16px"
      },
      !0
    );
  }
  function v() {
    clearTimeout(i(h)), L(
      h,
      setTimeout(
        () => {
          w();
        },
        150
      ),
      !0
    );
  }
  const f = (D) => {
    r.onError(D), r.onLoadingComplete();
  }, y = async () => {
    i(d) || (L(d, !0), i(d) && i(u) && i(p) && r.onLoadingComplete());
  }, k = async () => {
    i(p) || (L(p, !0), i(d) && i(u) && i(p) && r.onLoadingComplete());
  }, m = async () => {
    i(u) || (L(u, !0), i(d) && i(u) && i(p) && r.onLoadingComplete());
  }, S = async (D) => {
    r.onPaymentInfoChange({
      complete: D.complete,
      paymentMethod: D.complete ? D.value.type : void 0
    });
  }, x = async (D) => {
    r.onEmailChange(D.complete, D.value.email);
  };
  nr(() => (window.addEventListener("resize", v), () => {
    window.removeEventListener("resize", v);
  })), nr(async () => {
    w(), !o() && (s() || !r.stripeAccountId || !r.publishableApiKey || !r.elementsConfiguration || await Ve.initializeStripe(r.stripeAccountId, r.publishableApiKey, r.elementsConfiguration, r.brandingInfo, c, i(_), i(g)).then(({ stripe: D, elements: F }) => {
      o(D), s(F);
    }).catch((D) => {
      r.onError(D);
    }));
  }), kr(() => {
    r.elementsConfiguration && s() && Ve.updateElementsConfiguration(s(), r.elementsConfiguration);
  });
  var P = _e(), I = J(P);
  {
    var E = (D) => {
      var F = jb(), M = z(F);
      Nd(M, {
        get elements() {
          return s();
        },
        onError: f,
        onReady: k,
        get onSubmit() {
          return r.onExpressCheckoutElementSubmit;
        },
        get expressCheckoutOptions() {
          return r.expressCheckoutOptions;
        },
        get forceEnableWalletMethods() {
          return r.forceEnableWalletMethods;
        },
        get billingAddressRequired() {
          return r.billingAddressRequired;
        }
      });
      var C = R(M, 2);
      {
        var j = (A) => {
          qb(A, {
            get elements() {
              return s();
            },
            onReady: y,
            onChange: x,
            onError: f
          });
        };
        W(C, (A) => {
          r.skipEmail || A(j);
        });
      }
      var H = R(C, 2);
      Db(H, {
        get elements() {
          return s();
        },
        get brandingInfo() {
          return r.brandingInfo;
        },
        onReady: m,
        onChange: S,
        onError: f
      }), T(D, F);
    };
    W(I, (D) => {
      s() && D(E);
    });
  }
  T(e, P), re(), a();
}
const Bb = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
  <path fill-rule="evenodd" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 6.5a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm1.25 4.5a1.25 1.25 0 10-2.5 0v4.5a1.25 1.25 0 102.5 0v-4.5z" clip-rule="evenodd" />
</svg> `;
var Ub = /* @__PURE__ */ B('<div class="rcb-ui-asset-icon svelte-a15aei"><!></div>');
const Rb = {
  hash: "svelte-a15aei",
  code: ".rcb-ui-asset-icon.svelte-a15aei {display:inline-block;width:1em;height:1em;}"
};
function Ld(e) {
  oe(e, Rb);
  var r = Ub(), t = z(r);
  dn(t, () => Bb), T(e, r);
}
var Vb = /* @__PURE__ */ B('<div class="rcb-info svelte-jea5iu"><div class="rcb-info-icon-wrapper svelte-jea5iu"><!></div> <div class="rcb-info-content svelte-jea5iu"><div class="rcb-info-title svelte-jea5iu"><!></div> <div class="rcb-info-message svelte-jea5iu"><!></div></div></div>');
const Hb = {
  hash: "svelte-jea5iu",
  code: `.rcb-info.svelte-jea5iu {display:flex;align-items:flex-start;background-color:var(--rc-color-grey-ui-light);border-radius:var(--rc-shape-input-border-radius);gap:var(--rc-spacing-gapLarge-mobile);padding:var(--rc-spacing-gapLarge-mobile);}.rcb-info-content.svelte-jea5iu {flex:1;}.rcb-info-icon-wrapper.svelte-jea5iu {flex-shrink:0;color:var(--rc-color-accent-primary);}.rcb-info-title.svelte-jea5iu {color:var(--rc-color-grey-text-dark);margin-bottom:var(--rc-spacing-gapSmall-mobile);display:flex;}.rcb-info-message.svelte-jea5iu {color:var(--rc-color-grey-text-light);}

  @container layout-query-container (width >= 768px) {.rcb-info.svelte-jea5iu {gap:var(--rc-spacing-gapLarge-desktop);padding:var(--rc-spacing-gapLarge-desktop);}.rcb-info-title.svelte-jea5iu {margin-bottom:var(--rc-spacing-gapSmall-desktop);}
  }`
};
function Wb(e, r) {
  oe(e, Hb);
  var t = Vb(), n = z(t), a = z(n);
  Ld(a);
  var o = R(n, 2), s = z(o), l = z(s);
  ye(l, {
    size: "body-small",
    children: (d, p) => {
      var _ = Ee();
      U(() => pe(_, r.title)), T(d, _);
    },
    $$slots: { default: !0 }
  });
  var c = R(s, 2), u = z(c);
  ye(u, {
    size: "body-small",
    children: (d, p) => {
      var _ = Ee();
      U(() => pe(_, r.message)), T(d, _);
    },
    $$slots: { default: !0 }
  }), T(e, t);
}
function Yb(e, r) {
  ee(r, !0);
  const t = () => fe(o, "$translator", n), [n, a] = Ae(), o = Le(dr);
  {
    let s = /* @__PURE__ */ b(() => t().translate($.PriceUpdateTitle)), l = /* @__PURE__ */ b(() => {
      var c;
      return t().translate((c = r.subscriptionOption) != null && c.trial ? $.PriceUpdateTrialMessage : $.PriceUpdateBaseMessage);
    });
    Wb(e, {
      get title() {
        return i(s);
      },
      get message() {
        return i(l);
      }
    });
  }
  re(), a();
}
function Qs(e, r) {
  var n, a, o;
  if (e.productType === "subscription") {
    const s = r, l = ((n = s.discount) == null ? void 0 : n.price) ?? ((a = s.introPrice) == null ? void 0 : a.price) ?? s.base.price;
    if (l)
      return l;
  } else {
    const s = r;
    return ((o = s.discount) == null ? void 0 : o.price) ?? s.basePrice;
  }
  return e.price;
}
class Ec extends Error {
}
var Gb = /* @__PURE__ */ B('<div class="rc-loading svelte-zfhfge"><!></div>'), Kb = /* @__PURE__ */ B('<div class="rc-checkout-container svelte-zfhfge"><!> <!> <form data-testid="payment-form" class="rc-checkout-form svelte-zfhfge"><div><div class="rc-elements-container svelte-zfhfge"><!></div> <div><!></div> <div><!> <div class="rc-checkout-secure-container svelte-zfhfge"><!></div></div></div></form></div>');
const Xb = {
  hash: "svelte-zfhfge",
  code: `.rc-checkout-secure-container.svelte-zfhfge {margin-top:var(--rc-spacing-gapXLarge-mobile);}.rc-checkout-container.svelte-zfhfge {display:flex;flex-direction:column;gap:var(--rc-spacing-gapXLarge-mobile);user-select:none;position:relative;}.rc-checkout-price-update-info-container.svelte-zfhfge {margin-top:var(--rc-spacing-gapXLarge-mobile);}.fully-hidden.svelte-zfhfge {display:none;height:0;}.rc-checkout-pay-container.svelte-zfhfge {display:flex;flex-direction:column;margin-top:var(--rc-spacing-gapXLarge-mobile);}.rc-checkout-pay-container.fully-hidden.svelte-zfhfge {display:none;}.rc-checkout-form-container.svelte-zfhfge {width:100%;}.rc-elements-container.svelte-zfhfge {
    /* The standard height of the payment form from Stripe */
    /* Added to avoid the card getting smaller while loading */min-height:210px;}.rc-checkout-form-container.invisible.svelte-zfhfge {visibility:hidden;}.rc-loading.svelte-zfhfge {width:100%;height:100%;display:flex;justify-content:center;align-items:center;}

  @container layout-query-container (width <= 767px) {.rc-checkout-pay-container.svelte-zfhfge {flex-grow:1;justify-content:flex-end;}.rc-checkout-form.svelte-zfhfge {flex-grow:1;}.rc-checkout-form-container.svelte-zfhfge {height:100%;display:flex;flex-direction:column;}.rc-checkout-container.svelte-zfhfge {flex-grow:1;}.rc-loading.svelte-zfhfge {position:absolute;top:0;left:0;}
  }

  @container layout-query-container (width >= 768px) {.rc-checkout-secure-container.svelte-zfhfge {margin-top:var(--rc-spacing-gapXLarge-desktop);}.rc-checkout-container.svelte-zfhfge {gap:var(--rc-spacing-gapXLarge-desktop);}.rc-checkout-pay-container.svelte-zfhfge {margin-top:var(--rc-spacing-gapXLarge-desktop);}.rc-checkout-price-update-info-container.svelte-zfhfge {margin-top:var(--rc-spacing-gapXLarge-desktop);}
  }form.svelte-zfhfge {display:flex;flex-direction:column;flex-grow:1;}`
};
function $b(e, r) {
  var jn, sl, ll;
  ee(r, !0), oe(e, Xb);
  const t = () => fe(s, "$translator", n), [n, a] = Ae(), o = Le(no), s = Le(dr), l = (jn = r.productDetails.subscriptionOptions) == null ? void 0 : jn[r.purchaseOption.id], c = Qs(r.productDetails, r.purchaseOption);
  let u = /* @__PURE__ */ X(Xe(((sl = r.defaultPriceBreakdown) == null ? void 0 : sl.taxCalculationStatus) ?? ((ll = r.brandingInfo) != null && ll.gateway_tax_collection_enabled ? "unavailable" : "disabled"))), d = /* @__PURE__ */ X(null), p = /* @__PURE__ */ X(null), _ = /* @__PURE__ */ X(Xe(c.amountMicros)), g = /* @__PURE__ */ X(Xe(c.amountMicros)), h = /* @__PURE__ */ b(() => r.defaultPriceBreakdown ?? {
    currency: c.currency,
    totalAmountInMicros: i(g),
    totalExcludingTaxInMicros: i(_),
    taxCalculationStatus: i(u),
    taxAmountInMicros: i(d),
    taxBreakdown: i(p)
  }), w = /* @__PURE__ */ X(Xe(r.gatewayParams.elements_configuration)), v = /* @__PURE__ */ X(null), f = /* @__PURE__ */ X(null), y = /* @__PURE__ */ X(null), k = /* @__PURE__ */ X(Xe(r.customerEmail ?? void 0)), m = /* @__PURE__ */ X(Xe(!!r.customerEmail)), S = /* @__PURE__ */ X(!0), x = /* @__PURE__ */ X(!1), P = /* @__PURE__ */ X(void 0), I = /* @__PURE__ */ X(void 0), E = /* @__PURE__ */ X(void 0), D = /* @__PURE__ */ X(!1), F = /* @__PURE__ */ X(null), M = /* @__PURE__ */ b(() => i(S) || i(D) ? "loading" : i(I) ? "error" : "form"), C = /* @__PURE__ */ X("unavailable"), j = /* @__PURE__ */ b(() => !i(D) && i(x) && i(m) && (i(u) === "disabled" || i(u) === "calculated" || i(u) === "miss-match")), H = /* @__PURE__ */ b(() => l && r.managementUrl && i(h) ? Ve.buildStripeExpressCheckoutOptionsForSubscription(r.productDetails, i(h), l, t(), r.managementUrl) : void 0);
  kr(() => {
    r.onPriceBreakdownUpdated(i(h));
  }), nr(async () => {
    i(u) === "unavailable" && await A(null).catch(ve);
  }), Ot(() => {
    i(F) && (i(F).abort(), L(F, null));
  });
  async function A(Z, Se) {
    await r.purchaseOperationHelper.checkoutCalculateTax(Z == null ? void 0 : Z.countryCode, Z == null ? void 0 : Z.postalCode, Se).then((Fe) => {
      const Xt = Ad({ taxCalculation: Fe, taxCustomerDetails: Z });
      o.trackSDKEvent(Xt), Se == null || Se.throwIfAborted(), Fe.failed_reason ? !Z && Fe.failed_reason === Ks.invalid_tax_location ? L(u, "pending") : L(u, "disabled") : L(u, "calculated"), L(d, Fe.tax_amount_in_micros, !0), L(_, Fe.total_excluding_tax_in_micros, !0), L(g, Fe.total_amount_in_micros, !0), L(p, Fe.tax_breakdown, !0), L(w, Fe.gateway_params.elements_configuration, !0), L(v, Z, !0);
    });
  }
  function q() {
    o.trackSDKEvent({
      eventName: Mr.CheckoutPaymentFormImpression,
      properties: { mode: Dr }
    }), L(S, !1);
  }
  async function O(Z, Se) {
    L(k, Se, !0), L(m, Z, !0), await le();
  }
  async function G({ complete: Z, paymentMethod: Se }) {
    L(P, Se, !0), L(x, Z, !0), await le();
  }
  async function Y(Z) {
    if (Z == null || Z.preventDefault(), i(D)) return;
    const Se = qd({ selectedPaymentMethod: i(P) ?? null });
    o.trackSDKEvent(Se), L(D, !0), await be() ? r.onContinue() : L(D, !1);
  }
  async function te(Z, Se) {
    L(P, Z, !0), L(k, r.customerEmail ?? Se, !0), await Y();
  }
  async function le() {
    i(P) !== "card" || !i(m) || !i(x) || i(D) || i(u) === "disabled" || (i(u) !== "loading" && (L(C, i(u), !0), L(u, "loading")), await ge(async (Z) => {
      await xe().then(() => Z.throwIfAborted()).then(() => de(Z)).then(() => Z.throwIfAborted()).catch((Se) => {
        Z.aborted || ve(Se);
      }).finally(() => {
        i(u) === "loading" && !Z.aborted && L(u, i(C), !0);
      });
    }));
  }
  async function be() {
    return await ge(async (Z) => {
      const Se = i(g);
      let Fe;
      return await xe().then(() => Z.throwIfAborted()).then(() => de(Z)).then((Xt) => {
        Fe = Xt;
      }).then(() => Z.throwIfAborted()).then(ue(Se)).then(() => Z.throwIfAborted()).then(Ie).then(() => Z.throwIfAborted()).then(() => De(Fe)).then(() => Z.throwIfAborted()).then(() => !0).catch((Xt) => (Z.aborted || ve(Xt), !1));
    });
  }
  async function ge(Z) {
    i(F) && i(F).abort(), L(F, new AbortController(), !0);
    const Se = i(F).signal;
    try {
      return await Z(Se);
    } catch (Fe) {
      if (Fe instanceof DOMException && Fe.name === "AbortError")
        return Promise.resolve(void 0);
      throw Fe;
    }
  }
  async function xe() {
    i(y) && await Ve.submitElements(i(y));
  }
  async function de(Z) {
    var gn, ka;
    if (i(u) === "unavailable" || i(u) === "disabled" || !i(y) || !i(f))
      return;
    const {
      customerDetails: Se,
      confirmationTokenId: Fe
    } = await Ve.extractTaxCustomerDetails(i(y), i(f));
    return Z == null || Z.throwIfAborted(), Se.postalCode === ((gn = i(v)) == null ? void 0 : gn.postalCode) && Se.countryCode === ((ka = i(v)) == null ? void 0 : ka.countryCode) || await A(Se, Z), Fe && i(P) !== "card" ? Fe : void 0;
  }
  function ue(Z) {
    return () => {
      if (i(g) !== Z)
        throw new Ec();
    };
  }
  async function Ie() {
    var Fe;
    const Z = await r.purchaseOperationHelper.checkoutComplete(i(k)), Se = (Fe = Z == null ? void 0 : Z.gateway_params) == null ? void 0 : Fe.client_secret;
    Se && L(E, Se, !0);
  }
  async function De(Z) {
    !i(f) || !i(y) || !i(E) || await Ve.confirmElements(i(f), i(y), i(E), Z);
  }
  async function ve(Z) {
    if (Z instanceof Ec)
      L(u, "miss-match");
    else if (Z instanceof ae) {
      const Se = Qy({
        errorCode: Z.errorCode.toString(),
        errorMessage: Z.message
      });
      o.trackSDKEvent(Se), Z.errorCode === Q.MissingEmailError ? L(I, t().translate($.ErrorPageErrorMessageInvalidEmailError, { email: i(k) }), !0) : r.onError(Z);
    } else if (Z instanceof Zn)
      await Te(Z);
    else
      throw Z;
  }
  async function Te(Z) {
    const Se = os({
      errorCode: Z.gatewayErrorCode ?? "",
      errorMessage: Z.message ?? ""
    });
    o.trackSDKEvent(Se), Z.code === ss.HandledFormError || (Z.code === ss.UnhandledFormError ? L(I, Z.message, !0) : r.onError(new ae(Q.ErrorSettingUpPurchase, "Failed to initialize payment form", Z.message)));
  }
  const ir = () => {
    L(I, void 0);
  };
  var Je = Kb(), me = z(Je);
  {
    var Oe = (Z) => {
      var Se = Gb(), Fe = z(Se);
      Fd(Fe), T(Z, Se);
    };
    W(me, (Z) => {
      i(M) === "loading" && Z(Oe);
    });
  }
  var Ar = R(me, 2);
  {
    var ie = (Z) => {
      {
        const Se = (gn) => {
          $u(gn);
        }, Fe = (gn) => {
          var ka = Ee();
          U(() => pe(ka, i(I))), T(gn, ka);
        };
        let Xt = /* @__PURE__ */ b(() => t().translate($.ErrorButtonTryAgain));
        Gs(Z, {
          title: null,
          type: "error",
          get closeButtonTitle() {
            return i(Xt);
          },
          onDismiss: ir,
          icon: Se,
          message: Fe,
          $$slots: { icon: !0, message: !0 }
        });
      }
    };
    W(Ar, (Z) => {
      i(M) === "error" && Z(ie);
    });
  }
  var Ne = R(Ar, 2), Ke = z(Ne);
  let Sr;
  var Yr = z(Ke), Kt = z(Yr);
  {
    let Z = /* @__PURE__ */ b(() => !!r.customerEmail), Se = /* @__PURE__ */ b(() => i(u) !== "disabled");
    Lb(Kt, {
      get stripeAccountId() {
        return r.gatewayParams.stripe_account_id;
      },
      get publishableApiKey() {
        return r.gatewayParams.publishable_api_key;
      },
      get elementsConfiguration() {
        return i(w);
      },
      get brandingInfo() {
        return r.brandingInfo;
      },
      get forceEnableWalletMethods() {
        return r.forceEnableWalletMethods;
      },
      get skipEmail() {
        return i(Z);
      },
      get billingAddressRequired() {
        return i(Se);
      },
      onLoadingComplete: q,
      onError: Te,
      onEmailChange: O,
      onPaymentInfoChange: G,
      onExpressCheckoutElementSubmit: te,
      get expressCheckoutOptions() {
        return i(H);
      },
      get stripe() {
        return i(f);
      },
      set stripe(Fe) {
        L(f, Fe, !0);
      },
      get elements() {
        return i(y);
      },
      set elements(Fe) {
        L(y, Fe, !0);
      }
    });
  }
  var ot = R(Yr, 2);
  let On;
  var he = z(ot);
  Yb(he, {
    get subscriptionOption() {
      return l;
    }
  });
  var qe = R(ot, 2);
  let xr;
  var Gr = z(qe);
  {
    let Z = /* @__PURE__ */ b(() => !i(j)), Se = /* @__PURE__ */ b(() => {
      var Fe;
      return (Fe = r.brandingInfo) != null && Fe.gateway_tax_collection_enabled ? i(h) : void 0;
    });
    sb(Gr, {
      get disabled() {
        return i(Z);
      },
      get subscriptionOption() {
        return l;
      },
      get priceBreakdown() {
        return i(Se);
      }
    });
  }
  var _n = R(Gr, 2), Or = z(_n);
  Zy(Or, {
    get brandingInfo() {
      return r.brandingInfo;
    },
    get purchaseOption() {
      return r.purchaseOption;
    },
    get termsAndConditionsUrl() {
      return r.termsAndConditionsUrl;
    }
  }), U(() => {
    Sr = tr(Ke, 1, "rc-checkout-form-container svelte-zfhfge", null, Sr, { invisible: i(M) !== "form" }), On = tr(ot, 1, "rc-checkout-price-update-info-container svelte-zfhfge", null, On, {
      "fully-hidden": i(u) !== "miss-match" || i(M) !== "form"
    }), xr = tr(qe, 1, "rc-checkout-pay-container svelte-zfhfge", null, xr, { "fully-hidden": i(M) !== "form" });
  }), Vr("submit", Ne, Y), T(e, Je), re(), a();
}
function Zb(e) {
  return e != null;
}
var Jb = /* @__PURE__ */ ((e) => (e.Unknown = "unknown", e.Custom = "custom", e.Lifetime = "$rc_lifetime", e.Annual = "$rc_annual", e.SixMonth = "$rc_six_month", e.ThreeMonth = "$rc_three_month", e.TwoMonth = "$rc_two_month", e.Monthly = "$rc_monthly", e.Weekly = "$rc_weekly", e))(Jb || {}), ut = /* @__PURE__ */ ((e) => (e.Subscription = "subscription", e.Consumable = "consumable", e.NonConsumable = "non_consumable", e))(ut || {});
const ls = (e, r) => ({
  amount: e / 1e4,
  amountMicros: e,
  currency: r,
  formattedPrice: on(e, r)
}), Bd = (e) => ls(e.amount_micros, e.currency), Mi = (e) => {
  const r = e.period_duration, t = e.price ? Bd(e.price) : null, n = r ? Ns(r) : null;
  let a = null, o = null, s = null;
  if (t !== null && n !== null) {
    const l = Qb(n), c = 1e4, u = vo(
      t.amountMicros * l.toWeek,
      t.currency
    );
    a = {
      amount: u / c,
      amountMicros: u,
      currency: t.currency,
      formattedPrice: on(u, t.currency)
    };
    const d = vo(
      t.amountMicros * l.toMonth,
      t.currency
    );
    o = {
      amount: d / c,
      amountMicros: d,
      currency: t.currency,
      formattedPrice: on(d, t.currency)
    };
    const p = vo(
      t.amountMicros * l.toYear,
      t.currency
    );
    s = {
      amount: p / c,
      amountMicros: p,
      currency: t.currency,
      formattedPrice: on(p, t.currency)
    };
  }
  return {
    periodDuration: r,
    period: n,
    cycleCount: e.cycle_count,
    price: t,
    pricePerWeek: a,
    pricePerMonth: o,
    pricePerYear: s
  };
}, Ud = (e, r) => {
  const t = e.duration_mode ?? "one_time";
  let n = e.time_window ?? null;
  (t === "one_time" || t === "forever") && n === null && r !== null && (n = r);
  let a = null, o = null;
  const s = n ? Ns(n) : null;
  return s && (a = { number: 1, unit: s.unit }, o = t === "forever" ? 0 : s.number), {
    timeWindow: e.time_window,
    durationMode: t,
    price: ls(e.amount_micros, e.currency),
    name: e.name,
    period: a,
    cycleCount: o ?? 0,
    periodDuration: n,
    discountType: e.discount_type,
    percentage: e.percentage ?? null,
    fixedAmount: e.fixed_amount_micros != null ? ls(
      e.fixed_amount_micros,
      e.currency
    ) : null
  };
};
function Qb(e) {
  const { number: r, unit: t } = e, n = 7, a = 30, o = 365;
  let s;
  switch (t) {
    case ce.Day:
      s = r;
      break;
    case ce.Week:
      s = r * n;
      break;
    case ce.Month:
      s = r * a;
      break;
    case ce.Year:
      s = r * o;
      break;
    default:
      s = 0, ne.errorLog(`Unknown period unit: ${t}`);
  }
  const l = s > 0 ? n / s : 0, c = s > 0 ? a / s : 0, u = s > 0 ? o / s : 0;
  return { toWeek: l, toMonth: c, toYear: u };
}
const ev = (e) => {
  var r;
  return e.base == null ? (ne.debugLog("Missing base phase for subscription option. Ignoring."), null) : {
    id: e.id,
    priceId: e.price_id,
    base: Mi(e.base),
    trial: e.trial ? Mi(e.trial) : null,
    introPrice: e.intro_price ? Mi(e.intro_price) : null,
    discount: e.discount ? Ud(e.discount, (r = e.base) == null ? void 0 : r.period_duration) : null
  };
}, rv = (e) => e.base_price == null ? (ne.debugLog(
  "Missing base price for non-subscription option. Ignoring."
), null) : {
  id: e.id,
  priceId: e.price_id,
  basePrice: Bd(e.base_price),
  discount: e.discount ? Ud(e.discount, null) : null
}, tv = (e, r) => {
  const t = e.product_type;
  return t === "subscription" ? av(
    e,
    r,
    t
  ) : nv(
    e,
    r,
    t
  );
}, nv = (e, r, t) => {
  const n = {};
  if (Object.entries(e.purchase_options).forEach(
    ([s, l]) => {
      const c = rv(
        l
      );
      c != null && (n[s] = c);
    }
  ), Object.keys(n).length === 0)
    return ne.debugLog(
      `Product ${e.identifier} has no purchase options. Ignoring.`
    ), null;
  const a = e.default_purchase_option_id, o = a && a in e.purchase_options ? n[a] : null;
  return o == null ? (ne.debugLog(
    `Product ${e.identifier} has no default purchase option. Ignoring.`
  ), null) : {
    identifier: e.identifier,
    displayName: e.title,
    title: e.title,
    description: e.description,
    productType: t,
    currentPrice: o.basePrice,
    normalPeriodDuration: null,
    presentedOfferingIdentifier: r.offeringIdentifier,
    presentedOfferingContext: r,
    defaultPurchaseOption: o,
    defaultSubscriptionOption: null,
    subscriptionOptions: {},
    defaultNonSubscriptionOption: o,
    price: o.basePrice,
    period: null,
    freeTrialPhase: null,
    introPricePhase: null,
    discountPhase: o.discount
  };
}, av = (e, r, t) => {
  const n = {};
  if (Object.entries(e.purchase_options).forEach(
    ([l, c]) => {
      const u = ev(c);
      u != null && (n[l] = u);
    }
  ), Object.keys(n).length === 0)
    return ne.debugLog(
      `Product ${e.identifier} has no subscription options. Ignoring.`
    ), null;
  const a = e.default_purchase_option_id, o = a && a in n ? n[a] : null;
  if (o == null)
    return ne.debugLog(
      `Product ${e.identifier} has no default subscription option. Ignoring.`
    ), null;
  const s = o.base.price;
  return s == null ? (ne.debugLog(
    `Product ${e.identifier} default option has no base price. Ignoring.`
  ), null) : {
    identifier: e.identifier,
    displayName: e.title,
    title: e.title,
    description: e.description,
    productType: t,
    currentPrice: s,
    normalPeriodDuration: o.base.periodDuration,
    presentedOfferingIdentifier: r.offeringIdentifier,
    presentedOfferingContext: r,
    defaultPurchaseOption: o,
    defaultSubscriptionOption: o,
    subscriptionOptions: n,
    defaultNonSubscriptionOption: null,
    price: s,
    period: o.base.period,
    freeTrialPhase: o.trial,
    introPricePhase: o.introPrice,
    discountPhase: o.discount
  };
}, ov = (e, r, t) => {
  const n = t[r.platform_product_identifier];
  if (n === void 0) return null;
  const a = tv(n, e);
  return a === null ? null : {
    identifier: r.identifier,
    rcBillingProduct: a,
    webBillingProduct: a,
    packageType: sv(r.identifier)
  };
}, iv = (e, r, t, n, a) => {
  const o = {
    offeringIdentifier: r.identifier,
    targetingContext: e && n ? {
      ruleId: n.rule_id,
      revision: n.revision
    } : null,
    placementIdentifier: null
  }, s = r.packages.map(
    (c) => ov(o, c, t)
  ).filter(Zb), l = {};
  for (const c of s)
    c != null && (l[c.identifier] = c);
  return s.length == 0 ? null : {
    identifier: r.identifier,
    serverDescription: r.description,
    metadata: r.metadata,
    packagesById: l,
    availablePackages: s,
    lifetime: l.$rc_lifetime ?? null,
    annual: l.$rc_annual ?? null,
    sixMonth: l.$rc_six_month ?? null,
    threeMonth: l.$rc_three_month ?? null,
    twoMonth: l.$rc_two_month ?? null,
    monthly: l.$rc_monthly ?? null,
    weekly: l.$rc_weekly ?? null,
    paywallComponents: r.paywall_components,
    uiConfig: a
  };
};
function sv(e) {
  switch (e) {
    case "$rc_lifetime":
      return "$rc_lifetime";
    case "$rc_annual":
      return "$rc_annual";
    case "$rc_six_month":
      return "$rc_six_month";
    case "$rc_three_month":
      return "$rc_three_month";
    case "$rc_two_month":
      return "$rc_two_month";
    case "$rc_monthly":
      return "$rc_monthly";
    case "$rc_weekly":
      return "$rc_weekly";
    default:
      return e.startsWith("$rc_") ? "unknown" : "custom";
  }
}
var lv = /* @__PURE__ */ or('<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.94 5.72656L8 8.7799L11.06 5.72656L12 6.66656L8 10.6666L4 6.66656L4.94 5.72656Z" class="arrow-fill svelte-1eerlbf" fill-opacity="0.7"></path></svg>');
const cv = {
  hash: "svelte-1eerlbf",
  code: ".arrow.svelte-1eerlbf {transition:transform 0.3s ease;}.arrow-fill.svelte-1eerlbf {fill:var(--rc-color-grey-text-dark);}.arrow.left.svelte-1eerlbf {transform:rotate(90deg);}.arrow.up.svelte-1eerlbf {transform:rotate(180deg);}.arrow.right.svelte-1eerlbf {transform:rotate(-90deg);}.arrow.down.svelte-1eerlbf {transform:rotate(0deg);}"
};
function go(e, r) {
  oe(e, cv);
  let t = K(r, "direction", 8);
  var n = lv();
  U(() => tr(n, 0, `arrow ${t() ?? ""}`, "svelte-1eerlbf")), T(e, n);
}
var uv = /* @__PURE__ */ or('<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow"><path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" class="arrow-fill svelte-159d2rl" fill-opacity="0.7"></path></svg>');
const dv = {
  hash: "svelte-159d2rl",
  code: ".arrow-fill.svelte-159d2rl {fill:var(--rc-color-grey-text-dark);}"
};
function pv(e) {
  oe(e, dv);
  var r = uv();
  T(e, r);
}
const _v = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
     xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.5" clip-path="url(#clip0_344_3390)">
        <path d="M7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM1 2V4H3L6.6 11.59L5.25 14.04C5.09 14.32 5 14.65 5 15C5 16.1 5.9 17 7 17H19V15H7.42C7.28 15 7.17 14.89 7.17 14.75L7.2 14.63L8.1 13H15.55C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C20.96 5.34 21 5.17 21 5C21 4.45 20.55 4 20 4H5.21L4.27 2H1ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z"
              fill="currentColor"/>
    </g>
    <defs>
        <clipPath id="clip0_344_3390">
            <rect width="24" height="24" fill="currentColor"/>
        </clipPath>
    </defs>
</svg>
`;
var gv = /* @__PURE__ */ B('<div style="color:var(--rc-color-gray-text-dark);"><!></div>');
function fv(e) {
  var r = gv(), t = z(r);
  dn(t, () => _v), T(e, r);
}
const mv = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
     xmlns="http://www.w3.org/2000/svg">
    <path d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8Z"
          fill="currentColor"/>
</svg>
`;
var hv = /* @__PURE__ */ B('<div style="color:var(--rc-color-accent);" class="rcb-ui-asset-icon svelte-1dhcigx"><!></div>');
const yv = {
  hash: "svelte-1dhcigx",
  code: "div.svelte-1dhcigx {height:24px;width:24px;}"
};
function bv(e) {
  oe(e, yv);
  var r = hv(), t = z(r);
  dn(t, () => mv), T(e, r);
}
const vv = `<svg viewBox="0 0 124 124" fill="var(--rc-color-grey-text-dark)" xmlns="http://www.w3.org/2000/svg">
    <circle cx="62" cy="62" r="62" fill="var(--rc-color-grey-text-dark)" opacity="0.2"/>
    <rect x="44.1116" y="56" width="27.5" height="11" transform="rotate(45 44.1116 56)" fill="var(--rc-color-grey-text-dark)"/>
    <rect x="79.1133" y="44.334" width="11" height="44" transform="rotate(45 79.1133 44.334)" fill="var(--rc-color-grey-text-dark)"/>
</svg>
`;
var kv = /* @__PURE__ */ B('<div style="color:var(--rc-color-primary)"><!></div>');
function Rd(e) {
  var r = kv(), t = z(r);
  dn(t, () => vv), T(e, r);
}
var wv = /* @__PURE__ */ or('<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" class="arrow-fill svelte-1prqhxu" fill-opacity="0.7"></path></svg>');
const Pv = {
  hash: "svelte-1prqhxu",
  code: ".arrow-fill.svelte-1prqhxu {fill:var(--arrow-fill-color, var(--rc-color-grey-text-dark));}"
};
function xv(e) {
  oe(e, Pv);
  var r = wv();
  T(e, r);
}
const Ev = {
  cart: fv,
  error: $u,
  lock: bv,
  success: Rd,
  back: pv,
  info: Ld,
  close: xv,
  "chevron-left": go,
  "chevron-right": go,
  "chevron-up": go,
  "chevron-down": go
};
function Ua(e, r) {
  ee(r, !0);
  const t = Ev[r.name];
  let n = /* @__PURE__ */ X(Xe({}));
  if (r.name.startsWith("chevron")) {
    const a = r.name.split("-")[1];
    L(n, { direction: a }, !0);
  }
  t(e, Ye(() => i(n))), re();
}
var Sv = /* @__PURE__ */ B('<span class="rc-sandbox-only-error svelte-1dod9xz"><!></span> <br/> <br/>', 1), Iv = /* @__PURE__ */ B('<!> <a class="svelte-1dod9xz"> </a>.', 1), Tv = /* @__PURE__ */ B("<!> <!>", 1);
const Cv = {
  hash: "svelte-1dod9xz",
  code: "a.svelte-1dod9xz {color:var(--rc-color-grey-text-dark);}.rc-sandbox-only-error.svelte-1dod9xz {font-weight:bold;}"
};
function el(e, r) {
  ee(r, !0), oe(e, Cv);
  const t = () => fe(l, "$translator", n), [n, a] = Ae(), o = K(r, "fullWidth", 3, !1), s = /* @__PURE__ */ b(() => r.lastError ?? new ae(Q.UnknownError, "Unknown error without state set.")), l = Le(dr), c = /* @__PURE__ */ b(() => i(s).errorCode === Q.StripeTaxNotActive || i(s).errorCode === Q.StripeInvalidTaxOriginAddress || i(s).errorCode === Q.StripeMissingRequiredPermission);
  nr(() => {
    ne.errorLog(`Displayed error: ${Q[i(s).errorCode]}. Message: ${i(s).message ?? "None"}. Underlying error: ${i(s).underlyingErrorMessage ?? "None"}`);
  });
  function u() {
    return i(s).errorCode === Q.AlreadyPurchasedError ? t().translate($.ErrorPageCloseButtonTitle, { appName: r.appName ?? "App" }) : i(c) ? t().translate($.ErrorButtonClose) : t().translate($.ErrorButtonTryAgain);
  }
  function d() {
    switch (i(s).errorCode) {
      case Q.AlreadyPurchasedError:
        return r.productDetails.productType === ut.Subscription ? t().translate($.ErrorPageErrorTitleAlreadySubscribed, { productTitle: r.productDetails.title }) : t().translate($.ErrorPageErrorTitleAlreadyPurchased, { productTitle: r.productDetails.title });
      case Q.StripeTaxNotActive:
        return t().translate($.ErrorPageErrorTitleStripeTaxNotActive);
      case Q.StripeInvalidTaxOriginAddress:
        return t().translate($.ErrorPageErrorTitleStripeInvalidTaxOriginAddress);
      case Q.StripeMissingRequiredPermission:
        return t().translate($.ErrorPageErrorTitleStripeMissingRequiredPermission);
      default:
        return t().translate($.ErrorPageErrorTitleOtherErrors);
    }
  }
  function p() {
    const h = i(s).getErrorCode();
    switch (i(s).errorCode) {
      case Q.ErrorSettingUpPurchase:
      case Q.InvalidPaddleAPIKeyError:
        return t().translate($.ErrorPageErrorMessageErrorSettingUpPurchase, { errorCode: h });
      case Q.ErrorChargingPayment:
        return t().translate($.ErrorPageErrorMessageErrorChargingPayment, { errorCode: h });
      case Q.AlreadyPurchasedError:
        return r.productDetails.productType === ut.Subscription ? t().translate($.ErrorPageErrorMessageAlreadySubscribed, { errorCode: h }) : t().translate($.ErrorPageErrorMessageAlreadyPurchased, { errorCode: h });
      case Q.StripeTaxNotActive:
        return t().translate($.ErrorPageErrorMessageStripeTaxNotActive, { errorCode: h });
      case Q.StripeInvalidTaxOriginAddress:
        return t().translate($.ErrorPageErrorMessageStripeInvalidTaxOriginAddress, { errorCode: h });
      case Q.StripeMissingRequiredPermission:
        return t().translate($.ErrorPageErrorMessageStripeMissingRequiredPermission, { errorCode: h });
      case Q.NetworkError:
        return t().translate($.ErrorPageErrorMessageNetworkError, { errorCode: h });
      default:
        return t().translate($.ErrorPageErrorMessageUnknownError, { errorCode: h });
    }
  }
  function _() {
    return i(s).errorCode === Q.AlreadyPurchasedError ? $.ErrorPageTroubleAccessing : $.ErrorPageIfErrorPersists;
  }
  function g() {
    return i(s).errorCode === Q.AlreadyPurchasedError ? "success" : "error";
  }
  {
    const h = (y) => {
      {
        let k = /* @__PURE__ */ b(g);
        Ua(y, {
          get name() {
            return i(k);
          }
        });
      }
    }, w = (y) => {
      var k = Tv(), m = J(k);
      {
        var S = (E) => {
          var D = Sv(), F = J(D), M = z(F);
          Wr(M, {
            get key() {
              return $.ErrorPageErrorMessageOnlyInSandbox;
            }
          }), T(E, D);
        };
        W(m, (E) => {
          i(c) && E(S);
        });
      }
      var x = R(m), P = R(x);
      {
        var I = (E) => {
          var D = Iv(), F = J(D);
          {
            let j = /* @__PURE__ */ b(_);
            Wr(F, {
              get key() {
                return i(j);
              }
            });
          }
          var M = R(F, 2), C = z(M);
          U(() => {
            se(M, "href", `mailto:${r.supportEmail ?? ""}`), pe(C, r.supportEmail);
          }), T(E, D);
        };
        W(P, (E) => {
          !i(c) && r.supportEmail && E(I);
        });
      }
      U((E) => pe(x, ` ${E ?? ""} `), [p]), T(y, k);
    };
    let v = /* @__PURE__ */ b(d), f = /* @__PURE__ */ b(u);
    Gs(e, {
      get title() {
        return i(v);
      },
      get onDismiss() {
        return r.onDismiss;
      },
      type: "error",
      get closeButtonTitle() {
        return i(f);
      },
      get fullWidth() {
        return o();
      },
      icon: h,
      message: w,
      $$slots: { icon: !0, message: !0 }
    });
  }
  re(), a();
}
function rl(e, r) {
  ee(r, !1);
  const t = () => fe(u, "$translator", n), [n, a] = Ae();
  let o = K(r, "onContinue", 8), s = K(r, "title", 8, void 0), l = K(r, "closeButtonTitle", 8, void 0), c = K(r, "fullWidth", 8, !1);
  const u = Le(dr), d = Le(no);
  function p() {
    d.trackSDKEvent(eb("go_back_to_app", Dr)), o()();
  }
  nr(() => {
    d.trackSDKEvent(rb(Dr));
  }), An();
  {
    const _ = (w) => {
      Rd(w);
    };
    let g = /* @__PURE__ */ Vt(() => (Ge(s()), t(), Ge($), Ue(() => s() ?? t().translate($.SuccessPagePurchaseSuccessful)))), h = /* @__PURE__ */ Vt(() => (Ge(l()), t(), Ge($), Ue(() => l() ?? t().translate($.SuccessPageButtonClose))));
    Gs(e, {
      type: "success",
      get title() {
        return i(g);
      },
      onDismiss: p,
      get closeButtonTitle() {
        return i(h);
      },
      get fullWidth() {
        return c();
      },
      icon: _,
      $$slots: { icon: !0 }
    });
  }
  re(), a();
}
function Dv(e) {
  Fd(e);
}
var Av = /* @__PURE__ */ B('<div class="rcb-pricing-dropdown svelte-v5skdw"><div class="rcb-pricing-dropdown-header svelte-v5skdw" tabindex="0" role="button"><!> <span class="rcb-pricing-dropdown-toggle svelte-v5skdw"><!></span></div> <div><div class="rcb-pricing-dropdown-content-inner svelte-v5skdw"><!></div></div></div>');
const qv = {
  hash: "svelte-v5skdw",
  code: `.rcb-pricing-dropdown.svelte-v5skdw {width:100%;overflow:hidden;display:flex;flex-direction:column;}.rcb-pricing-dropdown-header.svelte-v5skdw {padding-top:var(--rc-spacing-gapSmall-mobile);padding-bottom:var(--rc-spacing-gapSmall-mobile);padding-left:var(--rc-spacing-gapLarge-mobile);padding-right:var(--rc-spacing-gapMedium-mobile);color:var(--rc-color-grey-text-light);border-radius:var(--rc-shape-input-button-border-radius);cursor:pointer;display:inline-flex;align-items:center;background-color:var(--rc-color-grey-ui-light);width:fit-content;user-select:none;}.rcb-pricing-dropdown-toggle.svelte-v5skdw {display:flex;align-items:center;margin-left:var(--rc-spacing-gapSmall-mobile);}.rcb-pricing-dropdown-content.svelte-v5skdw {display:flex;flex-direction:column;overflow:hidden;}

  @container layout-query-container (width < 768px) {.rcb-pricing-dropdown-content.svelte-v5skdw {max-height:1000px; /* Set a large max-height for animation */transition:max-height 0.2s ease-in-out;}.rcb-pricing-dropdown-content.collapsed.svelte-v5skdw {max-height:0;}.rcb-pricing-dropdown-content-inner.svelte-v5skdw {padding-top:var(--rc-spacing-gapMedium-mobile);}
  }

  @container layout-query-container (width >= 768px) {.rcb-pricing-dropdown-header.svelte-v5skdw {display:none;}
  }`
};
function Fv(e, r) {
  ee(r, !1), oe(e, qv);
  const t = () => fe(l, "$translator", n), [n, a] = Ae();
  let o = K(r, "isExpanded", 12, !0), s = K(r, "children", 8);
  const l = Le(dr);
  function c() {
    o(!o());
  }
  An();
  var u = Av(), d = z(u), p = z(d);
  ye(p, {
    size: "label-default",
    children: (m, S) => {
      var x = _e(), P = J(x);
      {
        var I = (D) => {
          var F = Ee();
          U((M) => pe(F, M), [
            () => (t(), Ge($), Ue(() => t().translate($.PricingDropdownHideDetails)))
          ]), T(D, F);
        }, E = (D) => {
          var F = Ee();
          U((M) => pe(F, M), [
            () => (t(), Ge($), Ue(() => t().translate($.PricingDropdownShowDetails)))
          ]), T(D, F);
        };
        W(P, (D) => {
          o() ? D(I) : D(E, !1);
        });
      }
      T(m, x);
    },
    $$slots: { default: !0 }
  });
  var _ = R(p, 2), g = z(_);
  {
    var h = (m) => {
      Ua(m, { name: "chevron-up" });
    }, w = (m) => {
      Ua(m, { name: "chevron-down" });
    };
    W(g, (m) => {
      o() ? m(h) : m(w, !1);
    });
  }
  var v = R(d, 2);
  let f;
  var y = z(v), k = z(y);
  Ze(k, () => s() ?? ze), U(() => {
    se(d, "aria-expanded", o()), f = tr(v, 1, "rcb-pricing-dropdown-content svelte-v5skdw", null, f, { collapsed: !o() });
  }), Vr("click", d, c), Vr("keydown", d, (m) => m.key === "Enter" || m.key === " " ? c() : null), T(e, u), re(), a();
}
var zv = /* @__PURE__ */ B('<div class="rcb-pricing-table-value-loading svelte-w1kcbi"><!></div>');
const Mv = {
  hash: "svelte-w1kcbi",
  code: `.rcb-pricing-table-value-loading.svelte-w1kcbi {color:transparent;
    animation: svelte-w1kcbi-rcb-pricing-table-value-loading 1.5s ease-in-out 0s infinite
      normal none running;cursor:progress;background-color:var(--rc-color-grey-text-dark);user-select:none;border-radius:var(--rc-shape-input-border-radius);}

  @keyframes svelte-w1kcbi-rcb-pricing-table-value-loading {
    0%,
    100% {
      opacity: 0.5;
    }
    50% {
      opacity: 0.3;
    }
  }`
};
function Ov(e, r) {
  oe(e, Mv);
  let t = K(r, "children", 8);
  var n = zv(), a = z(n);
  Ze(a, () => t() ?? ze), T(e, n);
}
const tl = 7, ei = 30, nl = 365, ri = 4.33, al = 52, ti = 12;
function cs(e) {
  switch (e.unit) {
    case ce.Year:
      return e.number * nl;
    case ce.Month:
      return e.number * ei;
    case ce.Week:
      return e.number * tl;
    case ce.Day:
      return e.number;
  }
}
function jv(e) {
  switch (e.unit) {
    case ce.Year:
      return e.number * al;
    case ce.Month:
      return e.number * ri;
    case ce.Week:
      return e.number;
    case ce.Day:
      return 0;
  }
}
function Nv(e) {
  switch (e.unit) {
    case ce.Year:
      return e.number * ti;
    case ce.Month:
      return e.number;
    case ce.Week:
    case ce.Day:
      return 0;
  }
}
function Lv(e) {
  switch (e.unit) {
    case ce.Year:
      return e.number;
    case ce.Month:
    case ce.Week:
    case ce.Day:
      return 0;
  }
}
function us(e, r) {
  const { unit: t, number: n } = e;
  return {
    period: r.translatePeriodUnit(t, { noWhitespace: !0 }) ?? "",
    periodAbbreviated: r.translatePeriodUnit(t, {
      noWhitespace: !0,
      short: !0
    }) ?? "",
    periodWithUnit: r.translatePeriod(n, t) ?? "",
    periodInDays: cs(e).toString(),
    periodInWeeks: jv(e).toString(),
    periodInMonths: Nv(e).toString(),
    periodInYears: Lv(e).toString()
  };
}
var Bv = /* @__PURE__ */ B('<div class="rcb-pricing-table-row svelte-1cr4unj"><div class="rcb-pricing-table-header svelte-1cr4unj"><div class="rcb-pricing-table-value"><!></div></div> <div class="rcb-pricing-table-value svelte-1cr4unj"><!></div></div> <div class="rcb-pricing-table-row svelte-1cr4unj"><div class="rcb-pricing-table-header svelte-1cr4unj"><div class="rcb-pricing-table-value"><!></div></div> <div class="rcb-pricing-table-value svelte-1cr4unj"><!></div></div> <div class="rcb-pricing-table-separator svelte-1cr4unj"></div>', 1), Uv = /* @__PURE__ */ B('<div class="rcb-pricing-table-row svelte-1cr4unj" data-testid="tax-loading-skeleton"><div class="rcb-pricing-table-header svelte-1cr4unj"><!></div> <div class="rcb-pricing-table-value svelte-1cr4unj"><!></div></div>'), Rv = /* @__PURE__ */ B('<div class="rcb-pricing-table-row svelte-1cr4unj"><div class="rcb-pricing-table-header svelte-1cr4unj"> </div> <div class="rcb-pricing-table-value svelte-1cr4unj"><!></div></div>'), Vv = /* @__PURE__ */ B('<div class="rcb-pricing-table-row svelte-1cr4unj"><div class="rcb-pricing-table-header svelte-1cr4unj"><!></div> <div class="rcb-pricing-table-value svelte-1cr4unj"><!></div></div>'), Hv = /* @__PURE__ */ B('<div class="rcb-pricing-table-row svelte-1cr4unj"><div class="rcb-pricing-table-header svelte-1cr4unj"><!></div> <div class="rcb-pricing-table-value svelte-1cr4unj"><!></div></div> <!> <div class="rcb-pricing-table-separator svelte-1cr4unj"></div>', 1), Wv = /* @__PURE__ */ B('<div class="rcb-pricing-table-row svelte-1cr4unj"><div class="rcb-pricing-table-header svelte-1cr4unj"><!></div> <div class="rcb-pricing-table-value svelte-1cr4unj"><!></div></div>'), Yv = /* @__PURE__ */ B('<div class="rcb-pricing-table svelte-1cr4unj"><!> <!> <!> <div class="rcb-pricing-table-row rcb-header svelte-1cr4unj"><div class="rcb-pricing-table-header svelte-1cr4unj"><!></div> <div class="rcb-pricing-table-value svelte-1cr4unj"><!></div></div></div>');
const Gv = {
  hash: "svelte-1cr4unj",
  code: `.rcb-pricing-table.svelte-1cr4unj {display:flex;flex-direction:column;gap:var(--rc-spacing-gapSmall-mobile);}.rcb-pricing-table-row.svelte-1cr4unj {display:flex;flex-direction:row;align-items:center;justify-content:space-between;}.rcb-pricing-table-separator.svelte-1cr4unj {height:1px;background-color:var(--rc-color-grey-ui-dark);}.rcb-pricing-table-row.svelte-1cr4unj > .rcb-pricing-table-header:where(.svelte-1cr4unj) {color:var(--rc-color-grey-text-light);}.rcb-pricing-table-row.svelte-1cr4unj > .rcb-pricing-table-value:where(.svelte-1cr4unj) {color:var(--rc-color-grey-text-dark);}.rcb-pricing-table-row.svelte-1cr4unj:last-child > .rcb-pricing-table-header:where(.svelte-1cr4unj),
  .rcb-pricing-table-row.svelte-1cr4unj:last-child > .rcb-pricing-table-value:where(.svelte-1cr4unj) {color:var(--rc-color-grey-text-dark);}

  @container layout-query-container (width >= 768px) {.rcb-pricing-table-separator.svelte-1cr4unj {display:none;}.rcb-pricing-table.svelte-1cr4unj {gap:var(--rc-spacing-gapSmall-desktop);}.rcb-pricing-table-row.svelte-1cr4unj > .rcb-pricing-table-header:where(.svelte-1cr4unj),
    .rcb-pricing-table-row.svelte-1cr4unj > .rcb-pricing-table-value:where(.svelte-1cr4unj) {color:var(--rc-color-grey-text-light);}
  }`
};
function Kv(e, r) {
  ee(r, !0), oe(e, Gv);
  const t = () => fe(l, "$translator", n), [n, a] = Ae(), o = (f) => {
    var y = Yv(), k = z(y);
    {
      var m = (j) => {
        var H = Bv(), A = J(H), q = z(A), O = z(q), G = z(O);
        ye(G, {
          size: "body-small",
          children: (Ie, De) => {
            var ve = Ee();
            U((Te) => pe(ve, Te), [
              () => t().translate($.PricingTableSubtotal)
            ]), T(Ie, ve);
          },
          $$slots: { default: !0 }
        });
        var Y = R(q, 2), te = z(Y);
        ye(te, {
          size: "body-small",
          children: (Ie, De) => {
            var ve = Ee();
            U((Te) => pe(ve, Te), [
              () => t().formatPrice(i(u), r.priceBreakdown.currency)
            ]), T(Ie, ve);
          },
          $$slots: { default: !0 }
        });
        var le = R(A, 2), be = z(le), ge = z(be), xe = z(ge);
        ye(xe, {
          size: "body-small",
          children: (Ie, De) => {
            var ve = Ee();
            U((Te) => pe(ve, `${Te ?? ""}${r.promotionalPricePhase && "name" in r.promotionalPricePhase && r.promotionalPricePhase.name ? `: ${r.promotionalPricePhase.name}` : ""}${i(_) ?? ""}`), [
              () => t().translate($.PricingTableDiscount)
            ]), T(Ie, ve);
          },
          $$slots: { default: !0 }
        });
        var de = R(be, 2), ue = z(de);
        ye(ue, {
          size: "body-small",
          children: (Ie, De) => {
            var ve = Ee();
            U((Te) => pe(ve, `-${Te ?? ""}`), [
              () => t().formatPrice(i(d), r.priceBreakdown.currency)
            ]), T(Ie, ve);
          },
          $$slots: { default: !0 }
        }), T(j, H);
      };
      W(k, (j) => {
        r.hasDiscount && j(m);
      });
    }
    var S = R(k, 2);
    {
      var x = (j) => {
        var H = Hv(), A = J(H), q = z(A), O = z(q);
        ye(O, {
          size: "body-small",
          children: (ge, xe) => {
            var de = Ee();
            U((ue) => pe(de, ue), [
              () => t().translate($.PricingTotalExcludingTax)
            ]), T(ge, de);
          },
          $$slots: { default: !0 }
        });
        var G = R(q, 2), Y = z(G);
        ye(Y, {
          size: "body-small",
          children: (ge, xe) => {
            var de = Ee();
            U((ue) => pe(de, ue), [
              () => t().formatPrice(r.priceBreakdown.totalExcludingTaxInMicros, r.priceBreakdown.currency)
            ]), T(ge, de);
          },
          $$slots: { default: !0 }
        });
        var te = R(A, 2);
        {
          var le = (ge) => {
            var xe = Uv(), de = z(xe), ue = z(de);
            ye(ue, {
              size: "body-small",
              children: (ve, Te) => {
                var ir = Ee();
                U((Je) => pe(ir, Je), [
                  () => t().translate($.PricingTableTax)
                ]), T(ve, ir);
              },
              $$slots: { default: !0 }
            });
            var Ie = R(de, 2), De = z(Ie);
            ye(De, {
              size: "body-small",
              children: (ve, Te) => {
                Ov(ve, {
                  children: (ir, Je) => {
                    var me = Ee();
                    U((Oe) => pe(me, Oe), [
                      () => t().formatPrice(1234e4, r.priceBreakdown.currency)
                    ]), T(ir, me);
                  },
                  $$slots: { default: !0 }
                });
              },
              $$slots: { default: !0 }
            }), T(ge, xe);
          }, be = (ge) => {
            var xe = _e(), de = J(xe);
            {
              var ue = (De) => {
                var ve = Rv(), Te = z(ve), ir = z(Te), Je = R(Te, 2), me = z(Je);
                ye(me, {
                  size: "body-small",
                  children: (Oe, Ar) => {
                    var ie = Ee();
                    U((Ne) => pe(ie, Ne), [
                      () => t().translate($.PricingTableEnterBillingAddressToCalculate)
                    ]), T(Oe, ie);
                  },
                  $$slots: { default: !0 }
                }), U((Oe) => pe(ir, Oe), [
                  () => t().translate($.PricingTableTax)
                ]), T(De, ve);
              }, Ie = (De) => {
                var ve = _e(), Te = J(ve);
                {
                  var ir = (Je) => {
                    var me = _e(), Oe = J(me);
                    Dt(Oe, 17, () => r.priceBreakdown.taxBreakdown, Ht, (Ar, ie) => {
                      var Ne = Vv(), Ke = z(Ne), Sr = z(Ke);
                      ye(Sr, {
                        size: "body-small",
                        children: (ot, On) => {
                          var he = Ee();
                          U(() => pe(he, i(ie).display_name)), T(ot, he);
                        },
                        $$slots: { default: !0 }
                      });
                      var Yr = R(Ke, 2), Kt = z(Yr);
                      ye(Kt, {
                        size: "body-small",
                        children: (ot, On) => {
                          var he = Ee();
                          U((qe) => pe(he, qe), [
                            () => t().formatPrice(i(ie).tax_amount_in_micros, r.priceBreakdown.currency)
                          ]), T(ot, he);
                        },
                        $$slots: { default: !0 }
                      }), T(Ar, Ne);
                    }), T(Je, me);
                  };
                  W(
                    Te,
                    (Je) => {
                      r.priceBreakdown.taxBreakdown !== null && Je(ir);
                    },
                    !0
                  );
                }
                T(De, ve);
              };
              W(
                de,
                (De) => {
                  r.priceBreakdown.taxCalculationStatus === "pending" ? De(ue) : De(Ie, !1);
                },
                !0
              );
            }
            T(ge, xe);
          };
          W(te, (ge) => {
            r.priceBreakdown.taxCalculationStatus === "loading" ? ge(le) : ge(be, !1);
          });
        }
        T(j, H);
      };
      W(S, (j) => {
        i(c) && j(x);
      });
    }
    var P = R(S, 2);
    {
      var I = (j) => {
        var H = Wv(), A = z(H), q = z(A);
        ye(q, {
          size: "body-small",
          children: (Y, te) => {
            var le = Ee();
            U((be) => pe(le, be), [
              () => t().translate($.PricingTableTrialEnds, {
                formattedTrialEndDate: t().translateDate(i(s), { dateStyle: "medium" })
              })
            ]), T(Y, le);
          },
          $$slots: { default: !0 }
        });
        var O = R(A, 2), G = z(O);
        ye(G, {
          size: "body-small",
          children: (Y, te) => {
            var le = Ee();
            U((be) => pe(le, be), [
              () => t().formatPrice(r.priceBreakdown.totalAmountInMicros, r.priceBreakdown.currency)
            ]), T(Y, le);
          },
          $$slots: { default: !0 }
        }), T(j, H);
      };
      W(P, (j) => {
        i(s) && j(I);
      });
    }
    var E = R(P, 2), D = z(E), F = z(D);
    ye(F, {
      size: "body-small",
      children: (j, H) => {
        var A = Ee();
        U((q) => pe(A, q), [
          () => t().translate($.PricingTableTotalDueToday)
        ]), T(j, A);
      },
      $$slots: { default: !0 }
    });
    var M = R(D, 2), C = z(M);
    ye(C, {
      size: "body-small",
      children: (j, H) => {
        var A = Ee();
        U((q) => pe(A, q), [
          () => t().formatPrice(i(p), r.priceBreakdown.currency)
        ]), T(j, A);
      },
      $$slots: { default: !0 }
    }), T(f, y);
  }, s = /* @__PURE__ */ b(() => {
    var f;
    return (f = r.trialPhase) != null && f.period ? rs(/* @__PURE__ */ new Date(), r.trialPhase.period, !0) : null;
  }), l = Le(dr), c = /* @__PURE__ */ b(() => r.priceBreakdown.taxCalculationStatus !== "unavailable" && r.priceBreakdown.taxCalculationStatus !== "disabled" && r.priceBreakdown.taxBreakdown && r.priceBreakdown.taxBreakdown.length > 0), u = /* @__PURE__ */ b(() => {
    var f, y;
    return ((y = (f = r.basePhase) == null ? void 0 : f.price) == null ? void 0 : y.amountMicros) ?? r.priceBreakdown.totalAmountInMicros;
  }), d = /* @__PURE__ */ b(() => {
    var k, m, S, x;
    if (!r.hasDiscount) return 0;
    const f = (m = (k = r.basePhase) == null ? void 0 : k.price) == null ? void 0 : m.amountMicros, y = (x = (S = r.promotionalPricePhase) == null ? void 0 : S.price) == null ? void 0 : x.amountMicros;
    return f == null || y == null ? 0 : f - y;
  }), p = /* @__PURE__ */ b(() => i(s) ? 0 : r.priceBreakdown.totalAmountInMicros), _ = /* @__PURE__ */ b(() => {
    var x;
    if (!r.promotionalPricePhase || !("durationMode" in r.promotionalPricePhase) || r.promotionalPricePhase.durationMode !== "time_window")
      return "";
    const f = (x = r.basePhase) == null ? void 0 : x.period, y = r.promotionalPricePhase.period;
    if (!f || !y || r.promotionalPricePhase.cycleCount <= 0)
      return "";
    const k = cs(f), m = cs({
      number: y.number * r.promotionalPricePhase.cycleCount,
      unit: y.unit
    });
    if (k <= 0 || m <= k)
      return "";
    const S = t().translatePeriod(y.number * r.promotionalPricePhase.cycleCount, y.unit);
    return S ? ` (${S})` : "";
  });
  var g = _e(), h = J(g);
  {
    var w = (f) => {
      Fv(f, {
        children: (y, k) => {
          o(y);
        },
        $$slots: { default: !0 }
      });
    }, v = (f) => {
      o(f);
    };
    W(h, (f) => {
      i(c) ? f(w) : f(v, !1);
    });
  }
  T(e, g), re(), a();
}
var Xv = /* @__PURE__ */ B('<div class="rcb-subscribe-to svelte-sdtx9l"><!></div>'), $v = /* @__PURE__ */ B('<span class="rcb-product-description svelte-sdtx9l"><!></span>'), Zv = /* @__PURE__ */ B('<div class="rcb-pricing-info-header svelte-sdtx9l"><!> <div class="rcb-product-title svelte-sdtx9l"><!></div> <!></div>');
const Jv = {
  hash: "svelte-sdtx9l",
  code: `.rcb-pricing-info-header.svelte-sdtx9l {display:flex;flex-direction:column;gap:var(--rc-spacing-gapMedium-mobile);}.rcb-product-title.svelte-sdtx9l {color:var(--rc-color-grey-text-dark);}.rcb-product-description.svelte-sdtx9l {color:var(--rc-color-grey-text-light);}.rcb-subscribe-to.svelte-sdtx9l {display:none;}

  @container layout-query-container (width >= 768px) {.rcb-subscribe-to.svelte-sdtx9l {display:block;}.rcb-pricing-info-header.svelte-sdtx9l {display:flex;flex-direction:column;gap:var(--rc-spacing-gapMedium-desktop);}
  }`
};
function Qv(e, r) {
  ee(r, !1), oe(e, Jv);
  let t = K(r, "productDetails", 8), n = K(r, "showProductDescription", 8);
  const a = t().productType === ut.Subscription;
  An();
  var o = Zv(), s = z(o);
  {
    var l = (_) => {
      var g = Xv(), h = z(g);
      ye(h, {
        size: "body-base",
        children: (w, v) => {
          {
            let f = /* @__PURE__ */ Vt(() => (Ge(t()), Ue(() => ({ productTitle: t().title }))));
            Wr(w, {
              get key() {
                return Ge($), Ue(() => $.ProductInfoSubscribeTo);
              },
              get variables() {
                return i(f);
              }
            });
          }
        },
        $$slots: { default: !0 }
      }), T(_, g);
    };
    W(s, (_) => {
      a && _(l);
    });
  }
  var c = R(s, 2), u = z(c);
  ye(u, {
    size: "heading-lg",
    branded: !0,
    children: (_, g) => {
      {
        let h = /* @__PURE__ */ Vt(() => (Ge(t()), Ue(() => ({ productTitle: t().title }))));
        Wr(_, {
          get key() {
            return Ge($), Ue(() => $.ProductInfoProductTitle);
          },
          get variables() {
            return i(h);
          }
        });
      }
    },
    $$slots: { default: !0 }
  });
  var d = R(c, 2);
  {
    var p = (_) => {
      var g = $v(), h = z(g);
      ye(h, {
        size: "body-small",
        children: (w, v) => {
          {
            let f = /* @__PURE__ */ Vt(() => (Ge(t()), Ue(() => ({ productDescription: t().description }))));
            Wr(w, {
              get key() {
                return Ge($), Ue(() => $.ProductInfoProductDescription);
              },
              get variables() {
                return i(f);
              }
            });
          }
        },
        $$slots: { default: !0 }
      }), T(_, g);
    };
    W(d, (_) => {
      Ge(n()), Ge(t()), Ue(() => n() && t().description) && _(p);
    });
  }
  T(e, o), re();
}
var ek = /* @__PURE__ */ B("<div><!></div>"), rk = /* @__PURE__ */ B("<div><!> <!></div>"), tk = /* @__PURE__ */ B('<div class="rcb-product-price-container svelte-17etw2v"><!> <!> <div><!> <!> <!></div></div>');
const nk = {
  hash: "svelte-17etw2v",
  code: ".rcb-product-price-container.svelte-17etw2v {display:flex;flex-direction:column;justify-content:space-between;gap:var(--rc-spacing-gapMedium-mobile);color:var(--rc-color-grey-text-dark);}"
};
function ak(e, r) {
  ee(r, !0), oe(e, nk);
  const t = () => fe(o, "$translator", n), [n, a] = Ae(), o = Le(dr), s = /* @__PURE__ */ b(() => {
    var C;
    return !!((C = r.trialPhase) != null && C.periodDuration);
  }), l = /* @__PURE__ */ b(() => {
    var C;
    return ((C = r.introPricePhase) == null ? void 0 : C.cycleCount) === 1;
  }), c = /* @__PURE__ */ b(() => !!r.introPricePhase), u = /* @__PURE__ */ b(() => {
    var H, A;
    if (!i(c) || !((H = r.introPricePhase) != null && H.period)) return "";
    const C = r.introPricePhase.period.number * ((A = r.introPricePhase) == null ? void 0 : A.cycleCount), j = r.introPricePhase.period.unit;
    return C == null || j == null ? "" : C === 1 && !i(s) && t().selectedLocale === Er ? t().translatePeriodUnit(j) || "" : t().translatePeriod(C, j) || "";
  }), d = /* @__PURE__ */ b(() => {
    var C, j;
    return (C = r.introPricePhase) != null && C.period ? i(l) ? t().translate($.ProductInfoIntroPricePhasePaidOnce) : r.introPricePhase && ((j = r.introPricePhase) != null && j.period) && t().translatePeriodFrequency(r.introPricePhase.period.number, r.introPricePhase.period.unit, { useMultipleWords: !0 }) || "" : "";
  }), p = /* @__PURE__ */ b(() => i(s) ? $.ProductInfoIntroPricePhaseAfterTrial : $.ProductInfoIntroPricePhase), _ = /* @__PURE__ */ b(() => t().formatPrice(r.priceBreakdown.totalAmountInMicros, r.priceBreakdown.currency)), g = /* @__PURE__ */ b(() => {
    var j, H;
    const C = r.introPricePhase || r.discountPhase ? ((H = (j = r.basePhase) == null ? void 0 : j.price) == null ? void 0 : H.amountMicros) ?? 0 : r.priceBreakdown.totalAmountInMicros;
    return t().formatPrice(C, r.priceBreakdown.currency);
  }), h = /* @__PURE__ */ b(() => i(c) ? $.ProductInfoAfter : i(s) ? $.ProductInfoAfterTrial : null), w = "heading-lg", v = /* @__PURE__ */ b(() => i(s) ? "heading-md" : "heading-lg"), f = /* @__PURE__ */ b(() => i(s) || i(c) ? "heading-md" : "heading-lg");
  var y = tk(), k = z(y);
  {
    var m = (C) => {
      var j = ek(), H = z(j);
      ye(H, {
        size: w,
        children: (A, q) => {
          {
            let O = /* @__PURE__ */ b(() => ({
              trialDuration: Zg(r.trialPhase.periodDuration, t())
            }));
            Wr(A, {
              get key() {
                return $.ProductInfoFreeTrialDuration;
              },
              get variables() {
                return i(O);
              }
            });
          }
        },
        $$slots: { default: !0 }
      }), T(C, j);
    };
    W(k, (C) => {
      i(s) && C(m);
    });
  }
  var S = R(k, 2);
  {
    var x = (C) => {
      var j = rk(), H = z(j);
      ye(H, {
        get size() {
          return i(v);
        },
        children: (O, G) => {
          {
            let Y = /* @__PURE__ */ b(() => ({
              introPriceDuration: i(u),
              introPrice: i(_)
            }));
            Wr(O, {
              get key() {
                return i(p);
              },
              get variables() {
                return i(Y);
              }
            });
          }
        },
        $$slots: { default: !0 }
      });
      var A = R(H, 2);
      {
        var q = (O) => {
          ye(O, {
            size: "body-small",
            children: (G, Y) => {
              var te = Ee();
              U(() => pe(te, i(d))), T(G, te);
            },
            $$slots: { default: !0 }
          });
        };
        W(A, (O) => {
          i(d) && O(q);
        });
      }
      T(C, j);
    };
    W(S, (C) => {
      i(c) && C(x);
    });
  }
  var P = R(S, 2), I = z(P);
  ye(I, {
    get size() {
      return i(f);
    },
    children: (C, j) => {
      var H = Ee();
      U(() => pe(H, i(g))), T(C, H);
    },
    $$slots: { default: !0 }
  });
  var E = R(I, 2);
  {
    var D = (C) => {
      ye(C, {
        size: "body-small",
        children: (j, H) => {
          var A = Ee();
          U((q) => pe(A, q), [
            () => t().translatePeriodFrequency(r.basePhase.period.number, r.basePhase.period.unit, { useMultipleWords: !0 })
          ]), T(j, A);
        },
        $$slots: { default: !0 }
      });
    };
    W(E, (C) => {
      var j;
      (j = r.basePhase) != null && j.period && C(D);
    });
  }
  var F = R(E, 2);
  {
    var M = (C) => {
      ye(C, {
        size: "body-small",
        children: (j, H) => {
          Wr(j, {
            get key() {
              return i(h);
            }
          });
        },
        $$slots: { default: !0 }
      });
    };
    W(F, (C) => {
      i(h) && C(M);
    });
  }
  T(e, y), re(), a();
}
var ok = /* @__PURE__ */ B("<div><!></div>");
function ik(e, r) {
  ee(r, !0);
  const t = () => fe(o, "$translator", n), [n, a] = Ae(), o = Le(dr), s = /* @__PURE__ */ b(() => {
    var d, p;
    return t().formatPrice(((p = (d = r.basePhase) == null ? void 0 : d.price) == null ? void 0 : p.amountMicros) ?? 0, r.priceBreakdown.currency);
  }), l = "heading-lg";
  var c = ok(), u = z(c);
  ye(u, {
    size: l,
    children: (d, p) => {
      var _ = Ee();
      U(() => pe(_, i(s))), T(d, _);
    },
    $$slots: { default: !0 }
  }), T(e, c), re(), a();
}
var sk = /* @__PURE__ */ B('<div class="rcb-pricing-info svelte-1jzyaxi"><div class="rcb-pricing-info-header svelte-1jzyaxi"><!> <!></div> <!></div>');
const lk = {
  hash: "svelte-1jzyaxi",
  code: `.rcb-pricing-info.svelte-1jzyaxi {display:flex;flex-direction:column;user-select:none;gap:var(--rc-spacing-gapXXLarge-mobile);}.rcb-pricing-info-header.svelte-1jzyaxi {display:flex;flex-direction:column;gap:var(--rc-spacing-gapLarge-mobile);}

  @container layout-query-container (width >= 768px) {.rcb-pricing-info.svelte-1jzyaxi {gap:var(--rc-spacing-gapXXXLarge-desktop);}.rcb-pricing-info-header.svelte-1jzyaxi {gap:var(--rc-spacing-gapLarge-desktop);}
  }`
};
function ck(e, r) {
  ee(r, !1), oe(e, lk);
  let t = K(r, "productDetails", 8), n = K(r, "purchaseOption", 8), a = K(r, "showProductDescription", 8), o = K(r, "priceBreakdown", 8);
  const s = t().productType === "subscription", l = s ? n() : null, c = s ? null : n(), u = s ? (l == null ? void 0 : l.base) ?? null : c != null && c.basePrice ? {
    periodDuration: null,
    period: null,
    cycleCount: 1,
    price: c.basePrice,
    pricePerWeek: null,
    pricePerMonth: null,
    pricePerYear: null
  } : null, d = (l == null ? void 0 : l.trial) ?? null, p = (l == null ? void 0 : l.discount) ?? (c == null ? void 0 : c.discount) ?? null, _ = (l == null ? void 0 : l.introPrice) ?? null, g = (l == null ? void 0 : l.discount) ?? (l == null ? void 0 : l.introPrice) ?? (c == null ? void 0 : c.discount) ?? null;
  An();
  var h = sk(), w = z(h), v = z(w);
  Qv(v, {
    get productDetails() {
      return t();
    },
    get showProductDescription() {
      return a();
    }
  });
  var f = R(v, 2);
  {
    var y = (S) => {
      ak(S, {
        get priceBreakdown() {
          return o();
        },
        get basePhase() {
          return u;
        },
        get trialPhase() {
          return d;
        },
        get discountPhase() {
          return p;
        },
        get introPricePhase() {
          return _;
        }
      });
    }, k = (S) => {
      ik(S, {
        get priceBreakdown() {
          return o();
        },
        get basePhase() {
          return u;
        }
      });
    };
    W(f, (S) => {
      s ? S(y) : S(k, !1);
    });
  }
  var m = R(w, 2);
  {
    let S = /* @__PURE__ */ Vt(() => !!p);
    Kv(m, {
      get priceBreakdown() {
        return o();
      },
      get trialPhase() {
        return d;
      },
      get basePhase() {
        return u;
      },
      get promotionalPricePhase() {
        return g;
      },
      get hasDiscount() {
        return i(S);
      }
    });
  }
  T(e, h), re();
}
const Da = (e) => `https://da08ctfrofx1b.cloudfront.net/${e}`;
var uk = /* @__PURE__ */ B("<div><!></div>");
const dk = {
  hash: "svelte-18ddpt0",
  code: `.rcb-ui-container.svelte-18ddpt0 {display:flex;flex-direction:column;inset:0;color-scheme:none;line-height:1.5em;font-family:-apple-system,
      BlinkMacSystemFont,
      avenir next,
      avenir,
      segoe ui,
      helvetica neue,
      helvetica,
      Cantarell,
      Ubuntu,
      roboto,
      noto,
      arial,
      sans-serif;overflow-x:hidden;overflow-y:auto;}.rcb-ui-container.fullscreen.svelte-18ddpt0 {position:fixed;top:0;left:0;right:0;bottom:0;overscroll-behavior:none;z-index:1000001;}.rcb-ui-container.inside.svelte-18ddpt0 {position:relative;width:100%;z-index:unset;height:100%;top:0;left:0;}`
};
function Vd(e, r) {
  ee(r, !0), oe(e, dk);
  const t = K(r, "brandingAppearance", 3, void 0), n = K(r, "brandFontConfig", 3, void 0), a = K(r, "isInElement", 3, !1), o = /* @__PURE__ */ b(() => new pa(t()).getTextStyleVars(n())), s = /* @__PURE__ */ b(() => new pa(t()).spacingStyleVars), l = /* @__PURE__ */ b(() => [i(o), i(s)].join("; ")), c = /* @__PURE__ */ b(() => {
    var g;
    return (g = n()) != null && g.font_url ? Da(n().font_url) : null;
  }), u = async (g) => {
    try {
      const h = new FontFace(Md, `url(${g})`);
      await h.load(), document.fonts.add(h);
    } catch (h) {
      console.error("Failed to set brand font:", h);
    }
  };
  kr(() => {
    i(c) && u(i(c));
  });
  var d = uk();
  let p;
  var _ = z(d);
  Ze(_, () => r.children ?? ze), U(() => {
    p = tr(d, 1, "rcb-ui-container svelte-18ddpt0", null, p, { fullscreen: !a(), inside: a() }), Pe(d, i(l));
  }), T(e, d), re();
}
var pk = /* @__PURE__ */ B('<div id="layout-query-container" class="svelte-1ewgunr"><div class="rcb-ui-layout svelte-1ewgunr"><!></div></div>');
const _k = {
  hash: "svelte-1ewgunr",
  code: `#layout-query-container.svelte-1ewgunr {width:100%;height:100%;container-type:size;container-name:layout-query-container;overflow-y:auto;overscroll-behavior:none;}.rcb-ui-layout.svelte-1ewgunr {width:100%;min-height:100%;display:flex;box-sizing:border-box;flex-direction:column;overscroll-behavior:none;}

  @container layout-query-container (width < 768px) {.rcb-ui-layout.svelte-1ewgunr {flex-grow:1;}
  }

  @container layout-query-container (width >= 768px) {.rcb-ui-layout.svelte-1ewgunr {flex-direction:row;}
  }`
};
function gk(e, r) {
  oe(e, _k);
  let t = K(r, "style", 8, ""), n = K(r, "children", 8);
  var a = pk(), o = z(a), s = z(o);
  Ze(s, () => n() ?? ze), U(() => Pe(o, t())), T(e, a);
}
const fk = (e) => e;
function mk(e) {
  const r = e - 1;
  return r * r * r + 1;
}
function Sc(e) {
  const r = typeof e == "string" && e.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
  return r ? [parseFloat(r[1]), r[2] || "px"] : [
    /** @type {number} */
    e,
    "px"
  ];
}
function hk(e, { delay: r = 0, duration: t = 400, easing: n = fk } = {}) {
  const a = +getComputedStyle(e).opacity;
  return {
    delay: r,
    duration: t,
    easing: n,
    css: (o) => `opacity: ${o * a}`
  };
}
function yk(e, { delay: r = 0, duration: t = 400, easing: n = mk, x: a = 0, y: o = 0, opacity: s = 0 } = {}) {
  const l = getComputedStyle(e), c = +l.opacity, u = l.transform === "none" ? "" : l.transform, d = c * (1 - s), [p, _] = Sc(a), [g, h] = Sc(o);
  return {
    delay: r,
    duration: t,
    easing: n,
    css: (w, v) => `
			transform: ${u} translate(${(1 - w) * p}${_}, ${(1 - w) * g}${h});
			opacity: ${c - d * v}`
  };
}
var bk = /* @__PURE__ */ B('<div><div class="layout-wrapper svelte-13h5jq9"><div><!></div></div></div>');
const vk = {
  hash: "svelte-13h5jq9",
  code: `.layout-wrapper-outer.svelte-13h5jq9 {flex:1;display:flex;background-color:var(--rc-color-background);}.layout-wrapper-outer.rcb-navbar.svelte-13h5jq9 {justify-content:flex-end;}.layout-wrapper.svelte-13h5jq9 {width:100%;}.layout-content.svelte-13h5jq9 {box-sizing:border-box;background-color:var(--rc-color-background);color:var(--rc-color-grey-text-dark);display:flex;flex-direction:column;}.layout-content.rcb-navbar.svelte-13h5jq9 {display:flex;flex-direction:column;gap:var(--rc-spacing-gapXLarge-mobile);}

  @container layout-query-container (width < 768px) {.layout-wrapper.svelte-13h5jq9 {width:100%;min-width:300px;display:flex;flex-grow:1;}.layout-content.svelte-13h5jq9 {flex-grow:1;height:100%;}.layout-content.rcb-navbar.svelte-13h5jq9 {padding-bottom:var(--rc-spacing-outerPadding-mobile);}.layout-content.rcb-main-block.svelte-13h5jq9 {padding:var(--rc-spacing-outerPadding-mobile);}
  }

  @container layout-query-container (width >= 768px) {.layout-wrapper.svelte-13h5jq9 {flex-basis:544px;}.layout-content.rcb-main-block.svelte-13h5jq9 {padding-left:var(--rc-spacing-outerPadding-desktop);padding-right:var(--rc-spacing-outerPadding-desktop);}.layout-content.rcb-navbar.svelte-13h5jq9 {gap:var(--rc-spacing-gapXXLarge-desktop);}.layout-wrapper-outer.svelte-13h5jq9 {padding-top:var(--rc-spacing-outerPaddingTop-desktop);padding-bottom:var(--rc-spacing-outerPadding-desktop);}
  }`
};
function Hd(e, r) {
  oe(e, vk);
  const t = `rcb-${r.location}`;
  var n = bk(), a = z(n), o = z(a), s = z(o);
  Ze(s, () => r.children ?? ze), U(() => {
    tr(n, 1, `layout-wrapper-outer ${t}`, "svelte-13h5jq9"), tr(o, 1, `layout-content ${t}`, "svelte-13h5jq9");
  }), Nu(3, o, () => hk, () => ({ duration: 500, delay: 50 })), T(e, n);
}
var kk = /* @__PURE__ */ B('<div class="navbar-body svelte-191m2u3"><!></div>'), wk = /* @__PURE__ */ B('<div class="navbar-header svelte-191m2u3"><!></div> <!>', 1), Pk = /* @__PURE__ */ B('<div class="rcb-ui-navbar svelte-191m2u3"><!></div>');
const xk = {
  hash: "svelte-191m2u3",
  code: `.rcb-ui-navbar.svelte-191m2u3 {width:100%;max-width:none;flex-shrink:0;background-color:var(--rc-color-background);}

  @container layout-query-container (width < 768px) {.navbar-body.svelte-191m2u3 {padding-left:var(--rc-spacing-outerPadding-mobile);padding-right:var(--rc-spacing-outerPadding-mobile);}
  }

  @container layout-query-container (width >= 768px) {.rcb-ui-navbar.svelte-191m2u3 {width:50vw;display:flex;justify-content:flex-end;}.navbar-header.svelte-191m2u3 {padding-left:var(--rc-spacing-outerPadding-desktop);padding-right:var(--rc-spacing-outerPadding-desktop);}.navbar-body.svelte-191m2u3 {padding-left:var(--rc-spacing-outerPadding-desktop);padding-right:var(--rc-spacing-outerPadding-desktop);}
  }`
};
function Ek(e, r) {
  ee(r, !0), oe(e, xk);
  const t = K(r, "brandingAppearance", 3, void 0), n = /* @__PURE__ */ b(() => new pa(t()).productInfoStyleVars);
  var a = Pk(), o = z(a);
  Hd(o, {
    location: "navbar",
    children: (s, l) => {
      var c = wk(), u = J(c), d = z(u);
      Ze(d, () => r.headerContent ?? ze);
      var p = R(u, 2);
      {
        var _ = (g) => {
          var h = kk(), w = z(h);
          Ze(w, () => r.bodyContent ?? ze), T(g, h);
        };
        W(p, (g) => {
          r.bodyContent && g(_);
        });
      }
      T(s, c);
    }
  }), U(() => Pe(a, i(n))), T(e, a), re();
}
var Sk = /* @__PURE__ */ B('<button class="rcb-close-button svelte-8qlvu1" data-testid="close-button"><!></button>');
const Ik = {
  hash: "svelte-8qlvu1",
  code: ".rcb-close-button.svelte-8qlvu1 {padding:10px;border:none;cursor:pointer;background-color:transparent;border-radius:50%;color:var(--rc-color-grey-text-dark);display:inline-flex;align-items:center;justify-content:center;width:fit-content;height:fit-content;}.rcb-close-button.svelte-8qlvu1:active {transition:outline 0.1s ease-in-out;outline:2px solid var(--rc-color-focus);}.rcb-close-button.svelte-8qlvu1:hover {color:var(--rc-color-grey-text-dark);}"
};
function Wd(e, r) {
  oe(e, Ik);
  var t = Sk(), n = z(t);
  Ua(n, { name: "close" }), Vr("click", t, function(a) {
    Yu.call(this, r, a);
  }), T(e, t);
}
const Tk = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <g clip-path="url(#clip0_6333_13826)">
    <rect opacity="0.2" width="12" height="12" rx="2.25" fill="black"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.53206 2.06972C9.28201 2.17252 9.88339 2.78615 9.96146 3.52824L10.2298 6.07852C10.2893 6.64453 9.87503 7.12287 9.30441 7.14692C8.73379 7.17097 8.22294 6.73163 8.16339 6.16562L8.08036 5.37641L6.00414 7.35193C5.6039 7.73275 4.94623 7.70146 4.53518 7.28205C4.12413 6.86263 4.11537 6.2139 4.51561 5.83307L6.59182 3.85756L5.79425 3.74823C5.22225 3.66982 4.79448 3.15142 4.83881 2.59036C4.88313 2.02929 5.38276 1.63802 5.95476 1.71643L8.53206 2.06972Z" fill="black"/>
    </g>
    <defs>
    <clipPath id="clip0_6333_13826">
    <rect width="12" height="12" fill="white"/>
    </clipPath>
    </defs>
    </svg>
`;
var Ck = /* @__PURE__ */ B('<div style="color:var(--rc-color-accent);" class="rcb-ui-asset-icon svelte-w5b346"><!></div>');
const Dk = {
  hash: "svelte-w5b346",
  code: "div.svelte-w5b346 {height:12px;width:12px;}"
};
function Ak(e) {
  oe(e, Dk);
  var r = Ck(), t = z(r);
  dn(t, () => Tk), T(e, r);
}
var qk = /* @__PURE__ */ B('<span class="rcb-sandbox-text svelte-bwwvt4">SANDBOX</span>'), Fk = /* @__PURE__ */ B('<span class="rcb-sandbox-text svelte-bwwvt4">Share feedback</span>'), zk = /* @__PURE__ */ B('<a class="rcb-ui-sandbox-banner-link svelte-bwwvt4" target="_blank"><!> <!></a>'), Mk = /* @__PURE__ */ B('<div><div class="rcb-sandbox-banner-spacer svelte-bwwvt4"></div> <div class="rcb-sandbox-banner-title-wrapper svelte-bwwvt4"><!></div> <div class="rcb-sandbox-banner-actions-wrapper svelte-bwwvt4" style="--arrow-fill-color: black"><!> <!></div></div>');
const Ok = {
  hash: "svelte-bwwvt4",
  code: `.rcb-ui-sandbox-banner.svelte-bwwvt4 {position:static;background-color:var(--rc-color-warning);color:black;padding:var(--rc-spacing-gapMedium-mobile) 0;display:flex;justify-content:space-between;align-items:center;height:24px;}.rcb-sandbox-text.svelte-bwwvt4 {font-weight:bold;color:black;line-height:2;}.rcb-sandbox-banner-spacer.svelte-bwwvt4 {flex:1;}.rcb-sandbox-banner-title-wrapper.svelte-bwwvt4 {flex:0;text-align:center;}

  @media (max-width: 768px) {.rcb-sandbox-banner-spacer.svelte-bwwvt4 {flex:0;}.rcb-sandbox-banner-title-wrapper.svelte-bwwvt4 {padding-left:var(--rc-spacing-gapXXLarge-mobile);}
  }.rcb-sandbox-banner-actions-wrapper.svelte-bwwvt4 {flex:1;display:flex;justify-content:flex-end;align-items:center;}.rcb-ui-sandbox-banner-link.svelte-bwwvt4 {display:flex;align-items:center;gap:var(--rc-spacing-gapSmall-mobile);line-height:12px;}`
};
function Yd(e, r) {
  ee(r, !1), oe(e, Ok);
  let t = K(r, "style", 8, ""), n = K(r, "isInElement", 8, !1), a = K(r, "brandingInfo", 8, null), o = /* @__PURE__ */ Br(!0);
  function s() {
    ne.debugLog("closeBanner"), L(o, !1);
  }
  An();
  var l = _e(), c = J(l);
  {
    var u = (d) => {
      var p = Mk();
      let _;
      var g = R(z(p), 2), h = z(g);
      ye(h, {
        size: "caption-default",
        children: (k, m) => {
          var S = qk();
          T(k, S);
        },
        $$slots: { default: !0 }
      });
      var w = R(g, 2), v = z(w);
      {
        var f = (k) => {
          var m = zk(), S = z(m);
          Ak(S);
          var x = R(S, 2);
          ye(x, {
            size: "caption-link",
            children: (P, I) => {
              var E = Fk();
              T(P, E);
            },
            $$slots: { default: !0 }
          }), U(() => se(m, "href", (Ge(a()), Ue(() => a().sandbox_configuration.checkout_feedback_form_url)))), T(k, m);
        };
        W(v, (k) => {
          Ge(a()), Ue(() => {
            var m;
            return (m = a()) == null ? void 0 : m.sandbox_configuration;
          }) && k(f);
        });
      }
      var y = R(v, 2);
      Wd(y, { $$events: { click: s } }), U(() => {
        _ = tr(p, 1, "rcb-ui-sandbox-banner svelte-bwwvt4", null, _, { isInElement: n() }), Pe(p, t());
      }), Nu(2, p, () => yk, () => ({ y: -100, duration: 300 })), T(d, p);
    };
    W(c, (d) => {
      i(o) && d(u);
    });
  }
  T(e, l), re();
}
var jk = /* @__PURE__ */ B('<div class="rcb-ui-main svelte-iuk1gs"><!></div>');
const Nk = {
  hash: "svelte-iuk1gs",
  code: ".rcb-ui-main.svelte-iuk1gs {flex:1;display:flex;background-color:var(--rc-color-background);}"
};
function Lk(e, r) {
  ee(r, !0), oe(e, Nk);
  const t = /* @__PURE__ */ b(() => new pa(r.brandingAppearance).formStyleVars);
  var n = jk(), a = z(n);
  Hd(a, {
    location: "main-block",
    children: (o, s) => {
      var l = _e(), c = J(l);
      Ze(c, () => r.children ?? ze), T(o, l);
    }
  }), U(() => Pe(n, i(t))), T(e, n), re();
}
var Bk = /* @__PURE__ */ B("<!> <!>", 1), Uk = /* @__PURE__ */ B("<!> <!>", 1);
function Rk(e, r) {
  ee(r, !0);
  const t = /* @__PURE__ */ b(() => {
    var n;
    return jd((n = r.brandingInfo) == null ? void 0 : n.appearance) ?? "";
  });
  {
    let n = /* @__PURE__ */ b(() => {
      var o;
      return (o = r.brandingInfo) == null ? void 0 : o.appearance;
    }), a = /* @__PURE__ */ b(() => {
      var o;
      return (o = r.brandingInfo) == null ? void 0 : o.brand_font_config;
    });
    Vd(e, {
      get brandingAppearance() {
        return i(n);
      },
      get brandFontConfig() {
        return i(a);
      },
      get isInElement() {
        return r.isInElement;
      },
      children: (o, s) => {
        var l = Uk(), c = J(l);
        {
          var u = (p) => {
            Yd(p, {
              get style() {
                return i(t);
              },
              get isInElement() {
                return r.isInElement;
              },
              get brandingInfo() {
                return r.brandingInfo;
              }
            });
          };
          W(c, (p) => {
            r.isSandbox && p(u);
          });
        }
        var d = R(c, 2);
        gk(d, {
          get style() {
            return i(t);
          },
          children: (p, _) => {
            var g = Bk(), h = J(g);
            {
              var w = (f) => {
                {
                  let y = /* @__PURE__ */ b(() => {
                    var k;
                    return (k = r.brandingInfo) == null ? void 0 : k.appearance;
                  });
                  Ek(f, {
                    get brandingAppearance() {
                      return i(y);
                    },
                    get headerContent() {
                      return r.navbarHeaderContent;
                    },
                    get bodyContent() {
                      return r.navbarBodyContent;
                    }
                  });
                }
              };
              W(h, (f) => {
                (r.navbarHeaderContent || r.navbarBodyContent) && f(w);
              });
            }
            var v = R(h, 2);
            {
              let f = /* @__PURE__ */ b(() => {
                var y;
                return (y = r.brandingInfo) == null ? void 0 : y.appearance;
              });
              Lk(v, {
                get brandingAppearance() {
                  return i(f);
                },
                children: (y, k) => {
                  var m = _e(), S = J(m);
                  Ze(S, () => r.mainContent ?? ze), T(y, m);
                },
                $$slots: { default: !0 }
              });
            }
            T(p, g);
          },
          $$slots: { default: !0 }
        }), T(o, l);
      },
      $$slots: { default: !0 }
    });
  }
  re();
}
var Vk = /* @__PURE__ */ B('<source type="image/webp"/>'), Hk = /* @__PURE__ */ B('<picture class="rcb-app-icon-picture-container svelte-15hivnw"><!> <img class="rcb-app-icon svelte-15hivnw" alt="App icon"/></picture>'), Wk = /* @__PURE__ */ B('<div class="rcb-app-icon loading svelte-15hivnw"></div>');
const Yk = {
  hash: "svelte-15hivnw",
  code: ".rcb-app-icon.svelte-15hivnw {width:32px;height:32px;border-radius:12px;box-shadow:0px 1px 10px 0px rgba(0, 0, 0, 0.1);}.rcb-app-icon-picture-container.svelte-15hivnw {height:32px;}.rcb-app-icon.loading.svelte-15hivnw {background-color:gray;}"
};
function Gd(e, r) {
  oe(e, Yk);
  var t = _e(), n = J(t);
  {
    var a = (s) => {
      var l = Hk(), c = z(l);
      {
        var u = (p) => {
          var _ = Vk();
          U(() => se(_, "srcset", r.srcWebp)), T(p, _);
        };
        W(c, (p) => {
          r.srcWebp && p(u);
        });
      }
      var d = R(c, 2);
      U(() => se(d, "src", r.src)), T(s, l);
    }, o = (s) => {
      var l = Wk();
      T(s, l);
    };
    W(n, (s) => {
      r.src ? s(a) : s(o, !1);
    });
  }
  T(e, t);
}
const fo = (e) => !e || e.trim() === "" ? null : e, Gk = {
  icon: null,
  iconWebp: null,
  wordmark: null,
  wordmarkWebp: null,
  src: null,
  srcWebp: null,
  wordmarkSrc: null,
  wordmarkSrcWebp: null
}, Kd = (e) => {
  if (!e)
    return Gk;
  const r = fo(e.app_icon), t = fo(e.app_icon_webp), n = fo(e.app_wordmark), a = fo(e.app_wordmark_webp);
  return {
    src: r ? Da(r) : null,
    srcWebp: t ? Da(t) : null,
    wordmarkSrc: n ? Da(n) : null,
    wordmarkSrcWebp: a ? Da(a) : null
  };
};
var Kk = /* @__PURE__ */ B('<button class="rcb-back-button svelte-7773d6" data-testid="close-button"><!></button>');
const Xk = {
  hash: "svelte-7773d6",
  code: ".rcb-back-button.svelte-7773d6 {padding:8px;border:none;cursor:pointer;background-color:transparent;border-radius:50%;color:var(--rc-color-grey-text-dark);display:inline-flex;align-items:center;justify-content:center;width:fit-content;height:fit-content;}"
};
function $k(e, r) {
  oe(e, Xk);
  let t = K(r, "disabled", 3, !1);
  var n = Kk(), a = z(n);
  Ua(a, { name: "back" }), U(() => n.disabled = t()), Vr("click", n, function(o) {
    Yu.call(this, r, o);
  }), T(e, n);
}
var Zk = /* @__PURE__ */ B('<source type="image/webp" class="rcb-app-icon svelte-7clux6"/>'), Jk = /* @__PURE__ */ B('<picture class="rcb-app-icon svelte-7clux6"><!> <img class="rcb-app-icon svelte-7clux6" alt="App icon"/></picture>');
const Qk = {
  hash: "svelte-7clux6",
  code: ".rcb-app-icon.svelte-7clux6 {height:32px;}"
};
function Xd(e, r) {
  oe(e, Qk);
  var t = Jk(), n = z(t);
  {
    var a = (s) => {
      var l = Zk();
      U(() => se(l, "srcset", r.srcWebp)), T(s, l);
    };
    W(n, (s) => {
      r.srcWebp && s(a);
    });
  }
  var o = R(n, 2);
  U(() => se(o, "src", r.src)), T(e, t);
}
var ew = /* @__PURE__ */ B('<div class="rcb-back-wrapper svelte-11a99mf"><!></div>'), rw = /* @__PURE__ */ B('<div class="rcb-close-wrapper svelte-11a99mf"><!></div>'), tw = /* @__PURE__ */ B('<div><!> <div class="rcb-header svelte-11a99mf"><div class="rcb-title svelte-11a99mf"><!> <!></div></div> <!></div>');
const nw = {
  hash: "svelte-11a99mf",
  code: `.rcb-header-wrapper.svelte-11a99mf {display:flex;position:relative;justify-content:space-between;align-items:center;}.rcb-header.svelte-11a99mf {display:flex;flex-direction:row;align-items:center;padding-top:var(--rc-spacing-gapSmall-mobile);padding-bottom:var(--rc-spacing-gapSmall-mobile);height:40px;justify-content:space-between;}.rcb-title.svelte-11a99mf {display:flex;align-items:center;position:relative;gap:var(--rc-spacing-gapMedium-mobile);}.rcb-close-wrapper.svelte-11a99mf,
  .rcb-back-wrapper.svelte-11a99mf {padding:var(--rc-spacing-gapSmall-mobile);}

  @container layout-query-container (width < 768px) {.rcb-header.svelte-11a99mf {padding-top:var(--rc-spacing-gapMedium-mobile);}.rcb-close-wrapper.svelte-11a99mf {padding-top:var(--rc-spacing-gapMedium-mobile);}.rcb-header-wrapper.svelte-11a99mf {padding-top:var(--rc-spacing-gapSmall-mobile);padding-bottom:var(--rc-spacing-gapSmall-mobile);padding-left:var(--rc-spacing-outerPadding-mobile);padding-right:var(--rc-spacing-outerPadding-mobile);}.rcb-header-wrapper.rcb-with-close-button.svelte-11a99mf {padding-right:var(--rc-spacing-gapSmall-mobile);}.rcb-back-wrapper.svelte-11a99mf {display:none;}.rcb-header-wrapper.svelte-11a99mf {padding-left:var(--rc-spacing-outerPadding-mobile);padding-right:var(--rc-spacing-outerPadding-mobile);}
  }

  @container layout-query-container (width >= 768px) {.rcb-close-wrapper.svelte-11a99mf {display:none;}.rcb-back-wrapper.svelte-11a99mf {position:absolute;left:-48px;margin-left:0;}
  }`
};
function aw(e, r) {
  ee(r, !0), oe(e, nw);
  const t = /* @__PURE__ */ b(() => Kd(r.brandingInfo)), n = /* @__PURE__ */ b(() => i(t).wordmarkSrc), a = /* @__PURE__ */ b(() => i(t).wordmarkSrcWebp), o = /* @__PURE__ */ b(() => i(t).src), s = /* @__PURE__ */ b(() => i(t).srcWebp), l = () => {
    r.onClose && r.onClose();
  };
  var c = tw();
  let u;
  var d = z(c);
  {
    var p = (S) => {
      var x = ew(), P = z(x);
      $k(P, { $$events: { click: l } }), T(S, x);
    };
    W(d, (S) => {
      r.showCloseButton && S(p);
    });
  }
  var _ = R(d, 2), g = z(_), h = z(g);
  {
    var w = (S) => {
      Xd(S, {
        get src() {
          return i(n);
        },
        get srcWebp() {
          return i(a);
        }
      });
    }, v = (S) => {
      var x = _e(), P = J(x);
      {
        var I = (E) => {
          Gd(E, {
            get src() {
              return i(o);
            },
            get srcWebp() {
              return i(s);
            }
          });
        };
        W(
          P,
          (E) => {
            i(o) !== null && i(s) !== null && E(I);
          },
          !0
        );
      }
      T(S, x);
    };
    W(h, (S) => {
      i(n) !== null ? S(w) : S(v, !1);
    });
  }
  var f = R(h, 2);
  {
    var y = (S) => {
      ye(S, {
        size: "body-base",
        children: (x, P) => {
          var I = Ee();
          U(() => {
            var E;
            return pe(I, (E = r.brandingInfo) == null ? void 0 : E.app_name);
          }), T(x, I);
        },
        $$slots: { default: !0 }
      });
    };
    W(f, (S) => {
      i(n) === null && S(y);
    });
  }
  var k = R(_, 2);
  {
    var m = (S) => {
      var x = rw(), P = z(x);
      Wd(P, { $$events: { click: l } }), T(S, x);
    };
    W(k, (S) => {
      r.showCloseButton && S(m);
    });
  }
  U(() => u = tr(c, 1, "rcb-header-wrapper svelte-11a99mf", null, u, { "rcb-with-close-button": r.showCloseButton })), T(e, c), re();
}
var ow = /* @__PURE__ */ B("<!> <!> <!> <!>", 1);
function iw(e, r) {
  ee(r, !0);
  const t = K(r, "onClose", 3, void 0), n = Qs(r.productDetails, r.purchaseOptionToUse);
  let a = /* @__PURE__ */ X(Xe(r.defaultPriceBreakdown ?? {
    currency: n.currency,
    totalAmountInMicros: n.amountMicros,
    totalExcludingTaxInMicros: n.amountMicros,
    taxCalculationStatus: "unavailable",
    taxAmountInMicros: null,
    taxBreakdown: null
  }));
  const o = (s) => {
    L(a, s, !0);
  };
  Rk(e, {
    get brandingInfo() {
      return r.brandingInfo;
    },
    get isInElement() {
      return r.isInElement;
    },
    get isSandbox() {
      return r.isSandbox;
    },
    get onClose() {
      return t();
    },
    navbarHeaderContent: (u) => {
      {
        let d = /* @__PURE__ */ b(() => !r.isInElement && !!t());
        aw(u, {
          get brandingInfo() {
            return r.brandingInfo;
          },
          get onClose() {
            return t();
          },
          get showCloseButton() {
            return i(d);
          }
        });
      }
    },
    navbarBodyContent: (u) => {
      {
        let d = /* @__PURE__ */ b(() => {
          var p, _;
          return ((_ = (p = r.brandingInfo) == null ? void 0 : p.appearance) == null ? void 0 : _.show_product_description) ?? !1;
        });
        ck(u, {
          get productDetails() {
            return r.productDetails;
          },
          get purchaseOption() {
            return r.purchaseOptionToUse;
          },
          get showProductDescription() {
            return i(d);
          },
          get priceBreakdown() {
            return i(a);
          }
        });
      }
    },
    mainContent: (u) => {
      var d = ow(), p = J(d);
      {
        var _ = (k) => {
          Dv(k);
        };
        W(p, (k) => {
          r.currentPage === "payment-entry-loading" && k(_);
        });
      }
      var g = R(p, 2);
      {
        var h = (k) => {
          $b(k, {
            get productDetails() {
              return r.productDetails;
            },
            get purchaseOption() {
              return r.purchaseOptionToUse;
            },
            get brandingInfo() {
              return r.brandingInfo;
            },
            get purchaseOperationHelper() {
              return r.purchaseOperationHelper;
            },
            get gatewayParams() {
              return r.gatewayParams;
            },
            get managementUrl() {
              return r.managementUrl;
            },
            get customerEmail() {
              return r.customerEmail;
            },
            get forceEnableWalletMethods() {
              return r.forceEnableWalletMethods;
            },
            get defaultPriceBreakdown() {
              return r.defaultPriceBreakdown;
            },
            get termsAndConditionsUrl() {
              return r.termsAndConditionsUrl;
            },
            get onContinue() {
              return r.onContinue;
            },
            get onError() {
              return r.onError;
            },
            onPriceBreakdownUpdated: o
          });
        };
        W(g, (k) => {
          r.currentPage === "payment-entry" && k(h);
        });
      }
      var w = R(g, 2);
      {
        var v = (k) => {
          {
            let m = /* @__PURE__ */ b(() => {
              var x;
              return ((x = r.brandingInfo) == null ? void 0 : x.support_email) ?? null;
            }), S = /* @__PURE__ */ b(() => {
              var x;
              return ((x = r.brandingInfo) == null ? void 0 : x.app_name) ?? null;
            });
            el(k, {
              get lastError() {
                return r.lastError;
              },
              get productDetails() {
                return r.productDetails;
              },
              get supportEmail() {
                return i(m);
              },
              get onDismiss() {
                return r.closeWithError;
              },
              get appName() {
                return i(S);
              }
            });
          }
        };
        W(w, (k) => {
          r.currentPage === "error" && k(v);
        });
      }
      var f = R(w, 2);
      {
        var y = (k) => {
          rl(k, {
            get onContinue() {
              return r.onContinue;
            }
          });
        };
        W(f, (k) => {
          r.currentPage === "success" && k(y);
        });
      }
      T(u, d);
    },
    $$slots: {
      navbarHeaderContent: !0,
      navbarBodyContent: !0,
      mainContent: !0
    }
  }), re();
}
function $d(e) {
  return e.trim() === "" ? "You need to provide your email address to continue." : e.match(/^[^@]+@[^@]+\.[^@]+$/) ? null : "Email is not valid. Please provide a valid email address.";
}
function sw(e) {
  if (e && !e.match(/^[A-Z]{3}$/)) {
    const r = `Currency code ${e} is not valid. Please provide a valid ISO 4217 currency code.`;
    throw ne.errorLog(r), new je(We.ConfigurationError, r);
  }
}
function lw(e, r) {
  var P;
  ee(r, !0);
  const t = K(r, "customTranslations", 19, () => ({})), n = K(r, "skipSuccessPage", 3, !1), a = r.customerEmail ? $d(r.customerEmail) : null;
  let o = /* @__PURE__ */ X(Xe(a ? void 0 : r.customerEmail)), s = r.rcPackage.webBillingProduct, l = /* @__PURE__ */ X(null);
  const c = r.rcPackage.webBillingProduct.identifier ?? null;
  let u = /* @__PURE__ */ X("payment-entry-loading"), d = /* @__PURE__ */ X(null), p = /* @__PURE__ */ X(Xe({})), _ = /* @__PURE__ */ X(null), g = /* @__PURE__ */ X(null), h = /* @__PURE__ */ X(null), w = /* @__PURE__ */ X(null), v = new cn(t(), r.selectedLocale, r.defaultLocale), f = gr(v);
  const y = gr(((P = r.brandingInfo) == null ? void 0 : P.appearance) ?? null);
  $e(dr, f), $e(va, y), nr(() => {
    r.isInElement || (L(g, document.documentElement.style.height, !0), L(h, document.documentElement.style.overflow, !0), L(w, document.body.style.height, !0), document.documentElement.style.height = "100%", document.body.style.height = "100%", document.documentElement.style.overflow = "hidden");
  }), Ot(() => {
    if (!r.isInElement) {
      const I = (E, D, F) => {
        F === "" ? E.style.removeProperty(D) : E.style.setProperty(D, F);
      };
      I(document.documentElement, "height", i(g)), I(document.body, "height", i(w)), I(document.documentElement, "overflow", i(h));
    }
  }), $e(no, r.eventsTracker);
  let k = Xe(typeof r.purchases._shouldForceEnableWalletMethods == "function" ? r.purchases._shouldForceEnableWalletMethods() : !1);
  nr(async () => {
    if (c === null) {
      S(new ae(Q.ErrorSettingUpPurchase, "Product ID was not set before purchase."));
      return;
    }
    r.purchaseOperationHelper.checkoutStart(r.appUserId, c, r.purchaseOption, r.rcPackage.webBillingProduct.presentedOfferingContext, i(o), r.metadata, r.workflowPurchaseContext, r.paywallId).then((I) => {
      L(l, null), L(u, "payment-entry"), L(p, I.gateway_params, !0), L(_, I.management_url, !0);
    }).catch((I) => {
      if (I.errorCode === Q.MissingEmailError)
        return L(o, void 0), r.purchaseOperationHelper.checkoutStart(r.appUserId, c, r.purchaseOption, r.rcPackage.webBillingProduct.presentedOfferingContext, i(o), r.metadata, r.workflowPurchaseContext, r.paywallId).then((E) => {
          L(l, null), L(u, "payment-entry"), L(p, E.gateway_params, !0), L(_, E.management_url, !0);
        }).catch((E) => {
          S(E);
        });
      S(I);
    });
  });
  const m = () => {
    if (i(u) === "payment-entry") {
      r.purchaseOperationHelper.pollCurrentPurchaseForCompletion().then((I) => {
        L(d, I, !0), n() ? r.onFinished(I) : L(u, "success");
      }).catch((I) => {
        S(I);
      });
      return;
    }
    if (i(u) === "success" || i(u) === "error") {
      r.onFinished(i(d));
      return;
    }
    L(u, "success");
  }, S = (I) => {
    const E = Cd({
      errorCode: I.getErrorCode().toString(),
      errorMessage: I.message
    });
    r.eventsTracker.trackSDKEvent(E), L(l, I, !0), L(u, "error");
  }, x = () => {
    r.onError(i(l) ?? new ae(Q.UnknownError, "Unknown error without state set."));
  };
  {
    let I = /* @__PURE__ */ b(() => r.purchases.isSandbox()), E = /* @__PURE__ */ b(() => i(o) ?? null);
    iw(e, {
      get isSandbox() {
        return i(I);
      },
      get currentPage() {
        return i(u);
      },
      get brandingInfo() {
        return r.brandingInfo;
      },
      get productDetails() {
        return s;
      },
      get purchaseOptionToUse() {
        return r.purchaseOption;
      },
      get lastError() {
        return i(l);
      },
      get gatewayParams() {
        return i(p);
      },
      get managementUrl() {
        return i(_);
      },
      get purchaseOperationHelper() {
        return r.purchaseOperationHelper;
      },
      get isInElement() {
        return r.isInElement;
      },
      get termsAndConditionsUrl() {
        return r.termsAndConditionsUrl;
      },
      get forceEnableWalletMethods() {
        return k;
      },
      get customerEmail() {
        return i(E);
      },
      closeWithError: x,
      onContinue: m,
      onError: S,
      get onClose() {
        return r.onClose;
      }
    });
  }
  re();
}
function Ic(e, r, t, n, a, o, s) {
  try {
    var l = e[o](s), c = l.value;
  } catch (u) {
    return void t(u);
  }
  l.done ? r(c) : Promise.resolve(c).then(n, a);
}
function cw(e) {
  return function() {
    var r = this, t = arguments;
    return new Promise(function(n, a) {
      var o = e.apply(r, t);
      function s(c) {
        Ic(o, n, a, s, l, "next", c);
      }
      function l(c) {
        Ic(o, n, a, s, l, "throw", c);
      }
      s(void 0);
    });
  };
}
function uw(e, r, t) {
  return (r = _w(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function Tc(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function ds(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Tc(Object(t), !0).forEach(function(n) {
      uw(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Tc(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function Zd(e, r) {
  if (e == null) return {};
  var t, n, a = dw(e, r);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (n = 0; n < o.length; n++) t = o[n], r.includes(t) || {}.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
  }
  return a;
}
function dw(e, r) {
  if (e == null) return {};
  var t = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (r.includes(n)) continue;
    t[n] = e[n];
  }
  return t;
}
function ps() {
  ps = function() {
    return r;
  };
  var e, r = {}, t = Object.prototype, n = t.hasOwnProperty, a = Object.defineProperty || function(A, q, O) {
    A[q] = O.value;
  }, o = typeof Symbol == "function" ? Symbol : {}, s = o.iterator || "@@iterator", l = o.asyncIterator || "@@asyncIterator", c = o.toStringTag || "@@toStringTag";
  function u(A, q, O) {
    return Object.defineProperty(A, q, {
      value: O,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), A[q];
  }
  try {
    u({}, "");
  } catch {
    u = function(q, O, G) {
      return q[O] = G;
    };
  }
  function d(A, q, O, G) {
    var Y = q && q.prototype instanceof f ? q : f, te = Object.create(Y.prototype), le = new j(G || []);
    return a(te, "_invoke", {
      value: D(A, O, le)
    }), te;
  }
  function p(A, q, O) {
    try {
      return {
        type: "normal",
        arg: A.call(q, O)
      };
    } catch (G) {
      return {
        type: "throw",
        arg: G
      };
    }
  }
  r.wrap = d;
  var _ = "suspendedStart", g = "suspendedYield", h = "executing", w = "completed", v = {};
  function f() {
  }
  function y() {
  }
  function k() {
  }
  var m = {};
  u(m, s, function() {
    return this;
  });
  var S = Object.getPrototypeOf, x = S && S(S(H([])));
  x && x !== t && n.call(x, s) && (m = x);
  var P = k.prototype = f.prototype = Object.create(m);
  function I(A) {
    ["next", "throw", "return"].forEach(function(q) {
      u(A, q, function(O) {
        return this._invoke(q, O);
      });
    });
  }
  function E(A, q) {
    function O(Y, te, le, be) {
      var ge = p(A[Y], A, te);
      if (ge.type !== "throw") {
        var xe = ge.arg, de = xe.value;
        return de && typeof de == "object" && n.call(de, "__await") ? q.resolve(de.__await).then(function(ue) {
          O("next", ue, le, be);
        }, function(ue) {
          O("throw", ue, le, be);
        }) : q.resolve(de).then(function(ue) {
          xe.value = ue, le(xe);
        }, function(ue) {
          return O("throw", ue, le, be);
        });
      }
      be(ge.arg);
    }
    var G;
    a(this, "_invoke", {
      value: function(Y, te) {
        function le() {
          return new q(function(be, ge) {
            O(Y, te, be, ge);
          });
        }
        return G = G ? G.then(le, le) : le();
      }
    });
  }
  function D(A, q, O) {
    var G = _;
    return function(Y, te) {
      if (G === h) throw Error("Generator is already running");
      if (G === w) {
        if (Y === "throw") throw te;
        return {
          value: e,
          done: !0
        };
      }
      for (O.method = Y, O.arg = te; ; ) {
        var le = O.delegate;
        if (le) {
          var be = F(le, O);
          if (be) {
            if (be === v) continue;
            return be;
          }
        }
        if (O.method === "next") O.sent = O._sent = O.arg;
        else if (O.method === "throw") {
          if (G === _) throw G = w, O.arg;
          O.dispatchException(O.arg);
        } else O.method === "return" && O.abrupt("return", O.arg);
        G = h;
        var ge = p(A, q, O);
        if (ge.type === "normal") {
          if (G = O.done ? w : g, ge.arg === v) continue;
          return {
            value: ge.arg,
            done: O.done
          };
        }
        ge.type === "throw" && (G = w, O.method = "throw", O.arg = ge.arg);
      }
    };
  }
  function F(A, q) {
    var O = q.method, G = A.iterator[O];
    if (G === e) return q.delegate = null, O === "throw" && A.iterator.return && (q.method = "return", q.arg = e, F(A, q), q.method === "throw") || O !== "return" && (q.method = "throw", q.arg = new TypeError("The iterator does not provide a '" + O + "' method")), v;
    var Y = p(G, A.iterator, q.arg);
    if (Y.type === "throw") return q.method = "throw", q.arg = Y.arg, q.delegate = null, v;
    var te = Y.arg;
    return te ? te.done ? (q[A.resultName] = te.value, q.next = A.nextLoc, q.method !== "return" && (q.method = "next", q.arg = e), q.delegate = null, v) : te : (q.method = "throw", q.arg = new TypeError("iterator result is not an object"), q.delegate = null, v);
  }
  function M(A) {
    var q = {
      tryLoc: A[0]
    };
    1 in A && (q.catchLoc = A[1]), 2 in A && (q.finallyLoc = A[2], q.afterLoc = A[3]), this.tryEntries.push(q);
  }
  function C(A) {
    var q = A.completion || {};
    q.type = "normal", delete q.arg, A.completion = q;
  }
  function j(A) {
    this.tryEntries = [{
      tryLoc: "root"
    }], A.forEach(M, this), this.reset(!0);
  }
  function H(A) {
    if (A || A === "") {
      var q = A[s];
      if (q) return q.call(A);
      if (typeof A.next == "function") return A;
      if (!isNaN(A.length)) {
        var O = -1, G = function Y() {
          for (; ++O < A.length; ) if (n.call(A, O)) return Y.value = A[O], Y.done = !1, Y;
          return Y.value = e, Y.done = !0, Y;
        };
        return G.next = G;
      }
    }
    throw new TypeError(typeof A + " is not iterable");
  }
  return y.prototype = k, a(P, "constructor", {
    value: k,
    configurable: !0
  }), a(k, "constructor", {
    value: y,
    configurable: !0
  }), y.displayName = u(k, c, "GeneratorFunction"), r.isGeneratorFunction = function(A) {
    var q = typeof A == "function" && A.constructor;
    return !!q && (q === y || (q.displayName || q.name) === "GeneratorFunction");
  }, r.mark = function(A) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(A, k) : (A.__proto__ = k, u(A, c, "GeneratorFunction")), A.prototype = Object.create(P), A;
  }, r.awrap = function(A) {
    return {
      __await: A
    };
  }, I(E.prototype), u(E.prototype, l, function() {
    return this;
  }), r.AsyncIterator = E, r.async = function(A, q, O, G, Y) {
    Y === void 0 && (Y = Promise);
    var te = new E(d(A, q, O, G), Y);
    return r.isGeneratorFunction(q) ? te : te.next().then(function(le) {
      return le.done ? le.value : te.next();
    });
  }, I(P), u(P, c, "Generator"), u(P, s, function() {
    return this;
  }), u(P, "toString", function() {
    return "[object Generator]";
  }), r.keys = function(A) {
    var q = Object(A), O = [];
    for (var G in q) O.push(G);
    return O.reverse(), function Y() {
      for (; O.length; ) {
        var te = O.pop();
        if (te in q) return Y.value = te, Y.done = !1, Y;
      }
      return Y.done = !0, Y;
    };
  }, r.values = H, j.prototype = {
    constructor: j,
    reset: function(A) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(C), !A) for (var q in this) q.charAt(0) === "t" && n.call(this, q) && !isNaN(+q.slice(1)) && (this[q] = e);
    },
    stop: function() {
      this.done = !0;
      var A = this.tryEntries[0].completion;
      if (A.type === "throw") throw A.arg;
      return this.rval;
    },
    dispatchException: function(A) {
      if (this.done) throw A;
      var q = this;
      function O(ge, xe) {
        return te.type = "throw", te.arg = A, q.next = ge, xe && (q.method = "next", q.arg = e), !!xe;
      }
      for (var G = this.tryEntries.length - 1; G >= 0; --G) {
        var Y = this.tryEntries[G], te = Y.completion;
        if (Y.tryLoc === "root") return O("end");
        if (Y.tryLoc <= this.prev) {
          var le = n.call(Y, "catchLoc"), be = n.call(Y, "finallyLoc");
          if (le && be) {
            if (this.prev < Y.catchLoc) return O(Y.catchLoc, !0);
            if (this.prev < Y.finallyLoc) return O(Y.finallyLoc);
          } else if (le) {
            if (this.prev < Y.catchLoc) return O(Y.catchLoc, !0);
          } else {
            if (!be) throw Error("try statement without catch or finally");
            if (this.prev < Y.finallyLoc) return O(Y.finallyLoc);
          }
        }
      }
    },
    abrupt: function(A, q) {
      for (var O = this.tryEntries.length - 1; O >= 0; --O) {
        var G = this.tryEntries[O];
        if (G.tryLoc <= this.prev && n.call(G, "finallyLoc") && this.prev < G.finallyLoc) {
          var Y = G;
          break;
        }
      }
      Y && (A === "break" || A === "continue") && Y.tryLoc <= q && q <= Y.finallyLoc && (Y = null);
      var te = Y ? Y.completion : {};
      return te.type = A, te.arg = q, Y ? (this.method = "next", this.next = Y.finallyLoc, v) : this.complete(te);
    },
    complete: function(A, q) {
      if (A.type === "throw") throw A.arg;
      return A.type === "break" || A.type === "continue" ? this.next = A.arg : A.type === "return" ? (this.rval = this.arg = A.arg, this.method = "return", this.next = "end") : A.type === "normal" && q && (this.next = q), v;
    },
    finish: function(A) {
      for (var q = this.tryEntries.length - 1; q >= 0; --q) {
        var O = this.tryEntries[q];
        if (O.finallyLoc === A) return this.complete(O.completion, O.afterLoc), C(O), v;
      }
    },
    catch: function(A) {
      for (var q = this.tryEntries.length - 1; q >= 0; --q) {
        var O = this.tryEntries[q];
        if (O.tryLoc === A) {
          var G = O.completion;
          if (G.type === "throw") {
            var Y = G.arg;
            C(O);
          }
          return Y;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function(A, q, O) {
      return this.delegate = {
        iterator: H(A),
        resultName: q,
        nextLoc: O
      }, this.method === "next" && (this.arg = e), v;
    }
  }, r;
}
function pw(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function _w(e) {
  var r = pw(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
var Ra = {
  CLASSIC: "classic",
  V1: "v1"
}, gw = Ra.V1, fw = "https://cdn.paddle.com/paddle/paddle.js", mw = "https://cdn.paddle.com/paddle/v2/paddle.js", hw = {
  url: fw
}, yw = {
  url: mw
};
function bw(e) {
  return document.querySelector('script[src="'.concat(e, '"]')) || void 0;
}
function vw(e) {
  var r = document.createElement("script");
  r.src = e;
  var t = document.head || document.body;
  if (!t)
    throw new Error("Cannot inject Paddle.js. It needs a <head> or <body> element.");
  return t.appendChild(r), r;
}
var Oi = {
  classic: void 0,
  v1: void 0
}, kw = {
  classic: "PaddleClassic",
  v1: "PaddleBillingV1"
};
function ww(e) {
  var r, t = (r = Pw(e)) === null || r === void 0 ? void 0 : r.url;
  if (t) {
    var n = Oi[e], a = kw[e];
    return n !== void 0 ? n : (Oi[e] = new Promise(function(o, s) {
      if (typeof window > "u") {
        o(void 0);
        return;
      }
      if (window[a]) {
        o(window[a]);
        return;
      }
      try {
        var l = bw(t);
        l || (l = vw(t)), l.addEventListener("load", function() {
          window[a] ? o(window[a]) : s(new Error("Paddle.js not available"));
        }), l.addEventListener("error", function() {
          s(new Error("Failed to load Paddle.js - ".concat(e)));
        });
      } catch (c) {
        s(c);
        return;
      }
    }), Oi[e]);
  }
}
function Pw(e) {
  if (e === Ra.CLASSIC)
    return hw;
  if (e === Ra.V1)
    return yw;
  console.error("[Paddle] Unknown Paddle Version");
}
var xw = ["environment", "version"], Ew = ["environment", "version"];
function Sw(e, r) {
  var t = e.environment;
  e.version;
  var n = Zd(e, xw);
  try {
    t && r.Environment.set(t), r.Initialized ? r.Update(ds({}, n)) : r.Initialize(ds({}, n));
  } catch (a) {
    console.warn("[Paddle] Paddle Initialization failed. Please check the inputs", a);
  }
}
function Iw(e, r) {
  var t = e.environment;
  e.version;
  var n = Zd(e, Ew);
  try {
    t && r.Environment.set(t), r.Setup(ds({}, n));
  } catch (a) {
    console.warn("[Paddle] Paddle Initialization failed. Please check the inputs", a);
  }
}
var Fa;
(function(e) {
  e.CHECKOUT_LOADED = "checkout.loaded", e.CHECKOUT_CLOSED = "checkout.closed", e.CHECKOUT_UPDATED = "checkout.updated", e.CHECKOUT_COMPLETED = "checkout.completed", e.CHECKOUT_ERROR = "checkout.error", e.CHECKOUT_FAILED = "checkout.failed", e.CHECKOUT_ITEMS_UPDATED = "checkout.items.updated", e.CHECKOUT_ITEMS_REMOVED = "checkout.items.removed", e.CHECKOUT_CUSTOMER_CREATED = "checkout.customer.created", e.CHECKOUT_CUSTOMER_UPDATED = "checkout.customer.updated", e.CHECKOUT_CUSTOMER_REMOVED = "checkout.customer.removed", e.CHECKOUT_PAYMENT_SELECTED = "checkout.payment.selected", e.CHECKOUT_PAYMENT_INITIATED = "checkout.payment.initiated", e.CHECKOUT_PAYMENT_FAILED = "checkout.payment.failed", e.CHECKOUT_DISCOUNT_APPLIED = "checkout.discount.applied", e.CHECKOUT_DISCOUNT_REMOVED = "checkout.discount.removed", e.CHECKOUT_UPSELL_CANCELED = "checkout.upsell.canceled";
})(Fa || (Fa = {}));
var Cc;
(function(e) {
  e.DAY = "day", e.WEEK = "week", e.MONTH = "month", e.YEAR = "year";
})(Cc || (Cc = {}));
var Dc;
(function(e) {
  e.ALIPAY = "alipay", e.APPLE_PAY = "apple-pay", e.CARD = "card", e.GOOGLE_PAY = "google-pay", e.IDEAL = "ideal", e.PAYPAL = "paypal", e.WIRE_TRANSFER = "wire-transfer", e.NONE = "none";
})(Dc || (Dc = {}));
var Ac;
(function(e) {
  e.AMERICAN_EXPRESS = "american_express", e.DINERS_CLUB = "diners_club", e.DISCOVER = "discover", e.JCB = "jcb", e.MADA = "mada", e.MAESTRO = "maestro", e.MASTER_CARD = "mastercard", e.UNION_PAY = "union_pay", e.VISA = "visa", e.UNKNOWN = "unknown";
})(Ac || (Ac = {}));
var qc;
(function(e) {
  e.DRAFT = "draft", e.READY = "ready", e.COMPLETED = "completed", e.BILLED = "billed", e.canceled = "canceled", e.PAST_DUE = "past_due";
})(qc || (qc = {}));
function Tw(e) {
  return _s.apply(this, arguments);
}
function _s() {
  return _s = cw(/* @__PURE__ */ ps().mark(function e(r) {
    var t, n;
    return ps().wrap(function(o) {
      for (; ; ) switch (o.prev = o.next) {
        case 0:
          return t = (r == null ? void 0 : r.version) || gw, o.next = 3, ww(t);
        case 3:
          if (n = o.sent, !n) {
            o.next = 9;
            break;
          }
          return r && (t === Ra.V1 ? Sw(r, n) : t === Ra.CLASSIC && Iw(r, n)), o.abrupt("return", n);
        case 9:
          return console.error("[Paddle] Error Loading Paddle"), o.abrupt("return");
        case 11:
        case "end":
          return o.stop();
      }
    }, e);
  })), _s.apply(this, arguments);
}
class Cw {
  constructor(r, t, n = 10) {
    V(this, "paddleInstance");
    V(this, "backend");
    V(this, "eventsTracker");
    V(this, "maxNumberAttempts");
    V(this, "waitMSBetweenAttempts", 1e3);
    this.backend = r, this.eventsTracker = t, this.maxNumberAttempts = n;
  }
  async initializePaddle(r, t) {
    var a;
    if ((a = this.paddleInstance) != null && a.Initialized)
      return ne.debugLog(
        "Paddle already initialized, returning existing instance"
      ), this.paddleInstance;
    const n = t ? "sandbox" : "production";
    try {
      const o = await Tw({
        token: r,
        version: "v1",
        environment: n
      });
      if (!o)
        throw new ae(
          Q.UnknownError,
          "Paddle client not found"
        );
      return this.paddleInstance = o, ne.debugLog(`Paddle initialized with environment: ${n}`), o;
    } catch (o) {
      throw o instanceof ae ? o : new ae(
        Q.UnknownError,
        `Error initializing Paddle: ${o}`
      );
    }
  }
  getPaddleInstance() {
    var r;
    if (!((r = this.paddleInstance) != null && r.Initialized))
      throw new ae(
        Q.UnknownError,
        "Paddle not initialized."
      );
    return this.paddleInstance;
  }
  async startCheckout({
    appUserId: r,
    productId: t,
    presentedOfferingContext: n,
    purchaseOption: a,
    customerEmail: o,
    metadata: s
  }) {
    try {
      const l = this.eventsTracker.getTraceId(), c = await this.backend.postCheckoutStart(
        r,
        t,
        n,
        a,
        l,
        o ?? void 0,
        s
      );
      return await this.initializePaddle(
        c.paddle_billing_params.client_side_token,
        c.paddle_billing_params.is_sandbox
      ), c;
    } catch (l) {
      throw l instanceof je ? ae.fromPurchasesError(
        l,
        Q.ErrorSettingUpPurchase,
        l.errorCode === We.InvalidCredentialsError
      ) : new ae(
        Q.UnknownError,
        `Error starting Paddle checkout: ${l}`
      );
    }
  }
  async purchase({
    operationSessionId: r,
    transactionId: t,
    onCheckoutLoaded: n,
    onClose: a,
    params: o
  }) {
    const s = this.getPaddleInstance(), { customerEmail: l, locale: c = "en" } = o;
    return new Promise((u, d) => {
      s.Update({
        eventCallback: async (_) => {
          const g = _.name, h = _.data;
          try {
            if (g === Fa.CHECKOUT_LOADED)
              n();
            else if (g === Fa.CHECKOUT_COMPLETED) {
              s.Checkout.close();
              const w = await this.pollOperationStatus(r);
              u(w);
            } else g === Fa.CHECKOUT_CLOSED && (h != null && h.status) && a();
          } catch (w) {
            s.Checkout.close(), w instanceof ae ? d(w) : w instanceof je ? d(
              ae.fromPurchasesError(
                w,
                Q.UnknownError
              )
            ) : d(
              new ae(
                Q.UnknownError,
                `Paddle event handler error: ${w}`
              )
            );
          }
        }
      });
      const p = {
        transactionId: t,
        settings: {
          displayMode: "overlay",
          theme: "light",
          variant: "one-page",
          locale: c,
          allowLogout: !1,
          showAddDiscounts: !1,
          showAddTaxId: !1,
          allowDiscountRemoval: !1
        },
        ...l && { customer: { email: l } }
      };
      try {
        s.Checkout.open(p);
      } catch (_) {
        d(
          new ae(
            Q.UnknownError,
            `Failed to open Paddle checkout: ${_}`
          )
        );
      }
    });
  }
  async pollOperationStatus(r) {
    if (!r)
      throw new ae(
        Q.ErrorSettingUpPurchase,
        "No purchase in progress"
      );
    return new Promise((t, n) => {
      const a = (o = 1) => {
        if (o > this.maxNumberAttempts) {
          n(
            new ae(
              Q.UnknownError,
              "Max attempts reached trying to get successful purchase status"
            )
          );
          return;
        }
        this.backend.getCheckoutStatus(r).then((s) => {
          const l = s.operation.store_transaction_identifier, c = s.operation.product_identifier, u = s.operation.purchase_date ? isNaN(Date.parse(s.operation.purchase_date)) ? null : new Date(s.operation.purchase_date) : null;
          switch (s.operation.status) {
            case Ut.Started:
            case Ut.InProgress:
              setTimeout(
                () => a(o + 1),
                this.waitMSBetweenAttempts
              );
              break;
            case Ut.Succeeded:
              if (!l || !c || !u) {
                n(
                  new ae(
                    Q.UnknownError,
                    "Missing required fields in operation response."
                  )
                );
                return;
              }
              t({
                redemptionInfo: Gu(s),
                operationSessionId: r,
                storeTransactionIdentifier: l ?? "",
                productIdentifier: c,
                purchaseDate: u ?? /* @__PURE__ */ new Date()
              });
              return;
            case Ut.Failed:
              Ku(
                s.operation.error,
                n
              );
          }
        }).catch((s) => {
          if (s instanceof je) {
            const l = ae.fromPurchasesError(
              s,
              Q.NetworkError
            );
            n(l);
          } else
            n(
              new ae(
                Q.NetworkError,
                `Failed to get checkout status: ${s}`
              )
            );
        });
      };
      a();
    });
  }
}
const Oo = (e, r) => e instanceof ae ? e : e instanceof je ? ae.fromPurchasesError(
  e,
  Q.UnknownError
) : new ae(
  Q.UnknownError,
  r
);
var Dw = /* @__PURE__ */ B('<!> <div class="rcb-fullscreen-wrapper svelte-skuziz"><div><!></div> <div class="rcb-fullscreen-content svelte-skuziz"><!></div></div>', 1);
const Aw = {
  hash: "svelte-skuziz",
  code: `.rcb-fullscreen-wrapper.svelte-skuziz {width:100%;height:100%;display:flex;flex-direction:column;align-items:center;}.rcb-fullscreen-header.svelte-skuziz {display:flex;justify-content:center;align-items:center;padding-top:var(--rc-spacing-gapXXLarge-mobile);padding-bottom:var(--rc-spacing-gapMedium-mobile);flex-shrink:0;position:absolute;}.rcb-fullscreen-header.static-header.svelte-skuziz {position:static;}.rcb-fullscreen-content.svelte-skuziz {flex:1;width:100%;box-sizing:border-box;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:0 var(--rc-spacing-outerPadding-mobile)
      var(--rc-spacing-outerPadding-mobile);color:var(--rc-color-grey-text-dark);}

  /* On short screens, don't position the header on top of the content */
  @media (max-height: 500px) {.rcb-fullscreen-header.svelte-skuziz {position:static;}
  }

  @media (min-width: 768px) {.rcb-fullscreen-header.svelte-skuziz {padding-top:var(--rc-spacing-gapXXLarge-desktop);}.rcb-fullscreen-content.svelte-skuziz {padding:0 var(--rc-spacing-outerPadding-desktop)
        var(--rc-spacing-outerPadding-desktop);}
  }`
};
function Jd(e, r) {
  ee(r, !0), oe(e, Aw);
  const t = /* @__PURE__ */ b(() => {
    var d;
    return r.brandingAppearance ?? ((d = r.brandingInfo) == null ? void 0 : d.appearance) ?? null;
  }), n = /* @__PURE__ */ b(() => new pa(i(t)).pageStyleVars), a = /* @__PURE__ */ b(() => {
    var d;
    return ((d = i(t)) == null ? void 0 : d.color_page_bg) ?? "#ffffff";
  }), o = /* @__PURE__ */ b(() => Kd(r.brandingInfo)), s = /* @__PURE__ */ b(() => i(o).wordmarkSrc), l = /* @__PURE__ */ b(() => i(o).wordmarkSrcWebp), c = /* @__PURE__ */ b(() => i(o).src), u = /* @__PURE__ */ b(() => i(o).srcWebp);
  {
    let d = /* @__PURE__ */ b(() => {
      var p;
      return (p = r.brandingInfo) == null ? void 0 : p.brand_font_config;
    });
    Vd(e, {
      get brandingAppearance() {
        return i(t);
      },
      get brandFontConfig() {
        return i(d);
      },
      get isInElement() {
        return r.isInElement;
      },
      children: (p, _) => {
        var g = Dw(), h = J(g);
        {
          var w = (I) => {
            Yd(I, {
              get style() {
                return i(n);
              },
              get isInElement() {
                return r.isInElement;
              },
              get brandingInfo() {
                return r.brandingInfo;
              }
            });
          };
          W(h, (I) => {
            r.isSandbox && I(w);
          });
        }
        var v = R(h, 2), f = z(v);
        let y;
        var k = z(f);
        {
          var m = (I) => {
            Xd(I, {
              get src() {
                return i(s);
              },
              get srcWebp() {
                return i(l);
              }
            });
          }, S = (I) => {
            var E = _e(), D = J(E);
            {
              var F = (C) => {
                Gd(C, {
                  get src() {
                    return i(c);
                  },
                  get srcWebp() {
                    return i(u);
                  }
                });
              }, M = (C) => {
                var j = _e(), H = J(j);
                {
                  var A = (q) => {
                    ye(q, {
                      size: "body-base",
                      children: (O, G) => {
                        var Y = Ee();
                        U(() => pe(Y, r.brandingInfo.app_name)), T(O, Y);
                      },
                      $$slots: { default: !0 }
                    });
                  };
                  W(
                    H,
                    (q) => {
                      var O;
                      (O = r.brandingInfo) != null && O.app_name && q(A);
                    },
                    !0
                  );
                }
                T(C, j);
              };
              W(
                D,
                (C) => {
                  i(c) !== null && i(u) !== null ? C(F) : C(M, !1);
                },
                !0
              );
            }
            T(I, E);
          };
          W(k, (I) => {
            i(s) !== null ? I(m) : I(S, !1);
          });
        }
        var x = R(f, 2), P = z(x);
        Ze(P, () => r.mainContent ?? ze), U(() => {
          Pe(v, `${i(n) ?? ""}; background-color: ${i(a) ?? ""}`), y = tr(f, 1, "rcb-fullscreen-header svelte-skuziz", null, y, { "static-header": r.isInElement });
        }), T(p, g);
      },
      $$slots: { default: !0 }
    });
  }
  re();
}
var qw = /* @__PURE__ */ B("<!> <!> <!>", 1), Fw = /* @__PURE__ */ B('<div class="rcb-ui-loading-container svelte-1r889ax"><!></div>');
const zw = {
  hash: "svelte-1r889ax",
  code: ".rcb-ui-loading-container.svelte-1r889ax {display:flex;flex-direction:column;align-items:center;}"
};
function Mw(e, r) {
  ee(r, !0), oe(e, zw);
  const t = () => fe(o, "$translator", n), [n, a] = Ae(), o = Le(dr);
  Jd(e, {
    get brandingInfo() {
      return r.brandingInfo;
    },
    get isInElement() {
      return r.isInElement;
    },
    get isSandbox() {
      return r.isSandbox;
    },
    mainContent: (l) => {
      var c = _e(), u = J(c);
      {
        var d = (_) => {
          var g = Fw(), h = z(g);
          Na(h, {
            gap: "medium",
            align: "center",
            children: (w, v) => {
              var f = qw(), y = J(f);
              Mo(y, { color: "var(--rc-color-grey-text-dark)" });
              var k = R(y, 2);
              ye(k, {
                size: "heading-md",
                children: (S, x) => {
                  var P = Ee();
                  U((I) => pe(P, I), [
                    () => t().translate($.LoadingPageProcessingPayment)
                  ]), T(S, P);
                },
                $$slots: { default: !0 }
              });
              var m = R(k, 2);
              ye(m, {
                size: "body-small",
                children: (S, x) => {
                  var P = Ee();
                  U((I) => pe(P, I), [
                    () => t().translate($.LoadingPageKeepPageOpen)
                  ]), T(S, P);
                },
                $$slots: { default: !0 }
              }), T(w, f);
            },
            $$slots: { default: !0 }
          }), T(_, g);
        }, p = (_) => {
          var g = _e(), h = J(g);
          {
            var w = (f) => {
              rl(f, {
                get onContinue() {
                  return r.onContinue;
                },
                fullWidth: !0
              });
            }, v = (f) => {
              var y = _e(), k = J(y);
              {
                var m = (S) => {
                  {
                    let x = /* @__PURE__ */ b(() => {
                      var I;
                      return ((I = r.brandingInfo) == null ? void 0 : I.support_email) ?? null;
                    }), P = /* @__PURE__ */ b(() => {
                      var I;
                      return ((I = r.brandingInfo) == null ? void 0 : I.app_name) ?? null;
                    });
                    el(S, {
                      get lastError() {
                        return r.lastError;
                      },
                      get productDetails() {
                        return r.productDetails;
                      },
                      get supportEmail() {
                        return i(x);
                      },
                      get onDismiss() {
                        return r.closeWithError;
                      },
                      get appName() {
                        return i(P);
                      },
                      fullWidth: !0
                    });
                  }
                };
                W(
                  k,
                  (S) => {
                    r.currentPage === "error" && S(m);
                  },
                  !0
                );
              }
              T(f, y);
            };
            W(
              h,
              (f) => {
                r.currentPage === "success" ? f(w) : f(v, !1);
              },
              !0
            );
          }
          T(_, g);
        };
        W(u, (_) => {
          r.currentPage === "loading" ? _(d) : _(p, !1);
        });
      }
      T(l, c);
    },
    $$slots: { mainContent: !0 }
  }), re(), a();
}
function Ow(e, r) {
  var k;
  ee(r, !0);
  const t = K(r, "customTranslations", 19, () => ({})), n = K(r, "skipSuccessPage", 3, !1);
  let a = new cn(t(), r.selectedLocale, r.defaultLocale), o = gr(a);
  const s = gr(((k = r.brandingInfo) == null ? void 0 : k.appearance) ?? null);
  $e(dr, o), $e(va, s), $e(no, r.eventsTracker);
  let l = /* @__PURE__ */ X(!1), c = /* @__PURE__ */ X(null), u = /* @__PURE__ */ X(null), d = /* @__PURE__ */ X("waiting");
  kr(() => {
    i(d) === "success" && i(c) && n() && r.onFinished(i(c));
  });
  const p = () => {
    i(d) === "success" && i(c) && r.onFinished(i(c));
  }, _ = () => {
    r.onError(i(u) ?? new ae(Q.UnknownError, "Unknown error without state set.")), r.unmountPaddlePurchaseUi();
  };
  let g = null, h = null, w = null;
  nr(async () => {
    var P;
    r.isInElement || (g = document.documentElement.style.height, h = document.documentElement.style.overflow, w = document.body.style.height, document.documentElement.style.height = "100%", document.body.style.height = "100%", document.documentElement.style.overflow = "hidden");
    const m = () => {
      L(d, "loading");
    }, S = {
      offeringIdentifier: r.productDetails.presentedOfferingContext.offeringIdentifier,
      targetingContext: null,
      placementIdentifier: null
    };
    let x;
    try {
      x = await r.paddleService.startCheckout({
        appUserId: r.appUserId,
        productId: r.productDetails.identifier,
        presentedOfferingContext: S,
        purchaseOption: r.purchaseOption,
        customerEmail: r.customerEmail,
        metadata: r.metadata
      }), L(l, x.paddle_billing_params.is_sandbox, !0);
    } catch (I) {
      const E = Oo(I, `Start Paddle checkout failed: ${I}`);
      L(u, E, !0), L(d, "error"), r.onError(E);
      return;
    }
    try {
      const I = await r.paddleService.purchase({
        operationSessionId: x.operation_session_id,
        transactionId: (P = x.paddle_billing_params) == null ? void 0 : P.transaction_id,
        onCheckoutLoaded: m,
        onClose: r.onClose,
        params: {
          rcPackage: r.rcPackage,
          purchaseOption: r.purchaseOption,
          appUserId: r.appUserId,
          presentedOfferingIdentifier: r.productDetails.presentedOfferingContext.offeringIdentifier,
          customerEmail: r.customerEmail,
          locale: r.selectedLocale || r.defaultLocale
        }
      });
      n() ? r.onFinished(I) : (L(c, I, !0), L(d, "success"));
    } catch (I) {
      const E = Oo(I, `Paddle purchase failed: ${I}`);
      L(u, E, !0), L(d, "error"), r.onError(E);
    }
  }), Ot(() => {
    if (!r.isInElement) {
      const m = (S, x, P) => {
        P === "" ? S.style.removeProperty(x) : S.style.setProperty(x, P);
      };
      m(document.documentElement, "height", g), m(document.body, "height", w), m(document.documentElement, "overflow", h);
    }
  });
  var v = _e(), f = J(v);
  {
    var y = (m) => {
      Mw(m, {
        get currentPage() {
          return i(d);
        },
        get brandingInfo() {
          return r.brandingInfo;
        },
        get productDetails() {
          return r.productDetails;
        },
        get isSandbox() {
          return i(l);
        },
        get lastError() {
          return i(u);
        },
        get isInElement() {
          return r.isInElement;
        },
        onContinue: p,
        closeWithError: _
      });
    };
    W(f, (m) => {
      i(d) !== "waiting" && m(y);
    });
  }
  T(e, v), re();
}
var jw = /* @__PURE__ */ B('<div class="stripe-checkout-container svelte-1kxsl49" data-testid="stripe-checkout-container"><div class="stripe-checkout-mount svelte-1kxsl49" data-testid="stripe-checkout-mount"></div></div>');
const Nw = {
  hash: "svelte-1kxsl49",
  code: ".stripe-checkout-container.svelte-1kxsl49 {width:100%;min-height:400px;flex:1;display:flex;flex-direction:column;}.stripe-checkout-mount.svelte-1kxsl49 {width:100%;flex:1;}"
};
function Lw(e, r) {
  ee(r, !0), oe(e, Nw);
  let t, n = null;
  async function a() {
    try {
      r.onContinue();
    } catch (l) {
      r.onError(l instanceof ae ? l : new ae(Q.ErrorSettingUpPurchase, l instanceof Error ? l.message : "Failed to complete checkout"));
    }
  }
  nr(async () => {
    try {
      const l = r.stripeBillingParams.publishable_api_key, c = r.stripeBillingParams.stripe_account_id, { embeddedCheckout: u } = await Ve.initializeStripeCheckout(c, l, r.stripeBillingParams, a);
      n = u, t && u.mount(t);
    } catch (l) {
      r.onError(l instanceof Error ? new ae(Q.ErrorSettingUpPurchase, l.message) : new ae(Q.ErrorSettingUpPurchase, "Failed to initialize Stripe Checkout"));
    }
  }), Ot(() => {
    n && (n.destroy(), n = null);
  });
  var o = jw(), s = z(o);
  to(s, (l) => t = l, () => t), T(e, o), re();
}
var Bw = /* @__PURE__ */ B('<div class="stripe-checkout-wrapper svelte-zapbpj"><!></div>'), Uw = /* @__PURE__ */ B("<!> <!> <!>", 1), Rw = /* @__PURE__ */ B('<div class="rcb-ui-loading-container svelte-zapbpj"><!></div>'), Vw = /* @__PURE__ */ B("<!> <!> <!>", 1), Hw = /* @__PURE__ */ B('<div class="rcb-ui-loading-container svelte-zapbpj"><!></div>');
const Ww = {
  hash: "svelte-zapbpj",
  code: ".rcb-ui-loading-container.svelte-zapbpj {display:flex;flex-direction:column;align-items:center;}.stripe-checkout-wrapper.svelte-zapbpj {width:100%;height:100%;display:flex;flex-direction:column;overflow:hidden auto;}"
};
function Yw(e, r) {
  ee(r, !0), oe(e, Ww);
  const t = () => fe(o, "$translator", n), [n, a] = Ae(), o = Le(dr);
  Jd(e, {
    get brandingInfo() {
      return r.brandingInfo;
    },
    get brandingAppearance() {
      return r.brandingAppearance;
    },
    get isInElement() {
      return r.isInElement;
    },
    get isSandbox() {
      return r.isSandbox;
    },
    mainContent: (l) => {
      var c = _e(), u = J(c);
      {
        var d = (_) => {
          var g = _e(), h = J(g);
          {
            var w = (f) => {
              var y = Bw(), k = z(y);
              Lw(k, {
                get stripeBillingParams() {
                  return r.stripeBillingParams;
                },
                get onContinue() {
                  return r.onContinue;
                },
                get onError() {
                  return r.onError;
                }
              }), T(f, y);
            }, v = (f) => {
              var y = Rw(), k = z(y);
              Na(k, {
                gap: "medium",
                align: "center",
                children: (m, S) => {
                  var x = Uw(), P = J(x);
                  Mo(P, { color: "var(--rc-color-grey-text-dark)" });
                  var I = R(P, 2);
                  ye(I, {
                    size: "heading-md",
                    children: (D, F) => {
                      var M = Ee();
                      U((C) => pe(M, C), [
                        () => t().translate($.LoadingPageProcessingPayment)
                      ]), T(D, M);
                    },
                    $$slots: { default: !0 }
                  });
                  var E = R(I, 2);
                  ye(E, {
                    size: "body-small",
                    children: (D, F) => {
                      var M = Ee();
                      U((C) => pe(M, C), [
                        () => t().translate($.LoadingPageKeepPageOpen)
                      ]), T(D, M);
                    },
                    $$slots: { default: !0 }
                  }), T(m, x);
                },
                $$slots: { default: !0 }
              }), T(f, y);
            };
            W(h, (f) => {
              r.stripeBillingParams ? f(w) : f(v, !1);
            });
          }
          T(_, g);
        }, p = (_) => {
          var g = _e(), h = J(g);
          {
            var w = (f) => {
              var y = Hw(), k = z(y);
              Na(k, {
                gap: "medium",
                align: "center",
                children: (m, S) => {
                  var x = Vw(), P = J(x);
                  Mo(P, { color: "var(--rc-color-grey-text-dark)" });
                  var I = R(P, 2);
                  ye(I, {
                    size: "heading-md",
                    children: (D, F) => {
                      var M = Ee();
                      U((C) => pe(M, C), [
                        () => t().translate($.LoadingPageProcessingPayment)
                      ]), T(D, M);
                    },
                    $$slots: { default: !0 }
                  });
                  var E = R(I, 2);
                  ye(E, {
                    size: "body-small",
                    children: (D, F) => {
                      var M = Ee();
                      U((C) => pe(M, C), [
                        () => t().translate($.LoadingPageKeepPageOpen)
                      ]), T(D, M);
                    },
                    $$slots: { default: !0 }
                  }), T(m, x);
                },
                $$slots: { default: !0 }
              }), T(f, y);
            }, v = (f) => {
              var y = _e(), k = J(y);
              {
                var m = (x) => {
                  rl(x, {
                    get onContinue() {
                      return r.onContinue;
                    },
                    fullWidth: !0
                  });
                }, S = (x) => {
                  var P = _e(), I = J(P);
                  {
                    var E = (D) => {
                      {
                        let F = /* @__PURE__ */ b(() => {
                          var C;
                          return ((C = r.brandingInfo) == null ? void 0 : C.support_email) ?? null;
                        }), M = /* @__PURE__ */ b(() => {
                          var C;
                          return ((C = r.brandingInfo) == null ? void 0 : C.app_name) ?? null;
                        });
                        el(D, {
                          get lastError() {
                            return r.lastError;
                          },
                          get productDetails() {
                            return r.productDetails;
                          },
                          get supportEmail() {
                            return i(F);
                          },
                          get onDismiss() {
                            return r.closeWithError;
                          },
                          get appName() {
                            return i(M);
                          },
                          fullWidth: !0
                        });
                      }
                    };
                    W(
                      I,
                      (D) => {
                        r.currentPage === "error" && D(E);
                      },
                      !0
                    );
                  }
                  T(x, P);
                };
                W(
                  k,
                  (x) => {
                    r.currentPage === "success" ? x(m) : x(S, !1);
                  },
                  !0
                );
              }
              T(f, y);
            };
            W(
              h,
              (f) => {
                r.currentPage === "loading" ? f(w) : f(v, !1);
              },
              !0
            );
          }
          T(_, g);
        };
        W(u, (_) => {
          r.currentPage === "stripe-checkout" ? _(d) : _(p, !1);
        });
      }
      T(l, c);
    },
    $$slots: { mainContent: !0 }
  }), re(), a();
}
function Gw(e, r) {
  ee(r, !0);
  const t = K(r, "customTranslations", 19, () => ({})), n = K(r, "skipSuccessPage", 3, !1);
  let a = r.rcPackage.webBillingProduct, o = new cn(t(), r.selectedLocale, r.defaultLocale), s = gr(o);
  $e(dr, s), $e(no, r.eventsTracker);
  let l = /* @__PURE__ */ X(!1), c = /* @__PURE__ */ X(null), u = /* @__PURE__ */ X(null), d = /* @__PURE__ */ X("loading"), p = /* @__PURE__ */ X(null);
  const _ = /* @__PURE__ */ b(() => {
    var m;
    return ((m = i(p)) == null ? void 0 : m.appearance) ?? null;
  }), g = gr(null);
  $e(va, g), kr(() => {
    g.set(i(_));
  }), kr(() => {
    i(d) === "success" && i(c) && n() && r.onFinished(i(c));
  });
  const h = () => {
    if (i(d) === "stripe-checkout") {
      L(d, "loading"), r.purchaseOperationHelper.pollCurrentPurchaseForCompletion().then((m) => {
        L(c, m, !0), n() ? r.onFinished(m) : L(d, "success");
      }).catch((m) => {
        w(Oo(m, "Failed to complete purchase"));
      });
      return;
    }
    i(d) === "success" && i(c) && r.onFinished(i(c));
  }, w = (m) => {
    L(u, m, !0), L(d, "error");
  }, v = () => {
    r.onError(i(u) ?? new ae(Q.UnknownError, "Unknown error without state set."));
  };
  let f = null, y = null, k = null;
  nr(async () => {
    r.isInElement || (f = document.documentElement.style.height, y = document.documentElement.style.overflow, k = document.body.style.height, document.documentElement.style.height = "100%", document.body.style.height = "100%", document.documentElement.style.overflow = "hidden");
    const m = a.identifier;
    if (!m) {
      w(new ae(Q.ErrorSettingUpPurchase, "Product ID was not set before purchase."));
      return;
    }
    let S = r.customerEmail;
    (S ? $d(S) : null) && (S = void 0);
    try {
      const P = await r.purchaseOperationHelper.checkoutStart(r.appUserId, m, r.purchaseOption, r.rcPackage.webBillingProduct.presentedOfferingContext, S, r.metadata, r.workflowPurchaseContext, r.paywallId);
      if (!P.stripe_billing_params) {
        w(new ae(Q.ErrorSettingUpPurchase, "Missing Stripe Checkout parameters"));
        return;
      }
      L(l, P.stripe_billing_params.environment.toLowerCase() === "sandbox"), L(p, P.stripe_billing_params, !0), L(d, "stripe-checkout");
    } catch (P) {
      w(Oo(P, "Failed to start Stripe Checkout"));
    }
  }), Ot(() => {
    if (!r.isInElement) {
      const m = (S, x, P) => {
        P === "" ? S.style.removeProperty(x) : S.style.setProperty(x, P);
      };
      m(document.documentElement, "height", f), m(document.body, "height", k), m(document.documentElement, "overflow", y);
    }
  }), Yw(e, {
    get currentPage() {
      return i(d);
    },
    get brandingInfo() {
      return r.brandingInfo;
    },
    get brandingAppearance() {
      return i(_);
    },
    get productDetails() {
      return a;
    },
    get isSandbox() {
      return i(l);
    },
    get lastError() {
      return i(u);
    },
    get isInElement() {
      return r.isInElement;
    },
    get stripeBillingParams() {
      return i(p);
    },
    onContinue: h,
    onError: w,
    closeWithError: v
  }), re();
}
function Qd(e) {
  return e == null ? !0 : new Date(e) > /* @__PURE__ */ new Date();
}
function Kw(e, r, t, n) {
  const a = r.product_identifier;
  if (a in t)
    return Xw(
      e,
      r,
      t[a]
    );
  if (a in n)
    return $w(
      e,
      r,
      n[a]
    );
  throw new je(
    We.CustomerInfoError,
    "Could not find entitlement product in subscriptions or non-subscriptions."
  );
}
function Xw(e, r, t) {
  return {
    identifier: e,
    isActive: Qd(r.expires_date),
    willRenew: ep(
      r.expires_date,
      t
    ),
    store: (t == null ? void 0 : t.store) ?? "unknown",
    latestPurchaseDate: new Date(r.purchase_date),
    originalPurchaseDate: new Date(r.purchase_date),
    expirationDate: Pt(r.expires_date),
    productIdentifier: r.product_identifier,
    productPlanIdentifier: r.product_plan_identifier ?? null,
    unsubscribeDetectedAt: Pt(
      t == null ? void 0 : t.unsubscribe_detected_at
    ),
    billingIssueDetectedAt: Pt(
      t == null ? void 0 : t.billing_issues_detected_at
    ),
    isSandbox: (t == null ? void 0 : t.is_sandbox) ?? !1,
    periodType: (t == null ? void 0 : t.period_type) ?? "normal",
    ownershipType: (t == null ? void 0 : t.ownership_type) ?? "UNKNOWN"
  };
}
function $w(e, r, t) {
  return {
    identifier: e,
    isActive: !0,
    willRenew: !1,
    store: t.store,
    latestPurchaseDate: new Date(r.purchase_date),
    originalPurchaseDate: new Date(
      t.original_purchase_date
    ),
    expirationDate: null,
    productIdentifier: r.product_identifier,
    productPlanIdentifier: null,
    unsubscribeDetectedAt: null,
    billingIssueDetectedAt: null,
    isSandbox: t.is_sandbox,
    periodType: "normal",
    ownershipType: "UNKNOWN"
  };
}
function Zw(e, r, t) {
  const n = {}, a = {};
  for (const o in e) {
    const s = Kw(
      o,
      e[o],
      r,
      t
    );
    n[o] = s, s.isActive && (a[o] = s);
  }
  return {
    all: n,
    active: a
  };
}
function Pt(e) {
  return e == null ? null : new Date(e);
}
function gs(e) {
  const r = Qw(e), t = e.subscriber, n = rP(
    t.non_subscriptions
  ), a = Object.entries(e.subscriber.non_subscriptions).flatMap(
    ([l, c]) => c.map((u) => ({
      transactionIdentifier: u.id,
      productIdentifier: l,
      purchaseDate: new Date(
        u.purchase_date || u.original_purchase_date
      ),
      storeTransactionId: u.store_transaction_id || null,
      store: u.store
    }))
  ), o = new Date(e.request_date), s = Object.fromEntries(
    Object.entries(e.subscriber.subscriptions).map(
      ([l, c]) => [
        l,
        {
          productIdentifier: l,
          purchaseDate: new Date(c.purchase_date),
          originalPurchaseDate: Pt(
            c.original_purchase_date
          ),
          expiresDate: Pt(c.expires_date),
          store: c.store,
          unsubscribeDetectedAt: Pt(
            c.unsubscribe_detected_at
          ),
          isSandbox: c.is_sandbox,
          billingIssuesDetectedAt: Pt(
            c.billing_issues_detected_at
          ),
          gracePeriodExpiresDate: Pt(
            c.grace_period_expires_date
          ),
          ownershipType: c.ownership_type ?? "UNKNOWN",
          periodType: c.period_type,
          refundedAt: Pt(c.refunded_at),
          storeTransactionId: c.store_transaction_id || null,
          managementURL: c.management_url ?? null,
          isActive: Qd(c.expires_date),
          willRenew: ep(c.expires_date, c)
        }
      ]
    )
  );
  return {
    entitlements: Zw(
      t.entitlements,
      t.subscriptions,
      n
    ),
    allExpirationDatesByProduct: r,
    allPurchaseDatesByProduct: Jw(
      e,
      n
    ),
    activeSubscriptions: eP(r),
    managementURL: t.management_url,
    requestDate: o,
    firstSeenDate: new Date(t.first_seen),
    originalPurchaseDate: Pt(
      t.original_purchase_date
    ),
    originalAppUserId: e.subscriber.original_app_user_id,
    nonSubscriptionTransactions: a,
    subscriptionsByProductIdentifier: s
  };
}
function ep(e, r) {
  if (r == null) return !1;
  const t = r.store == "promotional", n = e == null, a = r.unsubscribe_detected_at != null, o = r.billing_issues_detected_at != null;
  return !(t || n || a || o);
}
function Jw(e, r) {
  const t = {};
  for (const n in e.subscriber.subscriptions) {
    const a = e.subscriber.subscriptions[n];
    t[n] = new Date(
      a.purchase_date
    );
  }
  for (const n in r) {
    const a = r[n].purchase_date;
    a == null ? t[n] = null : t[n] = new Date(a);
  }
  return t;
}
function Qw(e) {
  const r = {};
  for (const t in e.subscriber.subscriptions) {
    const n = e.subscriber.subscriptions[t];
    n.expires_date == null ? r[t] = null : r[t] = new Date(
      n.expires_date
    );
  }
  return r;
}
function eP(e) {
  const r = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new Date();
  for (const n in e) {
    const a = e[n];
    (a == null || a > t) && r.add(n);
  }
  return r;
}
function rP(e) {
  const r = {};
  for (const t in e) {
    if (e[t].length === 0) continue;
    const n = e[t].length;
    r[t] = e[t][n - 1];
  }
  return r;
}
const rp = "1.30.0", tP = "https://api.revenuecat.com", nP = "https://e.revenue.cat";
var jo;
(function(e) {
  e[e.CONTINUE = 100] = "CONTINUE", e[e.SWITCHING_PROTOCOLS = 101] = "SWITCHING_PROTOCOLS", e[e.PROCESSING = 102] = "PROCESSING", e[e.EARLY_HINTS = 103] = "EARLY_HINTS", e[e.OK = 200] = "OK", e[e.CREATED = 201] = "CREATED", e[e.ACCEPTED = 202] = "ACCEPTED", e[e.NON_AUTHORITATIVE_INFORMATION = 203] = "NON_AUTHORITATIVE_INFORMATION", e[e.NO_CONTENT = 204] = "NO_CONTENT", e[e.RESET_CONTENT = 205] = "RESET_CONTENT", e[e.PARTIAL_CONTENT = 206] = "PARTIAL_CONTENT", e[e.MULTI_STATUS = 207] = "MULTI_STATUS", e[e.MULTIPLE_CHOICES = 300] = "MULTIPLE_CHOICES", e[e.MOVED_PERMANENTLY = 301] = "MOVED_PERMANENTLY", e[e.MOVED_TEMPORARILY = 302] = "MOVED_TEMPORARILY", e[e.SEE_OTHER = 303] = "SEE_OTHER", e[e.NOT_MODIFIED = 304] = "NOT_MODIFIED", e[e.USE_PROXY = 305] = "USE_PROXY", e[e.TEMPORARY_REDIRECT = 307] = "TEMPORARY_REDIRECT", e[e.PERMANENT_REDIRECT = 308] = "PERMANENT_REDIRECT", e[e.BAD_REQUEST = 400] = "BAD_REQUEST", e[e.UNAUTHORIZED = 401] = "UNAUTHORIZED", e[e.PAYMENT_REQUIRED = 402] = "PAYMENT_REQUIRED", e[e.FORBIDDEN = 403] = "FORBIDDEN", e[e.NOT_FOUND = 404] = "NOT_FOUND", e[e.METHOD_NOT_ALLOWED = 405] = "METHOD_NOT_ALLOWED", e[e.NOT_ACCEPTABLE = 406] = "NOT_ACCEPTABLE", e[e.PROXY_AUTHENTICATION_REQUIRED = 407] = "PROXY_AUTHENTICATION_REQUIRED", e[e.REQUEST_TIMEOUT = 408] = "REQUEST_TIMEOUT", e[e.CONFLICT = 409] = "CONFLICT", e[e.GONE = 410] = "GONE", e[e.LENGTH_REQUIRED = 411] = "LENGTH_REQUIRED", e[e.PRECONDITION_FAILED = 412] = "PRECONDITION_FAILED", e[e.REQUEST_TOO_LONG = 413] = "REQUEST_TOO_LONG", e[e.REQUEST_URI_TOO_LONG = 414] = "REQUEST_URI_TOO_LONG", e[e.UNSUPPORTED_MEDIA_TYPE = 415] = "UNSUPPORTED_MEDIA_TYPE", e[e.REQUESTED_RANGE_NOT_SATISFIABLE = 416] = "REQUESTED_RANGE_NOT_SATISFIABLE", e[e.EXPECTATION_FAILED = 417] = "EXPECTATION_FAILED", e[e.IM_A_TEAPOT = 418] = "IM_A_TEAPOT", e[e.INSUFFICIENT_SPACE_ON_RESOURCE = 419] = "INSUFFICIENT_SPACE_ON_RESOURCE", e[e.METHOD_FAILURE = 420] = "METHOD_FAILURE", e[e.MISDIRECTED_REQUEST = 421] = "MISDIRECTED_REQUEST", e[e.UNPROCESSABLE_ENTITY = 422] = "UNPROCESSABLE_ENTITY", e[e.LOCKED = 423] = "LOCKED", e[e.FAILED_DEPENDENCY = 424] = "FAILED_DEPENDENCY", e[e.UPGRADE_REQUIRED = 426] = "UPGRADE_REQUIRED", e[e.PRECONDITION_REQUIRED = 428] = "PRECONDITION_REQUIRED", e[e.TOO_MANY_REQUESTS = 429] = "TOO_MANY_REQUESTS", e[e.REQUEST_HEADER_FIELDS_TOO_LARGE = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE", e[e.UNAVAILABLE_FOR_LEGAL_REASONS = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS", e[e.INTERNAL_SERVER_ERROR = 500] = "INTERNAL_SERVER_ERROR", e[e.NOT_IMPLEMENTED = 501] = "NOT_IMPLEMENTED", e[e.BAD_GATEWAY = 502] = "BAD_GATEWAY", e[e.SERVICE_UNAVAILABLE = 503] = "SERVICE_UNAVAILABLE", e[e.GATEWAY_TIMEOUT = 504] = "GATEWAY_TIMEOUT", e[e.HTTP_VERSION_NOT_SUPPORTED = 505] = "HTTP_VERSION_NOT_SUPPORTED", e[e.INSUFFICIENT_STORAGE = 507] = "INSUFFICIENT_STORAGE", e[e.NETWORK_AUTHENTICATION_REQUIRED = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(jo || (jo = {}));
const aP = /^rcb_[a-zA-Z0-9_.-]+$/, oP = /^pdl_[a-zA-Z0-9_.-]+$/, iP = /^test_[a-zA-Z0-9_.-]+$/, sP = /^strp_[a-zA-Z0-9_.-]+$/;
function No(e) {
  return e ? e.startsWith("rcb_sb_") : !1;
}
function fs(e) {
  return e ? aP.test(e) : !1;
}
function tp(e) {
  return e ? oP.test(e) : !1;
}
function np(e) {
  const r = e ? sP.test(e) : !1, t = e ? e.startsWith("strp_sb_") : !1;
  return r && t;
}
function mn(e) {
  return e ? iP.test(e) : !1;
}
async function Kr(e, r, t) {
  return (await ap(
    e,
    r,
    t
  )).data;
}
async function ap(e, r, t) {
  const { apiKey: n, body: a, headers: o, httpConfig: s } = r, c = `${(s == null ? void 0 : s.proxyURL) ?? tP}${e.urlPath()}`;
  try {
    const u = await fetch(c, {
      method: e.method,
      headers: _p(n, o, s == null ? void 0 : s.additionalHeaders),
      body: cP(a),
      signal: t
    });
    await lP(u, e);
    const d = u.status;
    return { data: await u.json(), statusCode: d };
  } catch (u) {
    throw u instanceof TypeError ? new je(
      We.NetworkError,
      Jn.getPublicMessage(We.NetworkError),
      u.message
    ) : u;
  }
}
async function lP(e, r) {
  const t = e.status;
  if (t >= jo.INTERNAL_SERVER_ERROR)
    ji(r, t, await e.text());
  else if (t >= jo.BAD_REQUEST) {
    const n = await e.json(), a = n ? JSON.stringify(n) : null, o = n == null ? void 0 : n.code, s = n == null ? void 0 : n.message;
    if (o != null) {
      const l = Jn.convertCodeToBackendErrorCode(o);
      if (l == null)
        ji(
          r,
          t,
          a,
          o
        );
      else
        throw je.getForBackendError(
          l,
          s
        );
    } else
      ji(r, t, a);
  }
}
function ji(e, r, t, n) {
  throw new je(
    We.UnknownBackendError,
    "Unknown backend error.",
    `Request: ${e.name}. Status code: ${r}. Body: ${t}.`,
    { backendErrorCode: n }
  );
}
function cP(e) {
  return e == null ? null : JSON.stringify(e);
}
const op = "Authorization", ip = "Content-Type", sp = "Accept", lp = "X-Platform", cp = "X-Version", up = "X-Platform-Flavor", dp = "X-Platform-Flavor-Version", pp = "X-Is-Sandbox", uP = /* @__PURE__ */ new Set([
  op,
  ip,
  sp,
  lp,
  cp,
  pp,
  up,
  dp
]);
function _p(e, r, t) {
  let n = {
    [op]: `Bearer ${e}`,
    [ip]: "application/json",
    [sp]: "application/json",
    [lp]: "web",
    [cp]: rp,
    [pp]: `${No(e)}`
  };
  const a = ys.getPlatformInfo();
  if (a) {
    const o = {
      [up]: a.flavor,
      [dp]: a.version
    };
    n = { ...n, ...o };
  }
  return r && (n = { ...n, ...r }), t && (n = { ...t, ...n }), n;
}
const ao = "/v1/subscribers", Mn = "/rcbilling/v1";
class dP {
  constructor(r) {
    V(this, "appUserId");
    V(this, "method", "GET");
    V(this, "name", "getOfferings");
    this.appUserId = r;
  }
  urlPath() {
    const r = encodeURIComponent(this.appUserId);
    return `${ao}/${r}/offerings`;
  }
}
class pP {
  constructor(r, t, n, a) {
    V(this, "method", "GET");
    V(this, "name", "getProducts");
    V(this, "appUserId");
    V(this, "productIds");
    V(this, "currency");
    V(this, "discountCode");
    this.appUserId = r, this.productIds = t, this.currency = n, this.discountCode = a;
  }
  urlPath() {
    const r = encodeURIComponent(this.appUserId), t = this.productIds.map(encodeURIComponent).join("&id="), n = this.currency ? `&currency=${this.currency}` : "", a = this.discountCode ? `&discount_code=${encodeURIComponent(this.discountCode)}` : "";
    return `${Mn}/subscribers/${r}/products?id=${t}${n}${a}`;
  }
}
class _P {
  constructor(r) {
    V(this, "method", "GET");
    V(this, "name", "getCustomerInfo");
    V(this, "appUserId");
    this.appUserId = r;
  }
  urlPath() {
    const r = encodeURIComponent(this.appUserId);
    return `${ao}/${r}`;
  }
}
class gP {
  constructor() {
    V(this, "method", "POST");
    V(this, "name", "identify");
  }
  urlPath() {
    return `${ao}/identify`;
  }
}
class fP {
  constructor() {
    V(this, "method", "GET");
    V(this, "name", "getBrandingInfo");
  }
  urlPath() {
    return `${Mn}/branding`;
  }
}
class mP {
  constructor() {
    V(this, "method", "POST");
    V(this, "name", "postCheckoutPrepare");
  }
  urlPath() {
    return `${Mn}/checkout/prepare`;
  }
}
class hP {
  constructor() {
    V(this, "method", "POST");
    V(this, "name", "postCheckoutStart");
  }
  urlPath() {
    return `${Mn}/checkout/start`;
  }
}
class yP {
  constructor(r) {
    V(this, "method", "POST");
    V(this, "name", "postCheckoutCalculateTax");
    V(this, "operationSessionId");
    this.operationSessionId = r;
  }
  urlPath() {
    return `${Mn}/checkout/${this.operationSessionId}/calculate_taxes`;
  }
}
class bP {
  constructor(r) {
    V(this, "method", "POST");
    V(this, "name", "postCheckoutComplete");
    V(this, "operationSessionId");
    this.operationSessionId = r;
  }
  urlPath() {
    return `${Mn}/checkout/${this.operationSessionId}/complete`;
  }
}
class vP {
  constructor(r) {
    V(this, "method", "GET");
    V(this, "name", "getCheckoutStatus");
    V(this, "operationSessionId");
    this.operationSessionId = r;
  }
  urlPath() {
    return `${Mn}/checkout/${this.operationSessionId}`;
  }
}
class kP {
  constructor(r) {
    V(this, "method", "POST");
    V(this, "name", "setAttributes");
    V(this, "appUserId");
    this.appUserId = r;
  }
  urlPath() {
    const r = encodeURIComponent(this.appUserId);
    return `${ao}/${r}/attributes`;
  }
}
class wP {
  constructor() {
    V(this, "method", "POST");
    V(this, "name", "postReceipt");
  }
  urlPath() {
    return "/v1/receipts";
  }
}
class PP {
  constructor(r) {
    V(this, "method", "GET");
    V(this, "name", "getVirtualCurrencies");
    V(this, "appUserId");
    this.appUserId = r;
  }
  urlPath() {
    const r = encodeURIComponent(this.appUserId);
    return `${ao}/${r}/virtual_currencies`;
  }
}
const ms = {};
class xP {
  constructor(r, t = ms, n) {
    V(this, "API_KEY");
    V(this, "httpConfig");
    V(this, "isSandbox");
    V(this, "purchasesContext");
    this.API_KEY = r, this.httpConfig = t, this.isSandbox = No(r), this.purchasesContext = n;
  }
  getIsSandbox() {
    return this.isSandbox;
  }
  async getOfferings(r) {
    return await Kr(
      new dP(r),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async getCustomerInfo(r) {
    return await Kr(
      new _P(r),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async identify(r, t) {
    const n = {
      app_user_id: r,
      new_app_user_id: t
    }, a = await ap(new gP(), {
      apiKey: this.API_KEY,
      body: n,
      httpConfig: this.httpConfig
    }), o = a.statusCode === 201;
    return {
      ...a.data,
      was_created: o
    };
  }
  async getProducts(r, t, n, a) {
    return await Kr(
      new pP(r, t, n, a),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async getBrandingInfo() {
    return await Kr(
      new fP(),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async postCheckoutPrepare(r, t) {
    const n = {
      product_id: r,
      price_id: t.priceId
    };
    return t.id !== "base_option" && (n.offer_id = t.id), await Kr(
      new mP(),
      {
        apiKey: this.API_KEY,
        body: n,
        httpConfig: this.httpConfig
      }
    );
  }
  async postCheckoutStart(r, t, n, a, o, s, l = void 0, c, u) {
    var p, _;
    const d = {
      app_user_id: r,
      product_id: t,
      email: s,
      price_id: a.priceId,
      presented_offering_identifier: n.offeringIdentifier,
      trace_id: o
    };
    return l && (d.metadata = l), a.id !== "base_option" && (d.offer_id = a.id), n.targetingContext && (d.applied_targeting_rule = {
      rule_id: n.targetingContext.ruleId,
      revision: n.targetingContext.revision
    }), n.placementIdentifier && (d.presented_placement_identifier = n.placementIdentifier), (_ = (p = this.purchasesContext) == null ? void 0 : p.workflowContext) != null && _.workflowIdentifier && (d.presented_workflow_id = this.purchasesContext.workflowContext.workflowIdentifier), c && (d.presented_step_id = c), u && (d.paywall = {
      paywall_id: u
    }), await Kr(
      new hP(),
      {
        apiKey: this.API_KEY,
        body: d,
        httpConfig: this.httpConfig
      }
    );
  }
  async postCheckoutCalculateTax(r, t, n, a) {
    const o = {
      country_code: t,
      postal_code: n
    };
    return await Kr(
      new yP(r),
      {
        apiKey: this.API_KEY,
        body: o,
        httpConfig: this.httpConfig
      },
      a
    );
  }
  async postCheckoutComplete(r, t) {
    const n = {
      email: t
    };
    return await Kr(new bP(r), {
      apiKey: this.API_KEY,
      body: n,
      httpConfig: this.httpConfig
    });
  }
  async getCheckoutStatus(r) {
    return await Kr(
      new vP(r),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async setAttributes(r, t) {
    const n = Date.now(), a = {};
    for (const [s, l] of Object.entries(t))
      a[s] = {
        value: l,
        updated_at_ms: n
      };
    const o = {
      attributes: a
    };
    return await Kr(
      new kP(r),
      {
        apiKey: this.API_KEY,
        body: o,
        httpConfig: this.httpConfig
      }
    );
  }
  async postReceipt(r, t, n, a, o, s, l) {
    var d, p;
    let c = null;
    o.targetingContext && (c = {
      rule_id: o.targetingContext.ruleId,
      revision: o.targetingContext.revision
    });
    const u = {
      fetch_token: a,
      product_id: t,
      currency: n,
      app_user_id: r,
      presented_offering_identifier: o.offeringIdentifier,
      presented_placement_identifier: o.placementIdentifier,
      presented_workflow_id: (p = (d = this.purchasesContext) == null ? void 0 : d.workflowContext) == null ? void 0 : p.workflowIdentifier,
      applied_targeting_rule: c,
      initiation_source: s
    };
    return l && (u.paywall = {
      paywall_id: l
    }), await Kr(
      new wP(),
      {
        apiKey: this.API_KEY,
        body: u,
        httpConfig: this.httpConfig
      }
    );
  }
  async getVirtualCurrencies(r) {
    return await Kr(
      new PP(r),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
}
function EP(e) {
  if (!(fs(e) || mn(e) || tp(e) || np(e)))
    throw new je(
      We.InvalidCredentialsError,
      "Invalid API key. Use your Web Billing API key."
    );
}
function Ni(e) {
  if (!e || (/* @__PURE__ */ new Set([
    "no_user",
    "null",
    "none",
    "nil",
    "(null)",
    "NaN",
    "\\x00",
    "",
    "unidentified",
    "undefined",
    "unknown"
  ])).has(e) || e.includes("/"))
    throw new je(
      We.InvalidAppUserIdError,
      'Provided user id: "' + (e ?? "[Not provided]") + '" is not valid. See https://www.revenuecat.com/docs/customers/user-ids#tips-for-setting-app-user-ids for more information.'
    );
}
function SP(e) {
  if (e != null && e.endsWith("/"))
    throw new je(
      We.ConfigurationError,
      "Invalid proxy URL. The proxy URL should not end with a trailing slash."
    );
}
function IP(e) {
  if (e) {
    for (const r in e)
      if (uP.has(r))
        throw new je(
          We.ConfigurationError,
          "Invalid additional headers. Some headers are reserved for internal use."
        );
  }
}
var gp = /* @__PURE__ */ ((e) => (e.Current = "current", e))(gp || {});
function Fc(e, r) {
  async function t(...n) {
    return await this.preload(), await e.call(this, ...n);
  }
  return t;
}
const fp = (e, r) => {
  const t = {
    ...e.webBillingProduct,
    presentedOfferingContext: {
      ...e.webBillingProduct.presentedOfferingContext,
      placementIdentifier: r
    }
  };
  return {
    ...e,
    webBillingProduct: t,
    rcBillingProduct: t
  };
}, fn = (e, r) => e == null ? null : fp(e, r), TP = (e, r, t) => {
  const n = e.offering_ids_by_placement ?? null;
  if (n == null)
    return null;
  const a = e.fallback_offering_id ?? null;
  let o;
  if (t in n) {
    const l = n[t] ?? null;
    if (l == null)
      return null;
    o = r[l], o == null && (o = r[a]);
  } else
    o = r[a];
  if (o == null)
    return null;
  const s = Object.fromEntries(
    Object.entries(o.packagesById).map(([l, c]) => [
      l,
      fp(c, t)
    ])
  );
  return {
    ...o,
    packagesById: s,
    availablePackages: Object.values(s),
    weekly: fn(o.weekly, t),
    monthly: fn(
      o.monthly,
      t
    ),
    twoMonth: fn(
      o.twoMonth,
      t
    ),
    threeMonth: fn(
      o.threeMonth,
      t
    ),
    sixMonth: fn(
      o.sixMonth,
      t
    ),
    annual: fn(o.annual, t),
    lifetime: fn(
      o.lifetime,
      t
    )
  };
};
function CP(e, r) {
  const t = {};
  r.product_details.forEach((o) => {
    t[o.identifier] = o;
  });
  const n = {};
  e.offerings.forEach((o) => {
    const s = o.identifier === e.current_offering_id, l = iv(
      s,
      o,
      t,
      e.targeting,
      e.ui_config
    );
    l != null && (n[o.identifier] = l);
  });
  const a = e.current_offering_id ? n[e.current_offering_id] ?? null : null;
  return Object.keys(n).length == 0 && ne.debugLog(
    "Empty offerings. Please make sure you've configured offerings correctly in the RevenueCat dashboard and that the products are properly configured."
  ), {
    all: n,
    current: a
  };
}
const DP = 1000001;
function yr(e, r, t) {
  return t.formatPrice(
    vo(e, r),
    r
  );
}
function AP(e, r, t) {
  const n = t.formatPrice(e.amountMicros, e.currency);
  return r ? r.unit === ce.Year ? yr(
    e.amountMicros / nl / r.number,
    e.currency,
    t
  ) : r.unit === ce.Month ? yr(
    e.amountMicros / ei / r.number,
    e.currency,
    t
  ) : r.unit === ce.Week ? yr(
    e.amountMicros / tl / r.number,
    e.currency,
    t
  ) : r.unit === ce.Day ? yr(
    e.amountMicros / r.number,
    e.currency,
    t
  ) : n : n;
}
function qP(e, r, t) {
  const n = t.formatPrice(e.amountMicros, e.currency);
  return r ? r.unit === ce.Year ? yr(
    e.amountMicros / al / r.number,
    e.currency,
    t
  ) : r.unit === ce.Month ? yr(
    e.amountMicros / ri / r.number,
    e.currency,
    t
  ) : r.unit === ce.Week ? yr(
    e.amountMicros / r.number,
    e.currency,
    t
  ) : r.unit === ce.Day ? yr(
    e.amountMicros * tl / r.number,
    e.currency,
    t
  ) : n : n;
}
function FP(e, r, t) {
  return r ? r.unit === ce.Year ? yr(
    e.amountMicros / ti,
    e.currency,
    t
  ) : r.unit === ce.Month ? yr(
    e.amountMicros / r.number,
    e.currency,
    t
  ) : r.unit === ce.Week ? yr(
    e.amountMicros * ri / r.number,
    e.currency,
    t
  ) : r.unit === ce.Day ? yr(
    e.amountMicros * ei / r.number,
    e.currency,
    t
  ) : yr(
    e.amountMicros / (r.number || 1),
    e.currency,
    t
  ) : t.formatPrice(e.amountMicros, e.currency);
}
function zP(e, r, t) {
  const n = t.formatPrice(e.amountMicros, e.currency);
  return r ? r.unit === ce.Year ? yr(
    e.amountMicros / r.number,
    e.currency,
    t
  ) : r.unit === ce.Month ? yr(
    e.amountMicros * ti / r.number,
    e.currency,
    t
  ) : r.unit === ce.Week ? yr(
    e.amountMicros * al / r.number,
    e.currency,
    t
  ) : r.unit === ce.Day ? yr(
    e.amountMicros * nl / r.number,
    e.currency,
    t
  ) : n : n;
}
function mp(e, r, t) {
  return {
    pricePerDay: AP(e, r, t),
    pricePerWeek: qP(e, r, t),
    pricePerMonth: FP(e, r, t),
    pricePerYear: zP(e, r, t)
  };
}
function MP(e, r) {
  const t = /* @__PURE__ */ new Date();
  switch (e.unit) {
    case ce.Year:
      t.setFullYear(t.getFullYear() + e.number);
      break;
    case ce.Month:
      t.setMonth(t.getMonth() + e.number);
      break;
    case ce.Week:
      t.setDate(t.getDate() + e.number * 7);
      break;
    case ce.Day:
      t.setDate(t.getDate() + e.number);
      break;
  }
  return r.translateDate(t, { dateStyle: "long" }) ?? "";
}
function OP(e, r, t) {
  const n = e.discount ?? e.trial ?? e.introPrice, a = e.trial && !e.discount ? e.introPrice : null;
  if (n === null)
    return;
  const { period: o, price: s } = n;
  if (s !== null) {
    const l = mp(s, o, r);
    t["product.offer_price"] = r.formatPrice(
      s.amountMicros,
      s.currency
    ), t["product.offer_price_per_day"] = l.pricePerDay, t["product.offer_price_per_week"] = l.pricePerWeek, t["product.offer_price_per_month"] = l.pricePerMonth, t["product.offer_price_per_year"] = l.pricePerYear;
  }
  if (o !== null) {
    const l = us(o, r);
    t["product.offer_period"] = l.period, t["product.offer_period_abbreviated"] = l.periodAbbreviated, t["product.offer_period_with_unit"] = l.periodWithUnit, t["product.offer_period_in_days"] = l.periodInDays, t["product.offer_period_in_weeks"] = l.periodInWeeks, t["product.offer_period_in_months"] = l.periodInMonths, t["product.offer_period_in_years"] = l.periodInYears, t["product.offer_end_date"] = MP(o, r);
  }
  if (a !== null && (a.price !== null && (t["product.secondary_offer_price"] = r.formatPrice(
    a.price.amountMicros,
    a.price.currency
  )), a.period !== null)) {
    const l = us(a.period, r);
    t["product.secondary_offer_period"] = l.period, t["product.secondary_offer_period_abbreviated"] = l.periodAbbreviated;
  }
}
function jP(e, r, t) {
  var a;
  const n = ((a = e.discount) == null ? void 0 : a.price) ?? null;
  n !== null && (t["product.offer_price"] = r.formatPrice(
    n.amountMicros,
    n.currency
  ));
}
function zc(e, r = {}) {
  var a;
  if (r.translator)
    return Oc(e, r.translator);
  const t = ((a = e.paywallComponents) == null ? void 0 : a.default_locale) || Er, n = new cn(
    r.customTranslations ?? {},
    r.selectedLocale ?? t,
    r.fallbackLocale ?? t
  );
  return Oc(e, n);
}
function Lo(e) {
  var a;
  const r = e.webBillingProduct.price, t = hp(e), n = e.webBillingProduct.period || ((a = t == null ? void 0 : t.base) == null ? void 0 : a.period);
  if (!n || !n.number || n.number <= 0)
    return r.amountMicros;
  switch (n.unit) {
    case ce.Year:
      return r.amountMicros / ti;
    case ce.Month:
      return r.amountMicros / n.number;
    case ce.Week:
      return r.amountMicros * ri / n.number;
    case ce.Day:
      return r.amountMicros * ei / n.number;
    default:
      return r.amountMicros / (n.number || 1);
  }
}
function hp(e) {
  return e.webBillingProduct.productType === ut.Subscription ? e.webBillingProduct.defaultSubscriptionOption : e.webBillingProduct.productType === ut.NonConsumable || e.webBillingProduct.productType === ut.Consumable ? e.webBillingProduct.defaultNonSubscriptionOption : e.webBillingProduct.defaultPurchaseOption;
}
function NP(e, r) {
  return e === ut.Subscription && r != null;
}
function LP(e, r) {
  return e !== ut.Subscription && r != null;
}
function Mc(e, r, t, n = !1) {
  return t.translate($.PaywallVariablesPricePerPeriod, {
    formattedPrice: e,
    period: r.base.period ? r.base.period.number === 1 ? t.translatePeriodUnit(r.base.period.unit, {
      noWhitespace: !0,
      short: !n
    }) : t.translatePeriod(
      r.base.period.number,
      r.base.period.unit,
      {
        noWhitespace: !0,
        short: !n
      }
    ) : ""
  });
}
function Oc(e, r) {
  const t = e.availablePackages, n = t.filter(
    (o) => o.webBillingProduct.productType === ut.Subscription
  ), a = n.length > 0 ? n.reduce((o, s) => {
    const l = Lo(o), c = Lo(s);
    return l > c ? o : s;
  }) : null;
  return t.reduce(
    (o, s) => (o[s.identifier] = BP(
      s,
      a,
      r
    ), o),
    {}
  );
}
function BP(e, r, t) {
  const n = e.webBillingProduct, a = n.price, o = t.formatPrice(
    a.amountMicros,
    a.currency
  ), s = hp(e), l = n.productType, c = {
    "product.store_product_name": n.title,
    "product.price": o,
    "product.price_per_period": "",
    "product.price_per_period_abbreviated": "",
    "product.price_per_day": "",
    "product.price_per_week": "",
    "product.price_per_month": "",
    "product.price_per_year": "",
    "product.period": "",
    "product.period_abbreviated": "",
    "product.periodly": "",
    "product.period_in_days": "",
    "product.period_in_weeks": "",
    "product.period_in_months": "",
    "product.period_in_years": "",
    "product.period_with_unit": "",
    "product.currency_code": a.currency,
    "product.currency_symbol": t.formatPrice(0, a.currency).replace("0", ""),
    "product.offer_price": "",
    "product.offer_price_per_day": "",
    "product.offer_price_per_week": "",
    "product.offer_price_per_month": "",
    "product.offer_price_per_year": "",
    "product.offer_period": "",
    "product.offer_period_abbreviated": "",
    "product.offer_period_in_days": "",
    "product.offer_period_in_weeks": "",
    "product.offer_period_in_months": "",
    "product.offer_period_in_years": "",
    "product.offer_period_with_unit": "",
    "product.offer_end_date": "",
    "product.secondary_offer_price": "",
    "product.secondary_offer_period": "",
    "product.secondary_offer_period_abbreviated": "",
    "product.relative_discount": ""
  };
  if (NP(l, s)) {
    c["product.price_per_period_abbreviated"] = Mc(
      o,
      s,
      t
    ), c["product.price_per_period"] = Mc(
      o,
      s,
      t,
      !0
    );
    const u = n.period || s.base.period, d = mp(
      a,
      u,
      t
    );
    if (c["product.price_per_day"] = d.pricePerDay, c["product.price_per_week"] = d.pricePerWeek, c["product.price_per_month"] = d.pricePerMonth, c["product.price_per_year"] = d.pricePerYear, u) {
      const p = us(u, t);
      c["product.period"] = p.period, c["product.period_abbreviated"] = p.periodAbbreviated, c["product.period_with_unit"] = p.periodWithUnit, c["product.period_in_days"] = p.periodInDays, c["product.period_in_weeks"] = p.periodInWeeks, c["product.period_in_months"] = p.periodInMonths, c["product.period_in_years"] = p.periodInYears, c["product.periodly"] = t.translatePeriodFrequency(
        u.number,
        u.unit
      ) || "";
    }
    if (r) {
      const p = Lo(e), _ = Lo(r), g = (_ - p) * 100 / _;
      c["product.relative_discount"] = g < 1 ? "" : t.translate(
        $.PaywallVariablesSubRelativeDiscount,
        {
          discount: g.toFixed(0)
        }
      );
    }
    OP(s, t, c);
  }
  return LP(l, s) && (c["product.price"] = o, c["product.price_per_period"] = o, c["product.price_per_period_abbreviated"] = o, c["product.price_per_month"] = o, c["product.period_with_unit"] = t.translate(
    $.PeriodsLifetime
  ), c["product.period_in_months"] = t.translate(
    $.PeriodsLifetime
  ), c["product.periodly"] = t.translate(
    $.PeriodsLifetime
  ), c["product.price_per_week"] = "", c["product.relative_discount"] = "", c["product.period"] = "", c["product.period_abbreviated"] = "", jP(s, t, c)), c;
}
var UP = /(%?)(%([sdijo]))/g;
function RP(e, r) {
  switch (r) {
    case "s":
      return e;
    case "d":
    case "i":
      return Number(e);
    case "j":
      return JSON.stringify(e);
    case "o": {
      if (typeof e == "string")
        return e;
      const t = JSON.stringify(e);
      return t === "{}" || t === "[]" || /^\[object .+?\]$/.test(t) ? e : t;
    }
  }
}
function ol(e, ...r) {
  if (r.length === 0)
    return e;
  let t = 0, n = e.replace(
    UP,
    (a, o, s, l) => {
      const c = r[t], u = RP(c, l);
      return o ? a : (t++, u);
    }
  );
  return t < r.length && (n += ` ${r.slice(t).join(" ")}`), n = n.replace(/%{2,2}/g, "%"), n;
}
var VP = 2;
function HP(e) {
  if (!e.stack)
    return;
  const r = e.stack.split(`
`);
  r.splice(1, VP), e.stack = r.join(`
`);
}
var WP = class extends Error {
  constructor(e, ...r) {
    super(e), this.message = e, this.name = "Invariant Violation", this.message = ol(e, ...r), HP(this);
  }
}, yp = (e, r, ...t) => {
  if (!e)
    throw new WP(r, ...t);
};
yp.as = (e, r, t, ...n) => {
  if (!r) {
    const a = n.length === 0 ? t : ol(t, ...n);
    let o;
    try {
      o = Reflect.construct(e, [
        a
      ]);
    } catch {
      o = e(a);
    }
    throw o;
  }
};
const YP = "[MSW]";
function il(e, ...r) {
  const t = ol(e, ...r);
  return `${YP} ${t}`;
}
function GP(e, ...r) {
  console.warn(il(e, ...r));
}
function KP(e, ...r) {
  console.error(il(e, ...r));
}
const XP = {
  formatMessage: il,
  warn: GP,
  error: KP
};
function $P() {
  yp(
    typeof URL < "u",
    XP.formatMessage(
      `Global "URL" class is not defined. This likely means that you're running MSW in an environment that doesn't support all Node.js standard API (e.g. React Native). If that's the case, please use an appropriate polyfill for the "URL" class, like "react-native-url-polyfill".`
    )
  );
}
var bp = /* @__PURE__ */ ((e) => (e.HEAD = "HEAD", e.GET = "GET", e.POST = "POST", e.PUT = "PUT", e.PATCH = "PATCH", e.OPTIONS = "OPTIONS", e.DELETE = "DELETE", e))(bp || {});
$P();
class ZP {
  constructor(r, t, n, a) {
    V(this, "initialDelay");
    V(this, "maxDelay");
    V(this, "jitterPercent");
    V(this, "callback");
    V(this, "currentDelay");
    V(this, "timeoutId");
    V(this, "executingCallback", !1);
    V(this, "stopped", !1);
    V(this, "currentFlushPromise", null);
    this.initialDelay = r, this.currentDelay = r, this.maxDelay = t, this.jitterPercent = n, this.callback = a;
  }
  tryFlush() {
    if (!this.stopped) {
      if (this.backingOff()) {
        ne.debugLog("Backing off, not flushing");
        return;
      }
      this.clearTimeout(), this.executeCallbackWithRetries().catch(() => {
      });
    }
  }
  start() {
    this.stopped = !1, this.currentDelay = this.initialDelay;
  }
  stop() {
    this.stopped = !0, this.clearTimeout();
  }
  /**
   * Clears any scheduled flush and runs the callback once.
   * Returns the callback result (true = queue empty).
   * Runs the callback even when stopped (used by flushUntilDrain).
   */
  flushImmediately(r) {
    return this.clearTimeout(), this.executeCallbackWithRetries(r);
  }
  /**
   * Waits for any in-flight flush, then stops scheduling, runs the callback until it reports queue empty (or throws), then starts again.
   */
  async flushUntilDrain(r) {
    const t = this.currentFlushPromise;
    if (t)
      try {
        await t;
      } catch {
      }
    this.stop();
    try {
      let n = !1;
      for (; !n; )
        n = await this.flushImmediately(r);
    } finally {
      this.start();
    }
  }
  schedule(r) {
    if (this.stopped || this.timeoutId !== void 0)
      return;
    const t = this.addJitter(r || this.currentDelay);
    this.timeoutId = setTimeout(() => {
      this.timeoutId = void 0, this.executeCallbackWithRetries().catch(() => {
      });
    }, t);
  }
  backoff() {
    const r = this.currentDelay, t = Math.min(this.currentDelay * 2, this.maxDelay);
    ne.debugLog(`Backing next off to ${r}ms delay`), this.clearTimeout(), this.currentDelay = t, this.schedule(r);
  }
  reset() {
    this.currentDelay !== this.initialDelay && (this.clearTimeout(), this.currentDelay = this.initialDelay);
  }
  async executeCallbackWithRetries(r) {
    if (this.executingCallback)
      return ne.debugLog("Callback already running, rescheduling"), this.schedule(), !0;
    this.executingCallback = !0;
    let t;
    try {
      t = Promise.resolve(this.callback(r));
    } catch (n) {
      t = Promise.reject(n);
    }
    this.currentFlushPromise = t.then(
      () => {
      },
      () => {
      }
    );
    try {
      const n = await t;
      return this.reset(), n;
    } catch {
      return this.backoff(), !0;
    } finally {
      this.executingCallback = !1, this.currentFlushPromise = null;
    }
  }
  backingOff() {
    return this.currentDelay > this.initialDelay;
  }
  clearTimeout() {
    clearTimeout(this.timeoutId), this.timeoutId = void 0;
  }
  addJitter(r) {
    const t = r * this.jitterPercent, n = r - t, a = r + t;
    return Math.floor(Math.random() * (a - n + 1) + n);
  }
}
class jc {
  constructor(r) {
    V(this, "id");
    V(this, "timestamp");
    V(this, "data");
    this.id = Tn(), this.timestamp = Date.now(), this.data = r;
  }
  toJSON() {
    const r = {
      type: this.data.type,
      version: 1,
      id: this.id,
      app_user_id: this.data.appUserId,
      session_id: this.data.sessionId,
      offering_id: this.data.offeringId,
      paywall_revision: this.data.paywallRevision,
      timestamp: this.timestamp,
      paywall_rc_public_id: this.data.paywallRcPublicId
    };
    return this.data.displayMode !== void 0 && (r.display_mode = this.data.displayMode, r.dark_mode = this.data.darkMode ?? !1, r.locale = this.data.locale ?? "en_US"), r;
  }
}
function Rn() {
  if (typeof window < "u")
    return window;
  throw new je(
    We.UnsupportedError,
    "window is not available. This SDK requires a browser environment for this operation."
  );
}
function Bo() {
  if (typeof window < "u")
    return window;
}
function hs() {
  if (typeof document < "u")
    return document;
  throw new je(
    We.UnsupportedError,
    "document is not available. This SDK requires a browser environment for this operation."
  );
}
function JP() {
  if (typeof document < "u")
    return document;
}
function QP(e, r) {
  const t = Bo(), n = t != null && t.location ? new URLSearchParams(t.location.search) : new URLSearchParams();
  let a = null, o = null;
  typeof screen < "u" && screen && (a = screen.width, o = screen.height);
  const s = JP(), l = (s == null ? void 0 : s.referrer) ?? null, c = (s == null ? void 0 : s.title) ?? null;
  return {
    libraryName: "purchases-js",
    libraryVersion: rp,
    locale: navigator.language,
    userAgent: navigator.userAgent,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    screenWidth: a,
    screenHeight: o,
    utmSource: n.get("utm_source") ?? null,
    utmMedium: n.get("utm_medium") ?? null,
    utmCampaign: n.get("utm_campaign") ?? null,
    utmContent: n.get("utm_content") ?? null,
    utmTerm: n.get("utm_term") ?? null,
    pageReferrer: l,
    pageUrl: t != null && t.location ? `${t.location.origin}${t.location.pathname}` : "",
    pageTitle: c,
    source: e,
    rcSource: r
  };
}
const e1 = 2e3, r1 = 5 * 6e4, t1 = 0.1, Nc = 50 * 1024;
class n1 {
  constructor(r) {
    V(this, "apiKey");
    V(this, "eventsQueue", []);
    V(this, "eventsUrl");
    V(this, "flushManager");
    V(this, "traceId");
    V(this, "appUserId");
    V(this, "isSilent");
    V(this, "rcSource");
    V(this, "workflowContext");
    V(this, "isDisposed", !1);
    var t;
    this.apiKey = r.apiKey, this.eventsUrl = `${((t = r.httpConfig) == null ? void 0 : t.eventsURL) ?? nP}/v1/events`, this.appUserId = r.appUserId, this.isSilent = r.silent || !1, this.rcSource = r.rcSource, this.workflowContext = r.workflowContext, this.traceId = r.trace_id || Tn(), this.flushManager = new ZP(
      e1,
      r1,
      t1,
      this.doFlush.bind(this)
    );
  }
  async updateUser(r) {
    this.appUserId = r;
  }
  getTraceId() {
    return this.traceId;
  }
  trackSDKEvent(r) {
    this.trackEvent({ ...r, source: "sdk" });
  }
  trackExternalEvent(r) {
    this.trackEvent({ ...r });
  }
  trackPaywallEvent(r) {
    if (this.isSilent) {
      ne.verboseLog("Skipping event tracking, the EventsTracker is silent");
      return;
    }
    try {
      const t = new jc(r);
      ne.debugLog(
        `[PaywallEvent] Queuing ${r.type} (queue size: ${this.eventsQueue.length + 1}, url: ${this.eventsUrl})`
      ), ne.debugLog(
        `[PaywallEvent] Payload: ${JSON.stringify(t.toJSON())}`
      ), this.eventsQueue.push(t), this.flushManager.tryFlush();
    } catch (t) {
      ne.errorLog(
        `Error while tracking paywall event ${r.type}: ${t}`
      );
    }
  }
  trackEvent(r) {
    var t;
    if (this.isSilent) {
      ne.verboseLog("Skipping event tracking, the EventsTracker is silent");
      return;
    }
    try {
      const n = new Jy({
        eventName: r.eventName,
        traceId: this.traceId,
        appUserId: this.appUserId,
        context: QP(r.source, this.rcSource),
        workflowIdentifier: (t = this.workflowContext) == null ? void 0 : t.workflowIdentifier,
        properties: r.properties || {
          mode: Dr
        }
      });
      this.eventsQueue.push(n), this.flushManager.tryFlush();
    } catch (n) {
      ne.errorLog(
        `Error while tracking event ${r.eventName}: ${n}`
      );
    }
  }
  dispose() {
    this.isDisposed || (this.flushManager.stop(), this.eventsQueue.length > 0 && this.flushManager.flushUntilDrain({ ignoreDisposed: !0 }).catch((r) => {
      ne.debugLog(`Failed to flush events on dispose: ${r}`);
    }), this.isDisposed = !0);
  }
  async flushAllEvents() {
    this.isDisposed || (await this.flushManager.flushUntilDrain(), !this.isDisposed && this.eventsQueue.length > 0 && this.flushManager.schedule());
  }
  estimateSingleEventSize(r) {
    try {
      return JSON.stringify(r).length;
    } catch {
      return Nc;
    }
  }
  /**
   * Builds a batch of events that fits within browser keepalive size limit.
   * Browsers impose ~64KB limit on fetch() requests with keepalive:true.
   * https://developer.mozilla.org/en-US/docs/Web/API/RequestInit#keepalive
   * Returns null if the first event exceeds the limit (and removes it from queue).
   */
  batchEventsForKeepalive() {
    const r = [];
    let t = 16;
    for (const n of this.eventsQueue) {
      const a = this.estimateSingleEventSize(n), o = r.length > 0 ? 1 : 0, s = t + a + o;
      if (s <= Nc)
        r.push(n), t = s;
      else if (r.length === 0) {
        const l = n instanceof jc ? n.data.type : n.data.eventName;
        return ne.warnLog(
          `Event exceeds keepalive size limit (${a} bytes): ${l}`
        ), this.eventsQueue.shift(), null;
      } else
        break;
    }
    return r;
  }
  doFlush(r) {
    if (!(r != null && r.ignoreDisposed) && this.isDisposed || this.eventsQueue.length === 0)
      return Promise.resolve(!0);
    const t = this.batchEventsForKeepalive();
    if (!t)
      return Promise.resolve(this.eventsQueue.length === 0);
    const n = JSON.stringify({ events: t });
    return ne.debugLog(
      `[EventsTracker] Flushing ${t.length} event(s) to ${this.eventsUrl}`
    ), ne.debugLog(`[EventsTracker] Body: ${n}`), fetch(this.eventsUrl, {
      method: bp.POST,
      headers: _p(this.apiKey),
      body: n,
      keepalive: !0
    }).then((a) => {
      if (ne.debugLog(`[EventsTracker] Flush response: ${a.status}`), a.status === 200 || a.status === 201)
        return this.eventsQueue.splice(0, t.length), this.eventsQueue.length > 0 && this.flushManager.schedule(), this.eventsQueue.length === 0;
      throw ne.debugLog("Events failed to flush due to server error"), new Error("Events failed to flush due to server error");
    }).catch((a) => {
      throw ne.debugLog(`[EventsTracker] Flush error: ${a}`), a;
    });
  }
}
const mo = () => {
  const e = Bo(), r = e != null && e.location ? new URLSearchParams(e.location.search) : new URLSearchParams(), t = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content"
  ], n = {};
  return t.forEach((a) => {
    const o = r.get(a);
    o !== null && (n[a] = o);
  }), n;
}, a1 = ["app", "embedded"], Li = {
  autoCollectUTMAsMetadata: !0,
  collectAnalyticsEvents: !0,
  storeLoadTime: "configuration"
};
var o1 = /* @__PURE__ */ B('<p class="svelte-17914yi"><strong>Free Trial:</strong> </p>'), i1 = /* @__PURE__ */ B('<p class="svelte-17914yi"><strong>Intro Price:</strong> </p>'), s1 = /* @__PURE__ */ B('<p class="svelte-17914yi"><strong>Discount Price:</strong> </p>'), l1 = /* @__PURE__ */ B('<div class="rc-simulated-store-modal-overlay svelte-17914yi"><div class="rc-simulated-store-modal svelte-17914yi"><div class="rc-simulated-store-modal-content svelte-17914yi"><h2 class="rc-simulated-store-modal-title svelte-17914yi">Test Store Purchase</h2> <div class="rc-simulated-store-modal-details svelte-17914yi"><div><p class="svelte-17914yi"><strong>Product:</strong> </p> <p class="svelte-17914yi"><strong>Type:</strong> </p> <p class="svelte-17914yi"><strong>Price:</strong> </p> <!> <!> <!></div></div> <div class="rc-simulated-store-modal-buttons svelte-17914yi"><button type="button" class="rc-simulated-store-modal-button rc-simulated-store-modal-button-primary svelte-17914yi">Test valid purchase</button> <button type="button" class="rc-simulated-store-modal-button rc-simulated-store-modal-button-secondary svelte-17914yi">Test failed purchase</button> <button type="button" class="rc-simulated-store-modal-button rc-simulated-store-modal-button-cancel svelte-17914yi">Cancel</button></div></div></div></div>');
const c1 = {
  hash: "svelte-17914yi",
  code: `.rc-simulated-store-modal-overlay.svelte-17914yi {position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0, 0, 0, 0.5);display:flex;justify-content:center;align-items:center;font-family:-apple-system,
      BlinkMacSystemFont,
      avenir next,
      avenir,
      segoe ui,
      helvetica neue,
      helvetica,
      Cantarell,
      Ubuntu,
      roboto,
      noto,
      arial,
      sans-serif;
    /** One more than the paywall */z-index:1000002;}.rc-simulated-store-modal.svelte-17914yi {background:white;border-radius:8px;padding:0;max-width:500px;width:90%;max-height:90%;overflow-y:auto;box-shadow:0 4px 20px rgba(0, 0, 0, 0.15);}.rc-simulated-store-modal-content.svelte-17914yi {padding:24px;}.rc-simulated-store-modal-title.svelte-17914yi {margin:0 0 20px 0;font-size:24px;font-weight:600;color:#333;}.rc-simulated-store-modal-details.svelte-17914yi {margin-bottom:24px;}.rc-simulated-store-modal-details.svelte-17914yi p:where(.svelte-17914yi) {margin:8px 0;color:#666;line-height:1.5;}.rc-simulated-store-modal-buttons.svelte-17914yi {display:flex;flex-direction:column;gap:12px;}.rc-simulated-store-modal-button.svelte-17914yi {padding:12px 24px;border:none;border-radius:6px;font-size:16px;font-weight:500;cursor:pointer;transition:background-color 0.2s ease;}.rc-simulated-store-modal-button-primary.svelte-17914yi {background-color:#007aff;color:white;}.rc-simulated-store-modal-button-primary.svelte-17914yi:hover {background-color:#0056cc;}.rc-simulated-store-modal-button-secondary.svelte-17914yi {background-color:#ff3b30;color:white;}.rc-simulated-store-modal-button-secondary.svelte-17914yi:hover {background-color:#cc2e24;}.rc-simulated-store-modal-button-cancel.svelte-17914yi {background-color:#f2f2f7;color:#333;}.rc-simulated-store-modal-button-cancel.svelte-17914yi:hover {background-color:#e5e5ea;}

  /* Mobile responsive - full screen on small screens */
  @media (max-width: 768px) {.rc-simulated-store-modal-overlay.svelte-17914yi {padding:0;}.rc-simulated-store-modal.svelte-17914yi {width:100%;height:100%;border-radius:0;max-width:none;max-height:none;}.rc-simulated-store-modal-content.svelte-17914yi {height:100%;display:flex;flex-direction:column;justify-content:center;}
  }`
};
function u1(e, r) {
  ee(r, !1), oe(e, c1);
  let t = K(r, "productIdentifier", 8), n = K(r, "productType", 8), a = K(r, "basePrice", 8), o = K(r, "freeTrialPeriod", 8, void 0), s = K(r, "introPriceFormatted", 8, void 0), l = K(r, "discountFormatted", 8, void 0), c = K(r, "onValidPurchase", 8), u = K(r, "onFailedPurchase", 8), d = K(r, "onCancel", 8);
  function p(q) {
    q.target === q.currentTarget && d()();
  }
  An();
  var _ = l1(), g = z(_), h = z(g), w = R(z(h), 2), v = z(w), f = z(v), y = R(z(f)), k = R(f, 2), m = R(z(k)), S = R(k, 2), x = R(z(S)), P = R(S, 2);
  {
    var I = (q) => {
      var O = o1(), G = R(z(O));
      U(() => pe(G, ` ${o() ?? ""}`)), T(q, O);
    };
    W(P, (q) => {
      o() && q(I);
    });
  }
  var E = R(P, 2);
  {
    var D = (q) => {
      var O = i1(), G = R(z(O));
      U(() => pe(G, ` ${s() ?? ""}`)), T(q, O);
    };
    W(E, (q) => {
      s() && q(D);
    });
  }
  var F = R(E, 2);
  {
    var M = (q) => {
      var O = s1(), G = R(z(O));
      U(() => pe(G, ` ${l() ?? ""}`)), T(q, O);
    };
    W(F, (q) => {
      l() && q(M);
    });
  }
  var C = R(w, 2), j = z(C), H = R(j, 2), A = R(H, 2);
  U(() => {
    pe(y, ` ${t() ?? ""}`), pe(m, ` ${n() ?? ""}`), pe(x, ` ${a() ?? ""}`);
  }), Vr("click", j, function(...q) {
    var O;
    (O = c()) == null || O.apply(this, q);
  }), Vr("click", H, function(...q) {
    var O;
    (O = u()) == null || O.apply(this, q);
  }), Vr("click", A, function(...q) {
    var O;
    (O = d()) == null || O.apply(this, q);
  }), Vr("click", _, p), T(e, _), re();
}
async function vp(e, r, t, n) {
  const a = /* @__PURE__ */ new Date(), o = `test_${a.getTime()}_${Tn()}`, s = `test_store_operation_session_${Tn()}`, c = {
    storeTransactionId: o,
    productIdentifier: e.identifier,
    purchaseDate: a
  }, u = await r.postReceipt(
    t,
    e.identifier,
    e.price.currency,
    o,
    e.presentedOfferingContext,
    "purchase",
    n
  );
  return {
    customerInfo: gs(u),
    redemptionInfo: null,
    operationSessionId: s,
    storeTransaction: c
  };
}
function d1(e, r, t) {
  const n = e.rcPackage.webBillingProduct, a = n.productType, o = n.freeTrialPhase, s = n.introPricePhase, l = n.discountPhase, c = n.price, u = (d) => d ? `${d.number} ${d.unit}${d.number > 1 ? "s" : ""}` : "N/A";
  return new Promise((d, p) => {
    var v, f;
    const _ = hs(), g = _.createElement("div");
    _.body.appendChild(g);
    const h = () => {
      w && Ia(w), _.body.removeChild(g);
    };
    let w = null;
    w = Gn(u1, {
      target: g,
      props: {
        productIdentifier: n.identifier,
        productType: a,
        basePrice: c.formattedPrice,
        freeTrialPeriod: o ? u(o.period) : void 0,
        introPriceFormatted: (v = s == null ? void 0 : s.price) == null ? void 0 : v.formattedPrice,
        discountFormatted: (f = l == null ? void 0 : l.price) == null ? void 0 : f.formattedPrice,
        onValidPurchase: async () => {
          h(), ne.debugLog(
            "[Test store] Performing test purchase. This purchase won't appear in production."
          );
          try {
            d(
              await vp(
                n,
                r,
                t,
                e.paywallId
              )
            );
          } catch (y) {
            p(y);
          }
        },
        onFailedPurchase: () => {
          h(), ne.debugLog(
            "[Test store] Purchase failure simulated successfully in Test Store."
          ), p(
            new je(
              We.TestStoreSimulatedPurchaseError,
              Jn.getPublicMessage(
                We.TestStoreSimulatedPurchaseError
              ),
              "Simulated error successfully."
            )
          );
        },
        onCancel: () => {
          h(), p(new je(We.UserCancelledError));
        }
      }
    });
  });
}
class p1 {
  constructor() {
    V(this, "virtualCurrenciesCache", /* @__PURE__ */ new Map());
    V(this, "CACHE_EXPIRY_MS", 5 * 60 * 1e3);
  }
  // 5 minutes
  invalidateAllCaches() {
    this.virtualCurrenciesCache.clear();
  }
  cacheVirtualCurrencies(r, t) {
    this.virtualCurrenciesCache.set(r, {
      data: t,
      lastUpdatedAt: Date.now()
    });
  }
  /**
   * Retrieves cached virtual currencies for a given app user.
   *
   * @param appUserID - The unique identifier for the app user
   * @param allowStaleCache - If true, returns cached data regardless of age; if false, respects cache expiry
   * @returns The cached virtual currencies or null if not found or expired
   */
  getCachedVirtualCurrencies(r, t = !1) {
    const n = this.virtualCurrenciesCache.get(r);
    return this.getCachedData(n ?? null, t);
  }
  invalidateVirtualCurrenciesCache(r) {
    this.virtualCurrenciesCache.delete(r);
  }
  /**
   * Generic method to retrieve cached data with expiry checking.
   *
   * @param entry - The cache entry containing the data and timestamp
   * @param allowStaleCache - If true, bypasses expiry checks and returns data regardless of age
   * @returns The cached data or null if not found or expired (when allowStaleCache is false)
   */
  getCachedData(r, t = !1) {
    return r ? t ? r.data : Date.now() - r.lastUpdatedAt >= this.CACHE_EXPIRY_MS ? null : r.data : null;
  }
}
function _1(e) {
  return {
    balance: e.balance,
    name: e.name,
    code: e.code,
    serverDescription: e.description ?? null
  };
}
function g1(e) {
  const r = {};
  for (const [t, n] of Object.entries(
    e.virtual_currencies
  ))
    r[t] = _1(n);
  return {
    all: r
  };
}
function f1(e) {
  const r = e.webBillingProduct, t = r.productType === ut.Subscription, n = r.defaultSubscriptionOption;
  if (t && n)
    return {
      hasTrial: n.trial !== null,
      hasIntroOffer: n.introPrice !== null,
      hasPromoOffer: n.discount !== null
    };
  const a = r.defaultNonSubscriptionOption;
  return !t && a ? {
    hasTrial: !1,
    hasIntroOffer: !1,
    hasPromoOffer: a.discount !== null
  } : {};
}
function m1(e) {
  const r = Object.entries(e.packagesById).map(
    ([t, n]) => [t, f1(n)]
  );
  return Object.fromEntries(r);
}
const h1 = (e, r) => {
  var n;
  const t = ((n = e.subscriptionOptions) == null ? void 0 : n[r]) || e.defaultSubscriptionOption;
  if (!t)
    throw new ae(Q.ErrorSettingUpPurchase);
  return t;
}, y1 = (e, r) => {
  const t = Qs(
    e,
    r
  );
  return {
    currency: t.currency,
    taxCalculationStatus: "unavailable",
    totalAmountInMicros: t.amountMicros,
    totalExcludingTaxInMicros: t.amountMicros,
    taxAmountInMicros: null,
    taxBreakdown: null
  };
}, b1 = (e, r) => {
  const t = h1(
    e,
    r
  ), n = y1(
    e,
    t
  );
  return { subscriptionOption: t, priceBreakdown: n };
}, kp = (e, r, t, n) => {
  const a = e.webBillingProduct, { subscriptionOption: o, priceBreakdown: s } = b1(a, r.id);
  return Ve.buildStripeExpressCheckoutOptionsForSubscription(
    a,
    s,
    o,
    n,
    t,
    2,
    1
  );
}, Lc = (e, r, t, n, a, o) => {
  if (!r.elements_configuration)
    throw new ae(Q.ErrorSettingUpPurchase);
  return Ve.updateElementsConfiguration(
    e,
    r.elements_configuration
  ), { expOptions: kp(
    n,
    a,
    t,
    o
  ) };
}, v1 = async (e, r, t, n, a, o) => {
  var v, f;
  if (!e.elements_configuration)
    throw new ae(Q.ErrorSettingUpPurchase);
  const s = e.stripe_account_id, l = e.publishable_api_key, c = Ve.getStripeLocale(
    a.bcp47Locale || a.fallbackBcp47Locale
  ), u = {
    // Floating labels size cannot be overriden in Stripe since `!important` is being used.
    // There we set fontSizeBase to the desired label size
    // and update the input font size to 16px.
    fontSizeBase: "14px",
    fontFamily: La,
    // Spacing is hardcoded to 16px to match the desired gaps in mobile/desktop
    // which do not match the design system spacing. Also we cannot use "rem" units
    // since the fontSizeBase is set to 14px per the comment above.
    spacingGridRow: "16px"
  }, d = ((v = Bo()) == null ? void 0 : v.matchMedia) && ((f = Bo()) == null ? void 0 : f.matchMedia("(max-width: 767px)").matches);
  let p = "mobile";
  if (d ? p = "mobile" : p = "desktop", !s || !l)
    throw new ae(Q.ErrorSettingUpPurchase);
  const _ = e.elements_configuration, { stripe: g, elements: h } = await Ve.initializeStripe(
    s,
    l,
    _,
    o,
    c,
    u,
    p
  ), w = kp(
    t,
    n,
    r,
    a
  );
  return { stripeInstance: g, elementsInstance: h, expOptions: w };
};
var k1 = /* @__PURE__ */ B("<div><!></div>");
function w1(e, r) {
  var I;
  ee(r, !0);
  const t = "express_purchase_button";
  let n = gr(r.translator);
  const a = gr(((I = r.brandingInfo) == null ? void 0 : I.appearance) ?? null);
  $e(dr, n), $e(va, a);
  let o = /* @__PURE__ */ X(!0), s = /* @__PURE__ */ X(!1), l = /* @__PURE__ */ X(null), c = /* @__PURE__ */ X(null), u = /* @__PURE__ */ X(null);
  const d = (E) => {
    const D = Cd({
      errorCode: E.getErrorCode().toString(),
      errorMessage: E.message,
      mode: t
    });
    r.eventsTracker.trackSDKEvent(D), r.onError(E);
  };
  let p = !1;
  const _ = async () => {
    if (p)
      return;
    p = !0;
    let E;
    try {
      E = await r.purchaseOperationHelper.prepareCheckout(r.rcPackage.webBillingProduct.identifier, r.purchaseOption);
    } catch (F) {
      d(F);
      return;
    }
    if (!E.stripe_gateway_params) {
      const F = new ae(Q.ErrorSettingUpPurchase, "We couldn’t download Stripe params for this purchase. Please try again.");
      d(F);
      return;
    }
    const D = "http://blank";
    try {
      if (!i(c) || !i(l)) {
        const { stripeInstance: F, elementsInstance: M, expOptions: C } = await v1(E.stripe_gateway_params, D, r.rcPackage, r.purchaseOption, r.translator, r.brandingInfo);
        L(c, F, !0), L(l, M, !0), L(u, C, !0);
      } else {
        const { expOptions: F } = Lc(i(l), E.stripe_gateway_params, D, r.rcPackage, r.purchaseOption, r.translator);
        L(u, F, !0);
      }
    } catch (F) {
      d(F);
      return;
    }
    L(o, !1);
  };
  kr(() => {
    p = !1, _().then(() => {
    });
  });
  const g = (E) => {
    const D = os({
      errorCode: E.gatewayErrorCode ?? null,
      errorMessage: E.message ?? "",
      mode: t
    });
    r.eventsTracker.trackSDKEvent(D), d(new ae(Q.ErrorSettingUpPurchase, "Failed to initialize payment form", E.message));
  }, h = async (E, D) => {
    var C;
    const {
      customerDetails: F,
      confirmationTokenId: M
    } = await Ve.extractTaxCustomerDetails(E, D);
    if ((C = r.brandingInfo) != null && C.gateway_tax_collection_enabled) {
      const j = await r.purchaseOperationHelper.checkoutCalculateTax(F.countryCode, F.postalCode), H = Ad({ taxCalculation: j, taxCustomerDetails: F, mode: t });
      r.eventsTracker.trackSDKEvent(H);
    }
    return M;
  };
  async function w(E) {
    var C, j;
    if (!i(l) || !i(c)) return !1;
    await Ve.submitElements(i(l));
    const D = await r.purchaseOperationHelper.checkoutComplete(E), F = (C = D == null ? void 0 : D.gateway_params) == null ? void 0 : C.client_secret;
    if (!F)
      return !1;
    const M = (j = r.brandingInfo) != null && j.gateway_tax_collection_enabled ? await h(i(l), i(c)) : void 0;
    return await Ve.confirmElements(i(c), i(l), F, M), !0;
  }
  const v = async (E, D, F) => {
    if (i(s))
      return;
    const M = qd({ selectedPaymentMethod: E ?? null, mode: t });
    r.eventsTracker.trackSDKEvent(M), L(s, !0);
    try {
      const C = await w(D);
      if (L(s, !1), !C)
        return;
      const j = await r.purchaseOperationHelper.pollCurrentPurchaseForCompletion();
      r.onFinished(j), L(s, !1);
    } catch (C) {
      if (C instanceof ae)
        d(C);
      else if (C instanceof Zn) {
        const j = os({
          errorCode: C.gatewayErrorCode ?? null,
          errorMessage: C.message ?? "",
          mode: t
        });
        r.eventsTracker.trackSDKEvent(j), d(new ae(Q.ErrorSettingUpPurchase, "Failed to complete payment", C.message));
      }
      F.paymentFailed(), L(s, !1);
    }
  }, f = async () => {
    var D;
    const E = ko({
      appearance: (D = r.brandingInfo) == null ? void 0 : D.appearance,
      rcPackage: r.rcPackage,
      purchaseOptionToUse: r.purchaseOption,
      customerEmail: r.customerEmail,
      mode: "express_purchase_button"
    });
    r.eventsTracker.trackSDKEvent(E);
    try {
      const F = await r.purchaseOperationHelper.checkoutStart(r.appUserId, r.rcPackage.webBillingProduct.identifier, r.purchaseOption, r.rcPackage.webBillingProduct.presentedOfferingContext, r.customerEmail, r.metadata), M = F.management_url;
      if (!i(l))
        throw new ae(Q.ErrorSettingUpPurchase);
      const { expOptions: C } = Lc(i(l), F.gateway_params, M, r.rcPackage, r.purchaseOption, r.translator);
      return { applePay: C.applePay };
    } catch (F) {
      throw d(F instanceof ae ? F : new ae(Q.ErrorSettingUpPurchase)), F;
    }
  }, y = (E) => {
    f().then((D) => E.resolve(D));
  }, k = () => {
    r.eventsTracker.trackSDKEvent(Dd({ mode: "express_purchase_button" }));
  };
  function m(E) {
    var F, M;
    const D = ((F = E.availablePaymentMethods) == null ? void 0 : F.applePay) || ((M = E.availablePaymentMethods) == null ? void 0 : M.googlePay);
    r.onReady && r.onReady(!!D);
  }
  var S = k1(), x = z(S);
  {
    var P = (E) => {
      {
        let D = /* @__PURE__ */ b(() => {
          var F;
          return (F = r.brandingInfo) == null ? void 0 : F.gateway_tax_collection_enabled;
        });
        Nd(E, {
          get elements() {
            return i(l);
          },
          onError: g,
          onSubmit: v,
          onClick: y,
          onCancel: k,
          onReady: m,
          get expressCheckoutOptions() {
            return i(u);
          },
          forceEnableWalletMethods: !1,
          get billingAddressRequired() {
            return i(D);
          },
          hideCheckoutSeparator: !0
        });
      }
    };
    W(x, (E) => {
      !i(o) && i(l) && i(u) && r.brandingInfo && E(P);
    });
  }
  T(e, S), re();
}
var ia;
class P1 {
  constructor(r, t, n) {
    we(this, ia);
    V(this, "button");
    ke(this, ia, /* @__PURE__ */ X(Xe({ props: n })));
    const o = { updatePurchase: (s, l) => {
      this.changePackage(s, l);
    } };
    this.state.props.onReady = (s) => {
      t(o, s);
    }, this.button = Gn(w1, { target: r, props: this.state.props });
  }
  get state() {
    return i(N(this, ia));
  }
  set state(r) {
    L(N(this, ia), r, !0);
  }
  changePackage(r, t) {
    this.state.props && (this.state.props.rcPackage = r, this.state.props.purchaseOption = t ?? r.webBillingProduct.defaultPurchaseOption);
  }
}
ia = new WeakMap();
var x1 = /* @__PURE__ */ ((e) => (e.DisplayName = "$displayName", e.Email = "$email", e.PhoneNumber = "$phoneNumber", e.IDFA = "$idfa", e.IDFV = "$idfv", e.GPSAdId = "$gpsAdId", e.AndroidId = "$androidId", e.AmazonAdId = "$amazonAdId", e.IP = "$ip", e.AdjustId = "$adjustId", e.AmplitudeDeviceId = "$amplitudeDeviceId", e.AmplitudeUserId = "$amplitudeUserId", e.AppsflyerId = "$appsflyerId", e.AppsflyerSharingFilter = "$appsflyerSharingFilter", e.BranchId = "$branchId", e.BrazeAliasName = "$brazeAliasName", e.BrazeAliasLabel = "$brazeAliasLabel", e.ClevertapId = "$clevertapId", e.FbAnonId = "$fbAnonId", e.MparticleId = "$mparticleId", e.OnesignalId = "$onesignalId", e.OnesignalUserId = "$onesignalUserId", e.IntercomContactId = "$intercomContactId", e.MediaSource = "$mediaSource", e.Campaign = "$campaign", e.AdGroup = "$adGroup", e.AdId = "$ad", e.Keyword = "$keyword", e.Creative = "$creative", e.APNSTokens = "$apnsTokens", e.FCMTokens = "$fcmTokens", e.AirshipChannelId = "$airshipChannelId", e.SegmentId = "$segmentId", e.IterableUserId = "$iterableUserId", e.IterableCampaignId = "$iterableCampaignId", e.IterableTemplateId = "$iterableTemplateId", e.FirebaseAppInstanceId = "$firebaseAppInstanceId", e.MixpanelDistinctId = "$mixpanelDistinctId", e.ATTConsentStatus = "$attConsentStatus", e.KochavaDeviceId = "$kochavaDeviceId", e.DeviceVersion = "$deviceVersion", e.PosthogUserId = "$posthogUserId", e.TelemetryDeckUserId = "$telemetryDeckUserId", e.TelemetryDeckAppId = "$telemetryDeckAppId", e.AppleRefundHandlingPreference = "$appleRefundHandlingPreference", e.CustomerioId = "$customerioId", e.TenjinId = "$tenjinId", e))(x1 || {});
const Bc = "$RCAnonymousID:";
var Rc, Vc, ho;
Vc = [Fc], Rc = [Fc];
const Qe = class Qe {
  /** @internal */
  constructor(r, t, n = ms, a = Li, o, s) {
    gl(ho, 5, this);
    /** @internal */
    V(this, "_API_KEY");
    /** @internal */
    V(this, "_appUserId");
    /** @internal */
    V(this, "_brandingInfo", null);
    /** @internal */
    V(this, "_loadingResourcesPromise", null);
    /** @internal */
    V(this, "_flags");
    /** @internal */
    V(this, "_context");
    /** @internal */
    V(this, "backend");
    /** @internal */
    V(this, "purchaseOperationHelper");
    /** @internal */
    V(this, "eventsTracker");
    /** @internal */
    V(this, "inMemoryCache");
    var l;
    this._API_KEY = r, this._appUserId = t, this._flags = { ...Li, ...a }, this._context = o, No(r) ? ne.debugLog(
      "Initializing Purchases SDK with Web billing sandbox API Key"
    ) : mn(r) && ne.debugLog("Initializing Purchases SDK with RC Test store API Key."), this.eventsTracker = new n1({
      apiKey: this._API_KEY,
      appUserId: this._appUserId,
      silent: !this._flags.collectAnalyticsEvents,
      rcSource: this._flags.rcSource ?? null,
      workflowContext: (l = this._context) == null ? void 0 : l.workflowContext,
      trace_id: s,
      httpConfig: n
    }), this.backend = new xP(this._API_KEY, n, this._context), this.inMemoryCache = new p1(), this.purchaseOperationHelper = new gg(
      this.backend,
      this.eventsTracker
    ), this.eventsTracker.trackSDKEvent({
      eventName: Mr.SDKInitialized
    });
  }
  /**
   * Set the log level. Logs of the given level and below will be printed
   * in the console.
   * Default is `LogLevel.Silent` so no logs will be printed in the console.
   * @param logLevel - LogLevel to set.
   */
  static setLogLevel(r) {
    ne.setLogLevel(r);
  }
  /**
   * Set a custom log handler to handle SDK log messages with your own logging system.
   * If set to null, the SDK will use the default console logging.
   * @param handler - LogHandler function or null to use default console logging.
   */
  static setLogHandler(r) {
    ne.setLogHandler(r);
  }
  /**
   * Meant to be used by RevenueCat hybrids SDKS only.
   * @experimental
   * */
  static setPlatformInfo(r) {
    Qe._platformInfo = r;
  }
  /**
   * Build variables for each package in an offering.
   * Used to support Paywalls in Workflows.
   * @internal
   */
  static buildVariablesPerPackage(r, t = {}) {
    return zc(r, t);
  }
  /** @internal */
  static getPlatformInfo() {
    return Qe._platformInfo;
  }
  /**
   * Get the singleton instance of Purchases. It's preferred to use the instance
   * obtained from the `configure` method when possible.
   * @throws {@link UninitializedPurchasesError} if the instance has not been initialized yet.
   */
  static getSharedInstance() {
    if (Qe.isConfigured())
      return Qe.instance;
    throw new _g();
  }
  /**
   * Returns whether the Purchases SDK is configured or not.
   */
  static isConfigured() {
    return Qe.instance !== void 0;
  }
  static configure(r, t, n, a) {
    Qe.instance !== void 0 && ne.warnLog(
      "Purchases is already initialized. You normally should only configure Purchases once. Creating and returning new instance."
    );
    let o;
    if (typeof r == "object" && r !== null)
      o = r;
    else {
      if (typeof r != "string")
        throw new je(
          We.ConfigurationError,
          "API key must be provided as a string"
        );
      if (typeof t != "string")
        throw new je(
          We.ConfigurationError,
          "App user ID must be provided as a string"
        );
      o = {
        apiKey: r,
        appUserId: t,
        httpConfig: n,
        flags: a
      };
    }
    return Qe.configureInternal(o), Qe.getSharedInstance();
  }
  static configureInternal(r) {
    const { apiKey: t, appUserId: n, httpConfig: a, flags: o, context: s, trace_id: l } = r, c = a ?? ms, u = o ?? Li;
    Qe.validateConfig(r), u.storeLoadTime === "configuration" && Ve.preloadStripeModule(), Qe.instance = new Qe(
      t,
      n,
      c,
      u,
      s,
      l
    );
  }
  static validateConfig(r) {
    var t, n;
    EP(r.apiKey), Ni(r.appUserId), SP((t = r.httpConfig) == null ? void 0 : t.proxyURL), IP((n = r.httpConfig) == null ? void 0 : n.additionalHeaders);
  }
  /**
   * Loads and caches some optional data in the Purchases SDK.
   * Currently only fetching branding information.
   * You can call this method after configuring the SDK to speed
   * up the first call to {@link Purchases.purchase}.
   */
  async preload() {
    if (this.hasLoadedResources()) {
      ne.verboseLog("Purchases resources are loaded. Skipping.");
      return;
    }
    if (this._loadingResourcesPromise !== null) {
      ne.verboseLog("Purchases resources are loading. Waiting."), await this._loadingResourcesPromise;
      return;
    }
    return this._loadingResourcesPromise = this.fetchAndCacheBrandingInfo().catch((r) => {
      let t = `${r}`;
      r instanceof je && (t = `${r.message}. ${r.underlyingErrorMessage ? `Underlying error: ${r.underlyingErrorMessage}` : ""}`), ne.errorLog(`Error fetching branding info: ${t}`);
    }).finally(() => {
      this._loadingResourcesPromise = null;
    }), this._loadingResourcesPromise;
  }
  /** @internal */
  async fetchAndCacheBrandingInfo() {
    if (mn(this._API_KEY)) {
      ne.warnLog(
        "Branding info is not available for RC Test Store API keys."
      );
      return;
    }
    this._brandingInfo = await this.backend.getBrandingInfo();
  }
  /** @internal */
  hasLoadedResources() {
    return this._brandingInfo !== null;
  }
  /**
   * Renders an RC Paywall and allows the user to purchase from it using Web Billing.
   * @param paywallParams - The parameters object to customise the paywall render. Check {@link PresentPaywallParams}
   * @returns Promise<PurchaseResult>
   */
  async presentPaywall(r) {
    const t = r.htmlTarget;
    let n = !1;
    const a = hs();
    let o = t ?? a.getElementById("rcb-ui-pw-root");
    if (o === null) {
      n = !0;
      const m = a.createElement("div");
      m.id = "rcb-ui-pw-root", m.className = "rcb-ui-pw-root", m.style.zIndex = `${DP}`, m.style.position = "fixed", m.style.top = "0", m.style.left = "0", m.style.width = "100%", m.style.height = "100%", m.style.overflow = "auto", m.style.backgroundColor = "rgba(0, 0, 0, 0.4)", a.body.offsetWidth > 968 && (m.style.display = "flex", m.style.justifyContent = "center", m.style.alignItems = "center"), m.style.transition = "opacity 0.3s", m.style.opacity = "0", a.body.appendChild(m), o = m;
    }
    if (o === null)
      throw new Error(
        "Could not generate a mount point for the paywall widget"
      );
    const s = o, l = r.offering ? r.offering : (await this.getOfferings()).current;
    if (!l)
      throw new Error("No offering found.");
    if (!l.paywallComponents)
      throw new Error("This offering doesn't have a paywall attached.");
    if (!l.uiConfig)
      throw new Error(
        "No ui_config found for this offering, please contact support!"
      );
    const c = (m, S) => {
      const x = {}, P = (D) => D.toLowerCase().split("_")[0];
      Object.keys(m.components_localizations).forEach((D) => {
        x[P(D)] === void 0 && (x[P(D)] = []), x[P(D)].push(D);
      });
      const I = x[P(S)];
      if (!I)
        return m.default_locale;
      const E = I.find(
        (D) => D.toLowerCase() === S
      );
      return E || I[0];
    }, u = r.selectedLocale ? r.selectedLocale : navigator.language, d = c(
      l.paywallComponents,
      u
    ), p = new cn(
      {},
      d,
      l.paywallComponents.default_locale
    ), _ = Tn(), g = (m) => {
      var S, x, P;
      this.eventsTracker.trackPaywallEvent({
        type: m,
        appUserId: this._appUserId,
        sessionId: _,
        offeringId: l.identifier,
        paywallRevision: 0,
        paywallRcPublicId: ((S = l.paywallComponents) == null ? void 0 : S.id) ?? null,
        ...m === "paywall_impression" ? {
          displayMode: "full_screen",
          darkMode: ((P = (x = Rn()) == null ? void 0 : x.matchMedia) == null ? void 0 : P.call(x, "(prefers-color-scheme: dark)").matches) ?? !1,
          locale: d
        } : {}
      });
    }, h = async (m) => {
      var P, I;
      const S = l.availablePackages.find(
        (E) => E.identifier === m
      );
      if (S === void 0)
        throw new Error(`No package found for ${m}`);
      return { ...await this.purchase({
        rcPackage: S,
        htmlTarget: r.purchaseHtmlTarget,
        customerEmail: r.customerEmail,
        selectedLocale: d,
        defaultLocale: ((P = l.paywallComponents) == null ? void 0 : P.default_locale) || Er,
        paywallId: (I = l.paywallComponents) == null ? void 0 : I.id
      }), selectedPackage: S };
    }, w = (m) => {
      var x;
      if (r.onNavigateToUrl) {
        r.onNavigateToUrl(m);
        return;
      }
      (x = Rn().open(m, "_blank")) == null || x.focus();
    }, v = () => {
    }, f = () => {
      if (r.onVisitCustomerCenter) {
        r.onVisitCustomerCenter();
        return;
      }
    }, y = zc(l, {
      translator: p
    }), k = m1(l);
    return new Promise((m, S) => {
      let x = null, P = !1;
      const I = () => {
        P || (g("paywall_close"), P = !0);
      }, E = new MutationObserver(() => {
        s.childElementCount === 0 && (I(), E.disconnect());
      }), D = () => {
        E.disconnect(), I(), x && (Ia(x), x = null), s.innerHTML = "", n && s.parentNode && s.parentNode.removeChild(s);
      }, F = () => {
        ne.debugLog("Purchase cancelled by user"), D(), S(new je(We.UserCancelledError)), this.eventsTracker.flushAllEvents().catch((H) => {
          ne.debugLog(`Failed to flush paywall events on close: ${H}`);
        });
      }, M = (H) => {
        D(), m(H), this.eventsTracker.flushAllEvents().catch((A) => {
          ne.debugLog(
            `Failed to flush paywall events after purchase: ${A}`
          );
        });
      }, C = (H) => (A) => {
        var q;
        A instanceof je && A.errorCode === We.UserCancelledError && g("paywall_cancel"), ne.errorLog(`${H}: ${A}`), (q = r.onPurchaseError) == null || q.call(r, A);
      }, j = this.getWalletButtonRender(
        l,
        M,
        r.customerEmail,
        C("Error presenting express purchase button")
      );
      s.innerHTML = "", x = Gn(Th, {
        target: s,
        props: {
          paywallData: l.paywallComponents,
          selectedLocale: d,
          onNavigateToUrlClicked: w,
          onVisitCustomerCenterClicked: f,
          uiConfig: l.uiConfig,
          onBackClicked: () => {
            if (r.onBack) {
              r.onBack(F);
              return;
            }
            F();
          },
          onRestorePurchasesClicked: v,
          onPurchaseClicked: (H) => {
            h(H).then(M).catch(C("Error performing purchase"));
          },
          onError: (H) => {
            D(), S(H);
          },
          variablesPerPackage: y,
          infoPerPackage: k,
          hideBackButtons: r.hideBackButtons,
          walletButtonRender: j,
          customVariables: r.customVariables
        }
      }), E.observe(s, { childList: !0 }), g("paywall_impression"), s.style.opacity === "0" && (s.style.opacity = "1");
    });
  }
  /**
   * Fetch the configured offerings for this user. You can configure these
   * in the RevenueCat dashboard.
   * @param params - The parameters object to customise the offerings fetch. Check {@link GetOfferingsParams}
   */
  async getOfferings(r) {
    sw(r == null ? void 0 : r.currency);
    const t = this._appUserId, n = await this.backend.getOfferings(t), a = (r == null ? void 0 : r.offeringIdentifier) === gp.Current ? n.current_offering_id : r == null ? void 0 : r.offeringIdentifier;
    return a && (n.offerings = n.offerings.filter(
      (o) => o.identifier === a
    )), await this.getAllOfferings(n, t, r);
  }
  /**
   * Retrieves a specific offering by a placement identifier.
   * For more info see https://www.revenuecat.com/docs/tools/targeting
   * @param placementIdentifier - The placement identifier to retrieve the offering for.
   * @param params - The parameters object to customise the offerings fetch. Check {@link GetOfferingsParams}
   */
  async getCurrentOfferingForPlacement(r, t) {
    const n = this._appUserId, a = await this.backend.getOfferings(n), o = await this.getAllOfferings(
      a,
      n,
      t
    ), s = a.placements ?? null;
    return s == null ? null : TP(
      s,
      o.all,
      r
    );
  }
  async getAllOfferings(r, t, n) {
    const a = r.offerings.flatMap((s) => s.packages).map((s) => s.platform_product_identifier), o = await this.backend.getProducts(
      t,
      a,
      n == null ? void 0 : n.currency,
      n == null ? void 0 : n.discountCode
    );
    return this.logMissingProductIds(a, o.product_details), CP(r, o);
  }
  /**
   * Convenience method to check whether a user is entitled to a specific
   * entitlement. This will use {@link Purchases.getCustomerInfo} under the hood.
   * @param entitlementIdentifier - The entitlement identifier you want to check.
   * @returns Whether the user is entitled to the specified entitlement
   * @throws {@link PurchasesError} if there is an error while fetching the customer info.
   * @see {@link Purchases.getCustomerInfo}
   */
  async isEntitledTo(r) {
    const t = await this.getCustomerInfo();
    return r in t.entitlements.active;
  }
  /**
   * Method to perform a purchase for a given package. You can obtain the
   * package from {@link Purchases.getOfferings}. This method will present the purchase
   * form on your site, using the given HTML element as the mount point, if
   * provided, or as a modal if not.
   * @deprecated - please use .purchase
   * @param rcPackage - The package you want to purchase. Obtained from {@link Purchases.getOfferings}.
   * @param customerEmail - The email of the user. If undefined, RevenueCat will ask the customer for their email.
   * @param htmlTarget - The HTML element where the billing view should be added. If undefined, a new div will be created at the root of the page and appended to the body.
   * @returns a Promise for the customer info after the purchase is completed successfully.
   * @throws {@link PurchasesError} if there is an error while performing the purchase. If the {@link PurchasesError.errorCode} is {@link ErrorCode.UserCancelledError}, the user cancelled the purchase.
   */
  purchasePackage(r, t, n) {
    return this.purchase({
      rcPackage: r,
      customerEmail: t,
      htmlTarget: n
    });
  }
  async presentExpressPurchaseButton(r) {
    const {
      rcPackage: t,
      purchaseOption: n,
      htmlTarget: a,
      customerEmail: o,
      selectedLocale: s = Er,
      defaultLocale: l = Er,
      onButtonReady: c = () => {
      }
    } = r;
    if (a === void 0)
      throw new Error(
        "htmlTarget is required for presentExpressPurchaseButton"
      );
    const u = this._appUserId;
    if (!fs(this._API_KEY))
      throw new Error(
        "The Express Purchase button is only available with Web Billing API Keys."
      );
    const d = n ?? t.webBillingProduct.defaultPurchaseOption, _ = { ...this._flags.autoCollectUTMAsMetadata ? mo() : {}, ...r.metadata || {} }, g = new cn({}, s, l);
    return new Promise((h, w) => {
      const v = async (y) => {
        const k = vc({
          redemptionInfo: y.redemptionInfo,
          mode: "express_purchase_button"
        });
        this.eventsTracker.trackSDKEvent(k), ne.debugLog("Purchase finished");
        const m = {
          customerInfo: await this._getCustomerInfoForUserId(u),
          redemptionInfo: y.redemptionInfo,
          operationSessionId: y.operationSessionId,
          storeTransaction: {
            storeTransactionId: y.storeTransactionIdentifier,
            productIdentifier: t.webBillingProduct.identifier,
            purchaseDate: y.purchaseDate
          }
        };
        h(m);
      }, f = (y) => {
        var m;
        const k = kc({
          errorCode: (m = y.errorCode) == null ? void 0 : m.toString(),
          errorMessage: y.message,
          mode: "express_purchase_button"
        });
        this.eventsTracker.trackSDKEvent(k), w(y);
      };
      new P1(a, c, {
        appUserId: u,
        rcPackage: t,
        purchaseOption: d,
        customerEmail: o,
        purchases: this,
        eventsTracker: this.eventsTracker,
        brandingInfo: this._brandingInfo,
        purchaseOperationHelper: this.purchaseOperationHelper,
        metadata: _,
        customTranslations: r.labelsOverride,
        translator: g,
        onFinished: v,
        onError: f
      });
    });
  }
  /**
   * Renders a wallet button for the supported wallets (Apple Pay/Google Pay).
   * When clicked it uses the wallet UI to execute the purchase instead of
   * the checkout flow that would be shown with `.purchase`.
   * @internal
   * @param offering - The offering to render the wallet button for.
   * @param onSuccess - The callback to be called when the purchase is successful.
   * @param customerEmail - The email of the user. If undefined, RevenueCat will ask the customer for their email.
   * @param onPurchaseError - The callback to be called when the purchase fails.
   * @returns Function that renders the wallet button.
   */
  getWalletButtonRender(r, t, n, a) {
    if (fs(this._API_KEY))
      return (o, { selectedPackageId: s, onReady: l }) => {
        const c = r.packagesById[s];
        if (!c)
          return {};
        let u = null;
        return this.presentExpressPurchaseButton({
          rcPackage: c,
          customerEmail: n,
          htmlTarget: o,
          onButtonReady: (d, p) => {
            u = d, l == null || l(p);
          }
        }).then((d) => {
          t({ ...d, selectedPackage: c });
        }).catch(a), {
          destroy() {
            o.innerHTML = "";
          },
          update({
            selectedPackageId: d
          }) {
            if (u) {
              const p = r.packagesById[d];
              if (!p)
                return;
              const _ = p.webBillingProduct.defaultPurchaseOption;
              u.updatePurchase(p, _);
            }
          }
        };
      };
  }
  async purchase(r) {
    if (mn(this._API_KEY)) {
      const a = await d1(
        r,
        this.backend,
        this._appUserId
      );
      return this.inMemoryCache.invalidateAllCaches(), a;
    }
    return tp(this._API_KEY) ? await this.performPaddlePurchase(r) : np(this._API_KEY) ? await this.performStripePurchase(r) : await this.performWebBillingPurchase(r);
  }
  async performStripePurchase(r) {
    var S;
    const {
      rcPackage: t,
      purchaseOption: n,
      htmlTarget: a,
      customerEmail: o,
      workflowPurchaseContext: s,
      paywallId: l,
      selectedLocale: c = Er,
      defaultLocale: u = Er,
      skipSuccessPage: d = !1
    } = r, p = this.resolveHTMLTarget(a), _ = this._appUserId;
    ne.debugLog(
      `Presenting Stripe checkout for package ${t.identifier}`
    );
    const g = c || u, h = n ?? t.webBillingProduct.defaultPurchaseOption, w = ko({
      appearance: (S = this._brandingInfo) == null ? void 0 : S.appearance,
      rcPackage: t,
      purchaseOptionToUse: h,
      customerEmail: o
    });
    this.eventsTracker.trackSDKEvent(w);
    const f = { ...this._flags.autoCollectUTMAsMetadata ? mo() : {}, ...r.metadata || {} };
    let y = null;
    const k = this._brandingInfo;
    k && r.brandingAppearanceOverride && (k.appearance = r.brandingAppearanceOverride);
    const m = a !== void 0;
    return new Promise((x, P) => {
      const I = Rn();
      m || I.history.pushState({ checkoutOpen: !0 }, "");
      const E = () => {
        y && Ia(y), p.innerHTML = "";
      }, D = this.createCheckoutOnCloseHandler(
        P,
        E
      );
      !m && D && I.addEventListener("popstate", D);
      const F = this.createCheckoutOnFinishedHandler(
        x,
        _,
        t,
        E
      ), M = this.createCheckoutOnErrorHandler(
        P,
        E
      );
      y = Gn(Gw, {
        target: p,
        props: {
          isInElement: m,
          appUserId: _,
          rcPackage: t,
          purchaseOption: h,
          customerEmail: o,
          workflowPurchaseContext: s,
          paywallId: l,
          onFinished: F,
          onClose: D,
          onError: M,
          eventsTracker: this.eventsTracker,
          brandingInfo: this._brandingInfo,
          purchaseOperationHelper: this.purchaseOperationHelper,
          selectedLocale: g,
          metadata: f,
          defaultLocale: u,
          customTranslations: r.labelsOverride,
          skipSuccessPage: d
        }
      });
    });
  }
  async performWebBillingPurchase(r) {
    var m;
    const {
      rcPackage: t,
      purchaseOption: n,
      htmlTarget: a,
      customerEmail: o,
      workflowPurchaseContext: s,
      selectedLocale: l = Er,
      defaultLocale: c = Er,
      skipSuccessPage: u = !1
    } = r, d = this.resolveHTMLTarget(a), p = this._appUserId;
    ne.debugLog(
      `Presenting purchase form for package ${t.identifier}`
    );
    const _ = l || c, g = n ?? t.webBillingProduct.defaultPurchaseOption, h = ko({
      appearance: (m = this._brandingInfo) == null ? void 0 : m.appearance,
      rcPackage: t,
      purchaseOptionToUse: g,
      customerEmail: o
    });
    this.eventsTracker.trackSDKEvent(h);
    const v = { ...this._flags.autoCollectUTMAsMetadata ? mo() : {}, ...r.metadata || {} };
    let f = null;
    const y = this._brandingInfo;
    y && r.brandingAppearanceOverride && (y.appearance = r.brandingAppearanceOverride);
    const k = a !== void 0;
    return new Promise((S, x) => {
      const P = Rn();
      k || P.history.pushState({ checkoutOpen: !0 }, "");
      const I = () => {
        f && Ia(f), d.innerHTML = "";
      }, E = this.createCheckoutOnCloseHandler(
        x,
        I
      );
      !k && E && P.addEventListener("popstate", E);
      const D = this.createCheckoutOnFinishedHandler(
        S,
        p,
        t,
        I
      ), F = this.createCheckoutOnErrorHandler(
        x,
        I
      );
      f = Gn(lw, {
        target: d,
        props: {
          isInElement: k,
          appUserId: p,
          rcPackage: t,
          purchaseOption: g,
          customerEmail: o,
          workflowPurchaseContext: s,
          paywallId: r.paywallId,
          onFinished: D,
          onClose: E,
          onError: F,
          purchases: this,
          eventsTracker: this.eventsTracker,
          brandingInfo: this._brandingInfo,
          purchaseOperationHelper: this.purchaseOperationHelper,
          selectedLocale: _,
          metadata: v,
          defaultLocale: c,
          customTranslations: r.labelsOverride,
          termsAndConditionsUrl: r.termsAndConditionsUrl,
          skipSuccessPage: u
        }
      });
    });
  }
  async performPaddlePurchase(r) {
    var k;
    const {
      rcPackage: t,
      purchaseOption: n,
      customerEmail: a,
      selectedLocale: o = Er,
      defaultLocale: s = Er,
      skipSuccessPage: l = !1,
      htmlTarget: c
    } = r, u = this.resolveHTMLTarget(c), d = this._appUserId;
    ne.debugLog(
      `Presenting Paddle checkout for package ${t.identifier}`
    );
    const p = n ?? t.webBillingProduct.defaultPurchaseOption, g = {
      source: "paddle",
      ...this._flags.autoCollectUTMAsMetadata ? mo() : {},
      ...r.metadata || {}
    }, h = this._brandingInfo;
    h && r.brandingAppearanceOverride && (h.appearance = r.brandingAppearanceOverride);
    const w = ko({
      appearance: (k = this._brandingInfo) == null ? void 0 : k.appearance,
      rcPackage: t,
      purchaseOptionToUse: p,
      customerEmail: a
    });
    this.eventsTracker.trackSDKEvent(w);
    const v = new Cw(this.backend, this.eventsTracker);
    let f = null;
    const y = c !== void 0;
    return new Promise((m, S) => {
      const x = Rn();
      y || x.history.pushState({ checkoutOpen: !0 }, "");
      const P = () => {
        f && Ia(f), u.innerHTML = "";
      }, I = this.createCheckoutOnCloseHandler(S, P) ?? // Always unmount PaddlePurchaseUi when the user closes the checkout modal
      (() => {
        P();
      }), E = this.createCheckoutOnFinishedHandler(
        m,
        d,
        t,
        P
      ), D = this.createCheckoutOnErrorHandler(S);
      f || (f = Gn(Ow, {
        target: u,
        props: {
          eventsTracker: this.eventsTracker,
          brandingInfo: this._brandingInfo,
          selectedLocale: o || s,
          defaultLocale: s,
          customTranslations: r.labelsOverride,
          isInElement: y,
          onClose: I,
          onFinished: E,
          onError: D,
          skipSuccessPage: l,
          productDetails: t.webBillingProduct,
          rcPackage: t,
          appUserId: d,
          purchaseOption: p,
          customerEmail: a,
          metadata: g,
          unmountPaddlePurchaseUi: P,
          paddleService: v
        }
      }));
    });
  }
  /**
   * Uses htmlTarget if provided. Otherwise, looks for an element with id "rcb-ui-root".
   * If no element is found, creates a new div with className "rcb-ui-root".
   */
  resolveHTMLTarget(r) {
    const t = hs();
    let n = r ?? t.getElementById("rcb-ui-root");
    if (n === null) {
      const a = t.createElement("div");
      a.className = "rcb-ui-root", t.body.appendChild(a), n = a;
    }
    if (n === null)
      throw new Error(
        "Could not generate a mount point for the billing widget"
      );
    return n;
  }
  createCheckoutOnCloseHandler(r, t) {
    if (this._flags.rcSource && a1.includes(this._flags.rcSource))
      return;
    const a = () => {
      const o = Dd();
      this.eventsTracker.trackSDKEvent(o), Rn().removeEventListener("popstate", a), t == null || t(), ne.debugLog("Purchase cancelled by user"), r(new je(We.UserCancelledError));
    };
    return a;
  }
  createCheckoutOnFinishedHandler(r, t, n, a) {
    return async (s) => {
      const l = vc({
        redemptionInfo: s.redemptionInfo
      });
      this.eventsTracker.trackSDKEvent(l), this.inMemoryCache.invalidateAllCaches(), ne.debugLog("Purchase finished"), a == null || a();
      const c = {
        customerInfo: await this._getCustomerInfoForUserId(t),
        redemptionInfo: s.redemptionInfo,
        operationSessionId: s.operationSessionId,
        storeTransaction: {
          storeTransactionId: s.storeTransactionIdentifier,
          productIdentifier: n.webBillingProduct.identifier,
          purchaseDate: s.purchaseDate
        }
      };
      r(c);
    };
  }
  createCheckoutOnErrorHandler(r, t) {
    return (a) => {
      var s;
      const o = kc({
        errorCode: (s = a.errorCode) == null ? void 0 : s.toString(),
        errorMessage: a.message
      });
      this.eventsTracker.trackSDKEvent(o), t == null || t(), r(je.getForPurchasesFlowError(a));
    };
  }
  /**
   * Used by internal RC code to detect if used a test store API key.
   * @internal
   */
  _isConfiguredWithSimulatedStore() {
    return mn(this._API_KEY);
  }
  /**
   * Whether wallet methods should be force-enabled in the Express Checkout Element.
   * @internal
   */
  _shouldForceEnableWalletMethods() {
    return !!this._flags.forceEnableWalletMethods;
  }
  /**
   * Posts a simulated store receipt to the server.
   * @internal
   * @param product - The product for which we want to post the receipt for.
   * @returns Promise<PurchaseResult>
   */
  async _postSimulatedStoreReceipt(r) {
    if (!mn(this._API_KEY))
      throw new je(
        We.ConfigurationError,
        "Posting a test store receipt is only available for RC Test Store API keys."
      );
    return await vp(
      r,
      this.backend,
      this._appUserId,
      void 0
    );
  }
  /**
   * Gets latest available {@link CustomerInfo}.
   * @returns The latest {@link CustomerInfo}.
   * @throws {@link PurchasesError} if there is an error while fetching the customer info.
   */
  async getCustomerInfo() {
    return await this._getCustomerInfoForUserId(this._appUserId);
  }
  /**
   * Gets the current app user id.
   */
  getAppUserId() {
    return this._appUserId;
  }
  /**
   * Sets attributes for the current user. Attributes are useful for storing additional, structured information on a customer that can be used elsewhere in the system.
   * For example, you could store your customer's email address or additional system identifiers through the applicable reserved attributes, or store arbitrary facts like onboarding survey responses, feature usage, or other dimensions as custom attributes.
   *
   * Note: Unlike our mobile SDKs, the web SDK does not cache or retry sending attributes if the request fails. If the request fails, the attributes will not be saved and you will need to retry the operation.
   *
   * @param attributes - A dictionary of attributes to set for the current user.
   * @throws {@link PurchasesError} if there is an error while setting the attributes or if the customer doesn't exist.
   */
  async setAttributes(r) {
    return await this.getCustomerInfo(), await this.backend.setAttributes(this._appUserId, r);
  }
  /**
   * Change the current app user id. Returns the customer info for the new
   * user id.
   * @param newAppUserId - The user id to change to.
   */
  async changeUser(r) {
    return await this.replaceUserId(r), await this.getCustomerInfo();
  }
  /**
   * Identifies the current user ID with the provided appUserId, as long as the
   * previous user ID is an anonymous user ID. This will create an alias
   * between the two user ids in RevenueCat and replace the current user ID used.
   * If the old user ID is not anonymous, this method will change the current
   * user ID to the given appUserId without creating an alias.
   * @returns The customer info for the new user ID.
   * @throws {@link PurchasesError} if there is an error while performing the aliasing or fetching the customer info.
   * @param appUserId - The new user ID to identify the current user as.
   * @experimental
   */
  async identifyUser(r) {
    if (Ni(r), r === this._appUserId)
      return ne.debugLog(
        `aliasUser called with the current appUserID: ${r}. Ignoring.`
      ), {
        customerInfo: await this.getCustomerInfo(),
        wasCreated: !1
      };
    const t = await this.backend.identify(this._appUserId, r);
    return await this.replaceUserId(r), {
      customerInfo: gs(t),
      wasCreated: t.was_created
    };
  }
  async replaceUserId(r) {
    Ni(r), this._appUserId = r, await this.eventsTracker.updateUser(r), this.inMemoryCache.invalidateAllCaches();
  }
  /** @internal */
  logMissingProductIds(r, t) {
    const n = {};
    t.forEach(
      (o) => n[o.identifier] = o
    );
    const a = [];
    r.forEach((o) => {
      n[o] === void 0 && a.push(o);
    }), a.length > 0 && ne.debugLog(
      `Could not find product data for product ids:
        ${a.join()}.
        Please check that your product configuration is correct.`
    );
  }
  /**
   * @returns Whether the SDK is using a sandbox API Key.
   */
  isSandbox() {
    return No(this._API_KEY) || mn(this._API_KEY);
  }
  /**
   * @returns Whether the current user is anonymous.
   */
  isAnonymous() {
    return this._appUserId.startsWith(Bc);
  }
  /**
   * Fetches the virtual currencies for the current subscriber.
   *
   * @returns {Promise<VirtualCurrencies>} A VirtualCurrencies object containing the subscriber's virtual currencies.
   */
  async getVirtualCurrencies() {
    return await this._getVirtualCurrenciesForUserId(this._appUserId);
  }
  /**
   * The currently cached {@link VirtualCurrencies} if one is available.
   * This value will remain null until virtual currencies have been fetched at
   * least once with {@link Purchases.getVirtualCurrencies} or an equivalent function.
   *
   * @returns {VirtualCurrencies | null} A {@link VirtualCurrencies} object containing the subscriber's virtual currencies,
   * or null if no cached data is available.
   */
  getCachedVirtualCurrencies() {
    return this.inMemoryCache.getCachedVirtualCurrencies(this._appUserId, !0);
  }
  /**
   * Invalidates the cache for virtual currencies.
   *
   * This is useful for cases where a virtual currency's balance might have been updated
   * in a different part of your system, like if you decreased a user's balance from the user spending a virtual currency,
   * or if you increased the balance from your backend using the server APIs.
   */
  invalidateVirtualCurrenciesCache() {
    this.inMemoryCache.invalidateVirtualCurrenciesCache(this._appUserId);
  }
  /**
   * Closes the Purchases instance. You should never have to do this normally.
   */
  close() {
    Qe.instance === this ? (this.eventsTracker && this.eventsTracker.dispose(), Qe.instance = void 0) : ne.warnLog(
      "Trying to close a Purchases instance that is not the current instance. Ignoring."
    );
  }
  /** @internal */
  async _getCustomerInfoForUserId(r) {
    const t = await this.backend.getCustomerInfo(r);
    return gs(t);
  }
  /** @internal  */
  async _getVirtualCurrenciesForUserId(r) {
    const t = this.inMemoryCache.getCachedVirtualCurrencies(r);
    if (t)
      return ne.debugLog("Vending VirtualCurrencies from cache."), t;
    const n = await this.backend.getVirtualCurrencies(r), a = g1(n);
    return ne.debugLog("VirtualCurrencies updated from the network."), this.inMemoryCache.cacheVirtualCurrencies(r, a), a;
  }
  /**
   * Generates an anonymous app user ID that follows RevenueCat's format.
   * This can be used when you don't have a user identifier system in place.
   * The generated ID will be in the format: $RCAnonymousID:\<UUID without dashes\>
   * Example: $RCAnonymousID:123e4567e89b12d3a456426614174000
   * @returns A new anonymous app user ID string
   * @public
   */
  static generateRevenueCatAnonymousAppUserId() {
    return `${Bc}${Tn().replace(/-/g, "")}`;
  }
  /**
   * Track an event.
   * @param props - The properties of the event.
   * @internal
   */
  _trackEvent(r) {
    this.eventsTracker.trackExternalEvent(r);
  }
  /**
   * Immediately flush all pending events to the server.
   *
   * This method is useful before programmatic navigation to ensure events are delivered.
   * The SDK uses fetch with keepalive:true to allow delivery during navigation, but
   * calling this method before navigation provides additional reliability.
   *
   * Notes:
   * - Temporarily stops automatic event flushing, then restarts after completion
   * - Events are sent in batches if the payload exceeds the keepalive size limit (50KB)
   * - If a batch fails, remaining batches will not be attempted
   * - Safe to call multiple times; concurrent calls will be serialized
   * - Returns immediately if tracker is disposed
   *
   * @returns Promise that resolves when all events have been flushed or an error occurs
   * @internal
   */
  _flushAllEvents() {
    return this.eventsTracker.flushAllEvents();
  }
};
ho = pl(null), oi(ho, 1, "presentExpressPurchaseButton", Vc, Qe), oi(ho, 1, "purchase", Rc, Qe), ai(ho, Qe), /** @internal */
V(Qe, "_platformInfo"), /** @internal */
V(Qe, "instance");
let ys = Qe;
export {
  I1 as CustomVariableValue,
  We as ErrorCode,
  jr as LogLevel,
  gp as OfferingKeyword,
  Jb as PackageType,
  ce as PeriodUnit,
  ut as ProductType,
  ys as Purchases,
  je as PurchasesError,
  x1 as ReservedCustomerAttribute,
  _g as UninitializedPurchasesError
};
